import React, { useState, useRef, useEffect, Fragment, createElement as createElement$1, useMemo, createContext, useContext, useCallback, forwardRef, useLayoutEffect, useReducer, useId } from 'react';
import Link$1 from 'next/link.js';
import require$$2 from 'react/jsx-runtime';
import require$$3, { createPortal } from 'react-dom';
import Head from 'next/head.js';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router.js';
import { getStoryblokApi as getStoryblokApi$1 } from '@storyblok/react';
import DOMPurify from 'dompurify';

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

var getVariantClassName = function getVariantClassName(variant, style, moduleName) {
  var variantClassNames = {
    primary: "".concat(style["".concat(moduleName, "__themed_primary")], " ").concat(style["".concat(moduleName, "__themed_primary_font")]),
    secondary: "".concat(style["".concat(moduleName, "__themed_secondary")], " ").concat(style["".concat(moduleName, "__themed_secondary_font")]),
    theming_color_1: "".concat(style["".concat(moduleName, "__themed_color1")], " ").concat(style["".concat(moduleName, "__themed_color1_font")]),
    theming_color_2: "".concat(style["".concat(moduleName, "__themed_color2")], " ").concat(style["".concat(moduleName, "__themed_color2_font")]),
    theming_color_3: "".concat(style["".concat(moduleName, "__themed_color3")])
  };
  return variantClassNames[variant] || '';
};

var Variant;
(function (Variant) {
  Variant["Primary"] = "primary";
  Variant["Secondary"] = "secondary";
  Variant["ThemingColor1"] = "theming_color_1";
  Variant["ThemingColor2"] = "theming_color_2";
  Variant["ThemingColor3"] = "theming_color_3";
})(Variant || (Variant = {}));
var ComponentNames;
(function (ComponentNames) {
  ComponentNames["Quote"] = "quote";
  ComponentNames["Slider"] = "slider";
  ComponentNames["QuickInfo"] = "quickInfo";
  ComponentNames["ContentOneColumn"] = "contentOneColumn";
  ComponentNames["HomepageTeaserCompilation"] = "homepageTeaserCompilation";
  ComponentNames["ContentNavigation"] = "contentNavigation";
  ComponentNames["HomepageBanner"] = "homepageBanner";
  ComponentNames["Outline"] = "outline";
  ComponentNames["Headline"] = "headline";
  ComponentNames["Subline"] = "subline";
})(ComponentNames || (ComponentNames = {}));

var css$1i = {"font":"'../../../styling/fonts.css'","breakpoint":"'../../../styling/breakpoints.css'","roboto":"i__const_roboto_0","md":"i__const_md_1","headlineOne":"Headline-module_headlineOne__HRNbh","headlineTwo":"Headline-module_headlineTwo__YlFbP","headlineThree":"Headline-module_headlineThree__Wm3b4","headlineFour":"Headline-module_headlineFour__gOUy0","headlineFive":"Headline-module_headlineFive__BUqn-","headlineSix":"Headline-module_headlineSix__ig4FT","headline__themed_primary":"Headline-module_headline__themed_primary__vH-uH","headline__themed_secondary":"Headline-module_headline__themed_secondary__kJUf6","headline__themed_color1":"Headline-module_headline__themed_color1__5e3MH","headline__themed_color2":"Headline-module_headline__themed_color2__6Qqyy"};

var HeadlineTags;
(function (HeadlineTags) {
  HeadlineTags["H1"] = "h1";
  HeadlineTags["H2"] = "h2";
  HeadlineTags["H3"] = "h3";
  HeadlineTags["H4"] = "h4";
  HeadlineTags["H5"] = "h5";
  HeadlineTags["H6"] = "h6";
})(HeadlineTags || (HeadlineTags = {}));
function renderHeadline(_ref) {
  var tag = _ref.tag,
    children = _ref.children,
    className = _ref.className,
    title = _ref.title,
    hasAnchor = _ref.hasAnchor,
    variant = _ref.variant,
    exclude_from_toc = _ref.exclude_from_toc;
  var renderClassName = className ? className : '';
  var anchor = hasAnchor ? _generateAnchorLink(children, tag) : '';
  var excludeFromTocClass = exclude_from_toc ? 'exclude-from-toc' : '';
  switch (tag) {
    case HeadlineTags.H1:
    default:
      return /*#__PURE__*/React.createElement("h1", {
        title: title,
        className: "".concat(css$1i.headlineOne, " ").concat(renderClassName, " ").concat(variant ? getVariantClassName(variant, css$1i, ComponentNames.Headline) : '')
      }, children);
    case HeadlineTags.H2:
      return /*#__PURE__*/React.createElement("h2", {
        id: mapUmlaut(anchor),
        title: title,
        className: "".concat(css$1i.headlineTwo, " ").concat(renderClassName, " ").concat(excludeFromTocClass, " ").concat(variant ? getVariantClassName(variant, css$1i, ComponentNames.Headline) : '')
      }, children);
    case HeadlineTags.H3:
      return /*#__PURE__*/React.createElement("h3", {
        id: mapUmlaut(anchor),
        title: title,
        className: "".concat(css$1i.headlineThree, " ").concat(renderClassName, " ").concat(excludeFromTocClass, " ").concat(variant ? getVariantClassName(variant, css$1i, ComponentNames.Headline) : '')
      }, children);
    case HeadlineTags.H4:
      return /*#__PURE__*/React.createElement("h4", {
        title: title,
        className: "".concat(css$1i.headlineFour, " ").concat(renderClassName, " ").concat(variant ? getVariantClassName(variant, css$1i, ComponentNames.Headline) : '')
      }, children);
    case HeadlineTags.H5:
      return /*#__PURE__*/React.createElement("h5", {
        title: title,
        className: "".concat(css$1i.headlineFive, " ").concat(renderClassName, " ").concat(variant ? getVariantClassName(variant, css$1i, ComponentNames.Headline) : '')
      }, children);
    case HeadlineTags.H6:
      return /*#__PURE__*/React.createElement("h6", {
        title: title,
        className: "".concat(css$1i.headlineSix, " ").concat(renderClassName, " ").concat(variant ? getVariantClassName(variant, css$1i, ComponentNames.Headline) : '')
      }, children);
  }
}
var Headline = function Headline(_ref2) {
  var tag = _ref2.tag,
    children = _ref2.children,
    className = _ref2.className,
    title = _ref2.title,
    _ref2$hasAnchor = _ref2.hasAnchor,
    hasAnchor = _ref2$hasAnchor === void 0 ? true : _ref2$hasAnchor,
    variant = _ref2.variant,
    exclude_from_toc = _ref2.exclude_from_toc;
  return renderHeadline({
    title: title,
    tag: tag,
    children: children,
    className: className,
    hasAnchor: hasAnchor,
    variant: variant,
    exclude_from_toc: exclude_from_toc
  });
};

var _generateAnchorLink = function generateAnchorLink(text) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'h2';
  var _a;
  var isValidLevel = level === HeadlineTags.H2 || level === HeadlineTags.H3;
  if (isValidLevel) {
    if (Array.isArray(text)) {
      return encodeURIComponent(text.map(function (element) {
        return _generateAnchorLink(element, level);
      }).join('_'));
    }
    if (_typeof$1(text) === 'object' && ((_a = text === null || text === void 0 ? void 0 : text.props) === null || _a === void 0 ? void 0 : _a.children)) {
      return encodeURIComponent(_generateAnchorLink(text.props.children, level));
    }
    if (typeof text === 'string') {
      return encodeURIComponent(mapUmlaut(text).replace(/ /g, '_'));
    }
    return '';
  }
  return '';
};
var mapUmlaut = function mapUmlaut(text) {
  text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9_-]/g, ' ').toLowerCase();
  return text;
};

var AnchorTag = function AnchorTag(_ref) {
  var anchor_id = _ref.anchor_id;
  return /*#__PURE__*/React.createElement("span", {
    id: mapUmlaut(anchor_id)
  });
};

function _arrayLikeToArray$7(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$7(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _unsupportedIterableToArray$7(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$7(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$7(r, a) : void 0;
  }
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$7(r) || _nonIterableSpread();
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$7(r, e) || _nonIterableRest();
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var css$1h = {"xs":"345px","sm":"536px","md":"720px","lg":"940px","xl":"1200px","xxl":"1200px","xxl_v2":"1440px","colSpace":"15px","rowSpace":"-15px","containerSpace":"15px","containerSpace_v2":"16px","containerSpaceMd_v2":"32px","containerSpaceLg":"30px","container":"Grid-module_container__4hXNq","container_v1":"Grid-module_container_v1__viOxK","container_v2":"Grid-module_container_v2__5-ruc","noSpacing":"Grid-module_noSpacing__Oqgsv","marginBottom20":"Grid-module_marginBottom20__nj1A7","marginBottom40":"Grid-module_marginBottom40__Rcumy","marginBottom60":"Grid-module_marginBottom60__6A3Tt","marginBottom80":"Grid-module_marginBottom80__K6Rma","row":"Grid-module_row__8-iOP","col":"Grid-module_col__neKAZ","rowgap0":"Grid-module_rowgap0__9UPnJ","rowgap8":"Grid-module_rowgap8__azAGr","rowgap16":"Grid-module_rowgap16__zX-yF","rowgap24":"Grid-module_rowgap24__SQdu5","rowgap32":"Grid-module_rowgap32__NNPMo","rowgap40":"Grid-module_rowgap40__Ax47Z","rowgap48":"Grid-module_rowgap48__kiWoJ","rowgap64":"Grid-module_rowgap64__O1XmM","colxs12":"Grid-module_colxs12__ad2mH","colxs11":"Grid-module_colxs11__IVbAz","colxs10":"Grid-module_colxs10__e9vBs","colxs9":"Grid-module_colxs9__kdXNz","colxs8":"Grid-module_colxs8__TP5Ne","colxs7":"Grid-module_colxs7__9FJg6","colxs6":"Grid-module_colxs6__XgxOB","colxs5":"Grid-module_colxs5__lHb43","colxs4":"Grid-module_colxs4__ZPHe-","colxs3":"Grid-module_colxs3__4ewjs","colxs2":"Grid-module_colxs2__y8l-L","colxs1":"Grid-module_colxs1__LHzPz","rowgapxs0":"Grid-module_rowgapxs0__-Gsid","rowgapxs8":"Grid-module_rowgapxs8__KoaqH","rowgapxs16":"Grid-module_rowgapxs16__HfADb","rowgapxs24":"Grid-module_rowgapxs24__DtNZ1","rowgapxs32":"Grid-module_rowgapxs32__3Mls-","rowgapxs40":"Grid-module_rowgapxs40__HLD5z","rowgapxs48":"Grid-module_rowgapxs48__o7Snb","rowgapxs64":"Grid-module_rowgapxs64__zIPFJ","colsm12":"Grid-module_colsm12__XnOp3","colsm11":"Grid-module_colsm11__FD8kS","colsm10":"Grid-module_colsm10__4Madr","colsm9":"Grid-module_colsm9__ivaBt","colsm8":"Grid-module_colsm8__ywzBN","colsm7":"Grid-module_colsm7__MSShb","colsm6":"Grid-module_colsm6__L1vU3","colsm5":"Grid-module_colsm5__rWFvt","colsm4":"Grid-module_colsm4__sI78y","colsm3":"Grid-module_colsm3__WtAmF","colsm2":"Grid-module_colsm2__W6br6","colsm1":"Grid-module_colsm1__tbZn2","rowgapsm0":"Grid-module_rowgapsm0__wSVWp","rowgapsm8":"Grid-module_rowgapsm8__el2ar","rowgapsm16":"Grid-module_rowgapsm16__UjlWa","rowgapsm24":"Grid-module_rowgapsm24__mfjM-","rowgapsm32":"Grid-module_rowgapsm32__J5onF","rowgapsm40":"Grid-module_rowgapsm40__qMa-U","rowgapsm48":"Grid-module_rowgapsm48__61QdT","rowgapsm64":"Grid-module_rowgapsm64__m33G5","colmd12":"Grid-module_colmd12__j45-P","colmd11":"Grid-module_colmd11__Cshh9","colmd10":"Grid-module_colmd10__PoluP","colmd9":"Grid-module_colmd9__2EpDg","colmd8":"Grid-module_colmd8__lWB-l","colmd7":"Grid-module_colmd7__9IOVQ","colmd6":"Grid-module_colmd6__ifNlh","colmd5":"Grid-module_colmd5__OVctd","colmd4":"Grid-module_colmd4__QZ8xf","colmd3":"Grid-module_colmd3__sGGdR","colmd2":"Grid-module_colmd2__8ORB0","colmd1":"Grid-module_colmd1__0GdUA","rowgapmd0":"Grid-module_rowgapmd0__gksmB","rowgapmd8":"Grid-module_rowgapmd8__wau8G","rowgapmd16":"Grid-module_rowgapmd16__WUKix","rowgapmd24":"Grid-module_rowgapmd24__t5fDH","rowgapmd32":"Grid-module_rowgapmd32__TSO9t","rowgapmd40":"Grid-module_rowgapmd40__W4mjb","rowgapmd48":"Grid-module_rowgapmd48__Dca1H","rowgapmd64":"Grid-module_rowgapmd64__IHQ79","marginBottom120":"Grid-module_marginBottom120__aupiS","collg12":"Grid-module_collg12__cYauj","collg11":"Grid-module_collg11__pxRbQ","collg10":"Grid-module_collg10__1Besr","collg9":"Grid-module_collg9__Uxu-v","collg8":"Grid-module_collg8__bsAZ8","collg7":"Grid-module_collg7__sgUlU","collg6":"Grid-module_collg6__MBcjk","collg5":"Grid-module_collg5__ptE3n","collg4":"Grid-module_collg4__Oo-VM","collg3":"Grid-module_collg3__az-yO","collg2":"Grid-module_collg2__WWrng","collg1":"Grid-module_collg1__qd-LQ","rowgaplg0":"Grid-module_rowgaplg0__iUJG7","rowgaplg8":"Grid-module_rowgaplg8__UpsXF","rowgaplg16":"Grid-module_rowgaplg16__9ZS95","rowgaplg24":"Grid-module_rowgaplg24__CLMAx","rowgaplg32":"Grid-module_rowgaplg32__gNtNg","rowgaplg40":"Grid-module_rowgaplg40__HP6h0","rowgaplg48":"Grid-module_rowgaplg48__BGt1Q","rowgaplg64":"Grid-module_rowgaplg64__j6h6H","colxl12":"Grid-module_colxl12__uvHBN","colxl11":"Grid-module_colxl11__8VM14","colxl10":"Grid-module_colxl10__SmBY4","colxl9":"Grid-module_colxl9__nS4QX","colxl8":"Grid-module_colxl8__fmopp","colxl7":"Grid-module_colxl7__wDCdD","colxl6":"Grid-module_colxl6__hkgz3","colxl5":"Grid-module_colxl5__XCl-g","colxl4":"Grid-module_colxl4__fnP64","colxl3":"Grid-module_colxl3__H0Rni","colxl2":"Grid-module_colxl2__fO7Ld","colxl1":"Grid-module_colxl1__M-zNl","rowgapxl0":"Grid-module_rowgapxl0__77126","rowgapxl8":"Grid-module_rowgapxl8__10YXu","rowgapxl16":"Grid-module_rowgapxl16__8jeGH","rowgapxl24":"Grid-module_rowgapxl24__DTc5M","rowgapxl32":"Grid-module_rowgapxl32__fQs6D","rowgapxl40":"Grid-module_rowgapxl40__b0mvr","rowgapxl48":"Grid-module_rowgapxl48__C3ZLL","rowgapxl64":"Grid-module_rowgapxl64__QNk47","colxxl12":"Grid-module_colxxl12__U-15V","colxxl11":"Grid-module_colxxl11__kvjAF","colxxl10":"Grid-module_colxxl10__VjZzN","colxxl9":"Grid-module_colxxl9__X8kB1","colxxl8":"Grid-module_colxxl8__Fm-QU","colxxl7":"Grid-module_colxxl7__RdQzd","colxxl6":"Grid-module_colxxl6__2WlAD","colxxl5":"Grid-module_colxxl5__B-NrO","colxxl4":"Grid-module_colxxl4__PnJf7","colxxl3":"Grid-module_colxxl3__Unp6Z","colxxl2":"Grid-module_colxxl2__zHVK7","colxxl1":"Grid-module_colxxl1__ytOlN","rowgapxxl0":"Grid-module_rowgapxxl0__a9rOr","rowgapxxl8":"Grid-module_rowgapxxl8__prgQd","rowgapxxl16":"Grid-module_rowgapxxl16__kOba1","rowgapxxl24":"Grid-module_rowgapxxl24__Q4xUq","rowgapxxl32":"Grid-module_rowgapxxl32__uTeI4","rowgapxxl40":"Grid-module_rowgapxxl40__1-nL-","rowgapxxl48":"Grid-module_rowgapxxl48__DjZRA","rowgapxxl64":"Grid-module_rowgapxxl64__tNDfW"};

var ComponentVersion;
(function (ComponentVersion) {
  ComponentVersion["v1"] = "v1";
  ComponentVersion["v2"] = "v2";
})(ComponentVersion || (ComponentVersion = {}));
var isPreferredVersion = function isPreferredVersion(preferredVersion, versionToCheck) {
  return preferredVersion === versionToCheck;
};

var VALID_COLUMN_SIZES = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
var VALID_GAP_SIZES = ['gap', 'gapxs', 'gapsm', 'gapmd', 'gaplg', 'gapxl', 'gapxxl'];
var getSizeClassnames = function getSizeClassnames(sizes, type) {
  var colsizeClassName = '';
  Object.entries(sizes).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var VALID_SIZES = type === 'row' ? VALID_GAP_SIZES : VALID_COLUMN_SIZES;
    if (VALID_SIZES.some(function (v) {
      return v === key;
    })) {
      var cName = "".concat(type).concat(key).concat(value);
      colsizeClassName += " ".concat(css$1h[cName]);
    }
  });
  return colsizeClassName;
};
var concatClassNames = function concatClassNames(classNamesList) {
  return classNamesList.reduce(function (acc, current) {
    if (current) {
      acc += ' ' + current;
    }
    return acc;
  }, '');
};
var Row = function Row(_a) {
  var children = _a.children,
    className = _a.className,
    style = _a.style,
    gapSizes = __rest(_a, ["children", "className", "style"]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(concatClassNames([css$1h.row, getSizeClassnames(gapSizes, 'row')]), " ").concat(className ? className : ''),
    style: style || {}
  }, children);
};
var Col = function Col(_a) {
  var children = _a.children,
    className = _a.className,
    style = _a.style,
    columnSizes = __rest(_a, ["children", "className", "style"]);
  return /*#__PURE__*/React.createElement("div", {
    className: concatClassNames([css$1h.col, getSizeClassnames(columnSizes, 'col'), getSizeClassnames(columnSizes, 'row'), className]),
    style: style || {}
  }, children);
};
var styleVariant = {
  marginBottom80: css$1h.marginBottom80,
  noSpacing: css$1h.noSpacing
};
var applySpacing = function applySpacing(_ref3) {
  var spacingWithoutSeparator = _ref3.spacingWithoutSeparator,
    spacingWithSeparator = _ref3.spacingWithSeparator,
    noSpacing = _ref3.noSpacing;
  if (spacingWithoutSeparator || spacingWithSeparator) {
    return [styleVariant.marginBottom80];
  }
  if (noSpacing) {
    return [styleVariant.noSpacing];
  }
  return [];
};
var Container = function Container(_a) {
  var children = _a.children,
    className = _a.className,
    style = _a.style,
    _a$version = _a.version,
    version = _a$version === void 0 ? ComponentVersion.v1 : _a$version,
    spacingWithoutSeparator = _a.spacingWithoutSeparator,
    spacingWithSeparator = _a.spacingWithSeparator,
    noSpacing = _a.noSpacing,
    gapSizes = __rest(_a, ["children", "className", "style", "version", "spacingWithoutSeparator", "spacingWithSeparator", "noSpacing"]);
  return /*#__PURE__*/React.createElement("div", {
    className: concatClassNames([css$1h.container, version === 'v1' ? css$1h.container_v1 : css$1h.container_v2].concat(_toConsumableArray(applySpacing({
      spacingWithoutSeparator: spacingWithoutSeparator,
      spacingWithSeparator: spacingWithSeparator,
      noSpacing: noSpacing
    })), [getSizeClassnames(gapSizes, 'row'), className])),
    style: style || {}
  }, children);
};

var _a;
const hostname = (_a = process.env.NEXT_PUBLIC_WEB_HOSTNAME) !== null && _a !== void 0 ? _a : 'www';
const fallbackLang = {
    'cs-SK': 'cs-CZ',
    'de-AT': 'de-DE',
    'de-CH': 'de-DE',
    'en-AU': 'en-GB',
    'en-BG': 'en-DE',
    'en-CA': 'en-US',
    'en-EE': 'en-DE',
    'en-EG': 'en-DE',
    'en-FI': 'en-DE',
    'en-GR': 'en-DE',
    'en-HR': 'en-DE',
    'en-IE': 'en-GB',
    'en-IL': 'en-DE',
    'en-IN': 'en-DE',
    'en-LB': 'en-DE',
    'en-LT': 'en-DE',
    'en-MY': 'en-DE',
    'en-NO': 'en-DE',
    'en-NZ': 'en-DE',
    'en-RS': 'en-DE',
    'en-SG': 'en-DE',
    'en-SI': 'en-DE',
    'en-ZA': 'en-DE',
    'es-AR': 'es-ES',
    'es-CL': 'es-ES',
    'fr-CH': 'fr-FR',
    'fr-TN': 'fr-FR',
    'it-CH': 'it-IT',
    'de-BE': 'de-DE',
    'nl-BE': 'nl-NL',
    'fr-BE': 'fr-FR',
    'en-UA': 'en-DE',
};
const defaultLocale = 'en-US';
const igusDomains = [
    {
        domain: `${hostname}.igus.co.uk`,
        defaultLocale: 'en-GB',
        locales: ['en-GB'],
    },
    {
        domain: `${hostname}.igus.eu`,
        defaultLocale: 'en-DE',
        locales: ['en-DE'],
    },
    {
        domain: `${hostname}.igus.de`,
        defaultLocale: 'de-DE',
        locales: ['de-DE'],
    },
    {
        domain: `${hostname}.igus.com`,
        defaultLocale: 'en-US',
        locales: ['en-US'],
    },
    {
        domain: `${hostname}.igus.com.ar`,
        defaultLocale: 'es-AR',
        locales: ['es-AR'],
    },
    {
        domain: `${hostname}.igus.at`,
        defaultLocale: 'de-AT',
        locales: ['de-AT'],
    },
    {
        domain: `${hostname}.igus.com.au`,
        defaultLocale: 'en-AU',
        locales: ['en-AU'],
    },
    {
        domain: `${hostname}.igus.be`,
        defaultLocale: 'nl-BE',
        locales: ['nl-BE', 'fr-BE', 'de-BE'],
    },
    {
        domain: `${hostname}.igus.bg`,
        defaultLocale: 'en-BG',
        locales: ['en-BG'],
    },
    {
        domain: `${hostname}.igus.com.br`,
        defaultLocale: 'pt-BR',
        locales: ['pt-BR'],
    },
    {
        domain: `${hostname}.igus.ca`,
        defaultLocale: 'en-CA',
        locales: ['en-CA', 'fr-CA'],
    },
    {
        domain: `${hostname}.igus.ch`,
        defaultLocale: 'de-CH',
        locales: ['de-CH', 'fr-CH', 'it-CH'],
    },
    {
        domain: `${hostname}.igus.cl`,
        defaultLocale: 'es-CL',
        locales: ['es-CL'],
    },
    {
        domain: `${hostname}.igus.cz`,
        defaultLocale: 'cs-CZ',
        locales: ['cs-CZ'],
    },
    {
        domain: `${hostname}.igus.dk`,
        defaultLocale: 'da-DK',
        locales: ['da-DK'],
    },
    {
        domain: `${hostname}.igus.es`,
        defaultLocale: 'es-ES',
        locales: ['es-ES'],
    },
    {
        domain: `${hostname}.igus.com.eg`,
        defaultLocale: 'en-EG',
        locales: ['en-EG'],
    },
    {
        domain: `${hostname}.igus.fi`,
        defaultLocale: 'en-FI',
        locales: ['en-FI'],
    },
    {
        domain: `${hostname}.igus.fr`,
        defaultLocale: 'fr-FR',
        locales: ['fr-FR'],
    },
    {
        domain: `${hostname}.igus.gr`,
        defaultLocale: 'en-GR',
        locales: ['en-GR'],
    },
    {
        domain: `${hostname}.igus.hr`,
        defaultLocale: 'en-HR',
        locales: ['en-HR'],
    },
    {
        domain: `${hostname}.igus.hu`,
        defaultLocale: 'hu-HU',
        locales: ['hu-HU'],
    },
    {
        domain: `${hostname}.igus.ie`,
        defaultLocale: 'en-IE',
        locales: ['en-IE'],
    },
    {
        domain: `${hostname}.igus.co.il`,
        defaultLocale: 'en-IL',
        locales: ['en-IL'],
    },
    {
        domain: `${hostname}.igus.in`,
        defaultLocale: 'en-IN',
        locales: ['en-IN'],
    },
    {
        domain: `${hostname}.igus.it`,
        defaultLocale: 'it-IT',
        locales: ['it-IT'],
    },
    {
        domain: `${hostname}.igus.co.jp`,
        defaultLocale: 'ja-JP',
        locales: ['ja-JP'],
    },
    {
        domain: `${hostname}.igus.kr`,
        defaultLocale: 'ko-KR',
        locales: ['ko-KR'],
    },
    {
        domain: `${hostname}.igus.lt`,
        defaultLocale: 'en-LT',
        locales: ['en-LT'],
    },
    {
        domain: `${hostname}.igus.com.mx`,
        defaultLocale: 'es-MX',
        locales: ['es-MX'],
    },
    {
        domain: `${hostname}.igus.my`,
        defaultLocale: 'en-MY',
        locales: ['en-MY'],
    },
    {
        domain: `${hostname}.igus.nl`,
        defaultLocale: 'nl-NL',
        locales: ['nl-NL'],
    },
    {
        domain: `${hostname}.igus.no`,
        defaultLocale: 'en-NO',
        locales: ['en-NO'],
    },
    {
        domain: `${hostname}.igus.co.nz`,
        defaultLocale: 'en-NZ',
        locales: ['en-NZ'],
    },
    {
        domain: `${hostname}.igus.pl`,
        defaultLocale: 'pl-PL',
        locales: ['pl-PL'],
    },
    {
        domain: `${hostname}.igus.pt`,
        defaultLocale: 'pt-PT',
        locales: ['pt-PT'],
    },
    {
        domain: `${hostname}.igus.ro`,
        defaultLocale: 'ro-RO',
        locales: ['ro-RO'],
    },
    {
        domain: `${hostname}.igus.rs`,
        defaultLocale: 'en-RS',
        locales: ['en-RS'],
    },
    {
        domain: `${hostname}.igusab.se`,
        defaultLocale: 'sv-SE',
        locales: ['sv-SE'],
    },
    {
        domain: `${hostname}.igus.sg`,
        defaultLocale: 'en-SG',
        locales: ['en-SG'],
    },
    {
        domain: `${hostname}.igus.si`,
        defaultLocale: 'en-SI',
        locales: ['en-SI'],
    },
    {
        domain: `${hostname}.igus.sk`,
        defaultLocale: 'cs-SK',
        locales: ['cs-SK'],
    },
    {
        domain: `${hostname}.igus.com.tr`,
        defaultLocale: 'tr-TR',
        locales: ['tr-TR'],
    },
    {
        domain: `${hostname}.igus.com.tw`,
        defaultLocale: 'zh-TW',
        locales: ['zh-TW'],
    },
    {
        domain: `${hostname}.igus.vn`,
        defaultLocale: 'vi-VN',
        locales: ['vi-VN'],
    },
    {
        domain: `${hostname}.igus.co.za`,
        defaultLocale: 'en-ZA',
        locales: ['en-ZA'],
    },
    {
        domain: `${hostname}.igus.co.id`,
        defaultLocale: 'id-ID',
        locales: ['id-ID'],
    },
    {
        domain: `${hostname}.igus.ee`,
        defaultLocale: 'en-EE',
        locales: ['en-EE'],
    },
    {
        domain: `${hostname}.igus.co.th`,
        defaultLocale: 'th-TH',
        locales: ['th-TH'],
    },
    {
        domain: `${hostname}.igus.com.ua`,
        defaultLocale: 'en-UA',
        locales: ['en-UA'],
    },
];
const locales = [];
igusDomains.forEach(setup => {
    setup.locales.forEach(locale => {
        locales.push(locale);
    });
});
locales.push('nx-de');
const liveLocales = new Set([
    'en-US',
    'de-DE',
    'en-DE',
    'en', // Also add 'fr' and 'es' es soon as igus.eu/fr and igus.eu/es are live!
    'de-AT',
    'en-BG',
    'en-AU',
    'en-IL',
    'en-LT',
    'en-EE',
    'en-EG',
    'en-FI',
    'en-GR',
    'en-HR',
    'en-NO',
    'en-NZ',
    'en-RS',
    'en-SI',
    'en-ZA',
    'ro-RO',
    'cs-CZ',
    'en-SG',
    'en-MY',
    'es-ES',
    'en-GB',
    'fr-FR',
    'it-IT',
    'en-IE',
    'vi-VN',
    'pl-PL',
    'zh-TW',
    'tr-TR',
    'pt-BR',
    'en-CA',
    'fr-CA',
    'nl-NL',
    'pt-PT',
    'id-ID',
    'th-TH',
    'hu-HU',
    'ko-KR',
    'ja-JP',
    'fr-BE',
    'nl-BE',
    'de-BE',
    'es-CL',
    'es-AR',
    'es-MX',
    'sv-SE',
    'de-CH',
    'it-CH',
    'fr-CH',
]);
const igusDomainsByLocale = {};
const igusDomainsByFQDN = {};
// Generate lookup-tables because these lookups happen frequently.
for (const record of igusDomains) {
    igusDomainsByFQDN[record.domain] = record;
    // domain without hostname part for lookup without a hostname
    // this handles both www.igus.de → igus.de and www.igusab.se → igusab.se
    const domainWithoutHostname = record.domain.replace(/^[^.]+\./, '');
    if (domainWithoutHostname && domainWithoutHostname !== record.domain) {
        igusDomainsByFQDN[domainWithoutHostname] = record;
    }
    for (const locale of record.locales) {
        igusDomainsByLocale[locale] = record;
    }
}
/**
 * Format a locale identifier as a
 * [UTS locale identifier](https://www.unicode.org/reports/tr35/tr35-59/tr35.html#Identifiers).
 * You can feed in here the locale identifier from the Next.js router.
 *
 * Note: The igus pseudo locales 'en-de', 'fr-de', and 'es-de' are
 * translated to the official versions 'en', 'fr', and 'es' respectively.
 * Use `formatIgusLocaleIdentifier` instead if you do not want that
 * transformation.
 *
 * @param id - a locale identifier as read from `router.locale`
 * @returns - the formatted identifier, for example, `fr-CA`.
 */
function formatLocaleIdentifier(id) {
    var _a, _b;
    if (!id.length)
        id = defaultLocale;
    const parts = id.split('-');
    let newId = parts[0].toLowerCase();
    if (parts.length > 1) {
        if (((_a = parts[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== 'de' || newId === 'de') {
            newId += '-' + ((_b = parts[1]) === null || _b === void 0 ? void 0 : _b.toUpperCase());
        }
    }
    return newId;
}
/**
 * Determine whether a locale prefix is needed. The weird typing of the return
 * value is owed to the idiosyncrasies of the `locale` and `href` attributes of
 * the`<NextLink>` component.
 * @param id - a locale identifier as read from `router.locale`.
 * @returns - the locale prefix if a prefix is needed, false otherwise.
 */
function getLocalePrefix(id) {
    if (typeof id === 'undefined')
        return false;
    id = formatLocaleIdentifier(id);
    const record = igusDomainsByLocale[id];
    // If there is no record, we will serve the default locale which never needs
    // a prefix.
    if (!record)
        return false;
    if (id === record.defaultLocale)
        return false;
    return formatLocaleIdentifier(id);
}
/**
 * Get the domain setup for a specific locale identifier.
 * @param id - a locale identifier as read from `router.locale`.
 * @returns - the domain setup.
 */
function getDomainSetupByLocale(id) {
    var _a;
    return ((_a = igusDomainsByLocale[id]) !== null && _a !== void 0 ? _a : igusDomainsByLocale[defaultLocale]);
}
/**
 * Convert a URL path like fr-CA/website/foo/bar to a slug for the Storyblok
 * API, for example fr-ca/website/foo/bar.
 *
 * @param path the URL path
 * @returns the slug as found in Storyblok.
 */
const pathToSlug = (path) => {
    return path.replace(/^(\/?[a-z]{2}-[A-Z]{2})\/(website|configs)/, (_, locale, realm) => locale.toLowerCase() + '/' + realm);
};
/**
 * Gets the language codes that are natively supported in a country.
 *
 * @param countryCode Two–letter country code (e.g. 'CH', 'BE', 'DE')
 * @returns Array of language codes, e.g. ['de','fr','it']
 *
 * Rules
 * ─────
 * • Germany (DE) ➜ always returns ['de']  (to suppress the en-DE)
 * • Any other country:
 *   – include *every* language that occurs in `<lang>-<COUNTRY>`
 *   – keep the list alphabetical, but move 'de' to the front if present
 *   – development locales such as 'nx-DE' are ignored
 *   – returns [] if nothing is found
 */
function getSupportedLanguages(countryCode) {
    const upperCountry = countryCode.toUpperCase();
    const languages = new Set();
    for (const locale of locales) {
        if (locale === 'nx-DE')
            continue;
        const [language, country] = locale.split('-');
        if (language && country === upperCountry) {
            languages.add(language.toLowerCase());
        }
    }
    // Special-case: Germany  → only German
    if (upperCountry === 'DE' && languages.has('de')) {
        return ['de'];
    }
    const list = Array.from(languages).sort((a, b) => a.localeCompare(b));
    if (languages.has('de')) {
        return ['de', ...list.filter(l => l !== 'de')];
    }
    return list;
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var router$1 = {exports: {}};

var routerContext_sharedRuntime = {};

var _interop_require_default = {};

var hasRequired_interop_require_default;

function require_interop_require_default () {
	if (hasRequired_interop_require_default) return _interop_require_default;
	hasRequired_interop_require_default = 1;

	function _interop_require_default$1(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	_interop_require_default._ = _interop_require_default$1;
	return _interop_require_default;
}

var hasRequiredRouterContext_sharedRuntime;

function requireRouterContext_sharedRuntime () {
	if (hasRequiredRouterContext_sharedRuntime) return routerContext_sharedRuntime;
	hasRequiredRouterContext_sharedRuntime = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		Object.defineProperty(exports, "RouterContext", {
		    enumerable: true,
		    get: function() {
		        return RouterContext;
		    }
		});
		const _interop_require_default = /*@__PURE__*/ require_interop_require_default();
		const _react = /*#__PURE__*/ _interop_require_default._(React);
		const RouterContext = _react.default.createContext(null);
		if (process.env.NODE_ENV !== 'production') {
		    RouterContext.displayName = 'RouterContext';
		}

		
	} (routerContext_sharedRuntime));
	return routerContext_sharedRuntime;
}

var hasRequiredRouter$1;

function requireRouter$1 () {
	if (hasRequiredRouter$1) return router$1.exports;
	hasRequiredRouter$1 = 1;
	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		Object.defineProperty(exports, "useRouter", {
		    enumerable: true,
		    get: function() {
		        return useRouter;
		    }
		});
		const _react = React;
		const _routercontextsharedruntime = requireRouterContext_sharedRuntime();
		function useRouter() {
		    return (0, _react.useContext)(_routercontextsharedruntime.RouterContext);
		}

		if ((typeof exports.default === 'function' || (typeof exports.default === 'object' && exports.default !== null)) && typeof exports.default.__esModule === 'undefined') {
		  Object.defineProperty(exports.default, '__esModule', { value: true });
		  Object.assign(exports.default, exports);
		  module.exports = exports.default;
		}

		
	} (router$1, router$1.exports));
	return router$1.exports;
}

var router;
var hasRequiredRouter;

function requireRouter () {
	if (hasRequiredRouter) return router;
	hasRequiredRouter = 1;
	router = requireRouter$1();
	return router;
}

var routerExports = requireRouter();

var FormationType;
(function (FormationType) {
  FormationType["One"] = "1";
  FormationType["Two"] = "2";
  FormationType["Three"] = "3";
})(FormationType || (FormationType = {}));
var DownloadIconTheme;
(function (DownloadIconTheme) {
  DownloadIconTheme["Dark"] = "dark";
  DownloadIconTheme["Light"] = "light";
  DownloadIconTheme["Orange"] = "orange";
})(DownloadIconTheme || (DownloadIconTheme = {}));

var css$1g = {"document__wrapper":"Downloads-module_document__wrapper__x5npS","download__subgrid":"Downloads-module_download__subgrid__8kTsx","headline":"Downloads-module_headline__B3ZSp","icon__link__wrapper":"Downloads-module_icon__link__wrapper__bFQyP","link__primary_color":"Downloads-module_link__primary_color__KM491","download_icon_light":"Downloads-module_download_icon_light__ghFNJ","download_icon_dark":"Downloads-module_download_icon_dark__qJLek","download_icon_orange":"Downloads-module_download_icon_orange__14BS9","download__on__orange__background":"Downloads-module_download__on__orange__background__G0VMu","download__form__landing__text":"Downloads-module_download__form__landing__text__1dvGk","download__on__orange":"Downloads-module_download__on__orange__lolxs","one__column":"Downloads-module_one__column__EsfkP","two__column":"Downloads-module_two__column__tctLy","three__column":"Downloads-module_three__column__UMNVf"};

var CadIcon = function CadIcon(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: setIconVariant(variant),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2284 18.3917H12.723H12.9114L12.8506 18.2216L11.9939 15.7791H11.9635L11.1068 18.2216L11.0522 18.3917H11.2284Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4861 0.188232V9.52697H21.8309L12.4861 0.188232Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4309 17.7721C19.4309 16.5387 19.0724 15.5969 17.3954 15.5969H16.3443V19.9473H17.3954C19.0724 19.9534 19.4309 18.9995 19.4309 17.7721Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3777 0.188232H2.33316V23.9087H21.8187V11.6475H10.3777V0.188232ZM6.58633 20.9619C4.76962 20.9619 3.66379 19.5158 3.66379 17.766C3.66379 16.0282 4.76354 14.57 6.58633 14.57C7.96557 14.57 9.04101 15.3356 9.18076 16.6601H8.11139C7.93519 15.9553 7.47341 15.4389 6.58633 15.4389C5.27392 15.4389 4.73924 16.5933 4.73924 17.772C4.73924 18.9386 5.28607 20.1052 6.58633 20.1052C7.5524 20.1052 8.05063 19.4004 8.13569 18.5133H9.17468C9.08354 19.9654 8.0567 20.9619 6.58633 20.9619ZM15.281 14.7219H17.8025C19.68 14.7219 20.4942 16.089 20.4942 17.772C20.4942 19.4551 19.6861 20.8282 17.8025 20.8282H15.2749V14.7219H15.281ZM11.4167 14.7219H12.559L14.9104 20.8161H13.762L13.1909 19.1999H10.7544L10.1833 20.8161H9.08354L11.4167 14.7219Z"
  }));
};
var DefaultIcon = function DefaultIcon(_ref2) {
  var variant = _ref2.variant;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: setIconVariant(variant),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4071 0V9.45418H21.8613L12.4071 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8491 23.9781V11.5929H10.2744V0H2.13266V23.9781H21.8491Z"
  }));
};
var DwgIcon = function DwgIcon(_ref3) {
  var variant = _ref3.variant;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: setIconVariant(variant),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1412_8339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.28 0V9.45H21.73L12.28 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65001 16.13C6.93001 16.45 7.07001 16.86 7.07001 17.36V18.26C7.07001 18.76 6.93001 19.17 6.65001 19.49C6.37001 19.81 5.99001 19.97 5.50001 19.97H4.60001V15.65H5.50001C5.99001 15.65 6.38001 15.81 6.65001 16.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.14 11.59V0H2V23.98H21.72V11.59H10.14ZM8.05 18.26C8.05 19 7.82 19.6 7.35 20.06C6.88 20.52 6.27 20.76 5.53 20.76H3.62V14.87H5.53C6.28 14.87 6.88 15.1 7.35 15.57C7.82 16.03 8.05 16.63 8.05 17.37V18.26ZM13.82 20.76H12.93L11.75 16.53H11.73L10.55 20.76H9.65L8.25 14.87H9.22L10.16 19.17L11.34 14.87H12.13L13.32 19.17L14.25 14.87H15.22L13.82 20.76ZM20.12 19.96C19.97 20.18 19.71 20.38 19.35 20.57C18.99 20.75 18.53 20.84 17.97 20.84C17.26 20.84 16.68 20.62 16.22 20.17C15.76 19.72 15.53 19.14 15.53 18.43V17.2C15.53 16.48 15.75 15.9 16.18 15.45C16.62 15.01 17.17 14.78 17.86 14.78C18.55 14.78 19.09 14.95 19.48 15.29C19.86 15.63 20.06 16.08 20.06 16.63V16.65H19.13C19.12 16.35 18.99 16.07 18.78 15.87C18.57 15.67 18.27 15.57 17.87 15.57C17.68 15.56 17.5 15.6 17.32 15.68C17.15 15.76 17 15.88 16.89 16.03C16.64 16.33 16.51 16.72 16.51 17.19V18.43C16.51 18.9 16.65 19.29 16.92 19.6C17.05 19.75 17.21 19.86 17.39 19.94C17.58 20.02 17.77 20.06 17.97 20.06C18.23 20.06 18.48 20.03 18.72 19.95C18.88 19.9 19.02 19.81 19.14 19.7V18.5H17.97V17.77H20.12V19.96Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1412_8339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "19.73",
    height: "23.98",
    fill: "white",
    transform: "translate(2)"
  }))));
};
var DxfIcon = function DxfIcon(_ref4) {
  var variant = _ref4.variant;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: setIconVariant(variant),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1412_8341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.28 0V9.45H21.73L12.28 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34001 17.88C8.34001 19.04 8.00001 19.94 6.42001 19.94H5.42001V15.83H6.42001C8.00001 15.83 8.34001 16.73 8.34001 17.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.14 11.59V0H2V23.98H21.72V11.59H10.14ZM6.8 20.77H4.41V15H6.8C8.58 15 9.35 16.29 9.35 17.88C9.35 19.47 8.58 20.77 6.8 20.77ZM13.53 20.77L12.09 18.57L10.64 20.77H9.48L11.52 17.78L9.61 15H10.82L12.13 17.03L13.49 15H14.62L12.71 17.78L14.76 20.77H13.53ZM19.33 15.87H16.36V17.38H18.96V18.2H16.36V20.76H15.35V15H19.33V15.87Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1412_8341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "19.73",
    height: "23.98",
    fill: "white",
    transform: "translate(2)"
  }))));
};
var ExeIcon = function ExeIcon(_ref5) {
  var variant = _ref5.variant;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: setIconVariant(variant),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1412_8340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.28 0V9.45H21.73L12.28 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.14 11.59V0H2V23.98H21.72V11.59H10.14ZM8.59 20.91H4.47V14.78H8.57V15.6H5.5V17.33H8.18V18.15H5.49V20.09H8.59V20.91ZM13.1 20.91L11.78 18.61L10.44 20.91H9.23L11.16 17.83L9.28 14.79H10.48L11.76 17.06L13.05 14.79H14.26L12.37 17.83L14.33 20.91H13.1ZM19.27 20.91H15.13V14.78H19.23V15.6H16.15V17.33H18.83V18.15H16.16V20.09H19.27V20.91Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1412_8340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "19.73",
    height: "23.98",
    fill: "white",
    transform: "translate(2)"
  }))));
};
var PdfIcon = function PdfIcon(_ref6) {
  var variant = _ref6.variant;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: setIconVariant(variant),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.61922 15.7913C7.52201 15.7123 7.40657 15.6577 7.29112 15.6334C7.16353 15.603 7.02986 15.5908 6.89011 15.5908H5.31036V17.608H6.86581C6.98733 17.608 7.10884 17.5898 7.23036 17.5534C7.35796 17.5169 7.4734 17.4622 7.57669 17.3832C7.68606 17.3042 7.77112 17.2009 7.83796 17.0734C7.90479 16.9458 7.93517 16.7817 7.93517 16.5934C7.93517 16.3928 7.90479 16.2288 7.85011 16.1012C7.78935 15.9736 7.71036 15.8703 7.61922 15.7913Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0754 19.7832C13.3428 19.6738 13.5493 19.5158 13.7012 19.3214C13.8531 19.1209 13.9564 18.8961 14.0111 18.6287C14.0658 18.3614 14.0901 18.0758 14.0901 17.766C14.0901 17.4561 14.0597 17.1705 14.0111 16.9032C13.9564 16.6358 13.8531 16.411 13.7012 16.2105C13.5493 16.01 13.3428 15.8642 13.0754 15.7487C12.8081 15.6394 12.4678 15.5786 12.0547 15.5786H10.9974V19.9351H12.0486C12.4678 19.9533 12.8081 19.8986 13.0754 19.7832Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.407 0V9.45418H21.8612L12.407 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2744 0H2.13263V24H21.8491V11.5929H10.2744V0ZM8.92554 17.2192C8.87086 17.438 8.76757 17.6385 8.62174 17.8329C8.46984 18.0213 8.26326 18.1732 7.98985 18.2947C7.71643 18.4162 7.36402 18.483 6.93263 18.483H5.30428V20.8223H4.23491V14.722H6.92655C7.35795 14.722 7.71643 14.7828 7.98377 14.9104C8.25719 15.038 8.46377 15.1959 8.61567 15.3782C8.76757 15.5666 8.86478 15.7671 8.91947 15.9919C8.97415 16.2167 8.99845 16.4172 8.99845 16.6056C8.99238 16.7939 8.97415 17.0005 8.92554 17.2192ZM16.1012 14.722H20.3119V15.6456H17.1645V17.2435H19.9291V18.1185H17.1645V20.8284H16.1012V14.722ZM12.4617 14.722C12.9296 14.722 13.3367 14.801 13.6769 14.9651C14.0172 15.1291 14.2967 15.3418 14.5154 15.6213C14.7341 15.9008 14.8921 16.2228 14.9954 16.5873C15.1048 16.958 15.1534 17.3529 15.1534 17.7722C15.1534 18.1914 15.0987 18.5924 14.9954 18.957C14.886 19.3276 14.7281 19.6496 14.5154 19.923C14.3028 20.1965 14.0233 20.4152 13.6769 20.5792C13.3367 20.7433 12.9296 20.8223 12.4617 20.8223H9.93415V14.722H12.4617Z"
  }));
};
var ZippedIcon = function ZippedIcon(_ref7) {
  var variant = _ref7.variant;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: setIconVariant(variant),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4071 0V9.45418H21.8613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2684 0H6.30076V1.51899H7.81975V3.03797H6.30076V4.55696H7.81975V6.07595H6.30076V7.59494H7.81975V9.11392H6.30076V10.6329H7.81975V12.1519H6.30076V13.4582H7.6557C7.78937 13.4582 7.89874 13.5676 7.89874 13.7013L8.82228 19.7468C8.82228 19.759 8.8162 19.7651 8.81013 19.7772C8.82228 19.8076 8.82228 19.8441 8.82228 19.8744C8.82228 20.3787 7.70431 20.7919 6.33114 20.7919C4.95798 20.7919 3.84 20.3787 3.84 19.8744C3.84 19.838 3.84608 19.8076 3.85215 19.7772C3.84 19.7711 3.84 19.759 3.84 19.7468L4.76962 13.7013C4.76962 13.677 4.7757 13.6527 4.78177 13.6284V12.1519H6.30076V10.6329H4.78177V9.11392H6.30076V7.59494H4.78177V6.07595H6.30076V4.55696H4.78177V3.03797H6.30076V1.51899H4.78177V0H2.13266V24H21.8491V11.5747H10.2684V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23999 19.9049C6.86078 19.9049 7.36404 19.6927 7.36404 19.431C7.36404 19.1692 6.86078 18.957 6.23999 18.957C5.61919 18.957 5.11594 19.1692 5.11594 19.431C5.11594 19.6927 5.61919 19.9049 6.23999 19.9049Z"
  }));
};

var setFormation$1 = function setFormation(formation) {
  var layout = new Map();
  layout.set(FormationType.One, css$1g.one__column);
  layout.set(FormationType.Two, css$1g.two__column);
  layout.set(FormationType.Three, css$1g.three__column);
  return layout.get(formation);
};
var setIconVariant = function setIconVariant(variant) {
  var iconFill = new Map();
  iconFill.set(DownloadIconTheme.Dark, css$1g.download_icon_dark);
  iconFill.set(DownloadIconTheme.Light, css$1g.download_icon_light);
  iconFill.set(DownloadIconTheme.Orange, css$1g.download_icon_orange);
  return iconFill.get(variant);
};
var setDownloadIcon = function setDownloadIcon(props) {
  switch (props.icon) {
    case 'zip':
      return /*#__PURE__*/React.createElement(ZippedIcon, {
        variant: props.variant
      });
    case 'cad':
      return /*#__PURE__*/React.createElement(CadIcon, {
        variant: props.variant
      });
    case 'exe':
      return /*#__PURE__*/React.createElement(ExeIcon, {
        variant: props.variant
      });
    case 'dxf':
      return /*#__PURE__*/React.createElement(DxfIcon, {
        variant: props.variant
      });
    case 'pdf':
      return /*#__PURE__*/React.createElement(PdfIcon, {
        variant: props.variant
      });
    case 'dwg':
      return /*#__PURE__*/React.createElement(DwgIcon, {
        variant: props.variant
      });
    default:
      return /*#__PURE__*/React.createElement(DefaultIcon, {
        variant: props.variant
      });
  }
};

var css$1f = {"linkPrimaryColor":"Link-module_linkPrimaryColor__uardF","linkSecondaryColor":"Link-module_linkSecondaryColor__NQkj9","linkTertiaryColor":"Link-module_linkTertiaryColor__JKRsD","buttonStyleLink":"Link-module_buttonStyleLink__kHSKX","buttonTertiary":"Link-module_buttonTertiary__fd1hI","buttonSecondary":"Link-module_buttonSecondary__HLr6y","button__theming__color1":"Link-module_button__theming__color1__wePko","button__theming__color2":"Link-module_button__theming__color2__VhovA","on__orange__background__button":"Link-module_on__orange__background__button__HaaZI","buttonTransparent":"Link-module_buttonTransparent__QKctY","layout":"Link-module_layout__-XLu-","iconSpace":"Link-module_iconSpace__4wMz9","iconBefore":"Link-module_iconBefore__DWw4y","iconAfter":"Link-module_iconAfter__yDmPe","externalLinkIcon":"Link-module_externalLinkIcon__uoQoT","iconWrap":"Link-module_iconWrap__o-7M7","externalLinkIconPrimary":"Link-module_externalLinkIconPrimary__087P9","externalLinkIconSecondary":"Link-module_externalLinkIconSecondary__aEAFA","externalLinkIconTertiary":"Link-module_externalLinkIconTertiary__QeHKw","externalLinkIconButton":"Link-module_externalLinkIconButton__TbAsa","externalLinkIconButtonSecondary":"Link-module_externalLinkIconButtonSecondary__rDXHu","externalLinkIconThemeColor1":"Link-module_externalLinkIconThemeColor1__0Bgvt","externalLinkIconThemeColor2":"Link-module_externalLinkIconThemeColor2__DVmLU","cross__domain":"Link-module_cross__domain__JJ7lF"};

var LinkVariant;
(function (LinkVariant) {
  LinkVariant["Primary"] = "primary";
  LinkVariant["Secondary"] = "secondary";
  LinkVariant["Tertiary"] = "tertiary";
  LinkVariant["Button"] = "button";
  LinkVariant["ButtonTertiary"] = "button_tertiary";
  LinkVariant["ButtonSecondary"] = "button_secondary";
  LinkVariant["ButtonThemingColor1"] = "button_theming_color_1";
  LinkVariant["ButtonThemingColor2"] = "button_theming_color_2";
  LinkVariant["ButtonTransparent"] = "button_transparent";
})(LinkVariant || (LinkVariant = {}));
var TargetValues;
(function (TargetValues) {
  TargetValues["Blank"] = "_blank";
  TargetValues["Self"] = "_self";
  TargetValues["Parent"] = "_parent";
  TargetValues["Top"] = "_top";
})(TargetValues || (TargetValues = {}));
var IconPosition;
(function (IconPosition) {
  IconPosition[IconPosition["Before"] = 0] = "Before";
  IconPosition[IconPosition["After"] = 1] = "After";
})(IconPosition || (IconPosition = {}));
var ContactType;
(function (ContactType) {
  ContactType["Fax"] = "fax";
  ContactType["Phone"] = "phone";
  ContactType["CellPhone"] = "cell_phone";
  ContactType["Whatsapp"] = "whatsapp";
  ContactType["Email"] = "email";
})(ContactType || (ContactType = {}));
var LinkType;
(function (LinkType) {
  LinkType["Url"] = "url";
  LinkType["Email"] = "email";
  LinkType["Story"] = "story";
})(LinkType || (LinkType = {}));
var RelType;
(function (RelType) {
  RelType["NO_FOLLOW"] = "nofollow";
  RelType["NO_OPENER"] = "noopener";
  RelType["NO_REFERRER"] = "noreferrer";
})(RelType || (RelType = {}));

function _createForOfIteratorHelper$6(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$6(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$6(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$6(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$6(r, a) : void 0; } }
function _arrayLikeToArray$6(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var isValidEmail = function isValidEmail(email) {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};
var formatContactText = function formatContactText(type, contact_text) {
  switch (type) {
    case ContactType.Phone:
    case ContactType.CellPhone:
    case ContactType.Fax:
      return "tel:".concat(contact_text.replace(/[-\s()]/g, ''));
    case ContactType.Whatsapp:
      return "https://wa.me/".concat(contact_text).replace(/\s/g, '');
    case ContactType.Email:
      return "mailto:".concat(contact_text).trim().replace(/\s/g, '');
    default:
      return contact_text;
  }
};
var setIconPosition = function setIconPosition(icon, iconPosition) {
  if (!icon) {
    return '';
  }
  if (iconPosition === IconPosition.Before) {
    return css$1f.iconBefore;
  }
  if (iconPosition === IconPosition.After) {
    return css$1f.iconAfter;
  }
};
var setRelValueFromTarget = function setRelValueFromTarget(target) {
  switch (target) {
    case TargetValues.Blank:
    default:
      return 'noopener';
    case TargetValues.Self:
      return 'noreferrer';
    case TargetValues.Parent:
      return 'nofollow';
    case TargetValues.Top:
      return 'nofollow';
  }
};
var changeLinkStyle = function changeLinkStyle(variant, onOrangeBackground) {
  switch (variant) {
    case LinkVariant.Primary:
    default:
      return css$1f.linkPrimaryColor;
    case LinkVariant.Secondary:
      return css$1f.linkSecondaryColor;
    case LinkVariant.Tertiary:
      return css$1f.linkTertiaryColor;
    case LinkVariant.Button:
      return "".concat(css$1f.buttonStyleLink, " ").concat(onOrangeBackground ? css$1f.on__orange__background__button : '');
    case LinkVariant.ButtonTertiary:
      return "".concat(css$1f.buttonTertiary, " ").concat(onOrangeBackground ? css$1f.on__orange__background__button : '');
    case LinkVariant.ButtonSecondary:
      return css$1f.buttonSecondary;
    case LinkVariant.ButtonThemingColor1:
      return css$1f.button__theming__color1;
    case LinkVariant.ButtonThemingColor2:
      return css$1f.button__theming__color2;
    case LinkVariant.ButtonTransparent:
      return css$1f.buttonTransparent;
  }
};
var formatLink = function formatLink(href, urlPath) {
  var pattern = /.*website/;
  if (urlPath === null || urlPath === void 0 ? void 0 : urlPath.includes('/editor/')) {
    var domain = urlPath.split('/')[2];
    return "/".concat(domain).concat((href === null || href === void 0 ? void 0 : href.split(pattern)[1]) || '');
  }
  if (href === null || href === void 0 ? void 0 : href.startsWith('https://')) return href;
  return (href === null || href === void 0 ? void 0 : href.split(pattern)[1]) || '';
};
var externalLinkVariant = {
  primary: css$1f.externalLinkIconPrimary,
  secondary: css$1f.externalLinkIconSecondary,
  tertiary: css$1f.externalLinkIconTertiary,
  button: css$1f.externalLinkIconButton,
  button_tertiary: css$1f.buttonTertiary,
  button_secondary: css$1f.externalLinkIconButtonSecondary,
  button_theming_color_1: css$1f.externalLinkIconThemeColor1,
  button_theming_color_2: css$1f.externalLinkIconThemeColor2,
  button_transparent: css$1f.buttonTransparent
};
function isIgusDomain(url) {
  var igus = 'igus';
  var domain = (url === null || url === void 0 ? void 0 : url.replace(/^(https?:\/\/)?(www\.)?/i, '')) || '';
  var _domain$split = domain.split('?'),
    _domain$split2 = _slicedToArray(_domain$split, 2),
    domainPart = _domain$split2[0],
    queryPart = _domain$split2[1];
  if (typeof url === 'undefined') {
    return false;
  }
  if (url.startsWith('/')) {
    return true;
  }
  if (domainPart && domainPart.includes(igus) && domainPart.split('/').every(function (part) {
    return part !== igus;
  })) {
    if (queryPart) {
      var queryParams = new URLSearchParams(queryPart);
      var _iterator = _createForOfIteratorHelper$6(queryParams.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            param = _step$value[0],
            value = _step$value[1];
          if (param.includes(igus) || value.includes(igus)) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return true;
  }
  return false;
}
var isButtonLink = function isButtonLink(variant) {
  return variant !== LinkVariant.Primary && variant !== LinkVariant.Secondary && variant !== LinkVariant.Tertiary;
};
var determineContactType = function determineContactType(url, linktype) {
  if ((url === null || url === void 0 ? void 0 : url.startsWith('+')) || (url === null || url === void 0 ? void 0 : url.startsWith('('))) {
    return ContactType.Phone;
  }
  return linktype || '';
};
var isExternalCrossDomain = function isExternalCrossDomain(href, urlPath) {
  if (!(urlPath === null || urlPath === void 0 ? void 0 : urlPath.includes('/editor/'))) {
    return false;
  }
  var browserDomain = urlPath === null || urlPath === void 0 ? void 0 : urlPath.split('/')[2];
  var countryCode = browserDomain === null || browserDomain === void 0 ? void 0 : browserDomain.split('-')[1];
  var topLevelDomain = getTLD(href);
  if (browserDomain === 'en-us' && topLevelDomain === 'com') {
    return false;
  }
  if (countryCode === topLevelDomain) {
    return false;
  }
  return true;
};
var isInternalCrossDomain = function isInternalCrossDomain(href, urlPath) {
  if (!(urlPath === null || urlPath === void 0 ? void 0 : urlPath.includes('/editor/'))) return false;
  var browserDomain = urlPath === null || urlPath === void 0 ? void 0 : urlPath.split('/')[2];
  var linkDomain = href.split('/')[0];
  var countryCode = browserDomain === null || browserDomain === void 0 ? void 0 : browserDomain.split('-')[1];
  if (browserDomain === linkDomain) return false;
  if (countryCode === linkDomain) return false;
  return true;
};
function getTLD(url) {
  var _a;
  var domainRegex = /^(?:https?:\/\/)?(?:www\.)?([^/:?#]+)(?:[/:?#]|$)/i;
  var matches = url === null || url === void 0 ? void 0 : url.match(domainRegex);
  if (matches && matches[1]) {
    var hostnameParts = (_a = matches[1]) === null || _a === void 0 ? void 0 : _a.split('.');
    return hostnameParts[hostnameParts.length - 1];
  }
  return '';
}
/**
 * formats an href with the correct locale prefix for igus domains.
 * handles locale country code capitalization (e.g., 'it-CH' instead of 'it-ch').
 *
 * @param href - The URL to format
 * @param locale - The current locale (e.g., 'it-ch', 'fr-ca')
 * @param isIgusDomain - Whether the URL is an igus domain or not
 * @returns Formatted href with proper locale prefix and capitalization
 * @example
 * // returns '/it-CH/products' for igus domain
 * formatLocaleHref('/products', 'it-ch', true)
 */
function formatLocaleHref(href, locale, isIgusDomain, onCountrySwitch) {
  if (!isIgusDomain || !locale || (href === null || href === void 0 ? void 0 : href.startsWith('http')) || onCountrySwitch) {
    return href;
  }
  var _locale$split = locale.split('-'),
    _locale$split2 = _slicedToArray(_locale$split, 2),
    lang = _locale$split2[0],
    country = _locale$split2[1];
  var formattedLocale = "".concat(lang, "-").concat(country === null || country === void 0 ? void 0 : country.toUpperCase());
  return "/".concat(formattedLocale).concat(href);
}

var ExternalLinkIcon$1 = function ExternalLinkIcon(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/React.createElement("span", {
    className: css$1f.iconWrap
  }, "\xA0", /*#__PURE__*/React.createElement("svg", {
    className: "".concat(css$1f.externalLinkIcon, " ").concat(externalLinkVariant[variant]),
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10.6667H1.33333V1.33333H6V0H1.33333C0.593333 0 0 0.6 0 1.33333V10.6667C0 11.4 0.593333 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V6H10.6667V10.6667ZM7.33333 0V1.33333H9.72667L3.17333 7.88667L4.11333 8.82667L10.6667 2.27333V4.66667H12V0H7.33333Z"
  })));
};
var ExternalLink$1 = function ExternalLink(_a) {
  var _a$showExternalIcon = _a.showExternalIcon,
    showExternalIcon = _a$showExternalIcon === void 0 ? true : _a$showExternalIcon,
    children = _a.children,
    icon = _a.icon,
    href = _a.href,
    title = _a.title,
    download = _a.download,
    target = _a.target,
    rel = _a.rel,
    iconPosition = _a.iconPosition,
    variant = _a.variant,
    className = _a.className,
    _a$onOrangeBackground = _a.onOrangeBackground,
    onOrangeBackground = _a$onOrangeBackground === void 0 ? false : _a$onOrangeBackground,
    onMouseEnterEvent = _a.onMouseEnterEvent,
    _a$contact_type = _a.contact_type,
    contact_type = _a$contact_type === void 0 ? '' : _a$contact_type,
    piwik_click_id = _a.piwik_click_id,
    onClickHandler = _a.onClickHandler,
    _a$onCountrySwitch = _a.onCountrySwitch,
    onCountrySwitch = _a$onCountrySwitch === void 0 ? null : _a$onCountrySwitch,
    props = __rest(_a, ["showExternalIcon", "children", "icon", "href", "title", "download", "target", "rel", "iconPosition", "variant", "className", "onOrangeBackground", "onMouseEnterEvent", "contact_type", "piwik_click_id", "onClickHandler", "onCountrySwitch"]);
  var linkStyle = changeLinkStyle(variant, onOrangeBackground);
  var showIcon = setIconPosition(icon, iconPosition);
  var isEmail = isValidEmail(href);
  var igusDomain = isIgusDomain(href);
  var formattedContactHref = formatContactText(contact_type, href || '');
  var router = routerExports.useRouter();
  var isCrossDomain = isExternalCrossDomain(href, props.asPath || (router === null || router === void 0 ? void 0 : router.asPath));
  var localePrefix = getLocalePrefix(props.locale || (router === null || router === void 0 ? void 0 : router.locale));
  var formattedHref = formatLocaleHref(href, localePrefix, igusDomain, onCountrySwitch);
  return /*#__PURE__*/React.createElement("a", {
    onMouseEnter: onMouseEnterEvent,
    onClick: function onClick() {
      return onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
    },
    href: isEmail || typeof contact_type === 'string' && contact_type.trim() !== '' && contact_type !== LinkType.Url ? formattedContactHref : formattedHref,
    title: title,
    target: target,
    className: "".concat(css$1f.layout, " ").concat(linkStyle, " ").concat(isCrossDomain ? css$1f.cross__domain : '', " ").concat(className ? className : ''),
    rel: rel,
    download: download,
    "data-piwik-click-id": piwik_click_id || undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(showIcon ? showIcon : '')
  }, icon && (/*#__PURE__*/React.createElement("span", {
    className: "".concat(css$1f.iconSpace)
  }, /*#__PURE__*/React.createElement("img", {
    alt: props.altText,
    src: props.iconSource
  }))), children, !isEmail && showExternalIcon && !igusDomain && (/*#__PURE__*/React.createElement(ExternalLinkIcon$1, {
    variant: variant
  }))));
};
var InternalLink$1 = function InternalLink(_a) {
  var children = _a.children,
    icon = _a.icon,
    iconPosition = _a.iconPosition,
    variant = _a.variant,
    className = _a.className,
    href = _a.href,
    iconSource = _a.iconSource,
    altText = _a.altText,
    download = _a.download,
    downloadIcon = _a.downloadIcon,
    _a$onOrangeBackground2 = _a.onOrangeBackground,
    onOrangeBackground = _a$onOrangeBackground2 === void 0 ? false : _a$onOrangeBackground2,
    formatLink$1 = _a.formatLink,
    onMouseEnterEvent = _a.onMouseEnterEvent,
    _a$isNav = _a.isNav,
    isNav = _a$isNav === void 0 ? false : _a$isNav,
    anchor = _a.anchor,
    onClickHandler = _a.onClickHandler,
    props = __rest(_a, ["children", "icon", "iconPosition", "variant", "className", "href", "iconSource", "altText", "download", "downloadIcon", "onOrangeBackground", "formatLink", "onMouseEnterEvent", "isNav", "anchor", "onClickHandler"]);
  var showIcon = setIconPosition(icon, iconPosition);
  var linkStyle = changeLinkStyle(variant, onOrangeBackground) || '';
  var formatLinkFunc = formatLink$1 || formatLink;
  var router = routerExports.useRouter();
  var isCrossDomain = isInternalCrossDomain(href, props.asPath || (router === null || router === void 0 ? void 0 : router.asPath));
  var localePrefix = getLocalePrefix(props.locale || (router === null || router === void 0 ? void 0 : router.locale));
  return /*#__PURE__*/React.createElement(Link$1, Object.assign({
    onMouseEnter: onMouseEnterEvent,
    onClick: function onClick() {
      return onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
    },
    prefetch: false,
    locale: localePrefix || false,
    href: !download ? formatLinkFunc("".concat(!anchor ? href : "".concat(href, "#").concat(mapUmlaut(anchor))), props.asPath || (router === null || router === void 0 ? void 0 : router.asPath)) : href
  }, props, {
    className: "".concat(css$1f.layout, " ").concat(linkStyle, " ").concat(showIcon ? showIcon : '', " ").concat(isCrossDomain ? css$1f.cross__domain : '', " ").concat(className ? className : ''),
    target: !download ? '_self' : '_blank'
  }), downloadIcon && setDownloadIcon({
    icon: downloadIcon,
    variant: DownloadIconTheme.Light
  }), isNav ? /*#__PURE__*/React.createElement("span", null, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children), iconSource && /*#__PURE__*/React.createElement("img", {
    alt: altText,
    src: iconSource
  }));
};
var Link = function Link(props) {
  var external = props.external,
    children = props.children,
    className = props.className,
    showExternalIcon = props.showExternalIcon,
    onOrangeBackground = props.onOrangeBackground,
    href = props.href,
    rest = __rest(props, ["external", "children", "className", "showExternalIcon", "onOrangeBackground", "href"]);
  var renderClassName = className ? className : '';
  var emptyLink = external ? true : formatLink(href) === '';
  if (external || emptyLink) {
    return /*#__PURE__*/React.createElement(ExternalLink$1, Object.assign({
      className: renderClassName,
      showExternalIcon: showExternalIcon,
      onOrangeBackground: onOrangeBackground,
      iconPosition: props.iconPosition === IconPosition.After ? IconPosition.Before : undefined,
      href: href
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement(InternalLink$1, Object.assign({
    className: renderClassName,
    onOrangeBackground: onOrangeBackground,
    href: href
  }, rest), children);
};

var Asset = function Asset(_ref) {
  var assetLink = _ref.assetLink,
    filename = _ref.filename,
    title = _ref.title,
    _ref$external = _ref.external,
    external = _ref$external === void 0 ? true : _ref$external;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Link, {
    href: assetLink,
    title: title || filename,
    target: TargetValues.Blank,
    download: true,
    external: external,
    icon: false,
    variant: LinkVariant.Primary
  }, filename))));
};

var css$1e = {"backToTop":"BackToTop-module_backToTop__ox0L3","show":"BackToTop-module_show__y7cu8","large":"BackToTop-module_large__d9ANU","small":"BackToTop-module_small__SmKuX"};

var scrollToTop = function scrollToTop() {
  if (typeof window !== 'undefined') {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
};
var BackToTop = function BackToTop(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'large' : _ref$variant;
  var _useState = useState(false),
    show = _useState[0],
    setShow = _useState[1];
  var buttonRef = useRef(null);
  useEffect(function () {
    var options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setShow(!entry.isIntersecting);
      });
    }, options);
    var currentButtonRef = buttonRef.current;
    if (currentButtonRef) {
      observer.observe(currentButtonRef);
    }
    var handleScroll = function handleScroll() {
      if (typeof window !== 'undefined') {
        setShow(window.scrollY > 1200);
      }
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
    }
    return function () {
      if (currentButtonRef) {
        observer.unobserve(currentButtonRef);
      }
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  var variantStyles = variant === 'large' ? css$1e.large : css$1e.small;
  return /*#__PURE__*/React.createElement("button", {
    className: "".concat(css$1e.backToTop, " ").concat(variantStyles, " ").concat(show ? css$1e.show : ''),
    onClick: scrollToTop,
    "aria-label": "Back to top",
    type: "button",
    title: "Back to top"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "12",
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12L12 0L24 12H0Z",
    fill: "white"
  })));
};

var script$1 = {exports: {}};

var _interop_require_wildcard = {};

var hasRequired_interop_require_wildcard;

function require_interop_require_wildcard () {
	if (hasRequired_interop_require_wildcard) return _interop_require_wildcard;
	hasRequired_interop_require_wildcard = 1;

	function _getRequireWildcardCache(nodeInterop) {
	    if (typeof WeakMap !== "function") return null;

	    var cacheBabelInterop = new WeakMap();
	    var cacheNodeInterop = new WeakMap();

	    return (_getRequireWildcardCache = function(nodeInterop) {
	        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	    })(nodeInterop);
	}
	function _interop_require_wildcard$1(obj, nodeInterop) {
	    if (!nodeInterop && obj && obj.__esModule) return obj;
	    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return { default: obj };

	    var cache = _getRequireWildcardCache(nodeInterop);

	    if (cache && cache.has(obj)) return cache.get(obj);

	    var newObj = { __proto__: null };
	    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

	    for (var key in obj) {
	        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
	            else newObj[key] = obj[key];
	        }
	    }

	    newObj.default = obj;

	    if (cache) cache.set(obj, newObj);

	    return newObj;
	}
	_interop_require_wildcard._ = _interop_require_wildcard$1;
	return _interop_require_wildcard;
}

var headManagerContext_sharedRuntime = {};

var hasRequiredHeadManagerContext_sharedRuntime;

function requireHeadManagerContext_sharedRuntime () {
	if (hasRequiredHeadManagerContext_sharedRuntime) return headManagerContext_sharedRuntime;
	hasRequiredHeadManagerContext_sharedRuntime = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		Object.defineProperty(exports, "HeadManagerContext", {
		    enumerable: true,
		    get: function() {
		        return HeadManagerContext;
		    }
		});
		const _interop_require_default = /*@__PURE__*/ require_interop_require_default();
		const _react = /*#__PURE__*/ _interop_require_default._(React);
		const HeadManagerContext = _react.default.createContext({});
		if (process.env.NODE_ENV !== 'production') {
		    HeadManagerContext.displayName = 'HeadManagerContext';
		}

		
	} (headManagerContext_sharedRuntime));
	return headManagerContext_sharedRuntime;
}

var setAttributesFromProps = {exports: {}};

var hasRequiredSetAttributesFromProps;

function requireSetAttributesFromProps () {
	if (hasRequiredSetAttributesFromProps) return setAttributesFromProps.exports;
	hasRequiredSetAttributesFromProps = 1;
	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		Object.defineProperty(exports, "setAttributesFromProps", {
		    enumerable: true,
		    get: function() {
		        return setAttributesFromProps;
		    }
		});
		const DOMAttributeNames = {
		    acceptCharset: 'accept-charset',
		    className: 'class',
		    htmlFor: 'for',
		    httpEquiv: 'http-equiv',
		    noModule: 'noModule'
		};
		const ignoreProps = [
		    'onLoad',
		    'onReady',
		    'dangerouslySetInnerHTML',
		    'children',
		    'onError',
		    'strategy',
		    'stylesheets'
		];
		function isBooleanScriptAttribute(attr) {
		    return [
		        'async',
		        'defer',
		        'noModule'
		    ].includes(attr);
		}
		function setAttributesFromProps(el, props) {
		    for (const [p, value] of Object.entries(props)){
		        if (!props.hasOwnProperty(p)) continue;
		        if (ignoreProps.includes(p)) continue;
		        // we don't render undefined props to the DOM
		        if (value === undefined) {
		            continue;
		        }
		        const attr = DOMAttributeNames[p] || p.toLowerCase();
		        if (el.tagName === 'SCRIPT' && isBooleanScriptAttribute(attr)) {
		            el[attr] = !!value;
		        } else {
		            el.setAttribute(attr, String(value));
		        }
		        // Remove falsy non-zero boolean attributes so they are correctly interpreted
		        // (e.g. if we set them to false, this coerces to the string "false", which the browser interprets as true)
		        if (value === false || el.tagName === 'SCRIPT' && isBooleanScriptAttribute(attr) && (!value || value === 'false')) {
		            // Call setAttribute before, as we need to set and unset the attribute to override force async:
		            // https://html.spec.whatwg.org/multipage/scripting.html#script-force-async
		            el.setAttribute(attr, '');
		            el.removeAttribute(attr);
		        }
		    }
		}

		if ((typeof exports.default === 'function' || (typeof exports.default === 'object' && exports.default !== null)) && typeof exports.default.__esModule === 'undefined') {
		  Object.defineProperty(exports.default, '__esModule', { value: true });
		  Object.assign(exports.default, exports);
		  module.exports = exports.default;
		}

		
	} (setAttributesFromProps, setAttributesFromProps.exports));
	return setAttributesFromProps.exports;
}

var requestIdleCallback = {exports: {}};

var hasRequiredRequestIdleCallback;

function requireRequestIdleCallback () {
	if (hasRequiredRequestIdleCallback) return requestIdleCallback.exports;
	hasRequiredRequestIdleCallback = 1;
	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		function _export(target, all) {
		    for(var name in all)Object.defineProperty(target, name, {
		        enumerable: true,
		        get: all[name]
		    });
		}
		_export(exports, {
		    cancelIdleCallback: function() {
		        return cancelIdleCallback;
		    },
		    requestIdleCallback: function() {
		        return requestIdleCallback;
		    }
		});
		const requestIdleCallback = typeof self !== 'undefined' && self.requestIdleCallback && self.requestIdleCallback.bind(window) || function(cb) {
		    let start = Date.now();
		    return self.setTimeout(function() {
		        cb({
		            didTimeout: false,
		            timeRemaining: function() {
		                return Math.max(0, 50 - (Date.now() - start));
		            }
		        });
		    }, 1);
		};
		const cancelIdleCallback = typeof self !== 'undefined' && self.cancelIdleCallback && self.cancelIdleCallback.bind(window) || function(id) {
		    return clearTimeout(id);
		};

		if ((typeof exports.default === 'function' || (typeof exports.default === 'object' && exports.default !== null)) && typeof exports.default.__esModule === 'undefined') {
		  Object.defineProperty(exports.default, '__esModule', { value: true });
		  Object.assign(exports.default, exports);
		  module.exports = exports.default;
		}

		
	} (requestIdleCallback, requestIdleCallback.exports));
	return requestIdleCallback.exports;
}

var hasRequiredScript$1;

function requireScript$1 () {
	if (hasRequiredScript$1) return script$1.exports;
	hasRequiredScript$1 = 1;
	(function (module, exports) {
		'use client';
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		function _export(target, all) {
		    for(var name in all)Object.defineProperty(target, name, {
		        enumerable: true,
		        get: all[name]
		    });
		}
		_export(exports, {
		    default: function() {
		        return _default;
		    },
		    handleClientScriptLoad: function() {
		        return handleClientScriptLoad;
		    },
		    initScriptLoader: function() {
		        return initScriptLoader;
		    }
		});
		const _interop_require_default = /*@__PURE__*/ require_interop_require_default();
		const _interop_require_wildcard = /*@__PURE__*/ require_interop_require_wildcard();
		const _jsxruntime = require$$2;
		const _reactdom = /*#__PURE__*/ _interop_require_default._(require$$3);
		const _react = /*#__PURE__*/ _interop_require_wildcard._(React);
		const _headmanagercontextsharedruntime = requireHeadManagerContext_sharedRuntime();
		const _setattributesfromprops = requireSetAttributesFromProps();
		const _requestidlecallback = requireRequestIdleCallback();
		const ScriptCache = new Map();
		const LoadCache = new Set();
		const insertStylesheets = (stylesheets)=>{
		    // Case 1: Styles for afterInteractive/lazyOnload with appDir injected via handleClientScriptLoad
		    //
		    // Using ReactDOM.preinit to feature detect appDir and inject styles
		    // Stylesheets might have already been loaded if initialized with Script component
		    // Re-inject styles here to handle scripts loaded via handleClientScriptLoad
		    // ReactDOM.preinit handles dedup and ensures the styles are loaded only once
		    if (_reactdom.default.preinit) {
		        stylesheets.forEach((stylesheet)=>{
		            _reactdom.default.preinit(stylesheet, {
		                as: 'style'
		            });
		        });
		        return;
		    }
		    // Case 2: Styles for afterInteractive/lazyOnload with pages injected via handleClientScriptLoad
		    //
		    // We use this function to load styles when appdir is not detected
		    // TODO: Use React float APIs to load styles once available for pages dir
		    if (typeof window !== 'undefined') {
		        let head = document.head;
		        stylesheets.forEach((stylesheet)=>{
		            let link = document.createElement('link');
		            link.type = 'text/css';
		            link.rel = 'stylesheet';
		            link.href = stylesheet;
		            head.appendChild(link);
		        });
		    }
		};
		const loadScript = (props)=>{
		    const { src, id, onLoad = ()=>{}, onReady = null, dangerouslySetInnerHTML, children = '', strategy = 'afterInteractive', onError, stylesheets } = props;
		    const cacheKey = id || src;
		    // Script has already loaded
		    if (cacheKey && LoadCache.has(cacheKey)) {
		        return;
		    }
		    // Contents of this script are already loading/loaded
		    if (ScriptCache.has(src)) {
		        LoadCache.add(cacheKey);
		        // It is possible that multiple `next/script` components all have same "src", but has different "onLoad"
		        // This is to make sure the same remote script will only load once, but "onLoad" are executed in order
		        ScriptCache.get(src).then(onLoad, onError);
		        return;
		    }
		    /** Execute after the script first loaded */ const afterLoad = ()=>{
		        // Run onReady for the first time after load event
		        if (onReady) {
		            onReady();
		        }
		        // add cacheKey to LoadCache when load successfully
		        LoadCache.add(cacheKey);
		    };
		    const el = document.createElement('script');
		    const loadPromise = new Promise((resolve, reject)=>{
		        el.addEventListener('load', function(e) {
		            resolve();
		            if (onLoad) {
		                onLoad.call(this, e);
		            }
		            afterLoad();
		        });
		        el.addEventListener('error', function(e) {
		            reject(e);
		        });
		    }).catch(function(e) {
		        if (onError) {
		            onError(e);
		        }
		    });
		    if (dangerouslySetInnerHTML) {
		        // Casting since lib.dom.d.ts doesn't have TrustedHTML yet.
		        el.innerHTML = dangerouslySetInnerHTML.__html || '';
		        afterLoad();
		    } else if (children) {
		        el.textContent = typeof children === 'string' ? children : Array.isArray(children) ? children.join('') : '';
		        afterLoad();
		    } else if (src) {
		        el.src = src;
		        // do not add cacheKey into LoadCache for remote script here
		        // cacheKey will be added to LoadCache when it is actually loaded (see loadPromise above)
		        ScriptCache.set(src, loadPromise);
		    }
		    (0, _setattributesfromprops.setAttributesFromProps)(el, props);
		    if (strategy === 'worker') {
		        el.setAttribute('type', 'text/partytown');
		    }
		    el.setAttribute('data-nscript', strategy);
		    // Load styles associated with this script
		    if (stylesheets) {
		        insertStylesheets(stylesheets);
		    }
		    document.body.appendChild(el);
		};
		function handleClientScriptLoad(props) {
		    const { strategy = 'afterInteractive' } = props;
		    if (strategy === 'lazyOnload') {
		        window.addEventListener('load', ()=>{
		            (0, _requestidlecallback.requestIdleCallback)(()=>loadScript(props));
		        });
		    } else {
		        loadScript(props);
		    }
		}
		function loadLazyScript(props) {
		    if (document.readyState === 'complete') {
		        (0, _requestidlecallback.requestIdleCallback)(()=>loadScript(props));
		    } else {
		        window.addEventListener('load', ()=>{
		            (0, _requestidlecallback.requestIdleCallback)(()=>loadScript(props));
		        });
		    }
		}
		function addBeforeInteractiveToCache() {
		    const scripts = [
		        ...document.querySelectorAll('[data-nscript="beforeInteractive"]'),
		        ...document.querySelectorAll('[data-nscript="beforePageRender"]')
		    ];
		    scripts.forEach((script)=>{
		        const cacheKey = script.id || script.getAttribute('src');
		        LoadCache.add(cacheKey);
		    });
		}
		function initScriptLoader(scriptLoaderItems) {
		    scriptLoaderItems.forEach(handleClientScriptLoad);
		    addBeforeInteractiveToCache();
		}
		/**
		 * Load a third-party scripts in an optimized way.
		 *
		 * Read more: [Next.js Docs: `next/script`](https://nextjs.org/docs/app/api-reference/components/script)
		 */ function Script(props) {
		    const { id, src = '', onLoad = ()=>{}, onReady = null, strategy = 'afterInteractive', onError, stylesheets, ...restProps } = props;
		    // Context is available only during SSR
		    let { updateScripts, scripts, getIsSsr, appDir, nonce } = (0, _react.useContext)(_headmanagercontextsharedruntime.HeadManagerContext);
		    // if a nonce is explicitly passed to the script tag, favor that over the automatic handling
		    nonce = restProps.nonce || nonce;
		    /**
		   * - First mount:
		   *   1. The useEffect for onReady executes
		   *   2. hasOnReadyEffectCalled.current is false, but the script hasn't loaded yet (not in LoadCache)
		   *      onReady is skipped, set hasOnReadyEffectCalled.current to true
		   *   3. The useEffect for loadScript executes
		   *   4. hasLoadScriptEffectCalled.current is false, loadScript executes
		   *      Once the script is loaded, the onLoad and onReady will be called by then
		   *   [If strict mode is enabled / is wrapped in <OffScreen /> component]
		   *   5. The useEffect for onReady executes again
		   *   6. hasOnReadyEffectCalled.current is true, so entire effect is skipped
		   *   7. The useEffect for loadScript executes again
		   *   8. hasLoadScriptEffectCalled.current is true, so entire effect is skipped
		   *
		   * - Second mount:
		   *   1. The useEffect for onReady executes
		   *   2. hasOnReadyEffectCalled.current is false, but the script has already loaded (found in LoadCache)
		   *      onReady is called, set hasOnReadyEffectCalled.current to true
		   *   3. The useEffect for loadScript executes
		   *   4. The script is already loaded, loadScript bails out
		   *   [If strict mode is enabled / is wrapped in <OffScreen /> component]
		   *   5. The useEffect for onReady executes again
		   *   6. hasOnReadyEffectCalled.current is true, so entire effect is skipped
		   *   7. The useEffect for loadScript executes again
		   *   8. hasLoadScriptEffectCalled.current is true, so entire effect is skipped
		   */ const hasOnReadyEffectCalled = (0, _react.useRef)(false);
		    (0, _react.useEffect)(()=>{
		        const cacheKey = id || src;
		        if (!hasOnReadyEffectCalled.current) {
		            // Run onReady if script has loaded before but component is re-mounted
		            if (onReady && cacheKey && LoadCache.has(cacheKey)) {
		                onReady();
		            }
		            hasOnReadyEffectCalled.current = true;
		        }
		    }, [
		        onReady,
		        id,
		        src
		    ]);
		    const hasLoadScriptEffectCalled = (0, _react.useRef)(false);
		    (0, _react.useEffect)(()=>{
		        if (!hasLoadScriptEffectCalled.current) {
		            if (strategy === 'afterInteractive') {
		                loadScript(props);
		            } else if (strategy === 'lazyOnload') {
		                loadLazyScript(props);
		            }
		            hasLoadScriptEffectCalled.current = true;
		        }
		    }, [
		        props,
		        strategy
		    ]);
		    if (strategy === 'beforeInteractive' || strategy === 'worker') {
		        if (updateScripts) {
		            scripts[strategy] = (scripts[strategy] || []).concat([
		                {
		                    id,
		                    src,
		                    onLoad,
		                    onReady,
		                    onError,
		                    ...restProps,
		                    nonce
		                }
		            ]);
		            updateScripts(scripts);
		        } else if (getIsSsr && getIsSsr()) {
		            // Script has already loaded during SSR
		            LoadCache.add(id || src);
		        } else if (getIsSsr && !getIsSsr()) {
		            loadScript({
		                ...props,
		                nonce
		            });
		        }
		    }
		    // For the app directory, we need React Float to preload these scripts.
		    if (appDir) {
		        // Injecting stylesheets here handles beforeInteractive and worker scripts correctly
		        // For other strategies injecting here ensures correct stylesheet order
		        // ReactDOM.preinit handles loading the styles in the correct order,
		        // also ensures the stylesheet is loaded only once and in a consistent manner
		        //
		        // Case 1: Styles for beforeInteractive/worker with appDir - handled here
		        // Case 2: Styles for beforeInteractive/worker with pages dir - Not handled yet
		        // Case 3: Styles for afterInteractive/lazyOnload with appDir - handled here
		        // Case 4: Styles for afterInteractive/lazyOnload with pages dir - handled in insertStylesheets function
		        if (stylesheets) {
		            stylesheets.forEach((styleSrc)=>{
		                _reactdom.default.preinit(styleSrc, {
		                    as: 'style'
		                });
		            });
		        }
		        // Before interactive scripts need to be loaded by Next.js' runtime instead
		        // of native <script> tags, because they no longer have `defer`.
		        if (strategy === 'beforeInteractive') {
		            if (!src) {
		                // For inlined scripts, we put the content in `children`.
		                if (restProps.dangerouslySetInnerHTML) {
		                    // Casting since lib.dom.d.ts doesn't have TrustedHTML yet.
		                    restProps.children = restProps.dangerouslySetInnerHTML.__html;
		                    delete restProps.dangerouslySetInnerHTML;
		                }
		                return /*#__PURE__*/ (0, _jsxruntime.jsx)("script", {
		                    nonce: nonce,
		                    dangerouslySetInnerHTML: {
		                        __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
		                            0,
		                            {
		                                ...restProps,
		                                id
		                            }
		                        ]) + ")"
		                    }
		                });
		            } else {
		                // @ts-ignore
		                _reactdom.default.preload(src, restProps.integrity ? {
		                    as: 'script',
		                    integrity: restProps.integrity,
		                    nonce,
		                    crossOrigin: restProps.crossOrigin
		                } : {
		                    as: 'script',
		                    nonce,
		                    crossOrigin: restProps.crossOrigin
		                });
		                return /*#__PURE__*/ (0, _jsxruntime.jsx)("script", {
		                    nonce: nonce,
		                    dangerouslySetInnerHTML: {
		                        __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
		                            src,
		                            {
		                                ...restProps,
		                                id
		                            }
		                        ]) + ")"
		                    }
		                });
		            }
		        } else if (strategy === 'afterInteractive') {
		            if (src) {
		                // @ts-ignore
		                _reactdom.default.preload(src, restProps.integrity ? {
		                    as: 'script',
		                    integrity: restProps.integrity,
		                    nonce,
		                    crossOrigin: restProps.crossOrigin
		                } : {
		                    as: 'script',
		                    nonce,
		                    crossOrigin: restProps.crossOrigin
		                });
		            }
		        }
		    }
		    return null;
		}
		Object.defineProperty(Script, '__nextScript', {
		    value: true
		});
		const _default = Script;

		if ((typeof exports.default === 'function' || (typeof exports.default === 'object' && exports.default !== null)) && typeof exports.default.__esModule === 'undefined') {
		  Object.defineProperty(exports.default, '__esModule', { value: true });
		  Object.assign(exports.default, exports);
		  module.exports = exports.default;
		}

		
	} (script$1, script$1.exports));
	return script$1.exports;
}

var script;
var hasRequiredScript;

function requireScript () {
	if (hasRequiredScript) return script;
	hasRequiredScript = 1;
	script = requireScript$1();
	return script;
}

var scriptExports = requireScript();
var Script = /*@__PURE__*/getDefaultExportFromCjs(scriptExports);

var IgusGoContainer = function IgusGoContainer(_ref) {
  var script_url = _ref.script_url,
    stylesheet_url = _ref.stylesheet_url,
    data_lang = _ref.data_lang,
    headline = _ref.headline,
    text = _ref.text,
    _ref$default_headline = _ref.default_headline,
    default_headline = _ref$default_headline === void 0 ? '' : _ref$default_headline,
    _ref$default_text = _ref.default_text,
    default_text = _ref$default_text === void 0 ? '' : _ref$default_text,
    _ref$result_headline = _ref.result_headline,
    result_headline = _ref$result_headline === void 0 ? '' : _ref$result_headline,
    _ref$result_text = _ref.result_text,
    result_text = _ref$result_text === void 0 ? '' : _ref$result_text,
    _ref$result_recognize = _ref.result_recognized,
    result_recognized = _ref$result_recognize === void 0 ? '' : _ref$result_recognize,
    _ref$result_error_tex = _ref.result_error_text,
    result_error_text = _ref$result_error_tex === void 0 ? '' : _ref$result_error_tex,
    _ref$result_tabs_ = _ref.result_tabs_1,
    result_tabs_1 = _ref$result_tabs_ === void 0 ? '' : _ref$result_tabs_,
    _ref$result_tabs_2 = _ref.result_tabs_2,
    result_tabs_2 = _ref$result_tabs_2 === void 0 ? '' : _ref$result_tabs_2,
    _ref$result_card_case = _ref.result_card_case,
    result_card_case = _ref$result_card_case === void 0 ? '' : _ref$result_card_case,
    _ref$result_card_prod = _ref.result_card_product,
    result_card_product = _ref$result_card_prod === void 0 ? '' : _ref$result_card_prod,
    _ref$outro_text = _ref.outro_text,
    outro_text = _ref$outro_text === void 0 ? '' : _ref$outro_text,
    _ref$common_loading = _ref.common_loading,
    common_loading = _ref$common_loading === void 0 ? '' : _ref$common_loading,
    _ref$common_searchPla = _ref.common_searchPlaceholder,
    common_searchPlaceholder = _ref$common_searchPla === void 0 ? '' : _ref$common_searchPla,
    _ref$common_noSuggest = _ref.common_noSuggestion,
    common_noSuggestion = _ref$common_noSuggest === void 0 ? '' : _ref$common_noSuggest,
    _ref$common_error_tit = _ref.common_error_title,
    common_error_title = _ref$common_error_tit === void 0 ? '' : _ref$common_error_tit;
  var jsonData = {
    "default": {
      headline: headline || default_headline,
      text: text || default_text
    },
    result: {
      headline: result_headline,
      text: result_text,
      recognized: result_recognized,
      error: {
        text: result_error_text
      },
      tabs: {
        1: result_tabs_1,
        2: result_tabs_2
      },
      card: {
        "case": result_card_case,
        product: result_card_product
      }
    },
    outro: outro_text,
    common: {
      loading: common_loading,
      searchPlaceholder: common_searchPlaceholder,
      noSuggestion: common_noSuggestion,
      error: {
        title: common_error_title
      }
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (stylesheet_url === null || stylesheet_url === void 0 ? void 0 : stylesheet_url.url) && (/*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    href: stylesheet_url === null || stylesheet_url === void 0 ? void 0 : stylesheet_url.url
  })), (script_url === null || script_url === void 0 ? void 0 : script_url.url) && (/*#__PURE__*/React.createElement(Script, {
    type: "module",
    strategy: "afterInteractive",
    src: script_url === null || script_url === void 0 ? void 0 : script_url.url
  })), /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    id: "zero-lubrication-app",
    "data-json": jsonData && JSON.stringify(jsonData),
    "data-lang": data_lang
  })))));
};

var hasTextContent = function hasTextContent(text) {
  var _a;
  return !!((_a = text === null || text === void 0 ? void 0 : text.content) === null || _a === void 0 ? void 0 : _a.filter(function (text) {
    return text.content;
  }).length);
};

function removeUrlParameters(url, parametersToRemove) {
  try {
    var urlObject = new URL(url);
    parametersToRemove.forEach(function (param) {
      urlObject.searchParams["delete"](param);
    });
    return urlObject.toString();
  } catch (error) {
    return url;
  }
}

var css$1d = {"underline":"RichTextRenderer-module_underline__-doEG","italic":"RichTextRenderer-module_italic__fhwk5","strike":"RichTextRenderer-module_strike__Wtod1","bold":"RichTextRenderer-module_bold__udmlh","list__wrapper":"RichTextRenderer-module_list__wrapper__n9ES3","link__wrapper_format":"RichTextRenderer-module_link__wrapper_format__U8vxm","primary":"RichTextRenderer-module_primary__0Y0Jh","list__item__primary":"RichTextRenderer-module_list__item__primary__1W82o","secondary":"RichTextRenderer-module_secondary__d6AIM","list__item__secondary":"RichTextRenderer-module_list__item__secondary__cN9-g","theming_color_1":"RichTextRenderer-module_theming_color_1__Qwy4Y","list__item__theming_color_1":"RichTextRenderer-module_list__item__theming_color_1__8Q-5e","theming_color_2":"RichTextRenderer-module_theming_color_2__soCOV","list__item__theming_color_2":"RichTextRenderer-module_list__item__theming_color_2__x5eyJ","richtext__link":"RichTextRenderer-module_richtext__link__2L4-g"};

var conditionalClassname = function conditionalClassname(condition, classname) {
  return condition ? " ".concat(classname || '') : '';
};
var concatClassnames = function concatClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }
  return classnames.filter(Boolean).join(' ');
};
var chainConditionalClassnames = function chainConditionalClassnames() {
  var result = concatClassnames.apply(void 0, arguments);
  return result === '' ? '' : result.trim().replace(/\s+/g, ' ');
};
var classNameMapper = function classNameMapper(variants, classNames) {
  var mapper = new Map();
  variants.forEach(function (variant) {
    var variantClass = classNames === null || classNames === void 0 ? void 0 : classNames.find(function (className) {
      return className === null || className === void 0 ? void 0 : className.includes(variant);
    });
    mapper.set(variant, variantClass);
  });
  return mapper;
};

function _createForOfIteratorHelper$5(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$5(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$5(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$5(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$5(r, a) : void 0; } }
function _arrayLikeToArray$5(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _findClassName = function findClassName(element) {
  if (element && element.props) {
    if (element.props.className) {
      return element.props.className;
    }
    if (element.props.children) {
      if (Array.isArray(element.props.children)) {
        var _iterator = _createForOfIteratorHelper$5(element.props.children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            var className = _findClassName(child);
            if (className) {
              return className;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        return _findClassName(element.props.children);
      }
    }
  }
  return '';
};
var classNameMap = {
  primary: css$1d.list__item__primary,
  secondary: css$1d.list__item__secondary,
  theming_color_1: css$1d.list__item__theming_color_1,
  theming_color_2: css$1d.list__item__theming_color_2
};
var getClassName = function getClassName(className) {
  return className ? classNameMap[className] || '' : '';
};
var createDecoratedClassName = function createDecoratedClassName(decorators, style, item) {
  var decoratorClass = (decorators || []).map(function (mark) {
    return style[mark] || '';
  }).filter(Boolean).join(' ');
  if (item) {
    var itemClass = getClassName(_findClassName(item) || '');
    return "".concat(decoratorClass, " ").concat(itemClass);
  }
  return decoratorClass;
};

var List = function List(_ref) {
  var listType = _ref.listType,
    textData = _ref.textData,
    decorators = _ref.decorators,
    className = _ref.className;
  var renderListItem = function renderListItem(item, index, subIndex) {
    var optionalClass = createDecoratedClassName(decorators, css$1d, item);
    var props = item.props;
    if (props) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, item);
    }
    return /*#__PURE__*/React.createElement("li", {
      className: chainConditionalClassnames(optionalClass),
      key: "".concat(index, "-").concat(subIndex)
    }, item);
  };
  var renderListItems = function renderListItems(items, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "listitems-".concat(index)
    }, items.map(function (item, subIndex) {
      return renderListItem(item, index, subIndex);
    }));
  };
  var ListItems = function ListItems(_ref2) {
    var textData = _ref2.textData;
    return /*#__PURE__*/React.createElement(React.Fragment, null, Array.isArray(textData) ? textData.map(function (text, index) {
      return Array.isArray(text) ? renderListItems(text, index) : renderListItem(text, index, 0);
    }) : renderListItem(textData, 0, 0));
  };
  var UnorderedList = function UnorderedList(_ref3) {
    var listItems = _ref3.listItems;
    return /*#__PURE__*/React.createElement("ul", {
      className: "".concat(css$1d.list__wrapper, " ").concat(className)
    }, /*#__PURE__*/React.createElement(ListItems, {
      textData: listItems
    }));
  };
  var OrderedList = function OrderedList(_ref4) {
    var listItems = _ref4.listItems;
    return /*#__PURE__*/React.createElement("ol", {
      className: "".concat(css$1d.list__wrapper, " ").concat(className)
    }, /*#__PURE__*/React.createElement(ListItems, {
      textData: listItems
    }));
  };
  return listType === 'ordered' ? (/*#__PURE__*/React.createElement(OrderedList, {
    listItems: textData
  })) : (/*#__PURE__*/React.createElement(UnorderedList, {
    listItems: textData
  }));
};
var Paragraph = function Paragraph(_ref5) {
  var children = _ref5.children,
    decorators = _ref5.decorators;
  var optionalClass = (decorators === null || decorators === void 0 ? void 0 : decorators.length) ? decorators === null || decorators === void 0 ? void 0 : decorators.map(function (mark) {
    return css$1d[mark];
  }).join('  ') : '';
  return /*#__PURE__*/React.createElement("p", {
    className: "".concat(optionalClass, " ").concat(css$1d.richtext__link)
  }, children);
};
var Bold = function Bold(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement("strong", null, children);
};
var Italic = function Italic(_ref7) {
  var children = _ref7.children;
  return /*#__PURE__*/React.createElement("em", null, children);
};
var Quote = function Quote(_ref8) {
  var children = _ref8.children;
  return /*#__PURE__*/React.createElement("q", null, children);
};
var Underline = function Underline(_ref9) {
  var children = _ref9.children;
  return /*#__PURE__*/React.createElement("u", null, children);
};
var Strike = function Strike(_ref0) {
  var children = _ref0.children;
  return /*#__PURE__*/React.createElement("s", null, children);
};
var Superscript = function Superscript(_ref1) {
  var children = _ref1.children;
  return /*#__PURE__*/React.createElement("sup", null, children);
};
var Subscript = function Subscript(_ref10) {
  var children = _ref10.children;
  return /*#__PURE__*/React.createElement("sub", null, children);
};
var Anchor = function Anchor(_ref11) {
  var children = _ref11.children,
    id = _ref11.id;
  return /*#__PURE__*/React.createElement("span", {
    id: id
  }, children);
};
var Break = function Break() {
  return /*#__PURE__*/React.createElement("br", null);
};
var Span = function Span(_ref12) {
  var children = _ref12.children,
    id = _ref12.id,
    className = _ref12.className;
  return /*#__PURE__*/React.createElement("span", {
    id: id,
    className: className && css$1d[className] ? css$1d[className] : ''
  }, children);
};
var HeadlineAtom = function HeadlineAtom(props) {
  return /*#__PURE__*/React.createElement(Headline, Object.assign({}, props));
};
var LinkAtom = function LinkAtom(props) {
  return /*#__PURE__*/React.createElement(Link, Object.assign({}, props));
};

var RichTextRenderer = function RichTextRenderer(_ref) {
  var content = _ref.content,
    _ref$hasAnchor = _ref.hasAnchor,
    hasAnchor = _ref$hasAnchor === void 0 ? true : _ref$hasAnchor,
    _ref$center_content = _ref.center_content,
    center_content = _ref$center_content === void 0 ? false : _ref$center_content,
    exclude_from_toc = _ref.exclude_from_toc;
  return /*#__PURE__*/React.createElement(React.Fragment, null, content === null || content === void 0 ? void 0 : content.map(function (_a, index) {
    var type = _a.type,
      rest = __rest(_a, ["type"]);
    var componentKey = "".concat(type).concat(index);
    if (!type) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, "No Content");
    }
    switch (type) {
      case 'headline':
        return /*#__PURE__*/React.createElement(HeadlineAtom, Object.assign({
          key: componentKey,
          hasAnchor: hasAnchor
        }, rest, {
          exclude_from_toc: exclude_from_toc
        }));
      case 'link':
        return /*#__PURE__*/React.createElement(LinkAtom, Object.assign({
          key: componentKey,
          className: css$1d.richtext__link
        }, rest));
      case 'list':
        return /*#__PURE__*/React.createElement(List, Object.assign({
          key: componentKey
        }, rest, {
          className: center_content ? css$1d.link__wrapper_format : ''
        }));
      case 'paragraph':
        return /*#__PURE__*/React.createElement(Paragraph, Object.assign({
          key: componentKey
        }, rest));
      case 'bold':
        return /*#__PURE__*/React.createElement(Bold, Object.assign({
          key: componentKey
        }, rest));
      case 'italic':
        return /*#__PURE__*/React.createElement(Italic, Object.assign({
          key: componentKey
        }, rest));
      case 'quote':
        return /*#__PURE__*/React.createElement(Quote, Object.assign({
          key: componentKey
        }, rest));
      case 'underline':
        return /*#__PURE__*/React.createElement(Underline, Object.assign({
          key: componentKey
        }, rest));
      case 'subscript':
        return /*#__PURE__*/React.createElement(Subscript, Object.assign({
          key: componentKey
        }, rest));
      case 'superscript':
        return /*#__PURE__*/React.createElement(Superscript, Object.assign({
          key: componentKey
        }, rest));
      case 'anchor':
        return /*#__PURE__*/React.createElement(Anchor, Object.assign({
          key: componentKey
        }, rest));
      case 'hard_break':
        return /*#__PURE__*/React.createElement(Break, {
          key: componentKey
        });
      case 'span':
        return /*#__PURE__*/React.createElement(Span, Object.assign({
          key: componentKey
        }, rest));
      default:
        return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  }));
};

var linkPropsMapper = function linkPropsMapper(props) {
  var _a, _b, _c, _d;
  var name = props.name,
    variant = props.variant,
    link = props.link,
    asset = props.asset,
    piwik_click_id = props.piwik_click_id;
  var url = (link === null || link === void 0 ? void 0 : link.url) || ((_a = link === null || link === void 0 ? void 0 : link.story) === null || _a === void 0 ? void 0 : _a.url) || (link === null || link === void 0 ? void 0 : link.cached_url) || ((_b = asset === null || asset === void 0 ? void 0 : asset.item) === null || _b === void 0 ? void 0 : _b.embed_link);
  var external = (link === null || link === void 0 ? void 0 : link.linktype) === LinkType.Url || (link === null || link === void 0 ? void 0 : link.linktype) === LinkType.Email;
  var contactType = (link === null || link === void 0 ? void 0 : link.linktype) === LinkType.Email ? ContactType.Email : undefined;
  return {
    type: 'link',
    children: name,
    title: name,
    variant: variant !== null && variant !== void 0 ? variant : LinkVariant.Primary,
    external: external,
    href: url !== null && url !== void 0 ? url : '',
    target: (link === null || link === void 0 ? void 0 : link.target) || TargetValues.Self,
    icon: false,
    piwik_click_id: piwik_click_id,
    anchor: (_c = props.link) === null || _c === void 0 ? void 0 : _c.anchor,
    contact_type: contactType,
    rel: (_d = props.link) === null || _d === void 0 ? void 0 : _d.rel
  };
};

var TextMarks = new Map();
TextMarks.set('bold', 'strong');
TextMarks.set('italic', 'em');
TextMarks.set('quote', 'q');
TextMarks.set('underline', 'u');
TextMarks.set('strike', 's');
TextMarks.set('link', 'a');
TextMarks.set('subscript', 'sub');
TextMarks.set('superscript', 'sup');
TextMarks.set('anchor', 'a');
TextMarks.set('styled', 'span');
TextMarks.set('list_item', 'li');
var MarkComponent = new Map();
MarkComponent.set('bold', Bold);
MarkComponent.set('italic', Italic);
MarkComponent.set('quote', Quote);
MarkComponent.set('underline', Underline);
MarkComponent.set('strike', Strike);
MarkComponent.set('link', Link);
MarkComponent.set('subscript', Subscript);
MarkComponent.set('superscript', Superscript);
MarkComponent.set('anchor', Anchor);
MarkComponent.set('hard_break', Break);
MarkComponent.set('span', Span);
MarkComponent.set('styled', Span);
MarkComponent.set('list_item', List);
var renderTextWithMarks = function renderTextWithMarks(marks, text) {
  var preTags = '';
  var postTags = '';
  marks.forEach(function (_ref) {
    var type = _ref.type;
    if (type !== 'link') {
      var tag = TextMarks.get(type);
      preTags += "<".concat(tag, ">");
      postTags += "</".concat(tag, ">");
      return "".concat(preTags).concat(text || '').concat(postTags);
    }
  });
  return '';
};
var renderText = function renderText(content) {
  return content && content.map(function (c) {
    var text = c.text,
      marks = c.marks;
    if (marks) {
      return renderTextWithMarks(marks, text);
    }
    return text;
  }).join('') || '';
};
var convertHtmlEntities = function convertHtmlEntities(text) {
  if (text) {
    var entityMap = {
      '&quot;': '"',
      '&amp;': '&',
      '&apos;': "'",
      '&lt;': '<',
      '&gt;': '>',
      '&nbsp;': "\xA0",
      '&cent;': '¢',
      '&pound;': '£',
      '&yen;': '¥',
      '&sect;': '§',
      '&copy;': '©',
      '&laquo;': '«',
      '&shy;': "\xAD"
    };
    return text.replace(/&[a-z]+;/gi, function (match) {
      var _a;
      return (_a = entityMap[match]) !== null && _a !== void 0 ? _a : match;
    });
  }
  return '';
};
var renderListProps = function renderListProps(listsContent) {
  return listsContent.map(function (listItem) {
    var _a;
    return listItem && ((_a = listItem.content) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
      var _a;
      var nestedList = (item === null || item === void 0 ? void 0 : item.type) === 'ordered_list' || (item === null || item === void 0 ? void 0 : item.type) === 'bullet_list';
      if (nestedList) {
        var listType = (item === null || item === void 0 ? void 0 : item.type) === 'bullet_list' ? 'ul' : 'ol';
        return /*#__PURE__*/createElement$1(listType, {
          key: "bullet_list_".concat(index)
        }, (_a = item === null || item === void 0 ? void 0 : item.content) === null || _a === void 0 ? void 0 : _a.map(function (item, itemIndex) {
          return /*#__PURE__*/createElement$1('li', {
            key: "bullet_list_item_".concat(itemIndex)
          }, _textProps(item === null || item === void 0 ? void 0 : item.content));
        }));
      }
      return _textProps(item.content);
    }));
  });
};
// TODO - Fix type issues
var _textProps = function textProps(content) {
  if (!content) {
    return [/*#__PURE__*/createElement$1('br')];
  }
  return content && content.map(function (c, index) {
    var text = c.text,
      marks = c.marks,
      type = c.type,
      innerContent = c.content;
    var childrenContent = [];
    if (type === 'hard_break') {
      var breakElement = createBreakElement(type);
      childrenContent.push(breakElement);
    }
    if (innerContent) {
      // Recursively handle nested content
      if (type === 'bullet_list') {
        childrenContent.push(/*#__PURE__*/createElement$1('ul', {
          key: "bullet_list_".concat(index)
        }, innerContent.map(function (item, itemIndex) {
          return /*#__PURE__*/createElement$1('li', {
            key: "bullet_list_item_".concat(itemIndex)
          }, _textProps(item.content));
        })));
      } else {
        childrenContent.push.apply(childrenContent, _toConsumableArray(_textProps(innerContent)));
      }
    } else {
      if (marks) {
        var reverseMarks = marks.slice(0).reverse();
        var currentChildren = convertHtmlEntities(text);
        var currentProps = {};
        var childrenWithMarks = null;
        var anchorProps = {};
        reverseMarks.forEach(function (_ref2, index) {
          var type = _ref2.type,
            attrs = _ref2.attrs;
          var componentRender = MarkComponent.get(type) || MarkComponent.get('span');
          if (componentRender) {
            currentProps = Object.assign(Object.assign({}, currentProps), {
              key: "_mark_".concat(type, "_").concat(index)
            });
            if (type === 'anchor') {
              var id = attrs.id;
              anchorProps = Object.assign(Object.assign({}, anchorProps), {
                id: id
              });
            }
            if (type === 'link') {
              var custom = attrs.custom,
                href = attrs.href,
                linktype = attrs.linktype,
                target = attrs.target,
                anchor = attrs.anchor,
                story = attrs.story;
              currentProps = Object.assign(Object.assign(Object.assign(Object.assign({}, currentProps), {
                target: target,
                href: (story === null || story === void 0 ? void 0 : story.url) || href,
                contact_type: determineContactType(href, linktype),
                external: linktype !== 'story',
                variant: 'primary',
                anchor: anchor
              }), custom && custom.title && {
                title: custom.title
              }), custom && custom.rel && {
                rel: custom.rel
              });
            }
            if (type === 'styled' && (attrs === null || attrs === void 0 ? void 0 : attrs["class"])) {
              var className = attrs["class"];
              currentProps = Object.assign(Object.assign({}, currentProps), {
                className: className
              });
            }
            childrenWithMarks = /*#__PURE__*/createElement$1(componentRender, Object.assign(Object.assign({}, currentProps), anchorProps), currentChildren);
            currentProps = {};
            anchorProps = {};
            currentChildren = childrenWithMarks;
          }
        });
        if (childrenWithMarks) {
          childrenContent.push(childrenWithMarks);
        }
      } else {
        //@ts-ignore . TODO: To be fixed
        childrenContent.push(convertHtmlEntities(text));
      }
    }
    return _toConsumableArray(childrenContent.length > 0 ? childrenContent : []);
  }) || [];
};
var createBreakElement = function createBreakElement(type) {
  var breakerProps = {
    type: 'hard_break'};
  var breaker = /*#__PURE__*/createElement$1(MarkComponent.get(breakerProps.type), {
    key: "_mark_".concat(type)
  });
  return breaker;
};
var headlinePropsMapper = function headlinePropsMapper(_ref3) {
  var attrs = _ref3.attrs,
    content = _ref3.content,
    decorators = _ref3.decorators;
  return Object.assign(Object.assign(Object.assign({}, attrs && {
    tag: "h".concat(attrs.level)
  }), {
    type: 'headline',
    //@ts-ignore . TODO: To be fixed
    children: _textProps(content)
  }), decorators);
};
var listPropsMapper = function listPropsMapper(_ref4) {
  var type = _ref4.type,
    content = _ref4.content,
    decorators = _ref4.decorators;
  return Object.assign({
    type: 'list',
    listType: type === 'bullet_list' && 'unordered' || 'ordered',
    //@ts-ignore . TODO: To be fixed
    textData: renderListProps(content)
  }, decorators);
};
var paragraphPropsMapper = function paragraphPropsMapper(_ref5) {
  var content = _ref5.content,
    decorators = _ref5.decorators;
  return Object.assign({
    type: 'paragraph',
    //@ts-ignore . TODO: To be fixed
    children: _textProps(content)
  }, decorators);
};
var MapProps = new Map();
MapProps.set('heading', headlinePropsMapper);
MapProps.set('paragraph', paragraphPropsMapper);
MapProps.set('bullet_list', listPropsMapper);
MapProps.set('ordered_list', listPropsMapper);
MapProps.set('link', linkPropsMapper);
var componentProps = function componentProps(content) {
  var mappingFn = MapProps.get(content.type);
  if (mappingFn) {
    return mappingFn(content);
  }
  return content;
};
var mappedProps = function mappedProps(content) {
  return content === null || content === void 0 ? void 0 : content.map(function (blockContent) {
    if (blockContent.type === 'blok') {
      var attrs = blockContent.attrs;
      if (attrs) {
        var _a = attrs.body[0],
          component = _a.component,
          rest = __rest(_a, ["component"]);
        return componentProps(Object.assign({
          type: component
        }, rest));
      }
      return blockContent;
    }
    return componentProps(blockContent);
  });
};

var css$1c = {"copyright__wrapper":"Copyright-module_copyright__wrapper__XhVSQ","copyright__text__wrapper":"Copyright-module_copyright__text__wrapper__BEQWw","copyright__icon":"Copyright-module_copyright__icon__KjGeD","copyright__text":"Copyright-module_copyright__text__5SXv2"};

var CopyrightIcon = function CopyrightIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: css$1c.copyright__icon,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: "0.8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M12 5.5C10.7144 5.5 9.45772 5.88122 8.3888 6.59545C7.31988 7.30968 6.48676 8.32484 5.99479 9.51256C5.50282 10.7003 5.37409 12.0072 5.6249 13.2681C5.8757 14.529 6.49477 15.6872 7.40381 16.5962C8.31285 17.5052 9.47104 18.1243 10.7319 18.3751C11.9928 18.6259 13.2997 18.4972 14.4874 18.0052C15.6752 17.5132 16.6903 16.6801 17.4046 15.6112C18.1188 14.5423 18.5 13.2856 18.5 12C18.4967 10.2771 17.8108 8.62573 16.5925 7.40746C15.3743 6.18918 13.7229 5.5033 12 5.5ZM12 17.5C10.9122 17.5 9.84884 17.1774 8.94437 16.5731C8.0399 15.9687 7.33495 15.1098 6.91867 14.1048C6.50238 13.0998 6.39347 11.9939 6.60568 10.927C6.8179 9.86011 7.34173 8.8801 8.11092 8.11091C8.8801 7.34172 9.86011 6.8179 10.927 6.60568C11.9939 6.39346 13.0998 6.50238 14.1048 6.91866C15.1098 7.33494 15.9687 8.03989 16.5731 8.94436C17.1774 9.84883 17.5 10.9122 17.5 12C17.4983 13.4582 16.9184 14.8562 15.8873 15.8873C14.8562 16.9184 13.4582 17.4983 12 17.5ZM10 12C10 12.4198 10.1321 12.8289 10.3775 13.1694C10.623 13.51 10.9693 13.7646 11.3675 13.8974C11.7658 14.0301 12.1957 14.0342 12.5963 13.909C12.997 13.7839 13.3481 13.5358 13.6 13.2C13.6806 13.0953 13.7989 13.0262 13.9297 13.0075C14.0604 12.9889 14.1933 13.022 14.3 13.1C14.4061 13.1796 14.4762 13.298 14.495 13.4293C14.5137 13.5606 14.4796 13.6939 14.4 13.8C14.0222 14.3037 13.4955 14.6758 12.8945 14.8635C12.2935 15.0513 11.6487 15.0452 11.0513 14.8461C10.454 14.6469 9.93444 14.2649 9.56628 13.7541C9.19811 13.2433 9 12.6296 9 12C9 11.3704 9.19811 10.7567 9.56628 10.2459C9.93444 9.73507 10.454 9.35306 11.0513 9.15395C11.6487 8.95484 12.2935 8.94872 12.8945 9.13646C13.4955 9.3242 14.0222 9.69628 14.4 10.2C14.4796 10.3061 14.5137 10.4394 14.495 10.5707C14.4762 10.702 14.4061 10.8204 14.3 10.9C14.1933 10.978 14.0604 11.0111 13.9297 10.9925C13.7989 10.9738 13.6806 10.9047 13.6 10.8C13.3481 10.4642 12.997 10.2161 12.5963 10.091C12.1957 9.96581 11.7658 9.96989 11.3675 10.1026C10.9693 10.2354 10.623 10.49 10.3775 10.8306C10.1321 11.1711 10 11.5802 10 12Z"
  })));
};
var Tooltip$1 = function Tooltip() {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    width: "9",
    height: "13",
    viewBox: "0 0 9 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 6.5L9 0.00480843L9 12.9952L0 6.5Z"
  }));
};
var Copyright = function Copyright(_ref) {
  var text = _ref.text,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, text && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(css$1c.copyright__wrapper, " ").concat(className ? className : '', "  ")
  }, /*#__PURE__*/React.createElement(CopyrightIcon, null), /*#__PURE__*/React.createElement("div", {
    className: css$1c.copyright__text__wrapper
  }, /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement("figcaption", {
    className: css$1c.copyright__text
  }, text)))));
};

var imageCss = {"legend__wrapper":"image-module_legend__wrapper__kPUcO","float_align__text":"image-module_float_align__text__B6F-w","img_rounded__small":"image-module_img_rounded__small__JpZeP","img_rounded__medium":"image-module_img_rounded__medium__qBA3y","img_rounded__large":"image-module_img_rounded__large__v9QkI","img_shadow__micro":"image-module_img_shadow__micro__OjFHV","shadow_1":"image-module_shadow_1__Bx1KE","img_shadow__small":"image-module_img_shadow__small__kI07p","shadow_2":"image-module_shadow_2__e8FTB","img_shadow__regular":"image-module_img_shadow__regular__ECCCI","shadow_3":"image-module_shadow_3__t-naT","img_shadow__medium":"image-module_img_shadow__medium__XKJ2S","shadow_4":"image-module_shadow_4__gSpV4","img_shadow__large":"image-module_img_shadow__large__hI25r","shadow_5":"image-module_shadow_5__XtmZV","img_shadow__ultra":"image-module_img_shadow__ultra__QNLaK","shadow_6":"image-module_shadow_6__SGT4C"};

function _toArray(r) {
  return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$7(r) || _nonIterableRest();
}

var getToggleCenterImageSrc = function getToggleCenterImageSrc(imageUrl, isCenter, sortedImageSizes) {
  var _a, _b;
  var centeredImageSrc = '';
  var cleanCenterImageSrc = '';
  if (isCenter) {
    var keepCenterParam = 'keep=c';
    var _imageUrl$split = imageUrl.split('&'),
      _imageUrl$split2 = _toArray(_imageUrl$split),
      baseUrl = _imageUrl$split2[0];
      _imageUrl$split2[1];
      var remainingParams = _imageUrl$split2.slice(2);
    var width = ((_a = sortedImageSizes[0]) === null || _a === void 0 ? void 0 : _a.width) || '';
    var height = ((_b = sortedImageSizes[0]) === null || _b === void 0 ? void 0 : _b.height) || '';
    centeredImageSrc = "".concat(baseUrl, "&").concat(keepCenterParam, "&").concat(remainingParams.join('&'), "&w=").concat(width, "&h=").concat(height);
    cleanCenterImageSrc = "".concat(baseUrl, "&").concat(keepCenterParam, "&").concat(remainingParams.join('&'));
  }
  return {
    centeredImageSrc: centeredImageSrc,
    cleanCenterImageSrc: cleanCenterImageSrc
  };
};

function Image(_ref) {
  var src = _ref.src,
    imageSizes = _ref.imageSizes,
    alt = _ref.alt,
    _ref$priority = _ref.priority,
    priority = _ref$priority === void 0 ? false : _ref$priority,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    sizes = _ref.sizes,
    copyrightText = _ref.copyrightText,
    copyrightClassName = _ref.copyrightClassName,
    legend = _ref.legend,
    showLegend = _ref.showLegend,
    RoundedCorners = _ref.RoundedCorners,
    Shadow = _ref.Shadow,
    center = _ref.center;
  var hasDefaultColor = src === null || src === void 0 ? void 0 : src.includes('color=cccccc');
  var paramsToRemove = hasDefaultColor ? ['w', 'h', 'quality', 'color'] : ['w', 'h', 'quality'];
  var cleanImageSrc = removeUrlParameters(src, paramsToRemove);
  if (!imageSizes || imageSizes.length === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "No Sizes for Imagepath found: ".concat(src));
  }
  var sortedImageSizes = imageSizes.sort(function (a, b) {
    return a.width - b.width;
  });
  var srcSet = '';
  var roundedClasses = {
    Small: imageCss.img_rounded__small,
    Medium: imageCss.img_rounded__medium,
    Large: imageCss.img_rounded__large
  };
  var shadowClasses = {
    shadow_1: imageCss.img_shadow__micro,
    shadow_2: imageCss.img_shadow__small,
    shadow_3: imageCss.img_shadow__regular,
    shadow_4: imageCss.img_shadow__medium,
    shadow_5: imageCss.img_shadow__large,
    shadow_6: imageCss.img_shadow__ultra
  };
  var roundedClass = RoundedCorners ? roundedClasses[RoundedCorners] : '';
  var shadowClass = Shadow ? shadowClasses[Shadow] : '';
  if (!(src === null || src === void 0 ? void 0 : src.includes('widen'))) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      className: "".concat(className, " ").concat(roundedClass, " ").concat(shadowClass),
      src: src,
      alt: alt,
      loading: "lazy",
      style: {
        objectFit: 'cover',
        height: '100%',
        width: '100%'
      }
    }), legend && showLegend && hasTextContent(legend) && (/*#__PURE__*/React.createElement(LegendComponent, {
      legend: legend
    })));
  }
  if ((imageSizes === null || imageSizes === void 0 ? void 0 : imageSizes.length) === 1) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", Object.assign({
      className: "".concat(className, " ").concat(roundedClass, " ").concat(shadowClass),
      src: "\n          ".concat(cleanImageSrc, "&w=").concat(sortedImageSizes[0].width, "&h=").concat(sortedImageSizes[0].height),
      alt: alt
    }, priority ? {
      fetchpriority: 'high'
    } : {
      fetchpriority: 'auto'
    }, {
      loading: priority ? 'eager' : 'lazy'
    })), copyrightText && (/*#__PURE__*/React.createElement(Copyright, {
      text: copyrightText,
      className: copyrightClassName
    })), legend && showLegend && hasTextContent(legend) && (/*#__PURE__*/React.createElement(LegendComponent, {
      legend: legend
    })));
  }
  var _getToggleCenterImage = getToggleCenterImageSrc(src, center, sortedImageSizes),
    centeredImageSrc = _getToggleCenterImage.centeredImageSrc,
    cleanCenterImageSrc = _getToggleCenterImage.cleanCenterImageSrc;
  imageSizes === null || imageSizes === void 0 ? void 0 : imageSizes.forEach(function (size) {
    if (center) {
      return srcSet = "".concat(srcSet, " ").concat(cleanCenterImageSrc, "&w=").concat(size.width, "&h=").concat(size.height, " ").concat(size.width, "w,");
    }
    return srcSet = "".concat(srcSet, " ").concat(cleanImageSrc, "&w=").concat(size.width, "&h=").concat(size.height, " ").concat(size.width, "w,");
  });
  // remove the last comma
  srcSet = srcSet.slice(0, -1);
  var imageSrc = center ? centeredImageSrc : "".concat(cleanImageSrc, "&w=").concat(sortedImageSizes[0].width, "&h=").concat(sortedImageSizes[0].height);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", Object.assign({
    src: imageSrc,
    srcSet: srcSet,
    className: "".concat(className, " ").concat(roundedClass, " ").concat(shadowClass),
    alt: alt
  }, priority ? {
    fetchpriority: 'high'
  } : {
    fetchpriority: 'auto'
  }, {
    loading: priority ? 'eager' : 'lazy',
    sizes: sizes || undefined
  })), copyrightText && (/*#__PURE__*/React.createElement(Copyright, {
    text: copyrightText,
    className: copyrightClassName
  })), legend && showLegend && hasTextContent(legend) && (/*#__PURE__*/React.createElement(LegendComponent, {
    legend: legend
  })));
}
var LegendComponent = function LegendComponent(_ref2) {
  var legend = _ref2.legend,
    float_teaser = _ref2.float_teaser,
    center_content = _ref2.center_content;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(float_teaser && center_content ? imageCss.float_align__text : imageCss.legend__wrapper)
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(legend === null || legend === void 0 ? void 0 : legend.content)
  }));
};

var MarketingCloudContainer = function MarketingCloudContainer() {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

var regeneratorRuntime$1 = {exports: {}};

var OverloadYield = {exports: {}};

var hasRequiredOverloadYield;

function requireOverloadYield () {
	if (hasRequiredOverloadYield) return OverloadYield.exports;
	hasRequiredOverloadYield = 1;
	(function (module) {
		function _OverloadYield(e, d) {
		  this.v = e, this.k = d;
		}
		module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (OverloadYield));
	return OverloadYield.exports;
}

var regenerator$1 = {exports: {}};

var regeneratorDefine = {exports: {}};

var hasRequiredRegeneratorDefine;

function requireRegeneratorDefine () {
	if (hasRequiredRegeneratorDefine) return regeneratorDefine.exports;
	hasRequiredRegeneratorDefine = 1;
	(function (module) {
		function _regeneratorDefine(e, r, n, t) {
		  var i = Object.defineProperty;
		  try {
		    i({}, "", {});
		  } catch (e) {
		    i = 0;
		  }
		  module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
		    function o(r, n) {
		      _regeneratorDefine(e, r, function (e) {
		        return this._invoke(r, n, e);
		      });
		    }
		    r ? i ? i(e, r, {
		      value: n,
		      enumerable: !t,
		      configurable: !t,
		      writable: !t
		    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
		}
		module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regeneratorDefine));
	return regeneratorDefine.exports;
}

var hasRequiredRegenerator$1;

function requireRegenerator$1 () {
	if (hasRequiredRegenerator$1) return regenerator$1.exports;
	hasRequiredRegenerator$1 = 1;
	(function (module) {
		var regeneratorDefine = requireRegeneratorDefine();
		function _regenerator() {
		  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
		  var e,
		    t,
		    r = "function" == typeof Symbol ? Symbol : {},
		    n = r.iterator || "@@iterator",
		    o = r.toStringTag || "@@toStringTag";
		  function i(r, n, o, i) {
		    var c = n && n.prototype instanceof Generator ? n : Generator,
		      u = Object.create(c.prototype);
		    return regeneratorDefine(u, "_invoke", function (r, n, o) {
		      var i,
		        c,
		        u,
		        f = 0,
		        p = o || [],
		        y = false,
		        G = {
		          p: 0,
		          n: 0,
		          v: e,
		          a: d,
		          f: d.bind(e, 4),
		          d: function d(t, r) {
		            return i = t, c = 0, u = e, G.n = r, a;
		          }
		        };
		      function d(r, n) {
		        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
		          var o,
		            i = p[t],
		            d = G.p,
		            l = i[2];
		          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
		        }
		        if (o || r > 1) return a;
		        throw y = true, n;
		      }
		      return function (o, p, l) {
		        if (f > 1) throw TypeError("Generator is already running");
		        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
		          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
		          try {
		            if (f = 2, i) {
		              if (c || (o = "next"), t = i[o]) {
		                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
		                if (!t.done) return t;
		                u = t.value, c < 2 && (c = 0);
		              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
		              i = e;
		            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
		          } catch (t) {
		            i = e, c = 1, u = t;
		          } finally {
		            f = 1;
		          }
		        }
		        return {
		          value: t,
		          done: y
		        };
		      };
		    }(r, o, i), true), u;
		  }
		  var a = {};
		  function Generator() {}
		  function GeneratorFunction() {}
		  function GeneratorFunctionPrototype() {}
		  t = Object.getPrototypeOf;
		  var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
		      return this;
		    }), t),
		    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
		  function f(e) {
		    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
		  }
		  return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
		    return this;
		  }), regeneratorDefine(u, "toString", function () {
		    return "[object Generator]";
		  }), (module.exports = _regenerator = function _regenerator() {
		    return {
		      w: i,
		      m: f
		    };
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
		}
		module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regenerator$1));
	return regenerator$1.exports;
}

var regeneratorAsync = {exports: {}};

var regeneratorAsyncGen = {exports: {}};

var regeneratorAsyncIterator = {exports: {}};

var hasRequiredRegeneratorAsyncIterator;

function requireRegeneratorAsyncIterator () {
	if (hasRequiredRegeneratorAsyncIterator) return regeneratorAsyncIterator.exports;
	hasRequiredRegeneratorAsyncIterator = 1;
	(function (module) {
		var OverloadYield = requireOverloadYield();
		var regeneratorDefine = requireRegeneratorDefine();
		function AsyncIterator(t, e) {
		  function n(r, o, i, f) {
		    try {
		      var c = t[r](o),
		        u = c.value;
		      return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
		        n("next", t, i, f);
		      }, function (t) {
		        n("throw", t, i, f);
		      }) : e.resolve(u).then(function (t) {
		        c.value = t, i(c);
		      }, function (t) {
		        return n("throw", t, i, f);
		      });
		    } catch (t) {
		      f(t);
		    }
		  }
		  var r;
		  this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
		    return this;
		  })), regeneratorDefine(this, "_invoke", function (t, o, i) {
		    function f() {
		      return new e(function (e, r) {
		        n(t, i, e, r);
		      });
		    }
		    return r = r ? r.then(f, f) : f();
		  }, true);
		}
		module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regeneratorAsyncIterator));
	return regeneratorAsyncIterator.exports;
}

var hasRequiredRegeneratorAsyncGen;

function requireRegeneratorAsyncGen () {
	if (hasRequiredRegeneratorAsyncGen) return regeneratorAsyncGen.exports;
	hasRequiredRegeneratorAsyncGen = 1;
	(function (module) {
		var regenerator = requireRegenerator$1();
		var regeneratorAsyncIterator = requireRegeneratorAsyncIterator();
		function _regeneratorAsyncGen(r, e, t, o, n) {
		  return new regeneratorAsyncIterator(regenerator().w(r, e, t, o), n || Promise);
		}
		module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regeneratorAsyncGen));
	return regeneratorAsyncGen.exports;
}

var hasRequiredRegeneratorAsync;

function requireRegeneratorAsync () {
	if (hasRequiredRegeneratorAsync) return regeneratorAsync.exports;
	hasRequiredRegeneratorAsync = 1;
	(function (module) {
		var regeneratorAsyncGen = requireRegeneratorAsyncGen();
		function _regeneratorAsync(n, e, r, t, o) {
		  var a = regeneratorAsyncGen(n, e, r, t, o);
		  return a.next().then(function (n) {
		    return n.done ? n.value : a.next();
		  });
		}
		module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regeneratorAsync));
	return regeneratorAsync.exports;
}

var regeneratorKeys = {exports: {}};

var hasRequiredRegeneratorKeys;

function requireRegeneratorKeys () {
	if (hasRequiredRegeneratorKeys) return regeneratorKeys.exports;
	hasRequiredRegeneratorKeys = 1;
	(function (module) {
		function _regeneratorKeys(e) {
		  var n = Object(e),
		    r = [];
		  for (var t in n) r.unshift(t);
		  return function e() {
		    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = false, e;
		    return e.done = true, e;
		  };
		}
		module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regeneratorKeys));
	return regeneratorKeys.exports;
}

var regeneratorValues = {exports: {}};

var _typeof = {exports: {}};

var hasRequired_typeof;

function require_typeof () {
	if (hasRequired_typeof) return _typeof.exports;
	hasRequired_typeof = 1;
	(function (module) {
		function _typeof(o) {
		  "@babel/helpers - typeof";

		  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
		    return typeof o;
		  } : function (o) {
		    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
		}
		module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (_typeof));
	return _typeof.exports;
}

var hasRequiredRegeneratorValues;

function requireRegeneratorValues () {
	if (hasRequiredRegeneratorValues) return regeneratorValues.exports;
	hasRequiredRegeneratorValues = 1;
	(function (module) {
		var _typeof = require_typeof()["default"];
		function _regeneratorValues(e) {
		  if (null != e) {
		    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
		      r = 0;
		    if (t) return t.call(e);
		    if ("function" == typeof e.next) return e;
		    if (!isNaN(e.length)) return {
		      next: function next() {
		        return e && r >= e.length && (e = void 0), {
		          value: e && e[r++],
		          done: !e
		        };
		      }
		    };
		  }
		  throw new TypeError(_typeof(e) + " is not iterable");
		}
		module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regeneratorValues));
	return regeneratorValues.exports;
}

var hasRequiredRegeneratorRuntime;

function requireRegeneratorRuntime () {
	if (hasRequiredRegeneratorRuntime) return regeneratorRuntime$1.exports;
	hasRequiredRegeneratorRuntime = 1;
	(function (module) {
		var OverloadYield = requireOverloadYield();
		var regenerator = requireRegenerator$1();
		var regeneratorAsync = requireRegeneratorAsync();
		var regeneratorAsyncGen = requireRegeneratorAsyncGen();
		var regeneratorAsyncIterator = requireRegeneratorAsyncIterator();
		var regeneratorKeys = requireRegeneratorKeys();
		var regeneratorValues = requireRegeneratorValues();
		function _regeneratorRuntime() {

		  var r = regenerator(),
		    e = r.m(_regeneratorRuntime),
		    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
		  function n(r) {
		    var e = "function" == typeof r && r.constructor;
		    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
		  }
		  var o = {
		    "throw": 1,
		    "return": 2,
		    "break": 3,
		    "continue": 3
		  };
		  function a(r) {
		    var e, t;
		    return function (n) {
		      e || (e = {
		        stop: function stop() {
		          return t(n.a, 2);
		        },
		        "catch": function _catch() {
		          return n.v;
		        },
		        abrupt: function abrupt(r, e) {
		          return t(n.a, o[r], e);
		        },
		        delegateYield: function delegateYield(r, o, a) {
		          return e.resultName = o, t(n.d, regeneratorValues(r), a);
		        },
		        finish: function finish(r) {
		          return t(n.f, r);
		        }
		      }, t = function t(r, _t, o) {
		        n.p = e.prev, n.n = e.next;
		        try {
		          return r(_t, o);
		        } finally {
		          e.next = n.n;
		        }
		      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
		      try {
		        return r.call(this, e);
		      } finally {
		        n.p = e.prev, n.n = e.next;
		      }
		    };
		  }
		  return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
		    return {
		      wrap: function wrap(e, t, n, o) {
		        return r.w(a(e), t, n, o && o.reverse());
		      },
		      isGeneratorFunction: n,
		      mark: r.m,
		      awrap: function awrap(r, e) {
		        return new OverloadYield(r, e);
		      },
		      AsyncIterator: regeneratorAsyncIterator,
		      async: function async(r, e, t, o, u) {
		        return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
		      },
		      keys: regeneratorKeys,
		      values: regeneratorValues
		    };
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
		}
		module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (regeneratorRuntime$1));
	return regeneratorRuntime$1.exports;
}

var regenerator;
var hasRequiredRegenerator;

function requireRegenerator () {
	if (hasRequiredRegenerator) return regenerator;
	hasRequiredRegenerator = 1;
	// TODO(Babel 8): Remove this file.

	var runtime = requireRegeneratorRuntime()();
	regenerator = runtime;

	// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}
	return regenerator;
}

var regeneratorExports = requireRegenerator();
var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs(regeneratorExports);

var InputSearchIcon = function InputSearchIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className ? className : '',
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12303_447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4351 14.0629H14.7124L14.4563 13.8159C15.3528 12.773 15.8925 11.4191 15.8925 9.94625C15.8925 6.66209 13.2304 4 9.94625 4C6.66209 4 4 6.66209 4 9.94625C4 13.2304 6.66209 15.8925 9.94625 15.8925C11.4191 15.8925 12.773 15.3528 13.8159 14.4563L14.0629 14.7124V15.4351L18.6369 20L20 18.6369L15.4351 14.0629ZM9.94625 14.0629C7.66838 14.0629 5.82962 12.2241 5.82962 9.94625C5.82962 7.66838 7.66838 5.82962 9.94625 5.82962C12.2241 5.82962 14.0629 7.66838 14.0629 9.94625C14.0629 12.2241 12.2241 14.0629 9.94625 14.0629Z",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12303_447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
var SearchIcon = function SearchIcon(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className ? className : '',
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12178_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4351 14.0629H14.7124L14.4563 13.8159C15.3528 12.773 15.8925 11.4191 15.8925 9.94625C15.8925 6.66209 13.2304 4 9.94625 4C6.66209 4 4 6.66209 4 9.94625C4 13.2304 6.66209 15.8925 9.94625 15.8925C11.4191 15.8925 12.773 15.3528 13.8159 14.4563L14.0629 14.7124V15.4351L18.6369 20L20 18.6369L15.4351 14.0629ZM9.94625 14.0629C7.66838 14.0629 5.82962 12.2241 5.82962 9.94625C5.82962 7.66838 7.66838 5.82962 9.94625 5.82962C12.2241 5.82962 14.0629 7.66838 14.0629 9.94625C14.0629 12.2241 12.2241 14.0629 9.94625 14.0629Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12178_375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var css$1b = {"search__auto_suggest__wrapper":"SearchBar-module_search__auto_suggest__wrapper__kwPEI","search__auto_suggest__with_height":"SearchBar-module_search__auto_suggest__with_height__dG9oW","search__auto_suggest_list__wrapper":"SearchBar-module_search__auto_suggest_list__wrapper__lv0yj","search__auto_suggest_item":"SearchBar-module_search__auto_suggest_item__27-Fu","search__auto_suggest_link":"SearchBar-module_search__auto_suggest_link__UdGQv","search__input__wrapper":"SearchBar-module_search__input__wrapper__jVTcu","input__search":"SearchBar-module_input__search__XhcRv","search__input__element":"SearchBar-module_search__input__element__6eyxo","search__cad__upload":"SearchBar-module_search__cad__upload__R6uV3","search__cad__upload__button":"SearchBar-module_search__cad__upload__button__fNRYU"};

var fetchSearchTerms = function fetchSearchTerms(searchTerm) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var searchListUrl, searchData, response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          searchListUrl = '/Search/ListSearchTerms';
          searchData = new FormData();
          searchData.append('term', searchTerm);
          _context.prev = 3;
          _context.next = 6;
          return fetch("".concat(searchListUrl), {
            method: 'POST',
            body: searchData
          });
        case 6:
          response = _context.sent;
          if (!response.ok) {
            console.error('Failed to fetch suggestions');
          }
          _context.next = 10;
          return response.json();
        case 10:
          data = _context.sent;
          return _context.abrupt("return", data);
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](3);
          console.error('Error fetching suggestions:', _context.t0);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 14]]);
  }));
};
var useOutsideClick$1 = function useOutsideClick(callback) {
  var searchTermListRef = useRef(null);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (searchTermListRef.current && !searchTermListRef.current.contains(event.target)) {
        callback();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback]);
  return searchTermListRef;
};

var SearchBar = function SearchBar(_ref) {
  var placeholder = _ref.placeholder,
    className = _ref.className,
    height = _ref.height,
    _ref$preview = _ref.preview,
    preview = _ref$preview === void 0 ? false : _ref$preview,
    router = _ref.router,
    locale = _ref.locale;
  var _useState = useState([]),
    searchSuggestions = _useState[0],
    setSearchSuggestions = _useState[1];
  var _useState2 = useState(''),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var _useState3 = useState(false),
    showSuggestion = _useState3[0],
    setShowSuggestion = _useState3[1];
  var searchTermListRef = useOutsideClick$1(function () {
    setShowSuggestion(false);
  });
  var _useState4 = useState(false),
    renderCADSearch = _useState4[0],
    setRenderCADSearch = _useState4[1];
  var handleSearchChange = function handleSearchChange(event) {
    var value = event.target.value;
    setSearchTerm(value);
  };
  var handleSearch = function handleSearch(suggestion) {
    var searchQuery = suggestion || searchTerm;
    if (!searchQuery || preview) return;
    if (suggestion) {
      setSearchTerm(suggestion);
    }
    var domainSetup = getDomainSetupByLocale(locale);
    var hasMultipleLangs = domainSetup && (domainSetup === null || domainSetup === void 0 ? void 0 : domainSetup.locales.length) > 1;
    if (hasMultipleLangs) {
      var _locale$split = locale.split('-'),
        _locale$split2 = _slicedToArray(_locale$split, 2),
        languageCode = _locale$split2[0],
        countryCode = _locale$split2[1];
      var fullyQualifiedUrl = "https://".concat(window.location.hostname, "/search?q=").concat(encodeURIComponent(searchQuery));
      if (languageCode && countryCode) {
        var urlWithParams = "".concat(fullyQualifiedUrl, "&C=").concat(countryCode.toUpperCase(), "&L=").concat(languageCode);
        window.location.href = urlWithParams;
      } else {
        window.location.href = fullyQualifiedUrl;
      }
    } else {
      var searchBaseURL = "https://".concat(window.location.hostname, "/search?q=");
      router === null || router === void 0 ? void 0 : router.push("".concat(searchBaseURL).concat(encodeURIComponent(searchQuery)));
    }
    if (suggestion) {
      setShowSuggestion(false);
    }
  };
  useEffect(function () {
    if (searchTerm.length >= 2 && !preview) {
      var debounceTimer = setTimeout(function () {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var suggestions;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchSearchTerms(searchTerm);
              case 2:
                suggestions = _context.sent;
                setShowSuggestion(true);
                setSearchSuggestions(suggestions);
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
      }, 300);
      return function () {
        return clearTimeout(debounceTimer);
      };
    } else {
      setSearchSuggestions([]);
      setShowSuggestion(false);
    }
  }, [searchTerm, preview]);
  useEffect(function () {
    var cadSearchLocales = ['de-de', 'en-de'];
    var doRender = typeof locale !== 'undefined' && cadSearchLocales.includes(locale.toLowerCase()) || process.env.NODE_ENV === 'development';
    setRenderCADSearch(doRender);
  }, [locale]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$1b.search__input__wrapper).concat(conditionalClassname(!!className, className))
  }, /*#__PURE__*/React.createElement("input", {
    value: searchTerm,
    onChange: handleSearchChange,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') handleSearch(searchTerm);
    },
    role: "searchbox",
    "aria-label": "Search",
    name: "searchTerm",
    type: "text",
    placeholder: placeholder,
    className: css$1b.search__input__element
  }), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return handleSearch(searchTerm);
    },
    "aria-label": "Search",
    className: css$1b.input__search
  }, /*#__PURE__*/React.createElement(InputSearchIcon, null)), !!(searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) && showSuggestion && (/*#__PURE__*/React.createElement("div", {
    ref: searchTermListRef,
    style: {
      maxHeight: "".concat(height, "px")
    },
    className: "".concat(css$1b.search__auto_suggest__wrapper, " ").concat(conditionalClassname(!!height, "".concat(css$1b.search__auto_suggest__with_height)))
  }, /*#__PURE__*/React.createElement("ul", {
    className: css$1b.search__auto_suggest_list__wrapper
  }, searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.map(function (result) {
    return /*#__PURE__*/React.createElement("li", {
      key: "search-suggestion-".concat(result),
      className: css$1b.search__auto_suggest_item
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return handleSearch(result);
      },
      className: css$1b.search__auto_suggest_link
    }, result));
  })))), renderCADSearch && (/*#__PURE__*/React.createElement("div", {
    id: "search-cad-upload",
    className: css$1b.search__cad__upload
  }, /*#__PURE__*/React.createElement("button", {
    id: "search-cad-upload-button",
    className: css$1b.search__cad__upload__button
  }))));
};

var css$1a = {"separator":"Separator-module_separator__Rsu95"};

var Separator = function Separator(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("hr", {
    className: "".concat(css$1a.separator, " ").concat(className ? className : '', "\n    ")
  });
};

var ColumnView;
(function (ColumnView) {
  ColumnView["Two"] = "2";
  ColumnView["Three"] = "3";
  ColumnView["Four"] = "4";
})(ColumnView || (ColumnView = {}));
var AssetView;
(function (AssetView) {
  AssetView["Right"] = "right";
  AssetView["Left"] = "left";
  AssetView["Fullwidth"] = "fullwidth";
})(AssetView || (AssetView = {}));
var TeaserAssetImageHeight;
(function (TeaserAssetImageHeight) {
  TeaserAssetImageHeight["LARGE"] = "large";
  TeaserAssetImageHeight["MEDIUM"] = "medium";
  TeaserAssetImageHeight["SMALL"] = "small";
  TeaserAssetImageHeight["16_9"] = "169";
})(TeaserAssetImageHeight || (TeaserAssetImageHeight = {}));

var css$19 = {"placeholder":"TeaserPlaceholder-module_placeholder__o-s6K","teaser_list__wrapper":"TeaserPlaceholder-module_teaser_list__wrapper__9ZIqB","teaser_title":"TeaserPlaceholder-module_teaser_title__q4OpC","teaser_img":"TeaserPlaceholder-module_teaser_img__oZ29U","teaser_link":"TeaserPlaceholder-module_teaser_link__bDnvF","feed_error_text":"TeaserPlaceholder-module_feed_error_text__zaaD-","feed__wrapper":"TeaserPlaceholder-module_feed__wrapper__aXi-x"};

var TeaserPlaceholder = function TeaserPlaceholder(_ref) {
  var _ref$numberOfTeasers = _ref.numberOfTeasers,
    numberOfTeasers = _ref$numberOfTeasers === void 0 ? '3' : _ref$numberOfTeasers,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? ColumnView.Three : _ref$view,
    errorMessage = _ref.errorMessage;
  var items = Array.from({
    length: Number(numberOfTeasers)
  });
  var getColumnSize = function getColumnSize(view) {
    var size = new Map();
    size.set(ColumnView.Two, 6);
    size.set(ColumnView.Three, 4);
    size.set(ColumnView.Four, 3);
    return size.get(view);
  };
  return /*#__PURE__*/React.createElement(Row, {
    className: css$19.feed__wrapper
  }, errorMessage && (/*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: css$19.feed_error_text
  }, errorMessage))), items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Col, {
      key: "tp_".concat(index),
      lg: getColumnSize(view),
      className: css$19.teaser_list__wrapper
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(css$19.placeholder, " ").concat(css$19.teaser_title)
    }), /*#__PURE__*/React.createElement("span", {
      className: "".concat(css$19.placeholder, " ").concat(css$19.teaser_img)
    }), /*#__PURE__*/React.createElement("span", {
      className: "".concat(css$19.placeholder, " ").concat(css$19.teaser_link)
    }));
  }));
};

var primary = {
	"default": "#f07d00",
	hover: "#D26E00"
};
var secondary = {
	"default": "#363636",
	hover: "#000000"
};
var themeColor1 = {
	"default": "#da0e7d",
	hover: "#9b0a59"
};
var themeColor2 = {
	"default": "#49269e",
	hover: "#341d4e"
};
var themeColor3 = {
	"default": "#ffffff"
};
var theme = {
	primary: primary,
	secondary: secondary,
	themeColor1: themeColor1,
	themeColor2: themeColor2,
	themeColor3: themeColor3
};

var FontColor;
(function (FontColor) {
  FontColor["DEFAULT"] = "#363636";
  FontColor["WHITE"] = "#ffffff";
})(FontColor || (FontColor = {}));

var ThemeVariables = function ThemeVariables(_ref) {
  var primary = _ref.primary,
    primaryHover = _ref.primaryHover,
    primary_font = _ref.primary_font,
    secondary = _ref.secondary,
    secondaryHover = _ref.secondaryHover,
    secondary_font = _ref.secondary_font,
    themingColor_1 = _ref.themingColor_1,
    hoverColor_1 = _ref.hoverColor_1,
    font_color1 = _ref.font_color1,
    themingColor_2 = _ref.themingColor_2,
    hoverColor_2 = _ref.hoverColor_2,
    font_color2 = _ref.font_color2,
    themingColor_3 = _ref.themingColor_3,
    buttons_full_width = _ref.buttons_full_width;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  return /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("style", null, "\n      :root {\n        --theme-primary: ".concat((_a = primary === null || primary === void 0 ? void 0 : primary.color) !== null && _a !== void 0 ? _a : theme.primary["default"], ";\n        --theme-primary-hover: ").concat((_b = primaryHover === null || primaryHover === void 0 ? void 0 : primaryHover.color) !== null && _b !== void 0 ? _b : theme.primary.hover, ";\n        --theme-primary-font: ").concat(primary_font ? FontColor.DEFAULT : FontColor.WHITE, ";\n        --theme-secondary: ").concat((_c = secondary === null || secondary === void 0 ? void 0 : secondary.color) !== null && _c !== void 0 ? _c : theme.secondary["default"], ";\n        --theme-secondary-hover: ").concat((_d = secondaryHover === null || secondaryHover === void 0 ? void 0 : secondaryHover.color) !== null && _d !== void 0 ? _d : theme.secondary.hover, ";\n        --theme-secondary-font: ").concat(secondary_font ? FontColor.DEFAULT : FontColor.WHITE, ";\n        --theme-color1: ").concat((_e = themingColor_1 === null || themingColor_1 === void 0 ? void 0 : themingColor_1.color) !== null && _e !== void 0 ? _e : theme.themeColor1["default"], ";\n        --theme-color1-hover: ").concat((_f = hoverColor_1 === null || hoverColor_1 === void 0 ? void 0 : hoverColor_1.color) !== null && _f !== void 0 ? _f : theme.themeColor1.hover, ";\n        --theme-color1-font: ").concat(font_color1 ? FontColor.DEFAULT : FontColor.WHITE, ";\n        --theme-color2: ").concat((_g = themingColor_2 === null || themingColor_2 === void 0 ? void 0 : themingColor_2.color) !== null && _g !== void 0 ? _g : theme.themeColor2["default"], ";\n        --theme-color2-hover: ").concat((_h = hoverColor_2 === null || hoverColor_2 === void 0 ? void 0 : hoverColor_2.color) !== null && _h !== void 0 ? _h : theme.themeColor2.hover, ";\n        --theme-color2-font: ").concat(font_color2 ? FontColor.DEFAULT : FontColor.WHITE, ";\n        --theme-color3: ").concat((_j = themingColor_3 === null || themingColor_3 === void 0 ? void 0 : themingColor_3.color) !== null && _j !== void 0 ? _j : theme.themeColor3["default"], ";\n        --buttons-full-width: ").concat(buttons_full_width ? '100%' : 'fit-content', ";\n      }\n    ")));
};

var JsonLd = function JsonLd(props) {
  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(props.jsonLdSchema)
    }
  });
};

var hasLink = function hasLink(link) {
  if (link && link.length > 0) {
    return true;
  }
  return false;
};

var generateImageSrc = function generateImageSrc(imageData) {
  if (!imageData || !(imageData === null || imageData === void 0 ? void 0 : imageData.item)) return '';
  var _imageData$item = imageData.item,
    external_id = _imageData$item.external_id,
    filename = _imageData$item.filename,
    embed_link = _imageData$item.embed_link,
    focal_embed_link = _imageData$item.focal_embed_link;
  if (!external_id || !filename) return '';
  var baseLink = focal_embed_link !== null && focal_embed_link !== void 0 ? focal_embed_link : embed_link;
  if (!baseLink) return '';
  var match = baseLink.match(/\.(jpeg|jpg|png|tif)/);
  var baseLinkExtension = match ? match[0] : '';
  var reconstructedUrl = baseLink.replace(/\/content\/\w+\//, "/content/".concat(external_id, "/")).replace(/\/(jpeg|jpg|png|tif)\//, '/webp/').replace(/\/[\w-]+\.(jpeg|jpg|png|tif)/, "/".concat(filename.replace(/\.[^/.]+$/, '')).concat(baseLinkExtension));
  return reconstructedUrl;
};

var css$18 = {"image__fallback":"Fallback-module_image__fallback__GXQFf","link__icon":"Fallback-module_link__icon__akBF6","link__iconPrimary":"Fallback-module_link__iconPrimary__9IfeK","link__iconSecondary":"Fallback-module_link__iconSecondary__ljKWy","link__iconTertiary":"Fallback-module_link__iconTertiary__u-Y9c","chevron__down":"Fallback-module_chevron__down__ueTX2","chevron__up":"Fallback-module_chevron__up__2cVQ0","video_fallback":"Fallback-module_video_fallback__P1X-W","fallback__image_large":"Fallback-module_fallback__image_large__S-n-Y","fallback__image_medium":"Fallback-module_fallback__image_medium__jiGxj","fallback__image_small":"Fallback-module_fallback__image_small__RZYJA"};

var ChevronDirection;
(function (ChevronDirection) {
  ChevronDirection["Up"] = "up";
  ChevronDirection["Down"] = "down";
})(ChevronDirection || (ChevronDirection = {}));
var ChevronIcon = function ChevronIcon(_ref) {
  var direction = _ref.direction;
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "8",
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: direction === ChevronDirection.Down ? css$18.chevron__down : css$18.chevron__up
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.70504L10.59 0.295044L6 4.87504L1.41 0.295044L0 1.70504L6 7.70504L12 1.70504Z",
    fill: "#363636"
  }));
};

var MediaType;
(function (MediaType) {
  MediaType["IMAGE"] = "image";
  MediaType["VIDEO"] = "video";
  MediaType["YOUTUBE"] = "youtube";
})(MediaType || (MediaType = {}));
function hasAssetData(asset, mediaType) {
  var _a, _b, _c;
  var assetItem = asset && asset.length > 0 && asset[0];
  if (assetItem && ((_a = assetItem === null || assetItem === void 0 ? void 0 : assetItem.image) === null || _a === void 0 ? void 0 : _a.item) && mediaType == MediaType.IMAGE) {
    return true;
  }
  if (assetItem && ((_c = (_b = assetItem === null || assetItem === void 0 ? void 0 : assetItem.video) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.embed_link) && mediaType === MediaType.VIDEO) {
    return true;
  }
  if (assetItem && (assetItem === null || assetItem === void 0 ? void 0 : assetItem.youtube_id) && mediaType === MediaType.YOUTUBE) {
    return true;
  }
  return false;
}

var linkVariant$1 = {
  primary: css$18.link__iconPrimary,
  secondary: css$18.link__iconSecondary,
  tertiary: css$18.link__iconTertiary
};
var LinkIcon = function LinkIcon(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? LinkVariant.Primary : _ref$variant,
    className = _ref.className,
    onOrangeBackground = _ref.onOrangeBackground;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(css$18.link__icon, " ").concat(onOrangeBackground ? linkVariant$1.tertiary : linkVariant$1[variant], " ").concat(className ? className : ''),
    width: "5",
    height: "10",
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10L5 5L0 0V10Z"
  }));
};

var IconFont = function IconFont(_ref) {
  var className = _ref.className,
    icon = _ref.icon;
  useEffect(function () {
    if (icon.type === 'igus' && icon.color) {
      var style = document.createElement('style');
      style.innerHTML = "\n        .icon-".concat(icon.name, "::before {\n          color: ").concat(icon.color, ";\n        }\n      ");
      document.head.appendChild(style);
      return function () {
        document.head.removeChild(style);
      };
    }
  }, [icon]);
  if (icon.type === 'material') {
    return /*#__PURE__*/React.createElement("span", {
      className: "material-symbols-outlined ".concat(className || ''),
      style: {
        color: icon.color
      }
    }, icon.name);
  }
  if (icon.type === 'igus') {
    return /*#__PURE__*/React.createElement("span", {
      className: "icon-".concat(icon.name, " ").concat(className || '')
    }, (icon === null || icon === void 0 ? void 0 : icon.code) && Array.from({
      length: icon.code
    }).map(function (_item, i) {
      return /*#__PURE__*/React.createElement("span", {
        key: "path".concat(i + 1),
        className: "path".concat(i + 1, " ").concat(className || '')
      });
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

var css$17 = {"breakpoints":"'../../../styling/breakpoints.css'","lg":"i__const_lg_0","md":"i__const_md_1","sm":"i__const_sm_2","wrapper":"QuickInfo-module_wrapper__RwXGt","quickInfo__buttons__wrapper":"QuickInfo-module_quickInfo__buttons__wrapper__Ubn06","quickInfo__bg_white":"QuickInfo-module_quickInfo__bg_white__nyBCG","quickInfo__text_wrapper":"QuickInfo-module_quickInfo__text_wrapper__B5TOJ","quickInfo__headline":"QuickInfo-module_quickInfo__headline__otYJ7","quickInfo__onlyHeadline":"QuickInfo-module_quickInfo__onlyHeadline__GioYU","quickInfo__text__noLink":"QuickInfo-module_quickInfo__text__noLink__Qh8k7","centerText":"QuickInfo-module_centerText__jJoq2","image":"QuickInfo-module_image__Zx-qy","quickInfo__noImage":"QuickInfo-module_quickInfo__noImage__e-Jwu","quickInfo__onlyText":"QuickInfo-module_quickInfo__onlyText__3l38-","align_text__left":"QuickInfo-module_align_text__left__pDWTb","quickInfo__icon__primary":"QuickInfo-module_quickInfo__icon__primary__M0MOv","quickInfo__icon__secondary":"QuickInfo-module_quickInfo__icon__secondary__MWpmP","quickInfo__linksWrapper__noImage":"QuickInfo-module_quickInfo__linksWrapper__noImage__rUk8f","quickInfo__link":"QuickInfo-module_quickInfo__link__0-wfT","quickInfo__linksWrapper":"QuickInfo-module_quickInfo__linksWrapper__jXRHJ","two__columns":"QuickInfo-module_two__columns__YPGzb","three__columns":"QuickInfo-module_three__columns__GfU-w","four__columns":"QuickInfo-module_four__columns__qtVcB","quickInfo__on__orange":"QuickInfo-module_quickInfo__on__orange__-L2gy","quickInfo__on__orange__background":"QuickInfo-module_quickInfo__on__orange__background__ToCn-","quickInfo__themed_primary":"QuickInfo-module_quickInfo__themed_primary__cwqLm","quickInfo__themed_secondary":"QuickInfo-module_quickInfo__themed_secondary__-ze-l","quickInfo__themed_color1":"QuickInfo-module_quickInfo__themed_color1__V69Yl","quickInfo__themed_color2":"QuickInfo-module_quickInfo__themed_color2__nwcWF","quickInfo__font__icon":"QuickInfo-module_quickInfo__font__icon__GmKtr","font__icon__variant":"QuickInfo-module_font__icon__variant__Tt1-l","material__icon":"QuickInfo-module_material__icon__CpiUw","quickInfo__themed_primary_font":"QuickInfo-module_quickInfo__themed_primary_font__rtixq","quickInfo__themed_secondary_font":"QuickInfo-module_quickInfo__themed_secondary_font__Q9Q5T","quickInfo__themed_color1_font":"QuickInfo-module_quickInfo__themed_color1_font__4SWJh","quickInfo__themed_color2_font":"QuickInfo-module_quickInfo__themed_color2_font__yz-ha"};

var setColumnView = function setColumnView(view) {
  var columnLayout = new Map();
  columnLayout.set(ColumnView.Two, css$17.two__columns);
  columnLayout.set(ColumnView.Three, css$17.three__columns);
  columnLayout.set(ColumnView.Four, css$17.four__columns);
  return columnLayout.get(view);
};
var determineFinalVariant = function determineFinalVariant(onOrangeBackground, variant) {
  var isButtonVariant = variant === LinkVariant.ButtonTertiary || variant === LinkVariant.ButtonThemingColor1 || variant === LinkVariant.ButtonThemingColor2 || variant === LinkVariant.ButtonTransparent;
  return onOrangeBackground && isButtonVariant ? LinkVariant.Button : variant;
};
var iconSizes$3 = [{
  width: 65,
  height: 65
}];

var RenderButtonType$1 = function RenderButtonType(_ref) {
  var linkType = _ref.linkType,
    image = _ref.image,
    linkVariant = _ref.linkVariant,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou;
  var _a, _b, _c, _d, _e;
  var _linkPropsMapper = linkPropsMapper(linkType),
    children = _linkPropsMapper.children,
    title = _linkPropsMapper.title,
    variant = _linkPropsMapper.variant,
    external = _linkPropsMapper.external,
    href = _linkPropsMapper.href,
    target = _linkPropsMapper.target,
    icon = _linkPropsMapper.icon,
    anchor = _linkPropsMapper.anchor;
  var finalVariant = determineFinalVariant(onOrangeBackground, variant);
  return /*#__PURE__*/React.createElement("span", {
    className: chainConditionalClassnames(css$17.quickInfo__linksWrapper, conditionalClassname(!!image && !hasAssetData(image, MediaType.IMAGE), css$17.quickInfo__linksWrapper__noImage), !onOrangeBackground ? linkVariant : '')
  }, (finalVariant === LinkVariant.Primary || finalVariant === LinkVariant.Secondary) && (/*#__PURE__*/React.createElement(LinkIcon, {
    variant: finalVariant,
    className: chainConditionalClassnames(conditionalClassname(finalVariant === LinkVariant.Primary, css$17.quickInfo__icon__primary) || css$17.quickInfo__icon__secondary)
  })), /*#__PURE__*/React.createElement(Link, Object.assign({
    className: css$17.quickInfo__link,
    key: linkType._uid,
    variant: finalVariant,
    external: ((_a = linkType.link) === null || _a === void 0 ? void 0 : _a.linktype) === ContactType.Email || external,
    anchor: anchor,
    href: href ? href : '#',
    target: target,
    icon: icon,
    title: title,
    contact_type: determineContactType((_b = linkType.link) === null || _b === void 0 ? void 0 : _b.url, (_c = linkType.link) === null || _c === void 0 ? void 0 : _c.linktype)
  }, ((_d = linkType.link) === null || _d === void 0 ? void 0 : _d.rel) && {
    rel: (_e = linkType.link) === null || _e === void 0 ? void 0 : _e.rel
  }), children));
};
var QuickInfoCard = function QuickInfoCard(_ref2) {
  var text = _ref2.text,
    headline = _ref2.headline,
    link = _ref2.link,
    image = _ref2.image,
    background_color = _ref2.background_color,
    variant = _ref2.variant,
    _ref2$onOrangeBackgro = _ref2.onOrangeBackground,
    onOrangeBackground = _ref2$onOrangeBackgro === void 0 ? false : _ref2$onOrangeBackgro,
    _ref2$text_alignment = _ref2.text_alignment,
    text_alignment = _ref2$text_alignment === void 0 ? false : _ref2$text_alignment;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  var imageSrc = generateImageSrc(((_c = (_b = (_a = image === null || image === void 0 ? void 0 : image[0]) === null || _a === void 0 ? void 0 : _a.local_image) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.local_image) || ((_d = image === null || image === void 0 ? void 0 : image[0]) === null || _d === void 0 ? void 0 : _d.image));
  return /*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames(css$17.wrapper, conditionalClassname(!!background_color, css$17.quickInfo__bg_white), conditionalClassname(!!image && !hasAssetData(image, MediaType.IMAGE) && !((_e = image[0]) === null || _e === void 0 ? void 0 : _e.icon), css$17.quickInfo__noImage), conditionalClassname(!hasTextContent(text), css$17.centerText), conditionalClassname(!headline, css$17.quickInfo__onlyText), conditionalClassname(!hasLink(link) && !hasTextContent(text), css$17.centerText), conditionalClassname(text_alignment && !!image && !hasAssetData(image, MediaType.IMAGE) && !((_f = image[0]) === null || _f === void 0 ? void 0 : _f.icon), css$17.align_text__left), !onOrangeBackground && variant ? getVariantClassName(variant, css$17, ComponentNames.QuickInfo) : '')
  }, image && ((_g = image[0]) === null || _g === void 0 ? void 0 : _g.icon) && ((_h = image[0]) === null || _h === void 0 ? void 0 : _h.component) === 'icon_atom' ? (/*#__PURE__*/React.createElement(IconFont, {
    icon: (_j = image[0]) === null || _j === void 0 ? void 0 : _j.icon,
    className: "".concat(css$17.quickInfo__font__icon, " ").concat(conditionalClassname(!!variant, css$17.font__icon__variant), " ").concat(conditionalClassname(((_k = image[0]) === null || _k === void 0 ? void 0 : _k.icon.type) == 'material', css$17.material__icon))
  })) : image && hasAssetData(image, MediaType.IMAGE) && (/*#__PURE__*/React.createElement(Image, {
    src: imageSrc,
    alt: "".concat((_l = image[0]) === null || _l === void 0 ? void 0 : _l.alt_text),
    imageSizes: iconSizes$3,
    className: css$17.image
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$17.quickInfo__text_wrapper, " ").concat(conditionalClassname(text_alignment, css$17.align_text__left))
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4,
    className: chainConditionalClassnames(conditionalClassname(!hasTextContent(text) && !hasLink(link), css$17.quickInfo__onlyHeadline) || css$17.quickInfo__headline, !onOrangeBackground && variant ? getVariantClassName(variant, css$17, ComponentNames.QuickInfo) : '')
  }, headline), text && hasTextContent(text) && (/*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames(conditionalClassname(!!headline && !hasLink(link), css$17.quickInfo__text__noLink), !onOrangeBackground && variant ? getVariantClassName(variant, css$17, ComponentNames.QuickInfo) : '')
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }))), link && hasLink(link) && (/*#__PURE__*/React.createElement(React.Fragment, null, link.map(function (linkType) {
    return /*#__PURE__*/React.createElement(RenderButtonType$1, {
      key: linkType._uid,
      linkType: linkType,
      image: image,
      linkVariant: variant,
      onOrangeBackground: onOrangeBackground
    });
  })))));
};

var css$16 = {"accordion_element__wrapper":"Accordion-module_accordion_element__wrapper__nkzDK","accordion__active_element":"Accordion-module_accordion__active_element__p4TAW","accordion__inactive_element":"Accordion-module_accordion__inactive_element__C7tvI","accordion_header__wrapper":"Accordion-module_accordion_header__wrapper__CHO-e","accordion_header":"Accordion-module_accordion_header__3XG1f","accordion_header__active":"Accordion-module_accordion_header__active__ejqx3","accordion_content__wrapper":"Accordion-module_accordion_content__wrapper__nJcCE","accordion_active__wrapper":"Accordion-module_accordion_active__wrapper__ENwqG","accordion_image__wrapper":"Accordion-module_accordion_image__wrapper__YMxF3","accordion__image":"Accordion-module_accordion__image__jda18","accordion__image_small":"Accordion-module_accordion__image_small__TCsjM","accordion_with_image_content__wrapper":"Accordion-module_accordion_with_image_content__wrapper__2qV8i","link__wrapper":"Accordion-module_link__wrapper__LHTAZ","accordion__imageRatio_large":"Accordion-module_accordion__imageRatio_large__gelKm","accordion__imageRatio_medium":"Accordion-module_accordion__imageRatio_medium__PZCMU","accordion__imageRatio_small":"Accordion-module_accordion__imageRatio_small__n2Sum","accordion__text__wrapper":"Accordion-module_accordion__text__wrapper__1EhJa","accordion_content_with_column":"Accordion-module_accordion_content_with_column__86StB"};

var AccordionImageHeight;
(function (AccordionImageHeight) {
  AccordionImageHeight["LARGE"] = "large";
  AccordionImageHeight["MEDIUM"] = "medium";
  AccordionImageHeight["SMALL"] = "small";
})(AccordionImageHeight || (AccordionImageHeight = {}));

var jsonLdMapper = function jsonLdMapper(elements) {
  return elements.map(function (item) {
    var _a;
    return {
      '@type': 'Question',
      name: item.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: _mapContent((_a = item === null || item === void 0 ? void 0 : item.text) === null || _a === void 0 ? void 0 : _a.content)
      }
    };
  });
};
var accordionSrcSetSizes = {
  large: [{
    width: 673,
    height: 448
  }, {
    width: 540,
    height: 360
  }, {
    width: 433,
    height: 289
  }, {
    width: 320,
    height: 213
  }],
  medium: [{
    width: 673,
    height: 404
  }, {
    width: 540,
    height: 324
  }, {
    width: 433,
    height: 260
  }, {
    width: 320,
    height: 192
  }],
  small: [{
    width: 673,
    height: 269
  }, {
    width: 540,
    height: 216
  }, {
    width: 433,
    height: 173
  }, {
    width: 320,
    height: 128
  }]
};
var _mapContent = function mapContent(content) {
  return content === null || content === void 0 ? void 0 : content.map(function (item) {
    if (item.type === 'paragraph') {
      return item.content && (item === null || item === void 0 ? void 0 : item.content.map(function (c) {
        return c.text;
      }).join(' '));
    } else if (item.type === 'bullet_list' || item.type === 'ordered_list') {
      var listType = item.type === 'bullet_list' ? 'ul' : 'ol';
      var listItems = (item === null || item === void 0 ? void 0 : item.content) && (item === null || item === void 0 ? void 0 : item.content.map(function (c) {
        return "<li>".concat(c.content && _mapContent(c.content), "</li>");
      }).join(''));
      return "<".concat(listType, ">").concat(listItems, "</").concat(listType, ">");
    }
    return '';
  }).join('');
};

var AccordionElement = function AccordionElement(_ref) {
  var title = _ref.title,
    _uid = _ref._uid,
    image = _ref.image,
    link = _ref.link,
    text = _ref.text,
    onToggle = _ref.onToggle,
    _ref$asset_ratio = _ref.asset_ratio,
    asset_ratio = _ref$asset_ratio === void 0 ? AccordionImageHeight.LARGE : _ref$asset_ratio,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? false : _ref$view,
    imagePriority = _ref.imagePriority;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(open ? css$16.accordion__active_element : css$16.accordion__inactive_element, " ").concat(css$16.accordion_element__wrapper, " ")
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onToggle(_uid);
    },
    className: "".concat(css$16.accordion_header__wrapper, " ").concat(open ? css$16.accordion_header__active : css$16.accordion_header)
  }, title, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ChevronIcon, {
    direction: open ? ChevronDirection.Up : ChevronDirection.Down,
    key: _uid
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(open ? css$16.accordion_active__wrapper : css$16.accordion_content__wrapper, " ")
  }, image === null || image === void 0 ? void 0 : image.map(function (imageItem, index) {
    var _a, _b, _c, _d;
    var localImage = (_b = (_a = imageItem === null || imageItem === void 0 ? void 0 : imageItem.local_image) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.local_image;
    var defaultImage = imageItem === null || imageItem === void 0 ? void 0 : imageItem.image;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: chainConditionalClassnames(conditionalClassname(!!((_c = imageItem === null || imageItem === void 0 ? void 0 : imageItem.image) === null || _c === void 0 ? void 0 : _c.item), css$16.accordion_with_image_content__wrapper), conditionalClassname(view, css$16.accordion_content_with_column), conditionalClassname(!((_d = imageItem === null || imageItem === void 0 ? void 0 : imageItem.image) === null || _d === void 0 ? void 0 : _d.item), css$16.link__wrapper))
    }, imageItem && (/*#__PURE__*/React.createElement(AccordionImage, {
      image: localImage || defaultImage,
      alt_text: imageItem.alt_text,
      image_small: imageItem.image_small,
      copyright: imageItem.copyright,
      assetRatio: asset_ratio,
      legend: imageItem.legend,
      imagePriority: imagePriority
    })));
  }), /*#__PURE__*/React.createElement("div", {
    className: conditionalClassname(!!link && !!hasLink(link), css$16.accordion__text__wrapper)
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })), link && hasLink(link) && (/*#__PURE__*/React.createElement(React.Fragment, null, link.map(function (linkType) {
    return /*#__PURE__*/React.createElement(RenderButtonType$1, {
      key: linkType._uid,
      linkType: linkType
    });
  }))))));
};
var TwoColumnAccordion = function TwoColumnAccordion(_ref2) {
  var columnOne = _ref2.columnOne,
    columnTwo = _ref2.columnTwo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, columnOne), /*#__PURE__*/React.createElement(Col, {
    lg: 6
  }, columnTwo));
};
var AccordionImage = function AccordionImage(_ref3) {
  var image = _ref3.image,
    image_small = _ref3.image_small,
    alt_text = _ref3.alt_text,
    copyright = _ref3.copyright,
    legend = _ref3.legend,
    _ref3$assetRatio = _ref3.assetRatio,
    assetRatio = _ref3$assetRatio === void 0 ? AccordionImageHeight.LARGE : _ref3$assetRatio,
    imagePriority = _ref3.imagePriority;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (image === null || image === void 0 ? void 0 : image.item) && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(css$16.accordion_image__wrapper, "\n           ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === AccordionImageHeight.LARGE, css$16.accordion__imageRatio_large), conditionalClassname(assetRatio === AccordionImageHeight.MEDIUM, css$16.accordion__imageRatio_medium), conditionalClassname(assetRatio === AccordionImageHeight.SMALL, css$16.accordion__imageRatio_small)), "\n           ").concat(image_small ? css$16.accordion__image_small : css$16.accordion__image)
  }, /*#__PURE__*/React.createElement(Image, {
    src: generateImageSrc(image),
    alt: alt_text,
    imageSizes: accordionSrcSetSizes[assetRatio || 'large'],
    sizes: "(max-width: 720px) 50vw, (min-width: 721px) and (max-width: 948px) 25vw, 20vw",
    copyrightText: copyright,
    className: css$16.accordion__image,
    legend: legend,
    showLegend: true,
    priority: imagePriority
  }))));
};

var Accordion = function Accordion(_ref) {
  var accordion_element = _ref.accordion_element,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? false : _ref$separator,
    text = _ref.text,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? false : _ref$view,
    with_faq_json_schema = _ref.with_faq_json_schema,
    imagePriority = _ref.imagePriority;
  var elementsPerColumn = parseInt((accordion_element.length / 2).toFixed());
  var _useState = useState(),
    active = _useState[0],
    setActive = _useState[1];
  var handleToggle = function handleToggle(key) {
    return setActive(active !== key ? key : '');
  };
  return /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator,
    spacingWithoutSeparator: !separator
  }, with_faq_json_schema && (/*#__PURE__*/React.createElement(JsonLd, {
    jsonLdSchema: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: jsonLdMapper(accordion_element)
    }
  })), /*#__PURE__*/React.createElement(Row, {
    xs: 12
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  })))), /*#__PURE__*/React.createElement(Row, null, view ? (/*#__PURE__*/React.createElement(TwoColumnAccordion, {
    columnOne: accordion_element.slice(0, elementsPerColumn).map(function (element) {
      return /*#__PURE__*/React.createElement(AccordionElement, Object.assign({
        key: element._uid
      }, element, {
        view: view,
        onToggle: function onToggle() {
          return handleToggle(element._uid);
        },
        open: active === element._uid,
        imagePriority: imagePriority
      }));
    }),
    columnTwo: accordion_element.slice(elementsPerColumn).map(function (element) {
      return /*#__PURE__*/React.createElement(AccordionElement, Object.assign({
        key: element._uid
      }, element, {
        view: view,
        onToggle: function onToggle() {
          return handleToggle(element._uid);
        },
        open: active === element._uid,
        imagePriority: imagePriority
      }));
    })
  })) : (/*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, accordion_element.map(function (element) {
    return /*#__PURE__*/React.createElement(AccordionElement, Object.assign({
      key: element._uid
    }, element, {
      view: view,
      onToggle: function onToggle() {
        return handleToggle(element._uid);
      },
      open: active === element._uid,
      imagePriority: imagePriority
    }));
  })))));
};

var DownloadLink = function DownloadLink(_ref) {
  var icon = _ref.icon,
    name = _ref.name,
    assetLink = _ref.assetLink,
    display_titles = _ref.display_titles,
    title = _ref.title,
    className = _ref.className,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    _ref$relNofollow = _ref.relNofollow,
    relNofollow = _ref$relNofollow === void 0 ? false : _ref$relNofollow;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className ? className : '', " ").concat(css$1g.download__subgrid, " ").concat(onOrangeBackground ? css$1g.download__on__orange__background : '')
  }, display_titles && (/*#__PURE__*/React.createElement(Headline, {
    className: css$1g.headline,
    tag: HeadlineTags.H3
  }, title)), /*#__PURE__*/React.createElement("a", Object.assign({
    className: css$1g.icon__link__wrapper,
    download: true,
    target: "_self",
    title: name,
    href: assetLink
  }, relNofollow && {
    rel: RelType.NO_FOLLOW
  }), setDownloadIcon({
    icon: icon
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(css$1g.link__primary_color, " ").concat(onOrangeBackground ? css$1g.download__form__landing__text : '')
  }, name)));
};
var Downloads = function Downloads(_ref2) {
  var formation = _ref2.formation,
    separator = _ref2.separator,
    display_titles = _ref2.display_titles,
    text = _ref2.text,
    links = _ref2.links,
    _ref2$noSpacingGrid = _ref2.noSpacingGrid,
    noSpacingGrid = _ref2$noSpacingGrid === void 0 ? false : _ref2$noSpacingGrid,
    _ref2$onOrangeBackgro = _ref2.onOrangeBackground,
    onOrangeBackground = _ref2$onOrangeBackgro === void 0 ? false : _ref2$onOrangeBackgro;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    className: onOrangeBackground ? css$1g.download__on__orange : ''
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "".concat(css$1g.document__wrapper, " ").concat(setFormation$1(formation))
  }, links === null || links === void 0 ? void 0 : links.map(function (_ref3) {
    var icon = _ref3.icon,
      name = _ref3.name,
      title = _ref3.title,
      asset = _ref3.asset,
      local_asset = _ref3.local_asset,
      _uid = _ref3._uid,
      rel_nofollow = _ref3.rel_nofollow;
    var _a, _b;
    return /*#__PURE__*/React.createElement(DownloadLink, {
      display_titles: display_titles,
      icon: icon,
      name: name,
      title: title,
      assetLink: ((_a = local_asset === null || local_asset === void 0 ? void 0 : local_asset.item) === null || _a === void 0 ? void 0 : _a.embed_link) || ((_b = asset.item) === null || _b === void 0 ? void 0 : _b.embed_link),
      key: _uid,
      onOrangeBackground: onOrangeBackground,
      relNofollow: rel_nofollow
    });
  })))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$15 = {"pageIntro__wrapper":"PageIntro-module_pageIntro__wrapper__mfFUP","pageIntro__image_wrapper":"PageIntro-module_pageIntro__image_wrapper__qNjub","pageIntro__image_large":"PageIntro-module_pageIntro__image_large__Xd3TW","pageIntro__image_medium":"PageIntro-module_pageIntro__image_medium__-cV0Z","pageIntro__image_small":"PageIntro-module_pageIntro__image_small__ZeFmV","pageIntro__image":"PageIntro-module_pageIntro__image__Nzv8b","pageIntro__text_wrapper":"PageIntro-module_pageIntro__text_wrapper__bkSWm","pageIntro__button_wrapper":"PageIntro-module_pageIntro__button_wrapper__Dba3h","pageIntro__link__wrapper":"PageIntro-module_pageIntro__link__wrapper__g4t9x","pageIntro__video_wrapper":"PageIntro-module_pageIntro__video_wrapper__5korM","pageIntro_video_fallback":"PageIntro-module_pageIntro_video_fallback__QmNpS","link__on__image":"PageIntro-module_link__on__image__xMNrH","default__spacing":"PageIntro-module_default__spacing__pLF3n","spacing":"PageIntro-module_spacing__MZF5-","headlineOne":"PageIntro-module_headlineOne__JKKWe","headlineTwo":"PageIntro-module_headlineTwo__smvxC","iframe":"PageIntro-module_iframe__OfBL-","text__on__image__background":"PageIntro-module_text__on__image__background__3gT2B","text_on_image_background__fifty_percent":"PageIntro-module_text_on_image_background__fifty_percent__8apJB","text_on_image_background__sixty_percent":"PageIntro-module_text_on_image_background__sixty_percent__MYuUM","text_on_image_background__seventy_percent":"PageIntro-module_text_on_image_background__seventy_percent__4Y-3Z","text_on_image_background__eighty_percent":"PageIntro-module_text_on_image_background__eighty_percent__pYgTD","text__background":"PageIntro-module_text__background__W4Ei6","hide__header__below__image":"PageIntro-module_hide__header__below__image__xnfU9","text__on__background":"PageIntro-module_text__on__background__eaYJi","hide__link__on__image":"PageIntro-module_hide__link__on__image__BV6Mp","pageIntroHomepage__headlineOne":"PageIntro-module_pageIntroHomepage__headlineOne__lLSld"};

var PageIntroImageHeight;
(function (PageIntroImageHeight) {
  PageIntroImageHeight["LARGE"] = "large";
  PageIntroImageHeight["MEDIUM"] = "medium";
  PageIntroImageHeight["SMALL"] = "small";
})(PageIntroImageHeight || (PageIntroImageHeight = {}));
var ContentOnImageWidthProps;
(function (ContentOnImageWidthProps) {
  ContentOnImageWidthProps["FIFTY_PERCENT"] = "50_percent";
  ContentOnImageWidthProps["SIXTY_PERCENT"] = "60_percent";
  ContentOnImageWidthProps["SEVENTY_PERCENT"] = "70_percent";
  ContentOnImageWidthProps["EIGHTY_PERCENT"] = "80_percent";
})(ContentOnImageWidthProps || (ContentOnImageWidthProps = {}));

var MOBILE_BREAKPOINT = 536;
var determineVariant = function determineVariant(variant) {
  switch (variant) {
    case LinkVariant.ButtonSecondary:
    case LinkVariant.ButtonTertiary:
    case LinkVariant.ButtonThemingColor1:
    case LinkVariant.ButtonThemingColor2:
    case LinkVariant.ButtonTransparent:
      return LinkVariant.Button;
    default:
      return variant;
  }
};
var useDeviceStatus = function useDeviceStatus(showOnDevice) {
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return isMobile ? true : showOnDevice;
};
var sizes$1 = {
  169: [{
    width: 1200,
    height: 679
  }, {
    width: 1000,
    height: 562
  }, {
    width: 800,
    height: 450
  }, {
    width: 600,
    height: 337
  }, {
    width: 450,
    height: 253
  }],
  large: [{
    height: 400,
    width: 1200
  }, {
    height: 333,
    width: 999
  }, {
    height: 266,
    width: 799
  }, {
    height: 200,
    width: 600
  }, {
    height: 80,
    width: 399
  }],
  medium: [{
    height: 300,
    width: 1200
  }, {
    height: 250,
    width: 1000
  }, {
    height: 200,
    width: 800
  }, {
    height: 150,
    width: 600
  }, {
    height: 100,
    width: 400
  }],
  small: [{
    height: 240,
    width: 1200
  }, {
    height: 200,
    width: 1000
  }, {
    height: 160,
    width: 800
  }, {
    height: 120,
    width: 600
  }, {
    height: 80,
    width: 400
  }]
};
var isPageIntroHomepage = function isPageIntroHomepage(component) {
  return component === 'page_intro_homepage';
};

var VideoFallback = function VideoFallback(_ref) {
  var image = _ref.image,
    alt_text = _ref.alt_text,
    copyright = _ref.copyright,
    assetRatio = _ref.assetRatio;
  var _a, _b;
  return /*#__PURE__*/React.createElement(React.Fragment, null, image && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(css$18.video_fallback, " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === PageIntroImageHeight.LARGE, css$18.fallback__image_large), conditionalClassname(assetRatio === PageIntroImageHeight.MEDIUM, css$18.fallback__image_medium), conditionalClassname(assetRatio === PageIntroImageHeight.SMALL, css$18.fallback__image_small)))
  }, /*#__PURE__*/React.createElement(Image, {
    src: "".concat(((_a = image === null || image === void 0 ? void 0 : image.item) === null || _a === void 0 ? void 0 : _a.focal_embed_link) || ((_b = image === null || image === void 0 ? void 0 : image.item) === null || _b === void 0 ? void 0 : _b.embed_link)),
    alt: alt_text,
    copyrightText: copyright,
    priority: true,
    imageSizes: sizes$1[assetRatio || 'large'],
    sizes: "(max-width: 344px) 33vw, (max-width: 719px) 50vw, (max-width: 939px) 70vw, 1200px"
  }))));
};

var css$14 = {"wrapper":"Video-module_wrapper__znh28","video__element":"Video-module_video__element__tEftg","youtube__element":"Video-module_youtube__element__EbhBM"};

function getVideoFormat(fileName) {
  var _a;
  return ((_a = fileName.split('?')[0]) === null || _a === void 0 ? void 0 : _a.split('.').pop()) || '';
}
/**
 * Converts any thumbnail image URL to WebP format and ensures proper URL structure
 * @param url Original image URL
 * @returns Transformed WebP URL
 */
var convertToWebP = function convertToWebP(url) {
  if (!url) return '';
  return url.replace(/\/(jpeg|jpg|png|gif|tiff)\//, '/webp/');
};
var ThumbnailTypes = ['default', 'mqdefault', 'hqdefault'];
function getThumbnailUrls(youTubeId) {
  return ThumbnailTypes.map(function (type) {
    return "https://i.ytimg.com/vi/".concat(youTubeId, "/").concat(type, ".jpg");
  });
}
var youtubeURL = 'https://www.youtube.com/embed/';
var Videos = function Videos(props) {
  var aspectRatio = props.aspectRatio,
    caption = props.caption,
    background = props.background,
    legend = props.legend;
  var videoStyle = {
    style: Object.assign({
      aspectRatio: aspectRatio
    }, background ? {
      backgroundColor: "#".concat(background)
    } : {})
  };
  var renderLegend = function renderLegend(legend) {
    return legend && hasTextContent(legend) ? (/*#__PURE__*/React.createElement(LegendComponent, {
      legend: legend
    })) : null;
  };
  var renderCaption = function renderCaption(caption) {
    return caption ? (/*#__PURE__*/React.createElement("figcaption", {
      className: css$14.video_caption
    }, caption)) : null;
  };
  if ('youtubeId' in props) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("figure", {
      className: "".concat(conditionalClassname(!!props.className, props.className), " ").concat(css$14.wrapper)
    }, /*#__PURE__*/React.createElement("iframe", {
      className: css$14.youtube__element,
      style: {
        aspectRatio: aspectRatio
      },
      width: props.width,
      height: props.height,
      src: "".concat(youtubeURL).concat(props.youtubeId, "?rel=0"),
      allow: "accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      allowFullScreen: true,
      title: props.title
    }), renderCaption(caption), renderLegend(legend)), props.uploadDate && (/*#__PURE__*/React.createElement("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'VideoObject',
          name: props.title,
          description: props.title,
          thumbnailUrl: getThumbnailUrls(props.youtubeId),
          contentUrl: "https://youtu.be/".concat(props.youtubeId),
          uploadDate: props.uploadDate,
          embedUrl: "".concat(youtubeURL).concat(props.youtubeId)
        })
      }
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("figure", {
    className: css$14.wrapper
  }, /*#__PURE__*/React.createElement("video", Object.assign({
    width: props.width,
    height: props.height,
    controls: props.controls,
    autoPlay: props.autoplay,
    muted: props.muted,
    controlsList: props.controlsList,
    poster: convertToWebP(props.thumbnailUrl),
    preload: props.preload
  }, videoStyle, {
    className: "".concat(css$14.video__element, " ").concat(props.className ? props.className : '')
  }), /*#__PURE__*/React.createElement("source", {
    src: props.src,
    type: "video/".concat(getVideoFormat(props.src))
  }), props.children, /*#__PURE__*/React.createElement("track", {
    label: props.label,
    kind: "captions",
    srcLang: props.srcLang,
    src: props.captionSrc,
    "default": true
  })), renderCaption(caption), renderLegend(legend)), props.uploadDate && (/*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name: props.label,
        thumbnailUrl: convertToWebP(props.thumbnailUrl),
        contentUrl: props.src,
        uploadDate: props.uploadDate,
        embedUrl: props.src
      })
    }
  })));
};

var ModuleImageHeight;
(function (ModuleImageHeight) {
  ModuleImageHeight["LARGE"] = "large";
  ModuleImageHeight["MEDIUM"] = "medium";
  ModuleImageHeight["SMALL"] = "small";
})(ModuleImageHeight || (ModuleImageHeight = {}));
var getImageHeightFromAspectRatio = function getImageHeightFromAspectRatio(_ref) {
  var imageHeight = _ref.imageHeight,
    assetRatio = _ref.assetRatio;
  switch (assetRatio) {
    case ModuleImageHeight.SMALL:
      return imageHeight[0];
    case ModuleImageHeight.MEDIUM:
      return imageHeight[1];
    case ModuleImageHeight.LARGE:
    default:
      return imageHeight[2];
  }
};

var PageIntroAsset = function PageIntroAsset(_ref) {
  var video = _ref.video,
    alt_text = _ref.alt_text,
    image = _ref.image,
    copyright = _ref.copyright,
    fallback_image = _ref.fallback_image,
    assetRatio = _ref.assetRatio,
    _ref$background_on_im = _ref.background_on_image,
    background_on_image = _ref$background_on_im === void 0 ? false : _ref$background_on_im,
    link_on_image = _ref.link_on_image,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    contentOnImageWidth = _ref.contentOnImageWidth,
    text_on_image = _ref.text_on_image,
    _ref$display_h1_on_im = _ref.display_h1_on_image,
    display_h1_on_image = _ref$display_h1_on_im === void 0 ? false : _ref$display_h1_on_im,
    _ref$display_h2_on_im = _ref.display_h2_on_image,
    display_h2_on_image = _ref$display_h2_on_im === void 0 ? false : _ref$display_h2_on_im,
    headline = _ref.headline,
    subline = _ref.subline,
    variantH1 = _ref.variantH1,
    variantH2 = _ref.variantH2,
    component = _ref.component,
    iframe_link = _ref.iframe_link,
    RoundedCorners = _ref.RoundedCorners,
    Shadow = _ref.Shadow,
    local_image = _ref.local_image;
  if (video) {
    return /*#__PURE__*/React.createElement(MoodVideo, {
      video: video,
      fallback_image: fallback_image,
      assetRatio: assetRatio
    });
  }
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(PageIntroImage, {
    alt_text: alt_text,
    image: image,
    assetRatio: assetRatio,
    copyright: copyright,
    background_on_image: background_on_image,
    link_on_image: link_on_image,
    onOrangeBackground: onOrangeBackground,
    contentOnImageWidth: contentOnImageWidth,
    display_h1_on_image: display_h1_on_image,
    display_h2_on_image: display_h2_on_image,
    text_on_image: text_on_image,
    headline: headline,
    subline: subline,
    variantH1: variantH1,
    variantH2: variantH2,
    component: component,
    iframe_link: iframe_link,
    RoundedCorners: RoundedCorners,
    Shadow: Shadow,
    local_image: local_image
  })));
};
var PageIntroImage = function PageIntroImage(_ref2) {
  var image = _ref2.image,
    alt_text = _ref2.alt_text,
    copyright = _ref2.copyright,
    assetRatio = _ref2.assetRatio,
    _ref2$background_on_i = _ref2.background_on_image,
    background_on_image = _ref2$background_on_i === void 0 ? false : _ref2$background_on_i,
    link_on_image = _ref2.link_on_image,
    _ref2$onOrangeBackgro = _ref2.onOrangeBackground,
    onOrangeBackground = _ref2$onOrangeBackgro === void 0 ? false : _ref2$onOrangeBackgro,
    _ref2$display_h1_on_i = _ref2.display_h1_on_image,
    display_h1_on_image = _ref2$display_h1_on_i === void 0 ? false : _ref2$display_h1_on_i,
    _ref2$display_h2_on_i = _ref2.display_h2_on_image,
    display_h2_on_image = _ref2$display_h2_on_i === void 0 ? false : _ref2$display_h2_on_i,
    _ref2$contentOnImageW = _ref2.contentOnImageWidth,
    contentOnImageWidth = _ref2$contentOnImageW === void 0 ? ContentOnImageWidthProps.SEVENTY_PERCENT : _ref2$contentOnImageW,
    text_on_image = _ref2.text_on_image,
    headline = _ref2.headline,
    subline = _ref2.subline,
    variantH1 = _ref2.variantH1,
    variantH2 = _ref2.variantH2,
    component = _ref2.component,
    iframe_link = _ref2.iframe_link,
    RoundedCorners = _ref2.RoundedCorners,
    Shadow = _ref2.Shadow,
    local_image = _ref2.local_image;
  var _a, _b, _c, _d, _e, _f, _g;
  var showOnMobile = false;
  var isPageIntroHomepageComponent = false;
  if (component) {
    isPageIntroHomepageComponent = isPageIntroHomepage(component);
  }
  var imageSrc = generateImageSrc(((_a = local_image === null || local_image === void 0 ? void 0 : local_image[0]) === null || _a === void 0 ? void 0 : _a.local_image) || image);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(chainConditionalClassnames(css$15.pageIntro__image_wrapper, conditionalClassname(assetRatio === PageIntroImageHeight.LARGE, css$15.pageIntro__image_large), conditionalClassname(assetRatio === PageIntroImageHeight.MEDIUM, css$15.pageIntro__image_medium), conditionalClassname(assetRatio === PageIntroImageHeight.SMALL, css$15.pageIntro__image_small)))
  }, image && (/*#__PURE__*/React.createElement(Image, {
    src: imageSrc,
    imageSizes: sizes$1[assetRatio || 'large'],
    alt: alt_text,
    className: css$15.pageIntro__image,
    copyrightText: copyright,
    priority: true,
    sizes: "(max-width: 344px) 33vw, (max-width: 719px) 50vw, (max-width: 939px) 70vw, 1200px",
    RoundedCorners: RoundedCorners,
    Shadow: Shadow
  })), iframe_link && (/*#__PURE__*/React.createElement("iframe", {
    className: css$15.iframe,
    src: iframe_link,
    title: iframe_link
  })), !useDeviceStatus(showOnMobile) && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(css$15.text__on__image__background, " ").concat(background_on_image ? css$15.text__background : css$15.text__on__background, " ").concat(chainConditionalClassnames(conditionalClassname(contentOnImageWidth === ContentOnImageWidthProps.FIFTY_PERCENT, css$15.text_on_image_background__fifty_percent), conditionalClassname(contentOnImageWidth === ContentOnImageWidthProps.SIXTY_PERCENT, css$15.text_on_image_background__sixty_percent), conditionalClassname(contentOnImageWidth === ContentOnImageWidthProps.SEVENTY_PERCENT, css$15.text_on_image_background__seventy_percent), conditionalClassname(contentOnImageWidth === ContentOnImageWidthProps.EIGHTY_PERCENT, css$15.text_on_image_background__eighty_percent)), " ").concat(text_on_image && ((_b = text_on_image[0]) === null || _b === void 0 ? void 0 : _b.font_size) ? css$15.headlineTwo : css$15.headlineOne)
  }, text_on_image && hasTextContent((_c = text_on_image[0]) === null || _c === void 0 ? void 0 : _c.text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps((_e = (_d = text_on_image[0]) === null || _d === void 0 ? void 0 : _d.text) === null || _e === void 0 ? void 0 : _e.content)
  })), display_h1_on_image && headline && text_on_image && !hasTextContent((_f = text_on_image[0]) === null || _f === void 0 ? void 0 : _f.text) && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H1,
    variant: variantH1,
    className: "".concat(conditionalClassname(isPageIntroHomepageComponent, css$15.pageIntroHomepage__headlineOne))
  }, headline)), display_h2_on_image && subline && text_on_image && !hasTextContent((_g = text_on_image[0]) === null || _g === void 0 ? void 0 : _g.text) && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H2,
    variant: variantH2
  }, subline)), link_on_image && (link_on_image === null || link_on_image === void 0 ? void 0 : link_on_image.length) > 0 && (link_on_image === null || link_on_image === void 0 ? void 0 : link_on_image.map(function (linkElement) {
    return /*#__PURE__*/React.createElement("div", {
      key: linkElement._uid,
      className: css$15.link__on__image
    }, /*#__PURE__*/React.createElement(RenderButtonType, {
      linkType: linkElement,
      onOrangeBackground: onOrangeBackground
    }));
  })))));
};
var MoodVideo = function MoodVideo(_ref3) {
  var video = _ref3.video,
    fallback_image = _ref3.fallback_image,
    imageHeight = _ref3.imageHeight,
    assetRatio = _ref3.assetRatio;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  var videoProps = ((_b = (_a = video === null || video === void 0 ? void 0 : video[0]) === null || _a === void 0 ? void 0 : _a.local_video) === null || _b === void 0 ? void 0 : _b[0]) || (video === null || video === void 0 ? void 0 : video[0]);
  var fallbackImage = fallback_image && fallback_image[0];
  var localFallbackImage = (_d = (_c = fallback_image === null || fallback_image === void 0 ? void 0 : fallback_image[0]) === null || _c === void 0 ? void 0 : _c.local_image) === null || _d === void 0 ? void 0 : _d[0];
  var fallbackProps = {
    imageHeight: "".concat(imageHeight),
    className: "".concat(css$15.pageIntro__video_wrapper),
    image: (localFallbackImage === null || localFallbackImage === void 0 ? void 0 : localFallbackImage.local_image) || (fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.image),
    assetRatio: assetRatio,
    alt_text: fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.alt_text,
    copyright: fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.copyright
  };
  imageHeight = getImageHeightFromAspectRatio({
    imageHeight: [234, 293, 390],
    assetRatio: assetRatio
  });
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    className: css$15.pageIntro__video_wrapper
  }, /*#__PURE__*/React.createElement(Videos, {
    preload: "metadata",
    height: "".concat(imageHeight),
    width: "100%",
    autoplay: true,
    muted: true,
    thumbnailUrl: (_f = (_e = videoProps === null || videoProps === void 0 ? void 0 : videoProps.video) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.thumbnail_link,
    src: "".concat((videoProps === null || videoProps === void 0 ? void 0 : videoProps.video) ? (_h = (_g = videoProps === null || videoProps === void 0 ? void 0 : videoProps.video) === null || _g === void 0 ? void 0 : _g.item) === null || _h === void 0 ? void 0 : _h.embed_link : (_k = (_j = videoProps === null || videoProps === void 0 ? void 0 : videoProps.video) === null || _j === void 0 ? void 0 : _j.item) === null || _k === void 0 ? void 0 : _k.thumbnail_link),
    background: (_l = videoProps === null || videoProps === void 0 ? void 0 : videoProps.video) === null || _l === void 0 ? void 0 : _l.color,
    controlsList: "nodownload"
  }, fallbackImage && /*#__PURE__*/React.createElement(VideoFallback, Object.assign({}, fallbackProps)))), /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    className: css$15.pageIntro_video_fallback
  }, fallbackImage && /*#__PURE__*/React.createElement(PageIntroImage, Object.assign({}, fallbackProps))));
};

var css$13 = {"link":"Link_v2-module_link__mYtww","linkSm":"Link_v2-module_linkSm__wtAMw","linkMd":"Link_v2-module_linkMd__zoUd0","btn_primary":"Link_v2-module_btn_primary__B8hvZ","btn_secondary":"Link_v2-module_btn_secondary__uLiO-","btn_tertiary":"Link_v2-module_btn_tertiary__lnoke","hasIcon":"Link_v2-module_hasIcon__jv5K6","primary":"Link_v2-module_primary__EW-NC","secondary":"Link_v2-module_secondary__yBLiO","modeLight":"Link_v2-module_modeLight__Epqi4","modeDark":"Link_v2-module_modeDark__i2Z-f"};

function toPrimitive(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

var linkSize = {
  md: css$13.linkMd,
  sm: css$13.linkSm
};
var linkMode = {
  dark: css$13.modeDark,
  light: css$13.modeLight
};
var linkVariant = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LinkVariant.Primary, css$13.primary), LinkVariant.Secondary, css$13.secondary), LinkVariant.Tertiary, ''), LinkVariant.Button, css$13.btn_primary), LinkVariant.ButtonSecondary, css$13.btn_secondary), LinkVariant.ButtonTertiary, css$13.btn_tertiary), LinkVariant.ButtonThemingColor1, ''), LinkVariant.ButtonThemingColor2, ''), LinkVariant.ButtonTransparent, '');
var isTextLink = function isTextLink(variant) {
  return [LinkVariant.Primary, LinkVariant.Secondary].includes(variant);
};

var RightArrowIcon = function RightArrowIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4792 10.8333H3.33337V9.16666H13.4792L8.81254 4.49999L10 3.33333L16.6667 9.99999L10 16.6667L8.81254 15.5L13.4792 10.8333Z"
  }));
};

var ExternalLinkIcon = function ExternalLinkIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 15.8333H4.16667V4.16667H10V2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10H15.8333V15.8333ZM11.6667 2.5V4.16667H14.6583L6.46667 12.3583L7.64167 13.5333L15.8333 5.34167V8.33333H17.5V2.5H11.6667Z"
  }));
};
var ExternalLink = function ExternalLink(_a) {
  var href = _a.href,
    target = _a.target,
    children = _a.children,
    className = _a.className,
    disabled = _a.disabled,
    icon = _a.icon,
    piwik_click_id = _a.piwik_click_id,
    onMouseEnterEvent = _a.onMouseEnterEvent,
    onClickHandler = _a.onClickHandler,
    rel = _a.rel,
    _a$onCountrySwitch = _a.onCountrySwitch,
    onCountrySwitch = _a$onCountrySwitch === void 0 ? null : _a$onCountrySwitch,
    contact_type = _a.contact_type,
    props = __rest(_a, ["href", "target", "children", "className", "disabled", "icon", "piwik_click_id", "onMouseEnterEvent", "onClickHandler", "rel", "onCountrySwitch", "contact_type"]);
  var isEmail = isValidEmail(href);
  var igusDomain = isIgusDomain(href);
  var formattedContactHref = formatContactText(contact_type, href || '');
  var router = routerExports.useRouter();
  var localePrefix = getLocalePrefix(router === null || router === void 0 ? void 0 : router.locale);
  var formattedHref = formatLocaleHref(href, localePrefix, igusDomain, onCountrySwitch);
  return /*#__PURE__*/React.createElement("a", Object.assign({
    onMouseEnter: onMouseEnterEvent,
    onClick: function onClick() {
      return onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
    },
    rel: rel,
    href: isEmail || typeof contact_type === 'string' && contact_type.trim() !== '' && contact_type !== LinkType.Url ? formattedContactHref : formattedHref,
    target: target,
    "data-piwik-click-id": piwik_click_id || undefined,
    "aria-disabled": disabled,
    className: className
  }, props), children, icon && /*#__PURE__*/React.createElement(ExternalLinkIcon, null));
};
var InternalLink = function InternalLink(_a) {
  var href = _a.href,
    children = _a.children,
    disabled = _a.disabled,
    icon = _a.icon,
    className = _a.className,
    download = _a.download,
    onMouseEnterEvent = _a.onMouseEnterEvent,
    formatLink$1 = _a.formatLink,
    onClickHandler = _a.onClickHandler,
    anchor = _a.anchor,
    props = __rest(_a, ["href", "children", "disabled", "icon", "className", "download", "onMouseEnterEvent", "formatLink", "onClickHandler", "anchor"]);
  var router = routerExports.useRouter();
  var localePrefix = getLocalePrefix(router === null || router === void 0 ? void 0 : router.locale);
  var formatLinkFunc = formatLink$1 || formatLink;
  return /*#__PURE__*/React.createElement(Link$1, Object.assign({
    onMouseEnter: onMouseEnterEvent,
    onClick: function onClick() {
      return onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
    },
    href: !download ? formatLinkFunc("".concat(!anchor ? href : "".concat(href, "#").concat(mapUmlaut(anchor))), router === null || router === void 0 ? void 0 : router.asPath) : href,
    prefetch: false,
    className: className,
    "aria-disabled": disabled,
    locale: localePrefix || false,
    target: !download ? '_self' : '_blank'
  }, props), children, icon && /*#__PURE__*/React.createElement(RightArrowIcon, null));
};
var Link_v2 = function Link_v2(_a) {
  var href = _a.href,
    children = _a.children,
    icon = _a.icon,
    _a$iconPosition = _a.iconPosition,
    iconPosition = _a$iconPosition === void 0 ? IconPosition.After : _a$iconPosition,
    disabled = _a.disabled,
    variant = _a.variant,
    mode = _a.mode,
    _a$size = _a.size,
    size = _a$size === void 0 ? 'md' : _a$size,
    external = _a.external,
    className = _a.className,
    target = _a.target,
    onMouseEnterEvent = _a.onMouseEnterEvent,
    props = __rest(_a, ["href", "children", "icon", "iconPosition", "disabled", "variant", "mode", "size", "external", "className", "target", "onMouseEnterEvent"]);
  var isButtonVariant = variant.startsWith('button');
  var constructedClassName = chainConditionalClassnames(css$13.link, linkVariant[variant], className !== null && className !== void 0 ? className : '', conditionalClassname(Boolean(size) && isButtonVariant, linkSize[size]), conditionalClassname(Boolean(mode), linkMode[mode]), conditionalClassname(Boolean(icon), css$13.hasIcon));
  var emptyLink = external ? true : formatLink(href) === '';
  if (external || emptyLink) {
    return /*#__PURE__*/React.createElement(ExternalLink, Object.assign({
      onMouseEnterEvent: onMouseEnterEvent,
      target: target,
      className: constructedClassName,
      href: href,
      children: children,
      disabled: disabled,
      icon: icon,
      iconPosition: iconPosition
    }, props));
  }
  return /*#__PURE__*/React.createElement(InternalLink, Object.assign({
    onMouseEnterEvent: onMouseEnterEvent,
    className: constructedClassName,
    href: href,
    children: children,
    disabled: disabled,
    icon: icon,
    iconPosition: iconPosition
  }, props));
};

var RenderButtonType = function RenderButtonType(_ref) {
  var linkType = _ref.linkType,
    className = _ref.className,
    wrapperClassName = _ref.wrapperClassName,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    _ref$prefetch = _ref.prefetch,
    prefetch = _ref$prefetch === void 0 ? false : _ref$prefetch,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? ComponentVersion.v1 : _ref$version;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  if ((linkType === null || linkType === void 0 ? void 0 : linkType.component) === 'download') {
    return /*#__PURE__*/React.createElement(DownloadLink, Object.assign({
      className: className,
      key: linkType._uid,
      icon: linkType.icon,
      name: linkType.name,
      title: linkType.title,
      display_titles: true,
      assetLink: (_c = (_b = (_a = linkType.local_asset) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.embed_link) !== null && _c !== void 0 ? _c : (_e = (_d = linkType.asset) === null || _d === void 0 ? void 0 : _d.item) === null || _e === void 0 ? void 0 : _e.embed_link,
      onOrangeBackground: onOrangeBackground
    }, linkType.rel_nofollow && {
      relNofollow: linkType.rel_nofollow
    }));
  }
  if ((linkType === null || linkType === void 0 ? void 0 : linkType.component) === 'download_teaser') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (_f = linkType.download) === null || _f === void 0 ? void 0 : _f.map(function (download) {
      var _a, _b;
      return /*#__PURE__*/React.createElement(DownloadLink, Object.assign({
        key: linkType._uid,
        className: className,
        icon: download === null || download === void 0 ? void 0 : download.icon,
        name: download === null || download === void 0 ? void 0 : download.name,
        title: download === null || download === void 0 ? void 0 : download.title,
        display_titles: true,
        assetLink: (_b = (_a = download.asset) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.embed_link,
        onOrangeBackground: onOrangeBackground
      }, linkType.rel_nofollow && {
        relNofollow: linkType.rel_nofollow
      }));
    }));
  }
  var _linkPropsMapper = linkPropsMapper(linkType),
    children = _linkPropsMapper.children,
    title = _linkPropsMapper.title,
    variant = _linkPropsMapper.variant,
    external = _linkPropsMapper.external,
    href = _linkPropsMapper.href,
    target = _linkPropsMapper.target,
    icon = _linkPropsMapper.icon,
    piwik_click_id = _linkPropsMapper.piwik_click_id,
    anchor = _linkPropsMapper.anchor;
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(css$15.pageIntro__link__wrapper, " ").concat(conditionalClassname(!!wrapperClassName, wrapperClassName))
  }, showIcon && isPreferredVersion(ComponentVersion.v1, version) && (variant === LinkVariant.Primary || variant === LinkVariant.Secondary || variant === LinkVariant.Tertiary) && (/*#__PURE__*/React.createElement(LinkIcon, {
    variant: variant,
    onOrangeBackground: onOrangeBackground
  })), isPreferredVersion(ComponentVersion.v1, version) ? (/*#__PURE__*/React.createElement(Link, Object.assign({
    className: className,
    key: linkType._uid,
    variant: onOrangeBackground ? determineVariant(variant) : variant,
    external: ((_g = linkType.link) === null || _g === void 0 ? void 0 : _g.linktype) === ContactType.Email || external,
    href: href && href || '#',
    target: target,
    icon: icon,
    title: title,
    onOrangeBackground: onOrangeBackground,
    piwik_click_id: piwik_click_id,
    anchor: anchor,
    contact_type: determineContactType((_h = linkType.link) === null || _h === void 0 ? void 0 : _h.url, (_j = linkType.link) === null || _j === void 0 ? void 0 : _j.linktype)
  }, ((_k = linkType.link) === null || _k === void 0 ? void 0 : _k.rel) && {
    rel: (_l = linkType.link) === null || _l === void 0 ? void 0 : _l.rel
  }, prefetch && {
    prefetch: prefetch
  }), children)) : (/*#__PURE__*/React.createElement(Link_v2, Object.assign({
    className: className,
    key: linkType._uid,
    variant: variant,
    external: ((_m = linkType.link) === null || _m === void 0 ? void 0 : _m.linktype) === ContactType.Email || external,
    href: href && href || '#',
    target: target,
    icon: true,
    mode: "light",
    piwik_click_id: piwik_click_id,
    anchor: anchor,
    contact_type: determineContactType((_o = linkType.link) === null || _o === void 0 ? void 0 : _o.url, (_p = linkType.link) === null || _p === void 0 ? void 0 : _p.linktype)
  }, ((_q = linkType.link) === null || _q === void 0 ? void 0 : _q.rel) && {
    rel: (_r = linkType.link) === null || _r === void 0 ? void 0 : _r.rel
  }, prefetch && {
    prefetch: prefetch
  }), children)));
};
var PageIntro = function PageIntro(_ref2) {
  var image = _ref2.image,
    button = _ref2.button,
    text = _ref2.text,
    headline = _ref2.headline,
    subline = _ref2.subline,
    separator = _ref2.separator,
    style = _ref2.style,
    _ref2$onOrangeBackgro = _ref2.onOrangeBackground,
    onOrangeBackground = _ref2$onOrangeBackgro === void 0 ? false : _ref2$onOrangeBackgro,
    asset_ratio = _ref2.asset_ratio,
    _ref2$background_on_i = _ref2.background_on_image,
    background_on_image = _ref2$background_on_i === void 0 ? false : _ref2$background_on_i,
    link_on_image = _ref2.link_on_image,
    _ref2$spacing = _ref2.spacing,
    spacing = _ref2$spacing === void 0 ? false : _ref2$spacing,
    content_on_image_width = _ref2.content_on_image_width,
    display_h1_on_image = _ref2.display_h1_on_image,
    display_h2_on_image = _ref2.display_h2_on_image,
    text_on_image = _ref2.text_on_image,
    variant_h1 = _ref2.variant_h1,
    variant_h2 = _ref2.variant_h2,
    component = _ref2.component;
  var _a;
  var isImageAsset = image && image.length > 0 && ((_a = image[0]) === null || _a === void 0 ? void 0 : _a.component) === 'image_atom';
  var isPageIntroHomepageComponent = false;
  if (component) {
    isPageIntroHomepageComponent = isPageIntroHomepage(component);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator,
    spacingWithoutSeparator: !separator,
    className: "".concat(onOrangeBackground ? css$15.pageIntro__wrapper : '', " ").concat(css$15.default__spacing, " ").concat(conditionalClassname(spacing, css$15.spacing)),
    style: style
  }, image && image.length > 0 && (/*#__PURE__*/React.createElement(PageIntroAsset, Object.assign({}, image[0], {
    background_on_image: background_on_image,
    display_h1_on_image: display_h1_on_image,
    display_h2_on_image: display_h2_on_image,
    link_on_image: link_on_image,
    headline: headline,
    subline: subline,
    assetRatio: asset_ratio,
    onOrangeBackground: onOrangeBackground,
    contentOnImageWidth: content_on_image_width,
    text_on_image: text_on_image,
    variantH1: variant_h1,
    variantH2: variant_h2,
    component: component
  }))), useDeviceStatus(!display_h1_on_image) && headline && (/*#__PURE__*/React.createElement(Row, {
    className: "".concat(conditionalClassname(display_h1_on_image && isImageAsset, css$15.hide__header__below__image))
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H1,
    variant: variant_h1,
    className: "".concat(conditionalClassname(isPageIntroHomepageComponent, css$15.pageIntroHomepage__headlineOne))
  }, headline)))), useDeviceStatus(!display_h2_on_image) && subline && (/*#__PURE__*/React.createElement(Row, {
    className: "".concat(conditionalClassname(display_h2_on_image && isImageAsset, css$15.hide__header__below__image))
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H2,
    exclude_from_toc: true,
    variant: variant_h2
  }, subline)))), hasTextContent(text) && (/*#__PURE__*/React.createElement("div", {
    className: css$15.pageIntro__text_wrapper
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  }))), link_on_image && (link_on_image === null || link_on_image === void 0 ? void 0 : link_on_image.length) > 0 && (link_on_image === null || link_on_image === void 0 ? void 0 : link_on_image.map(function (linkElement) {
    return /*#__PURE__*/React.createElement("div", {
      key: linkElement._uid,
      className: css$15.hide__link__on__image
    }, /*#__PURE__*/React.createElement(RenderButtonType, {
      key: linkElement._uid,
      linkType: linkElement,
      onOrangeBackground: onOrangeBackground
    }));
  })), button && (button === null || button === void 0 ? void 0 : button.length) > 0 && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: css$15.pageIntro__button_wrapper
  }, button === null || button === void 0 ? void 0 : button.map(function (linkElement) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      key: linkElement._uid,
      linkType: linkElement,
      onOrangeBackground: onOrangeBackground
    });
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator,
    className: conditionalClassname(spacing, css$15.spacing)
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$12 = {"benefits__wrapper":"Benefits-module_benefits__wrapper__ar5PI","two__column__download__link__wrapper":"Benefits-module_two__column__download__link__wrapper__mgw-c","two__column__benefits__wrapper":"Benefits-module_two__column__benefits__wrapper__vL4DV","two__column__benefits__list__wrapper":"Benefits-module_two__column__benefits__list__wrapper__bcvTf","benefits__list__wrapper":"Benefits-module_benefits__list__wrapper__PxGJ0","benefits__download__wrapper":"Benefits-module_benefits__download__wrapper__7ynR2","benefits__icon__wrapper":"Benefits-module_benefits__icon__wrapper__CBR5K","benefits__on__orange":"Benefits-module_benefits__on__orange__UfQo-","benefits__themed_color1":"Benefits-module_benefits__themed_color1__6XK9h","benefits__themed_color2":"Benefits-module_benefits__themed_color2__Gny9l","benefits__link":"Benefits-module_benefits__link__6nh5Y","benefits__button_link":"Benefits-module_benefits__button_link__KkCpN"};

var CheckOrange = function CheckOrange(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "24",
    height: "28",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13757_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59081 15.6237L4.79775 11.8306L3.5061 13.1131L8.59081 18.1978L19.5061 7.28255L18.2236 6L8.59081 15.6237Z",
    fill: "#F07D00"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13757_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var CheckGrey = function CheckGrey() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "28",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13757_549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59081 17.6237L4.79775 13.8306L3.5061 15.1131L8.59081 20.1978L19.5061 9.28255L18.2236 8L8.59081 17.6237Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13757_549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0 2)"
  }))));
};
var ArrowOrange = function ArrowOrange(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "24",
    height: "28",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13757_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6L10.59 7.41L16.17 13H4V15H16.17L10.59 20.59L12 22L20 14L12 6Z",
    fill: "#F07D00"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13757_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0 2)"
  }))));
};
var ArrowGrey = function ArrowGrey() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "28",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13757_497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6L10.59 7.41L16.17 13H4V15H16.17L10.59 20.59L12 22L20 14L12 6Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13757_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0 2)"
  }))));
};
var SquareOrange = function SquareOrange(_ref3) {
  var className = _ref3.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "24",
    height: "28",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13757_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6H4V22H20V6Z",
    fill: "#F07D00"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13757_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0 2)"
  }))));
};
var SquareGrey = function SquareGrey() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "28",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13757_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6H4V22H20V6Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13757_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0 2)"
  }))));
};

var BenefitsListIcons;
(function (BenefitsListIcons) {
  BenefitsListIcons["CHECKORANGE"] = "checkmark_orange";
  BenefitsListIcons["CHECKGREY"] = "checkmark_grey";
  BenefitsListIcons["ARROWORANGE"] = "arrow_orange";
  BenefitsListIcons["ARROWGREY"] = "arrow_grey";
  BenefitsListIcons["SQUAREORANGE"] = "square_orange";
  BenefitsListIcons["SQUAREGREY"] = "square_grey";
  BenefitsListIcons["CHECKPINK"] = "checkmark_theming_color_1";
  BenefitsListIcons["CHECKPURPLE"] = "checkmark_theming_color_2";
  BenefitsListIcons["ARROWPINK"] = "arrow_theming_color_1";
  BenefitsListIcons["ARROWPURPLE"] = "arrow_theming_color_2";
  BenefitsListIcons["SQUAREPINK"] = "square_theming_color_1";
  BenefitsListIcons["SQUAREPURPLE"] = "square_theming_color_2";
})(BenefitsListIcons || (BenefitsListIcons = {}));

var setBenefitIcon = function setBenefitIcon(icon) {
  switch (icon) {
    case BenefitsListIcons.ARROWGREY:
      return /*#__PURE__*/React.createElement(ArrowGrey, null);
    case BenefitsListIcons.ARROWORANGE:
      return /*#__PURE__*/React.createElement(ArrowOrange, null);
    case BenefitsListIcons.CHECKGREY:
      return /*#__PURE__*/React.createElement(CheckGrey, null);
    case BenefitsListIcons.SQUAREGREY:
      return /*#__PURE__*/React.createElement(SquareGrey, null);
    case BenefitsListIcons.SQUAREORANGE:
      return /*#__PURE__*/React.createElement(SquareOrange, null);
    case BenefitsListIcons.CHECKPINK:
      return /*#__PURE__*/React.createElement(CheckOrange, {
        className: css$12.benefits__themed_color1
      });
    case BenefitsListIcons.CHECKPURPLE:
      return /*#__PURE__*/React.createElement(CheckOrange, {
        className: css$12.benefits__themed_color2
      });
    case BenefitsListIcons.ARROWPINK:
      return /*#__PURE__*/React.createElement(ArrowOrange, {
        className: css$12.benefits__themed_color1
      });
    case BenefitsListIcons.ARROWPURPLE:
      return /*#__PURE__*/React.createElement(ArrowOrange, {
        className: css$12.benefits__themed_color2
      });
    case BenefitsListIcons.SQUAREPINK:
      return /*#__PURE__*/React.createElement(SquareOrange, {
        className: css$12.benefits__themed_color1
      });
    case BenefitsListIcons.SQUAREPURPLE:
      return /*#__PURE__*/React.createElement(SquareOrange, {
        className: css$12.benefits__themed_color2
      });
    default:
      return /*#__PURE__*/React.createElement(CheckOrange, null);
  }
};

var Benefits = function Benefits(_ref) {
  var icon = _ref.icon,
    text = _ref.text,
    download = _ref.download,
    list_item = _ref.list_item,
    link = _ref.link,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? false : _ref$view;
  return /*#__PURE__*/React.createElement(Container, {
    className: onOrangeBackground ? css$12.benefits__on__orange : '',
    spacingWithoutSeparator: true
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, !!list_item.length && (/*#__PURE__*/React.createElement("ul", {
    className: chainConditionalClassnames(css$12.benefits__wrapper, view ? css$12.two__column__benefits__wrapper : '')
  }, list_item.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: chainConditionalClassnames(view ? css$12.two__column__benefits__list__wrapper : css$12.benefits__list__wrapper),
      key: item._uid
    }, /*#__PURE__*/React.createElement("span", {
      className: css$12.benefits__icon__wrapper
    }, setBenefitIcon(icon)), hasTextContent(item === null || item === void 0 ? void 0 : item.list_item) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
      content: mappedProps(item === null || item === void 0 ? void 0 : item.list_item.content)
    })));
  }))), /*#__PURE__*/React.createElement("div", {
    className: conditionalClassname(view, "".concat(css$12.two__column__download__link__wrapper))
  }, !!download.length && download.map(function (_ref2) {
    var icon = _ref2.icon,
      name = _ref2.name,
      title = _ref2.title,
      asset = _ref2.asset,
      _uid = _ref2._uid;
    var _a;
    return /*#__PURE__*/React.createElement(DownloadLink, {
      display_titles: false,
      icon: icon,
      name: name,
      title: title,
      assetLink: (_a = asset.item) === null || _a === void 0 ? void 0 : _a.embed_link,
      key: _uid,
      className: css$12.benefits__download__wrapper,
      onOrangeBackground: onOrangeBackground
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: conditionalClassname(view, "".concat(css$12.two__column__download__link__wrapper))
  }, !!link.length && link.map(function (linkData) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      className: conditionalClassname(isButtonLink(linkData.variant), "".concat(css$12.benefits__button_link)),
      wrapperClassName: conditionalClassname(!isButtonLink(linkData.variant), "".concat(css$12.benefits__link)),
      key: linkData._uid,
      linkType: linkData,
      onOrangeBackground: onOrangeBackground
    });
  })))));
};

var css$11 = {"breadcrumb_container":"Breadcrumb-module_breadcrumb_container__t3LtK","breadcrumb_list__wrapper":"Breadcrumb-module_breadcrumb_list__wrapper__vwviM","crumb__wrapper":"Breadcrumb-module_crumb__wrapper__YaN4G","crumb":"Breadcrumb-module_crumb__ehuzf","crumb_icon":"Breadcrumb-module_crumb_icon__oWEGb","crumb__link":"Breadcrumb-module_crumb__link__uI5fG","fallback_crumb":"Breadcrumb-module_fallback_crumb__4pQSx","crumb_button":"Breadcrumb-module_crumb_button__p1ilT"};

var BreadcrumbLink = function BreadcrumbLink(_ref) {
  var name = _ref.name,
    slug = _ref.slug;
  return /*#__PURE__*/React.createElement("li", {
    className: css$11.crumb__wrapper
  }, /*#__PURE__*/React.createElement(Link, {
    href: slug,
    target: TargetValues.Self,
    variant: LinkVariant.Secondary,
    className: chainConditionalClassnames(css$11.crumb, css$11.crumb__link),
    title: name,
    external: false
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkIcon, {
    className: css$11.crumb_icon
  }), name)));
};
var TrailingCrumbs = function TrailingCrumbs(_ref2) {
  var links = _ref2.links,
    locale = _ref2.locale;
  return /*#__PURE__*/React.createElement(React.Fragment, null, links === null || links === void 0 ? void 0 : links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(BreadcrumbLink, Object.assign({
      key: "".concat(link.name, "-").concat(index)
    }, link, {
      locale: locale
    }));
  }));
};
var BreadcrumbJsonLd = function BreadcrumbJsonLd(_ref3) {
  var jsonLdSchema = _ref3.jsonLdSchema;
  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(jsonLdSchema)
    }
  });
};

var breadcrumbJsonLdMapper = function breadcrumbJsonLdMapper(links, domain) {
  return links === null || links === void 0 ? void 0 : links.map(function (link, index) {
    var isLastLink = index === (links === null || links === void 0 ? void 0 : links.length) - 1;
    var slug = link.slug;
    if (slug === null || slug === void 0 ? void 0 : slug.endsWith('/')) {
      slug = slug.slice(0, -1);
    }
    if (index === 0) {
      return {
        '@type': 'ListItem',
        position: ++index,
        item: Object.assign(Object.assign({}, isLastLink ? {} : {
          '@id': "https://".concat(domain)
        }), {
          name: "".concat(link.name)
        })
      };
    }
    return {
      '@type': 'ListItem',
      position: ++index,
      item: Object.assign(Object.assign({}, isLastLink ? {} : {
        '@id': "https://".concat(domain).concat(slug)
      }), {
        name: "".concat(link.name)
      })
    };
  });
};
var crumbTextCount = function crumbTextCount(links) {
  return links.map(function (link) {
    return link.name;
  }).toString().length;
};
var processLinksForJson = function processLinksForJson(links) {
  if (!links) return [];
  return links.map(function (link) {
    return Object.assign(Object.assign({}, link), {
      slug: formatLink(link.slug)
    });
  });
};
var isFallbackPage = function isFallbackPage(locale, slug) {
  var domain = slug === null || slug === void 0 ? void 0 : slug.split('/')[0];
  return (domain === null || domain === void 0 ? void 0 : domain.toLowerCase()) === (locale === null || locale === void 0 ? void 0 : locale.toLowerCase());
};
// Returns the localized homepage breadcrumb name for a given locale and suffix table
function getHomepageBreadcrumbName(homepageName, htmlTitleSuffix, locale) {
  var _a;
  var suffix = (_a = htmlTitleSuffix === null || htmlTitleSuffix === void 0 ? void 0 : htmlTitleSuffix[(locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) || '']) === null || _a === void 0 ? void 0 : _a.trim();
  return suffix ? "".concat(homepageName, " ").concat(suffix) : homepageName;
}

var Breadcrumb = function Breadcrumb(_ref) {
  var links = _ref.links,
    domain = _ref.domain,
    className = _ref.className,
    storySlug = _ref.storySlug,
    locale = _ref.locale,
    htmlTitleSuffix = _ref.htmlTitleSuffix;
  var isFallback = isFallbackPage(locale, storySlug);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var crumbTextLength = crumbTextCount(links);
  var disableToggle = crumbTextLength > 180;
  var homepageName = formatMessage({
    id: 'HOMEPAGE_NAME'
  });
  var homeLink = Object.assign(Object.assign({}, links[0]), {
    name: getHomepageBreadcrumbName(homepageName, htmlTitleSuffix, locale),
    slug: '/'
  });
  var currentLink = links[links.length - 1];
  var trailingLinks = links.slice(1, -1);
  var jsonLdLinks = processLinksForJson(links.slice(1));
  var hiddenLinks = links.length - 5;
  var _useState = useState(crumbTextLength > 120),
    toggle = _useState[0],
    setToggle = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbJsonLd, {
    jsonLdSchema: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbJsonLdMapper([homeLink].concat(_toConsumableArray(jsonLdLinks)), domain)
    }
  }), !!links.length && (/*#__PURE__*/React.createElement(Container, {
    noSpacing: true,
    className: chainConditionalClassnames(css$11.breadcrumb_container, conditionalClassname(Boolean(className), className))
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("ul", {
    className: css$11.breadcrumb_list__wrapper
  }, /*#__PURE__*/React.createElement(BreadcrumbLink, Object.assign({}, homeLink)), toggle ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: css$11.crumb__wrapper
  }, /*#__PURE__*/React.createElement("button", {
    disabled: disableToggle,
    onClick: function onClick() {
      return setToggle(!toggle);
    },
    className: "".concat(css$11.crumb_button)
  }, /*#__PURE__*/React.createElement(LinkIcon, null), " ...")), /*#__PURE__*/React.createElement(TrailingCrumbs, {
    locale: locale,
    links: trailingLinks.slice(hiddenLinks)
  }))) : (/*#__PURE__*/React.createElement(TrailingCrumbs, {
    locale: locale,
    links: trailingLinks
  })), /*#__PURE__*/React.createElement("li", {
    className: css$11.crumb__wrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(css$11.crumb, "  ").concat(isFallback ? '' : css$11.fallback_crumb)
  }, /*#__PURE__*/React.createElement(LinkIcon, {
    className: css$11.crumb_icon
  }), (currentLink === null || currentLink === void 0 ? void 0 : currentLink.breadcrumb_title) || (currentLink === null || currentLink === void 0 ? void 0 : currentLink.name)))))))));
};

var SelectContactView;
(function (SelectContactView) {
  SelectContactView["FIXED"] = "fix_contact";
  SelectContactView["ZIP_CODE"] = "zip_codes";
  SelectContactView["REGION"] = "regions";
})(SelectContactView || (SelectContactView = {}));

var getFallbackLocale = function getFallbackLocale(locale) {
  if (!locale) return null;
  return fallbackLang[locale] || null;
};

var QuoteIcon = function QuoteIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className ? className : '',
    width: "52",
    height: "40",
    viewBox: "0 0 52 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1445 0.730469V3.60157C45.082 5.08587 41.8984 7.42967 39.5938 10.6328C37.2891 13.7969 36.1367 17.0977 36.1367 20.5352C36.1367 21.2773 36.2539 21.8242 36.4883 22.1758C36.6445 22.4102 36.8203 22.5273 37.0156 22.5273C37.2109 22.5273 37.5039 22.3906 37.8945 22.1172C39.1445 21.2188 40.7266 20.7695 42.6406 20.7695C44.8672 20.7695 46.8398 21.6875 48.5586 23.5234C50.2773 25.3203 51.1367 27.4688 51.1367 29.9688C51.1367 32.5859 50.1406 34.8906 48.1484 36.8828C46.1953 38.875 43.8125 39.8711 41 39.8711C37.7188 39.8711 34.8867 38.5234 32.5039 35.8281C30.1211 33.1328 28.9297 29.5195 28.9297 24.9883C28.9297 19.7148 30.5508 14.9883 33.793 10.8086C37.0352 6.62887 42.1523 3.26947 49.1445 0.730469ZM20.9609 0.730469V3.60157C16.8984 5.08587 13.7148 7.42967 11.4102 10.6328C9.1055 13.7969 7.9531 17.0977 7.9531 20.5352C7.9531 21.2773 8.0703 21.8242 8.3047 22.1758C8.4609 22.4102 8.6367 22.5273 8.832 22.5273C9.0273 22.5273 9.3203 22.3906 9.7109 22.1172C10.9609 21.2188 12.543 20.7695 14.457 20.7695C16.6836 20.7695 18.6562 21.6875 20.375 23.5234C22.0938 25.3203 22.9531 27.4688 22.9531 29.9688C22.9531 32.5859 21.957 34.8906 19.9648 36.8828C18.0117 38.875 15.6289 39.8711 12.8164 39.8711C9.5352 39.8711 6.7031 38.5234 4.32031 35.8281C1.9375 33.1328 0.746094 29.5195 0.746094 24.9883C0.746094 19.7148 2.36719 14.9883 5.60938 10.8086C8.8516 6.62887 13.9688 3.26947 20.9609 0.730469Z",
    fill: "#F07D00"
  }));
};
var RectangularProfile = function RectangularProfile(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className ? className : '',
    viewBox: "0 0 286 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2815_3781)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    width: "285",
    height: "285",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 151.53C172.932 151.53 197.196 127.266 197.196 97.3335C197.196 67.4014 172.932 43.1367 143 43.1367C113.067 43.1367 88.8027 67.4014 88.8027 97.3335C88.8027 127.266 113.067 151.53 143 151.53Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 363.803C207.852 363.803 260.426 319.317 260.426 264.442C260.426 209.567 207.852 165.081 143 165.081C78.1469 165.081 25.5734 209.567 25.5734 264.442C25.5734 319.317 78.1469 363.803 143 363.803Z",
    fill: "#CECECE"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2815_3781"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    width: "285",
    height: "285",
    fill: "white"
  }))));
};
var CircularProfile = function CircularProfile(_ref3) {
  var className = _ref3.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className ? className : '',
    viewBox: "0 0 286 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_3606)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    width: "285",
    height: "285",
    rx: "142.5",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 151.53C172.932 151.53 197.196 127.266 197.196 97.3335C197.196 67.4014 172.932 43.1367 143 43.1367C113.067 43.1367 88.8027 67.4014 88.8027 97.3335C88.8027 127.266 113.067 151.53 143 151.53Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 363.803C207.852 363.803 260.426 319.317 260.426 264.442C260.426 209.567 207.852 165.081 143 165.081C78.1469 165.081 25.5734 209.567 25.5734 264.442C25.5734 319.317 78.1469 363.803 143 363.803Z",
    fill: "#CECECE"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_3606"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    width: "285",
    height: "285",
    rx: "142.5",
    fill: "white"
  }))));
};

var FaxIcon = function FaxIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26550_2213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4H8V1.5H3V8.75V9.5H10V5.5C10 4.67 9.33 4 8.5 4ZM4 2.5H7V4H4V2.5ZM6 8H4V5.5H6V8ZM7 8C6.725 8 6.5 7.775 6.5 7.5C6.5 7.225 6.725 7 7 7C7.275 7 7.5 7.225 7.5 7.5C7.5 7.775 7.275 8 7 8ZM7 6.5C6.725 6.5 6.5 6.275 6.5 6C6.5 5.725 6.725 5.5 7 5.5C7.275 5.5 7.5 5.725 7.5 6C7.5 6.275 7.275 6.5 7 6.5ZM8.5 8C8.225 8 8 7.775 8 7.5C8 7.225 8.225 7 8.5 7C8.775 7 9 7.225 9 7.5C9 7.775 8.775 8 8.5 8ZM8.5 6.5C8.225 6.5 8 6.275 8 6C8 5.725 8.225 5.5 8.5 5.5C8.775 5.5 9 5.725 9 6C9 6.275 8.775 6.5 8.5 6.5Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3.5C0.56 3.5 0 4.06 0 4.75V8.75C0 9.44 0.56 10 1.25 10C1.94 10 2.5 9.44 2.5 8.75V4.75C2.5 4.06 1.94 3.5 1.25 3.5Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26550_2213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "10",
    height: "10",
    fill: "white",
    transform: "translate(0 0.5)"
  }))));
};

var PhoneIcon = function PhoneIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6352 10.2758L11.6755 8.31973C11.5202 8.1594 11.3261 8.04168 11.112 7.9779C10.8979 7.91412 10.6709 7.90642 10.453 7.95554C10.235 8.00467 10.0334 8.10896 9.86751 8.25839C9.70164 8.40782 9.57708 8.59735 9.50585 8.80874C9.39479 9.11116 9.17735 9.36295 8.89406 9.51718C8.61077 9.67142 8.28096 9.71757 7.9661 9.64704C7.13105 9.34599 6.37281 8.86478 5.74543 8.23772C5.11805 7.61066 4.63697 6.85318 4.33648 6.01928C4.25079 5.70443 4.29034 5.36871 4.44685 5.0823C4.60337 4.79588 4.86475 4.58093 5.17635 4.48239C5.38813 4.41128 5.57801 4.28696 5.72772 4.12139C5.87743 3.95582 5.98191 3.75458 6.03113 3.53702C6.08035 3.31947 6.07263 3.09294 6.00873 2.87922C5.94483 2.66551 5.82689 2.47181 5.66627 2.31677L3.70729 0.366314C3.44924 0.13068 3.11218 0 2.76244 0C2.4127 0 2.07564 0.13068 1.81759 0.366314L0.487809 1.69363C-0.841975 3.0908 0.627787 6.78772 3.91375 10.0676C7.19972 13.3475 10.9084 14.8802 12.3068 13.483L13.6366 12.1557C13.8707 11.8983 14.0003 11.5631 14 11.2154C13.9997 10.8678 13.8697 10.5328 13.6352 10.2758Z",
    fill: "#363636"
  }));
};
var CurvedPhoneIcon = function CurvedPhoneIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.51 15.38C19.28 15.38 18.09 15.18 16.98 14.82C16.63 14.7 16.24 14.79 15.97 15.06L14.4 17.03C11.57 15.68 8.92 13.13 7.51 10.2L9.46 8.54C9.73 8.26 9.81 7.87 9.7 7.52C9.33 6.41 9.14 5.22 9.14 3.99C9.14 3.45 8.69 3 8.15 3H4.69C4.15 3 3.5 3.24 3.5 3.99C3.5 13.28 11.23 21 20.51 21C21.22 21 21.5 20.37 21.5 19.82V16.37C21.5 15.83 21.05 15.38 20.51 15.38Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0.5)"
  }))));
};

var css$10 = {"wrapper":"ContactPerson-module_wrapper__redMV","address__wrapper":"ContactPerson-module_address__wrapper__OkYl8","address":"ContactPerson-module_address__jlbM9","link":"ContactPerson-module_link__XE1Pl","separator":"ContactPerson-module_separator__JhVHB","company":"ContactPerson-module_company__RFeYL","name":"ContactPerson-module_name__YdMyV","phone__wrapper":"ContactPerson-module_phone__wrapper__VfFGC","fax":"ContactPerson-module_fax__CTifJ","phone":"ContactPerson-module_phone__qjYR6","search__text":"ContactPerson-module_search__text__MDFtT","search__input":"ContactPerson-module_search__input__imyQj","search__input__wrapper":"ContactPerson-module_search__input__wrapper__Phf2J","search__select":"ContactPerson-module_search__select__cFjGt","search__icon":"ContactPerson-module_search__icon__3vHfE","result__content__wrapper":"ContactPerson-module_result__content__wrapper__6gqIa","result__image__wrapper":"ContactPerson-module_result__image__wrapper__vRs8r","result__image":"ContactPerson-module_result__image__IarNE","result__main__wrapper":"ContactPerson-module_result__main__wrapper__QvbcA","button__link":"ContactPerson-module_button__link__Ppaar","error__text":"ContactPerson-module_error__text__tDEq2","input__error":"ContactPerson-module_input__error__l4BcT","search__input__error":"ContactPerson-module_search__input__error__mK-zA","show__results":"ContactPerson-module_show__results__iwmkh","headline":"ContactPerson-module_headline__FmJCC","contact_loader_icon":"ContactPerson-module_contact_loader_icon__tD3w7"};

var contactLocaleMap = {
  'en-de': 'de-de'
};
var fetchUtil = function fetchUtil(urlPath_1) {
  for (var _len = arguments.length, args_1 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args_1[_key - 1] = arguments[_key];
  }
  return __awaiter(void 0, [urlPath_1].concat(args_1), void 0, function (urlPath) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, errorText, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(urlPath, options);
          case 3:
            response = _context.sent;
            if (response.ok) {
              _context.next = 9;
              break;
            }
            _context.next = 7;
            return response.text();
          case 7:
            errorText = _context.sent;
            throw new Error("Fetch error: ".concat(response.status, ", message: ").concat(errorText));
          case 9:
            _context.next = 11;
            return response.json();
          case 11:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            console.error('Fetch error:', _context.t0);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 15]]);
    })();
  });
};
var getContactLocale = function getContactLocale(locale) {
  if (!locale) return '';
  return contactLocaleMap[locale.toLowerCase()] || locale.toLowerCase();
};

var useFormattedContactLinks = function useFormattedContactLinks(contactLinks, locale) {
  return useMemo(function () {
    if (!contactLinks) return [];
    return contactLinks.map(function (item) {
      var _a, _b, _c, _d;
      var rawUrl = ((_b = (_a = item.link) === null || _a === void 0 ? void 0 : _a.story) === null || _b === void 0 ? void 0 : _b.url) ? formatLink(item.link.story.url) : ((_c = item.link) === null || _c === void 0 ? void 0 : _c.url) || ((_d = item.link) === null || _d === void 0 ? void 0 : _d.cached_url) || '';
      var localePrefix = getLocalePrefix(locale || '');
      var urlWithLocalePrefix = localePrefix ? "/".concat(localePrefix).concat(rawUrl) : rawUrl;
      return Object.assign(Object.assign({}, item), {
        url: "".concat(window.location.origin).concat(urlWithLocalePrefix)
      });
    });
  }, [contactLinks, locale]);
};

var SearchRegion = function SearchRegion(_ref) {
  var formSlug = _ref.formSlug,
    onClick = _ref.onClick,
    className = _ref.className,
    id = _ref.id,
    selectLocationText = _ref.selectLocationText,
    selectPlaceholderText = _ref.selectPlaceholderText,
    noContactFoundText = _ref.noContactFoundText,
    changeLocationText = _ref.changeLocationText,
    sendMessageText = _ref.sendMessageText,
    contact_link = _ref.contact_link,
    locale = _ref.locale,
    middlewareBaseURL = _ref.middlewareBaseURL;
  var _a;
  var _useState = useState(''),
    userRegion = _useState[0],
    setUserRegion = _useState[1];
  var _useState2 = useState([]),
    allRegion = _useState2[0],
    setAllRegion = _useState2[1];
  var _useState3 = useState(false),
    showResult = _useState3[0],
    setShowResult = _useState3[1];
  var _useState4 = useState(false),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState([]),
    foundContactResult = _useState5[0],
    setFoundContactResult = _useState5[1];
  var isMounted = useRef(false);
  var urlPath = "".concat(middlewareBaseURL, "/contact/region-uuid/").concat(locale === null || locale === void 0 ? void 0 : locale.toLowerCase(), "?uuid=").concat(userRegion);
  var handleSearchRegion = function handleSearchRegion() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var foundRegionContacts;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.next = 3;
            return fetchUtil(urlPath, {
              version: 'published'
            });
          case 3:
            foundRegionContacts = _context.sent;
            setShowResult(true);
            setFoundContactResult(foundRegionContacts);
            setLoading(false);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  var handleSelectRegion = function handleSelectRegion(e) {
    setUserRegion(e.target.value);
    isMounted.current = true;
  };
  var regionUrlPath = "".concat(middlewareBaseURL, "/contact/regions/").concat(locale === null || locale === void 0 ? void 0 : locale.toLowerCase());
  var fetchRegions = function fetchRegions() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var regions;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchUtil(regionUrlPath);
          case 2:
            regions = _context2.sent;
            console.log({
              regions: regions,
              regionUrlPath: regionUrlPath
            });
            setAllRegion(regions);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
  useEffect(function () {
    if (isMounted.current) {
      handleSearchRegion();
    }
  }, [userRegion]);
  useEffect(function () {
    fetchRegions();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: className || ''
  }, /*#__PURE__*/React.createElement("div", {
    className: css$10.wrapper,
    onMouseDown: onClick,
    id: id
  }, loading ? (/*#__PURE__*/React.createElement(Loader$1, null)) : (/*#__PURE__*/React.createElement(React.Fragment, null, !showResult && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H6,
    className: css$10.headline
  }, selectLocationText)), !showResult && allRegion && (allRegion === null || allRegion === void 0 ? void 0 : allRegion.length) > 0 && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(css$10.search__input__wrapper)
  }, /*#__PURE__*/React.createElement("select", {
    className: css$10.search__select,
    "aria-label": "Select location",
    name: "location",
    value: userRegion,
    onChange: handleSelectRegion
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, selectPlaceholderText), allRegion && (allRegion === null || allRegion === void 0 ? void 0 : allRegion.length) > 0 && (allRegion === null || allRegion === void 0 ? void 0 : allRegion.map(function (region) {
    return /*#__PURE__*/React.createElement("option", {
      key: region === null || region === void 0 ? void 0 : region.uuid,
      value: region === null || region === void 0 ? void 0 : region.uuid
    }, region === null || region === void 0 ? void 0 : region.name);
  }))))), showResult && (!foundContactResult || foundContactResult.length === 0) && (/*#__PURE__*/React.createElement("p", null, noContactFoundText)), showResult && foundContactResult && (foundContactResult === null || foundContactResult === void 0 ? void 0 : foundContactResult.length) > 0 && ((_a = foundContactResult.slice(0, 2)) === null || _a === void 0 ? void 0 : _a.map(function (contact) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return /*#__PURE__*/React.createElement(ContactResultCard, {
      key: contact.uuid,
      name: getFullName((_a = contact === null || contact === void 0 ? void 0 : contact.content) === null || _a === void 0 ? void 0 : _a.first_name, (_b = contact === null || contact === void 0 ? void 0 : contact.content) === null || _b === void 0 ? void 0 : _b.last_name),
      phone: ((_c = contact === null || contact === void 0 ? void 0 : contact.content) === null || _c === void 0 ? void 0 : _c.phone) || ((_d = contact === null || contact === void 0 ? void 0 : contact.content) === null || _d === void 0 ? void 0 : _d.mobile),
      formSlug: formSlug,
      imageUrl: (_j = (_h = (_g = (_f = (_e = contact.content) === null || _e === void 0 ? void 0 : _e.image[0]) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.item) === null || _h === void 0 ? void 0 : _h.focal_embed_link) !== null && _j !== void 0 ? _j : (_o = (_m = (_l = (_k = contact.content) === null || _k === void 0 ? void 0 : _k.image[0]) === null || _l === void 0 ? void 0 : _l.image) === null || _m === void 0 ? void 0 : _m.item) === null || _o === void 0 ? void 0 : _o.embed_link,
      imageAlt: (_q = (_p = contact === null || contact === void 0 ? void 0 : contact.content) === null || _p === void 0 ? void 0 : _p.image[0]) === null || _q === void 0 ? void 0 : _q.alt_text,
      selectProduct: (_r = contact.content) === null || _r === void 0 ? void 0 : _r.select_products,
      contactUid: contact === null || contact === void 0 ? void 0 : contact.uuid,
      sendMessageText: sendMessageText
    });
  })), showResult && (/*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setShowResult(false);
    },
    "aria-label": "Change location",
    className: css$10.button__link
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkIcon, {
    variant: LinkVariant.Primary
  }), changeLocationText))), contact_link && (contact_link === null || contact_link === void 0 ? void 0 : contact_link.length) > 0 && (contact_link === null || contact_link === void 0 ? void 0 : contact_link.map(function (item) {
    var _a, _b, _c, _d;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      variant: LinkVariant.Primary,
      target: TargetValues.Self,
      title: item.name || 'Request a quote',
      href: ((_b = (_a = item.link) === null || _a === void 0 ? void 0 : _a.story) === null || _b === void 0 ? void 0 : _b.url) || ((_c = item.link) === null || _c === void 0 ? void 0 : _c.url) || ((_d = item.link) === null || _d === void 0 ? void 0 : _d.cached_url) || '/',
      className: css$10.link
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkIcon, {
      variant: LinkVariant.Primary
    }), item.name)));
  }))))));
};
var ContactResultCard = function ContactResultCard(_ref2) {
  var name = _ref2.name,
    phone = _ref2.phone,
    formSlug = _ref2.formSlug,
    imageUrl = _ref2.imageUrl,
    _ref2$imageAlt = _ref2.imageAlt,
    imageAlt = _ref2$imageAlt === void 0 ? '' : _ref2$imageAlt,
    contactUid = _ref2.contactUid,
    selectProduct = _ref2.selectProduct,
    sendMessageText = _ref2.sendMessageText;
  var imageSize = [{
    width: 66,
    height: 66
  }];
  return /*#__PURE__*/React.createElement("div", {
    key: contactUid,
    className: "".concat(css$10.result__main__wrapper, " ").concat(css$10.show__results)
  }, selectProduct && (/*#__PURE__*/React.createElement(Headline, {
    tag: "h6"
  }, selectProduct.join(', '))), /*#__PURE__*/React.createElement("div", {
    className: css$10.result__content__wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css$10.result__image__wrapper
  }, imageUrl ? (/*#__PURE__*/React.createElement(Image, {
    src: imageUrl,
    imageSizes: imageSize,
    alt: imageAlt,
    className: css$10.result__image
  })) : (/*#__PURE__*/React.createElement(CircularProfile, null))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: css$10.name
  }, name), /*#__PURE__*/React.createElement("div", {
    className: css$10.phone__wrapper
  }, phone && (/*#__PURE__*/React.createElement(Link, {
    href: phone,
    contact_type: ContactType.Phone,
    variant: LinkVariant.Secondary,
    target: TargetValues.Self,
    title: phone,
    external: true,
    showExternalIcon: false,
    className: css$10.phone
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PhoneIcon, null), phone)))), formSlug && (/*#__PURE__*/React.createElement(Link, {
    variant: LinkVariant.Primary,
    target: TargetValues.Self,
    title: sendMessageText || 'Send Message',
    href: "".concat(formSlug, "?contact=").concat(contactUid),
    className: css$10.link
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkIcon, {
    variant: LinkVariant.Primary
  }), sendMessageText))))), /*#__PURE__*/React.createElement(Separator, {
    className: css$10.separator
  }));
};
var ContactNoImage = function ContactNoImage(_ref3) {
  var formSlug = _ref3.formSlug,
    onClick = _ref3.onClick,
    className = _ref3.className,
    id = _ref3.id,
    sendMessageText = _ref3.sendMessageText,
    noContactFoundText = _ref3.noContactFoundText,
    contact_link = _ref3.contact_link,
    locale = _ref3.locale,
    middlewareBaseURL = _ref3.middlewareBaseURL;
  var _a, _b, _c;
  var _useState6 = useState([]),
    contactPerson = _useState6[0],
    setContactPerson = _useState6[1];
  var _useState7 = useState(),
    loading = _useState7[0],
    setLoading = _useState7[1];
  var targetLocale = locale !== null && locale !== void 0 ? locale : getFallbackLocale(locale);
  var urlPath = "".concat(middlewareBaseURL, "/contact/").concat((_a = targetLocale === null || targetLocale === void 0 ? void 0 : targetLocale.toLowerCase()) !== null && _a !== void 0 ? _a : '');
  var fetchFixedContact = function fetchFixedContact() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var fixedContact;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setLoading(true);
            _context3.next = 3;
            return fetchUtil(urlPath);
          case 3:
            fixedContact = _context3.sent;
            setContactPerson(fixedContact);
            setLoading(false);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  useEffect(function () {
    fetchFixedContact();
  }, []);
  var contactData = ((_c = (_b = contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.contact_info) || [];
  var formattedFormSlug = formatLink(formSlug || '');
  var formattedContactLinks = useFormattedContactLinks(contact_link, locale);
  return /*#__PURE__*/React.createElement("div", {
    className: className || ''
  }, /*#__PURE__*/React.createElement("div", {
    className: css$10.wrapper,
    onMouseDown: onClick,
    id: id
  }, loading ? (/*#__PURE__*/React.createElement(Loader$1, null)) : (/*#__PURE__*/React.createElement(React.Fragment, null, contactData && contactData.length > 0 && (contactData === null || contactData === void 0 ? void 0 : contactData.map(function (contact, index) {
    var _a, _b;
    var content = (_a = contact === null || contact === void 0 ? void 0 : contact.select_contact_person) === null || _a === void 0 ? void 0 : _a.content;
    var contactUUID = (_b = contact === null || contact === void 0 ? void 0 : contact.select_contact_person) === null || _b === void 0 ? void 0 : _b.uuid;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: content === null || content === void 0 ? void 0 : content._uid
    }, index > 0 && /*#__PURE__*/React.createElement(Separator, {
      className: css$10.separator
    }), /*#__PURE__*/React.createElement(React.Fragment, null, (content === null || content === void 0 ? void 0 : content.select_products) && content.select_products.length > 0 && (/*#__PURE__*/React.createElement(Headline, {
      tag: HeadlineTags.H6,
      className: css$10.headline
    }, content.select_products.join(', '))), getFullName(content === null || content === void 0 ? void 0 : content.first_name, content === null || content === void 0 ? void 0 : content.last_name) && (/*#__PURE__*/React.createElement("p", {
      className: css$10.name
    }, getFullName(content === null || content === void 0 ? void 0 : content.first_name, content === null || content === void 0 ? void 0 : content.last_name))), content.company && content.component === 'contact_company' && (/*#__PURE__*/React.createElement("p", {
      className: css$10.company
    }, content.company)), (content === null || content === void 0 ? void 0 : content.job_title) && /*#__PURE__*/React.createElement("p", null, content.job_title), /*#__PURE__*/React.createElement("address", {
      className: css$10.address__wrapper
    }, (content === null || content === void 0 ? void 0 : content.company_address1) && (/*#__PURE__*/React.createElement("p", {
      className: css$10.address
    }, content.company_address1)), (content === null || content === void 0 ? void 0 : content.company_address2) && (/*#__PURE__*/React.createElement("p", {
      className: css$10.address
    }, content.company_address2)), (content === null || content === void 0 ? void 0 : content.company_address3) && (/*#__PURE__*/React.createElement("p", {
      className: css$10.address
    }, content.company_address3)), content.adress_1 && (/*#__PURE__*/React.createElement("p", {
      className: css$10.address
    }, content.adress_1)), content.adress_2 && (/*#__PURE__*/React.createElement("p", {
      className: css$10.address
    }, content.adress_2)), content.adress_3 && (/*#__PURE__*/React.createElement("p", {
      className: css$10.address
    }, content.adress_3))), /*#__PURE__*/React.createElement("div", {
      className: css$10.phone__wrapper
    }, (content === null || content === void 0 ? void 0 : content.phone) || (content === null || content === void 0 ? void 0 : content.mobile) && (/*#__PURE__*/React.createElement(Link, {
      href: (content === null || content === void 0 ? void 0 : content.phone) || (content === null || content === void 0 ? void 0 : content.mobile),
      contact_type: ContactType.Phone,
      variant: LinkVariant.Secondary,
      target: TargetValues.Self,
      title: (content === null || content === void 0 ? void 0 : content.phone) || (content === null || content === void 0 ? void 0 : content.mobile),
      external: true,
      showExternalIcon: false,
      className: css$10.phone
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PhoneIcon, null), (content === null || content === void 0 ? void 0 : content.phone) || (content === null || content === void 0 ? void 0 : content.mobile)))), (content === null || content === void 0 ? void 0 : content.fax) && (/*#__PURE__*/React.createElement(Link, {
      href: content.fax,
      contact_type: ContactType.Fax,
      variant: LinkVariant.Secondary,
      target: TargetValues.Self,
      title: content.fax,
      external: true,
      showExternalIcon: false,
      className: css$10.fax
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FaxIcon, null), content.fax)))), content && (/*#__PURE__*/React.createElement(Link, {
      variant: LinkVariant.Primary,
      target: TargetValues.Self,
      title: sendMessageText || 'Send Message',
      href: "".concat(window.location.origin).concat(formattedFormSlug, "?contact=").concat(contactUUID),
      className: css$10.link,
      external: true,
      showExternalIcon: false
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkIcon, {
      variant: LinkVariant.Primary
    }), sendMessageText))), !content && /*#__PURE__*/React.createElement("p", null, noContactFoundText)));
  })), formattedContactLinks.length > 0 && formattedContactLinks.map(function (item) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Separator, {
      className: css$10.separator
    }), /*#__PURE__*/React.createElement(Link, {
      variant: LinkVariant.Primary,
      target: TargetValues.Self,
      title: item.name || 'Request a quote',
      href: item.url || '/',
      className: css$10.link,
      external: true,
      showExternalIcon: false
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkIcon, {
      variant: LinkVariant.Primary
    }), item.name)));
  })))));
};
var SearchZip = function SearchZip(_ref4) {
  var formSlug = _ref4.formSlug,
    onClick = _ref4.onClick,
    className = _ref4.className,
    id = _ref4.id,
    selectLocationText = _ref4.selectLocationText,
    locationDescriptionText = _ref4.locationDescriptionText,
    zipCodePlaceholderText = _ref4.zipCodePlaceholderText,
    locationErrorText = _ref4.locationErrorText,
    noContactFoundText = _ref4.noContactFoundText,
    changeLocationText = _ref4.changeLocationText,
    sendMessageText = _ref4.sendMessageText,
    contact_link = _ref4.contact_link,
    locale = _ref4.locale,
    middlewareBaseURL = _ref4.middlewareBaseURL;
  var _a;
  var _useState8 = useState(''),
    userZip = _useState8[0],
    setUserZip = _useState8[1];
  var _useState9 = useState(false),
    showResult = _useState9[0],
    setShowResult = _useState9[1];
  var _useState0 = useState(false),
    zipError = _useState0[0],
    setZipError = _useState0[1];
  var _useState1 = useState(false),
    loading = _useState1[0],
    setLoading = _useState1[1];
  var _useState10 = useState([]),
    foundContactResult = _useState10[0],
    setFoundContactResult = _useState10[1];
  var formattedContactLinks = useFormattedContactLinks(contact_link, locale);
  var handleSearchZip = function handleSearchZip(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var urlPath, foundZipContacts;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            e.preventDefault();
            if (isValidZipCode(userZip)) {
              _context4.next = 4;
              break;
            }
            setShowResult(false);
            return _context4.abrupt("return", setZipError(true));
          case 4:
            _context4.prev = 4;
            setZipError(false);
            setLoading(true);
            urlPath = "".concat(middlewareBaseURL, "/contact/zip-code/").concat(getContactLocale(locale), "?zipCode=").concat(userZip);
            _context4.next = 10;
            return fetchUtil(urlPath);
          case 10:
            foundZipContacts = _context4.sent;
            setFoundContactResult(foundZipContacts);
            setShowResult(true);
            setLoading(false);
            _context4.next = 21;
            break;
          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](4);
            console.error(_context4.t0);
            setZipError(true);
            setLoading(false);
          case 21:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[4, 16]]);
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className || ''
  }, /*#__PURE__*/React.createElement("div", {
    className: css$10.wrapper,
    onMouseDown: onClick,
    id: id
  }, loading ? (/*#__PURE__*/React.createElement(Loader$1, null)) : (/*#__PURE__*/React.createElement(React.Fragment, null, !showResult && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H6,
    className: css$10.headline
  }, selectLocationText)), !showResult && (/*#__PURE__*/React.createElement("p", {
    className: css$10.search__text
  }, locationDescriptionText)), !showResult && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(css$10.search__input__wrapper, " ").concat(zipError && css$10.search__input__error)
  }, !showResult && (/*#__PURE__*/React.createElement("form", {
    onSubmit: handleSearchZip
  }, /*#__PURE__*/React.createElement("input", {
    maxLength: 9,
    type: "number",
    placeholder: zipCodePlaceholderText,
    onChange: function onChange(e) {
      return setUserZip(e.target.value);
    },
    value: userZip,
    className: "".concat(css$10.search__input, "  ").concat(zipError && css$10.input__error)
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    "aria-label": "Search zip code",
    className: css$10.search__icon
  }, /*#__PURE__*/React.createElement(InputSearchIcon, null)))))), zipError && /*#__PURE__*/React.createElement("p", {
    className: css$10.error__text
  }, locationErrorText), showResult && (foundContactResult === null || foundContactResult === void 0 ? void 0 : foundContactResult.length) === 0 && (/*#__PURE__*/React.createElement("p", null, noContactFoundText)), showResult && foundContactResult && (foundContactResult === null || foundContactResult === void 0 ? void 0 : foundContactResult.length) > 0 && ((_a = foundContactResult.slice(0, 2)) === null || _a === void 0 ? void 0 : _a.map(function (contact) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return /*#__PURE__*/React.createElement(ContactResultCard, {
      key: contact.uuid,
      name: getFullName((_a = contact === null || contact === void 0 ? void 0 : contact.content) === null || _a === void 0 ? void 0 : _a.first_name, (_b = contact === null || contact === void 0 ? void 0 : contact.content) === null || _b === void 0 ? void 0 : _b.last_name),
      phone: ((_c = contact === null || contact === void 0 ? void 0 : contact.content) === null || _c === void 0 ? void 0 : _c.phone) || ((_d = contact === null || contact === void 0 ? void 0 : contact.content) === null || _d === void 0 ? void 0 : _d.mobile),
      formSlug: formSlug,
      imageUrl: ((_h = (_g = (_f = (_e = contact.content) === null || _e === void 0 ? void 0 : _e.image[0]) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.item) === null || _h === void 0 ? void 0 : _h.focal_embed_link) || ((_m = (_l = (_k = (_j = contact.content) === null || _j === void 0 ? void 0 : _j.image[0]) === null || _k === void 0 ? void 0 : _k.image) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.embed_link),
      imageAlt: (_p = (_o = contact === null || contact === void 0 ? void 0 : contact.content) === null || _o === void 0 ? void 0 : _o.image[0]) === null || _p === void 0 ? void 0 : _p.alt_text,
      selectProduct: (_q = contact.content) === null || _q === void 0 ? void 0 : _q.select_products,
      contactUid: contact === null || contact === void 0 ? void 0 : contact.uuid,
      sendMessageText: sendMessageText
    });
  })), showResult && (/*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setShowResult(false);
    },
    "aria-label": "Change location",
    className: css$10.button__link
  }, /*#__PURE__*/React.createElement(LinkIcon, {
    variant: LinkVariant.Primary
  }), changeLocationText)))), formattedContactLinks.length > 0 && formattedContactLinks.map(function (item) {
    return /*#__PURE__*/React.createElement(Link, {
      key: item.name,
      variant: LinkVariant.Primary,
      target: TargetValues.Self,
      title: item.name || 'Request a quote',
      href: item.url || '/',
      className: css$10.link,
      external: true,
      showExternalIcon: false
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkIcon, {
      variant: LinkVariant.Primary
    }), item.name));
  })));
};
var Loader$1 = function Loader() {
  return /*#__PURE__*/React.createElement("div", {
    className: css$10.contact_loader_icon
  });
};
var getFullName = function getFullName(firstName, lastName) {
  return "".concat(firstName || '', " ").concat(lastName || '').trim();
};
var isValidZipCode = function isValidZipCode(zip) {
  var zipCodePattern = /^\d{3,10}$/;
  return zipCodePattern.test(zip);
};

var ContactPerson = function ContactPerson(_ref) {
  var classname = _ref.classname,
    onClick = _ref.onClick,
    id = _ref.id,
    defaultFormSlug = _ref.defaultFormSlug,
    select_contact_view = _ref.select_contact_view,
    selectLocationText = _ref.selectLocationText,
    selectPlaceholderText = _ref.selectPlaceholderText,
    noContactFoundText = _ref.noContactFoundText,
    changeLocationText = _ref.changeLocationText,
    sendMessageText = _ref.sendMessageText,
    locationDescriptionText = _ref.locationDescriptionText,
    zipCodePlaceholderText = _ref.zipCodePlaceholderText,
    locationErrorText = _ref.locationErrorText,
    contact_link = _ref.contact_link,
    locale = _ref.locale,
    middlewareBaseURL = _ref.middlewareBaseURL;
  var resolvedFormSlug = _typeof$1(defaultFormSlug) === 'object' && defaultFormSlug !== null ? defaultFormSlug.slug : defaultFormSlug;
  if (select_contact_view === SelectContactView.FIXED) {
    return /*#__PURE__*/React.createElement(ContactNoImage, {
      formSlug: resolvedFormSlug,
      id: id,
      className: classname,
      onClick: onClick,
      sendMessageText: sendMessageText,
      noContactFoundText: noContactFoundText,
      contact_link: contact_link,
      locale: locale,
      middlewareBaseURL: middlewareBaseURL
    });
  }
  if (select_contact_view === SelectContactView.ZIP_CODE) {
    return /*#__PURE__*/React.createElement(SearchZip, {
      className: classname,
      onClick: onClick,
      id: id,
      formSlug: resolvedFormSlug,
      selectLocationText: selectLocationText,
      locationDescriptionText: locationDescriptionText,
      zipCodePlaceholderText: zipCodePlaceholderText,
      locationErrorText: locationErrorText,
      noContactFoundText: noContactFoundText,
      changeLocationText: changeLocationText,
      sendMessageText: sendMessageText,
      contact_link: contact_link,
      locale: locale,
      middlewareBaseURL: middlewareBaseURL
    });
  }
  if (select_contact_view === SelectContactView.REGION) {
    return /*#__PURE__*/React.createElement(SearchRegion, {
      className: classname,
      onClick: onClick,
      id: id,
      formSlug: resolvedFormSlug,
      selectedView: select_contact_view,
      selectLocationText: selectLocationText,
      selectPlaceholderText: selectPlaceholderText,
      noContactFoundText: noContactFoundText,
      changeLocationText: changeLocationText,
      sendMessageText: sendMessageText,
      contact_link: contact_link,
      locale: locale,
      middlewareBaseURL: middlewareBaseURL
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

var css$$ = {"breakpoints":"'../../../styling/breakpoints.css'","md":"i__const_md_0","lg":"i__const_lg_1","contact__special__wrapper":"ContactSpecial-module_contact__special__wrapper__7xb-H","content__wrapper":"ContactSpecial-module_content__wrapper__YgXec","contact__image__wrapper":"ContactSpecial-module_contact__image__wrapper__aM0R4","contact__image":"ContactSpecial-module_contact__image__-L-UR","outline__themed_primary":"ContactSpecial-module_outline__themed_primary__4Dogq","outline__themed_secondary":"ContactSpecial-module_outline__themed_secondary__sXuSu","outline__themed_color1":"ContactSpecial-module_outline__themed_color1__HV8Nj","outline__themed_color2":"ContactSpecial-module_outline__themed_color2__QtCg3","fallback__image":"ContactSpecial-module_fallback__image__0ep17"};

var ContactSpecial = function ContactSpecial(_ref) {
  var headline = _ref.headline,
    text = _ref.text,
    variant = _ref.variant,
    image = _ref.image,
    link = _ref.link,
    variant_h2 = _ref.variant_h2,
    imagePriority = _ref.imagePriority;
  var imageItem = setImage(image);
  return /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: css$$.contact__special__wrapper
  }, /*#__PURE__*/React.createElement(Col, {
    className: css$$.content__wrapper
  }, headline && (/*#__PURE__*/React.createElement(Headline, {
    tag: "h3",
    variant: variant_h2
  }, headline)), /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }), link && link.length > 0 && link.map(function (item) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      linkType: item
    });
  })), /*#__PURE__*/React.createElement(Col, {
    className: css$$.content__wrapper
  }, /*#__PURE__*/React.createElement("figure", {
    className: css$$.contact__image__wrapper
  }, /*#__PURE__*/React.createElement(ContactSpecialImage, {
    imageData: imageItem,
    variant: variant,
    imagePriority: imagePriority
  }))))));
};
var ContactSpecialImage = function ContactSpecialImage(_ref2) {
  var imageData = _ref2.imageData,
    variant = _ref2.variant,
    imagePriority = _ref2.imagePriority;
  var _a, _b;
  var imageSizes = [{
    height: 235,
    width: 235
  }];
  var imageSrc = generateImageSrc(((_b = (_a = imageData === null || imageData === void 0 ? void 0 : imageData.local_image) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.local_image) || (imageData === null || imageData === void 0 ? void 0 : imageData.image));
  return (imageData === null || imageData === void 0 ? void 0 : imageData.image) ? (/*#__PURE__*/React.createElement(Image, {
    src: imageSrc,
    alt: imageData.alt_text,
    copyrightText: imageData.copyright,
    imageSizes: imageSizes,
    className: "".concat(css$$.contact__image, " ").concat(variant ? getVariantClassName(variant, css$$, ComponentNames.Outline) : ''),
    copyrightClassName: css$$.contact__special__copyright,
    priority: imagePriority
  })) : (/*#__PURE__*/React.createElement(CircularProfile, {
    className: "".concat(variant ? getVariantClassName(variant, css$$, ComponentNames.Outline) : '', " ").concat(css$$.fallback__image)
  }));
};
var setImage = function setImage(image) {
  var _a, _b, _c, _d;
  if (image && image.length > 0 && ((_a = image[0]) === null || _a === void 0 ? void 0 : _a.component) === 'image_atom') {
    return image[0];
  }
  var contactImage = image && ((_d = (_c = (_b = image[0]) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.image[0]);
  return contactImage;
};

var FallbackProfile$1 = function FallbackProfile() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "135",
    height: "135",
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2719_3769)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "135",
    height: "135",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4998 71.7775C81.6782 71.7775 93.172 60.2836 93.172 46.1053C93.172 31.927 81.6782 20.4331 67.4998 20.4331C53.3215 20.4331 41.8276 31.927 41.8276 46.1053C41.8276 60.2836 53.3215 71.7775 67.4998 71.7775Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4998 172.328C98.2195 172.328 123.123 151.256 123.123 125.262C123.123 99.2684 98.2195 78.1964 67.4998 78.1964C36.7801 78.1964 11.8768 99.2684 11.8768 125.262C11.8768 151.256 36.7801 172.328 67.4998 172.328Z",
    fill: "#CECECE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "1.5",
    y: "1.5",
    width: "132",
    height: "132",
    stroke: "#F07D00",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2719_3769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "135",
    height: "135",
    fill: "white"
  }))));
};

var css$_ = {"headline__background":"ContactStandard-module_headline__background__QY7wi","main__headline":"ContactStandard-module_main__headline__s7-yx","sub__container":"ContactStandard-module_sub__container__wk5Rz","wrapper__container":"ContactStandard-module_wrapper__container__mSNqK","profile__wrapper":"ContactStandard-module_profile__wrapper__uxDjC","image__wrapper":"ContactStandard-module_image__wrapper__Xop4f","image":"ContactStandard-module_image__e2IW4","contact__wrapper":"ContactStandard-module_contact__wrapper__-2kU4","no--margin":"ContactStandard-module_no--margin__e6qvi","email__anchor":"ContactStandard-module_email__anchor__dpCqe","text__anchor":"ContactStandard-module_text__anchor__g81gg","phone__icon":"ContactStandard-module_phone__icon__fhlYH","job__title":"ContactStandard-module_job__title__TmMIM","image__right":"ContactStandard-module_image__right__DpUFT","image__left":"ContactStandard-module_image__left__qpqAN","text__content__two__column__wrapper":"ContactStandard-module_text__content__two__column__wrapper__p7Xas","text__content__single__column":"ContactStandard-module_text__content__single__column__p5cBy"};

var ComponentContact;
(function (ComponentContact) {
  ComponentContact["CONTACT_COMPANY"] = "contact_company";
  ComponentContact["CONTACT"] = "contact";
})(ComponentContact || (ComponentContact = {}));
var ContactImageDisplay;
(function (ContactImageDisplay) {
  ContactImageDisplay["IMAGE"] = "image";
  ContactImageDisplay["PLACEHOLDER"] = "placeholder";
  ContactImageDisplay["EMPTY"] = "empty";
})(ContactImageDisplay || (ContactImageDisplay = {}));

var setInfoTextTwoColumn = function setInfoTextTwoColumn(storyTextContent, defaultTextContent) {
  var _a;
  return storyTextContent && ((_a = storyTextContent.info_text_two_columns) === null || _a === void 0 ? void 0 : _a.length) > 0 ? storyTextContent === null || storyTextContent === void 0 ? void 0 : storyTextContent.info_text_two_columns : defaultTextContent === null || defaultTextContent === void 0 ? void 0 : defaultTextContent.info_text_two_columns;
};
/**
 * Should display image or placeholder or nothing (neither image nor placeholder)
 * if it's a contact_company, and has an image display it but if it doesn't have an image don't show a placeholder.
 * If it's a contact, show image only when the current contact has an image else show a placeholder.
 * @param contactType ComponentContact
 * @param image ImageSourceType
 * @returns ContactImageDisplay
 */
var getImageDisplayType = function getImageDisplayType(contactType, image) {
  if (contactType === ComponentContact.CONTACT_COMPANY && image) {
    return ContactImageDisplay.IMAGE;
  }
  if (contactType === ComponentContact.CONTACT_COMPANY && !image) {
    return ContactImageDisplay.EMPTY;
  }
  if (contactType === ComponentContact.CONTACT && image) {
    return ContactImageDisplay.IMAGE;
  }
  if (contactType === ComponentContact.CONTACT && !image) {
    return ContactImageDisplay.PLACEHOLDER;
  }
  return ContactImageDisplay.EMPTY;
};
/**
 * Determines which contact data to use based on locale settings
 * For fallback locales (e.g. en-sg -> en-de), prioritize defaultContact
 * For primary locales (e.g. de-de, en-gb), prioritize tag
 */
var getContactData = function getContactData(locale, tag, defaultContact) {
  if (!locale) return tag || defaultContact;
  var isFallbackLocale = Boolean(fallbackLang[locale]);
  return isFallbackLocale ? defaultContact || tag : tag || defaultContact;
};
var profileSize = [{
  width: 135,
  height: 135
}];

var ContactStandard = function ContactStandard(_ref) {
  var view = _ref.view,
    tag = _ref.tag,
    default_text = _ref.default_text,
    headlines_text = _ref.headlines_text,
    default_form_slug = _ref.default_form_slug,
    defaultContact = _ref.defaultContact;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
  var router = useRouter();
  var locale = (_a = router.locale) !== null && _a !== void 0 ? _a : router.defaultLocale;
  var renderContactData = getContactData(locale, tag, defaultContact);
  var defaultTextContent = default_text && ((_b = default_text[0]) === null || _b === void 0 ? void 0 : _b.content);
  var storyTextContent = headlines_text[0];
  var infoTextOneColumn = hasTextContent(storyTextContent === null || storyTextContent === void 0 ? void 0 : storyTextContent.info_text_one_column) ? storyTextContent === null || storyTextContent === void 0 ? void 0 : storyTextContent.info_text_one_column : defaultTextContent === null || defaultTextContent === void 0 ? void 0 : defaultTextContent.info_text_one_column;
  var infoTextTwoColumn = setInfoTextTwoColumn(storyTextContent, defaultTextContent);
  var contactComponentType = (_c = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _c === void 0 ? void 0 : _c.component;
  var contactImage = (_f = (_e = (_d = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _d === void 0 ? void 0 : _d.image[0]) === null || _e === void 0 ? void 0 : _e.image) === null || _f === void 0 ? void 0 : _f.item;
  var shouldDisplayImage = getImageDisplayType(contactComponentType, contactImage) === ContactImageDisplay.IMAGE;
  var shouldDisplayPlaceholder = getImageDisplayType(contactComponentType, contactImage) === ContactImageDisplay.PLACEHOLDER;
  var shouldDisplayNothing = getImageDisplayType(contactComponentType, contactImage) === ContactImageDisplay.EMPTY;
  return /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: css$_.headline__background
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: 'h3',
    className: css$_.main__headline
  }, (storyTextContent === null || storyTextContent === void 0 ? void 0 : storyTextContent.headline) || (defaultTextContent === null || defaultTextContent === void 0 ? void 0 : defaultTextContent.headline))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$_.sub__container, "  ").concat(view ? css$_.image__right : css$_.image__left)
  }, /*#__PURE__*/React.createElement("div", {
    className: css$_.wrapper__container
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, (storyTextContent === null || storyTextContent === void 0 ? void 0 : storyTextContent.headline_contact_person) || (defaultTextContent === null || defaultTextContent === void 0 ? void 0 : defaultTextContent.headline_contact_person)), /*#__PURE__*/React.createElement("div", {
    className: css$_.profile__wrapper
  }, !shouldDisplayNothing && (/*#__PURE__*/React.createElement("div", {
    className: css$_.image__wrapper
  }, shouldDisplayImage && (/*#__PURE__*/React.createElement(Image, {
    src: "".concat(((_k = (_j = (_h = (_g = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _g === void 0 ? void 0 : _g.image[0]) === null || _h === void 0 ? void 0 : _h.image) === null || _j === void 0 ? void 0 : _j.item) === null || _k === void 0 ? void 0 : _k.focal_embed_link) || ((_p = (_o = (_m = (_l = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _l === void 0 ? void 0 : _l.image[0]) === null || _m === void 0 ? void 0 : _m.image) === null || _o === void 0 ? void 0 : _o.item) === null || _p === void 0 ? void 0 : _p.embed_link)),
    alt: ((_r = (_q = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _q === void 0 ? void 0 : _q.image[0]) === null || _r === void 0 ? void 0 : _r.alt_text) || 'Profile',
    imageSizes: profileSize,
    copyrightText: (_t = (_s = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _s === void 0 ? void 0 : _s.image[0]) === null || _t === void 0 ? void 0 : _t.copyright,
    className: css$_.image
  })), shouldDisplayPlaceholder && /*#__PURE__*/React.createElement(FallbackProfile$1, null))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$_.contact__wrapper, " ").concat(shouldDisplayNothing && css$_['no--margin'])
  }, /*#__PURE__*/React.createElement("strong", null, ((_u = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _u === void 0 ? void 0 : _u.first_name) && ((_v = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _v === void 0 ? void 0 : _v.last_name) ? "".concat(renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content.first_name, " ").concat(renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content.last_name) : (_w = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _w === void 0 ? void 0 : _w.company), ((_x = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _x === void 0 ? void 0 : _x.job_title) && (/*#__PURE__*/React.createElement("p", {
    className: css$_.job__title
  }, renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content.job_title)), (((_y = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _y === void 0 ? void 0 : _y.phone) || ((_z = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _z === void 0 ? void 0 : _z.mobile)) && (/*#__PURE__*/React.createElement(Link, {
    href: ((_0 = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _0 === void 0 ? void 0 : _0.phone) || ((_1 = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _1 === void 0 ? void 0 : _1.mobile),
    external: true,
    target: TargetValues.Blank,
    title: ((_2 = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _2 === void 0 ? void 0 : _2.phone) || ((_3 = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _3 === void 0 ? void 0 : _3.mobile),
    variant: LinkVariant.Secondary,
    showExternalIcon: false,
    className: css$_.text__anchor,
    contact_type: ContactType.Phone
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PhoneIcon, {
    className: css$_.phone__icon
  }), ((_4 = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _4 === void 0 ? void 0 : _4.phone) || ((_5 = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _5 === void 0 ? void 0 : _5.mobile)))), /*#__PURE__*/React.createElement(Link, {
    variant: LinkVariant.ButtonSecondary,
    target: TargetValues.Self,
    title: (_6 = renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.content) === null || _6 === void 0 ? void 0 : _6.name,
    href: "".concat(default_form_slug, "?contact=").concat(renderContactData === null || renderContactData === void 0 ? void 0 : renderContactData.uuid),
    className: css$_.email__anchor
  }, (storyTextContent === null || storyTextContent === void 0 ? void 0 : storyTextContent.email_button_text) || (defaultTextContent === null || defaultTextContent === void 0 ? void 0 : defaultTextContent.email_button_text))))), /*#__PURE__*/React.createElement("div", {
    className: css$_.wrapper__container
  }, hasTextContent(infoTextOneColumn) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(infoTextOneColumn.content)
  })), /*#__PURE__*/React.createElement("div", {
    className: css$_.text__content__two__column__wrapper
  }, infoTextTwoColumn === null || infoTextTwoColumn === void 0 ? void 0 : infoTextTwoColumn.map(function (textContent) {
    return /*#__PURE__*/React.createElement("div", {
      key: textContent._uid,
      className: css$_.text__content__single__column
    }, /*#__PURE__*/React.createElement(RichTextRenderer, {
      content: mappedProps(textContent === null || textContent === void 0 ? void 0 : textContent.info_text_column.content)
    }));
  })))))));
};

var ArrowFill = function ArrowFill(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className ? className : ''),
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22140_15032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78198 7L4.78198 2L-0.218018 7L9.78198 7Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22140_15032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "10",
    height: "10",
    fill: "white",
    transform: "matrix(-1 0 0 -1 10 10)"
  }))));
};

var ArrowIcon = function ArrowIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className ? className : ''),
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08748 5L6.91248 6.175L10.7291 10L6.91248 13.825L8.08748 15L13.0875 10L8.08748 5Z",
    fill: "currentColor"
  }));
};

var CartIcon = function CartIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12178_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8 16.8C7.92 16.8 7.208 17.52 7.208 18.4C7.208 19.28 7.92 20 8.8 20C9.68 20 10.4 19.28 10.4 18.4C10.4 17.52 9.68 16.8 8.8 16.8ZM4 4V5.6H5.6L8.48 11.672L7.4 13.632C7.272 13.856 7.2 14.12 7.2 14.4C7.2 15.28 7.92 16 8.8 16H18.4V14.4H9.136C9.024 14.4 8.936 14.312 8.936 14.2L8.96 14.104L9.68 12.8H15.64C16.24 12.8 16.768 12.472 17.04 11.976L19.904 6.784C19.968 6.672 20 6.536 20 6.4C20 5.96 19.64 5.6 19.2 5.6H7.368L6.616 4H4ZM16.8 16.8C15.92 16.8 15.208 17.52 15.208 18.4C15.208 19.28 15.92 20 16.8 20C17.68 20 18.4 19.28 18.4 18.4C18.4 17.52 17.68 16.8 16.8 16.8Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12178_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var CloseIcon = function CloseIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className ? className : '',
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z"
  }));
};

var ContactFormIcon = function ContactFormIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67965 6.985C8.67965 6.08379 8.08576 5.46411 7.16612 5.46411C6.05502 5.46411 5.26953 6.44046 5.26953 7.41685C5.26953 8.29944 5.78675 8.95664 6.72557 8.95664C7.93247 8.95664 8.67965 8.05526 8.67965 6.985ZM9.41638 3.63172H11.2191L10.3752 8.11011C10.2601 8.43008 10.145 9.14514 10.5095 9.14514C11.334 9.14514 12.2929 8.31714 12.2929 6.28485C12.2929 3.27409 10.1834 1.73116 7.26838 1.73116C4.08483 1.73116 2.0521 3.93272 2.0521 7.01875C2.0521 10.3118 4.35338 12.2687 7.59452 12.2687C9.05192 12.2687 10.2793 11.8547 11.2191 11.1585H13.0985C11.7177 13.0214 9.79989 14 7.44103 14C3.35605 14 0 11.102 0 7.01875C0 3.02956 3.27949 0 7.32593 0C10.7012 0 14 2.20156 14 5.68268C14 9.99184 10.4136 11.1208 9.26293 11.1208C8.55331 11.1208 8.09309 10.801 8.07393 10.1989H8.03554C7.65189 10.7069 7.05737 11.1397 6.19448 11.1397C4.54523 11.1397 3.03009 9.59674 3.03009 7.73381C3.03009 5.53225 4.52603 3.44349 6.8849 3.44349C7.86289 3.44349 8.64925 3.76346 9.24373 4.53485L9.41638 3.63172Z",
    fill: "#363636"
  }));
};

var css$Z = {"prepayment__wrapper":"Icons-module_prepayment__wrapper__tSBAw","prepayment__text":"Icons-module_prepayment__text__x73lS","social__icons":"Icons-module_social__icons__-057t"};

var FacebookIcon = function FacebookIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.2498H18.75L19.5834 12.9165H16.6667V11.2498C16.6667 10.3915 16.6667 9.58317 18.3334 9.58317H19.5834V6.78317C19.3117 6.74734 18.2859 6.6665 17.2025 6.6665C14.94 6.6665 13.3334 8.04734 13.3334 10.5832V12.9165H10.8334V16.2498H13.3334V23.3332H16.6667V16.2498Z",
    fill: "white"
  }));
};

var GlobeIcon = function GlobeIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9067 9.33301C10.96 8.89301 11 8.45301 11 7.99967C11 7.54634 10.96 7.10634 10.9067 6.66634H13.16C13.2667 7.09301 13.3334 7.53967 13.3334 7.99967C13.3334 8.45967 13.2667 8.90634 13.16 9.33301M9.72671 13.0397C10.1267 12.2997 10.4334 11.4997 10.6467 10.6663H12.6134C11.9734 11.7663 10.9534 12.6197 9.72671 13.0397ZM9.56004 9.33301H6.44004C6.37337 8.89301 6.33337 8.45301 6.33337 7.99967C6.33337 7.54634 6.37337 7.09967 6.44004 6.66634H9.56004C9.62004 7.09967 9.66671 7.54634 9.66671 7.99967C9.66671 8.45301 9.62004 8.89301 9.56004 9.33301ZM8.00004 13.3063C7.44671 12.5063 7.00004 11.6197 6.72671 10.6663H9.27337C9.00004 11.6197 8.55337 12.5063 8.00004 13.3063ZM5.33337 5.33301H3.38671C4.02004 4.22634 5.04671 3.37301 6.26671 2.95967C5.86671 3.69967 5.56671 4.49967 5.33337 5.33301ZM3.38671 10.6663H5.33337C5.56671 11.4997 5.86671 12.2997 6.26671 13.0397C5.04671 12.6197 4.02004 11.7663 3.38671 10.6663ZM2.84004 9.33301C2.73337 8.90634 2.66671 8.45967 2.66671 7.99967C2.66671 7.53967 2.73337 7.09301 2.84004 6.66634H5.09337C5.04004 7.10634 5.00004 7.54634 5.00004 7.99967C5.00004 8.45301 5.04004 8.89301 5.09337 9.33301M8.00004 2.68634C8.55337 3.48634 9.00004 4.37967 9.27337 5.33301H6.72671C7.00004 4.37967 7.44671 3.48634 8.00004 2.68634ZM12.6134 5.33301H10.6467C10.4334 4.49967 10.1267 3.69967 9.72671 2.95967C10.9534 3.37967 11.9734 4.22634 12.6134 5.33301ZM8.00004 1.33301C4.31337 1.33301 1.33337 4.33301 1.33337 7.99967C1.33337 9.76779 2.03575 11.4635 3.286 12.7137C3.90505 13.3328 4.63998 13.8238 5.44882 14.1589C6.25766 14.4939 7.12456 14.6663 8.00004 14.6663C9.76815 14.6663 11.4638 13.964 12.7141 12.7137C13.9643 11.4635 14.6667 9.76779 14.6667 7.99967C14.6667 7.1242 14.4943 6.25729 14.1592 5.44845C13.8242 4.63961 13.3331 3.90469 12.7141 3.28563C12.095 2.66657 11.3601 2.17551 10.5513 1.84048C9.74243 1.50545 8.87552 1.33301 8.00004 1.33301Z",
    fill: "#363636"
  }));
};

var IgusLogo = function IgusLogo() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "77",
    height: "40",
    viewBox: "0 0 88 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0942 19.6806C80.5319 18.9088 79.7944 18.2815 78.9423 17.8503C76.5512 16.5922 73.0244 16.3132 68.8999 16.3132C65.8541 16.3132 64.9006 15.2145 64.9006 13.4667C64.9006 12.2997 66.0164 9.58697 71.1116 9.57843C75.3045 9.57843 77.4991 11.8926 77.3995 13.0255H81.0174C81.1597 8.38859 75.2959 5.96054 71.1059 5.96623C64.818 5.96623 61.2884 9.06606 61.2884 13.555C61.2884 15.3084 61.7324 16.7772 62.7116 17.8589C63.5086 18.7384 64.6615 19.3646 66.2213 19.6891H60.5284V17.8503V5.9947H57.0471V19.6806H39.1342C39.1342 19.5696 39.1342 19.4586 39.1342 19.3447V17.8503V5.9947H35.2715V17.8503V19.6806H34.779V5.9947H31.1811V9.9627C30.0323 8.71243 28.6375 7.71307 27.0842 7.0273C25.531 6.34154 23.8528 5.98417 22.1549 5.97762C15.608 5.97762 10.248 11.1725 9.59617 17.8332C9.55137 18.2873 9.52952 18.7433 9.5307 19.1995C9.5307 19.3533 9.5307 19.5098 9.5307 19.6635H9.03541V5.9947H5.43176V17.8503V19.6806H0.0234375V20.4235H5.43176V27.0416V32.4499H9.0468V27.0416V20.4235H9.59333C9.7903 22.8015 10.6133 25.0848 11.9787 27.0416C13.0164 28.5775 14.3886 29.8583 15.9922 30.7878C17.5959 31.7173 19.3893 32.2713 21.2378 32.4083C23.0863 32.5452 24.9418 32.2616 26.6649 31.5786C28.3881 30.8956 29.9341 29.831 31.1868 28.4649V32.3646C31.167 33.6952 30.8845 35.0089 30.3556 36.2301C28.9324 39.5292 25.8012 41.8177 22.1606 41.8177C18.5199 41.8177 15.3945 39.5235 13.9712 36.2244C13.4345 35.0048 13.1443 33.6911 13.1173 32.3589H9.52786C9.54287 33.6692 9.74414 34.9707 10.1256 36.2244C11.7567 41.5587 16.5331 45.41 22.1549 45.41C27.7767 45.41 32.5531 41.5587 34.1813 36.2244C34.563 34.9718 34.7643 33.6711 34.779 32.3617V20.4235H35.3199C35.5202 22.8025 36.3472 25.086 37.7166 27.0416C38.8515 28.6977 40.3703 30.0545 42.1433 30.9963C43.9163 31.9381 45.8909 32.4368 47.8985 32.4499C49.5904 32.4453 51.2632 32.0918 52.8123 31.4115C54.3614 30.7312 55.7536 29.7388 56.9019 28.4962V32.4499H60.5227V27.0416V20.4235H75.498C78.1168 21.0185 78.6292 22.1485 78.6292 23.7995C78.6539 24.4106 78.5405 25.0194 78.2976 25.5807C78.0546 26.142 77.6883 26.6414 77.2258 27.0416C75.9335 28.1631 73.8101 28.704 71.1059 28.704C68.7234 28.704 67.0041 28.0066 65.9111 27.0388C64.8607 26.1137 64.3853 24.9409 64.4451 23.9076H60.8244C60.7875 24.9852 60.9999 26.0567 61.4449 27.0388C62.8852 30.2268 66.6682 32.319 71.1059 32.319C74.943 32.319 79.9585 31.1804 81.6379 27.0388C82.0463 26.0056 82.2456 24.9017 82.2243 23.7909C82.254 22.6304 82.0143 21.4787 81.524 20.4264H87.6041V19.6806H81.0942ZM27.6059 27.0416C26.1032 28.2068 24.2556 28.8391 22.3541 28.8391C20.4526 28.8391 18.6051 28.2068 17.1024 27.0416C16.0748 26.2416 15.2179 25.2437 14.5824 24.1071C13.9468 22.9704 13.5454 21.7179 13.4019 20.4235H31.3149C31.1706 21.7186 30.768 22.9716 30.131 24.1084C29.4939 25.2451 28.6353 26.2426 27.6059 27.0416ZM31.3633 19.6863H13.3308C13.3308 19.5297 13.3308 19.3732 13.3308 19.2138C13.3253 18.7582 13.3491 18.3028 13.4019 17.8503C14.0282 13.1735 17.7941 9.57558 22.3484 9.57558C26.9028 9.57558 30.6659 13.1735 31.2864 17.8503C31.3447 18.3006 31.3742 18.7541 31.3746 19.2081C31.3746 19.3561 31.3718 19.5241 31.3633 19.6806V19.6863ZM53.3524 27.0416C51.8474 28.2142 49.9942 28.851 48.0864 28.851C46.1785 28.851 44.3253 28.2142 42.8204 27.0416C41.7935 26.2422 40.937 25.2453 40.3014 24.1096C39.6659 22.974 39.2642 21.7226 39.1199 20.4292H57.0329C56.8911 21.7211 56.4924 22.9716 55.8604 24.1071C55.2283 25.2427 54.3756 26.2404 53.3524 27.0416Z",
    fill: "#EF7D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22973 3.60081C7.58646 3.60193 7.93549 3.49714 8.23261 3.29972C8.52973 3.10229 8.76156 2.82111 8.89872 2.4918C9.03589 2.1625 9.07222 1.79989 9.00311 1.44991C8.934 1.09994 8.76256 0.778361 8.51051 0.525914C8.25846 0.273468 7.93715 0.101519 7.58729 0.0318546C7.23743 -0.0378101 6.87476 -0.00205535 6.54524 0.134589C6.21572 0.271233 5.93417 0.502616 5.73627 0.799421C5.53838 1.09623 5.43303 1.4451 5.4336 1.80183C5.43435 2.27822 5.62373 2.73493 5.96033 3.07206C6.29692 3.40919 6.75333 3.5993 7.22973 3.60081Z",
    fill: "#EF7D00"
  }));
};
var IgusLogoOrangeVariant = function IgusLogoOrangeVariant() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "51",
    viewBox: "0 0 2048 1062"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.92585907 -0.00067474 1.85171814 -0.00134949 2.80563354 -0.00204468 C17.98153673 0.01544869 32.75790601 0.7020152 47.75 3.25 C49.27536377 3.50740967 49.27536377 3.50740967 50.83154297 3.77001953 C99.82944662 12.314301 148.93866826 30.08575667 186.75 63.25 C187.33749023 63.75917969 187.92498047 64.26835937 188.53027344 64.79296875 C213.59576278 86.64277347 229.96330212 115.2469778 234.75 148.25 C234.75 154.19 234.75 160.13 234.75 166.25 C206.37 166.25 177.99 166.25 148.75 166.25 C148.42 162.95 148.09 159.65 147.75 156.25 C144.43888204 147.19001347 139.18073265 139.39238314 132.75 132.25 C132.24339844 131.6621875 131.73679687 131.074375 131.21484375 130.46875 C105.33970912 102.40978048 63.25522993 91.12761858 26.75 87.25 C25.59757812 87.11851562 24.44515625 86.98703125 23.2578125 86.8515625 C-20.81867482 82.61564034 -74.34872502 88.58750132 -109.796875 117.51220703 C-127.33587886 132.35415491 -139.44440889 151.08232551 -141.43359375 174.40234375 C-141.97040943 191.35940384 -137.57614197 207.44116308 -126.25 220.25 C-104.77485215 241.39348534 -69.9918069 241.62345358 -41.94674683 241.78875732 C-35.45367646 241.8297663 -28.96130537 241.92228913 -22.46875 242.01171875 C-20.52318459 242.0374295 -20.52318459 242.0374295 -18.53831482 242.06365967 C150.67343425 244.46794256 150.67343425 244.46794256 208.75 292.25 C210.12285156 293.32507813 210.12285156 293.32507813 211.5234375 294.421875 C220.58182981 301.61895382 229.34817476 309.51346193 235.75 319.25 C235.75 319.91 235.75 320.57 235.75 321.25 C286.24 321.25 336.73 321.25 388.75 321.25 C388.75 327.19 388.75 333.13 388.75 339.25 C342.22 339.25 295.69 339.25 247.75 339.25 C249.73 343.87 251.71 348.49 253.75 353.25 C254.72739935 356.05850732 255.64222105 358.77485685 256.4375 361.625 C256.63899658 362.33503174 256.84049316 363.04506348 257.0480957 363.77661133 C270.36851788 412.0477679 265.76015945 468.89981651 241.18066406 512.91918945 C223.3618418 543.64021079 196.15770599 567.19431575 164.75 583.25 C164.01233398 583.6310791 163.27466797 584.0121582 162.51464844 584.40478516 C125.41340124 603.3757279 83.99507678 612.33512121 42.75 616.25 C41.75137939 616.34571289 40.75275879 616.44142578 39.72387695 616.54003906 C28.35296526 617.49180817 16.96644855 617.49350152 5.5625 617.5 C3.96304031 617.50101212 3.96304031 617.50101212 2.33126831 617.50204468 C-14.04780917 617.48560522 -30.06599383 617.00279855 -46.25 614.25 C-47.3004248 614.07307617 -48.35084961 613.89615234 -49.43310547 613.71386719 C-108.50920009 603.43744874 -168.56009486 576.10341958 -204.953125 526.58203125 C-227.74820818 493.9097326 -238.25 460.20085751 -238.25 420.25 C-209.87 420.25 -181.49 420.25 -152.25 420.25 C-151.92 425.53 -151.59 430.81 -151.25 436.25 C-144.41777889 466.5069792 -127.15385017 488.83599151 -101.32666016 505.49023438 C-49.54580138 537.67869527 21.33734386 537.19419497 78.92578125 523.8671875 C104.61150692 517.58863997 129.42048327 507.80633606 148.75 489.25 C149.6575 488.38375 150.565 487.5175 151.5 486.625 C152.2425 485.84125 152.985 485.0575 153.75 484.25 C154.19472656 483.78851562 154.63945313 483.32703125 155.09765625 482.8515625 C174.69428321 461.42591703 177.85839048 434.20229287 176.91845703 406.38183594 C176.21223087 393.25217047 172.59300944 380.20887151 164.08203125 369.96875 C162.75 368.25 162.75 368.25 161.82421875 366.15625 C160.47220872 363.75704674 159.23418538 363.342668 156.75 362.25 C155.65048303 361.39542493 154.56815942 360.51846045 153.5 359.625 C142.16343981 351.04937329 128.31286357 346.07711624 114.75 342.25 C113.6771022 341.91231913 112.60420441 341.57463825 111.49879456 341.22672462 C105.24428661 339.68441235 98.8637013 339.96149282 92.46264648 339.9715271 C91.00793397 339.96651962 89.55322423 339.9606425 88.09851837 339.95397437 C84.11462639 339.93821504 80.13080502 339.93474593 76.14688563 339.93332577 C71.84567057 339.92962461 67.54449392 339.91446555 63.24330139 339.90071106 C55.79566858 339.8784569 48.34804947 339.86343253 40.90039062 339.85334396 C30.13238281 339.83874718 19.36442272 339.81320753 8.59644294 339.78501268 C-8.87465691 339.73956287 -26.34576363 339.70294057 -43.81689453 339.671875 C-60.78663339 339.64168205 -77.75635534 339.60730566 -94.72607422 339.56738281 C-96.31157359 339.56366055 -96.31157359 339.56366055 -97.92910326 339.55986309 C-106.19575863 339.54042291 -114.46241342 339.5207404 -122.72906804 339.50098133 C-163.23602482 339.40422308 -203.74299605 339.32859815 -244.25 339.25 C-244.25 431.98 -244.25 524.71 -244.25 620.25 C-272.63 620.25 -301.01 620.25 -330.25 620.25 C-330.58 590.55 -330.91 560.85 -331.25 530.25 C-337.19 536.19 -343.13 542.13 -349.25 548.25 C-352.89110811 551.40562703 -356.42750896 554.3591746 -360.25 557.25 C-361.43537752 558.17516442 -362.62023614 559.10099391 -363.8046875 560.02734375 C-406.46277896 593.05105415 -456.75538697 613.11510192 -510.25 619.25 C-510.97960938 619.34571289 -511.70921875 619.44142578 -512.4609375 619.54003906 C-521.18663676 620.58577364 -529.97460514 620.49383816 -538.75 620.5 C-540.04673141 620.50101212 -540.04673141 620.50101212 -541.36965942 620.50204468 C-580.85340487 620.45328637 -619.15276145 612.30198871 -655.25 596.25 C-656.13284668 595.85941406 -657.01569336 595.46882812 -657.92529297 595.06640625 C-676.5373676 586.74434979 -694.00683006 576.58110264 -710.25 564.25 C-710.83475098 563.8080127 -711.41950195 563.36602539 -712.02197266 562.91064453 C-719.2477742 557.41965911 -726.13966868 551.69941443 -732.79296875 545.5234375 C-734.97099653 543.50815584 -737.18609286 541.55727564 -739.4375 539.625 C-746.27025342 533.67074345 -752.37340345 527.13535365 -758.25 520.25 C-759.45076172 518.88294922 -759.45076172 518.88294922 -760.67578125 517.48828125 C-801.45573123 470.72877813 -834.25 402.3465789 -834.25 339.25 C-838.21 339.25 -842.17 339.25 -846.25 339.25 C-846.24723462 341.48326349 -846.24723462 341.48326349 -846.24441338 343.76164341 C-846.20099286 379.19272402 -846.16806671 414.6238009 -846.14786934 450.05490262 C-846.14536826 454.42649437 -846.14277959 458.79808607 -846.14013672 463.16967773 C-846.13934979 464.47500322 -846.13934979 464.47500322 -846.13854696 465.80669891 C-846.12987085 479.85263147 -846.11411645 493.89854746 -846.09569441 507.94447023 C-846.07691728 522.38274871 -846.06586685 536.82101858 -846.06182301 551.25930876 C-846.05909407 560.15118807 -846.05051057 569.04302055 -846.03416707 577.93488543 C-846.02350346 584.05233441 -846.0204203 590.16975958 -846.02299725 596.28721715 C-846.02426414 599.80393622 -846.02247916 603.32057415 -846.01158905 606.83727837 C-845.95808614 627.13622066 -846.49794446 647.3396756 -850.0625 667.375 C-850.31797607 668.84972778 -850.31797607 668.84972778 -850.57861328 670.35424805 C-860.73917422 727.29820188 -885.88563436 782.30322005 -925.21484375 825.03125 C-927.0454442 827.02699099 -928.80836483 829.06230611 -930.5625 831.125 C-937.79565077 839.41789146 -945.761122 847.25065255 -954.25 854.25 C-954.75837402 854.67216797 -955.26674805 855.09433594 -955.79052734 855.52929688 C-969.18304989 866.60804744 -983.30982239 876.37410112 -998.25 885.25 C-999.28769531 885.88292969 -1000.32539062 886.51585937 -1001.39453125 887.16796875 C-1017.99735479 897.03512723 -1035.86163073 904.43746024 -1054.25 910.25 C-1055.07790039 910.51264648 -1055.90580078 910.77529297 -1056.75878906 911.04589844 C-1067.05480569 914.26067167 -1077.4312753 916.84778236 -1088 919 C-1088.96832764 919.19867676 -1089.93665527 919.39735352 -1090.93432617 919.60205078 C-1107.63908534 922.85627897 -1124.01423153 923.65724899 -1141 923.625 C-1142.07926758 923.62445618 -1143.15853516 923.62391235 -1144.27050781 923.62335205 C-1161.59164689 923.58330429 -1178.23594203 922.73177421 -1195.25 919.25 C-1196.31428223 919.03569336 -1197.37856445 918.82138672 -1198.47509766 918.60058594 C-1248.70693346 908.17324912 -1293.67911456 884.7953629 -1332.25 851.25 C-1333.10335938 850.51007812 -1333.95671875 849.77015625 -1334.8359375 849.0078125 C-1339.83139097 844.59435361 -1344.63119175 839.99328043 -1349.375 835.3125 C-1349.95636719 834.74418457 -1350.53773438 834.17586914 -1351.13671875 833.59033203 C-1352.54764903 832.1823766 -1353.90416007 830.72029848 -1355.25 829.25 C-1355.25 828.59 -1355.25 827.93 -1355.25 827.25 C-1355.91 827.25 -1356.57 827.25 -1357.25 827.25 C-1359.02734375 825.3359375 -1359.02734375 825.3359375 -1361.1875 822.625 C-1361.99703125 821.60921875 -1362.8065625 820.5934375 -1363.640625 819.546875 C-1364.06923828 819.00353516 -1364.49785156 818.46019531 -1364.93945312 817.90039062 C-1366.20985791 816.30055152 -1367.50023217 814.71923304 -1368.796875 813.140625 C-1406.90871329 766.2957149 -1429.02516176 709.03878364 -1436.0625 649.3125 C-1436.18665283 648.28439209 -1436.31080566 647.25628418 -1436.4387207 646.19702148 C-1437.481994 636.42259015 -1437.25 627.2545226 -1437.25 617.25 C-1409.2 617.25 -1381.15 617.25 -1352.25 617.25 C-1351.59 625.83 -1350.93 634.41 -1350.25 643.25 C-1344.51130595 682.57068148 -1331.21625343 720.2222911 -1307.25 752.25 C-1306.81896973 752.83507324 -1306.38793945 753.42014648 -1305.94384766 754.02294922 C-1300.56017586 761.29222121 -1294.72856639 768.07070672 -1288.5625 774.6875 C-1287.95696289 775.33783203 -1287.35142578 775.98816406 -1286.72753906 776.65820312 C-1253.70333207 811.49023933 -1204.14191513 835.60266963 -1155.92407227 837.45458984 C-1151.32409926 837.57645073 -1146.72626534 837.58403432 -1142.125 837.5625 C-1141.31395813 837.56067719 -1140.50291626 837.55885437 -1139.66729736 837.55697632 C-1126.99706437 837.5091353 -1114.66882166 836.96636659 -1102.25 834.25 C-1101.4770459 834.08371094 -1100.7040918 833.91742187 -1099.90771484 833.74609375 C-1073.71151466 827.90428161 -1047.90185212 817.25217059 -1026.25 801.25 C-1025.20070313 800.48300781 -1024.15140625 799.71601562 -1023.0703125 798.92578125 C-1016.24680834 793.84964945 -1009.95710797 788.37320762 -1003.80859375 782.5 C-1001.25 780.25 -1001.25 780.25 -999.03515625 779.1875 C-996.68526519 777.95342155 -996.36710432 776.61948299 -995.25 774.25 C-993.95941553 772.8954426 -992.61979578 771.58689929 -991.25 770.3125 C-953.20970603 733.00257968 -932.92907656 673.54066018 -931.93363667 621.24777222 C-931.8920208 616.10205854 -931.91802428 610.95813995 -931.95703125 605.8125 C-931.9626485 603.58235972 -931.96690847 601.35221566 -931.96989441 599.12207031 C-931.981176 593.34203288 -932.01049271 587.56223314 -932.04400635 581.7822876 C-932.07507392 575.84838066 -932.08847693 569.91443412 -932.10351562 563.98046875 C-932.13538394 552.40354321 -932.18636959 540.82679161 -932.25 529.25 C-932.94270996 530.05751709 -932.94270996 530.05751709 -933.64941406 530.88134766 C-934.26526367 531.59339355 -934.88111328 532.30543945 -935.515625 533.0390625 C-936.42489746 534.09407959 -936.42489746 534.09407959 -937.35253906 535.17041016 C-939.74229596 537.78954928 -942.33251993 540.06001207 -945.03515625 542.34765625 C-947.56601663 544.52142875 -949.99491289 546.79007861 -952.4375 549.0625 C-968.08253894 563.28917002 -985.87018407 574.89457391 -1004.25 585.25 C-1005.2402417 585.81799316 -1005.2402417 585.81799316 -1006.25048828 586.39746094 C-1034.15968042 602.33175088 -1065.65921356 612.02620708 -1097.25 617.25 C-1098.68303467 617.49556641 -1098.68303467 617.49556641 -1100.14501953 617.74609375 C-1170.79894501 629.42722097 -1247.46598294 610.58561233 -1305.625 569.1875 C-1307.85217677 567.56599599 -1310.05510535 565.91487015 -1312.25 564.25 C-1313.11915039 563.59499512 -1313.11915039 563.59499512 -1314.00585938 562.92675781 C-1321.49590796 557.25408743 -1328.60313587 551.28911237 -1335.453125 544.859375 C-1338.00859362 542.47522271 -1340.61700808 540.17257894 -1343.25 537.875 C-1396.32292199 490.05011815 -1430.2564009 414.65242527 -1436.25 344.25 C-1436.25 342.6 -1436.25 340.95 -1436.25 339.25 C-1440.21 339.25 -1444.17 339.25 -1448.25 339.25 C-1448.25 431.98 -1448.25 524.71 -1448.25 620.25 C-1476.3 620.25 -1504.35 620.25 -1533.25 620.25 C-1533.25 527.52 -1533.25 434.79 -1533.25 339.25 C-1574.83 339.25 -1616.41 339.25 -1659.25 339.25 C-1659.25 333.31 -1659.25 327.37 -1659.25 321.25 C-1617.67 321.25 -1576.09 321.25 -1533.25 321.25 C-1533.25 215.65 -1533.25 110.05 -1533.25 1.25 C-1505.2 1.25 -1477.15 1.25 -1448.25 1.25 C-1448.25 106.85 -1448.25 212.45 -1448.25 321.25 C-1444.62 321.25 -1440.99 321.25 -1437.25 321.25 C-1437.27356567 319.96258911 -1437.27356567 319.96258911 -1437.29760742 318.64916992 C-1438.47455534 244.02471247 -1416.89524852 170.67344792 -1369.25 112.25 C-1368.78674316 111.67781738 -1368.32348633 111.10563477 -1367.84619141 110.51611328 C-1352.30874872 91.42533959 -1335.00106026 73.97198517 -1315.25 59.25 C-1314.69521973 58.83298828 -1314.14043945 58.41597656 -1313.56884766 57.98632812 C-1276.89748539 30.56568862 -1233.50705271 11.52861637 -1188.25 4.25 C-1187.3955127 4.10191895 -1186.54102539 3.95383789 -1185.66064453 3.80126953 C-1113.80724859 -8.32439892 -1036.74809406 10.61578618 -977.5390625 52.5625 C-961.37281367 64.19407736 -946.33493157 77.16506843 -932.25 91.25 C-931.92 61.55 -931.59 31.85 -931.25 1.25 C-903.2 1.25 -875.15 1.25 -846.25 1.25 C-846.25 106.85 -846.25 212.45 -846.25 321.25 C-842.62 321.25 -838.99 321.25 -835.25 321.25 C-835.25 215.65 -835.25 110.05 -835.25 1.25 C-805.22 1.25 -775.19 1.25 -744.25 1.25 C-744.25 106.85 -744.25 212.45 -744.25 321.25 C-606.31 321.25 -468.37 321.25 -326.25 321.25 C-326.25 215.65 -326.25 110.05 -326.25 1.25 C-299.19 1.25 -272.13 1.25 -244.25 1.25 C-244.25 106.85 -244.25 212.45 -244.25 321.25 C-183.365 320.755 -183.365 320.755 -121.25 320.25 C-127.52 318.27 -133.79 316.29 -140.25 314.25 C-172.01923333 302.55892213 -199.06422362 281.42679543 -213.4765625 250.25 C-214.0711225 248.9181856 -214.66236139 247.58488278 -215.25 246.25 C-215.66523926 245.32960938 -215.66523926 245.32960938 -216.08886719 244.390625 C-233.01879228 206.16044434 -231.54747355 155.79064287 -217.42089844 116.97167969 C-215.58869104 112.28508604 -213.47703688 107.75983867 -211.25 103.25 C-210.95399902 102.63108887 -210.65799805 102.01217773 -210.35302734 101.37451172 C-189.5558353 58.15095808 -148.38745533 31.08735616 -104.41015625 15.5 C-70.81278302 4.11386388 -35.32390732 0.02329578 0 0 Z M-1292.25 157.25 C-1296.20028374 161.71337926 -1299.81388727 166.38240437 -1303.25 171.25 C-1303.67571289 171.85263672 -1304.10142578 172.45527344 -1304.54003906 173.07617188 C-1310.64293151 181.81016985 -1316.28128709 190.81930494 -1321.25 200.25 C-1321.63655762 200.9836377 -1322.02311523 201.71727539 -1322.42138672 202.47314453 C-1338.94475631 234.34666548 -1356.40440807 284.63236773 -1347.25 321.25 C-1208.65 321.25 -1070.05 321.25 -927.25 321.25 C-927.25 263.16229254 -939.45792334 211.11234555 -976.25 165.25 C-977.054375 164.24195313 -977.85875 163.23390625 -978.6875 162.1953125 C-989.97427779 148.32821155 -1002.69350222 135.6588618 -1017.25 125.25 C-1017.91692871 124.77111328 -1018.58385742 124.29222656 -1019.27099609 123.79882812 C-1096.5121539 68.96527137 -1199.70758367 74.55239268 -1292.25 157.25 Z M-1346.25 339.25 C-1344.67282007 352.49016108 -1344.67282007 352.49016108 -1342.0625 365.4375 C-1341.84819336 366.31204834 -1341.63388672 367.18659668 -1341.41308594 368.08764648 C-1327.03323459 425.00195914 -1291.89045464 475.82570441 -1241.4375 506.4375 C-1219.04543701 519.67683659 -1194.99624521 529.07000797 -1169.25 533.25 C-1168.20561768 533.42354004 -1168.20561768 533.42354004 -1167.14013672 533.60058594 C-1114.67581408 541.89543779 -1060.8522001 527.21814644 -1018.1953125 496.32421875 C-1016.77446885 495.28078416 -1015.35518635 494.23522031 -1013.9375 493.1875 C-1013.27951416 492.70506836 -1012.62152832 492.22263672 -1011.94360352 491.72558594 C-1007.89415167 488.68990436 -1004.3034437 485.42775897 -1000.77514648 481.80102539 C-999.08391634 480.08109821 -997.30057046 478.53082991 -995.4375 477 C-980.82617193 464.29206332 -969.26432796 447.70572687 -959.25 431.25 C-958.78231201 430.49630127 -958.31462402 429.74260254 -957.83276367 428.96606445 C-941.42439871 402.20303268 -931.36484773 370.39847733 -928.25 339.25 C-1066.19 339.25 -1204.13 339.25 -1346.25 339.25 Z M-744.25 339.25 C-742.48312007 353.45990684 -742.48312007 353.45990684 -739.625 367.375 C-739.36485107 368.43702637 -739.10470215 369.49905273 -738.83666992 370.59326172 C-728.60508769 410.9136746 -707.56393156 445.16103604 -679.25 475.25 C-678.63382813 475.90871094 -678.01765625 476.56742188 -677.3828125 477.24609375 C-648.74223193 506.91444635 -607.62864325 526.69438749 -567.25 533.25 C-566.20561768 533.42354004 -566.20561768 533.42354004 -565.14013672 533.60058594 C-514.92522923 541.53979486 -460.94093802 528.50632585 -419.65014648 498.99511719 C-411.73009731 493.1816896 -404.37814766 487.01071736 -397.25 480.25 C-395.90102145 479.09806326 -394.5471549 477.95181556 -393.1875 476.8125 C-378.70728475 464.12032753 -367.19190565 447.62938478 -357.25 431.25 C-356.59773438 430.20328125 -355.94546875 429.1565625 -355.2734375 428.078125 C-339.16430975 401.25097202 -329.6933501 370.24015086 -326.25 339.25 C-464.19 339.25 -602.13 339.25 -744.25 339.25 Z ",
    fill: "#F6F6F8",
    transform: "translate(1659.25,138.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.94505628 2.80504541 5.53045166 5.77165189 8 9 C8.4846875 8.46890625 8.969375 7.9378125 9.46875 7.390625 C15.97808142 0.53079112 22.1576537 -3.62604079 31.72265625 -4.23828125 C41.20028365 -4.48326031 50.44933121 -4.62897102 58.1171875 1.765625 C65.44328826 9.48690962 67.13315087 18.43004062 67.11352539 28.83154297 C67.11367142 29.48590836 67.11381744 30.14027374 67.1139679 30.81446838 C67.11327647 32.95707626 67.10552052 35.09959499 67.09765625 37.2421875 C67.09578933 38.73576815 67.09436672 40.22934942 67.09336853 41.72293091 C67.08956494 45.63885207 67.07975324 49.55473568 67.06866455 53.47064209 C67.05840388 57.47261039 67.05386096 61.47458481 67.04882812 65.4765625 C67.03812889 73.31772742 67.02054973 81.1588547 67 89 C60.07 89 53.14 89 46 89 C45.970271 86.29889038 45.970271 86.29889038 45.93994141 83.54321289 C45.87190883 77.56404848 45.79511497 71.58504917 45.71247292 65.60607243 C45.66272942 61.98440878 45.6163994 58.36277125 45.578125 54.7409668 C45.54099245 51.23950017 45.49456086 47.73826444 45.44193649 44.2369976 C45.41464527 42.2647704 45.39674948 40.29242031 45.37905884 38.32008362 C45.44493083 26.90723637 45.44493083 26.90723637 41.3125 16.5625 C35.91770553 12.9173686 30.63178319 12.60925789 24.36328125 13.484375 C20.62253259 14.30053834 18.72971919 15.27028081 16 18 C11.80946347 26.16797442 11.39945223 34.17789404 11.390625 43.19921875 C11.37408875 44.51541702 11.35755249 45.8316153 11.34051514 47.18769836 C11.29725407 50.64815232 11.27693574 54.10835487 11.26177979 57.56903076 C11.24205774 61.11583068 11.20010612 64.66236483 11.16015625 68.20898438 C11.08530265 75.13924808 11.03680229 82.06943067 11 89 C4.07 89 -2.86 89 -10 89 C-10.01458252 87.03208496 -10.02916504 85.06416992 -10.04418945 83.03662109 C-10.09591002 76.52255092 -10.16121457 70.00872676 -10.23571491 63.49487877 C-10.28037444 59.54689972 -10.31964004 55.59902282 -10.34643555 51.65087891 C-10.37251299 47.83813174 -10.41294611 44.02577855 -10.46318626 40.21327591 C-10.4798251 38.76133768 -10.49135794 37.30933134 -10.49761391 35.85731125 C-10.50728805 33.81770629 -10.53538366 31.77910243 -10.56762695 29.73974609 C-10.58428154 28.00100723 -10.58428154 28.00100723 -10.60127258 26.22714233 C-11.14369226 21.83701153 -12.67019383 18.48324534 -15.625 15.1875 C-19.93764769 13.03117616 -24.45041859 12.49008372 -29.1875 13.4375 C-35.2572049 15.46073497 -38.82147784 18.68504575 -41.75 24.4375 C-43.54650489 29.55753893 -44.12598463 34.3226699 -44.11352539 39.72998047 C-44.11341209 41.38101273 -44.11341209 41.38101273 -44.11329651 43.06539917 C-44.10813522 44.23748932 -44.10297394 45.40957947 -44.09765625 46.6171875 C-44.09553383 48.43562668 -44.09553383 48.43562668 -44.09336853 50.290802 C-44.08778345 54.15222673 -44.07523361 58.01359288 -44.0625 61.875 C-44.05748308 64.49739499 -44.0529205 67.1197909 -44.04882812 69.7421875 C-44.03781889 76.1614808 -44.02056444 82.58073048 -44 89 C-50.93 89 -57.86 89 -65 89 C-65 58.97 -65 28.94 -65 -2 C-58.4 -2 -51.8 -2 -45 -2 C-44.67 1.3 -44.34 4.6 -44 8 C-43.360625 7.113125 -42.72125 6.22625 -42.0625 5.3125 C-32.76245431 -5.90069794 -11.96396757 -8.11080364 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(889,819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.74765625 0.00563965 1.4953125 0.0112793 2.265625 0.01708984 C13.34781946 0.25957287 21.69241422 3.76109386 29.8515625 11.31640625 C40.53413588 22.49910011 43.06323521 35.62950429 42.98803711 50.56323242 C42.68276953 63.70068984 38.48145837 77.10544732 29.30078125 86.85546875 C21.26695262 94.11120259 11.24166858 96.9611092 0.51171875 96.59375 C-10.29021415 95.51803884 -18.67144992 92.0707317 -26.3125 84.3125 C-26.30464478 86.21310181 -26.30464478 86.21310181 -26.29663086 88.15209961 C-26.27858486 92.8353607 -26.26706947 97.51861871 -26.25756836 102.2019043 C-26.25252722 104.23218298 -26.24569443 106.26245802 -26.23706055 108.29272461 C-26.22498533 111.20427347 -26.21926966 114.1157745 -26.21484375 117.02734375 C-26.20968246 117.9408812 -26.20452118 118.85441864 -26.19920349 119.79563904 C-26.19900832 121.96825427 -26.25038195 124.14077296 -26.3125 126.3125 C-26.6425 126.6425 -26.9725 126.9725 -27.3125 127.3125 C-33.9125 127.3125 -40.5125 127.3125 -47.3125 127.3125 C-47.3125 86.0625 -47.3125 44.8125 -47.3125 2.3125 C-40.7125 2.3125 -34.1125 2.3125 -27.3125 2.3125 C-26.9825 5.2825 -26.6525 8.2525 -26.3125 11.3125 C-25.61125 10.57 -24.91 9.8275 -24.1875 9.0625 C-16.95631452 2.14571388 -9.79272559 -0.07747409 0 0 Z M-28.3125 12.3125 C-27.3125 14.3125 -27.3125 14.3125 -27.3125 14.3125 Z M-21.3125 24.3125 C-28.13165163 33.54770867 -28.36909641 45.29961367 -27.3125 56.3125 C-25.66858109 64.40768986 -23.12828478 70.98668178 -16.19140625 75.77734375 C-9.69060542 79.53220631 -3.72251065 80.39739106 3.6875 79.3125 C9.94703328 77.52706265 14.10855769 73.64736088 17.6875 68.3125 C22.9550792 58.66213029 23.33586866 45.4523771 20.625 34.875 C18.31581159 28.44613275 14.12412638 22.59088566 8.375 18.8125 C-2.21598006 14.50430472 -13.26478766 15.88156326 -21.3125 24.3125 Z ",
    fill: "#F7F7F9",
    transform: "translate(1407.3125,814.6875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.94281664 6.4600117 18.14377432 14.41624749 22.5078125 26.48046875 C25.53998164 38.34047211 23.70182305 50.06041713 17.8203125 60.60546875 C11.07576287 71.12630657 2.04832693 77.77708749 -10.1796875 80.85546875 C-21.83792982 82.88208077 -33.14123146 80.77606867 -43.109375 74.26953125 C-52.57896846 67.15957419 -58.31055637 58.88710262 -61.4921875 47.48046875 C-62.55203421 35.23061262 -61.75331958 23.89479618 -54.2421875 13.66796875 C-48.62271998 7.05401124 -42.60445289 1.73462844 -34.4921875 -1.51953125 C-33.16960937 -2.05320313 -33.16960937 -2.05320313 -31.8203125 -2.59765625 C-21.58740208 -5.43212439 -9.48344426 -4.71530585 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(187.4921875,3.51953125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.10893425 3.42411187 6.73125153 7.00625459 8.4375 12.125 C8.5484005 13.89796702 8.60373243 15.67464742 8.62695312 17.45092773 C8.64367065 18.53893173 8.66038818 19.62693573 8.6776123 20.74790955 C8.69118774 21.92293533 8.70476318 23.09796112 8.71875 24.30859375 C8.73715942 25.51564468 8.75556885 26.72269562 8.77453613 27.96632385 C8.83336331 31.83166575 8.88614308 35.69705205 8.9375 39.5625 C9.00511423 44.64462573 9.07880314 49.72660943 9.15625 54.80859375 C9.16982544 55.98159531 9.18340088 57.15459686 9.1973877 58.36314392 C9.21410522 59.45430008 9.23082275 60.54545624 9.24804688 61.66967773 C9.26057495 62.62881577 9.27310303 63.5879538 9.28601074 64.57615662 C9.42407607 66.89913913 9.78257906 68.89920639 10.4375 71.125 C13.0775 71.455 15.7175 71.785 18.4375 72.125 C18.4375 77.075 18.4375 82.025 18.4375 87.125 C9.66756045 89.31748489 2.7974791 90.62652721 -5.5625 86.125 C-8.35906139 83.77000093 -9.40021178 82.61186467 -10.5625 79.125 C-11.0265625 79.51171875 -11.490625 79.8984375 -11.96875 80.296875 C-21.36817709 87.38151781 -34.86172067 90.75571206 -46.5625 89.125 C-55.94194875 87.23794424 -63.22791156 84.18328443 -68.8984375 76.2578125 C-73.17172405 69.19628224 -73.76821501 61.42400227 -71.94921875 53.4296875 C-69.44436938 46.21307303 -65.24991501 41.6255147 -58.51904297 38.03491211 C-50.71069112 34.70237297 -42.65194207 33.68293524 -34.3125 32.5625 C-32.15777709 32.27054327 -30.00399341 31.9746393 -27.85162354 31.66578674 C-25.91000945 31.38731955 -23.9662773 31.12373808 -22.02246094 30.86108398 C-18.43139748 30.0971088 -15.70875059 29.00448628 -12.5625 27.125 C-11.56066542 25.02835267 -11.56066542 25.02835267 -11.5625 22.6875 C-11.500625 21.92566406 -11.43875 21.16382813 -11.375 20.37890625 C-11.58842864 17.81331618 -12.19349767 16.29491527 -13.5625 14.125 C-19.4627747 9.93269956 -27.14653549 9.70064305 -34.1640625 10.375 C-38.85253338 11.25310826 -42.30198422 12.48089413 -45.5625 16.125 C-46.5525 18.765 -47.5425 21.405 -48.5625 24.125 C-55.1625 24.125 -61.7625 24.125 -68.5625 24.125 C-70.31516662 18.86700013 -67.7679476 13.80429565 -65.5625 8.90234375 C-61.38921748 1.38174088 -54.75639228 -2.30349256 -46.875 -5.25 C-31.95879751 -9.4216289 -13.02771255 -9.01736024 0 0 Z M-15.9921875 42.53125 C-21.6228611 44.67005245 -27.37038313 45.22576305 -33.31640625 45.94140625 C-39.85549012 46.80731233 -44.49606728 48.19333463 -49.4375 52.8125 C-51.68738404 56.31967217 -52.32322455 58.10076534 -52.05078125 62.1640625 C-51.13987681 65.82225474 -49.31452862 67.55643996 -46.5625 70.125 C-39.61917713 73.6025959 -30.86732866 73.11792558 -23.5625 70.875 C-18.61746807 68.91872363 -15.4699457 66.85024013 -12.94140625 62.04296875 C-11.1754034 57.75298836 -11.22198722 53.7661132 -11.375 49.1875 C-11.38853516 48.40826172 -11.40207031 47.62902344 -11.41601562 46.82617188 C-11.45099776 44.92547596 -11.50479041 43.02514166 -11.5625 41.125 C-13.02609099 41.06177145 -13.02609099 41.06177145 -15.9921875 42.53125 Z ",
    fill: "#F7F7F9",
    transform: "translate(1547.5625,821.875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.88929199 0.00563965 1.77858398 0.0112793 2.69482422 0.01708984 C14.88994889 0.24313271 24.65726316 4.16467904 33.875 12.3125 C42.82737879 21.83766132 46.5891744 34.85755268 46.5 47.625 C46.49262817 48.8778479 46.49262817 48.8778479 46.48510742 50.15600586 C46.24196213 63.00529954 42.0599031 74.98190991 33.19921875 84.49609375 C23.1778983 93.54447047 10.67619909 96.68705017 -2.52734375 96.5234375 C-12.55058246 95.87985261 -20.62986838 93.08033244 -28.8125 87.3125 C-29.72 86.69375 -30.6275 86.075 -31.5625 85.4375 C-37.67032531 79.66899832 -41.20815567 73.25074184 -43.8125 65.3125 C-44.039375 64.63960937 -44.26625 63.96671875 -44.5 63.2734375 C-48.41594467 49.18691431 -46.19737255 33.53400545 -39.37109375 20.79296875 C-30.36127406 6.45403265 -16.69923637 -0.11004957 0 0 Z M-17.8125 24.3125 C-24.71665497 33.76857048 -25.64570264 43.90403309 -24.8125 55.3125 C-23.08475297 64.72052399 -18.72409803 71.85168805 -10.8125 77.3125 C-4.82035925 80.22920427 2.19045307 80.52471915 8.5703125 78.58984375 C16.78706022 74.73140899 20.74237054 68.46155622 24.1875 60.3125 C27.18565232 51.52416602 26.12937978 38.59788505 22.1875 30.3125 C18.83034284 24.40348506 14.53545104 19.9237139 8.1875 17.3125 C-1.86417859 14.87960964 -10.4760854 16.94466607 -17.8125 24.3125 Z ",
    fill: "#F7F7F9",
    transform: "translate(1005.8125,814.6875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.96884964 7.22380409 16.68741906 17.36855845 18.96875 29.54296875 C20.66399527 46.23642565 18.94202962 62.07188327 8.0625 75.5625 C-0.0644443 84.28882848 -11.58498601 88.74315822 -23.328125 89.47265625 C-35.53915751 89.84026587 -45.72640925 87.35355339 -55.75 80.3125 C-57.0803125 79.44625 -57.0803125 79.44625 -58.4375 78.5625 C-68.04529019 69.21437981 -72.74803153 56.68276209 -72.99169922 43.38745117 C-73.04501371 29.25754398 -69.99352209 15.70875592 -60.125 4.9375 C-44.07969019 -9.84512708 -18.24723005 -11.08418881 0 0 Z M-44.75 17.3125 C-51.5847172 26.82919483 -52.52834616 36.86482419 -51.75 48.3125 C-50.17121358 57.11682717 -46.36099136 63.20510142 -39.62890625 69.015625 C-33.76747442 73.06135341 -27.63119566 73.01137143 -20.75 72.3125 C-14.03964662 70.52156109 -9.66567416 65.85883952 -5.75 60.3125 C-0.46343504 50.90125248 -0.15663438 38.1728086 -2.875 27.875 C-5.45450627 20.65238243 -9.83685594 15.00914245 -16.546875 11.21875 C-26.77264203 7.01240611 -37.10916257 9.62257797 -44.75 17.3125 Z ",
    fill: "#F7F7F9",
    transform: "translate(1200.75,821.6875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.09179501 5.94989581 9.43184212 12.32973694 10.5625 21.375 C3.3025 21.375 -3.9575 21.375 -11.4375 21.375 C-12.4275 19.065 -13.4175 16.755 -14.4375 14.375 C-19.92974075 10.25581944 -27.38612086 9.93159569 -34.04296875 10.66015625 C-38.08112082 11.44407158 -40.81319894 12.02261542 -43.4375 15.375 C-44.10426878 18.83249949 -44.10426878 18.83249949 -43.4375 22.375 C-39.4215307 26.57351336 -35.01994297 27.59128104 -29.5625 28.875 C-28.72404541 29.08511719 -27.88559082 29.29523437 -27.02172852 29.51171875 C-24.49635257 30.14444082 -21.96772265 30.76197933 -19.4375 31.375 C5.09069416 37.32786086 5.09069416 37.32786086 11.5625 47.375 C14.66564769 53.44024322 14.66857568 61.44693663 12.83984375 67.94140625 C8.84721877 77.49461016 3.02464233 82.40019672 -6.4375 86.375 C-21.25717003 90.95999641 -38.14579948 91.28466744 -52.3125 84.25 C-59.41537929 79.82395209 -64.60550779 73.72687459 -67.0625 65.7109375 C-67.55616402 62.63582203 -67.4375 59.48948862 -67.4375 56.375 C-60.5075 56.375 -53.5775 56.375 -46.4375 56.375 C-45.4475 59.345 -44.4575 62.315 -43.4375 65.375 C-40.62462531 69.15783148 -37.91501656 70.13329153 -33.4375 71.375 C-25.36101621 72.05243927 -17.70513822 72.22257317 -10.4375 68.375 C-7.99002923 64.70379385 -7.61701937 61.64149927 -8.4375 57.375 C-14.92177479 49.87755727 -27.88137103 48.77604818 -37.0625 46.80078125 C-48.02839008 44.30610796 -56.92218496 40.89153887 -63.4375 31.375 C-66.53137274 25.45628693 -66.53052712 17.46347487 -64.8203125 11.06640625 C-61.99822547 4.66051844 -56.95470261 0.00059784 -50.6484375 -2.9140625 C-34.82284511 -8.84332757 -14.55154118 -9.61002344 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1880.4375,821.625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.05207885 5.93388453 9.87065177 12.47157595 11.5625 21.3125 C8.00110935 21.54553424 4.44167554 21.68711781 0.875 21.8125 C-0.63610352 21.91304687 -0.63610352 21.91304687 -2.17773438 22.015625 C-5.12871728 22.09353874 -7.58070983 22.07022715 -10.4375 21.3125 C-12.28203564 19.39782382 -13.28007234 17.66549928 -14.35083008 15.24023438 C-15.70936436 12.83021715 -16.88306862 12.28067497 -19.4375 11.3125 C-27.50311093 9.88373463 -34.51731526 9.85240763 -41.9375 13.5625 C-43.69623947 15.31086481 -43.69623947 15.31086481 -43.9375 18.25 C-43.32455332 22.00429842 -42.27606504 22.86955378 -39.4375 25.3125 C-33.56657002 28.47464182 -26.87576907 29.69285823 -20.40966797 31.06811523 C2.99534757 36.05037102 2.99534757 36.05037102 10.4765625 45.50390625 C14.77060586 52.65549645 14.91275998 61.81745466 12.9453125 69.82421875 C9.78352682 76.94523163 2.91945223 82.30063519 -4.05859375 85.46875 C-18.8631914 90.71964178 -35.7658004 91.5104229 -50.33203125 85.0234375 C-58.21231116 80.60480979 -63.63351224 75.01961988 -66.4375 66.3125 C-66.7675 63.0125 -67.0975 59.7125 -67.4375 56.3125 C-60.5075 56.3125 -53.5775 56.3125 -46.4375 56.3125 C-45.4475 59.2825 -44.4575 62.2525 -43.4375 65.3125 C-39.52547869 69.32746924 -35.51667973 71.13322023 -29.94921875 71.61328125 C-19.82348239 71.72467467 -19.82348239 71.72467467 -10.4375 68.3125 C-7.87570664 65.44018623 -7.42160278 64.09146371 -7.5 60.25 C-8.59372089 56.82300787 -9.71530543 55.62450086 -12.4375 53.3125 C-14.96496471 52.14421146 -14.96496471 52.14421146 -17.875 51.375 C-19.58429688 50.88 -19.58429688 50.88 -21.328125 50.375 C-25.31137575 49.3122671 -29.32883206 48.41421742 -33.34960938 47.50610352 C-56.12954901 42.32611196 -56.12954901 42.32611196 -62.4375 32.3125 C-65.84217514 25.98213443 -66.54962724 19.68819112 -64.78125 12.73046875 C-62.06589226 4.92381525 -57.68666351 0.95098765 -50.5625 -2.9375 C-35.51031231 -9.76899492 -13.79043759 -9.28849361 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1632.4375,821.6875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.41894383 5.72855156 9.72543255 13.69963457 10.9140625 22.6796875 C11.1705789 27.74572723 11.14836034 32.80428143 11.109375 37.875 C11.10563642 39.31802167 11.10279345 40.76104591 11.10079956 42.20407104 C11.0932295 45.9687422 11.07363952 49.73325457 11.0513916 53.49786377 C11.03078885 57.35272068 11.02176725 61.20760369 11.01171875 65.0625 C10.99038606 72.60164265 10.95525958 80.14062243 10.9140625 87.6796875 C3.9840625 87.6796875 -2.9459375 87.6796875 -10.0859375 87.6796875 C-10.1156665 85.02401733 -10.1156665 85.02401733 -10.14599609 82.31469727 C-10.21403582 76.43532254 -10.29083028 70.55609635 -10.37346458 64.67691135 C-10.42320254 61.1157825 -10.4695325 57.55468012 -10.5078125 53.9934082 C-10.55207505 49.88995529 -10.61163053 45.78684339 -10.671875 41.68359375 C-10.68342621 40.41761856 -10.69497742 39.15164337 -10.70687866 37.8473053 C-10.67804134 26.1518526 -10.67804134 26.1518526 -15.2734375 15.7421875 C-20.84357588 11.65741935 -26.06790073 11.27217436 -32.72265625 12.140625 C-38.31687259 13.41666112 -42.05340958 16.97404072 -45.0859375 21.6796875 C-48.433773 28.96517257 -48.55558284 36.12380813 -48.59765625 44.02734375 C-48.61560745 45.27978378 -48.63355865 46.53222382 -48.65205383 47.82261658 C-48.69679939 51.12198001 -48.72922987 54.4211509 -48.75549316 57.72070312 C-48.78548827 61.09974307 -48.83195242 64.47855435 -48.87695312 67.85742188 C-48.96165163 74.46475786 -49.02856807 81.07206 -49.0859375 87.6796875 C-56.0159375 87.6796875 -62.9459375 87.6796875 -70.0859375 87.6796875 C-70.0859375 57.6496875 -70.0859375 27.6196875 -70.0859375 -3.3203125 C-63.4859375 -3.3203125 -56.8859375 -3.3203125 -50.0859375 -3.3203125 C-49.7559375 0.3096875 -49.4259375 3.9396875 -49.0859375 7.6796875 C-47.3534375 5.8234375 -47.3534375 5.8234375 -45.5859375 3.9296875 C-33.66929862 -8.00808018 -14.09755393 -8.92317084 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1294.0859375,820.3203125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.04113865 1.43109909 3.83405887 2.92891353 5.640625 4.64453125 C6.47013672 5.43150391 6.47013672 5.43150391 7.31640625 6.234375 C13.19484783 12.43372406 15.640625 19.17435538 15.640625 27.64453125 C8.710625 27.64453125 1.780625 27.64453125 -5.359375 27.64453125 C-6.349375 25.00453125 -7.339375 22.36453125 -8.359375 19.64453125 C-10.58080965 15.64594887 -12.77604988 14.23816427 -16.984375 12.76953125 C-24.36720919 10.86953716 -31.81121277 11.39156377 -38.5390625 15.1640625 C-44.21450898 19.77992992 -47.04772254 26.87934815 -48.109375 33.95703125 C-49.16842614 45.34183098 -48.93225975 57.34475071 -41.546875 66.76953125 C-37.00748323 71.32021504 -32.25260568 72.80221995 -25.921875 73.08203125 C-19.82829814 72.88141967 -15.18059075 71.48733794 -10.828125 67.1015625 C-7.28875893 62.60533293 -6.88778926 59.75818829 -5.359375 53.64453125 C1.570625 53.64453125 8.500625 53.64453125 15.640625 53.64453125 C14.18861125 65.26064128 10.74881107 74.78922689 1.46875 82.43359375 C-9.93352728 90.41518784 -22.73195311 92.19552281 -36.359375 90.01953125 C-46.18897952 87.74386718 -55.31827985 82.82924081 -61.359375 74.64453125 C-70.31559781 59.78252192 -72.81590108 44.32163487 -68.734375 27.33203125 C-65.77943327 16.14183033 -59.88330458 6.35297763 -49.90625 0.109375 C-35.01447173 -7.7247967 -14.81835486 -8.51319393 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1794.359375,820.35546875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0 13.86 0 21 0 C21 8.91 21 17.82 21 27 C26.94 27 32.88 27 39 27 C39 32.28 39 37.56 39 43 C33.06 43 27.12 43 21 43 C21.08543024 50.26712689 21.17914242 57.53403226 21.28752708 64.80085564 C21.33751898 68.17497504 21.38384837 71.54906269 21.421875 74.92333984 C21.46737328 78.80064629 21.52539279 82.67759052 21.5859375 86.5546875 C21.59748871 87.76929657 21.60903992 88.98390564 21.62094116 90.23532104 C21.64081085 91.35633209 21.66068054 92.47734314 21.68115234 93.63232422 C21.69447601 94.62271698 21.70779968 95.61310974 21.7215271 96.6335144 C21.77427446 99.18735695 21.77427446 99.18735695 24 101 C25.99782924 101.46335723 25.99782924 101.46335723 28.25 101.625 C28.99765625 101.69976563 29.7453125 101.77453125 30.515625 101.8515625 C33.33914747 102.02026353 36.1714422 102 39 102 C39 107.28 39 112.56 39 118 C34.78714601 119.40428466 30.78858505 119.22437686 26.375 119.25 C25.51003906 119.270625 24.64507813 119.29125 23.75390625 119.3125 C17.41845868 119.35049369 10.49908379 118.88093558 5.40795898 114.68920898 C0.90965825 109.66851441 -0.25428596 104.28291608 -0.22705078 97.71923828 C-0.22682419 95.88801926 -0.22682419 95.88801926 -0.22659302 94.01980591 C-0.21627045 92.71647308 -0.20594788 91.41314026 -0.1953125 90.0703125 C-0.19157802 88.71125497 -0.1887331 87.35219474 -0.18673706 85.99313354 C-0.17913483 82.43225551 -0.1595161 78.87154303 -0.1373291 75.31072998 C-0.11679679 71.67071776 -0.10771962 68.03067855 -0.09765625 64.390625 C-0.07626661 57.26034284 -0.04111266 50.13019971 0 43 C-4.95 43 -9.9 43 -15 43 C-15 37.72 -15 32.44 -15 27 C-10.05 27 -5.1 27 0 27 C0 18.09 0 9.18 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1659,790)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0 13.86 0 21 0 C21 8.91 21 17.82 21 27 C26.94 27 32.88 27 39 27 C39 32.28 39 37.56 39 43 C33.06 43 27.12 43 21 43 C21.09357466 50.45668322 21.19967903 57.91304331 21.31738281 65.36938477 C21.35565843 67.90579345 21.39051376 70.44225616 21.421875 72.97875977 C21.46755563 76.62535911 21.5255463 80.27158702 21.5859375 83.91796875 C21.59748871 85.05147263 21.60903992 86.1849765 21.62094116 87.35282898 C21.64081085 88.41355118 21.66068054 89.47427338 21.68115234 90.56713867 C21.69447601 91.49757492 21.70779968 92.42801117 21.7215271 93.38664246 C22.02373737 96.22276578 22.82627223 98.41266397 24 101 C25.37446232 101.1710442 26.74960949 101.33658727 28.125 101.5 C28.89070313 101.5928125 29.65640625 101.685625 30.4453125 101.78125 C33.28740707 102.02460978 36.14750538 102 39 102 C39 107.28 39 112.56 39 118 C34.76991866 119.41002711 30.74406267 119.22440253 26.3125 119.25 C25.43916016 119.270625 24.56582031 119.29125 23.66601562 119.3125 C17.0303428 119.35214554 11.49648025 118.54473563 5.9765625 114.52734375 C-0.97869577 106.34586943 -0.28533485 96.00586098 -0.1953125 85.7734375 C-0.1924826 84.54460846 -0.18965271 83.31577942 -0.18673706 82.04971313 C-0.17561897 78.15803942 -0.15052976 74.26660315 -0.125 70.375 C-0.11495939 67.72265959 -0.10583544 65.07031555 -0.09765625 62.41796875 C-0.07570703 55.94522221 -0.04123516 49.47265125 0 43 C-4.95 43 -9.9 43 -15 43 C-15 37.72 -15 32.44 -15 27 C-10.05 27 -5.1 27 0 27 C0 18.09 0 9.18 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1062,790)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0 13.86 0 21 0 C21 41.25 21 82.5 21 125 C14.07 125 7.14 125 0 125 C0 83.75 0 42.5 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1452,783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.04464852 8.79294216 12.43781548 18.48672032 13.09765625 30.8515625 C13.12452696 41.8416825 8.92983603 52.28964905 1.48046875 60.421875 C-8.18661725 69.3611302 -18.90451943 71.54195649 -31.55078125 71.32421875 C-41.61906747 70.88580334 -49.52357779 66.3430588 -56.578125 59.38671875 C-65.06000485 50.10106974 -67.38458278 39.59139377 -67.140625 27.25 C-66.31924037 16.55896194 -61.45567312 7.15595764 -53.76953125 -0.265625 C-38.00159441 -13.42332905 -15.61191811 -12.9316419 0 0 Z M-49.6875 7.9375 C-57.23192195 17.40062679 -58.11473241 27.33238026 -56.89453125 39.046875 C-55.19129785 47.17813052 -51.64135436 53.92567624 -44.61328125 58.546875 C-35.94741486 63.49879865 -27.28043862 64.22485066 -17.4453125 62.65625 C-10.72248227 60.5289447 -4.99642732 55.33202372 -1.25 49.4765625 C3.40309046 40.49220917 4.60417145 31.00771706 2.45703125 21.03515625 C-0.45262283 12.11967773 -5.71878246 5.68374133 -13.8515625 1.01171875 C-26.39243317 -4.91102514 -40.24257327 -2.02185629 -49.6875 7.9375 Z ",
    fill: "#F7F7F9",
    transform: "translate(1968.89453125,232.953125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0 13.86 0 21 0 C21 30.03 21 60.06 21 91 C14.07 91 7.14 91 0 91 C0 60.97 0 30.94 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1701,817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.83265381 0.00523682 1.66530762 0.01047363 2.52319336 0.01586914 C3.42231445 0.0190918 4.32143555 0.02231445 5.24780273 0.02563477 C6.66609375 0.03820312 6.66609375 0.03820312 8.11303711 0.05102539 C9.06243164 0.05553711 10.01182617 0.06004883 10.98999023 0.06469727 C13.34356776 0.07652429 15.69702188 0.09300514 18.05053711 0.11352539 C19.67617097 3.36479312 19.17962671 6.93890514 19.1640625 10.51049805 C19.16420853 11.37885788 19.16435455 12.24721771 19.164505 13.14189148 C19.16380671 16.02048211 19.15601821 18.89900853 19.14819336 21.77758789 C19.14632888 23.77013107 19.14490512 25.76267471 19.14390564 27.75521851 C19.1400828 33.00611633 19.13025448 38.25698661 19.11920166 43.50787354 C19.10898254 48.86339953 19.10440694 54.21892996 19.09936523 59.57446289 C19.08863202 70.08749779 19.07103709 80.60050499 19.05053711 91.11352539 C11.79053711 91.11352539 4.53053711 91.11352539 -2.94946289 91.11352539 C-2.97201278 79.39625408 -2.99037732 67.67899708 -3.00127506 55.96170902 C-3.00650417 50.52150227 -3.01360232 45.08131108 -3.02490234 39.64111328 C-3.03573024 34.39566837 -3.04173951 29.15023847 -3.04434013 23.90478325 C-3.04619456 21.89881593 -3.04981551 19.89284947 -3.05519295 17.8868885 C-3.06240208 15.08749715 -3.06345389 12.2881686 -3.06298828 9.48876953 C-3.06658356 8.65079834 -3.07017883 7.81282715 -3.07388306 6.94946289 C-3.06161375 0.17829059 -3.06161375 0.17829059 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1106.949462890625,816.886474609375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.754375 -0.0928125 5.754375 -0.0928125 11.625 -0.1875 C13.42251709 -0.22846802 13.42251709 -0.22846802 15.25634766 -0.27026367 C22.32625431 -0.32546949 26.88477846 0.29467603 32.375 5.0625 C34.75603132 9.36667201 34.63418873 13.18809298 34 18 C32.89697999 21.04952591 32.08916707 22.40458867 29.2421875 23.9609375 C27.52685494 24.71790612 25.76494669 25.36728326 24 26 C24.45890625 26.78503906 24.9178125 27.57007813 25.390625 28.37890625 C28.61843178 33.9055082 31.8382509 39.43532159 35 45 C31.84533531 45.56783964 29.13535482 45.74528926 26 45 C23.32615676 42.37963363 21.75453772 39.28088412 20 36 C19.05035626 34.51523955 18.09264551 33.03559163 17.125 31.5625 C15 28.25471698 15 28.25471698 15 26 C12.69 26 10.38 26 8 26 C8 32.27 8 38.54 8 45 C5.36 45 2.72 45 0 45 C0 30.15 0 15.3 0 0 Z M8 7 C8 10.96 8 14.92 8 19 C10.24940295 19.08119503 12.49964871 19.13927819 14.75 19.1875 C16.00296875 19.22230469 17.2559375 19.25710938 18.546875 19.29296875 C22.16090442 18.98634861 23.53766828 18.60824768 26 16 C26.75 13 26.75 13 26 10 C22.1011344 6.90256788 19.07382151 6.66442965 14.1875 6.8125 C13.02605469 6.83957031 11.86460938 6.86664063 10.66796875 6.89453125 C9.78753906 6.92933594 8.90710937 6.96414062 8 7 Z ",
    fill: "#F7F7F9",
    transform: "translate(1926,242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0 13.86 0 21 0 C21.020625 3.114375 21.04125 6.22875 21.0625 9.4375 C21.071604 10.42032959 21.08070801 11.40315918 21.09008789 12.41577148 C21.09258545 13.18477783 21.09508301 13.95378418 21.09765625 14.74609375 C21.10551147 15.93223267 21.10551147 15.93223267 21.11352539 17.14233398 C21 19 21 19 20 20 C18.5112814 20.08669432 17.018555 20.10703494 15.52734375 20.09765625 C14.71773193 20.09515869 13.90812012 20.09266113 13.07397461 20.09008789 C12.03893799 20.08098389 11.00390137 20.07187988 9.9375 20.0625 C6.658125 20.041875 3.37875 20.02125 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1701,783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.26 0 14.52 0 22 0 C22.020625 3.114375 22.04125 6.22875 22.0625 9.4375 C22.071604 10.42032959 22.08070801 11.40315918 22.09008789 12.41577148 C22.09258545 13.18477783 22.09508301 13.95378418 22.09765625 14.74609375 C22.10551147 15.93223267 22.10551147 15.93223267 22.11352539 17.14233398 C22 19 22 19 21 20 C19.5112814 20.08669432 18.018555 20.10703494 16.52734375 20.09765625 C15.62822266 20.09443359 14.72910156 20.09121094 13.80273438 20.08789062 C12.85720703 20.07951172 11.91167969 20.07113281 10.9375 20.0625 C9.98810547 20.05798828 9.03871094 20.05347656 8.06054688 20.04882812 C5.70696935 20.0370011 3.35351523 20.02052025 1 20 C-0.1482685 17.703463 -0.11561175 16.41686833 -0.09765625 13.8671875 C-0.09515869 13.14128418 -0.09266113 12.41538086 -0.09008789 11.66748047 C-0.08098389 10.74596191 -0.07187988 9.82444336 -0.0625 8.875 C-0.041875 5.94625 -0.02125 3.0175 0 0 Z ",
    fill: "#F7F7F9",
    transform: "translate(1104,783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.88383075 1.97722293 6.99050561 4.08677409 9 8 C10.52109808 14.06080942 10.2740691 18.50801313 7 24 C3.3347606 27.92095378 0.30544732 29.79576858 -4.984375 30.12890625 C-10.0513375 29.80485632 -13.25240065 27.69884287 -16.875 24.3125 C-20.04083279 19.37752536 -20.54131798 15.50974701 -19.3125 9.8125 C-15.14070433 0.87293785 -9.42783478 -1.22129929 0 0 Z M-13 6 C-15.60339999 10.19903224 -16.34460843 12.80485891 -15.5 17.6875 C-14.64305001 20.71263672 -13.93080231 22.08344428 -11.875 24.5625 C-8.1039728 26.4480136 -5.1364424 26.82896315 -1 26 C2.02899973 24.22210886 3.5538292 22.73009767 5.375 19.75 C6.238018 15.95272078 6.18915237 12.72550901 5 9 C2.80742191 6.35766231 1.06660382 4.53330191 -2 3 C-6.62526419 2.58886541 -9.40077799 2.98443561 -13 6 Z ",
    fill: "#F7F7F9",
    transform: "translate(1913,815)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.68965517 0 9.68965517 0 13 3 C13.5 5.5 13.5 5.5 13 8 C11.5 9.8125 11.5 9.8125 10 11 C10.99 12.98 11.98 14.96 13 17 C10.625 16.8125 10.625 16.8125 8 16 C6.6875 13.4375 6.6875 13.4375 6 11 C5.34 11 4.68 11 4 11 C4 12.98 4 14.96 4 17 C3.34 17.33 2.68 17.66 2 18 C1.34 17.67 0.68 17.34 0 17 C0 11.39 0 5.78 0 0 Z M4 4 C4 4.99 4 5.98 4 7 C5.65 7 7.3 7 9 7 C9 6.01 9 5.02 9 4 C7.35 4 5.7 4 4 4 Z ",
    fill: "#F7F7F9",
    transform: "translate(1902,821)"
  }));
};

var InstagramIcon = function InstagramIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.6665H18.5C21.1666 6.6665 23.3333 8.83317 23.3333 11.4998V18.4998C23.3333 19.7817 22.8241 21.0111 21.9176 21.9175C21.0112 22.8239 19.7818 23.3332 18.5 23.3332H11.5C8.83329 23.3332 6.66663 21.1665 6.66663 18.4998V11.4998C6.66663 10.218 7.17585 8.98858 8.08228 8.08215C8.9887 7.17573 10.2181 6.6665 11.5 6.6665ZM11.3333 8.33317C10.5376 8.33317 9.77458 8.64924 9.21197 9.21185C8.64936 9.77446 8.33329 10.5375 8.33329 11.3332V18.6665C8.33329 20.3248 9.67496 21.6665 11.3333 21.6665H18.6666C19.4623 21.6665 20.2253 21.3504 20.7879 20.7878C21.3506 20.2252 21.6666 19.4622 21.6666 18.6665V11.3332C21.6666 9.67484 20.325 8.33317 18.6666 8.33317H11.3333ZM19.375 9.58317C19.6512 9.58317 19.9162 9.69292 20.1115 9.88827C20.3069 10.0836 20.4166 10.3486 20.4166 10.6248C20.4166 10.9011 20.3069 11.1661 20.1115 11.3614C19.9162 11.5568 19.6512 11.6665 19.375 11.6665C19.0987 11.6665 18.8337 11.5568 18.6384 11.3614C18.443 11.1661 18.3333 10.9011 18.3333 10.6248C18.3333 10.3486 18.443 10.0836 18.6384 9.88827C18.8337 9.69292 19.0987 9.58317 19.375 9.58317ZM15 10.8332C16.105 10.8332 17.1648 11.2722 17.9462 12.0536C18.7276 12.835 19.1666 13.8948 19.1666 14.9998C19.1666 16.1049 18.7276 17.1647 17.9462 17.9461C17.1648 18.7275 16.105 19.1665 15 19.1665C13.8949 19.1665 12.8351 18.7275 12.0537 17.9461C11.2723 17.1647 10.8333 16.1049 10.8333 14.9998C10.8333 13.8948 11.2723 12.835 12.0537 12.0536C12.8351 11.2722 13.8949 10.8332 15 10.8332ZM15 12.4998C14.3369 12.4998 13.701 12.7632 13.2322 13.2321C12.7634 13.7009 12.5 14.3368 12.5 14.9998C12.5 15.6629 12.7634 16.2988 13.2322 16.7676C13.701 17.2364 14.3369 17.4998 15 17.4998C15.663 17.4998 16.2989 17.2364 16.7677 16.7676C17.2366 16.2988 17.5 15.6629 17.5 14.9998C17.5 14.3368 17.2366 13.7009 16.7677 13.2321C16.2989 12.7632 15.663 12.4998 15 12.4998Z",
    fill: "white"
  }));
};

var LineIcon = function LineIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    width: "30",
    height: "30",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.664 10.84C18.6637 10.9794 18.6082 11.1129 18.5096 11.2113C18.411 11.3097 18.2773 11.365 18.138 11.365H16.676V12.303H18.139C18.2098 12.2999 18.2805 12.3112 18.3468 12.3362C18.4132 12.3611 18.4738 12.3993 18.525 12.4483C18.5762 12.4973 18.6169 12.5562 18.6447 12.6213C18.6726 12.6865 18.6869 12.7566 18.6869 12.8275C18.6869 12.8984 18.6726 12.9685 18.6447 13.0337C18.6169 13.0989 18.5762 13.1578 18.525 13.2068C18.4738 13.2558 18.4132 13.2939 18.3468 13.3189C18.2805 13.3438 18.2098 13.3551 18.139 13.352H16.15C16.0115 13.351 15.8791 13.2954 15.7814 13.1973C15.6836 13.0992 15.6285 12.9665 15.628 12.828V8.85202C15.628 8.56502 15.863 8.32702 16.153 8.32702H18.141C18.2746 8.33552 18.4 8.39467 18.4915 8.49239C18.583 8.59012 18.6339 8.71907 18.6336 8.85296C18.6333 8.98686 18.582 9.11561 18.4901 9.21299C18.3982 9.31036 18.2727 9.36903 18.139 9.37702H16.676V10.315H18.139C18.429 10.315 18.664 10.552 18.664 10.84ZM14.565 13.325C14.5115 13.3427 14.4554 13.3511 14.399 13.35C14.3168 13.3514 14.2354 13.3333 14.1615 13.2972C14.0876 13.261 14.0233 13.2078 13.974 13.142L11.938 10.378V12.828C11.928 12.96 11.8685 13.0834 11.7714 13.1734C11.6744 13.2634 11.5469 13.3134 11.4145 13.3134C11.2821 13.3134 11.1546 13.2634 11.0576 13.1734C10.9605 13.0834 10.901 12.96 10.891 12.828V8.85202C10.8906 8.78348 10.9038 8.71554 10.9297 8.6521C10.9557 8.58867 10.9939 8.53099 11.0422 8.48239C11.0906 8.43378 11.148 8.39521 11.2113 8.36889C11.2746 8.34257 11.3425 8.32902 11.411 8.32902C11.573 8.32902 11.723 8.41502 11.823 8.54002L13.875 11.315V8.85202C13.875 8.56502 14.11 8.32702 14.4 8.32702C14.687 8.32702 14.925 8.56502 14.925 8.85202V12.828C14.9255 12.9383 14.8909 13.0459 14.8261 13.1353C14.7614 13.2246 14.67 13.2911 14.565 13.325ZM9.61501 13.352C9.47637 13.3512 9.34365 13.2957 9.24571 13.1976C9.14777 13.0995 9.09253 12.9667 9.09201 12.828V8.85202C9.09201 8.56502 9.32701 8.32702 9.61701 8.32702C9.90601 8.32702 10.141 8.56502 10.141 8.85202V12.828C10.1402 12.9671 10.0845 13.1002 9.98595 13.1984C9.88742 13.2965 9.75408 13.3518 9.61501 13.352ZM8.08501 13.352H6.09901C5.96034 13.3507 5.82771 13.2951 5.72956 13.1972C5.63142 13.0992 5.57557 12.9667 5.57401 12.828V8.85202C5.57401 8.56502 5.81201 8.32702 6.09901 8.32702C6.38901 8.32702 6.62401 8.56502 6.62401 8.85202V12.302H8.08801C8.22724 12.302 8.36078 12.3573 8.45924 12.4558C8.55769 12.5542 8.61301 12.6878 8.61301 12.827C8.61301 12.9663 8.55769 13.0998 8.45924 13.1983C8.36078 13.2967 8.22724 13.352 8.08801 13.352M12.003 2.57202C6.49001 2.57202 2.00301 6.21502 2.00301 10.69C2.00301 14.7 5.56101 18.059 10.366 18.697C10.691 18.765 11.135 18.912 11.247 19.189C11.347 19.439 11.313 19.827 11.279 20.089L11.142 20.939C11.105 21.189 10.942 21.927 12.016 21.476C13.092 21.027 17.78 18.078 19.88 15.664C21.314 14.089 22 12.477 22 10.69C22 6.21502 17.512 2.57202 12 2.57202",
    fill: "#363636"
  }));
};

var LinkedInIcon = function LinkedInIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7833 9.16652C10.7831 9.60855 10.6073 10.0324 10.2946 10.3448C9.98188 10.6572 9.55787 10.8326 9.11585 10.8324C8.67382 10.8321 8.24998 10.6563 7.93758 10.3436C7.62517 10.0309 7.44979 9.60688 7.45001 9.16486C7.45023 8.72283 7.62604 8.29899 7.93876 7.98659C8.25147 7.67419 8.67548 7.4988 9.11751 7.49902C9.55954 7.49924 9.98338 7.67505 10.2958 7.98777C10.6082 8.30049 10.7836 8.7245 10.7833 9.16652ZM10.8333 12.0665H7.50001V22.4999H10.8333V12.0665ZM16.1 12.0665H12.7833V22.4999H16.0667V17.0249C16.0667 13.9749 20.0417 13.6915 20.0417 17.0249V22.4999H23.3333V15.8915C23.3333 10.7499 17.45 10.9415 16.0667 13.4665L16.1 12.0665Z",
    fill: "white"
  }));
};

var LocationIcon = function LocationIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "20",
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5C7.66304 4.5 8.29893 4.76339 8.76777 5.23223C9.23661 5.70107 9.5 6.33696 9.5 7C9.5 7.3283 9.43534 7.65339 9.3097 7.95671C9.18406 8.26002 8.99991 8.53562 8.76777 8.76777C8.53562 8.99991 8.26002 9.18406 7.95671 9.3097C7.65339 9.43534 7.3283 9.5 7 9.5C6.33696 9.5 5.70107 9.23661 5.23223 8.76777C4.76339 8.29893 4.5 7.66304 4.5 7C4.5 6.33696 4.76339 5.70107 5.23223 5.23223C5.70107 4.76339 6.33696 4.5 7 4.5ZM7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 12.25 7 20 7 20C7 20 0 12.25 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM7 2C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7C2 8 2 10 7 16.71C12 10 12 8 12 7C12 5.67392 11.4732 4.40215 10.5355 3.46447C9.59785 2.52678 8.32608 2 7 2Z",
    fill: "#363636"
  }));
};

var MotionPlasticsLogo = function MotionPlasticsLogo(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: conditionalClassname(!!className, className),
    width: "148",
    height: "22",
    viewBox: "0 0 148 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.570312 5.14742H3.03537V6.79269H3.10368C3.90355 5.62847 4.84004 4.82861 6.7358 4.82861C8.17613 4.82861 9.52252 5.4463 10.0491 6.79269C10.9401 5.58293 12.0132 4.82861 13.7496 4.82861C16.2402 4.82861 17.7005 5.94728 17.7005 8.81369V16.9689H15.0959V10.0491C15.0959 8.15331 14.9821 6.87239 12.9497 6.87239C11.1906 6.87239 10.4362 8.01098 10.4362 10.0263V16.9461H7.8317V9.37445C7.8317 7.72918 7.33072 6.88377 5.75377 6.88377C4.40738 6.88377 3.17201 8.00529 3.17201 9.94659V16.9575H0.570312V5.14742Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5234 11.0425C18.5234 7.45593 20.7152 4.82863 24.484 4.82863C28.2527 4.82863 30.4474 7.45593 30.4474 11.0425C30.4474 14.6746 28.2527 17.2763 24.484 17.2763C20.7152 17.2763 18.5234 14.6746 18.5234 11.0425ZM27.8428 11.0425C27.8428 9.01012 26.8153 6.88379 24.484 6.88379C22.1527 6.88379 21.128 9.01012 21.128 11.0425C21.128 13.0749 22.1556 15.2211 24.484 15.2211C26.8124 15.2211 27.8457 13.0977 27.8457 11.0425H27.8428Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0586 5.14744H32.0227V1.60641H34.6272V5.14744H36.9784V7.08875H34.6272V13.3937C34.6272 14.4697 34.7183 15.0162 35.8825 15.0162C36.2502 15.0313 36.6183 15.0007 36.9784 14.9251V16.9347C36.419 17.0142 35.8553 17.0598 35.2904 17.0714C32.5464 17.0714 32.091 16.021 32.0227 14.0569V7.08875H30.0586V5.14744Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0039 0.65567H40.6084V3.12357H38.0039V0.65567ZM38.0039 5.15596H40.6084V16.966H38.0039V5.15596Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5234 11.0425C41.5234 7.45592 43.7152 4.82861 47.484 4.82861C51.2527 4.82861 53.4616 7.45592 53.4616 11.0425C53.4616 14.6746 51.267 17.2763 47.484 17.2763C43.701 17.2763 41.5234 14.6746 41.5234 11.0425ZM50.8428 11.0425C50.8428 9.0101 49.8153 6.88377 47.484 6.88377C45.1527 6.88377 44.128 9.0101 44.128 11.0425C44.128 13.0749 45.1556 15.2211 47.484 15.2211C49.8124 15.2211 50.8428 13.0977 50.8428 11.0425Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2422 5.14742H56.7101V6.88377L56.7556 6.92932C57.133 6.28953 57.6707 5.75924 58.3156 5.39082C58.9606 5.02241 59.6905 4.82863 60.4333 4.82861C63.0151 4.82861 64.6148 6.175 64.6148 8.84785V16.9575H62.0017V9.53386C61.9334 7.68364 61.2474 6.88377 59.6932 6.88377C57.9569 6.88377 56.8467 8.25578 56.8467 9.98929V16.9575H54.2422V5.14742Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9197 5.14743H75.382V6.74716H75.4247C76.1562 5.37515 77.551 4.82863 79.0824 4.82863C82.8028 4.82863 84.6103 7.63811 84.6103 11.1108C84.6103 14.3074 82.9878 17.2763 79.5151 17.2763C78.0064 17.2763 76.364 16.7298 75.5641 15.4261H75.5186V21.3212H72.9141L72.9197 5.14743ZM78.7437 6.88379C76.5519 6.88379 75.4303 8.52906 75.4303 11.0653C75.4303 13.4392 76.643 15.2211 78.7437 15.2211C81.1205 15.2211 82.0114 13.1204 82.0114 11.0653C82.0114 8.93895 80.8899 6.88379 78.7437 6.88379Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5039 0.655678H88.1084V16.966H85.5039V0.655678Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4617 14.3188C99.4617 14.9593 99.5983 15.2098 100.079 15.2098C100.293 15.219 100.506 15.2066 100.717 15.1728V16.9774C100.183 17.1417 99.63 17.2374 99.0717 17.2621C97.9986 17.2621 97.267 16.8977 97.0621 15.8388C96.0345 16.8436 94.3665 17.2621 92.9717 17.2621C90.8027 17.2621 88.9297 16.1235 88.9297 13.815C88.9297 10.9144 91.1898 10.3992 93.3617 10.1373L94.7991 9.9523C96.3989 9.74735 97.0165 9.49686 97.0165 8.46928C97.0165 7.09727 95.5933 6.86956 94.5714 6.86956C93.1083 6.86956 92.0807 7.46447 91.9669 8.74254H89.3623C89.5474 5.70534 92.1035 4.81439 94.7308 4.81439C97.0393 4.81439 99.4588 5.75089 99.4588 8.23018L99.4617 14.3188ZM96.86 11.0311C96.3334 11.3499 95.9463 11.441 94.8475 11.5776L93.7972 11.7143C92.6102 11.8765 91.5371 12.332 91.5371 13.5873C91.5371 14.7771 92.6557 15.2098 93.7744 15.2098C95.1436 15.2098 96.86 14.6177 96.86 12.9724V11.0311Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.777 13.1802C103.94 14.7116 105.058 15.2354 106.45 15.2354C107.455 15.2354 109.146 15.0304 109.078 13.6812C109.009 12.332 107.114 12.1526 105.218 11.7171C103.322 11.2816 101.426 10.6184 101.426 8.21024C101.426 5.62848 104.213 4.82861 106.359 4.82861C108.782 4.82861 110.996 5.81065 111.295 8.46073H108.577C108.323 7.20258 107.344 6.88377 106.177 6.88377C105.423 6.88377 104.031 7.06595 104.031 8.09638C104.031 9.37445 105.949 9.5794 107.868 9.98929C109.786 10.3992 111.682 11.1108 111.682 13.4392C111.682 16.2487 108.85 17.2763 106.405 17.2763C103.413 17.2763 101.244 15.9527 101.176 13.166L103.777 13.1802Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.568 5.14744H113.527V1.60641H116.131V5.14744H118.482V7.08875H116.131V13.3937C116.131 14.4697 116.222 15.0162 117.386 15.0162C117.754 15.0312 118.122 15.0006 118.482 14.9251V16.9347C117.922 17.0143 117.357 17.0599 116.791 17.0714C114.05 17.0714 113.595 16.021 113.527 14.0569V7.08875H111.562L111.568 5.14744Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.504 0.65567H122.108V3.12357H119.504V0.65567ZM119.504 5.15596H122.108V16.966H119.504V5.15596Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.094 9.10119C130.889 7.63809 129.862 6.88377 128.401 6.88377C127.052 6.88377 125.156 7.61532 125.156 11.1791C125.156 13.1432 126.01 15.2211 128.288 15.2211C129.816 15.2211 130.849 14.2391 131.094 12.5255H133.699C133.22 15.6083 131.325 17.2763 128.29 17.2763C124.59 17.2763 122.555 14.6518 122.555 11.1791C122.555 7.61532 124.499 4.82861 128.381 4.82861C131.123 4.82861 133.451 6.19777 133.702 9.09834L131.094 9.10119Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.864 13.1802C137.024 14.7116 138.145 15.2354 139.537 15.2354C140.542 15.2354 142.233 15.0304 142.165 13.6812C142.096 12.332 140.201 12.1526 138.305 11.7171C136.409 11.2816 134.519 10.6184 134.519 8.21024C134.519 5.62848 137.306 4.82861 139.452 4.82861C141.874 4.82861 144.089 5.81065 144.388 8.46073H141.669C141.416 7.20258 140.434 6.88377 139.27 6.88377C138.515 6.88377 137.123 7.06595 137.123 8.09638C137.123 9.37445 139.042 9.5794 140.961 9.98929C142.879 10.3992 144.775 11.1108 144.775 13.4392C144.775 16.2487 141.943 17.2763 139.497 17.2763C136.506 17.2763 134.337 15.9527 134.266 13.166L136.864 13.1802Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.355 8.45505C146.137 8.46028 145.921 8.42081 145.719 8.33907C145.517 8.25733 145.334 8.13506 145.181 7.97981C145.028 7.82457 144.909 7.63963 144.83 7.43644C144.751 7.23324 144.715 7.01609 144.724 6.7984C144.73 6.47858 144.83 6.1677 145.013 5.90468C145.195 5.64167 145.45 5.43822 145.747 5.31982C146.044 5.20142 146.37 5.17333 146.683 5.23908C146.996 5.30482 147.283 5.46148 147.507 5.68942C147.732 5.91736 147.884 6.20645 147.945 6.52048C148.005 6.83451 147.972 7.15952 147.849 7.45479C147.726 7.75006 147.519 8.00248 147.253 8.18041C146.987 8.35834 146.675 8.45387 146.355 8.45505ZM146.355 5.43208C146.18 5.43247 146.007 5.46878 145.846 5.53878C145.685 5.60877 145.541 5.71095 145.421 5.83901C145.302 5.96706 145.21 6.11827 145.151 6.28329C145.092 6.44831 145.068 6.62362 145.08 6.7984C145.08 7.55272 145.566 8.16756 146.355 8.16756C146.699 8.14035 147.02 7.98445 147.254 7.73095C147.489 7.47745 147.619 7.14498 147.619 6.79982C147.619 6.45467 147.489 6.12219 147.254 5.86869C147.02 5.61519 146.699 5.45929 146.355 5.43208ZM146.028 7.74628H145.726V5.91314H146.42C146.864 5.91314 147.089 6.0697 147.089 6.43974C147.093 6.50463 147.084 6.56963 147.061 6.63067C147.039 6.69171 147.004 6.74749 146.959 6.79451C146.915 6.84154 146.86 6.87879 146.801 6.90395C146.741 6.92911 146.676 6.94162 146.611 6.94072L147.124 7.74628H146.785L146.309 6.9635H146.025L146.028 7.74628ZM146.363 6.70731C146.588 6.70731 146.788 6.68454 146.788 6.42266C146.788 6.16079 146.568 6.17502 146.389 6.17502H146.028V6.71016L146.363 6.70731Z",
    fill: "#363636"
  }));
};

var NavArrowIcon = function NavArrowIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className ? className : ''),
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.119141L6.59 1.52914L12.17 7.11914H0V9.11914H12.17L6.59 14.7091L8 16.1191L16 8.11914L8 0.119141Z",
    fill: "currentColor"
  }));
};

var PersonIcon = function PersonIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12178_378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12178_378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var PinterestIcon = function PinterestIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.619 18.2217C13.0946 20.9697 12.4548 23.6042 10.5586 24.9805C9.97281 20.8269 11.4177 17.7075 12.0888 14.3957C10.9445 12.4702 12.2262 8.59495 14.639 9.5496C17.6078 10.7241 12.0683 16.7089 15.7866 17.4565C19.6696 18.2367 21.255 10.7192 18.8475 8.27471C15.3685 4.74456 8.72082 8.19432 9.53809 13.2485C9.73692 14.4839 11.0133 14.8586 10.0483 16.5642C7.82172 16.0701 7.1575 14.3142 7.24277 11.9731C7.38067 8.14077 10.6858 5.458 14.0015 5.08667C18.1945 4.61737 22.1297 6.62565 22.673 10.5701C23.2852 15.0224 20.7808 19.844 16.2969 19.497C15.0814 19.4025 14.5712 18.8001 13.619 18.2217Z",
    fill: "white"
  }));
};

var TiktokIcon = function TiktokIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1012 9.63516C20.9746 9.56975 20.8514 9.49804 20.732 9.42031C20.3849 9.1908 20.0666 8.92037 19.784 8.61484C19.0769 7.80586 18.8129 6.98516 18.7156 6.41055H18.7195C18.6383 5.93359 18.6719 5.625 18.6769 5.625H15.4566V18.0773C15.4566 18.2445 15.4566 18.4098 15.4496 18.573C15.4496 18.5934 15.4477 18.6121 15.4465 18.634C15.4465 18.643 15.4465 18.6523 15.4445 18.6617C15.4445 18.6641 15.4445 18.6664 15.4445 18.6687C15.4106 19.1155 15.2674 19.5471 15.0275 19.9256C14.7876 20.304 14.4583 20.6177 14.0687 20.8391C13.6627 21.0701 13.2035 21.1912 12.7363 21.1906C11.2359 21.1906 10.0199 19.9672 10.0199 18.4562C10.0199 16.9453 11.2359 15.7219 12.7363 15.7219C13.0203 15.7216 13.3026 15.7663 13.5727 15.8543L13.5766 12.5754C12.7568 12.4695 11.9239 12.5346 11.1306 12.7667C10.3373 12.9988 9.60064 13.3928 8.96718 13.9238C8.41213 14.4061 7.9455 14.9815 7.58828 15.6242C7.45234 15.8586 6.93945 16.8004 6.87734 18.3289C6.83828 19.1965 7.09882 20.0953 7.22304 20.4668V20.4746C7.30117 20.6934 7.6039 21.4398 8.09726 22.0691C8.49509 22.5739 8.96511 23.0174 9.49218 23.3852V23.3773L9.5 23.3852C11.059 24.4445 12.7875 24.375 12.7875 24.375C13.0867 24.3629 14.0891 24.375 15.2273 23.8355C16.4898 23.2375 17.2086 22.3465 17.2086 22.3465C17.6678 21.8141 18.0329 21.2074 18.2883 20.5523C18.5797 19.7863 18.6769 18.8676 18.6769 18.5004V11.8941C18.716 11.9176 19.2363 12.2617 19.2363 12.2617C19.2363 12.2617 19.9859 12.7422 21.1555 13.0551C21.9945 13.2777 23.125 13.3246 23.125 13.3246V10.1277C22.7289 10.1707 21.9246 10.0457 21.1012 9.63516Z",
    fill: "white"
  }));
};

var WhatsappIcon = function WhatsappIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9598 2.03704C11.3148 1.38879 10.5466 0.874806 9.69985 0.525076C8.85313 0.175345 7.94491 -0.00313607 7.02814 4.16986e-05C3.18693 4.16986e-05 0.0562815 3.11503 0.0562815 6.93702C0.0562815 8.16202 0.3799 9.35201 0.984925 10.402L0 14L3.69347 13.034C4.71357 13.587 5.8603 13.881 7.02814 13.881C10.8693 13.881 14 10.766 14 6.94402C14 5.08903 13.2754 3.34603 11.9598 2.03704ZM7.02814 12.705C5.98693 12.705 4.96683 12.425 4.07337 11.9L3.86231 11.774L1.66734 12.348L2.25126 10.22L2.11055 10.003C1.53208 9.08389 1.22492 8.02149 1.22412 6.93702C1.22412 3.75903 3.82714 1.16904 7.0211 1.16904C8.56884 1.16904 10.0251 1.77104 11.1156 2.86303C11.6555 3.39781 12.0834 4.03389 12.3744 4.73443C12.6655 5.43496 12.8139 6.186 12.8111 6.94402C12.8251 10.122 10.2221 12.705 7.02814 12.705ZM10.208 8.39302C10.0322 8.30902 9.17387 7.88902 9.01909 7.82602C8.85729 7.77002 8.74472 7.74202 8.62512 7.91002C8.50553 8.08502 8.17487 8.47702 8.07638 8.58902C7.97789 8.70802 7.87236 8.72202 7.69648 8.63102C7.5206 8.54702 6.95779 8.35802 6.29648 7.77002C5.77588 7.30802 5.43116 6.74102 5.32563 6.56602C5.22714 6.39102 5.31156 6.30002 5.40301 6.20902C5.4804 6.13202 5.57889 6.00602 5.66332 5.90802C5.74774 5.81002 5.78291 5.73302 5.8392 5.62102C5.89548 5.50202 5.86734 5.40403 5.82513 5.32003C5.78291 5.23603 5.43116 4.38203 5.29045 4.03203C5.14975 3.69603 5.00201 3.73803 4.89648 3.73103H4.55879C4.4392 3.73103 4.25628 3.77303 4.09447 3.94803C3.9397 4.12303 3.48945 4.54303 3.48945 5.39703C3.48945 6.25102 4.11558 7.07702 4.2 7.18902C4.28442 7.30802 5.43116 9.05801 7.17588 9.80701C7.59095 9.98901 7.91457 10.094 8.16784 10.171C8.58291 10.304 8.96281 10.283 9.26533 10.241C9.60301 10.192 10.2995 9.82101 10.4402 9.41501C10.5879 9.00901 10.5879 8.66602 10.5387 8.58902C10.4894 8.51202 10.3839 8.47702 10.208 8.39302Z",
    fill: "#363636"
  }));
};

var WhatsAppIcon2 = function WhatsAppIcon2() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    version: "1.0",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 360.000000 360.000000",
    preserveAspectRatio: "xMidYMid meet"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,360.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1630 3608 c-294 -27 -621 -150 -870 -326 -122 -86 -336 -300 -422\r\n-422 -136 -191 -251 -456 -298 -686 -79 -385 -28 -797 144 -1149 251 -514 714\r\n-870 1282 -986 132 -26 406 -36 552 -19 615 71 1156 461 1423 1025 205 436\r\n226 962 54 1406 -252 652 -834 1093 -1530 1159 -125 11 -199 11 -335 -2z m465\r\n-692 c121 -31 293 -114 390 -187 436 -328 575 -909 335 -1394 -206 -416 -658\r\n-667 -1109 -617 -129 14 -257 49 -359 97 l-73 35 -295 -87 c-162 -47 -296 -84\r\n-299 -82 -2 3 36 131 85 286 l90 280 -39 84 c-121 262 -150 524 -87 771 112\r\n439 473 767 922 838 107 17 327 5 439 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 2759 c-291 -41 -553 -227 -694 -491 -76 -142 -120 -340 -107\r\n-488 12 -148 71 -329 145 -450 17 -28 31 -54 31 -60 0 -5 -25 -77 -55 -161\r\n-30 -84 -52 -155 -50 -157 3 -3 80 18 173 45 l168 51 97 -48 c219 -108 440\r\n-132 672 -74 93 23 270 116 353 184 311 260 421 700 267 1078 -70 172 -224\r\n352 -382 446 -185 109 -410 155 -618 125z m-132 -453 c17 -17 117 -248 117\r\n-270 0 -8 -22 -42 -49 -76 -31 -38 -47 -67 -44 -79 9 -35 119 -166 183 -217\r\n72 -59 176 -114 213 -114 18 0 38 17 79 68 29 37 62 68 73 69 11 1 76 -26 145\r\n-60 l125 -62 3 -48 c8 -125 -117 -229 -273 -229 -112 0 -327 88 -453 187 -83\r\n65 -222 218 -291 321 -118 175 -122 361 -10 477 44 46 47 47 106 47 40 0 67\r\n-5 76 -14z"
  })));
};

var TwitterIcon = function TwitterIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03901 7L13.2164 15.8249L7 23H8.39907L13.8415 16.7181L18.2389 23H23L16.475 13.6787L22.2612 7H20.8621L15.8499 12.7855L11.8001 7H7.03901ZM9.09644 8.10107H11.2837L20.9422 21.8988H18.755L9.09644 8.10107Z",
    fill: "white"
  }));
};

var YoutubeIcon = function YoutubeIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: css$Z.social__icons,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 17.4998L17.6584 14.9998L13.3334 12.4998V17.4998ZM22.9667 10.9748C23.075 11.3665 23.15 11.8915 23.2 12.5582C23.2584 13.2248 23.2834 13.7998 23.2834 14.2998L23.3334 14.9998C23.3334 16.8248 23.2 18.1665 22.9667 19.0248C22.7584 19.7748 22.275 20.2582 21.525 20.4665C21.1334 20.5748 20.4167 20.6498 19.3167 20.6998C18.2334 20.7582 17.2417 20.7832 16.325 20.7832L15 20.8332C11.5084 20.8332 9.33335 20.6998 8.47502 20.4665C7.72502 20.2582 7.24169 19.7748 7.03335 19.0248C6.92502 18.6332 6.85002 18.1082 6.80002 17.4415C6.74169 16.7748 6.71669 16.1998 6.71669 15.6998L6.66669 14.9998C6.66669 13.1748 6.80002 11.8332 7.03335 10.9748C7.24169 10.2248 7.72502 9.7415 8.47502 9.53317C8.86669 9.42484 9.58335 9.34984 10.6834 9.29984C11.7667 9.2415 12.7584 9.2165 13.675 9.2165L15 9.1665C18.4917 9.1665 20.6667 9.29984 21.525 9.53317C22.275 9.7415 22.7584 10.2248 22.9667 10.9748Z",
    fill: "white"
  }));
};

var css$Y = {"breakpoints":"'../../../styling/breakpoints.css'","md":"i__const_md_0","lg":"i__const_lg_1","contentNavigation__content__wrapper":"ContentNavigation-module_contentNavigation__content__wrapper__xpjtj","contentNavigation__link":"ContentNavigation-module_contentNavigation__link__mkQqq","contentNavigation__card__wrapper":"ContentNavigation-module_contentNavigation__card__wrapper__EM4P6","download_icon_image__wrapper":"ContentNavigation-module_download_icon_image__wrapper__O5IbN","contentNavigation__card_teaserView":"ContentNavigation-module_contentNavigation__card_teaserView__wcY9g","download_icon_image_teaserView__wrapper":"ContentNavigation-module_download_icon_image_teaserView__wrapper__vDEbQ","contentNavigation__themed_primary":"ContentNavigation-module_contentNavigation__themed_primary__MIfPW","contentNavigation__themed_secondary":"ContentNavigation-module_contentNavigation__themed_secondary__srEZy","contentNavigation__themed_color1":"ContentNavigation-module_contentNavigation__themed_color1__Bs6-2","contentNavigation__themed_color2":"ContentNavigation-module_contentNavigation__themed_color2__jMPzJ","contentNavigation__card__no__image":"ContentNavigation-module_contentNavigation__card__no__image__dZLNo","contentNavigation__image__wrapper":"ContentNavigation-module_contentNavigation__image__wrapper__0XmF0","contentNavigation__card_teaserImage":"ContentNavigation-module_contentNavigation__card_teaserImage__TSTy0","contentNavigation__image":"ContentNavigation-module_contentNavigation__image__Nu3kv","contentNavigation__card__text":"ContentNavigation-module_contentNavigation__card__text__z36JR","contentNavigation__card__text_teaserView":"ContentNavigation-module_contentNavigation__card__text_teaserView__jus-k","download_icon":"ContentNavigation-module_download_icon__aMbaU","contentNavigation__arrow__icon":"ContentNavigation-module_contentNavigation__arrow__icon__8Bkw5","contentNavigation__icon__wrapper":"ContentNavigation-module_contentNavigation__icon__wrapper__A2ZPG","download_icon__themed":"ContentNavigation-module_download_icon__themed__YBH5J","icon__font__custom":"ContentNavigation-module_icon__font__custom__XWStP","icon__font__material":"ContentNavigation-module_icon__font__material__ZFxQP","icon__font__white":"ContentNavigation-module_icon__font__white__gJTal","icon__font_size":"ContentNavigation-module_icon__font_size__TBURB","icon__font_container":"ContentNavigation-module_icon__font_container__W9DcF","contentNavigation__themed_primary_font":"ContentNavigation-module_contentNavigation__themed_primary_font__WYjCz","contentNavigation__themed_secondary_font":"ContentNavigation-module_contentNavigation__themed_secondary_font__h7cu5","contentNavigation__themed_color1_font":"ContentNavigation-module_contentNavigation__themed_color1_font__c-SxR","contentNavigation__themed_color2_font":"ContentNavigation-module_contentNavigation__themed_color2_font__Ve7rb","contentNavigation__content__four_columns":"ContentNavigation-module_contentNavigation__content__four_columns__Dku-C"};

function _createForOfIteratorHelper$4(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$4(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$4(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$4(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$4(r, a) : void 0; } }
function _arrayLikeToArray$4(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var checkLinkLength = function checkLinkLength(linkData) {
  return linkData.length > 24 ? linkData.slice(0, 24) : linkData;
};
var renderNavigationLinkType = function renderNavigationLinkType(dynamic_link, links, subpath_links) {
  var _a, _b;
  if (dynamic_link && subpath_links && subpath_links.length > 0) {
    var mappedLinks = subpath_links === null || subpath_links === void 0 ? void 0 : subpath_links.map(function (item) {
      return {
        external: false,
        variant: LinkVariant.Secondary,
        target: TargetValues.Self,
        title: item.name,
        href: item.slug,
        _uid: item.uuid,
        anchor: item.anchor,
        rel: item.rel
      };
    });
    return checkLinkLength(mappedLinks);
  }
  if (dynamic_link && subpath_links && subpath_links.length === 0) {
    return [];
  }
  var renderLinks = [];
  var _iterator = _createForOfIteratorHelper$4(links),
    _step;
  try {
    var _loop = function _loop() {
      var linkItem = _step.value;
      var imageExist = (linkItem === null || linkItem === void 0 ? void 0 : linkItem.image) && (linkItem === null || linkItem === void 0 ? void 0 : linkItem.image[0]);
      var _linkPropsMapper = linkPropsMapper(linkItem),
        title = _linkPropsMapper.title,
        href = _linkPropsMapper.href,
        external = _linkPropsMapper.external,
        target = _linkPropsMapper.target,
        variant = _linkPropsMapper.variant,
        anchor = _linkPropsMapper.anchor;
      if (linkItem.download) {
        linkItem.download.length > 0 && linkItem.download.map(function (download) {
          var _a, _b, _c, _d, _e, _f;
          renderLinks.push({
            image: imageExist,
            external: false,
            variant: variant,
            target: TargetValues.Self,
            title: download.name,
            href: ((_b = (_a = download.asset) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.embed_link) || '',
            _uid: linkItem._uid,
            anchor: anchor,
            icon: download.icon,
            name: download.name,
            asset: {
              item: {
                filename: (_d = (_c = download.asset) === null || _c === void 0 ? void 0 : _c.item) === null || _d === void 0 ? void 0 : _d.filename,
                embed_link: (_f = (_e = download.asset) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.embed_link
              }
            },
            component: 'download_content_navigation',
            rel_nofollow: download.rel_nofollow
          });
        });
      }
      if (imageExist && !linkItem.download) {
        renderLinks.push({
          image: imageExist,
          title: title,
          href: href,
          variant: variant,
          external: external,
          target: target,
          _uid: linkItem._uid,
          anchor: anchor,
          rel: (_a = linkItem.link) === null || _a === void 0 ? void 0 : _a.rel
        });
      } else if (!linkItem.download) {
        renderLinks.push({
          title: title,
          href: href,
          variant: variant || '',
          external: external,
          target: target,
          _uid: linkItem._uid,
          anchor: anchor,
          rel: (_b = linkItem.link) === null || _b === void 0 ? void 0 : _b.rel
        });
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return checkLinkLength(renderLinks);
};
var iconSizes$2 = [{
  width: 25,
  height: 50
}];
var teaserSizes = [{
  width: 105,
  height: 120
}];

var NavigationCard = function NavigationCard(_ref) {
  var href = _ref.href,
    target = _ref.target,
    variant = _ref.variant,
    title = _ref.title,
    external = _ref.external,
    teaser_view = _ref.teaser_view,
    anchor = _ref.anchor,
    icon = _ref.icon,
    component = _ref.component,
    image = _ref.image,
    rel_nofollow = _ref.rel_nofollow,
    rel = _ref.rel;
  var _a, _b, _c, _d;
  var imageUrl = ((_b = (_a = image === null || image === void 0 ? void 0 : image.image) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.embed_link) || (image === null || image === void 0 ? void 0 : image.icon);
  return /*#__PURE__*/React.createElement(Link, Object.assign({
    href: href,
    target: target,
    variant: variant,
    title: title,
    external: external,
    className: css$Y.contentNavigation__link,
    showExternalIcon: false,
    anchor: anchor,
    download: component === 'download_content_navigation'
  }, rel_nofollow && {
    rel: RelType.NO_FOLLOW
  }, rel && {
    rel: rel
  }), /*#__PURE__*/React.createElement("span", {
    className: chainConditionalClassnames(css$Y.contentNavigation__card__wrapper, imageUrl ? '' : css$Y.contentNavigation__card__no__image, teaser_view ? css$Y.contentNavigation__card_teaserView : '', getVariantClassName(variant, css$Y, ComponentNames.ContentNavigation), conditionalClassname(!!icon && !!variant, css$Y.download_icon__themed), conditionalClassname(!!icon && !variant, css$Y.download_icon), conditionalClassname(!!icon && !!imageUrl, css$Y.download_icon_image__wrapper), conditionalClassname(!!icon && !!imageUrl && !!teaser_view, css$Y.download_icon_image_teaserView__wrapper))
  }, image && (/*#__PURE__*/React.createElement("span", {
    className: chainConditionalClassnames(css$Y.contentNavigation__image__wrapper, teaser_view ? css$Y.contentNavigation__card_teaserImage : '')
  }, (image === null || image === void 0 ? void 0 : image.component) === 'image_atom' ? (/*#__PURE__*/React.createElement(Image, {
    alt: image.alt_text,
    imageSizes: teaser_view ? teaserSizes : iconSizes$2,
    src: (_d = (_c = image === null || image === void 0 ? void 0 : image.image) === null || _c === void 0 ? void 0 : _c.item) === null || _d === void 0 ? void 0 : _d.embed_link,
    className: chainConditionalClassnames(css$Y.contentNavigation__image, teaser_view ? css$Y.contentNavigation__image_teaser : '')
  })) : (image === null || image === void 0 ? void 0 : image.icon) && (/*#__PURE__*/React.createElement("span", {
    className: conditionalClassname(!!teaser_view, css$Y.icon__font_container)
  }, /*#__PURE__*/React.createElement(IconFont, {
    icon: image === null || image === void 0 ? void 0 : image.icon,
    className: "".concat((image === null || image === void 0 ? void 0 : image.icon.type) == 'material' ? css$Y.icon__font__material : css$Y.icon__font__custom, " ").concat(conditionalClassname(!!variant, css$Y.icon__font__white), " ").concat(conditionalClassname(!!teaser_view, css$Y.icon__font_size))
  }))))), icon && setDownloadIcon({
    icon: icon,
    variant: variant ? DownloadIconTheme.Light : DownloadIconTheme.Dark
  }), /*#__PURE__*/React.createElement("span", {
    className: chainConditionalClassnames(css$Y.contentNavigation__card__text, teaser_view ? css$Y.contentNavigation__card__text_teaserView : '')
  }, title), !teaser_view && (/*#__PURE__*/React.createElement("span", {
    className: css$Y.contentNavigation__icon__wrapper
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    className: css$Y.contentNavigation__arrow__icon
  })))));
};
var ContentNavigation = function ContentNavigation(_ref2) {
  var dynamic_links = _ref2.dynamic_links,
    links = _ref2.links,
    view = _ref2.view,
    text = _ref2.text,
    subpath_links = _ref2.subpath_links,
    separator = _ref2.separator,
    teaser_view = _ref2.teaser_view;
  var renderLinks = renderNavigationLinkType(dynamic_links, links, subpath_links);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator,
    spacingWithoutSeparator: !separator
  }, /*#__PURE__*/React.createElement(Row, null, text && hasTextContent(text) && (/*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$Y.contentNavigation__content__wrapper, " ").concat(view ? css$Y.contentNavigation__content__four_columns : '')
  }, !!renderLinks.length && renderLinks.map(function (link) {
    return /*#__PURE__*/React.createElement(NavigationCard, Object.assign({
      key: link._uid
    }, link, {
      teaser_view: teaser_view
    }));
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$X = {"breakpoints":"'../../../styling/breakpoints.css'","xl":"i__const_xl_0","main_wrapper":"ContentOneColumn-module_main_wrapper__-EiNe","with_background_color":"ContentOneColumn-module_with_background_color__sLU1p","contentOneColumn__themed_primary":"ContentOneColumn-module_contentOneColumn__themed_primary__RhY9o","contentOneColumn__themed_secondary":"ContentOneColumn-module_contentOneColumn__themed_secondary__fMw8a","contentOneColumn__themed_color1":"ContentOneColumn-module_contentOneColumn__themed_color1__Lmdlo","contentOneColumn__themed_color2":"ContentOneColumn-module_contentOneColumn__themed_color2__ofJvo","contentOneColumn__themed_primary_font":"ContentOneColumn-module_contentOneColumn__themed_primary_font__EKya4","contentOneColumn__themed_secondary_font":"ContentOneColumn-module_contentOneColumn__themed_secondary_font__5ctg8","contentOneColumn__themed_color1_font":"ContentOneColumn-module_contentOneColumn__themed_color1_font__vvxMB","contentOneColumn__themed_color2_font":"ContentOneColumn-module_contentOneColumn__themed_color2_font__EWM29","horizontal__line":"ContentOneColumn-module_horizontal__line__Z8C4n","lines__marginBottom":"ContentOneColumn-module_lines__marginBottom__WFJ1U"};

var ContentOneColumn = function ContentOneColumn(_ref) {
  var _ref$background_color = _ref.background_color,
    background_color = _ref$background_color === void 0 ? false : _ref$background_color,
    children = _ref.children,
    variant = _ref.variant,
    lines = _ref.lines;
  var className = [css$X.main_wrapper];
  if (background_color) {
    className.push(css$X.with_background_color);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, lines && (/*#__PURE__*/React.createElement("hr", {
    className: "".concat(css$X.horizontal__line, " ").concat(getVariantClassName(lines, css$X, ComponentNames.ContentOneColumn), " ").concat(conditionalClassname(!!lines, css$X.lines__marginBottom))
  })), /*#__PURE__*/React.createElement(Col, {
    className: "".concat(className.join(' '), " ").concat(background_color && variant ? getVariantClassName(variant, css$X, ComponentNames.ContentOneColumn) : '')
  }, children), lines && (/*#__PURE__*/React.createElement("hr", {
    className: "".concat(css$X.horizontal__line, " ").concat(getVariantClassName(lines, css$X, ComponentNames.ContentOneColumn), " ").concat(conditionalClassname(!!lines, css$X.lines__marginBottom))
  })));
};

var igusEuLocale = new Set(['fr-DE', 'en-DE', 'es-DE']);
var isIgusEuDomain = function isIgusEuDomain(locale) {
  return igusEuLocale.has(locale);
};
var igusEuDomainHeader = function igusEuDomainHeader(locale, country, language) {
  var _a;
  if (isIgusEuDomain(locale)) {
    return {
      language: (_a = locale.split('-')[0]) !== null && _a !== void 0 ? _a : '',
      country: 'INT'
    };
  }
  return {
    language: language,
    country: country
  };
};

var img$33 = "data:image/webp;base64,UklGRqIAAABXRUJQVlA4IJYAAAAwBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwD8APyA5ALsAnkQDDiU7Ml2CAAD++E6f89TsYIzzf5O3dG3XX7Wt5r7AUJ9YXnZbLzkX1fTdQPkLXimoEzPfzwf/6sWxMwiv75uiicUXxB8x6H//86Of+Qy2onKdhmOoE+caTMe4uv+YCUm/keQ/ZD95D95KAAA=";

var img$32 = "data:image/webp;base64,UklGRmYAAABXRUJQVlA4IFoAAACwAwCdASoYABAAPlEgjkQjoiGYBAA4BQSzAE6ZQAGhi9gSaQwQ4AD+9oJb+1t/6H3i1tn/9tv/UJkH/7nx0p33f/voB/t2/Nv8HJJ//eStqogJ2Jkn0mGAAAA=";

var img$31 = "data:image/webp;base64,UklGRqYAAABXRUJQVlA4IJoAAACwBACdASoYABAAPlEejEQjoaEYBAA4BQS2ADuC+AfhWD6AN8A/QAdM645F4+uoAP7/Gt3eGsvOFHflZhXLE93+Y0LtOTV3C8wp/Kvio1RVjmaKYbVI/dkpTe6ZkB/5jc8S0o206Dg3qvH//zEOVenq4QHIZZP//0odK9Pmr5QWHryNO0B6+RfJzMDNVXntdrtdr/tdr/tXIAAA";

var img$30 = "data:image/webp;base64,UklGRoABAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov+ZGwBWUDggSAEAANAHAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCPCfAJNXgs2SAc717DP7RftH7RDvqrkfzP8wD9gB9tCUzioNhGPzL7AAAAP7+LVfPY83LHLVvn9nNT/sznUzkeuO/rfz1/wYJCYY/n94xF24RFR/jbfKSYwUtpkwH7R517OPXQS9G9GQU9/OXSg9RIP7yfXvboVckFcaOUcTRGkr4JeqJgfsHEv3FbBZnpgS3hwGIp5nmPP/9brVXy9TennGGU6XaRwxuP/j/+f+KvjhhUEzf4fxtV9f9titatZj/hFQfxiL/r3ZDj//9Qx/wx1XV9AmlOwLL/TFRyB/ydqzDdRxlYijgYn/st4iHt1xh/vtEw1fiberDMQ9NphiPw7Th1U4f/kVzTz44VA7dzv842eb+bNryb/+t2JqUf6/95HRVM1P/s2AAAAA=";

var img$2$ = "data:image/webp;base64,UklGRqoAAABXRUJQVlA4IJ4AAABQBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwD8YOEAJMD2tIQawljdxQjdMdEAA/uv32Wk4ikW0+jVk5Ub3EMzJUXphq27Lrs85/1dElFPlJG/NSDy5u7G4/7//B59cuYQ5rX/4GqbsVNZP8k/wu0korCmvBt79a/Hv42ug8E6rE3lQNakUFVvXXbt+ilY3cL0BggzsKcRgAA==";

var img$2_ = "data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAACQBACdASoYABAALjkolEohI6Ojg4A4S2ADsASYD+AfiBigH9A9v8D0P5q10wAA/vtlnR/5XpSVf/dtM1xsaKUON/6hWmG56FZdUt//+ywU/Upf9LBT9SlubQopurW5wBUAAA==";

var img$2Z = "data:image/webp;base64,UklGRuAAAABXRUJQVlA4INQAAABwBgCdASoYABAAPlEejUQjoaEYBAA4BQS2AE6XgTyD8SfxmQQASmbxd+x3qh75WOrYWenLKOt509+ZrxAA/vhNJIdjurODyuF/iI2//fI6SlmPEK316zLn/pSW9GgX6x397PNeUO1H5T+VBfh9HT6K+Bs/pj84T8xE2e+P8hdoDvV7fZJM4OpaDZ2penQl+Dj+f4KGQrmYDkOf+dOEm4/f/xIUwT+ZgONJSDCjX+KXPHsAkK+lynP+a0FQpcdVw+YtLOBl/VEPXa/JAl05eQ/fITdAAA==";

var img$2Y = "data:image/webp;base64,UklGRhoBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSCQAAAABH6AgbQPGv+Tu2oiI+CkUBCDD0Fw03ew2iOj/BOCZocJnwjNWUDgg0AAAAFAHAJ0BKhgAEAA+USCNRCOiIRgEADgFBLYATplCOBvQPwAqQP//tAfwDEAfwD+Qfqr71V3R9X+iAAIXCNKOO5RpaQAA+dLt/dN/2qodkgtKlUCVBiy1zJTgNYn+nE/U+7fNl4jawBgyHmwmjALv/zNXEIyxwrSnv3MKdmLNYcKSp699D/4qTb3CBeKqFGxbG4xjND4DiR/oJ//xzs0YedFRiYXod//qiOIeZS/178Q2va7QK2MytoFKnP6Cn4z5/3jjJ5y+tAgFoYzI73ygAAA=";

var img$2X = "data:image/webp;base64,UklGRroAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSB8AAAABF3Dk/4iIQUHbNkzCn0lp7kKI6P8ESP1LK/UjrdQ/AFZQOCB0AAAAsAQAnQEqGAAQAD5RFJJHI5EQjAA4BQS2AE6QHDYBhAH8A9v+7AAMCi+7jgaOYAD++Eu34Pv/8c/paWP/1GnbiG1tnqJW+MieOPv/tNBlI57//qaDKRz3//U0G4kR/8gNtR1UOXAMtA9cL6cwe1xZPigAAAA=";

var img$2W = "data:image/webp;base64,UklGRlIBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBQAAAABD9D/iAgIBJL2Fx8hov+BCCCANlZQOCAYAQAAkAYAnQEqGAAQAD5RHoxEI6GhGAQAOAUEswBOiP1dxA3qr1/yWd+Jf5R9gD+L/0gaKYDda0IKjyaIlQrHAADMJvGRgWXEM0c6QdefddRXWakU/jTVoEvpf7pHcEt7N1SvXzvGEa/W8HQxy7rFtFO4ZtD/46Woviz7rijbvsDA9jdP5XXj+mGQdgbJ5NGG9/gbto8LIUrLG+5AXrvv5Tpq4e0ceB7b8k/wjkbW/Cwr/2B7SPTvaTv/ya8v/bersf1H/sD2wMu6h97WVkJPJ2P/1B+r74pD441JKBOpXax/uGUPDfMjM7ExHfudt9/2o7pMbK7VUgyirtma/jf/0P/w+0Wei48RDH/i7/5B/g7Ki/iw3ypbvUAAAA==";

var img$2V = "data:image/webp;base64,UklGRq4AAABXRUJQVlA4IKIAAADwBQCdASoYABAAPlEejUQjoaEYBAA4BQS2AE6ZQjwfQZwJ//20P7p+QGKjfoB79ACfm5A1TIpfQABhS8yTG5LneJJSTPgWf013aUgPkSGyZWUdfMa/jS1kPpL+vY8lmavqNRO6F/3/ffFdB8ve2w6JUr/xf7v6zes32ff/LNBxej4KK/sXQ9mbMa39RHSCCEe03/E8DWc0YIf7ICnf1XPOIAA=";

var img$2U = "data:image/webp;base64,UklGRh4BAABXRUJQVlA4IBIBAAAQCACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwD8YKUB/gPxm3QC4YOAA/VXrIv2c9EkvQGwjzOP8QNJFs9olaMmb0qYAAP7zZvCeUlwPc/5t11FMLIc/+8iO1/9eJOW1J9bP0YOh6Y83hadnPIg74jKtLos935ZtQLcpdk8zxoiC0z1klg8Xu5fZzpEd8vy+PW/6y5P9t6s+O17Vlyzf/VU3EEQ6jxv/zoj59VP+3BXz9Xc1dyiRE8rnh4eCr/v/8IH/x2//oLN/OVAv0x3Co+yby7v/14b9SD+v/uTP8ThkhAGyjQaX4hG+FNWPS37/+OeotP/q784Khf+EgbXvZ+qffLDMa1QPUaq/rUAA";

var img$2T = "data:image/webp;base64,UklGRqwAAABXRUJQVlA4IKAAAAAQBQCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQjgbwD8IOEC7AA/QAc87NBnebp4gAP79U/f7nRrKf+K9xnY3/9uF1Ij3QTI8um9yS//Vxbd6uXjIxPdqvs7f+wefnSBVmHFYSF0Ly0/u4c900Mv+Q3CbrPg//nplPbc0NbPnyXYG1Mf6fM/9WmkAPqtY3X/YB7QpqJC8KaxHxBJJHAAA";

var img$2S = "data:image/webp;base64,UklGRqQAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggbAAAAPADAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCO43QCaAOkABG8gAA/vCbQ1PPrCF3/+xz/E7T/IKvL+5dk8Yv9vRP5i+a1//3Hf5O6f0SvePkLevEx5j2R+dhtPs+L/z0f/Xo/1ffvyAAAA==";

var img$2R = "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAABQAgCdASoYABAAAQAcJaAB3BfAPwA/YACIxgAA/u5X///eiI///olX5f//lkvj/M4xRtdWZ558+/89o/88IAAA";

var img$2Q = "data:image/webp;base64,UklGRroAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3Fw8hov8TEJ8BAFZQOCCAAAAAEAQAnQEqGAAQAD5RIIxEI6IhGAQAOAUEtgBOmUFArDzAIN/eDsMgvsAA/tiaODxy/MI9qifnPPw2KxW7d4dwb5i/1C42B/dk6hgz/4Vr8HbaMpGnpa60ses5v/gTv/3sXQgJxQH8Fb2rm9Po0J0//x2TO3Rf06aCgmWM7h7f3AA=";

var img$2P = "data:image/webp;base64,UklGRo4AAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3B08hov8TkG4cAFZQOCBUAAAAsAIAnQEqGAAQAAEAHCWwAdIBLQP4BhAAHVNqZUeAAP7/dmb3mv/8vT55LnTpV52uFKxT9dRn6///hcrPJv0ldWTf8sed/7ENDeEjn//YhnaC7AAA";

var img$2O = "data:image/webp;base64,UklGRqwAAABXRUJQVlA4IKAAAADwAwCdASoYABAAPlEejEQjoaEYBAA4BQSxAA7QAiAPIpGcveOlHFYAAP7+7X42paHZvYxZ5+b21t9lJqD5OofxBxzrC3/jzm3CIx8P8E26piv/XAxiTRVN9DdmjYJdN11J8P6Pfm62xILcu59qs6LA3ofav/I/9661cfy+P+1Q0bHhVHv8g///fktZedMdTCRDNRGl/7P/v9l31Vh0WQAA";

var img$2N = "data:image/webp;base64,UklGRpYBAABXRUJQVlA4IIoBAADQCgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbyv8M9EA0gRsD+AYgD9QP1V9//TAN4z/Z30M6OA3yc2A/2nlZ+YPRN/yfWA/QD2Of1uH1kYjwNErnk3cS69Z5AAD+9mP7qzWvB/W8VNOGJAPso4yLL+ZFu+hb5bRQUbF56/93/1cVIxZE6GCmF2G5pJv9o0JA/8ysBhtP18pQFYlbWww8bJeKa2qv6SvS4+F+OHzrl3z6oLAO/3fZ1efo9dzKmhm6Y/4PXwn7G5TNZxmC+raqBvX/ylgFzt8t/hwNofaBApu/37JTl8m7hyzp/lz8v/flYkbP1fuT7ZRz/TtJ8G/A//mJeJ17N4Kb/LnPumH3P+qP+8mWhVfUfyk0VBa6gPhNNUbGXTQXTuhWQDSumRh8tmep3F8m+ZFkyDo4hnVj8cc5csLH3PPGpFt4u5kPGO3Owy/Hl92/ydtPcM/tZww0qrk8z928a4/+vf+Or/fx61YNhFflrf/7e/8qsMQLdz4V9b66uAAA";

var img$2M = "data:image/webp;base64,UklGRpIAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggWgAAALADAJ0BKhgAEAA+USCORCOiIZgEADgFBLUAWI3HmYABZedBIqEyAP7wy79RHgdfm7ol2/+4H1MH18HQ0Ijv/6yvbDZ/+/yif/k4/37f9GBfn90zDkFIOAgAAA==";

var img$2L = "data:image/webp;base64,UklGRpYBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBAj+xzmI6P8EyGgDAFZQOCBcAQAAcAkAnQEqGAAQAD5RII1EI6IhGAQAOAUEtgBOmUI4G8g+QCsAuwHi5euPpgHPi+y5LIJBAy1X8gJ8z/qvJr7Sept/nN5AHT8nOeyPuN/N/+oFA/pgAP7+gcZyZ3Qxxd0hftt/SOQSafc5WPnD/Ej/53YNMAGa/PYMP9h7/FhYOPTXGve/ePeUUVCx8KTlJ3DQ6TZr6r4BQU3ZBho9euc+RZ1MYdyVQVPTD5HU6OeSd5qMZ3B9n0D/n/7sIzANF1Yzc07iVeSWgtBmNs1592+DdA7etG3w2ADLLBdAMP+A38tZc5Rapy6ertzlK5qOaxL6/9Oz7QtZ73/3/Sf+yEecOh77cn5RDnaMmGY+4xw/2//3ADqQf+6jfHuqDGGUb9t1/bsp4Gsys2rO/pGruPR9+A1DPSSo/E7PM7+f+Ef6s8/oY/zSfyQJXyPaEd5S/OQzW4psnSnlP4jAIAAA";

var img$2K = "data:image/webp;base64,UklGRqQAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBcAAAABD3Dk/4iIQCZtU/+m820WIvqfPTTRAwBWUDggZgAAABAEAJ0BKhgAEAABABwlsAHYA/AD8QJgB/AMIA/wH8A9/+7AAYFF96sgAP7yng+Zj/xP7FN396D//g87Nu///dR+sfm6vgiuOGclqf1YuGclqf//3saXzutvpUNcnCPmrLiIGEgAAA==";

var img$2J = "data:image/webp;base64,UklGRn4BAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggRgEAALAIAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCO5vAPwlfgB/QNsA/XLLAOej/YD4AP1V9Hl4gMcEmhdSv9gBxGNfp3gwOvS8t6D6AAAD+6NBfFHSE1SiF3vp18CEE8CIUfq8Jc86pq86Z0aNAyfl/+/5JZYf2mTIoO7vBrfqyWPyYSc4xbVuWjCsbv9v4//yNh/n6yr4CMSTCCfVR/egpnsax/hseG5qxBJ+ObU6yRf/lX0rOFHgvEyT/k7y8THxlh1aONq7Y9jHxopF29T8zvLxMftKV93wnf/P/6D1eJUyi3efi4pBVL/LjyoNW1mCaBxyp12abw3rrEa+JPyLHz0wkRGA3NlqPVS1vvDgse5u9t5Nmj074Un//L526yWIL83/8vH+zi1Q9txjn/6Wxftl5U8S3vh84/l1VOnjnpM/8xQAA";

var img$2I = "data:image/webp;base64,UklGRswAAABXRUJQVlA4IMAAAABwBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgRYD7Ad4B7/9k3AWVK1wjLQm/zmw3AAP7+Le9fKzGG/J9QHRgUt4TgtK29vUaD6Z9SHTyumPx/If6jFCzq154XtadbGxGBctlOh/7yQ5o7A+Haoo7Wcnb9m1b3xyIt78Av/OS+HhBME+xvtef4ySIz4fqb//gcUrr+yj+0fLONIeVd1rW0NTb2/sA1QafPJTLZ3wOX3dwvitzPDB17s0AuAAA=";

var img$2H = "data:image/webp;base64,UklGRrQAAABXRUJQVlA4IKgAAABQBQCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQjub0n8M1t/5JmRBAv9cnr3B1eF16AAA/vwQvXoMqkJ04tfcKBlBilRTZDn4+vPdMDfN5+EIXscW0vjEpf/dPVkWxlPYzCjm/0Bf8dgmg4k8cyiO8i/RId1t5zgI5lY1QjKq2rf3m0/YDDpzGKfWVl62YoRc7rdgz+QfZScNcqZGhqG6GacH1ubKAAA=";

var img$2G = "data:image/webp;base64,UklGRqwAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBQAAAABD3D//4iIIBBI2h98hYj+p8vkAVZQOCByAAAAkAQAnQEqGAAQAD5RII5EI6IhmAQAOAUEoAnTKDGD1/7qv6AfwC6/wHj9y8PAAP7DIXBH//oc89v/ycV8GX/+oRDv//mNqp+QXdVsJsiePz8CZMkzNin6CpIOTioLql4Xv0vcDFpipxgKQUSDUuagTUAA";

var img$2F = "data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAAAQAwCdASoYABAAPlEejUQjoaEYBAA4BQS2AFiNQABBboAA/vFNr/FtI6E3E//3sF/7sF/7P+ueNz7sP8qf/Hb/yopYC+T++iyFOgAA";

var img$2E = "data:image/webp;base64,UklGRvgAAABXRUJQVlA4IOwAAAAwBwCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjubyWmA//+1h/Y8QB+GftVXdV+qo9CT/CjMn2mTCa0aLoEds6AA/sB/tE5LW/qPZAfdy2y5g8DmVUfmmXy+drb+l2cte8cy3V0p/9W4FFCOK5Jr/ct+HrR/mSsR5g6/91Hlqg+t4fglLF3scEnqG9WA1YQVa0tZubT8eoD4P/xQoWZX9DyZEenbpW/kRSoPy9CSpLLZL1sz//gUUoYU5KBF/c1vtQidBuz1Buh9qJPplzkCnPm+0QpeEFBrMvDV0r9L5zriBJs9eZUr32AAAA==";

var img$2D = "data:image/webp;base64,UklGRvQAAABXRUJQVlA4IOgAAABwBwCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbyD8Jf2A/wHIBEAPEBz/+cV/5n+q5YB+oBrABJOKuhLB4eeS3gAD+9Xv4nf+Eftvp/5wfc3Jr1E7QWzmTX/WgMyaw+gERfPWMGTFd2/Ex/u04fpnUfj5cBgynvzHcqRy8r7n3x/V2uVElCbL//kQRmqXjfQK8sgWi1zF/+Jws9DgNfuv+Gd38HTSrWeiVkSfQf0XDXGn9qT/4vqfzQuYfZC7TA9RknPnXGLX2WmyhKH7kbGh6oPlhCL/Ch1qRKf7w1/hQ61n/lIgA";

var img$2C = "data:image/webp;base64,UklGRngBAABXRUJQVlA4IGwBAAAwCQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjub0nXAJwA/kG2Mf5n/AWcB+zPwAfsB+x3sVmACmHeJ36D9Df/GcCB+xwrn7l/dADsMBPpAAM3OJ7MqrEIARnJGlotvHmJTO7SK3axZjbp7XpmTisRueD8qc9AUFKJH8ZbytQMAYE1p6luvPwgNnHkQgndZBDdf4kbqPZ69g8eEN7vu9tVzypwLdHhaXsTFb1a9bhUs8LOe//iRWvc/4nbbAFC1jhjtFWDH9QGPsB0VYaO6fWGuEKEfGmb/+RNX135+RaeVL//8ucMPui1ysa6P6JWfnwmGWpTv/8XMFfujGnsa7ueynvzi8OhvKKHsy/wcPJf+8Uhy3DQ3kivPtTZdzzPnubJjQJyn/vCfiW5Aavscvz+8kxWKu0IP4ArvWaT8jQ8tkG3/5td9j7UzszzD9/1RGnYlr4W+ff+So7LMAxpf/ZhJ6Pp49FWUgAAA";

var img$2B = "data:image/webp;base64,UklGRtQAAABXRUJQVlA4IMgAAACwBgCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQjuRYF/mXdred/mf9AygDyj/2MpUCPAvzPtAfwANdt9FKAD+/MacYF8uv2Jf4bPfaPy6eCfI5lZ6hf+zZK//61xHoZ/5xf+dajzF/NxnOAIklVqJ4Cae/mHcL5sfPVUH8w5by28/8OLFyqrpg52EKB//a91pD6fcPoVBR0b+plJ14TcQsfRbV4Chjd493fpfkFS56GeQcafb+5bQeRZ+SrZXUHTHfftb1vAAAA==";

var img$2A = "data:image/webp;base64,UklGRvAAAABXRUJQVlA4IOQAAABQBwCdASoYABAAPlEejUQjoaEYBAA4BQS2AE6ZQjubwD8SeEC7ATYBc/+lPew95ABTE/Gy8A/QAcDq8cuSUvpfupQAAP7oyXw3uWKiPFaUAAl1At1L6d0vXp/qsTHpoxc0CFbhzlbop/j31f3p/3dZX03fmI8cQ1BaByH9FgAqpuTGLm8Fz7c4h/+xNP/+3IyUIvD//25GShGR9brND3i3kZ/+Aaeo0Gu0+xP/Skf+XJRaVucXrWhWdQCE6hqliAf/nf//3B+Lij+SVZBONPT/A7/Lmy6LFH8k53HlRp1VfTbJAAA=";

var img$2z = "data:image/webp;base64,UklGRhQBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBIAAAABD3D//4iIIBBI2t98goj+R8xWUDgg3AAAAJAGAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCOBvAPxg4QHwAiwDnuvYzb4DH0m5VCS8oDjj5eaHQYAAA/vVv2kO+ELaDktyU5ASvgV09oy4DmjaIHv/kitsJJTX3sn8oGa89XthTErjUvSR//r8Tdk2d7KJv4aGdGVr1H8Je7dcpHiz//y8lGyv1amavh+t+Yf/nxYIrptnW/Qf1gPr3qw+Vo7PiXs5n6abz/+YD69y2Plcs807LhnzKvBEE6xeNft9CRl+LsDNCHz6IXPdr8cEm/K7OOIOgAAA=";

var img$2y = "data:image/webp;base64,UklGRpwAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBMAAAABD/CE/4iIIBBI2h99gYj+B3oBAFZQOCBiAAAA0AMAnQEqGQAQAD5RII5EI6IhmAQAOAUEtQBOmUI4G8lAL+KRH4YAAP6L2/1N1l5xXbbcfzDQRv/uhx7/dD28Oq/dD/2Qz7VWUfQAnfOU3y7n/+/W+oP/H/I4E//I45fAAAA=";

var img$2x = "data:image/webp;base64,UklGRpoAAABXRUJQVlA4II4AAABwAwCdASoYABAAPlEejEQjoaEYBAA4BQS1AE6ADdc7tv+vXAAA/vip3C1uiTHvWGpVvqve1b47/w6feAJn5/6Sf+SOP/bWxi+X5U3rPGvtGQc+SHuMku+3+boOBmn8cbHXcRPf+ez059u0qkx1RVeHXT3O0C/+FdcbH170g4r93//Ehf+I0TMxBhE/wgAA";

var img$2w = "data:image/webp;base64,UklGRpgAAABXRUJQVlA4IIwAAAAQBQCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQjgbyD8JfwA5ALsAFWAPghPzNQ5gAP70JPabHA6RCettgUaAan978dBpevt7Kx6I9ZcVqj8RfwIj0v5AdwH8vmmBvvVS4G3tAXQmLH/wjL/+ptARP5JymKIhJffWc37oJnElOLc+Lc+I/NwR5OQAAA==";

var img$2v = "data:image/webp;base64,UklGRq4AAABXRUJQVlA4IKIAAADwAwCdASoYABAAPlEejEQjoaEYBAA4BQSzAFqLQA/CgDCcMlTptPcAAP74VeYAfaZSgzbd6Md9YZb74UTcs6fkq0uT0Wkn/lnBv8OLBTcuaRAyk225Ot2FZBzeBVCtpeoYr8wKIYf6m33Jo/pSbtopbv8j9b9ZKys/+11g8Vw04764OToyxtv/72waQfuP/zrvXS//Cm48VpX/xIX/hApvYAA=";

var img$2u = "data:image/webp;base64,UklGRmAAAABXRUJQVlA4IFQAAABQAwCdASoYABAAAQAcJagCxGoBJgP4B+AF3/3aqDA1gC9ZYAD+/fdPf7O3GuX/45t/5HHc+pfZvmVUvs3//JT+u7iNYhS6yXjSi/J6wOMFlAFS8AA=";

var img$2t = "data:image/webp;base64,UklGRvwAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSDMAAAABL6CgbRumbxt/wiuNiIh+j4KCtm2YvvFnfRFE9F9IkGBzCtrqgq2o5cGw36jlAVsZ9gUAVlA4IKIAAADQBQCdASoZABAAPlEUkkcjkRCMADgFBLYATpANGAP4B+VWKAf4D2/0DN/gE5/UHRYnMT1krktEAP7sWP+8mATlf6DlV/b9J4jv6MtV/aVJ/nJc6dAAF+UZZp+gPBNe9DZH9i5plxk7rkyMTVclpiaUMuJtKoF33+idE4Y4SA8/gK/o0e+SshfBL4MJ5C2zv+9aKjlsSyHQggEqhkfFKQHIIAA=";

var img$2s = "data:image/webp;base64,UklGRmIBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCsAAAABJ6AgbQOme/4lz0ZExCcZCtq2Yfr4w+4Ogoj+TwDqfFHHA3c5cMcDdbkAAFZQOCAQAQAAcAcAnQEqGQAQAD5RHoxEI6GhGAQAOAUEtgBOmUI7m9JpgNAA2wD1/9MA53n2UvJgRKTN4s+T+swy6ODrT3iDFIKG5zAA/vhVtP5mSfqge3/qWT11dZ+XdND9eqMadzBhl7IKKk1gnY1F6/RSt1fFs/ebB9qHQvaz1Lw9ejvLh2r1wAkQOxNCJB6+Nn5bO5mp8FLR38O7smrgZqG9Ti5ZVXHyJowtx3p7ffxhyKIn/+cx6e28kBMeftfzoM7E6Rzd3CtF1dv9v3raGP6YzQnCzonVtLkgQS/88T+PVVX/ih+nd/kkAGz3FeLJf9OJ7Kf1O+BgU5Krtj/7osD/5eq2P+6Oqge62tTm6m09Fia6AAA=";

var img$2r = "data:image/webp;base64,UklGRlQBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSC8AAAABN0AmbQP95t/vYiMiAl9BQds2TLvHH/UfgIj+T4Aiaw9IypEO5pBjDjlJuaZsAgBWUDgg/gAAAFAGAJ0BKhkAEAA+UR6MRCOhoRgEADgFBLYATplBjBpgP8BoQHr/2SdXAXwA2MXzAMCzG8fjDyrjpjCAAP772plf+hoSZ3irCOW+SJQblB+VWsVcysY70AV0XgfilnnCLSubYeP3jjGnW7EN7Mip6ZhCeX95n3/ZeZ7e8zr5yQwPisYxokSJhFqynbU0VwHvsc4LvYwC0iGf/4M7FRufjJP7qkQGOQQzO2D+uTUOu93/NPqaI+DU//nBE9W3+E5w2kLJeqH5kxa+cMWJxS//pBpKfwXF0VafmqHdLquB37Tyb0oyBkEzRHaVU7s+cWZwaPLe225F0Kh13OA4AAAA";

var img$2q = "data:image/webp;base64,UklGRuIAAABXRUJQVlA4INYAAABwBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQKsA3k3yVSmGePtBwCOQEbVMn4WGLygAAP7+7JU1otPi5R7l5/K3fnsF5GmC/xOZE5ufmP5Oo9iwd42XVC/SDtqoK0LDx0FLc6U7BlwE+7FhOU89olnI6I5wTd4pip+nPu2Dgx1YaPsWI102//W9k/tWXYy9g7+RzvCKCvCIMbqatvDvb106olPNctG1+3h/n//5uNq0qTidtR++RgSv3w1nnnhIvYS7cZP8GIJJLDQzwGWoGlEBw0AA";

var img$2p = "data:image/webp;base64,UklGRqIAAABXRUJQVlA4IJYAAADQBACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6TYD8AFAWkQeLf9+c3f+Y10PGUgAD5f5N+2yMF8+acqTj9//6Nb5JaXxGtx+ld07S/+IDuDb3yVcxzzGB/yTS+kM7+b1t791LcQwJzULu4J/pzTfc/qf5mgRK9P/5c/Kv+JRwftIAvTkZzqbF1OerRvVt2r0fwsz+E4AA=";

var img$2o = "data:image/webp;base64,UklGRsgAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCwAAAABL6CgbRumbxt/wiuNiIh+j4KCtm2Yno0/608gov8TgHL+YClU8hmWAuX8AVZQOCB2AAAAkAQAnQEqGQAQAAEAHCWwAnTlBeAGgAVH/tAf13CZv0A9/9AAAh2DaoDL0Z4IAP7/nUxUNn3OmVif8c/vK6DlMAcH/r22t/90SCg2BQ1/BYr5Hoa/gsV/1todX/KQ09fN09pQjaTmpzdNCCQRU1qLHBfHVnBwAA==";

var img$2n = "data:image/webp;base64,UklGRiQBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCQAAAABJ6AgbQNm37/j2YiI+GdCTdsGTBd/2LkKIKL/EyC8Z2V5YwZWUDgg2gAAANAFAJ0BKhkAEAA+UR6MRCOhoRgEADgFBLYATplCOBvQN4C7AJ48JUZ3mYrm5sKUKDlbkR2CyYAA/v2Y9DtzttsPufcfl9ZbuSFnRAa8WZT4/h5iolspJ2VNUwI0CHn0v/xCzoiPrauJb4kTFbcgfy2OV+sf36/fPXC6E9Vj/F+eXd3ZVLoTo1V1fnyJaLEWQm5aeHx6OGXoHgi8uvg+27AwSIox+rmex/z9++n6aTGjNt73fePQ0+59//XmmN//4BY/5k53R35Gaps1JNH2WEZVZh1+D7pa24AA";

var img$2m = "data:image/webp;base64,UklGRjABAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCwAAAABP0AmbUP7zb/f1UZERK+BUNC2DdN9/qT/AET0fwIEWX2AUo50FDhlktIHAFZQOCDeAAAAsAYAnQEqGQAQAD5RHoxEI6GhGAQAOAUEtgBOmUI7kWA7Cv9M8AA6VqsAfgBQAH4AU5WFOaqxqWgzgf5rfkAA/veB8N/51qP/8xdgPwcH/iY/o31R45vBxQaJekt/5E+PE3QPx+57wFlD4PH7/7/g4WPHqf8JNfZRv4P6r65Adv2Tv0ovSUYnXloDMG4PR6Xv//pYZBYgP3/8f0/fv/Q3dvcZbDb/yNJAxG+//xflT+3hTvLuVXZ7bu6wymFI3kJ0ctOur7NZGtOD4zEKpECWTJxeYjS9Ejdct7MQAAAA";

var img$2l = "data:image/webp;base64,UklGRjABAABXRUJQVlA4ICQBAADwBwCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbyv5AKwDqAYYDbQMpK/Y4+jP8ANdA/FWwF/870gA+UIL6lpxMwX23DowA/u6Hr6RiO08xZF7bW9qTl66J/3LXDCuadsjWZ+k8OwpLfCKv/QGzF5X+s6kER6F4tjyBO/+NimXu823IX/QPps1ebeJ4av/Pz4J6a8Wji8wwVvJjlY7+bFeie9/8MMIdHSldf5W1iKpccjD2ekADfv3PGPsr+7I45IenjH8ZMEP5K/xO/Z5/YS/+Dfuha8+3q3KFTX480R4BJpzu/9U/pss+fTJ4n0Ol3poBGhYsz7mIUOTdoQXKZ9AICJ33mO3O+mLNy4/XDFYkXN/d0B6yM/H/SuSJ1vqwAAAA";

var img$2k = "data:image/webp;base64,UklGRm4BAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBQAAAABD9D/iAgISAj+/5YJEf2fAEbTCVZQOCA0AQAAMAgAnQEqGAAQAD5RHoxEI6GhGAQAOAUEtgBOmUI7m2AfgBWAdUDQAeIB/Sfb/0wDnZP9J/cvg6JOA8liYAOyrjx+6M4+B13HmYQA/vhSHBmsi+F/HL/0a03Tf/60x6jEP/3icxKP/+z79SAfWW//0a8z9T5NRmPN/SLeLhy0rvxY//0Isz9gptU2AJrhpqYlqk5iVVxbxA/4ZBogsfqn2Mk4vxtT+8f/zJ1nrUFLY0lyZ70nv9I8CSv/xTRSC/d4gS5s4IpzkPq1p38VsYq8cEENfvv5Hm5uPO9RhQXcLvxPdz/8dv6d7dfy5JTefwuqK2q/+s/a//obaVMjKfn8iuWu6n2EINDlz4uZ55FNXZZ//NxIHhG3+biQCtosgRvf6UZ95qed8bBy4k98BdmUibIAAAA=";

var img$2j = "data:image/webp;base64,UklGRgABAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggyAAAAJAFAJ0BKhgAEAA+USCNRCOiIRgEADgFBLYATplAoADpQP1u9G4mQP4AMAN58md9J8/yyCCgAP7yo/8ff/mYXAHRhKX+MRjiiQoEz9J3u1aXb+hwzxV1w/bDIPrzPotzdoTlZMHZxfv3xjhQ/xLGb+4/QpF4yF75p8J2blZ84+6yX/qC9j/NuLe9I0nIDIE8dx41qr3MSOfrN63xAtKSoff/R2kSGwTzzjdCK3imNBceNs1QBwksqGvZ/vW35/ElFOT0ZThFZoAA";

var img$2i = "data:image/webp;base64,UklGRggBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBQAAAABD3D//4iIIBBI2l98hIj+T0BMP1ZQOCDOAAAAcAYAnQEqGAAQAD5RHo1EI6GhGAQAOAUEtgBOmUI4G9Apf/aWwUD9gLMw/2P9yIIgX+yPUBhDPC8pH7VAAP78F4xwn4c9A7ZJ94ExTfYMjIlaDxHp+agM9FC3cQK3G9BRUKlCj/7O/r5/YgGNbmwJ+WDjf36KVgOwnwL//3IB76Q/v7ifONzrpoJ82j/XtL9D//+BvmEUG1Xc7N866P8z37Xyomkrkv4/2Z+f+zCxK5RSGB3shSRWJsaFvsTtcmsk4owdXZLiZRTIWWgIgAA=";

var img$2h = "data:image/webp;base64,UklGRpoAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBoAAAABF9D/iAgoaNuGacsf9tsYRPR/AvBMozOab1ZQOCBaAAAAEAQAnQEqGAAQAD5RHoxEI6GhGAQAOAUEswBOjXAfwDCAAE1DorwVirAA+daNPsVfzeDAgr8v/7Qj+CdbBLD/4iOi/6I5N//Ft5f/LPd/Weco8AIOABoOTAAA";

var img$2g = "data:image/webp;base64,UklGRgIBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCsAAAABL6CgbRumb+PPODQiIoB3oKBtG6Zn48/6E4jo/wSgnD9YCpV8hqVAOX8AAFZQOCCwAAAAEAUAnQEqGQAQAD5RII1EI6IhGAQAOAUEtgBOiZAP1Aqf9ngH4AfiAD5/AqwWh//NMAD++Eu367IH7iq/Sj+j8RIgV4bCxQDVjuobKMV/UJk3lXKOo+KF24zv+n9Xv6Ifz7P2WdOPOrcpm3Dx6boZlRPY9vPE7v/stH/UuIP//tNB+71N3On42gF5h/+egiI3x/zVMcaifRfF8ryie8t9odr4X6+CNK+P/4t+JCaAAAA=";

var img$2f = "data:image/webp;base64,UklGRkABAABXRUJQVlA4IDQBAADQCACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwD8QPyA5AIwCrV8qB+KvAA/S/+5e3/0f/UAc9v7GHkkEz0LcAfzr+09m0Nwzu0wAAP718fH7ryZx4KBi6aPYo9j/gdMvOzcdr4faNTPSmuh+v07HbEeWee2U3C25tV/cRoWz51y04A1pzZRG8b4ko1Ogaa+Fm/vWpWxJ/4voHQ43tlMHfdB51VAChURC//wyfUcdUzH/aYSOR7j3R/tgoG0HKT/7Ma5+QGEbgKWy6n8Qn5vxbFYVzjEahQ9yNVvOW0D3MrlHy6EujSRzlKf6ZvtnnGq9ZOy971gjeVn59/2NZnIVNzeCMD/GqiMoB0KcaP9GQaFst20CYcn6aC3H3jzESvn/k1wccPrK6x4/dWhxBIAAAA==";

var img$2e = "data:image/webp;base64,UklGRrQAAABXRUJQVlA4IKgAAADwBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjwnYBUgcAD8AYv/6AP//Z/5LAC/rfVGNfCyjAD+4tX+k92oNHHdrif+k9cxCQe+skfcwwGNO1qwWrBGMBlCS5ZBLcdH/4ffzemf/NqTev2PimH5zXo/rm/Fsd1z/093eFj8cgiFg/HIjysmee9Yg4PSXPmFeD1MsnM3Nd/zXsgx/ugNlle7eybAAAA=";

var img$2d = "data:image/webp;base64,UklGRoYBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSDAAAAABN0CQbeOvd55t14iI+GUdChpJcUAUBhCz/j1QvwiI6L+QIMHqEpWu+wALDvyzXCdWUDggMAEAABAJAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCOBvIPwA2kDKBGgP6BiAP0i/zv9A3yvrM/QA8sD2Rv1j9HcmXvIs3wAdWFR+hw8cbD+fbwAD+ESfUwFb09vX+v6/7x3EX/7A/wR1RTMVXCqPHdOyfqhLoz3MHc2IFgP417xpFydYGETYr00L6xuViX2pUPL7ZFslPH/MPvaNmfj/+MN7XxYxqNB3Lq7HN6p+J+bEXTgwQzJwlApP/kE36mqbp+FYub8fqe0O5KnKVFbR3lKUF9wP/jnv36H4/1S3PNLY0P8X/iwTRmt/Nf760/vai+jL7cz5R+N3ouTCyxudbkDG6qidvwdC6rPEMbFWkg7p19s4/+GNLAq8EcLkQRET+lVk/xfqfQaPWO5vaT9DAAAA=";

var img$2c = "data:image/webp;base64,UklGRgIBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBQAAAABD9D/iAgIBAj+w0mI6P8ECCU6AFZQOCDIAAAAsAUAnQEqGAAQAD5RHoxEI6GhGAQAOAUEtgBOmUGMHsBvAPEzyQD0AOliJNJEixbkYt74JWbsAP7+7X+j//p4hm+/f7lP/F1vle3qfv/6t5kfQz00juR7EMvjPEdSzJ8NlvhWJ7v7pX/+ZyyPl9Hu1aUY+mnzgUo+sXP+zh/oqYeA2pqdy5puf9L86t65hPSMXUxZoj0zEVdGZ5O/pSpinN6fGGVAEKWGqjNIpcaSMukLd1PxM68wMx60JgRFnjxyY1w5uQsAAAA=";

var img$2b = "data:image/webp;base64,UklGRo4BAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBkAAAABF9D/iAgQSNr49w9+niCi/4MABAQAe/cOAFZQOCBOAQAAMAkAnQEqGAAQAD5RHoxEI6GhGAQAOAUEtgBOmUI7m9J3gIgBrgGyAb7d1gHoAeVn7D37D+jNcoDygPQ9+GvM18576v9ZhVXyUjy055wVSDDUAADeUJyf0fmPwFfXi0Tc+f5JzVzRQeLJRY7gLixdFN/rf6umRUIoG9omny5f5AQlYognEneN1qYMVe+Hb8fLJB9Qm/ZHV97sgvMAKjiOHeZb5HbepmO0WCj//nPvSTb+r6JjLnNHP3//JmW/p5DrU7QKvtifvUpqffxVVtfwi3XSfsI//Ewv/xWCaampi2i39b86//9RW/69QVzS6NWo/3I/Uw1K/4SP+eXs5P9/ohmv4Dar3eBtbrXX+B4/AnUVh2wf4VBO1bSEf6iXgMtx4ygQlqDo0n7TLO4hf8DVZm7/p1yqfkPizdJHdKVdr+n6XCnDSh6cDPPT2QAAAA==";

var img$2a = "data:image/webp;base64,UklGRvYAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBoAAAABFyAmTd717yvWiIg4IJO2Seff+v6I/kdgR1ZQOCC2AAAA0AUAnQEqGQAQAD5RHoxEI6GhGAQAOAUEtgBOmUI7m9J/DOZ/xQBvKJEVilXpR5z5kQRPqhUAAAD52DyrjNbnrQVSxHEdj6jOkevLVxtsZbv/g8lEvl4y4gF/VIf/DqrCYmHBZufvg7VlINP/1JCqw//rh65CzWpZnnC//jcVluzf/n44QFsffZMy3xy6PEX9o5vduDBEp028aFdbi8B3N1nBsD7nTMhehdbsJChwpttzKiAAAAA=";

var img$29 = "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAADQAgCdASoYABAAAQAcJaACdOUF+AfiBqhXAPxVAhFAAP7vuP//1BmUt2XrdZ4T/uO670JTrKiHU6fU6f/UoAAA";

var img$28 = "data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAADQAgCdASoYABAAAQAcJbAC7GvV/gGEAev+B5/gdP7gAPxJH1lv4++EVp2f/8WHy+KWp//2Ndj//9jXY/6teYz6dwxrcxn07g5UukMf99J10iQx0OekPGdpUG2UAcAA";

var img$27 = "data:image/webp;base64,UklGRjoCAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSD8AAAABV6CgbSTkmfz7RRMRkf2FiGRQ0LaRc+M3f8yJnkFE/xWmbcO4M2kvCYzDrEKmCKFZsL1+bBHyIiKZgWxul3kAVlA4INQBAACwCwCdASoZABAAPlEejEQjoaEYBAA4BQS2AE6ZQjubyWmA6gH+AxAH6NfsB7AGoAegB5PH+l/o3wgfpB6Ed2BUVW+P/vH45T3jxs/Kf+9/G74QP8NvGY4b2d/MiQvueRKy0ixJ2QAA+XcdntMvRsJuct+k/BihCfy9/p/2hPd5dr/8omfx5+MWv/mLLMJhN1gOAyxAdY8EPJBx5fp24L2MD0gf1eOcXbR8OJE52OSoGRqxQdpSfpT4aafBhWG+6D4hQfZVivfk2TH1UZwcTkp+oa38Aj6p3/V8loQ9x4b6YPi//MNX1XxT/5VhNnn50OmGzMEjL3OyZ1bsRV5/OKahX0ETWLE/17dcEcPMwyIc6xr6p1LIb9JgS6z/IEXkbn19T7DTUjxtsBtvHK1ft2W+3SUo80izaWIieg/mF6R5nd1qpPM33/5Y//MZ8NTUwsG2YJHisi90MVbbfT9skX98S1tYredHwVkU6BGu/brm7Bz/e8yk7rW0v5eIUuHbXtbUmP9rwJNLr3CXwdlGGJnDP/7SNPHXPx1AATQwM6kNq6RX/sQWJe514cQM+q9TNmj1MB/hoYvfDqMPGKSd/+HW9vcnmPGT3T+P0t0qhH7U14AAAAA=";

var img$26 = "data:image/webp;base64,UklGRqIBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBsAAAABFyAWTDTm79idRkTEAZm0TTr/1vdH9D8GOgIAVlA4IGABAAAwCQCdASoZABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwD8APyA5ALsA9QD9IN8A6wD0AOkZ/cL9bvaAXIA6Pr+x8umUBwAA0+6wXisSul6/oFgAAP74px/4hj773r/AJNN8sk+0dUylPiaFysThQ4pMlWh1+IV3e707rj47/eY/w1LIgWMphD9REnz268YU5OZtBe+3LwbJ7vuzTDNnjdQD0Z8d3/JwXfOqDPjaW/ACvC4K/v/4YqhacKAX3/xcj3L+MIvsGJa9D/0dUeuPv/5zH/i5W3cI8y8OM9QNylij/i5toQxq32PdKkb4FdxlPB5E0Y1e/tn5vemNzXxx7+BGb8Fb5DJakxcCfBV+YSJ/ceyMJfhF4olvgbMWBD/Ov4UiS++/Nn7leHudhL76Pe3ql0F1U9dqtP3RrofMQ3vrUM0bBUf8uHaguu+9FaArnkTrP8xblAuu3BpJN1rcAAAA";

var img$25 = "data:image/webp;base64,UklGRtoBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSDIAAAABL6CobRs4K/VfDNdGZjwWEbF6HqCQkSSG4lDO46u/TReI6P8ESBbxyyqMStasQqngF1ZQOCCCAQAAkAcAnQEqGAAQAD5RHoxEI6GhGAQAOAUEtgBOmUGMFGk/pnlgHoAeV77H/6wKtJdFNnj+b/RJ6nIly15C0ysru9JGUS0AAP7+yqZQ37j/D7kZk6GxTJMy7v/48Q+b+f1Xf+YKefxIFv/8vPelW6BOYzb/GxVAwJwLTefP+ransMH9qyd7TX8sZgtSV/jrG/fBjnGnu2ZZUKVB4Mk1JHnPWt0t9jBEzznWJn/IsVAYu5Ig+aZv4/zMzfBdCbr+tK5U5fAyRl1SBJJ1UoROHKJV+X4qz/8Swf1bbLxxHj/rmf/+W395GfuWOX546f2H39LIu8UZ4iQbR/ajdsm/3LHDz0MHcD5i/Fbv7/df5yr3NeG/9e+k+KV4y9ugkv/+9nv6KI3DLqcuf2X1+5s7NTKL8lypBWrG/awPfAYN8eHrtFOZK4Ez13PBWr+OTfg0gpvZYM/qvbscS8gT+v/1OgFqXu92hhPs+KB5mZ+m79f86+bp4OonI6/5X64B0sdzQ3XKIAA=";

var img$24 = "data:image/webp;base64,UklGRsIAAABXRUJQVlA4ILYAAAAQBgCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQiQCpA//+2r/gMJg/Wb3wLH/AyBae2+ngIB/XgAA/vhLt5pn/E/IJed021WR/mF1G21+534ZXY/7+UFOYW8kD/VG6XZ8i/XnS7o+dwcA85z5GtW7VJuskRap//yGUR1inEfm1Arqeh3CCnU91T1/9z6bxr/YfOZh1vJQXE9VCwwTPu0DmyUayoxDZLf6oy3ujfAczsWIHZwYAA==";

var img$23 = "data:image/webp;base64,UklGRt4AAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSDIAAAABP0AmbUP7zb/f1UZERL0hUNC2DdPd8ie9SyCi/2STNnZOD0E5npFSail+Mit5c/SSEVZQOCCGAAAA0AMAnQEqGQAQAAEAHCWwAnRrgP5nhDX9V9v+7TSNACzOXh8O0qxAAP76XYGj/eT+9J/6IASxv9r/3pP/QDC0tDhfUpWjpsDhAQ9p8ft8v/1bfzQc1Q//1DHmg5qh//Pt6F5+vn9yGn4JLcDVjF+Uz8bCBdDsaCoPKO4P9+1NZCtfb93AAAA=";

var img$22 = "data:image/webp;base64,UklGRoAAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBMAAAABD/CC/4iIIBBI2h99gYj+B3oBAFZQOCBGAAAAkAIAnQEqGQAQAAEAHCWgAnTKEcDeAfjBwgAOQkAA/t9V//23wl+tUbjF/jm3/1Nf/U6Vr/wT//S08LRm6rdUxuyJd0AAAA==";

var img$21 = "data:image/webp;base64,UklGRu4AAABXRUJQVlA4IOIAAACQBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjAFuDLqumAJl3xgOAAEmjLl3tFY+7sR4AD+TngHCEZgkC8nrs7/MvSKXhKgyAJwzrz/z/9yqBFj/6pf97vdRQ52VOMfQP++aK/EMjAv4mfcP8Mf03tU+usXTVv3hWSe7B82Uwq3vInB+H9XDexmesSt3/v+Wud5c/aFaLtPJpviwTJ7Px2Kp/4xd7kAt8Oc9sMmv/a//DVj/X3/G2cnWCAf6D7/Yf7ONwex5yX96Oc2/hYExBFJKCJvhTGitRVtS4N6AAAA";

var img$20 = "data:image/webp;base64,UklGRuIAAABXRUJQVlA4INYAAACwBQCdASoYABAAPlEejEQjoaEYBAA4BQS1AE6ZQjAFuFSA59u7mf2A9/8+QAMvGTDS7UPbICwA/opJrN7mE+WQMq/0QSj4kFDz+Hwvl/zXPX+68bIkXArP8AP/HXlJltoeX+p+rrVoa4zUIufQ9eB/ZgUTPzPH4+/+jl8eTTiqVZ5/++si842s0sZkGP9+TN/gUFB/+wap9ZIP/4kOc067ckHFrRxIcwxTiOmjum//30zz+Tg4++1mf6qEd7Q0+wNLI3EM9MFhx4QayT1ApGmtSpQpBGAA";

var img$1$ = "data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAABQBQCdASoYABAAPlEgjUQjoiEYBAA4BQS1AE6coL8A/ADWoeAfgB+qu4ABVgC0b3G3pAAA+dif/MVp/xk9XBH8DySM1SazTExrYNH5j9Fs8RI6B1DHjBcOm8JI+R6TdHfpjGl6Engnk4pPFHctOIc2zt7Zf0KW07jigAAA";

var img$1_ = "data:image/webp;base64,UklGRowAAABXRUJQVlA4IIAAAAAQBACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6Xro+XgYcV2Grv6TShgAD++E6f6oY5HmKmcLDjerYlNZa1C8S+f8GfHTD6Bd+9VykA+y+d9z4d/+vKia38Q//v4FzPpf9NEwn1MSyLv/3ptaHh6Pvw63euujNdw/hwucaiMAAAAA==";

var img$1Z = "data:image/webp;base64,UklGRkwBAABXRUJQVlA4IEABAABwCQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwD8QOECIAeIDmAP4B+QG8Afqr7//RgaVj7Cv7Qfqr7EpTG/HXqAfqGNkYY0DaOiXMPjKUAAA/t4hzMoa41osbS/P1h9mkriL8uLcRUjojcG9ngFBEl2dBRXus2JSPHh66nPJv1GcQo9aOc92lyHdajjpXntVzgUY7XNq/PlXoCSmqTf+P2ey0hmF3wfIEzCAI4X3bJ/ydnE1LVhryao+Ws4UjUNryFHen1gusxhdSL/80Wo6Seq0vH25sTEBqI4XhjSrD/R44AgER+t/6ey134STnfb2Nkb+ZeqevxNMwz++GgR/AoytsYQap2+9rbZBIOg1U8hlj/M274JGCXpw3mp0fB0plpdJfoa1vkJ7PII3TG879JT74HhNdvTKVwAAAA==";

var img$1Y = "data:image/webp;base64,UklGRrIAAABXRUJQVlA4IKYAAAAwBgCdASoYABAAPlEgjUQjoiEYBAA4BQS1AE6ZQjgbYBUgf//aA/0GIA/gH9g9f8RAAJrbJylo+uvwAPnWjT8rP/K+OWiYdbwuPWnVniLqCFi6Z3yAh85/mrTdnAw6okh9jkLYdfP3oVtjnryC3Fa+wTH/8t5sm9XswIcm/yFX//Iafg27IGPVcabztC+yZ3nv2Lp/WK2dp5wY75bQNBLPXBgo0gAA";

var img$1X = "data:image/webp;base64,UklGRjgBAABXRUJQVlA4ICwBAACwCACdASoYABAAPlEejUQjoaEYBAA4BQS2AE6ZQjubwDeAjAKsx/TfEA0gH6S/6r+gZYBz2ZNAOJV9gD9Rt8A/TMdvO5zNJzehvwvzwsAA/vhNsmfjhXUEva7Exf9d3/+Of5MdaDVrrvV9pJnFbV13Po/3cDwSAMAcj1N790FXjDX/8WHyXhdwoCCKFCbrQsVNI7Ot9V2J4DM9Uv2z7nII7iLAwuzCW4vcKN1mzjv+q0/0/+5x/dsxBxZl69Ng//adIMaKDh+O5mAPcG05ZIlyK4tALx/SfaKDeLJz87/4p8f/DX5hE6DZLVaxbvhz/tF3+RXzjbJuaj+7kBf+J1bpeE+keMvhPpHjL9hj+YZebaPs4e/WoOW/EK6PFw3WU4/4+/TQtJN4LHpxAAA=";

var img$1W = "data:image/webp;base64,UklGRiYBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSCAAAAABH0CQbePPvO3XiIj4AkTaNvNv6qbOx6cgov9J7uASAlZQOCDgAAAAUAYAnQEqGAAQAD5RII1EI6IhGAQAOAUEtgBOmUI4G8g/EnhAfACfANOZ/W74DvKAA1v/mMk0DlEoEKAA/vvaQ82tjX857w/NZ1QQp/p28boiQH3atOmT97f+ZpvNnjoDlzmD2yM6/v+jeL5U3YoNxxfO45qT5By1pjP8nkrYZZ8982pB/mJ/g2rXv/7au7vdQdPPgT/2+jihjSboq//60ncv/+aQb9L7nUGeeW3cCt1ZQzkcpficflAccDkV/Or5M59/+hQ6wTzUSGf86RHk5wfaln0gr9DU8288x88QAAA=";

var img$1V = "data:image/webp;base64,UklGRtQAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSDAAAAABL6CgbSPn9kE4/iz3P42IiJ8X4lDQtg3j7vDnvRGI6H8sAPwMANIAqLMBQBYAfgBWUDggfgAAANADAJ0BKhkAEAA+UR6MRCOhoRgEADgFBLYATplBafoHGWcwZNK2gAD+768S3690vg/aAPzHomgMYH/8hFkKxrcFUoVQKHyKRAX1i6FRrGJRt/+zG32v/Zxuv/1RF+Hf2cbo9+rg7UNBRXe9cNBX39i2l2qNiHxQYhEgaAAAAA==";

var img$1U = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAABwAQCdASoYABAAAQAcJaAC7AFz5AD+7/Nv//6a+r/6MP/9Pf/2eX//2mpzAAAA";

var img$1T = "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAADQAgCdASoYABAAAQAcJaACdOUF+AfiBqhXAPwrAgQAAP74lb//y7QCl52Jj3/iem1cp+5T9/yk802cDZwP5wAA";

var img$1S = "data:image/webp;base64,UklGRsIAAABXRUJQVlA4ILYAAABwBgCdASoYABAAPlEejUQjoaEYBAA4BQSxAE6ZQjgRYF//3JfwAxAD9APfqMsA/AAKcf6BR+rBOrl6MQAA/uqqlgdL5/yKJneLvE3PTcBKaRKo9NJ/Z3nPO1id0taZug+tZE0bEo/1S6dby5/ItDNcxpqNceMtCX+NZ/8smWZ20huhj8nGqqjD6zrQrXuANrGjCN6YGAVdUfKVJ55/eU3EwN8fiSLwtcv2ufpsrn3gswOx7pAAAA==";

var img$1R = "data:image/webp;base64,UklGRuwAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBYAAAABD/Dp/4iIQCAIkefWcyGi/+lFzagHVlA4ILAAAABQBQCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQjgbYBUf+2N/AMIAFdXt9GoWLlbAJCAA/vNwL3qH4tY+3xAhMqxi1p1CxN0AiC/DE/nczpwIl/8ObyX9715tBsK/813Kb+Wobg5Lc09q9JjLs1sORR/+RN+20Pw+9oxlRLraOH4lGf/4j/0zzQrvLuTts5VZDY5+Q4iK6wINn+IqN9NwjI3Akx+e7sAivM9L5BAAAA==";

var img$1Q = "data:image/webp;base64,UklGRr4AAABXRUJQVlA4ILIAAABwBQCdASoYABAAPlEgjEQjoiEYBAA4BQS1AE6OwE//7d2Cgev+gAD5AF1LN8uKEV3lcdRAAP72hhfk+3P/Am+vmArTWpvsF/a/FmXfMvSQ3Fl578f6hMoA8vmvHpz5OxUj6sFS/pAErK8h/cx5DDT1324F8pzmsGv/q9GSdokP/8jRtfaGsNzP91rzV6M57/han/bSn4Vf8h1ytxkeZVQ7ak86CfWVOjazKewu9zQlwAAA";

var img$1P = "data:image/webp;base64,UklGRhoBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSDAAAAABN6CobSPm9gE5/ujmszQiIoDvsoSCto0c3/jnj3oTiOh/TADEn7HMXtazscy5jD9WUDggxAAAALAFAJ0BKhkAEAA+UR6NRCOhoRgEADgFBLYATplCO5NBnAn9nb2wWAc/P9JDLeOQSPpsz9Z2oAD+uCoXOU5A/sx2/2hwYqGHIgx4WYe2IAenTFdE3FLSV7yP0M81tKBYqFXAPvR5MgLEKSj5++lvFek1uS+8Ffa/uw2EP/7U4ypkMdsPbrkkdyf9DT5Hs3/tJN+rnRz85FYZoW0EVjAaa/AItZN6+xAPKE69V86P74krpzo91k2opqWepT7Lac5N6bzoAAA=";

var img$1O = "data:image/webp;base64,UklGRkQBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSC4AAAABL6A0AAEmG93/V2q8ERHxNTAUtG3DtN3Gn/UfgIj+T4Ahqwc8xUih4ClaSg8AVlA4IPAAAACQBgCdASoZABAAPlEejEQjoaEYBAA4BQS2AE6ZQYweAEwAdIDxGv8d/M98A4ADpRfJgJcAGkoowhHgAwwAAP74eXc98Q852Ds/+J5qv7P+iG1v+OxsBHjSPtX4kr5ebQ2TIkp7EnZUvhFiWrfrp6KVcf5E1/jLYWhTPQYXSprftex014+O6hpVeQU7o+H3L//HXrEMEx5hH51fv+6hX+/y/rPK6qU0uxr7DVTRUfdH6pZ19t/LnBf692/x9OlwM6b6nlZRXiEd/DmP/17XP+KdMIYFPtVaZ8m/pol1t42FkWmV8QR+a4cuaqqnSRAAAAA=";

var img$1N = "data:image/webp;base64,UklGRrAAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBMAAAABD/CL/4iIIBBI2h99gYj+R3gBAFZQOCB2AAAA8AMAnQEqGQAQAD5RFJJHI5EQjAA4BQS1AE6ZQjubyUAnX/rdAzUJIAD+uCoXOVK/zX3pf2/t9o//x6LxX7l72rnd+VvpIUkrhJ//suN/9Xp/+G+raGiUXxypkMVb92e6DH3/+Tf++qn/dnugx9//k3/97JAAAA==";

var img$1M = "data:image/webp;base64,UklGRrgBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCkAAAABJ6CgbRumbxuF8SdaGhER7fugtG0Dpuv/swOLI/o/ARMucpDuKPKQAABWUDggaAEAAPAIAJ0BKhkAEAA+UR6MRCOhoRgEADgFBLYATplCO5FgVcDlANtA9f/o/9LA/Zn4DftV9gBeK2wC+ivRP/1HWg9B0eKPCNnF6U7cF0T2UKeAAP5Pg/h/3x/MyhGqEnD7icrmY2qXMi1p2Y6mIExwInposGnoZYW3OzLHTbfs/iGQlSHMadJH2dT/2NPul212/Y1LKT/73dVH9YdyMkRaYCgIvYMIf/NCkR1bGn62BzjcmYZsbx6ME+KLRrIxGYZQqbIitfqkarx5iowvO2kiLs8nFkASyDsIxk+NbO/8T+3ttgb1ZIv9t/+OOL/+kHy4Gv/Rb/+Dz/AyVNe0fNaYdf5rPZiQ8fHaWI2zkJ3hQ3MfKNPv5/ZiKaTLnk4t+HsMFL7zLpejJ6FzQMav/8pO//TxD6C3/VMI129rZBntTIrdfjKgL+67Bujuc8Zk/cYNQ+MpbCl7vQKNKMD8sewvmljBHk0kudAAAA==";

var img$1L = "data:image/webp;base64,UklGRuQAAABXRUJQVlA4INgAAABwBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQWoHUAwVX9VcsA0VUmXhN+F22hUrAiwAAP78dW/i+lp19tr622U9/DLqCqMRpE3EzGoF1kDMpwx2/3Df/Vc1dLsI9U/H9wP89jNS5ZGMyyy6VQYM/iKfpXJuQh5A8i0W1Cnh+fZT5XWiDfNw32R+YcMJ27cadnRskWdN/+ugI+j79WXrO/2H+Si9D/v5cj/5Gkh7vPdQ+8dgfyGNTUpf6SvWIOKSQLxM6Wce79yUzX5oxKZoUWrMxeXgAAA=";

var img$1K = "data:image/webp;base64,UklGRq4AAABXRUJQVlA4IKIAAABwBACdASoYABAAPlEejUQjoaEYBAA4BQS2AFqBcAHofQcCZV7bfNbyLI7FgAD+/uy8+pC5RsyxnBKt8DfhNQHTaL/6LdM9Bs3BMWV2+HqN/mCwGpG2n/iiZmvOejakZktmAJwvQK2Sc28x4Cr2ohoiGJ1GW5gf/1I/K3fz+kAwRl3BvdLA/1bHs/hTppnGPRNb8NXwsHZEJOo6jcDacR/AAAA=";

var img$1J = "data:image/webp;base64,UklGRvQAAABXRUJQVlA4IOgAAABQBwCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQYwewJ//2yf7NhEv6Ae+O3QDzAf27llfG+oAfoAOl8p3rjsMVdwAAP7/Gt2PH+8cFbZ7luimews0YBYWzPRf6SI/TZTE//25bdvBKr0dhfLg+z48mu8DNv/5P8j9Bc1OV//5+lNt2zfnBP8CemfokfM/Cd03LtFA8rMn48SK2VIkwX0Lb08x+L4NwGyzS2pCvtXV7exP9jOf9aXOz5etq64G5qiTWxv/LkDt8vabVGsvi3QRXf9EsZQj7NiiydmhhsVlIRyPMcS5wAAA";

var img$1I = "data:image/webp;base64,UklGRgoBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBIAAAABD/D6/4iIIBBIQp9/goj+B81WUDgg0gAAANAGAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCOBvAPxg4QHwAdIB//yiAfoBzAsy7fAB1bWninizerxbzQAD++E6YQUvH+vrM1s806kPRBUJA2ScLY/LtzU/920pbYzVvyLi9819289zFzvvH430/dHzakZp9vluvXRUNmFWZstPg+PSvDpk9k+BGh9TOlFGUf3lawb6VS1CEsFJb8vH/8SFbOe1HQqJC+usy8vH6TE8B/NXP/jjnk8Tr7o+wi/eZEVhdUxPdQqZdwbQ7N2IAAA==";

var img$1H = "data:image/webp;base64,UklGRgIBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSDAAAAABL6CgbSPn9kE4/iz3P42IiJ8X4lDQtg3j7vDnvRGI6H8sAPwMANIAqLMBQBYAfgBWUDggrAAAABAFAJ0BKhkAEAA+UR6NRCOhoRgEADgFBLYATplCPB1gVdz+O4QB+kHv/gPI+uw8YdgA/vhIxcrwWBGHorG0aeXH1yQ9Duf4akiAbzpB0PdoGXQdHvNt//CQh8HG1K36Lf/DxHhj7Pt59VFJmWHI/v+RXyrel/DX4mMfvYostYvHb5VdEq/RN4/49/Wt7J3fFEntQQ5vZrTCmHNL0sjETrYZcP/Q38nari/QAAA=";

var img$1G = "data:image/webp;base64,UklGRrYBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSDMAAAABV6CgbRumZ4Mw/kAvjYiI/57KFBlQ1DaSs+U6f8x+HYCI/k/ACO2vTapLuSmeLXt2bBkAVlA4IFwBAACQCgCdASoZABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbyD8JeEB8AP5XhGf63ZYBz2fsiViVikHeA70/+l+2b2KfL3+19VH/P/lJ3K/QY/ZkdzruqsHP4BOLe8RVmwAA/vaH8O+lkOivprA2NF9teAr3pC0Rk4NEYnB5FhpAWtpZaVee7l+ZZgRX+o3Lo3uZ0Kdp4gj7H1U9Uxnhc2mQPYwPqesDOW7v2bV6kP/ejfaQyPyH/05Umf+QE4LZT5tKnPtR/uYooQYgflC/l6GmTl8PyZMgqD//vYKqDtCKnAJDh6nP9EOOsgUdRZBFlVCF6z7PBdBM952u7Z/vw49VliI+Bk7EaDlf/8vpG+TJQAx5mflf/p4g8JsgX6G3+7ExAcX5fu+dE9JXc4TOTXG8Hi60/7Hv/Gl7yuA0PY40V/flrvX0jHMEDnTe+yg59v2z/38qLX0ZTMSXXwAAAAA=";

var img$1F = "data:image/webp;base64,UklGRswAAABXRUJQVlA4IMAAAADQBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQYwWQDn/7Js/ZX0MyZNFv/qILCP7NT8mLaYAAP7iiNrBA7ZR5cTVMS+/zrZNcKBZdnHxZt0yx1y+YPYJkf6/ovX5NHgD8epRP5dnSvC0C+Ji3vFvn50PY9WsqX/zuU/VrMMLf8Zv9olYp0bBz/eMyqCS+NYCs/z7H8GwgrmExUj2WvjJH252Ygp8Vzyv8m3u1jhROGQCjB6Q4sMDOGrZPBFYAAA=";

var img$1E = "data:image/webp;base64,UklGRoQBAABXRUJQVlA4IHgBAACQCQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjAFuF+AbSN+wHBHdQBvDH7AehyvF+uA7lWbs+MH5A9gD9P/8PwDv6gDGM+pJkcEfWn8V+pi6RSAAPcIGbiGt+cgLZ/1LeX8jl+NmEsr7JPhont2clOfWOp46R3HjDg13wiMnt++5//v9oJPxh+8/+2rrDpuH5y5bNJUX/+6wmTfmj20zQ4Tr5Js96fPOwfgy9zf2rXavPZexD82N7XuVj1Qp613BrMY+orPP+j/z8sPx8sWruv/+bT5oflbZmrtWva4PXy2kBDcAmeazxDCG1a/+m/+eR4WRUajR1XbgFX5+/MofB/T2uh0c4Ee0AtLxc+Hjv7kQ/721/qMKkbLbxtO4rkJMe/+MO+/sAb0K6LM/vz9Mbtc2Xw1+f1k9c3+tRCLhZLDrKUrzPSn8Y72d/7XwrP//gyz1K7tvWqfwxka9fQc+I5HsXfuYXUH/5cbqciTQzqjQFf/XWgA";

var img$1D = "data:image/webp;base64,UklGRuAAAABXRUJQVlA4INQAAACQBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQT4BxgG8AfoB7/93Heyl5KtyAYoAGcgKuzgT0Y392BUAAP4nv9nKx562Xf45+0K922uEOzxvkdFYDTQKLNr7OQs/H/1iyUXrd7nr00ExEs+Vu/0/8ny7/99J+6pXnBu+z/fwUx019+GkH4g5HFI91rgis64//Eiv+VO/aVr9m+38HS0Tkx0D4ZvUf4zsQqaWZH+7ajsKLmob3WRzIUMCumOlLbnrgWyPBUk8O0AQhIQjsD7yOyoAAA==";

var img$1C = "data:image/webp;base64,UklGRl4BAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCsAAAABJ6CobRuo/BEWxrn3aERE4I+CmkZSoDtAADj5/Nu7kjqi/xPQp0aWal8DAFZQOCAMAQAAsAUAnQEqGQAQAD5RHoxEI6GhGAQAOAUEtQAO0rIiHzFf6N1JfQAF/twTAJ/fnZH/BFhAEonUAP7+hRp5e/kC25NLgX1i/4D8lrG9NhNgKFrbXaOXlLW//pJ3yn4RqKIB973MKB2LcN3H9IPnP3Olifh7xXK4PqHmmVZuFWm3r325Arsac5/LIeO6OHPfHwYEt2OxEf6h//7PfYn+776YD6f8sf1gA3O/4WVp/In5XjF/P1Sel85//+jtGcpYr69OTPLpj/8sFG9pa33svfxMq0fmJCjOwn/86PgQf83H0X/3ptktys9ldA/XzzXIz+CPL7ngPhdh/7g4akMGyY718huypTB+xTPRmkAAAA==";

var img$1B = "data:image/webp;base64,UklGRqYAAABXRUJQVlA4IJoAAAAQBACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQZWyJdtGrfS0tkCjCAD+/HbBOaYFCYxkY35t+MnJaj3UYq3vABZ/8RX/sXhddGP2UKMbX/+LD5fDt1VCyfQtQHPGc5574X8OpqCOevWm35473pdXQ/md9jO1+J12koqtvfzL7oP7X//Yf7OPU6OYIz1E1wLVjBKihZLe1RAA";

var img$1A = "data:image/webp;base64,UklGRiQBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBsAAAABFyAWTDDmD9mdRkTEAZm0TTr/1vdH9D8GOgIAVlA4IOIAAADwBgCdASoZABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwD8YPxm5AFeAdABwAH7Aeln6MxGzitVZ4hVOcGUocFDQAP7J4vYUGTGPzSByoYRZzI8ZmFT67qO0TxjL4bzlKQMzaSdTyp7dSxseZrzgwYohv4yjDleY/UVf5j63WynPeWGfwavpgA1HxQLbIWisj//hrQaE3aP/o3taTXEFr6cWDMMTr6s0yPriphSy+e7eBVXfvhgKj2CzAFz7k+mMo+LtplfByTjgvm7d2rBzyJt7HmjVlwomv829fd/wbW/obgAA";

var img$1z = "data:image/webp;base64,UklGRhoBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSC8AAAABL6AgAJCEhgf8f1nGjYiIXzc5oKBtG6btNv6s/wBE9H8CAuk1nqKl9ICnGCmsAQBWUDggxAAAAFAHAJ0BKhkAEAA+UR6NRCOhoRgEADgFBLYATplCOBvIKYDqAfwDxANIB+qv+A/gHv/6YBvKv6zEaBugBvsyU0xk0kAA/vhJfg/Cz8y4gf0QX6Mu6TtakgZxv9jypXYjAGCTxWA59rV4+2HzH/UK/BPfwT47+ATyN+oLCHgxZP8lrNIh8WUQP/4EHM0pP+L+/dymrvzZQg5sFJ/wQ/C2fDqjyof50MTf4/xlbUBocYrJbooxFO0YCzrfHdX13JxyUCgAAAA=";

var img$1y = "data:image/webp;base64,UklGRuwAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBQAAAABD9D/iAgISAj+/5YJEf2fALJbB1ZQOCCyAAAA0AUAnQEqGAAQAD5RII1EI6IhGAQAOAUEtgBOmUFp/2qv4AagDn4Lu3/VWlAAmh4J8ANMrc92AAD++Eu36NV0JxBYeM6uAN+t0oOJ6nE6Had/O+azmtjtNXc/Vxr8riaA13vXg0BM5kO0y+2P/sk0OE1S0hEi+l20lx/6V/6DwG/+rSSazm6/zNCH/6WAGbvA/kGcfGb0/e6aXhwS8ax1l8Zmhpz3fgcIJhA98FIAYwAAAA==";

var img$1x = "data:image/webp;base64,UklGRgYBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBsAAAABFyAWTCjmb9mbRkTEAZm0TTr/1vdH9D8GOgIAVlA4IMQAAADwBQCdASoZABAAPlEkjkSjoiEYBAA4BQS2AE6ZQjgbwD8AGAAaoB0kXlAEysL/XkdYjPcfCfHoAAD+0xXCHhgnGEPRcGJSu1HOYMX4i0bl0dYDpBG9nG7O3RPD7/vG/zLt95RMWh9+dr1txGv/9JJOT52JSwQmsn/7z1tIBfP3c0Mv/n2ll5zsFF69Q/zzR0/ob7kyYue+z29KIEv395Kjq8B/wm7Q60P9ZJ67j9P4zxr9eg/zUzidxvfyLTzZlFnfsNAA";

var img$1w = "data:image/webp;base64,UklGRrYAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3Fw8hov8TEJ8BAFZQOCB8AAAAEAQAnQEqGAAQAD5RHoxEI6GhGAQAOAUEtgBdl0APwAIg4YlvhEWMhgAA/vb0K52o/6f/cUK2qPVsTt8Atf/VHCZKuOG4mQER7YO5i1UP/xLgP/y2f4nevuuA++bzl/y0Fjbf/xheH8x+fneHW7V/x7/4kL/xIVFKduAAAA==";

var img$1v = "data:image/webp;base64,UklGRqABAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggaAEAAPAIAJ0BKhgAEAA+UR6NRCOhoRgEADgFBLYATplCOBvAPwg/G7kAjAH2a5gDzANUz6ThVGscnTHfOXzgagH6o/6QZyJZbGNOYBpm7sd0x6FAAP7rwbFnvuJVLN4qIC35rJc/IC5qXm+cUp//N2HZjct3fzMghKk2R8UP9QK+6K+8qVY2SD3NC3p7pSJErFic+EGFh9WuOhx2GSpZAP/+Rc68T/+tFXWRqbkze9CKpnkz3Cr/LmSNn+vczlRZLepn7VtbbfT38bAsr7O/00v7t//cQ0P28TH1zk/I3/xXp6//wa/91/eyTqh+uX5MfgomrW/8hCTDzJG7xJgPRa8ybvU5Xm5WfP9JJ+u8MeZI3hvn/2QiU9//XOy9Gsl3ujo9+fuP0/2JG2vdzQpznpT/wxXOTz/9j0Wf2H/Ccz9j/t/x/X7wz48b0AkIC+ZYMRT5f+f8HHdbVZy4Pme5sdKUhy/JmBX3XUAAAA==";

var img$1u = "data:image/webp;base64,UklGRuoAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSE4AAAABYBXZdhoLiYTWQSYKCgZQBqOCyqjL9x2GKyEiJkCjSYX+N/eIjDyXaTSp0DfldpFZ5gqNpifct7lVi66UBpNEiwndKQ2mEl286ENpMAFWUDggdgAAAHADAJ0BKhgAEAA+UR6MRCOhoRgEADgFBKALsAIseeFF/btDAAD+9+Hj9tw+2RUZo2//8//KVNdxKfmeId+fYfxUU2llj5LcKqz+fZRA/6KjdwbD/8FczBkiOp6/G75f5cx8JCG//7jP//tk/+RwAjQ1daYzAAA=";

var img$1t = "data:image/webp;base64,UklGRuQAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3B08hov8TkG4cAFZQOCCqAAAA8AQAnQEqGAAQAD5RHo1EI6GhGAQAOAUEtgBdl0Ak2eCgev+MLUlZhmPVJhxq+x+AAP74S7fru//xz/L45+yMwbP+rnBo0dqG0V/exlv1N+c8jgidD8z1k3+IM95xy9P3mq+UafPO+OpD/250XrpQNooxFF7D/8tZN7KJD2jW9lEhaEJGmiof/4uYps/3GNSy/FTDhEOt9kSOKN07o3eRhroxxh2SEdsAAAA=";

var img$1s = "data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAACQAgCdASoYABAAAQAcJbAB2AJMB/gMJAA6pZRm7AD+/fhE5/xq7aL2bfqe1/U///egdZP/+6B1k/0djTjcN//49Z2ihqf/bO/Ir82bNf4BvIr82ayIAAAA";

var img$1r = "data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAABQAwCdASoYABAAAQAcJbACsLoBJgP6BhIH6Ae/+B6I9kXN2AD++2fn4Ov/9X/+oTVpEDf/UegkQrDrH+h5HT/kL74zfyLXwn//v3Ywa+bfX/33Ywa+bfX8KQp+6bG1S7Y7AbkBBgAAAA==";

var img$1q = "data:image/webp;base64,UklGRowAAABXRUJQVlA4IIAAAADQBACdASoYABAAPlEejUQjoaEYBAA4BQS1AE6ZQT4BhAH8A9v+5AAMCi+7lgW1AAD++9uTy4P/7b7b/+AK/Zn//thtv/4NqmI9QYdkIc6IB/9QxbBPSz/+oYtgnpZ//UMaYT3q/jfCxVuffhiX9TDBBIIK+A+gHFBe4OBBPwKIAA==";

var img$1p = "data:image/webp;base64,UklGRswAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3B08hov8TkG4cAFZQOCCSAAAAUAQAnQEqGAAQAD5RII1EI6IhGAQAOAUEtgBOj+E9/DPChmVkqfjQs8KacAD++Eu3Os9GNBpeG59z9M0WTngIBscdk0dCbsYZvz8/v42jB7oTo5yi5msxwf8HO1u5T98osj99N1tEfXk6Zphf+w632v/Zv//0xt9r/2b2t8//6CRmIt9K9rMeOrwcIloLDDouAAA=";

var img$1o = "data:image/webp;base64,UklGRooAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggUgAAADADAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLMATplCMAAIsYAA/vSIh5s8LcH/4kL/c639Q/2u0xbObP+JC/zEXne/8e//s2fV17YBmcT44JQAAAA=";

var img$1n = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAABQAQCdASoYABAAAQAcJaAAA/zwAP7uZh///sR0f//Ngf+xh//+jjf/9KYhAAAA";

var img$1m = "data:image/webp;base64,UklGRowAAABXRUJQVlA4IIAAAADwBACdASoYABAAPlEgjUQjoiEYBAA4BQS1AE6ZQjgbwD8IPxu5AAdEhA1+9a6/zAAA/vhOn/PU8hZ77RNIQWxoslcU05Z1ECjPd26JDpBYFY2J7n0YmX/+rHKaqj19bFx81q7O35pr9/851LC3mfyHwla8XW8mOyH7/Jjv8gsAAA==";

var img$1l = "data:image/webp;base64,UklGRloBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggIgEAAFAHAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCO5vSfwzqQLsB4gF8AdLR/yjMALowmk+gANUD9LLcl01AEDoJ11gAzj9TjJjx1PiM/5/QrKqWyKhSysWy2sJ9om7vUea+cgb3OATL0j19jC4R2xC1q56qxVoQMPtUyI+5LFAZ5Bree2zDNePMNmy7OygU+uJuwoU+t5OeROxYqB//HesJYCd190LNRxgv/7hlnjvRdJWucRY0LP/yVqh/PB63bu9K3H1xm6zx696ceHeN/92Xs9pSxZgfQyFwWQxxu0L31dAaKdyCE3yJ6cfRb0tj3/sLRTuoVRcZO2tQABZ92Sxo5kJ2MT/T9DXP/H/eAP3rXolTkPi1N7mA+cBGXVo7AAAA";

var img$1k = "data:image/webp;base64,UklGRlYAAABXRUJQVlA4IEoAAAAwAwCdASoYABAAPlEejEQjoaEYBAA4BQS1AAAtT9G91z2AAP7+7L3+mfAV+vdEmPnrmgZf/kFv16xL//+B9dbwc8V0SBmArQAAAA==";

var img$1j = "data:image/webp;base64,UklGRowBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggVAEAAHAHAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCOBvIKYCsOf1m9//omeoA58L2Nv2e9IgmXt2SLbJ5mbY2lcxiLRHAAP73gm5ePi9urK/reO7O4LAm/+zeWFfkP+jx/3atcX8F5AIgMOtjL8EiJlNq+KrAJ97BXqH70r3nz9+zyF1vSo3ETPupId8zsv+28QUou6FmcuEyGenKZ+PBy7uqT/+NvGajNpdJL8qkkaUmREEAmmeB/IYl9k2v/y4ybAR3//mkqGRxJ/L/S5VGbTj31dpxSBRDJgDu/OTaEifP/MJD8CN4g1dvlnXRL/18ryx9BjQvujlSu+J0dz0Z0S6hH0v5GnT/++QlPce2t94Of8Msvlm11zWURVq/ltk5lcgMwHfLpped960sPBD/qyzsjnjP+e9ASJKe7/JbxjHW4LirpPdtT8X/42o+Hul/ldBgAAA=";

var img$1i = "data:image/webp;base64,UklGRroBAABXRUJQVlA4IK4BAAAwCwCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjub0n8M6kDqQf27bAOYA/quUAc6x+ynwAfqX6Kf/zpFeOdlO8cn/Y5vX4kfnL0Sv9LwHf7MjbTLJhCTqJAh/4QAnb5HgAD+7SlzJ6n2UH9zupAa8dtqhidD8/n8KDu63XGlX5L9Te+t/iDUlU7uXfeInQvR67c1Jt5UdDaz5ha52jlHyiOcAhQnskJYf2M+AJAKqAa88IkIFg/sYukrF7oc+lLzim9zLYWIn/PBjp5h1CWbQ9fuF7pVINI5lMgD7Ucr+Dl41UlZYYr692+aQJP/lIX87HH3zjK1F1Z7vL8Zzatud3LmUmsX/22AnvY5Dfwofr6bvdC1TuG5H+wObKWf+p9N5d51bH/Ug99X/tf/7zTyEvCPYZjb6W66qlgiIsxd3+9M+44WJSFiyX+5+tPDVFB6TtHsAAPMWxJoZUnsVTFzCOiLtLxHtPMxuwrFLIMF24PXq0qynHXcvybrTrTEOg9C5Xo4GZz+6fUqcK50pF3cFFNfP89mrBcQ52CwBLXcIGRP3UDXy/DMVOkyIAAA";

var img$1h = "data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAAAQAwCdASoYABAAAQAcJaACdMoRwN4B+MH6zcYFygATfQAA/vJd//5WbH/n2pcC4Cn/PziR4t/ydg1UJ+VHGSJLjiAAAA==";

var img$1g = "data:image/webp;base64,UklGRuoAAABXRUJQVlA4IN4AAACQBgCdASoYABAAPlEejUQjoaEYBAA4BQS2AE6ZQjubyWmA//+1hhgP1PPQAYZFnNt83yPc5bxSgBzyb98AAP78Exyj1a69kSSNCmBwPeQVI5pkGklzyP8IAnQwK8vHQNHPiqYgtafJTj5NM7bpLFZ3z7obXo3Jn/11C6wo2t/vNfT3TF2Sw1Dp6MZxv//X4Br/R5gLRcYehm8s1rzk6Yr586B+GvjArz4cnkjUCISzIfvXLONkt54V9KcNHjeGfP/yIQGEEwwpht1Gqujdva68iDv3O//6cOwv/9LoAAA=";

var img$1f = "data:image/webp;base64,UklGRoYAAABXRUJQVlA4IHoAAADwBACdASoYABAAPlEejEQjoaEYBAA4BQS1AE6ZQjgbwD8IOEC7ABVgfwAb7Ld5XwAA/vd5WcZGe2geFKl6o9IEHSI74lj/PIQW0/xmUKn4ts3Vvb46pH7sVhHb5M8LeNWZ/9wYRrT9eI2LrFSTG73QJdAndAnc2gAAAA==";

var img$1e = "data:image/webp;base64,UklGRs4AAABXRUJQVlA4IMIAAADwBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjwjQDJA/7e13/GsIA/jvtq3cB+1XZ/gaoD9rZONuBgGLFlAAP71o5l6zvE4GqOfQhFIec9ysArMFflCK9NWL6a+xFuPx5JJBkbAC1/ervoCyHp/+0bweNIGMQLZq1hEJ/Emb9BXikVXYb1HdqM0yzT1mYoQMbaO573/QeBFWKqDZaSZ2J5qFOfRx7jkt36CzhWUqQWcIBs3lHLBq2R43eeyeHcAAA==";

var img$1d = "data:image/webp;base64,UklGRpoAAABXRUJQVlA4II4AAACwAwCdASoYABAAPlEejEQjoaEYBAA4BQSgCsB2gPwABBcckfrOoAD+nD2U4YzDD8Zev94Z+OsbzLz6JreaFQYR7r5/DJ0Pp92ueWLA6D5fLsF/zbcNmBII7tqNXgofIDl1aQ4IMABvDplkGZ4//npz/+c7/PzfJn/4K/8Ilf9iY/0x/4RK/7G+QAbZfAAA";

var img$1c = "data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAAAwAwCdASoYABAAAQAcJbAC7GuA/gH4gXf/dmf9A7P8KB9gAP7tEv//9Gz/86Gz//y1YS8n33PvFyIpn7/+71lTQD99BiLO/+hQKh77/9CgVD33tb5w/lpBlLWAxeAdrYAAAA==";

var img$1b = "data:image/webp;base64,UklGRsQAAABXRUJQVlA4ILgAAACQBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwDeAfACfAOAA8rT/Ae6IBjISGsgugAD+9BsnwqyVTxlPa2pA378+B+OlOL1D2h1ArA5KXneXlCXgw6cjr2frtR9jKP8FnhgF+CqTP/3EKlKlu3NNbXwf+WmAQ5mk/sQq6qS7dirGKSP+YQCA1dU4PeHRMv+VzJ/NBf64agXz/2dnLH4f6nT/Ljf7E7dXz/3ahtBXH9WUAAAA";

var img$1a = "data:image/webp;base64,UklGRvIAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSDsAAAABT6CobSOGP9c+29uDRkTEExtvfwWFsG1FD+FjRJJRBOtF+L7tEUT0fwK0a/8BYcjg2rU/GGMCcO3afwBWUDggkAAAALAFAJ0BKhgAEAA+USCNRCOiIRgEADgFBLYATplCOBvIPkArAP//sVdEB4IHttgPHWwGYvFXQgD+/VP2JuwRI31n+z8QhiVLBgCYAOABJL92EBHX/k2vfh+N8IyLVk/bONrMw+Tbg14YreTbg14bf6uQL1/UaEGudK1/eZ1H7xYIcP+V7ccR/5XssTWsIh2wAA==";

var img$19 = "data:image/webp;base64,UklGRu4AAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBsAAAABFyAWTGTmT9efRkTEAZm0TTr/1vdH9D8GOgIAVlA4IKwAAAAwBQCdASoZABAAPlEgjUQjoiEYBAA4BQS2AF2ZQjAH4AXQNgAHmAQNj0jTA9XPzz+MAAD+6OYv+e/O3f+Gv/RuYBLc6ixpt72dcU4DdqmFCzmuObd7VI4m35umkn16/ATZJld9Ao5/+i6vAFmqzCzRB8jP/Zcb/6vT/8N66Xn6aNwNDG/9XcrTArVilNOK5sfbkfOAPtsHHA+/+Tf73T/9q444H3/yb/+9kgAA";

var img$18 = "data:image/webp;base64,UklGRvoAAABXRUJQVlA4IO4AAAAQBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjuHCtM4D+V0qBNEH43eZRqAA1GaH7tpkWltk8AA/vwP9PX2/3qc8nS8md77kJ/sx85tapsFu0eWeYY9w44Y95trnqrEZGXtd2IH19Ut3j8CDH9N8n0pgBFKPty7Btu9fYV6ao3cPaw6ze0yiA/djvagasDvwDKOmHH/rnl67A7S/j+gV34nfxHUK/5O5PG/Tp7j++A/H++4bml8O4m5imhrZye19CFPa41/6eIf7Ozc+hyf7A/N+fsDAHfh0ehwwJyDIENz1LencNdRVbTuAAAA";

var img$17 = "data:image/webp;base64,UklGRuAAAABXRUJQVlA4INQAAADQBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQOFJ/TP3/9MA3lz9gPRNJlEX+MNqDSyp+NG4AP72hchC8/7JwrbgWOI8b3udb5rK+//UI5lJDIn7s+Ug6HcHo1AMacDkJgeDnB0iVQ/y8mT94bRkEALzaeNpepYI7EFd+4FS0fOrvhjhLG2qdYCJ//HPhospPHv63x5DJ/t7f+ZMq//Jt9/+Czl7Yw9n6tP3UIJPQf/rn/IC7jS6Y2yMLxd9BZFTH4YojwRByjrqhs1BMjALggogAA==";

var img$16 = "data:image/webp;base64,UklGRngBAABXRUJQVlA4IGwBAABQCQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgb0D8VWuzb0lpXXsI/sd6Ii8X44C1BSy/FZ8kf6f3AP1A/qv5l8Zn+tYraT7AP49YB+dcAAAD++FSB/f2VUdUQp++xLEG05b13Ppt0fzBHDma7UTPlMKWlXCmT4Zz41/Smp7agL9+cVgGlhtbbdYcVFbC2a0junxqI4TQfEFr///9tzh/Ogg6Zk9XvpH0DV6+C6rBtJdSXGqXYu7qJ5Za0gpfZZir2f/iY+x86uCeYDu2NIPnu3VjgX6GofBijJJan9OW//xi1r7uM0xXaL/nPs9W131O5I/nHvdHvX5hBMF029OJsXTPcWxf2HjyjzYMUt8L26r7Q/0ECtSmYNdMJTcZ0ECWrc4XRefySMC/yDQz806G8ZOsblry1Ux2mNs3lzVSBuBDn+R5eHIH99ToOr/oD7IlN+Z3z7JvPv++QhdYbW//Jt8EPa3oiAAAA";

var img$15 = "data:image/webp;base64,UklGRrwAAABXRUJQVlA4ILAAAAAQBgCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQjAEnV/sGEQfrd72OmAbv+fJWGc9/D3HNbmb6oAA/hP9/Mw/2v4ueTX/bPTOBZiFfjpXqeXvuogani/0v4mi9ov/VEtgWJbrfQ2ydFeWPOX/8woWAO5lbn5KsIeoHyyzZvRX/oV47m5/if6FGCgflFUYPusuurXQ2twtfngT9kgUZCllg3HblWBoGXThQJEAxgAAAA==";

var img$14 = "data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAAAwAgCdASoYABAAAQAcJaACdOUF+AaAACLAAAD+8E+//+ioeG5fWcR/2c+/73Q+t0cU0vs7v/q0P5bv5JAAAA==";

var img$13 = "data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAAAQBQCdASoYABAAPlEejEQjoaEYBAA4BQS1AE6ZQjAH4AXQbAD+AYQB+wHvogJ58GgwAPnWjT8rP/K+OWekfgnsi3JhRIu5Ov9nbpXhs3BiaTRWy2iN0RhkuEtf/zOAVF8V06JxQX42IdfB3j6dpV9f/Ft3ew4uNLtXff9hubwe0Pi70ggoLR0m1A2oHiAzAE0AAA==";

var img$12 = "data:image/webp;base64,UklGRt4AAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSDIAAAABT6CgbRum7TYQ48/y04iI+K+fdAahoG0k5Bn8e2YDEf2fgIQq/rASa0nOeImyhGeiBlZQOCCGAAAAUAQAnQEqGQAQAD5RII5EI6IhmAQAOAUEtgBYjYDJ/7jtv/gPH8F6Xqw9gAD+3jYqezqpD+i6/HfBeiu4a2AFCr7/weeDxmTAdbJphtz83zQOkV8fmv+our///Swz/fyiQ/+LDP9/KJCC0FqV1hoZPI2yOD9SExRzW2OruIBEkDASdmAyAAA=";

var img$11 = "data:image/webp;base64,UklGRkQBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSC4AAAABL0AmbfOXGph/jzs3GxERX4NQ0LYN03Ybf9Z/ACL6PwGGrB7wFCOFgqdoKT0AVlA4IPAAAADwBQCdASoZABAAPlEejEQjoaEYBAA4BQS2AE6ZQUf/aAcoB/gN4A4AD9VetL8oApdIj/m73a/RQAD++FXudmzqlcdP3/weUf34f60Yx/iXOShfWLBrflZWGanSrdlMHU8FbwCOiT6y9D4R/xhhBy4PEsW+eY21rQNz1768h9yPQcfXhLqP7fcndXY5cuRnVM8MUWRDM99Mm3pnnBDFQAY3s/0f/q9J/zT7SEP/0lK4/8e/6j4ygdbSMl0hf/y9J/115/z6n+ts+D1p/2j82eJbFs7d2iRNLH6dM6nNEhopiGRai2KEoyiGAUkQiwEAAAA=";

var img$10 = "data:image/webp;base64,UklGRioBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBsAAAABFyAWTGTmT9efRkTEAZm0TTr/1vdH9D8GOgIAVlA4IOgAAACwBQCdASoZABAAPlEejEQjoaEYBAA4BQS2AE6HsgcAB0j/7FGeV3TPmAfqAPqufaIaKcX8mHgA+p/2m5eSsDJpR8dpn1kQSojk0614ov3Ns8dH4lwtI331Z/r8ZnvZxUWX6uxGZljvQO3l+ckdBt2e+VwluJcF87sJ3lc4f+YwX2s+vhP8v/5Cwf7TWQ+pIZKKRAK2fmGgjF9oS8v3rEyLvPT67zV7Umb2QFfq157GpHRaPDituB/nb0j4n//LWX3k3cvW1j9M+WgzZodtrV//4r+I/dM3c+txAZw4G3Hv+tnai3CmECAA";

var img$$ = "data:image/webp;base64,UklGRgIBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCwAAAABJ6CobSPmXQjlT3LdoBER8SMCCto2cnyDP+27HwAi+j8IBYD8TQMgBuv+A1ZQOCCwAAAAUAUAnQEqGQAQAD5RHoxEI6GhGAQAOAUEtABOmUIkAug2AF+Ae+rd0gGBUCNhGdWYKFGEAP74S5gf0jtDxxza7gWN5R3sm/VzhY5+9Dt3f9tloGx8BwsfeZmA+2N1OewcpD9j+8bddKXRchIKba1vf/nrgTkua9yuu+hl0sd/Xb77lnTtXf7O0v/5hQp5nJWChFQW3WuKgt/2aGJEiGFINAPEDV6BKfGpgJlTo3izAAA=";

var img$_ = "data:image/webp;base64,UklGRiQBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSC8AAAABP6A0khTmAzZZ+m8RTxsREX/LYA7UBgCBaP8/3ewR/Z8AhyhyTGLWIDGNWYzeAABWUDggzgAAAFAGAJ0BKhkAEAA+UR6MRCOhoRgEADgFBLIATpbgDwANsAyQD9QPSR9jdNgD0Gc0nMA/QAfbG2Df1lEAAOJPauSp1PhWTcgkov85I/p/cHf/RZ2BmObO+3rHS3C15h2J4uZ7NVa1L6nd/n5yLXjnhpP08Ad05EK2/v5SPx4x2YvY/zDnDPpxczzfqpyIsgYJ/5aH7n3/x2+SvcBD9hDxAcm9//4SvMAbLO1uiv5g9LdDC+QE2JCfbbmEVxY832fDcs5uRt9mPHMgILjgAAAA";

var img$Z = "data:image/webp;base64,UklGRhIBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSC8AAAABR6AgAAhE2+D/ynYjIuI/f4PIoaBtG6b74w/6E4jo/wQYqhS1/MA19ZodkRr9AABWUDggvAAAAFAEAJ0BKhkAEAA+UR6MRCOhoRgEADgFBLYATplA19sCATLrUViOwR9BrAAA/vpZ+f87rGu7UeT5I1T3fMwUo+IL/zdgWz8wiLz4AQbMem5p63s6XMu5DcHMx5RvhkEuq91BIf2wsrbbI0f+IgJaHN66PxiGTrRzlcWHNMOvWRTv4gP8fdYUys74wn+f/0jI//e2AOhB75/XhYX/wa/8ConMryr27YFAgxIHMIJODQRhBKD4cNCPJg0UoAAA";

var img$Y = "data:image/webp;base64,UklGRh4BAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSCIAAAABJyAUQAAiyJ+xnUZExCcwkLZNtt+/8gmI6H8cADL9AOg0VlA4INYAAAAQBQCdASoZABAAPlEgjUQjoiEYBAA4BQS2AE6XgDJALUAnyxRrFbDyUuZvGaf/CzzgAP7+7XmrbvOln7NcbpOL9T+WLHHvH+mN8dv/6BwEJlmanU21fPt+0Pvl8L/D+4lAaSv5DH6+X5Ff/0voc2NGQLPof/8tDwx5dW5MZhn51fJv/eTDyl+9FyL+MgkNbXXyP/sQv/7zSMy3C5j7/z//wdKmuKpmWibQtN7noKpvTiN4V73js6ve1OtwaJFMIUVjNScmYP+4D5//WA4zf6YD+nxOAAAA";

var img$X = "data:image/webp;base64,UklGRrYAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBUAAAABF/CM/4iIgUzaJp1/6/sj+h8DHQEAVlA4IHoAAACQBQCdASoZABAAPlEUkkcjkRCMADgFBLUATpygvwDSCuAfQAzADLAP0ANUADbBfE4ukiJ2AAD+766OBtGH/bq/LH+RX/9Muj1uRGWxl8PsT4iNqGcOT//Zcb6vT/8N9W0NH/KBBC7TxzPTexT546k/7s90GLpf/vmwAA==";

var img$W = "data:image/webp;base64,UklGRkwBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBoAAAABHyCQTRjyZ23XiIjgQCYMMfSP7o/ofwzkp1ZQOCAMAQAAUAYAnQEqGQAQAD5RHo1EI6GhGAQAOAUEtgBOl0A/FX8QL0GERftmTR/xiZi+6gCuVKuPWUY3jfbvvgAA/v7WP/+iWs1WLL+h0HLVzWTttyqvsTXR0ODfk93vx/ZcN4DZHMLAcpxp/NbJxr57GNGwWxeN9v72j5vNg/v/5xPla/V0VZqG/W/lUiDClJb/bWkmN5+e9mPyYzaMdrKBXG3jNeI2fo5x30vH3gp3V/sZ/z6EgwG1gxHICxeusf2xuHzf6jTzds6EbBuFpv48YxelCwdF5UMQgmFcdg0Ziai4RBvd+mzNp+niwAvxxFkMxXwtRA6Jxu3IGlEIg/3/g0tzh+bOwMzl+hmHs8AAAA==";

var img$V = "data:image/webp;base64,UklGRg4BAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBUAAAABF3CH/4iIgUzaJp1/6/sj+h8DHQEAVlA4INIAAABwBQCdASoZABAAPlEejEQjoaEYBAA4BQS2AE6ZQjwW//6JLJR/JVJlTQAB9kvQMb1ttGGAAP78pWD8Dp/Pt1O7aRlXuAuMmk18eruj6YRfM8TxEod01Ipm1hSeeEmu89MNoWYcb4WYAO/JG+T8IzUE+LdRZu//TEgBPu3SxDlrbCn/LO+/sY/pHP76IYjZY3+QUgFZe4wb4dtKQCKFE/fv6XYdG/2KXz0JO4fg9//GIJmzwP+vDjnxX3Xcm+Kb8gBdD2IvIqqV/PzA3NpKQZiLAAA=";

var img$U = "data:image/webp;base64,UklGRuYAAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBUAAAABF3CH/4iIgUzaJp1/6/sj+h8DHQEAVlA4IKoAAACQBACdASoZABAAPlEejEQjoaEYBAA4BQSxAF2CcSqsEk0i4Cp5Jt6n3mAzw0AA/v7tXl+kHv/yr//oLXy5lilIf4hdNWSM+jX0RRv1SiDM0CbMw6nEOdnmspNWDCV1PyFeGP5i+HfoJjGw26WPn45B5vHgGXHquvaEb8ucUxD/w1v/xi//vS/2SJD884ONnB1Q/4a2f88/5fi+kJn9ml45nBE7aKBX4NwAAA==";

var img$T = "data:image/webp;base64,UklGRjYAAABXRUJQVlA4ICoAAABQAQCdASoYABAAAQAcJaAAA/zwAP7vsd///qJqP/xv9V///1On//qUAAA=";

var img$S = "data:image/webp;base64,UklGRiQBAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSC4AAAABN6AgAAhEO+L/v3YjIuI/J8ShoG0jxzf++aPeBCL6HxMA8Wcss5f1bCxzLuMPVlA4INAAAADwBACdASoZABAAPlEejEQjoaEYBAA4BQS2AE6ZQYwUZn6/9KVgZv9DVFf1oFcnnzQA/vNkaGhK7eGLr78HJqakmpFkFXflvnfi3E/H0Ff8xLP9BjkkI4Qf+qieswdOEHuH4tAn/matGCyziuzT/faun+iqMza/titkNYPfZKT9gbSnt9r/1z/rqJIUZBk7kcU/5t8xtX/0sOnecc5bwE5Mq3gbdieLY1y4LHG7irk7hB93C2qZMuAeFAVCwQCBW3RGSc+hlKMOlYfFUqyzS4AA";

var img$R = "data:image/webp;base64,UklGRt4AAABXRUJQVlA4WAoAAAAQAAAAGAAADwAAQUxQSBsAAAABFyAWTGTmT9efRkTEAZm0TTr/1vdH9D8GOgIAVlA4IJwAAABwBACdASoZABAAPlEejEQjoaEYBAA4BQS0AE6ZQjgG+q+iqBXbjGROM41+AADONLksm1NV4++eBlVsCKy9N6HXQY+bq8y/6YVivRZuP4YIaO6fRm34Jrln8x7vfYmFh5/0TgT//IMa7A8IvG6daiPpXedfM/r9Q/9UR/s8nu8nfzk2/QwfXf42f9LP7x/5O/nEZCUJJNV7HcHGgAA=";

var img$Q = "data:image/webp;base64,UklGRqYAAABXRUJQVlA4IJoAAADQBACdASoYABAAPlEejEQjoaEYBAA4BQS2AF2L0A2wDJAOgA9RvyVQIbQwARDeIAD51ohJRWaQX6/rwxmmpn8kBauxph35kNUlXue2g5FwpqQgyqf//q5I+/VYPf8v7Wt87J8e/0hSN//1cqDaxMQvG/U4Hncfj36eV/f/53qaoN/5rR0oIK9//+xarD9YOZmidsbSGs8wAAAA";

var img$P = "data:image/webp;base64,UklGRrAAAABXRUJQVlA4IKQAAAAQBQCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQiQC+nXVcIA/Wb34wHj+S5OJKsswAP74S7fru//xz/L8RmGnak3tkq6exp1uphsxDB7X/8WHy+G2xDXvIqu8j8J/aADjvLsw+QBO9Yi3ls/KvVU7B8huYGJbPn1X/+y0eyhkv0tHszjG1Y9URw12nxGOoB9wiZTtavJAYotc1tJpwi70PZAAAA==";

var img$O = "data:image/webp;base64,UklGRqIAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBIAAAABD/D6/4iIIBBIQp9/goj+B81WUDggagAAAHADAJ0BKhgAEAA+UR6MRCOhoRgEADgFBKAAPgEmADm6D10nIAD+/u19K88G0P51qXf731bbzCsn/OPBfY+IEd5eRjHvOmL/TzxznZC1ON9jLo/fQywDn8eDEMoABzUO19b//yU3+3Q2AAA=";

var img$N = "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAAAQAwCdASoYABAAAQAcJaACdMoRwN4B+IH7AcYFygATfQAA/t9V//3AAX/uZ3Z+b+rX/9dy770T3r/cdypynTLZDvx1daAA";

var img$M = "data:image/webp;base64,UklGRugAAABXRUJQVlA4INwAAAAQBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjwfQPD/5zPgAOlC/af0cClmixbQ+osP5X2apxAA/vhOcegjI6wiyJsdJVzDzlHOzwLFYK0h+D1m1jXk87Jil//jn95ScvT+aC4BM8YamwFfTH0f67VaFnuU+fRZQy4tUXaKK/Fkdf/0zSHOW9Lcfaod8Vpqo5CNWZR0DXIk//9Xo3/wa/8jk2WcZfIf/sN9vTX96TD1vyOl+lEaPg5tGXEqT9Aj9Sj/5aybgtJXAQ0PY/q+dyLPlSHmOkZUAAAA";

var img$L = "data:image/webp;base64,UklGRmIAAABXRUJQVlA4IFYAAACwAgCdASoYABAAAQAcJbABCAP4BhAH6qgdm8Rh9jQA/v92RWf/1RH50Mh38f/6Pke/ya/D3z3P5dDEf/48z393M9//7LR53/pxZr9r/nf+nFiKSOnAAA==";

var img$K = "data:image/webp;base64,UklGRrwAAABXRUJQVlA4ILAAAACwBQCdASoYABAAAQAcJbACdLwJ5B+AH4kzAD+V4Tl/M/bbu3T2AP2S/Wb2jAOsiyZvbwC304AA+daz874OvWdqf0N3SEIVFULkhP46pilomJe/xQNv/3i+A9Y5+1N3//FH5IBcop6iEKq/uyEsPn/7On3UHwh0UORa4+jgTmuWBYHt4828GlyKT31sghyBUJTC/rcDnBHmfJ7JQ3BkvAKMQoegIoyOfVV2wKAyPkAAAA==";

var img$J = "data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAADQBACdASoYABAAPlEejEQjoaEYBAA4BQSyAE6ZQjgBBAHKhQb7ezCXMfEZeEPnAAD++ltmN+p1G//yKP+/H6U8SPzDymPKfzom9ijNRzbJF3/EgQA8RzfqD0fOVHHQ5TssX/SdUPW+6OyY/htZTnbv/yDGj+aHo6GrYv1Wf+8lbgvVNtK0lfwmRIeGWsV2gAYAAA==";

var img$I = "data:image/webp;base64,UklGRjQBAABXRUJQVlA4ICgBAAAQBwCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjubwBpAHBAZIV+s37GeySUwPxWZSvqAdCAMv+SU1pWg47qAAAD+9vjxNxhMYfrhncN8ifImvY+8zaZbv1eKvVxJlzPwdyMH+nReDAfcQuw+4u6w01OvVxgQL3PITLe9TPa7JjnM5z+tRSPBC4fgumAiQGnl/Yb7762tGNlTjP0/VjlBvkvf/UQlych5XmM9D69DL93/JM1wtbH7P+Xpb4+Dcuf/OwHek+EP6aNcOnNfMO26C8ziIs/8V/3A97fMxbC812IZ9m4vjb/Vfv6Xb5iTaqsJUypk+BRP5iWqb+3++LX4FDvR3/xHAVZ5cNE91d+NjfqnZ9cz2cr6+3/Oz/Cn6Ime/42lriEgAA==";

var img$H = "data:image/webp;base64,UklGRngBAABXRUJQVlA4IGwBAACQCACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjubyX8K6kCKgOsA9ADykv2O+CL9sPRmRRObLePf5m9EjdZh0zyzyap5c8EYuTbJYAD++E6fs/+q3zAczN2LK/nazUEmtUj9qVsjg6bpkCXUihRGMf56NNouKJkA91mz28Asl1Os85ARa3MPcN7FbX33acrqD3Wrfc2acKLePPBt/q+J3dHAZFmdFMzcozigj2vcVD3/+h1zkZ1gBvw/oPym8M4iGR9f//pSs9NXOJ2YBvsM25//mIcIM1Xcg/ve/Dwbp3+XEf9553MzrYmth/4Kl9ebGQKf/3D/WmKeTsfwn8UnqEn/xJB+/D07/2Qf9v/xrQzSTNZOKmxpwpFvjo5YHEkb/hMC02QwW5vectUvuk51FvUEXkSMq/ZRggmyq7UCf3s/RiaInko+83yVd/F6/9+Ms1KxdvbL9/v82bE8/ruo7ueNO+Wk7AnAAAAA";

var img$G = "data:image/webp;base64,UklGRqgAAABXRUJQVlA4IJwAAAAQBACdASoYABAAPlEejUQjoaEYBAA4BQS2AE6ZQAHB/qv4RAtm3TZIgAD+8xB6blvmJb0PsTv9it2pYVbsX49lP3XQS9Y0BeKLtcssj/v9Tq0xn76dT+fZT9VfJMj1WpircCvuIYjc0tk3+P9WQ2phcGHmOf9M8H7LntZRv7ev2Ub//7LR/1T/GBBvIS+V8+pU+K2LVBJCUZdAAAA=";

var img$F = "data:image/webp;base64,UklGRvYAAABXRUJQVlA4IOoAAADQBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQYwewJwBsAHSA8QD/AfwDAAP0A61jymXeABeYpq94/gEEoAA/vhWfIj+ERn/WL/q3Zo/8f+g64H/x1nahpWfuPiZoKShTfE3V7S1RDLlVCGz//Ppz4P7H/QvP/g2fvLP5XQ+xeWVxfbmFL7uVDuJZJyfXtcAx9T/cPZb59c7fv/xfobD8McT+vduC36n9ugiYpINZ9UKt7aa/VoL+9pUY/3psTB31ul1KfrN28nNT+6dRmdgLFuWjwjcU02ZvwCxNMYTn8WvQNrnz0N/AAA=";

var img$E = "data:image/webp;base64,UklGRoIAAABXRUJQVlA4IHYAAABwAwCdASoYABAAPlEgjUQjoiEYBAA4BQS1AAHwqMZOK/r/1gAA/vG+ueJZMJRQ9RWC+FfuBNhM/V6h9P+38tbL3LGPu1Sf3p9G2BmsZNuLEdWf5tT1Fh4hkv/60Ae//Xrmn//99MlbE32jUv/+EkTlsUMEFgAA";

var img$D = "data:image/webp;base64,UklGRvoAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBUAAAABD9D/iAgIBJL2954hov8RDwAAAAAAVlA4IL4AAAAwBQCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQYwcID/AXH+KgmGaLwUV/Y+UzmewMAD+/u17b665AMzHjQZxlXGb8t3k6mKrkkZ/+lh7yg568tTqF+c2QL9uou+tMu+xb00zjK7hj4ffbuT7D3nU5rM2b/0Z6C37bbz9jt5ywqUVXgbofD+EQ/Pn/CJD58xFH5bjZlYDKO//ih3Ir/zc3M/05nIr/zc3BK5/eY9/Sa8m9VbT8mtTp6qZUFAA";

var img$C = "data:image/webp;base64,UklGRuwAAABXRUJQVlA4IOAAAABQBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQWoG2AaCT6/+mAbyN+1X63FMgeYFMWDMsZXfuwwXsAD+/uxta//g8+wqcHJ8nBwXjfuFxCVJb7pT59fSnpLwdrFr0H8zn/DneXs3Jp0IpCfv6Q/b6dH8YSffOzQP/pjqiVoycxAm/H+yxCV4k/LDPH598+IJE5y6nQnjziFbLR45ziGzCGqQRF7Y/7UFwfobmF/8zPpTn/8U8t35O5xzMtP7gQpPu+429ex+qet2D412mRlULgDoatdDl3H5k6kKQAAAAA==";

var img$B = "data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAAAwAwCdASoYABAAAQAcJbAC7LoBJgP8BhIH6q+/+B5/YibgAPxJH+or/2nqXf4oP/1HoJENX//4tzbevhHmPP/y21FIX8nr5ul+xqgkP+/NBHv5jYjWNq4cApABeAAA";

var img$A = "data:image/webp;base64,UklGRqIAAABXRUJQVlA4IJYAAAAQBQCdASoYABAAPlEejUQjoaEYBAA4BQS2AFiSgBaAXJmqGMDA2X0d+ypMwSuf2twAAP7+7LWyhIrab5/vINmqYT1d1amv9tskSZ4YZNE23pA1FmIqyQwgZ34xIV3na7w//sGKr/6Z/8eNo7WQbn4DFJFl/Py6ujgRCRuBRNaWd0opz4R/4nFmAmjDfjNpfJaGaTbGVAA=";

var img$z = "data:image/webp;base64,UklGRpoAAABXRUJQVlA4II4AAADwBACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbwD8YPxm5AEIADkWpFJ00hAAA/u6If64V3ucV4DeAeYa9s0/MMWNKx1p1YA2GuO6M3Zqp+rJwvI79z15rKgXvqxAil8X/DO+5QngwOSyWElHd3k0W7EwDdrsa3bX+H+9BARn75MdyH7/Ifv8gsAAA";

var img$y = "data:image/webp;base64,UklGRsAAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggiAAAAFAEAJ0BKhgAEAA+UR6NRCOhoRgEADgFBLIATplCOBvQPxVlgABlGR+ps8AA+dLcJ+sugcT0UxX6+HhOWBf5cJrkDxDRNlS95mNpDuqqBbQY328LxJhkKn/2DuCwF8uE4RB39xcvEjf/4S9dh/+fgLaz33WGznXpG+P0aef3JWRNQtPIbhOA4AA=";

var img$x = "data:image/webp;base64,UklGRuYAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBgAAAABD9D/iAgoSNuAWf3b3pMQ0f8JUMY8MSVWUDggqAAAABAFAJ0BKhgAEAA+UR6NRCOhoRgEADgFBLYATplBjB6/9zP/AXH+2wE6AA8fukTJghwA/rIywCVHzUf/I0/nQ5qFM8sngVaHcX1ry7CiZa6/5TP86HOKUiE1od/Yev6l3PAk7H0iVxXgQKIYBDZfDu5JP5bR4N9zZo04sJBKtiHFPvZ5q6c6fD1kplAXn5cIKSN1U33h0lgkHXruGBJwyDlut2athWAAAA==";

var img$w = "data:image/webp;base64,UklGRtwAAABXRUJQVlA4INAAAADwBQCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQYwWQDxYPX/0wDeQP2q9G4mWROSCLItnZvRGwAD+/HVv4t5SzfWW5IZj//wywYZv2fZ76JKfBttlbKAyiOfrvitf+YsAAK4siuLYcIYAJYpIKatk4Hp9E6P/lxNhlTbijJFwnZ/8dr5/zfEzPhbsNEd6m/CKFj843pI4RuuzuNkdT/7zTig22nOrjxcyW/9hbXHBaNJNNmf4nTO54vLusZ0NUmk4HSgT+AIfLtry2WtAAAAA";

var img$v = "data:image/webp;base64,UklGRvwAAABXRUJQVlA4IPAAAADQBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQYwewHmAegB+oHQS+v/pgG5AeiqiQCPeGJ8ifZUiVGh/61QA/u+jNE+IHQP3+eFo1XbanEzuxYthnq/iwhDRa09Yck9fj5DJ0buu1b0sb+HvEDXNhq+fc/euwduqpAwU/3E3p/V2yu3Yt5j7I5+OERRb/6vSnXGCyqIdStne3xe+eWn/+XpTpUsDfIVamv3f/Fl5QzJw74J5Wv8zwDetuvJ8o2CNU/t7SqpD+Jdnh/EK/VEP2p8Nm1F8sKkkbXSg2Fht6+xHc/aVR1l1xxuYbGzmkAA=";

var img$u = "data:image/webp;base64,UklGRtgAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3B08hov8TkG4cAFZQOCCeAAAAEAYAnQEqGAAQAD5RHoxEI6GhGAQAOAUEtQBOmUI8J2AVH/t3f0DRAeIB+oHvq03+BqYiETyS0wAAAP74S7fru//xz/L8RKd398wLmjzSX/+LD5fBbG0Hsx+WAufpoJWWC2Jf/lw7DRKRL4fpB9Nk6HNnPf7LHzb1tP/4vx6Tl1OkKwEYEeNippIJCw4FAC4OW85esinrK3QINBJAAAA=";

var img$t = "data:image/webp;base64,UklGRuAAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3B08hov8TkG4cAFZQOCCmAAAAMAQAnQEqGAAQAD5RHo1EI6GhGAQAOAUEtgBOkCc5Vt/8B4/gWXpTZZ8AAP74S7fru//xz/L9Ci+NOzhPvWd2KIGbvkpU+OpQvTDT0/f/22/9QmTUWoXF1/yY/jjMl8PHAdGM/fEnqBVfuwKNlarCAl/7LR+Hf2iQ//0tH4d/jGlX+qlftPu70A9F+1jjQHMf//odbup74RW8rPHaWoBvAa+RSLKAAA==";

var img$s = "data:image/webp;base64,UklGRkgBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBcAAAABD9D/iAgoSNuA2fzb/g4i+j8BBNSbDgBWUDggCgEAAFAIAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCOBFgVYD+LeIBpAP4B/EP6r7aOmAc8p+o3wl/YAgB2CHBmRQbBW8DuXiEEyCYQADeZ+61Ue//BKb/Ydy+Rd/NY3+D66pHu+ds+xdgc4+9/LjquEHRiRAKSVuXnVAJzC/U27FmnO0e85eEwh+8DW+1okd/U4/t6FJghIM7vyL+P3g7KGx9/8zL/KN+sZxQQ+zPNlrDL7BDlq3i8MaiHj7yYBSIFn/BO+ym7Cfyr9uKwOX4+ZoLYv63mk7uT+CcniAlQfjcHP22Dk4Y2xYgf/nJo9ysclSTS/9JhmA88L/P2ZJgL8/Uf3uslBccAAAA";

var img$r = "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAAAQAwCdASoYABAAAQAcJaACdMoRwN4B+IH7AcYFygATfQAA/t9V//23QX/uZ3Z+b+rX/9dy770T3r/cdypynTLZDvx1daAA";

var img$q = "data:image/webp;base64,UklGRtQAAABXRUJQVlA4IMgAAACwBACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQPAB4gHrgWR8Bhs65KBBuhIwAP74VezTdm6/E1zD5qy0RnBqikJ5T7ue9GO26btPZTYh+Ra0bubz9/yJuYcUZ7DLnyeVT/+vxPpIgqUND7NT782L7wa6JZz043h3+1a7h2NGay/9zZ/gqL9Df6KR+kUDb/97P4dld+f53WoW8eMfNdu/4nfozkN8Q/7inZU164yacuBACFE2Rxf8UZAbWTHYkBtvXC2IYp0AAA==";

var img$p = "data:image/webp;base64,UklGRo4AAABXRUJQVlA4IIIAAACwBQCdASoYABAAPlEUkkcjkRCMADgFBLYAXZdAJOr/APyAwwD3/0AAfgBTgHt9oBawCRqYBsgA99/KXlDf9irG864+31Kzv864/bRlyMoihdj7lo9A82rtUli9nzyj5UOTqvWk5/HllY8TSRxJkAL6B5OnVmndaVqBK1BYNQ70XsAA";

var img$o = "data:image/webp;base64,UklGRooAAABXRUJQVlA4IH4AAACwAwCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQZSAJMZuexjp4AD++Eu367v/8c/y/DlliNk39jMsFx6f2uhiZtt0XAoi4hOjbnrmxv5v/iO2c/+y0f9U/ucbr/9TQf2v/Zxuh9vpXOJjd4BbC8/xKG3w8GDw/yGJaWHfwAA=";

var img$n = "data:image/webp;base64,UklGRg4BAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBIAAAABD9D/iAgIBJL2N58gov+ZNQBWUDgg1gAAAPAEAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYAXZeAT49WADYBfIGoAfoAMDabqHb5gAD++6G13/PPaUo931arn9c/2DJF9me876d/BrS/2L/vwLgTGzearM8jk3xEZEG7u49+JGCvujpPTHmPzilxsQvY81WHsph9U4sa/8PW0Ris9C1T0AjrrVXQmtGhg9NDxQaqzSuf7mkARtCjjYrQI+xPfor1ugQvNpf//Jt8H3V8i4fmGsCv/+B/M5XOxG/wL2vwpDjg/YfBDf/gf1+fsr9KlLNAAAA=";

var img$m = "data:image/webp;base64,UklGRtoAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggogAAABAEAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLIATplAEsz5FIlNcv6jwmAAAP7uoHL+OIv1GfbGbqqESpLLRu6PUTD4AtaiYd++fNZF3exC4JzQICwew/pgdQ/T6PMs/McdbejuZn/4mP/i1AX77P5ACR9jP/F9u532gBrgcL0jPh+Xf+X3JNPX9Gf8JMelKkT/41l+eOu2f+Tozv8s0wDbgRuAAA==";

var img$l = "data:image/webp;base64,UklGRvgAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggwAAAANAFAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCOBtmf4gIIAIivyL/8cMvLox7bpdw3/4CeAAA/vhOc1AEH1IzejVbkc4Ap7UsB8E9FIGaFeB/+MWTV3owV+AfPP0OfJhHu9qn5cJP4E+M8lQL+6pbJXSrWXwJMP7/veYLum1N8GmrGTeKYY3p+uV1Ndj3/xIRCh+kXnWRrr/EhfxvX9TxumnT/dXV69XrCvqDdVkT0axx/XEY44838XZt/dMAAA==";

var img$k = "data:image/webp;base64,UklGRqQAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3Fw8hov8TEJ8BAFZQOCBqAAAAUAMAnQEqGAAQAD5RHoxEI6GhGAQAOAUEoAuwGkAGXRUYGhgA/v7te9f/NW0PifDra9fF5/NppD/7X3b8T0xbiaY/+ZwVPQTVuPdrcTlDzrNf/Z5VF/ZB+/+o/8oA3/Kh//8SF/4hsWIAAA==";

var img$j = "data:image/webp;base64,UklGRrQAAABXRUJQVlA4IKgAAABwBACdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQNf/sicyAAPpCZQzpSVVgAD+9Wef8JFaQ/+w3j/71Xs0AHRviY40dl3gZARCFrPF/qqG6WMl8+6fnJuDjmfXJXzl/opIqJxZGdvI1HkkeipiJvup9f/tPzPsk8nPygyancqz/+/kpZt++5QPf/wPJ4c/Uyt//vyUxivvMfS//A8jrl7C6Tz+l0AAAAA=";

var img$i = "data:image/webp;base64,UklGRgwBAABXRUJQVlA4IAABAADwBwCdASoYABAAPlEgjUQjoiEYBAA4BQS2AE6ZQjgbyD6QKAAdVp+s3wV+RWUqD/h96r6l3+R9QDqAP0AG13T97P2CHxSOs+gA/cWcFWLK13/uKY+G//e9f+t+tP6e8I7tbM6Yr1lmnWTfH7GHuNJmXnrWJk12AzM8YW3yAtzGyWY+hseWQDKxMmDgMzPGFsgmth3mzvH71X6jfkI9/6WHLvVIVyceXi/DzrnlgLZ2xSR0f9wm+3KOjCLWp5u33VwNxJ/pc2o2vr+gN/Vojbrvouj3FaG0IaLtF9/PMJjpZtmvrQ8SRY5P/+MX/glaPv5HMwFV5/7r7z7+pyEAAAAA";

var img$h = "data:image/webp;base64,UklGRioBAABXRUJQVlA4IB4BAAAQBwCdASoYABAAPlEejUQjoaEYBAA4BQS2AE6ZQjgbYA8FXc1fQBvAH6AdM57HnlYJgB3JM3r8VRYRWmy79PXyAAD8sY8ddUYXmldFBYfwAjIOld/i57Pyr6ZjMIMGDkyBscWyiPba/foG39LVHNmNNslhPqsAuawiwJXamkqueDYL137cQNnqVBfsa0++xwGDzH/p7PfpV+9rnyDPXKmVPQ7B/+JeG+OgcVIl3H/wKuW/nwv1W+j/e+H8EfxX4r1RFPRe65UwMNVLPjHxGf7q6k7hDTNq7TIkM881d/B54TmyffdaXfeS3RXtCZ7s3ZjE9iCpd3Uzoew3YPIHutKw/TGndlY4y2rF2K7JOZHWzT/BDu3OM/ALZ6mY+AAA";

var img$g = "data:image/webp;base64,UklGRnwAAABXRUJQVlA4IHAAAABwAwCdASoYABAAPlEejEQjoaEYBAA4BQSgB2AGV/gMUmJ9sJAA/vfGx51Zv+yzUD8CdOr9Bf4ljFao4D/RTZA+ceJLPGn//oeAD/h/5Nsj/n/gRU7m6w+///yrcvqcfIF+G/+pVt7Uz/8SF/4fwAAA";

var img$f = "data:image/webp;base64,UklGRkwBAABXRUJQVlA4IEABAAAQCACdASoYABAAPlEejUQjoaEYBAA4BQS2AE6ZQjgb0neAbwBo//RgaVl7AH67+hmuSV0QWZF5u9DH+xcAx+swhfNZzsq3mYAAAPcEfR0BrlM/8F+WL3gsI704aKA88ErFCRxAXDIVYB4EqfciB9bnDP8Iuu+4J5+fKXC3Ln1JLNL/DPfspY3tpv5YP6bYBVvSRg/+3aZXD9JwLIzH+mWvjkRf1iVT/8gvhdywEBQZDa1a2rtIy+hnAdkpfXs8//skUzA2LLunS7zMuXO/wiz+1v1z96v0c0jDdMuBpj/xu1k/xT+wT8a57kLNO7x7NqOBiXv0psZVnpjVD5Zjbj1/5ADkf+cJhzjXKlLvcoMcP2psf/6jwecve39/b3LWkH/yr/7JL7Uz/LQvzKz8enxpLivyPN/5nh8X/wZ9tYAAAA==";

var img$e = "data:image/webp;base64,UklGRnIAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3Fw8hov8TEJ8BAFZQOCA4AAAA8AEAnQEqGAAQAAEAHCWgArC6AfgABEjAAP7wvZf//WBE/94z/dgvxzb/jm3/2M36dzANpvL+gAA=";

var img$d = "data:image/webp;base64,UklGRvwAAABXRUJQVlA4IPAAAACQBwCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjgbyCmA//+13/TcIz/Sv3urH/aAH9A/AD8gKpAm5osSVgidJIUXjAAA/uxEK2InHq2LL46iZPffQ5D7/l7zpRfcO1PxAeQv1rD/mTlCXcfKGlOlzyF9V8bJs032937uS53t7+r9iX/dH+44ka0vT71bL3pwQrLGhX5bMrHpQlOBf/8o/XdKk//Cc77WvvoxXdQ51gVwnLhr/+TV6Y/v2if+tczVNwssSh9r/hm/Z8YX/y9vjuBC3veGhkPysuXm7E7UT/BTsz3Kf4Kdhsyv5QmCAAA=";

var img$c = "data:image/webp;base64,UklGRvoAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBcAAAABD9D/iAgoaNuGSfjD7i6DiP4nH4k0CQBWUDggvAAAABAFAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLMATplA8AHP/pX/CgKrp/kub/Ct7BtPfjgA/uw9ieCqB9pHLlA/x0zC6D6h4P6ix0MqNHGX4FYr/ShABjxUHzqFwvFob/30o8pIfoE/1GNlLJ6XOk0tb/xvBYP+qVj+oscvQ5j/84l4c/4O66mBYYtObeb8b47/3wwV/sqYhv/l367/KS2b+Ae/f8ihxoM2EqwPy7CJtBWCfLmS1BPiHbRKAAAA";

var img$b = "data:image/webp;base64,UklGRu4AAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBcAAAABD9D/iAgoSNuA2fzb/g4i+j8B+BOWAgBWUDggsAAAAHAFAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLQATplCO5NBnAbwDn/7u0bv9XAAsHH+9limIagA/v7Y2vloZ2/vbLPn+/n36MH+DrjwOncRR91QVcS/csv/1VTjnutJ//X/kaX43T5+PjF7/Q/tT/8AdH+b6/Pk9KHVbGg5Jw8S1Ojmdz/BvugwV0YNsxCVyDm59B6F9U7Gy4S9gcr/cHgn6RUW1keAMn1Bi6DZgcZqYAAA";

var img$a = "data:image/webp;base64,UklGRtYAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBIAAAABD9D/iAgIBJL2B18hov/pMnlWUDggngAAAHAFAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYATplCOBNBm/9yW3/7t0I1AE11cdJ/fzFQ4IAA+diPkehqMQmCbEKFncXzwx//0IZ+2WQawc+p2Ghv/8HOEv4O3UshT/8m2xv+neR+pbhjnpwPqmeYr0bp7dxWwAqk/5SXir/n/lJeL7Gp4ephSdUa/4gt/xBGGotmg9DhstwOqJ+fgAAA";

var img$9 = "data:image/webp;base64,UklGRr4AAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDgghgAAAFAEAJ0BKhgAEAA+USCNRCOiIRgEADgFBLMATplAtAAbIBBv61ersV/EmAAA/vwTG86jPYhD6FksaUn260DQ9/+6ev7Y/7FFGj//2nrwH/08+ddf7fVH9Vth+5AD9P84OI6brmZ3CDlETj3IRy85YKGTtggPGML/T/ft+zeIk9dNoLn4AAAA";

var img$8 = "data:image/webp;base64,UklGRoIAAABXRUJQVlA4IHYAAABQBACdASoYABAAPlEgjkQjoiGYBAA4BQS2AE6ZQjgbwD8IPxu5AACHwUmgAPnYn75U8W8f29P7SDYy9vt+J8cUQ/ootej+Rj3mTjRiQWixNb+95Q//sFgGy7LrPHna/8+NZbEFCOXb7HqlYTy+Sr0a1SABU4AA";

var img$7 = "data:image/webp;base64,UklGRgwBAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSCoAAAABL/Dl/4iIHQraSIruRCEBA5D6F8OPgoj+T0DG7n/G0o0Zu3+gQkPG7n9WUDggvAAAANAFAJ0BKhgAEAA+USCNRCOiIRgEADgFBLYATplBjB7An//ar/meEAf5n2/xaxjfMJFUHqOGWUAA/vlr98cj/AvbHkfXlz9Ut8I6EsiY7M7+dv/Mlnwri6rEbCYHFgLWMJnb6PbsHgjo4emS6buyt3env/pzxVXRn//KZSJL7HoCIVQmIkPa5l21y//j7v0z6zbOCdTLfkvQiaIhorof3IGnDv73x5Fa9/VAOzns+bVNaI6Gv9EXJh+NQAAA";

var img$6 = "data:image/webp;base64,UklGRsgAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggkAAAAPADAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLMATplCOA9wACza+gSs8VAA/vhIz+5XSeZIhVXu8aiJ9pbRMH8J6iMOLhc4+cqyTf9feo+AS6Fsv2/waGaqd/EWQDvWKYmKKC//Bb/0S9dh//Ehf+7JBP+V2mJ//Ehf7uC8q/Hv/6Jeuw+ek5tZl3k+dTL1IqAAAA==";

var img$5 = "data:image/webp;base64,UklGRgABAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBIAAAABD9D/iAgIBJL2N58gov+BRgBWUDggyAAAAFAFAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLYAVgYJ5WADYL/OWoAfsAQ9Vc55sfvi3S7kuAD+/A7eJHiNqixoRFmB1nAztDftXhm6F/yJ6cUfjxWaqLex/7biSc/H5y8h+c4Yqy4jeX1A2wtY7V3rfj3/aIkfb54PYYTCenX1/abSI6nyX31jBEdJaG5wID7Vr4oeim+d/ZexFhmBddf/x2+1zsfmUb7RzkH//fU/mHDJkoGbJEFQ/psgNbiyeggu99sgOU8AwAAA";

var img$4 = "data:image/webp;base64,UklGRqQAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3Fw8hov8TEJ8BAFZQOCBqAAAAEAMAnQEqGAAQAD5RHoxEI6GhGAQAOAUEoAdgAAnUEUAAAP74WLdTf3V/r0c09qo+f1/9oeTr+y7xX9mo63DyHwbLsCxUn//9RDa+jFpf+A6v+5usPv//82D8elf+pQ1/tTP/xIX/h/AAAA==";

var img$3 = "data:image/webp;base64,UklGRowAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBMAAAABD9D/iAgIBJL3B08hov8TkG4cAFZQOCBSAAAAEAIAnQEqGAAQAAEAHCWoAQgACzcKGnKNAAD++2fn4Ov/9X/+oTVpKi//8L9/o3RfgUAL/9kUuyiJ//99HX8TH/Nmmv/++7H8TH/NmgEXHAAAAA==";

var img$2 = "data:image/webp;base64,UklGRgwBAABXRUJQVlA4IAABAABwBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQYwewGLmaYBz4XssfrB6EBMwfqqMclf+ttXP+xivQfAA/k9Uwlx3h8M4STazwR7XLz/v99PHOYDrRwZ+B3/cH3b2uj2r6NIiigJozlBGF7Ff8+uwPfyTe99i7rPHfD8/W1o1wLX+L5wNn5MrDrOw/21V7HSId9gV9YXSPsZ1MM4+78Y8kTcXLPskgPlEJ+mAysdV2QEc/mK/eVA9xkQEWjSdx6/z81Y+Xyg+ofWJPFxr/jUf/Ex/mA/fn5oG+0woozbAKG2Kfw8Nzz5U4D0GnrcZ9Wx94wFzQGxu/2ikpDnUlLgA";

var img$1 = "data:image/webp;base64,UklGRrAAAABXRUJQVlA4WAoAAAAQAAAAFwAADwAAQUxQSBEAAAABD9D/iAgIBJL2N58gov8RMwBWUDggeAAAABAEAJ0BKhgAEAA+UR6MRCOhoRgEADgFBLQATplA1gDJAAnRSCpSf2hgAP73WS/+fmf9Mf9MfOn+tvW3xBGp2VjXvq53jp7+FnqzYkjTTTd1bFTfJ6xf5H/Yrew0KdmNAEEf29JDj6pmG+9ZPFGxNfybL2LbO/GAAA==";

var img = "data:image/webp;base64,UklGRvgAAABXRUJQVlA4IOwAAABwBgCdASoYABAAPlEejEQjoaEYBAA4BQS2AE6ZQjuTQZwGeZ+uBpgG8ZEQ3tgA588Uh7QCzg2JzeBrrgAA/v7tfSlMjeYiY8vUemaFMlBYfVAbwvcQvIajGsBZP7FLaoetj9Ml+p75LnW7L91wWU0HvR8p/uF/L1fOnP/31hbKx2bDKcnx/mq8Z1sauLwQszikk7FJMag+dMbnxBDa91JRPJGn0oZ+CPHJLMCNgle9OkUfqFrQaXhZZeC+f/HJbjpKh98Gq7mfYXn/z3SvT9hjBZi/WbvWrlJmIn3rTp5aT7eStIIb4lKd7AAAAA==";

var flagMap = {
  ad: img$33,
  ae: img$32,
  af: img$31,
  ag: img$30,
  al: img$2$,
  am: img$2_,
  ao: img$2Z,
  ar: img$2Y,
  at: img$2X,
  au: img$2W,
  az: img$2V,
  ba: img$2U,
  bb: img$2T,
  bd: img$2S,
  be: img$2R,
  bf: img$2Q,
  bg: img$2P,
  bh: img$2O,
  bi: img$2N,
  bj: img$2M,
  bn: img$2L,
  bo: img$2K,
  br: img$2J,
  bs: img$2I,
  bt: img$2H,
  bw: img$2G,
  by: img$2F,
  bz: img$2E,
  ca: img$2D,
  cd: img$2C,
  cf: img$2B,
  cg: img$2A,
  ch: img$2z,
  ci: img$2y,
  cl: img$2x,
  cm: img$2w,
  cn: img$2v,
  co: img$2u,
  cr: img$2t,
  cu: img$2s,
  cv: img$2r,
  cy: img$2q,
  cz: img$2p,
  de: img$2o,
  dj: img$2n,
  dk: img$2m,
  dm: img$2l,
  "do": img$2k,
  dz: img$2j,
  ec: img$2i,
  ee: img$2h,
  eg: img$2g,
  er: img$2f,
  es: img$2e,
  et: img$2d,
  fi: img$2c,
  fj: img$2b,
  fm: img$2a,
  fr: img$29,
  ga: img$28,
  gb: img$27,
  gd: img$26,
  ge: img$25,
  gh: img$24,
  gm: img$23,
  gn: img$22,
  gq: img$21,
  gr: img$20,
  gt: img$1$,
  gw: img$1_,
  gy: img$1Z,
  hn: img$1Y,
  hr: img$1X,
  ht: img$1W,
  hu: img$1V,
  id: img$1U,
  ie: img$1T,
  il: img$1S,
  "in": img$1R,
  iq: img$1Q,
  ir: img$1P,
  is: img$1O,
  it: img$1N,
  jm: img$1M,
  jo: img$1L,
  jp: img$1K,
  ke: img$1J,
  kg: img$1I,
  kh: img$1H,
  ki: img$1G,
  km: img$1F,
  kn: img$1E,
  kp: img$1D,
  kr: img$1C,
  kw: img$1B,
  kz: img$1A,
  la: img$1z,
  lb: img$1y,
  lc: img$1x,
  li: img$1w,
  lk: img$1v,
  lr: img$1u,
  ls: img$1t,
  lt: img$1s,
  lu: img$1r,
  lv: img$1q,
  ly: img$1p,
  ma: img$1o,
  mc: img$1n,
  md: img$1m,
  me: img$1l,
  mg: img$1k,
  mh: img$1j,
  mk: img$1i,
  ml: img$1h,
  mm: img$1g,
  mn: img$1f,
  mr: img$1e,
  mt: img$1d,
  mu: img$1c,
  mv: img$1b,
  mw: img$1a,
  mx: img$19,
  my: img$18,
  mz: img$17,
  na: img$16,
  ne: img$15,
  ng: img$14,
  ni: img$13,
  nl: img$12,
  no: img$11,
  np: img$10,
  nr: img$$,
  nz: img$_,
  om: img$Z,
  pa: img$Y,
  pe: img$X,
  pg: img$W,
  ph: img$V,
  pk: img$U,
  pl: img$T,
  ps: img$S,
  pt: img$R,
  pw: img$Q,
  py: img$P,
  qa: img$O,
  ro: img$N,
  rs: img$M,
  ru: img$L,
  rw: img$K,
  sa: img$J,
  sb: img$I,
  sc: img$H,
  sd: img$G,
  se: img$F,
  sg: img$E,
  si: img$D,
  sk: img$C,
  sl: img$B,
  sm: img$A,
  sn: img$z,
  so: img$y,
  sr: img$x,
  ss: img$w,
  st: img$v,
  sv: img$u,
  sy: img$t,
  sz: img$s,
  td: img$r,
  tg: img$q,
  th: img$p,
  tj: img$o,
  tl: img$n,
  tm: img$m,
  tn: img$l,
  to: img$k,
  tr: img$j,
  tt: img$i,
  tv: img$h,
  tw: img$g,
  tz: img$f,
  ua: img$e,
  ug: img$d,
  us: img$c,
  uy: img$b,
  uz: img$a,
  va: img$9,
  vc: img$8,
  ve: img$7,
  vn: img$6,
  vu: img$5,
  ws: img$4,
  ye: img$3,
  za: img$2,
  zm: img$1,
  zw: img
};

var CountryData = {
  af: {
    name: 'Afghanistan',
    localName: 'افغانستان',
    flagUrl: flagMap.af,
    url: 'fa-af'
  },
  al: {
    name: 'Albania',
    localName: 'Shqipëria',
    flagUrl: flagMap.al,
    url: 'sq-al'
  },
  dz: {
    name: 'Algeria',
    localName: 'الجزائر',
    flagUrl: flagMap.dz,
    url: 'ar-dz'
  },
  ad: {
    name: 'Andorra',
    flagUrl: flagMap.ad,
    url: 'ca-ad'
  },
  ao: {
    name: 'Angola',
    flagUrl: flagMap.ao,
    url: 'pt-ao'
  },
  ag: {
    name: 'Antigua and Barbuda',
    flagUrl: flagMap.ag,
    url: 'en-ag'
  },
  ar: {
    name: 'Argentina',
    flagUrl: flagMap.ar,
    url: 'es-ar'
  },
  am: {
    name: 'Armenia',
    localName: 'Հայաստան',
    flagUrl: flagMap.am,
    url: 'hy-am'
  },
  au: {
    name: 'Australia',
    flagUrl: flagMap.au,
    url: 'en-au'
  },
  at: {
    name: 'Austria',
    localName: 'Österreich',
    flagUrl: flagMap.at,
    url: 'de-at'
  },
  az: {
    name: 'Azerbaijan',
    localName: 'Azərbaycan',
    flagUrl: flagMap.az,
    url: 'az-az'
  },
  bs: {
    name: 'Bahamas',
    flagUrl: flagMap.bs,
    url: 'en-bs'
  },
  by: {
    name: 'Belarus',
    localName: 'Беларусь',
    flagUrl: flagMap.by,
    url: 'be-by'
  },
  be: {
    name: 'Belgium',
    localName: 'België',
    flagUrl: flagMap.be,
    url: 'fr-be'
  },
  bz: {
    name: 'Belize',
    localName: 'Belize',
    flagUrl: flagMap.bz,
    url: 'en-bz'
  },
  bj: {
    name: 'Benin',
    localName: 'Bénin',
    flagUrl: flagMap.bj,
    url: 'fr-bj'
  },
  bt: {
    name: 'Bhutan',
    localName: 'འབྲུག་ཡུལ',
    flagUrl: flagMap.bt,
    url: 'dz-bt'
  },
  bo: {
    name: 'Bolivia',
    flagUrl: flagMap.bo,
    url: 'es-bo'
  },
  ba: {
    name: 'Bosnia and Herzegovina',
    localName: 'Bosna i Hercegovina',
    flagUrl: flagMap.ba,
    url: 'bs-ba'
  },
  bw: {
    name: 'Botswana',
    flagUrl: flagMap.bw,
    url: 'en-bw'
  },
  br: {
    name: 'Brazil',
    localName: 'Brasil',
    flagUrl: flagMap.br,
    url: 'pt-br'
  },
  bn: {
    name: 'Brunei',
    flagUrl: flagMap.bn,
    url: 'ms-bn'
  },
  bg: {
    name: 'Bulgaria',
    localName: 'България',
    flagUrl: flagMap.bg,
    url: 'en-bg'
  },
  bf: {
    name: 'Burkina Faso',
    flagUrl: flagMap.bf,
    url: 'fr-bf'
  },
  bi: {
    name: 'Burundi',
    localName: 'Burundi',
    flagUrl: flagMap.bi,
    url: 'rn-bi'
  },
  kh: {
    name: 'Cambodia',
    localName: 'កម្ពុជា',
    flagUrl: flagMap.kh,
    url: 'km-kh'
  },
  cm: {
    name: 'Cameroon',
    localName: 'Cameroun',
    flagUrl: flagMap.cm,
    url: 'fr-cm'
  },
  ca: {
    name: 'Canada',
    flagUrl: flagMap.ca,
    url: 'en-ca'
  },
  cv: {
    name: 'Cape Verde',
    localName: 'Cabo Verde',
    flagUrl: flagMap.cv,
    url: 'pt-CV'
  },
  cf: {
    name: 'Central African Republic',
    localName: 'République centrafricaine',
    flagUrl: flagMap.cf,
    url: 'fr-cf'
  },
  td: {
    name: 'Chad',
    localName: 'تشاد',
    flagUrl: flagMap.td,
    url: 'fr-td'
  },
  cl: {
    name: 'Chile',
    flagUrl: flagMap.cl,
    url: 'es-cl'
  },
  cn: {
    name: 'China',
    localName: '中国',
    flagUrl: flagMap.cn,
    url: 'zh-cn'
  },
  co: {
    name: 'Colombia',
    flagUrl: flagMap.co,
    url: 'es-co'
  },
  km: {
    name: 'Comoros',
    localName: 'جزر القمر',
    flagUrl: flagMap.km,
    url: 'ar-km'
  },
  cr: {
    name: 'Costa Rica',
    flagUrl: flagMap.cr,
    url: 'es-cr'
  },
  hr: {
    name: 'Croatia',
    localName: 'Hrvatska',
    flagUrl: flagMap.hr,
    url: 'en-hr'
  },
  cu: {
    name: 'Cuba',
    flagUrl: flagMap.cu,
    url: 'es-cu'
  },
  cy: {
    name: 'Cyprus',
    localName: 'Κύπρος',
    flagUrl: flagMap.cy,
    url: 'el-cy'
  },
  cz: {
    name: 'Czech Republic',
    localName: 'Česká republika',
    flagUrl: flagMap.cz,
    url: 'cs-cz'
  },
  cd: {
    name: 'Democratic Republic of the Congo',
    localName: 'République démocratique du Congo',
    flagUrl: flagMap.cd,
    url: 'fr-cd'
  },
  dk: {
    name: 'Denmark',
    localName: 'Danmark',
    flagUrl: flagMap.dk,
    url: 'da-dk'
  },
  dj: {
    name: 'Djibouti',
    localName: 'جيبوتي',
    flagUrl: flagMap.dj,
    url: 'ar-dj'
  },
  dm: {
    name: 'Dominica',
    flagUrl: flagMap.dm,
    url: 'en-dm'
  },
  "do": {
    name: 'Dominican Republic',
    localName: 'República Dominicana',
    flagUrl: flagMap["do"],
    url: 'es-do'
  },
  ec: {
    name: 'Ecuador',
    flagUrl: flagMap.ec,
    url: 'es-ec'
  },
  eg: {
    name: 'Egypt',
    localName: 'مصر',
    flagUrl: flagMap.eg,
    url: 'en-eg'
  },
  sv: {
    name: 'El Salvador',
    flagUrl: flagMap.sv,
    url: 'es-sv'
  },
  gq: {
    name: 'Equatorial Guinea',
    localName: 'Guinea Ecuatorial',
    flagUrl: flagMap.gq,
    url: 'es-gq'
  },
  er: {
    name: 'Eritrea',
    localName: 'ኤርትራ',
    flagUrl: flagMap.er,
    url: 'ti-er'
  },
  ee: {
    name: 'Estonia',
    localName: 'Eesti',
    flagUrl: flagMap.ee,
    url: 'en-ee'
  },
  et: {
    name: 'Ethiopia',
    localName: 'ኢትዮጵያ',
    flagUrl: flagMap.et,
    url: 'am-et'
  },
  fj: {
    name: 'Fiji',
    flagUrl: flagMap.fj,
    url: 'en-fj'
  },
  fi: {
    name: 'Finland',
    localName: 'Suomi',
    flagUrl: flagMap.fi,
    url: 'en-fi'
  },
  fr: {
    name: 'France',
    flagUrl: flagMap.fr,
    url: 'fr-fr'
  },
  ga: {
    name: 'Gabon',
    flagUrl: flagMap.ga,
    url: 'fr-ga'
  },
  gm: {
    name: 'Gambia',
    flagUrl: flagMap.gm,
    url: 'en-gm'
  },
  ge: {
    name: 'Georgia',
    localName: 'საქართველო',
    flagUrl: flagMap.ge,
    url: 'ka-ge'
  },
  de: {
    name: 'Germany',
    localName: 'Deutschland',
    flagUrl: flagMap.de,
    url: 'de-de'
  },
  gh: {
    name: 'Ghana',
    flagUrl: flagMap.gh,
    url: 'en-gh'
  },
  gr: {
    name: 'Greece',
    localName: 'Ελλάδα',
    flagUrl: flagMap.gr,
    url: 'en-gr'
  },
  gd: {
    name: 'Grenada',
    flagUrl: flagMap.gd,
    url: 'en-gd'
  },
  gt: {
    name: 'Guatemala',
    flagUrl: flagMap.gt,
    url: 'es-gt'
  },
  gn: {
    name: 'Guinea',
    localName: 'Guinée',
    flagUrl: flagMap.gn,
    url: 'fr-gn'
  },
  gw: {
    name: 'Guinea-Bissau',
    localName: 'Guiné-Bissau',
    flagUrl: flagMap.gw,
    url: 'pt-gw'
  },
  gy: {
    name: 'Guyana',
    flagUrl: flagMap.gy,
    url: 'en-gy'
  },
  ht: {
    name: 'Haiti',
    localName: 'Haïti',
    flagUrl: flagMap.ht,
    url: 'ht-ht'
  },
  hn: {
    name: 'Honduras',
    flagUrl: flagMap.hn,
    url: 'es-gn'
  },
  hu: {
    name: 'Hungary',
    localName: 'Magyarország',
    flagUrl: flagMap.hu,
    url: 'hu-hu'
  },
  "in": {
    name: 'India',
    localName: 'भारत',
    flagUrl: flagMap["in"],
    url: 'en-in'
  },
  us: {
    name: 'United States',
    flagUrl: flagMap.us,
    url: 'en-us'
  },
  id: {
    name: 'Indonesia',
    flagUrl: flagMap.id,
    url: 'id-id'
  },
  pk: {
    name: 'Pakistan',
    localName: 'پاکستان',
    flagUrl: flagMap.pk,
    url: 'ur-pk'
  },
  ng: {
    name: 'Nigeria',
    flagUrl: flagMap.ng,
    url: 'en-ng'
  },
  ru: {
    name: 'Russia',
    localName: 'Россия',
    flagUrl: flagMap.ru,
    url: 'ru-ru'
  },
  mx: {
    name: 'Mexico',
    flagUrl: flagMap.mx,
    url: 'es-mx'
  },
  jp: {
    name: 'Japan',
    localName: '日本',
    flagUrl: flagMap.jp,
    url: 'ja-jp'
  },
  ph: {
    name: 'Philippines',
    localName: 'Pilipinas',
    flagUrl: flagMap.ph,
    url: 'en-ph'
  },
  vn: {
    name: 'Vietnam',
    localName: 'Việt Nam',
    flagUrl: flagMap.vn,
    url: 'vi-vn'
  },
  ir: {
    name: 'Iran',
    localName: 'ایران',
    flagUrl: flagMap.ir,
    url: 'fa-ir'
  },
  tw: {
    name: 'Taiwan',
    localName: '台灣',
    flagUrl: flagMap.tw,
    url: 'zh-tw'
  },
  tr: {
    name: 'Turkey',
    localName: 'Türkiye',
    flagUrl: flagMap.tr,
    url: 'tr-tr'
  },
  th: {
    name: 'Thailand',
    localName: 'ประเทศไทย',
    flagUrl: flagMap.th,
    url: 'th-th'
  },
  gb: {
    name: 'United Kingdom',
    localName: 'United Kingdom',
    flagUrl: flagMap.gb,
    url: 'en-gb'
  },
  tz: {
    name: 'Tanzania',
    flagUrl: flagMap.tz,
    url: 'sw-tz'
  },
  za: {
    name: 'South Africa',
    flagUrl: flagMap.za,
    url: 'en-za'
  },
  it: {
    name: 'Italy',
    localName: 'Italia',
    flagUrl: flagMap.it,
    url: 'it-it'
  },
  ke: {
    name: 'Kenya',
    flagUrl: flagMap.ke,
    url: 'en-ke'
  },
  mm: {
    name: 'Myanmar',
    flagUrl: flagMap.mm,
    url: 'my-mm'
  },
  kr: {
    name: 'South Korea',
    localName: '대한민국',
    flagUrl: flagMap.kr,
    url: 'ko-kr'
  },
  ug: {
    name: 'Uganda',
    flagUrl: flagMap.ug,
    url: 'en-ug'
  },
  sd: {
    name: 'Sudan',
    localName: 'السودان',
    flagUrl: flagMap.sd,
    url: 'ar-sd'
  },
  es: {
    name: 'Spain',
    localName: 'España',
    flagUrl: flagMap.es,
    url: 'es-es'
  },
  iq: {
    name: 'Iraq',
    localName: 'العراق',
    flagUrl: flagMap.iq,
    url: 'ar-iq'
  },
  pl: {
    name: 'Poland',
    localName: 'Polska',
    flagUrl: flagMap.pl,
    url: 'pl-pl'
  },
  ma: {
    name: 'Morocco',
    localName: 'المغرب',
    flagUrl: flagMap.ma,
    url: 'ar-ma'
  },
  sa: {
    name: 'Saudi Arabia',
    localName: 'العربية السعودية',
    flagUrl: flagMap.sa,
    url: 'ar-sa'
  },
  ua: {
    name: 'Ukraine',
    localName: 'Україна',
    flagUrl: flagMap.ua,
    url: 'ru-ua'
  },
  uz: {
    name: 'Uzbekistan',
    localName: 'Ozbekiston',
    flagUrl: flagMap.uz,
    url: 'uz-uz'
  },
  ye: {
    name: 'Yemen',
    localName: 'اليَمَن',
    flagUrl: flagMap.ye,
    url: 'ar-ye'
  },
  pe: {
    name: 'Peru',
    localName: 'Perú',
    flagUrl: flagMap.pe,
    url: 'es-pe'
  },
  my: {
    name: 'Malaysia',
    flagUrl: flagMap.my,
    url: 'en-my'
  },
  mz: {
    name: 'Mozambique',
    localName: 'Moçambique',
    flagUrl: flagMap.mz,
    url: 'pt-mz'
  },
  np: {
    name: 'Nepal',
    localName: 'नेपाल',
    flagUrl: flagMap.np,
    url: 'ne-np'
  },
  mg: {
    name: 'Madagascar',
    localName: 'Madagasikara',
    flagUrl: flagMap.mg,
    url: 'mg-mg'
  },
  ci: {
    name: "Côte d'Ivoire",
    flagUrl: flagMap.ci,
    url: 'fr-ci'
  },
  ve: {
    name: 'Venezuela',
    flagUrl: flagMap.ve,
    url: 'es-ve'
  },
  ne: {
    name: 'Niger',
    flagUrl: flagMap.ne,
    url: 'fr-ne'
  },
  kp: {
    name: 'North Korea',
    localName: '조선민주주의인민공화국',
    flagUrl: flagMap.kp,
    url: 'ko-kp'
  },
  ml: {
    name: 'Mali',
    flagUrl: flagMap.ml,
    url: 'fr-ml'
  },
  sy: {
    name: 'Syria',
    localName: 'سوريا',
    flagUrl: flagMap.sy,
    url: 'ar-sy'
  },
  lk: {
    name: 'Sri Lanka',
    localName: 'ශ්‍රී ලංකා',
    flagUrl: flagMap.lk,
    url: 'si-lk'
  },
  mw: {
    name: 'Malawi',
    flagUrl: flagMap.mw,
    url: 'en-mw'
  },
  zm: {
    name: 'Zambia',
    flagUrl: flagMap.zm,
    url: 'en-zm'
  },
  ro: {
    name: 'Romania',
    localName: 'România',
    flagUrl: flagMap.ro,
    url: 'ro-ro'
  },
  kz: {
    name: 'Kazakhstan',
    localName: 'Қазақстан',
    flagUrl: flagMap.kz,
    url: 'kk-kz'
  },
  so: {
    name: 'Somalia',
    localName: 'Soomaaliya',
    flagUrl: flagMap.so,
    url: 'so-so'
  },
  sn: {
    name: 'Senegal',
    localName: 'Sénégal',
    flagUrl: flagMap.sn,
    url: 'fr-sn'
  },
  nl: {
    name: 'Netherlands',
    localName: 'Nederland',
    flagUrl: flagMap.nl,
    url: 'nl-nl'
  },
  zw: {
    name: 'Zimbabwe',
    flagUrl: flagMap.zw,
    url: 'en-zw'
  },
  rw: {
    name: 'Rwanda',
    flagUrl: flagMap.rw,
    url: 'rw-rw'
  },
  tn: {
    name: 'Tunisia',
    localName: 'تونس',
    flagUrl: flagMap.tn,
    url: 'ar-tn'
  },
  jo: {
    name: 'Jordan',
    localName: 'الأردن',
    flagUrl: flagMap.jo,
    url: 'ar-jo'
  },
  ss: {
    name: 'South Sudan',
    localName: 'جنوب السودان',
    flagUrl: flagMap.ss,
    url: 'en-ss'
  },
  se: {
    name: 'Sweden',
    localName: 'Sverige',
    flagUrl: flagMap.se,
    url: 'sv-se'
  },
  pg: {
    name: 'Papua New Guinea',
    localName: 'Papua Niugini',
    flagUrl: flagMap.pg,
    url: 'en-pg'
  },
  pt: {
    name: 'Portugal',
    flagUrl: flagMap.pt,
    url: 'pt-pt'
  },
  tj: {
    name: 'Tajikistan',
    localName: 'Тоҷикистон',
    flagUrl: flagMap.tj,
    url: 'tg-tj'
  },
  ae: {
    name: 'United Arab Emirates',
    localName: 'دولة الإمارات العربية المتحدة',
    flagUrl: flagMap.ae,
    url: 'ar-ae'
  },
  il: {
    name: 'Israel',
    localName: 'יִשְׂרָאֵל',
    flagUrl: flagMap.il,
    url: 'en-il'
  },
  tg: {
    name: 'Togo',
    flagUrl: flagMap.tg,
    url: 'fr-tg'
  },
  ch: {
    name: 'Switzerland',
    localName: 'Schweiz',
    flagUrl: flagMap.ch,
    url: 'de-ch'
  },
  sl: {
    name: 'Sierra Leone',
    flagUrl: flagMap.sl,
    url: 'en-sl'
  },
  la: {
    name: 'Laos',
    localName: 'ລາວ',
    flagUrl: flagMap.la,
    url: 'lo-la'
  },
  rs: {
    name: 'Serbia',
    localName: 'Србија',
    flagUrl: flagMap.rs,
    url: 'en-rs'
  },
  ni: {
    name: 'Nicaragua',
    flagUrl: flagMap.ni,
    url: 'es-ni'
  },
  ly: {
    name: 'Libya',
    localName: 'ليبيا',
    flagUrl: flagMap.ly,
    url: 'ar-ly'
  },
  py: {
    name: 'Paraguay',
    flagUrl: flagMap.py,
    url: 'es-py'
  },
  kg: {
    name: 'Kyrgyzstan',
    localName: 'Кыргызстан',
    flagUrl: flagMap.kg,
    url: 'ky-kg'
  },
  tm: {
    name: 'Turkmenistan',
    localName: 'Türkmenistan',
    flagUrl: flagMap.tm,
    url: 'tk-tm'
  },
  cg: {
    name: 'Congo',
    flagUrl: flagMap.cg,
    url: 'fr-cg'
  },
  sg: {
    name: 'Singapore',
    flagUrl: flagMap.sg,
    url: 'en-sg'
  },
  sk: {
    name: 'Slovakia',
    localName: 'Slovensko',
    flagUrl: flagMap.sk,
    url: 'cs-sk'
  },
  no: {
    name: 'Norway',
    localName: 'Norge',
    flagUrl: flagMap.no,
    url: 'en-no'
  },
  lr: {
    name: 'Liberia',
    flagUrl: flagMap.lr,
    url: 'en-lr'
  },
  ps: {
    name: 'State of Palestine',
    localName: 'فلسطين',
    flagUrl: flagMap.ps,
    url: 'ar-ps'
  },
  lb: {
    name: 'Lebanon',
    localName: 'لبنان',
    flagUrl: flagMap.lb,
    url: 'ar-lb'
  },
  nz: {
    name: 'New Zealand',
    flagUrl: flagMap.nz,
    url: 'en-nz'
  },
  ie: {
    name: 'Ireland',
    localName: 'Éire',
    flagUrl: flagMap.ie,
    url: 'en-ie'
  },
  mr: {
    name: 'Mauritania',
    localName: 'موريتانيا',
    flagUrl: flagMap.mr,
    url: 'ar-mr'
  },
  om: {
    name: 'Oman',
    localName: 'عمان',
    flagUrl: flagMap.om,
    url: 'ar-om'
  },
  pa: {
    name: 'Panama',
    localName: 'Panamá',
    flagUrl: flagMap.pa,
    url: 'es-pa'
  },
  kw: {
    name: 'Kuwait',
    localName: 'الكويت',
    flagUrl: flagMap.kw,
    url: 'ar-kw'
  },
  mn: {
    name: 'Mongolia',
    localName: 'Монгол Улс',
    flagUrl: flagMap.mn,
    url: 'mn-mn'
  },
  md: {
    name: 'Moldova',
    flagUrl: flagMap.md,
    url: 'ro-md'
  },
  uy: {
    name: 'Uruguay',
    flagUrl: flagMap.uy,
    url: 'es-uy'
  },
  jm: {
    name: 'Jamaica',
    flagUrl: flagMap.jm,
    url: 'en-jm'
  },
  lt: {
    name: 'Lithuania',
    localName: 'Lietuva',
    flagUrl: flagMap.lt,
    url: 'en-lt'
  },
  qa: {
    name: 'Qatar',
    localName: 'قطر',
    flagUrl: flagMap.qa,
    url: 'ar-qa'
  },
  na: {
    name: 'Namibia',
    flagUrl: flagMap.na,
    url: 'en-ma'
  },
  ls: {
    name: 'Lesotho',
    flagUrl: flagMap.ls,
    url: 'en-ls'
  },
  si: {
    name: 'Slovenia',
    localName: 'Slovenija',
    flagUrl: flagMap.si,
    url: 'en-si'
  },
  mk: {
    name: 'North Macedonia',
    localName: 'Северна Македонија',
    flagUrl: flagMap.mk,
    url: 'mk-mk'
  },
  lv: {
    name: 'Latvia',
    localName: 'Latvija',
    flagUrl: flagMap.lv,
    url: 'lv-lv'
  },
  tt: {
    name: 'Trinidad and Tobago',
    flagUrl: flagMap.tt,
    url: 'en-tt'
  },
  tl: {
    name: 'Timor-Leste',
    localName: 'Timor-Leste',
    flagUrl: flagMap.tl,
    url: 'pt-tl'
  },
  mu: {
    name: 'Mauritius',
    localName: 'Moris',
    flagUrl: flagMap.mu,
    url: 'en-mu'
  },
  sz: {
    name: 'Eswatini',
    flagUrl: flagMap.sz,
    url: 'en-sz'
  },
  sb: {
    name: 'Solomon Islands',
    flagUrl: flagMap.sb,
    url: 'en-sb'
  },
  lu: {
    name: 'Luxembourg',
    localName: 'Lëtzebuerg',
    flagUrl: flagMap.lu,
    url: 'lb-lu'
  },
  me: {
    name: 'Montenegro',
    localName: 'Црна Гора',
    flagUrl: flagMap.me,
    url: 'sr-me'
  },
  sr: {
    name: 'Suriname',
    flagUrl: flagMap.sr,
    url: 'nl-sr'
  },
  fm: {
    name: 'Micronesia',
    localName: 'Micronesia',
    flagUrl: flagMap.fm,
    url: 'en-fm'
  },
  mt: {
    name: 'Malta',
    flagUrl: flagMap.mt,
    url: 'mt-mt'
  },
  mv: {
    name: 'Maldives',
    localName: 'ދިވެހިރާއްޖެ',
    flagUrl: flagMap.mv,
    url: 'dv-mv'
  },
  is: {
    name: 'Iceland',
    localName: 'Ísland',
    flagUrl: flagMap.is,
    url: 'is-is'
  },
  vu: {
    name: 'Vanuatu',
    flagUrl: flagMap.vu,
    url: 'bi-vu'
  },
  st: {
    name: 'Sao Tome & Principe',
    localName: 'São Tomé e Príncipe',
    flagUrl: flagMap.st,
    url: 'pt-st'
  },
  ws: {
    name: 'Samoa',
    flagUrl: flagMap.ws,
    url: 'sm-ws'
  },
  lc: {
    name: 'Saint Lucia',
    flagUrl: flagMap.lc,
    url: 'en-lc'
  },
  ki: {
    name: 'Kiribati',
    flagUrl: flagMap.ki,
    url: 'en-ki'
  },
  to: {
    name: 'Tonga',
    flagUrl: flagMap.to,
    url: 'to-to'
  },
  sc: {
    name: 'Seychelles',
    flagUrl: flagMap.sc,
    url: 'en-sc'
  },
  vc: {
    name: 'St. Vincent & Grenadines',
    flagUrl: flagMap.vc,
    url: 'en-vc'
  },
  kn: {
    name: 'Saint Kitts & Nevis',
    flagUrl: flagMap.kn,
    url: 'en-kn'
  },
  mh: {
    name: 'Marshall Islands',
    flagUrl: flagMap.mh,
    url: 'en-mh'
  },
  li: {
    name: 'Liechtenstein',
    flagUrl: flagMap.li,
    url: 'de-li'
  },
  mc: {
    name: 'Monaco',
    flagUrl: flagMap.mc,
    url: 'fr-mc'
  },
  sm: {
    name: 'San Marino',
    flagUrl: flagMap.sm,
    url: 'it-sm'
  },
  pw: {
    name: 'Palau',
    flagUrl: flagMap.pw,
    url: 'en-pw'
  },
  nr: {
    name: 'Nauru',
    flagUrl: flagMap.nr,
    url: 'en-nr'
  },
  tv: {
    name: 'Tuvalu',
    flagUrl: flagMap.tv,
    url: 'en-tv'
  },
  va: {
    name: 'Holy See',
    localName: 'Sancta Sedes',
    flagUrl: flagMap.va,
    url: 'it-va'
  },
  bd: {
    name: 'Bangladesh',
    localName: 'বাংলাদেশ',
    flagUrl: flagMap.bd,
    url: 'bn-bd'
  },
  bh: {
    name: 'Bahrain',
    localName: 'البحرين',
    flagUrl: flagMap.bh,
    url: 'en-bh'
  },
  bb: {
    name: 'Barbados',
    flagUrl: flagMap.bb,
    url: 'en-bb'
  }
};

var css$W = {"countrySwitch__modal":"CountrySwitch-module_countrySwitch__modal__4aNWm","countrySwitch__headline":"CountrySwitch-module_countrySwitch__headline__KDLrx","countrySwitch__dropdown":"CountrySwitch-module_countrySwitch__dropdown__gs64f","countrySwitch__closeIcon":"CountrySwitch-module_countrySwitch__closeIcon__INmjy","countrySwitch__dropdown__wrapper":"CountrySwitch-module_countrySwitch__dropdown__wrapper__Nzwrw","country__flag__inputfield":"CountrySwitch-module_country__flag__inputfield__etC88","arrowUp":"CountrySwitch-module_arrowUp__2CSV2","arrowDown":"CountrySwitch-module_arrowDown__NdvoR","dropdown__input":"CountrySwitch-module_dropdown__input__RDDUi","dropdown__input_noImg":"CountrySwitch-module_dropdown__input_noImg__Ig8Pm","select":"CountrySwitch-module_select__6-E9u","not_selected__country":"CountrySwitch-module_not_selected__country__Wt-xM","country":"CountrySwitch-module_country__sje7T","country__wrapper":"CountrySwitch-module_country__wrapper__eHsc-","country__name":"CountrySwitch-module_country__name__ZwfWy","country__flag":"CountrySwitch-module_country__flag__BUzs8","countrySwitch__links_wrapper":"CountrySwitch-module_countrySwitch__links_wrapper__pSygP","countrySwitch__links":"CountrySwitch-module_countrySwitch__links__tEzdP","countrySwitch__separator":"CountrySwitch-module_countrySwitch__separator__fYHEM","countrySwitch__separator_2":"CountrySwitch-module_countrySwitch__separator_2__69X3d","hidden":"CountrySwitch-module_hidden__rkfCN","countrySwitch__nopage__headline":"CountrySwitch-module_countrySwitch__nopage__headline__QUe58","countrySwitch__nopage__links__wrapper":"CountrySwitch-module_countrySwitch__nopage__links__wrapper__BpPeP","countrySwitch__nopage__links":"CountrySwitch-module_countrySwitch__nopage__links__9fLbr","countrySwitch__nopage__link_close":"CountrySwitch-module_countrySwitch__nopage__link_close__92h5k","countrySwitch__nopage__link_okay":"CountrySwitch-module_countrySwitch__nopage__link_okay__RoKbj","countrySwitch__wrapper":"CountrySwitch-module_countrySwitch__wrapper__mmTNK","countrySwitch__selection__wrapper":"CountrySwitch-module_countrySwitch__selection__wrapper__TNTW0","countrySwitch__links__wrapper":"CountrySwitch-module_countrySwitch__links__wrapper__4DVAm","language_settings__modal":"CountrySwitch-module_language_settings__modal__36ZOl","open":"CountrySwitch-module_open__xVyfm"};

function _createForOfIteratorHelper$3(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$3(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$3(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$3(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0; } }
function _arrayLikeToArray$3(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// FIXME! This can be taken from some npmjs module.
var languageMap = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
  nl: 'Nederlands',
  pt: 'Português',
  it: 'Italiano',
  zh: '中文',
  cs: 'Čeština',
  da: 'Dansk',
  hu: 'Magyar',
  ja: '日本語',
  ko: '한국어',
  no: 'Norsk',
  pl: 'Polski',
  ro: 'Română',
  sv: 'Svenska',
  tr: 'Türkçe',
  ru: 'Русский',
  vi: 'Tiếng Việt',
  id: 'Bahasa Indonesia',
  th: 'ภาษาไทย'
};
var FALLBACK_DOMAIN = 'https://www.igus.eu/';
var WEBTEST_HOSTNAME = 'webtest';
var getLanguageCode = function getLanguageCode(countryCode) {
  var languageCode = getSupportedLanguages(countryCode.toUpperCase());
  return languageCode;
};
var useGetDomainForCountry = function useGetDomainForCountry(countryCode, domains) {
  var _a, _b;
  var availableLanguages = [];
  var _iterator = _createForOfIteratorHelper$3(domains),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var domain = _step.value;
      var matchingLocales = domain.locales.filter(function (locale) {
        return locale.endsWith("-".concat(countryCode.toUpperCase()));
      });
      var _iterator2 = _createForOfIteratorHelper$3(matchingLocales),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var locale = _step2.value;
          var languageCode = (_a = locale.split('-')[0]) !== null && _a !== void 0 ? _a : '';
          availableLanguages.push({
            locales: [locale],
            defaultLocale: locale,
            langName: (_b = languageMap[languageCode]) !== null && _b !== void 0 ? _b : languageCode,
            domain: "https://".concat(domain.domain)
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return availableLanguages;
};
/**
 * Checks whether a country exists within the provided igusDomains list.
 *
 * @param {string} countryCode - The country code.
 * @param {Array<DomainProps>} igusDomains - An array of domain objects.
 * @returns {boolean} True if the country exists; otherwise, false.
 */
var checkCountryExists = function checkCountryExists(countryCode, igusDomains) {
  return igusDomains.some(function (domain) {
    return domain.locales.some(function (locale) {
      return locale.toUpperCase().endsWith("-".concat(countryCode.toUpperCase()));
    });
  });
};
/**
 * Searches for matching links for a specified country in the provided links array.
 *
 * The function handles three scenarios:
 * 1. If already on an alternate link path (e.g., en-de), creates synthetic links for all fallback links
 * 2. Checks for direct matches in the links array
 * 3. Checks for matches in fallback locales
 *
 * @param {LinksDataProps} linksArray - Array of link objects (alternate links for current page)
 * @param {string} countryCode - The country code to check (can be simple 'de' or composite 'en-de')
 * @param {{ [locale: string]: string }} [fallbackLocales={}] - Mapping of main locales to their fallback locales
 * @param {string} [currentLocale] - The current active locale (e.g., 'en-de')
 * @returns {LinksDataProps | null} Array of matching link objects if found, null otherwise
 */
var linkExistsForCountry = function linkExistsForCountry(linksArray, countryCode) {
  var fallbackLocales = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  try {
    if (!countryCode.includes('-')) {
      var nativeLanguages = getLanguageCode(countryCode);
      var nativeLocales = nativeLanguages.map(function (lang) {
        return formatLocaleIdentifier("".concat(lang, "-").concat(countryCode));
      });
      var foundNativeLinks = [];
      var _iterator3 = _createForOfIteratorHelper$3(nativeLocales),
        _step3;
      try {
        var _loop = function _loop() {
          var nativeLocale = _step3.value;
          var nativeLink = linksArray.find(function (link) {
            var nativeLocaleLower = nativeLocale.toLowerCase();
            var fullSlug = link.full_slug || '';
            var fullSlugLower = fullSlug.toLowerCase();
            var normalizedSlug = pathToSlug(fullSlug) || fullSlug;
            var normalizedSlugLower = normalizedSlug.toLowerCase();
            return fullSlugLower.startsWith("".concat(nativeLocaleLower, "/website")) || fullSlugLower.startsWith("".concat(nativeLocaleLower, "/")) || normalizedSlugLower.startsWith("".concat(nativeLocaleLower, "/"));
          });
          if (nativeLink === null || nativeLink === void 0 ? void 0 : nativeLink.published) {
            foundNativeLinks.push(Object.assign(Object.assign({}, nativeLink), {
              locale: nativeLocale
            }));
          } else {
            // If no direct native link found, check fallback
            var fallbackLocale = fallbackLocales[nativeLocale];
            if (fallbackLocale) {
              var fallbackLink = linksArray.find(function (link) {
                var _a, _b;
                var lowerCaseFallback = fallbackLocale.toLowerCase();
                return ((_a = pathToSlug(link.full_slug)) === null || _a === void 0 ? void 0 : _a.startsWith("".concat(lowerCaseFallback, "/website"))) || ((_b = pathToSlug(link.full_slug)) === null || _b === void 0 ? void 0 : _b.startsWith("".concat(lowerCaseFallback, "/")));
              });
              if (fallbackLink === null || fallbackLink === void 0 ? void 0 : fallbackLink.published) {
                foundNativeLinks.push(Object.assign(Object.assign({}, fallbackLink), {
                  locale: nativeLocale
                }));
              }
            }
          }
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (foundNativeLinks.length > 0) {
        return foundNativeLinks;
      }
    }
    // If no native language link found or if searching with explicit locale,
    // fallback to original logic
    var candidateDomains = [];
    if (countryCode.includes('-')) {
      candidateDomains.push(countryCode.toUpperCase());
      var mainLocale = fallbackLocales[countryCode.toUpperCase()];
      if (mainLocale && !candidateDomains.includes(mainLocale.toUpperCase())) {
        candidateDomains.push(mainLocale.toUpperCase());
      }
    } else {
      var languageCodes = getLanguageCode(countryCode);
      candidateDomains = languageCodes.map(function (lang) {
        return "".concat(lang, "-").concat(countryCode).toLowerCase();
      });
    }
    var slugs = candidateDomains.reduce(function (acc, domain) {
      var lowerDomain = domain.toLowerCase();
      var directLink = linksArray.find(function (link) {
        return link.full_slug.toLowerCase().startsWith("".concat(lowerDomain, "/website"));
      }) || linksArray.find(function (link) {
        return link.full_slug.toLowerCase().startsWith("".concat(lowerDomain, "/"));
      }) || linksArray.find(function (link) {
        return (pathToSlug(link.full_slug) || '').toLowerCase().startsWith("".concat(lowerDomain, "/"));
      }) || linksArray.find(function (link) {
        var _a;
        return ((_a = link === null || link === void 0 ? void 0 : link.locale) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === lowerDomain;
      });
      if (directLink && !acc.find(function (link) {
        return link.full_slug === directLink.full_slug;
      })) {
        acc.push(directLink);
      }
      var mainLocale = fallbackLocales[formatLocaleIdentifier(domain)];
      if (mainLocale) {
        var fallbackLink = linksArray.find(function (link) {
          return link.full_slug.toLowerCase().startsWith("".concat(mainLocale.toLowerCase(), "/website"));
        });
        if (fallbackLink && !acc.find(function (link) {
          return link.full_slug === fallbackLink.full_slug;
        })) {
          acc.push(fallbackLink);
        }
      }
      return acc;
    }, []);
    return slugs.length > 0 ? slugs : null;
  } catch (_a) {
    return null;
  }
};
/**
 * Handles a change in the country selection by updating the page URL and returning matching links.
 *
 * @param {string} currentPage - The current page URL.
 * @param {string} selectedCountry - The country code to switch to.
 * @param {LinksDataProps} linksArray - An array of link objects.
 * @param {{ [key: string]: Array<string> }} [fallbackLocales={}] - Optional fallback locales for matching links.
 * @returns {LinksDataProps} An array of matching link objects for the selected country.
 */
var handleCountryChange = function handleCountryChange(currentPage, selectedCountry, linksArray) {
  var fallbackLocales = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var languageCode = getLanguageCode(selectedCountry);
  var updatedPageUrl = languageCode.map(function (lang) {
    var pageUrl = currentPage;
    if (pageUrl.includes('website')) {
      pageUrl = pageUrl.replace('/website/', '');
    }
    return {
      full_slug: pageUrl,
      locale: lang
    };
  });
  var newUrl = linkExistsForCountry(linksArray, selectedCountry, fallbackLocales);
  return newUrl || updatedPageUrl;
};
var getCountryHomepageLink = function getCountryHomepageLink(countryCode) {
  var isProd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'www';
  var hostname = isProd !== null && isProd !== void 0 ? isProd : WEBTEST_HOSTNAME;
  var languageCodes = getLanguageCode(countryCode);
  var _iterator4 = _createForOfIteratorHelper$3(languageCodes),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var languageCode = _step4.value;
      var locale = formatLocaleIdentifier("".concat(languageCode, "-").concat(countryCode.toLocaleUpperCase()));
      var domainSetup = getDomainSetupByLocale(locale);
      if (domainSetup) {
        return "https://".concat(domainSetup.domain).replace('www.', "".concat(hostname, "."));
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return FALLBACK_DOMAIN.replace('www.', "".concat(hostname, "."));
};
/**
 * Retrieves the possible links for a given country from the provided igusDomains.
 *
 * @param {string} countryCode - The country code.
 * @param {Array<DomainProps>} igusDomains - An array of domain objects.
 * @returns {string} The homepage link for the specified country.
 */
var getDomainsForCountry = function getDomainsForCountry(country, domains, linksData) {
  var isProd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'www';
  var _a, _b, _c;
  var selectedCountry = [];
  var hostname = isProd !== null && isProd !== void 0 ? isProd : WEBTEST_HOSTNAME;
  var upperCountryCode = country.toUpperCase();
  var countryCodeSuffix = "-".concat(upperCountryCode);
  var _iterator5 = _createForOfIteratorHelper$3(domains),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var domain = _step5.value;
      var formattedDomain = formatLink(domain.domain).replace('www.', "".concat(hostname, ".")).replace(/\/+$/, '');
      var _iterator7 = _createForOfIteratorHelper$3(domain.locales),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var locale = _step7.value;
          if (locale.endsWith(countryCodeSuffix) && locale !== 'en-DE') {
            selectedCountry.push({
              locales: [locale],
              defaultLocale: locale,
              domain: formattedDomain,
              langName: (_a = languageMap[locale.split('-')[0]]) !== null && _a !== void 0 ? _a : locale.split('-')[0]
            });
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
    // build a map of normalized slugs keyed by locale, and keep the source locale derived from each link
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  var localeSlugMap = new Map();
  var _iterator6 = _createForOfIteratorHelper$3(linksData),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var link = _step6.value;
      var normalizedSlug = link.full_slug.includes('website') ? formatLink(removeLocaleFromUrl(link.full_slug, locales)).replace(/\/+$/, '') : removeLocaleFromUrl(link.full_slug, locales).replace(/\/+$/, '');
      // derive a locale key from the link itself if explicit locale is missing
      var fullSlugRaw = (link.full_slug || '').replace(/^\/+/, '');
      var firstSegmentLocale = fullSlugRaw.split('/')[0] || '';
      var derivedLocaleKey = formatLocaleIdentifier(firstSegmentLocale);
      var localeKey = (_c = (_b = link.locale) !== null && _b !== void 0 ? _b : derivedLocaleKey) !== null && _c !== void 0 ? _c : 'de-DE';
      localeSlugMap.set(localeKey, {
        full_slug: normalizedSlug,
        sourceLocale: derivedLocaleKey
      });
    }
    // first available slug info, used as a potential same-country fallback when a locale-specific match is missing
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  var firstAvailableSlugInfo = function () {
    var first = localeSlugMap.values().next();
    return first && first.value || null;
  }();
  var countryHomePageLink = getCountryHomepageLink(country, isProd);
  return selectedCountry.map(function (language) {
    var _a, _b;
    var defaultLocale = language.defaultLocale,
      langName = language.langName,
      domain = language.domain,
      locales = language.locales;
    var matchingLink = localeSlugMap.get(defaultLocale);
    if (isExternalLink$1(linksData)) {
      return {
        locales: locales,
        defaultLocale: defaultLocale,
        langName: langName,
        domain: (_a = matchingLink === null || matchingLink === void 0 ? void 0 : matchingLink.full_slug) !== null && _a !== void 0 ? _a : domain
      };
    }
    var domainSetup = getDomainSetupByLocale(defaultLocale);
    var hasMultipleLangs = domainSetup && domainSetup.locales.length > 1;
    // decide slug for this language
    var selectedSlug = (_b = matchingLink === null || matchingLink === void 0 ? void 0 : matchingLink.full_slug) !== null && _b !== void 0 ? _b : '';
    if (!selectedSlug && firstAvailableSlugInfo) {
      // only reuse a default slug when it originates from the same country as the target
      var targetCountry = (defaultLocale.split('-')[1] || '').toUpperCase();
      var sourceCountry = (firstAvailableSlugInfo.sourceLocale.split('-')[1] || '').toUpperCase();
      if (targetCountry && sourceCountry && targetCountry === sourceCountry) {
        selectedSlug = firstAvailableSlugInfo.full_slug;
      }
    }
    // if the country is not live and it is a multilanguage country
    // we need to add the country code and language code to the domain as query params
    // this is to avoid the country switch modal to open a 404 page when the page exists on the mma site
    if (hasMultipleLangs && defaultLocale && !isLiveLocale(defaultLocale, isProd)) {
      var _defaultLocale$split = defaultLocale.split('-'),
        _defaultLocale$split2 = _slicedToArray(_defaultLocale$split, 2),
        languageCode = _defaultLocale$split2[0],
        countryCode = _defaultLocale$split2[1];
      var finalDomain = "".concat(countryHomePageLink).concat(selectedSlug || '/');
      if (languageCode && countryCode) {
        var separator = finalDomain.includes('?') ? '&' : '?';
        finalDomain += "".concat(separator, "c=").concat(countryCode.toUpperCase(), "&L=").concat(languageCode);
      }
      return {
        defaultLocale: defaultLocale,
        domain: finalDomain,
        langName: langName,
        locales: [defaultLocale]
      };
    }
    var localePrefix = getLocalePrefix(defaultLocale);
    var slugWithLocalePrefix = buildFullSlug(localePrefix, hasMultipleLangs, defaultLocale, selectedSlug);
    // If homepage (no selectedSlug) and multi-language domain, always append a locale segment
    if (!selectedSlug) {
      if (hasMultipleLangs) {
        // use localePrefix when available; otherwise default to defaultLocale segment for default language
        var segment = localePrefix || defaultLocale;
        var base = countryHomePageLink.replace(/\/+$/, '');
        return {
          defaultLocale: defaultLocale,
          domain: "".concat(base, "/").concat(segment),
          langName: langName,
          locales: [defaultLocale]
        };
      }
      // single-language country → bare homepage
      return {
        defaultLocale: defaultLocale,
        domain: countryHomePageLink,
        langName: langName,
        locales: [defaultLocale]
      };
    }
    return {
      defaultLocale: defaultLocale,
      domain: "".concat(countryHomePageLink).concat(slugWithLocalePrefix),
      langName: langName,
      locales: [defaultLocale]
    };
  });
};
/**
 * Checks if the page exists for a given country, updates available domains, and returns the country page status.
 *
 * @param {CheckPageExistsForCountryParams} params - An object containing parameters for the check.
 * @param {LinksDataProps} params.links - An array of link objects.
 * @param {LinksDataProps} params.newUrl - An updated URL object.
 * @param {string} params.selectedCountry - The selected country code.
 * @param {AvailableLanguagesProps} params.availableLanguages - Array of available language objects.
 * @param {(domains: Array<DomainProps>) => void} params.setAvailableDomains - Callback to update the available domains.
 * @param {Array<DomainProps>} params.igusdomains - An array of igus domain objects.
 * @param {string} params.oldUrl - The original URL string.
 * @param {{ [key: string]: Array<string> }} [params.fallbackLocales={}] - Optional fallback locales for matching links.
 * @param {string} [params.locale] - Optional locale string.
 *
 * @returns {CountryPageStatus} Returns an object indicating the status of the page (e.g., 'page exists', 'no page for domain', or 'an error occurred'),
 * optionally including additional data like countryHomePage.
 */
var checkPageExistsForCountry = function checkPageExistsForCountry(_ref) {
  var links = _ref.links,
    newUrl = _ref.newUrl,
    selectedCountry = _ref.selectedCountry,
    availableLanguages = _ref.availableLanguages,
    setAvailableDomains = _ref.setAvailableDomains,
    igusdomains = _ref.igusdomains,
    oldUrl = _ref.oldUrl,
    _ref$fallbackLocales = _ref.fallbackLocales,
    fallbackLocales = _ref$fallbackLocales === void 0 ? {} : _ref$fallbackLocales,
    locale = _ref.locale,
    isProd = _ref.isProd;
  var _a, _b, _c;
  if (oldUrl === '/') {
    var domains = getDomainsForCountry(selectedCountry, availableLanguages, [{
      full_slug: oldUrl
    }], isProd);
    setAvailableDomains(domains);
    return {
      status: 'page exists'
    };
  }
  try {
    if (!isLiveLocale(selectedCountry, isProd)) {
      var _domains = getDomainsForCountry(selectedCountry, availableLanguages, [{
        full_slug: oldUrl
      }], isProd);
      setAvailableDomains(_domains);
      return {
        status: 'no page for domain',
        countryHomePage: (_b = (_a = _domains[0]) === null || _a === void 0 ? void 0 : _a.domain) !== null && _b !== void 0 ? _b : FALLBACK_DOMAIN
      };
    }
    // Derive a slug by prepending the locale if not already there.
    var localizedSlug = locale && !oldUrl.toLowerCase().includes(locale.toLowerCase()) ? "".concat(locale.toLowerCase()).concat(oldUrl) : oldUrl;
    var currentPageInfo = links.find(function (link) {
      return link.full_slug === localizedSlug;
    });
    var currentPageForProcessing = [Object.assign(Object.assign({}, currentPageInfo), {
      full_slug: localizedSlug
    })];
    var linkExists = linkExistsForCountry(links, selectedCountry, fallbackLocales);
    if (!linkExists && locale && localizedSlug.toLowerCase().includes(locale.toLowerCase())) {
      var _domains2 = getDomainsForCountry(selectedCountry, availableLanguages, currentPageForProcessing, isProd);
      setAvailableDomains(_domains2);
      return {
        status: 'page exists'
      };
    }
    if (((_c = currentPageForProcessing[0]) === null || _c === void 0 ? void 0 : _c.full_slug) && slugExists(currentPageForProcessing[0].full_slug, newUrl) && linkExists) {
      var _domains3 = getDomainsForCountry(selectedCountry, availableLanguages, linkExists, isProd);
      setAvailableDomains(_domains3);
      return {
        status: 'page exists'
      };
    }
    if (!checkCountryExists(selectedCountry, igusdomains)) {
      setAvailableDomains([]);
      return {
        status: 'country does not exist'
      };
    }
    if (!linkExists) {
      var countryHomePage = getCountryHomepageLink(selectedCountry);
      var _domains4 = getDomainsForCountry(selectedCountry, availableLanguages, currentPageForProcessing, isProd);
      setAvailableDomains(_domains4);
      return {
        status: 'no page for domain',
        countryHomePage: countryHomePage
      };
    }
    var _domains5 = getDomainsForCountry(selectedCountry, availableLanguages, linkExists, isProd);
    setAvailableDomains(_domains5);
    return {
      status: 'page exists'
    };
  } catch (_d) {
    return {
      status: 'an error occurred'
    };
  }
};
/**
 * Retrieves international links from an array of domain objects.
 *
 * @param {Array<DomainProps>} domains - The array of domain objects.
 * @returns {Array<DomainProps>} A filtered array containing only international links (English and Spanish).
 */
var getInternationalLinks = function getInternationalLinks(domains) {
  var isProd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'www';
  var hostname = isProd !== null && isProd !== void 0 ? isProd : WEBTEST_HOSTNAME;
  return domains.filter(function (domain) {
    return domain.locales.some(function (locale) {
      return (
        // FIXME! Do we really need es-int?
        locale.toLowerCase() === 'en-de' || locale.toLowerCase() === 'es-int'
      );
    });
  }).map(function (domain) {
    return Object.assign(Object.assign({}, domain), {
      domain: domain.domain.replace('www.', "".concat(hostname, "."))
    });
  });
};
var sortCountries = function sortCountries(a, b) {
  var _a, _b;
  var countryA = (_a = CountryData[a.toLowerCase()]) === null || _a === void 0 ? void 0 : _a.name.toUpperCase();
  var countryB = (_b = CountryData[b.toLowerCase()]) === null || _b === void 0 ? void 0 : _b.name.toUpperCase();
  if (countryA && countryB) {
    if (countryA < countryB) return -1;
    if (countryA > countryB) return 1;
  }
  // FIXME! This is wrong and leads to an unstable sort!
  return 0;
};
var checkConditionStaticText = {
  COUNTRY_DOES_NOT_EXIST: 'country does not exist',
  NO_PAGE_FOR_DOMAIN: 'no page for domain',
  NO_LOCAL_PAGE_FOR_DOMAIN: 'no local page for domain',
  ERROR_TEXT: 'An error occured',
  PAGE_EXISTS_FOR_CURRENT_PAGE: 'page exists for current country'
};
var getFlagUrl = function getFlagUrl(selectedCountry) {
  var _a;
  var flagUrl = (_a = CountryData[selectedCountry.toLowerCase()]) === null || _a === void 0 ? void 0 : _a.flagUrl;
  return typeof flagUrl === 'string' ? flagUrl : flagUrl === null || flagUrl === void 0 ? void 0 : flagUrl.src;
};
var slugExists = function slugExists(slug, data) {
  return data.some(function (item) {
    return (item === null || item === void 0 ? void 0 : item.full_slug) === slug;
  });
};
var isExternalLink$1 = function isExternalLink(links) {
  return links.some(function (link) {
    var _a, _b;
    return ((_a = link === null || link === void 0 ? void 0 : link.full_slug) === null || _a === void 0 ? void 0 : _a.startsWith('https://')) || ((_b = link === null || link === void 0 ? void 0 : link.full_slug) === null || _b === void 0 ? void 0 : _b.startsWith('http://'));
  });
};
/**
 * Checks if the current locale is a fallback and returns its main locale
 */
var findMainLocaleFromFallback = function findMainLocaleFromFallback(currentLocale, fallbackLang) {
  var _a;
  var loweredLocale = formatLocaleIdentifier(currentLocale);
  return (_a = fallbackLang[loweredLocale]) !== null && _a !== void 0 ? _a : null;
};
/**
 * Determines if a locale is considered "live" based on the environment and locale configuration
 *
 * @param {string} locale - The locale to check. Can be:
 *   - a full locale with country code (e.g., 'en-us')
 *   - just a country code (e.g., 'us')
 * @param {string | null} isProd - Environment indicator:
 *   - 'www' for production environment
 *   - null for test environment (webtest)
 * @returns {boolean} Returns:
 *   - true if in test environment (isProd is null)
 *   - true if in production and locale is in liveLocales set
 *   - false if in production and locale is not in liveLocales set
 */
var isLiveLocale = function isLiveLocale(locale) {
  var isProd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'www';
  return !isProd || (locale.includes('-') ? liveLocales.has(locale) : getLanguageCode(locale).some(function (langCode) {
    return liveLocales.has("".concat(langCode, "-").concat(locale.toUpperCase()));
  }));
};
var useFilteredCountries = function useFilteredCountries(isDropdownOpen, searchInput, countryData) {
  return React.useMemo(function () {
    if (!isDropdownOpen) {
      return countryData;
    }
    return Object.entries(countryData).reduce(function (acc, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        country = _ref4[1];
      if (country.name.toLowerCase().includes(searchInput.toLowerCase())) {
        acc[key] = country;
      }
      return acc;
    }, {});
  }, [searchInput]);
};
var localeRegexCache = new Map();
/**
 * Removes the locale segment (e.g., /en-gb/) from the start of a URL path.
 * @param url The URL path (e.g., /en-gb/products)
 * @param locales Array of supported locale strings (e.g., ['en-gb', 'fr', ...])
 * @returns The URL path without the locale segment
 */
var removeLocaleFromUrl = function removeLocaleFromUrl(url, locales) {
  if (!url) return url;
  var cacheKey = locales.join(',');
  var localePattern = localeRegexCache.get(cacheKey);
  if (!localePattern) {
    var normalizedLocales = locales.map(function (l) {
      return l.toLowerCase();
    });
    localePattern = new RegExp("^/?(".concat(normalizedLocales.join('|'), ")(/|$)"), 'i');
    localeRegexCache.set(cacheKey, localePattern);
  }
  return url.replace(localePattern, '/');
};
/**
 * Builds URL slug with appropriate locale prefixes for multi-language domains.
 *
 * @param {string | false} localePrefix - Locale prefix from getLocalePrefix() or false if none
 * @param {boolean} hasMultipleLangs - Whether domain supports multiple languages
 * @param {string} defaultLocale - Full locale identifier (e.g., "de-CH", "en-CA")
 * @param {string} slug - Page slug without locale (e.g., "/products")
 *
 * @returns {string} Complete URL slug:
 *   - Single language: slug unchanged
 *   - Multi-language with prefix: `/${localePrefix}${slug}`
 *   - Multi-language without prefix: `/${defaultLocale}${slug}`
 *
 * @example
 * buildFullSlug("de-ch", true, "de-CH", "/products") // "/de-ch/products"
 * buildFullSlug("de-de", false, "de-DE", "/products") // "/products"
 */
var buildFullSlug = function buildFullSlug(localePrefix, hasMultipleLangs, defaultLocale, slug) {
  if (!hasMultipleLangs) {
    return slug;
  }
  if (!localePrefix) {
    return "/".concat(defaultLocale).concat(slug);
  }
  return "/".concat(localePrefix).concat(slug);
};

var css$V = {"countrySwitch__clearSelection__button":"CloseInputButton-module_countrySwitch__clearSelection__button__GjLKS","countrySwitch__clearSelection__icon":"CloseInputButton-module_countrySwitch__clearSelection__icon__vZW9u"};

var CloseInputButton = function CloseInputButton(_ref) {
  var onClearSelection = _ref.onClearSelection;
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": "Clear selection",
    title: "Clear selection",
    onClick: onClearSelection,
    className: css$V.countrySwitch__clearSelection__button
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: css$V.countrySwitch__clearSelection__icon
  }));
};

var CountrySwitchInput = function CountrySwitchInput(_ref) {
  var selectedCountry = _ref.selectedCountry,
    isDropdownOpen = _ref.isDropdownOpen,
    searchInput = _ref.searchInput,
    onSearchInputChange = _ref.onSearchInputChange,
    toggleDropdown = _ref.toggleDropdown,
    onClearSelection = _ref.onClearSelection,
    dropdownButtonRef = _ref.dropdownButtonRef,
    dropdownRef = _ref.dropdownRef,
    children = _ref.children,
    inputPlaceholderText = _ref.inputPlaceholderText,
    className = _ref.className,
    _ref$hideCloseBtn = _ref.hideCloseBtn,
    hideCloseBtn = _ref$hideCloseBtn === void 0 ? false : _ref$hideCloseBtn;
  var _a, _b, _c;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$W.countrySwitch__dropdown__wrapper, " ").concat(className ? className : '')
  }, selectedCountry && (/*#__PURE__*/React.createElement("img", {
    src: getFlagUrl(selectedCountry),
    alt: ((_a = CountryData[selectedCountry]) === null || _a === void 0 ? void 0 : _a.name) || ((_b = CountryData[selectedCountry]) === null || _b === void 0 ? void 0 : _b.localName) || '',
    width: 24,
    height: 16,
    className: css$W.country__flag__inputfield,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    fetchpriority: 'low'
  })), /*#__PURE__*/React.createElement("input", {
    placeholder: inputPlaceholderText,
    value: isDropdownOpen ? searchInput : ((_c = CountryData[selectedCountry]) === null || _c === void 0 ? void 0 : _c.name) || inputPlaceholderText,
    onChange: onSearchInputChange,
    onClick: toggleDropdown,
    className: chainConditionalClassnames(css$W.dropdown__input, conditionalClassname(selectedCountry === '', css$W.dropdown__input_noImg), conditionalClassname(selectedCountry !== '', css$W.dropdown__input_selected))
  }), !hideCloseBtn && (/*#__PURE__*/React.createElement(CloseInputButton, {
    onClearSelection: onClearSelection
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": "Toggle dropdown",
    title: "Toggle dropdown",
    onClick: toggleDropdown,
    className: isDropdownOpen ? css$W.arrowUp : css$W.arrowDown,
    ref: dropdownButtonRef
  }, /*#__PURE__*/React.createElement(ArrowFill, null))), /*#__PURE__*/React.createElement("div", {
    ref: dropdownRef,
    style: {
      display: isDropdownOpen ? 'block' : 'none'
    }
  }, children));
};

var CountrySwitchDropdown = function CountrySwitchDropdown(_ref) {
  var onSelectCountry = _ref.onSelectCountry,
    selectedCountry = _ref.selectedCountry,
    countries = _ref.countries,
    isOpen = _ref.isOpen;
  var dropdownRef = useRef(null);
  var selectedOptionRef = useRef(null);
  useEffect(function () {
    if (isOpen && dropdownRef.current && selectedOptionRef.current) {
      var dropdownHeight = dropdownRef.current.clientHeight;
      var optionHeight = selectedOptionRef.current.clientHeight;
      var scrollOffset = selectedOptionRef.current.offsetTop - dropdownHeight / 2 + optionHeight / 2;
      dropdownRef.current.scrollTop = scrollOffset;
    }
  }, [isOpen]);
  var mapCountries = function mapCountries(countryCode) {
    var country = CountryData[countryCode];
    return /*#__PURE__*/React.createElement("button", {
      key: countryCode,
      onClick: function onClick() {
        return onSelectCountry(countryCode);
      },
      className: "country-option ".concat(selectedCountry === countryCode ? css$W.select : css$W.not_selected__country, " ").concat(css$W.country),
      ref: selectedCountry === countryCode ? selectedOptionRef : null
    }, /*#__PURE__*/React.createElement("span", {
      className: css$W.country__wrapper
    }, /*#__PURE__*/React.createElement("img", {
      src: getFlagUrl(countryCode),
      alt: country.name,
      width: 24,
      height: 16,
      className: css$W.country__flag
    }), /*#__PURE__*/React.createElement("p", {
      className: css$W.country__name
    }, country.name, country.localName && country.localName !== country.name ? " - ".concat(country.localName) : '')));
  };
  var countryData = Object.keys(countries).sort(sortCountries).map(mapCountries);
  return /*#__PURE__*/React.createElement("div", {
    ref: dropdownRef,
    className: "".concat(css$W.countrySwitch__dropdown, " ").concat(isOpen ? css$W.open : '')
  }, countryData);
};

var InternationalLinks = function InternationalLinks(_ref) {
  var internationalLinks = _ref.internationalLinks,
    internationalLinkTitleEn = _ref.internationalLinkTitleEn,
    internationalLinkTextEn = _ref.internationalLinkTextEn,
    alternateLinks = _ref.alternateLinks,
    setIsModalAlternateOpen = _ref.setIsModalAlternateOpen,
    setNoPageForDomain = _ref.setNoPageForDomain,
    urlPath = _ref.urlPath,
    locale = _ref.locale,
    internationalLinkEn = _ref.internationalLinkEn;
  var _a, _b;
  var euEnglishAlternateLink = (_a = alternateLinks === null || alternateLinks === void 0 ? void 0 : alternateLinks.find(function (link) {
    var _a;
    return (_a = link === null || link === void 0 ? void 0 : link.full_slug) === null || _a === void 0 ? void 0 : _a.startsWith('en-de');
  })) === null || _a === void 0 ? void 0 : _a.full_slug;
  var euEnglishBaseUrl = removeQueryFromUrl("https://".concat((_b = internationalLinks === null || internationalLinks === void 0 ? void 0 : internationalLinks[0]) === null || _b === void 0 ? void 0 : _b.domain));
  var getEuAlternateLink = function getEuAlternateLink() {
    if (euEnglishAlternateLink) {
      return "".concat(euEnglishBaseUrl).concat(removeLanguageSegmentFromUrl(euEnglishAlternateLink));
    }
    return euEnglishBaseUrl;
  };
  var euAlternateLink = getEuAlternateLink();
  var handleLinkClick = function handleLinkClick(event) {
    if (euEnglishBaseUrl === euAlternateLink && urlPath !== '/' && locale !== 'en-de') {
      event.preventDefault();
      setNoPageForDomain(function (prev) {
        return Object.assign(Object.assign({}, prev), {
          countryHomePageLink: euEnglishBaseUrl,
          countryHomeText: 'INT (English)'
        });
      });
      return setIsModalAlternateOpen(true);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css$W.countrySwitch__links_wrapper
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleLinkClick,
    className: css$W.countrySwitch__links
  }, /*#__PURE__*/React.createElement(Link, {
    href: internationalLinkEn || euAlternateLink || euEnglishBaseUrl,
    variant: LinkVariant.Primary,
    title: internationalLinkTitleEn,
    target: TargetValues.Self,
    external: true,
    showExternalIcon: false
  }, internationalLinkTextEn)));
};
var removeQueryFromUrl = function removeQueryFromUrl(url) {
  if (!url) {
    return '';
  }
  var parsedUrl = new URL(url);
  parsedUrl.search = '';
  return parsedUrl.toString().replace(/\/+$/, '');
};
var removeLanguageSegmentFromUrl = function removeLanguageSegmentFromUrl(url) {
  return url.replace(/^[a-z]{2}-[a-z]{2}\/website/, '').replace(/^[a-z]{2}-[a-z]{2}\//, '/').replace(/\/website/, '').replace(/\/+$/, '');
};

var CountrySwitchContext = /*#__PURE__*/createContext({
  selectedCountry: '',
  setSelectedCountry: function setSelectedCountry() {},
  isModalOpen: false,
  setIsModalOpen: function setIsModalOpen() {}
});
var CountrySwitchContextProvider = function CountrySwitchContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    selectedCountry = _useState[0],
    setSelectedCountry = _useState[1];
  var _useState2 = useState(false),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var contextValue = useMemo(function () {
    return {
      selectedCountry: selectedCountry.toLowerCase(),
      setSelectedCountry: setSelectedCountry,
      isModalOpen: isModalOpen,
      setIsModalOpen: setIsModalOpen
    };
  }, [isModalOpen, selectedCountry]);
  return /*#__PURE__*/React.createElement(CountrySwitchContext.Provider, {
    value: contextValue
  }, children);
};

var NoPageDialog = function NoPageDialog(_ref) {
  var languageSettingsHeadline = _ref.languageSettingsHeadline,
    unavailablePageText = _ref.unavailablePageText,
    switchToCountryHomepageText = _ref.switchToCountryHomepageText,
    cancelButtonText = _ref.cancelButtonText,
    okayButtonText = _ref.okayButtonText,
    homepageText = _ref.homepageText,
    countryHomePageLink = _ref.countryHomePageLink,
    euEnglishText = _ref.euEnglishText;
  var _a;
  var _useContext = useContext(CountrySwitchContext),
    selectedCountry = _useContext.selectedCountry,
    setSelectedCountry = _useContext.setSelectedCountry,
    setIsModalOpen = _useContext.setIsModalOpen;
  var modalRef = useRef(null);
  var closeModal = function closeModal() {
    var _a;
    (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.close();
    setIsModalOpen(false);
    setSelectedCountry('');
  };
  useEffect(function () {
    var modal = modalRef.current;
    if (modal && !modal.open) {
      modal.showModal();
    }
  }, []);
  var countryName = (_a = CountryData[selectedCountry]) === null || _a === void 0 ? void 0 : _a.name;
  var unavailablePage = "".concat(unavailablePageText, " ").concat(euEnglishText || countryName, ". ").concat(switchToCountryHomepageText);
  return /*#__PURE__*/React.createElement("dialog", {
    className: "".concat(css$W.countrySwitch__modal, " ").concat(css$W.language_settings__modal),
    ref: modalRef
  }, /*#__PURE__*/React.createElement("button", {
    className: css$W.countrySwitch__closeIcon,
    onClick: function onClick() {
      closeModal();
    },
    "aria-label": "Close modal",
    title: "Close modal"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H2,
    className: css$W.countrySwitch__nopage__headline
  }, languageSettingsHeadline), /*#__PURE__*/React.createElement("p", null, unavailablePage), /*#__PURE__*/React.createElement("ul", {
    className: css$W.countrySwitch__nopage__links__wrapper
  }, /*#__PURE__*/React.createElement("li", {
    className: css$W.countrySwitch__nopage__links
  }, /*#__PURE__*/React.createElement("button", {
    className: css$W.countrySwitch__nopage__link_close,
    onClick: function onClick() {
      closeModal();
    }
  }, cancelButtonText), /*#__PURE__*/React.createElement(Link, {
    href: countryHomePageLink,
    variant: LinkVariant.Button,
    title: homepageText,
    target: TargetValues.Self,
    external: true,
    showExternalIcon: false,
    className: css$W.countrySwitch__nopage__link_okay
  }, okayButtonText))));
};

var CountrySwitchModal = function CountrySwitchModal(_ref) {
  var alternateLinksForCountrySwitch = _ref.alternateLinksForCountrySwitch,
    domainsforCountrySwitch = _ref.domainsforCountrySwitch,
    countryOrRegionText = _ref.countryOrRegionText,
    notificationText = _ref.notificationText,
    languageSettingsHeadline = _ref.languageSettingsHeadline,
    requestLanguageChangeText = _ref.requestLanguageChangeText,
    unavailableLinksText = _ref.unavailableLinksText,
    internationalLinksText = _ref.internationalLinksText,
    unavailablePageText = _ref.unavailablePageText,
    switchToCountryHomepageText = _ref.switchToCountryHomepageText,
    cancelButtonText = _ref.cancelButtonText,
    okayButtonText = _ref.okayButtonText,
    inputPlaceholderText = _ref.inputPlaceholderText,
    internationalLinkTitleEn = _ref.internationalLinkTitleEn,
    internationalLinkTextEn = _ref.internationalLinkTextEn,
    internationalLinkTitleEs = _ref.internationalLinkTitleEs,
    internationalLinkTextEs = _ref.internationalLinkTextEs,
    homepageText = _ref.homepageText,
    searchInput = _ref.searchInput,
    internationalLinkEs = _ref.internationalLinkEs,
    internationalLinkEn = _ref.internationalLinkEn,
    setSearchInput = _ref.setSearchInput,
    locale = _ref.locale,
    urlPath = _ref.urlPath,
    fallbackLocales = _ref.fallbackLocales,
    isProd = _ref.isProd;
  var _useContext = useContext(CountrySwitchContext),
    selectedCountry = _useContext.selectedCountry,
    setSelectedCountry = _useContext.setSelectedCountry,
    setIsModalOpen = _useContext.setIsModalOpen;
  var links = alternateLinksForCountrySwitch.filter(function (link) {
    return link.published;
  });
  var igusDomains = domainsforCountrySwitch;
  var _useState = useState(false),
    isDropdownOpen = _useState[0],
    setIsDropdownOpen = _useState[1];
  var _useState2 = useState(true),
    linksExist = _useState2[0],
    setLinksExist = _useState2[1];
  var _useState3 = useState([]),
    availableDomains = _useState3[0],
    setAvailableDomains = _useState3[1];
  var _useState4 = useState({
      noPageForDomain: false,
      countryHomePageLink: '',
      countryHomeText: ''
    }),
    noPageForDomainStatus = _useState4[0],
    setNoPageForDomainStatus = _useState4[1];
  var _useState5 = useState(null),
    error = _useState5[0],
    setError = _useState5[1];
  var oldUrl = {
    currentPage: urlPath,
    selectedCountry: selectedCountry
  };
  useEffect(function () {
    if (selectedCountry === '') {
      setAvailableDomains([]);
    }
  }, [selectedCountry]);
  var toggleDropdown = function toggleDropdown() {
    setIsDropdownOpen(!isDropdownOpen);
  };
  var filteredCountries = useFilteredCountries(isDropdownOpen, searchInput, CountryData);
  var handleSearchInputChange = function handleSearchInputChange(_ref2) {
    var value = _ref2.target.value;
    setSearchInput(value);
    if (!value) setSelectedCountry('');
  };
  var newUrl = handleCountryChange(urlPath, selectedCountry, links, fallbackLocales);
  var handleSelectCountry = function handleSelectCountry(countryCode) {
    var _a, _b;
    setSelectedCountry(countryCode);
    setSearchInput((_b = (_a = CountryData[countryCode]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
    toggleDropdown();
  };
  var handleClearSelection = function handleClearSelection() {
    setSelectedCountry('');
    setSearchInput('');
  };
  var availableLanguages = useGetDomainForCountry(selectedCountry, domainsforCountrySwitch);
  var checkAndHandlePageExistence = function checkAndHandlePageExistence() {
    try {
      var result = checkPageExistsForCountry({
        links: links,
        newUrl: newUrl,
        selectedCountry: selectedCountry,
        availableLanguages: availableLanguages,
        setAvailableDomains: setAvailableDomains,
        igusdomains: igusDomains,
        oldUrl: oldUrl.currentPage,
        fallbackLocales: fallbackLocales,
        locale: locale,
        isProd: isProd
      });
      switch (result.status) {
        case checkConditionStaticText.COUNTRY_DOES_NOT_EXIST:
          setLinksExist(false);
          break;
        case checkConditionStaticText.NO_PAGE_FOR_DOMAIN:
          if (result.status === 'no page for domain') {
            setNoPageForDomainStatus({
              noPageForDomain: true,
              countryHomePageLink: result.countryHomePage
            });
          }
          break;
        case checkConditionStaticText.NO_LOCAL_PAGE_FOR_DOMAIN:
          setLinksExist(linksExist);
          break;
        default:
          setLinksExist(true);
          if (noPageForDomainStatus.noPageForDomain) {
            setNoPageForDomainStatus({
              noPageForDomain: false,
              countryHomePageLink: ''
            });
          }
          break;
      }
    } catch (error) {
      if (error instanceof Error) {
        setError(error);
      }
    }
  };
  var internationalLinks = getInternationalLinks(igusDomains, isProd);
  var modalRef = useRef(null);
  var dropdownRef = useRef(null);
  var dropdownButtonRef = useRef(null);
  var isDomainMounted = useRef(false);
  var handleDropdownClickOutside = useCallback(function (event) {
    var _a;
    if ((_a = dropdownButtonRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) {
      return;
    }
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  }, []);
  var closeModal = function closeModal(setIsModalOpen, setSelectedCountry) {
    var _a;
    (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.close();
    setIsModalOpen(false);
    setSelectedCountry('');
  };
  useEffect(function () {
    var handleEscape = function handleEscape(event) {
      if (event.key === 'Escape') {
        closeModal(setIsModalOpen, setSelectedCountry);
      }
    };
    window.addEventListener('keydown', handleEscape);
    return function () {
      window.removeEventListener('keydown', handleEscape);
    };
  });
  useEffect(function () {
    var modal = modalRef.current;
    if (modal && !modal.open) {
      modal.showModal();
    }
    document.addEventListener('mousedown', handleDropdownClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleDropdownClickOutside);
    };
  }, [handleDropdownClickOutside]);
  useEffect(function () {
    checkAndHandlePageExistence();
    isDomainMounted.current = true;
  }, [selectedCountry]);
  var _useState6 = useState(false),
    isModalAlternateOpen = _useState6[0],
    setIsModalAlternateOpen = _useState6[1];
  var handleAlternatePage = function handleAlternatePage(domain) {
    var result = checkPageExistsForCountry({
      links: links,
      newUrl: newUrl,
      selectedCountry: selectedCountry,
      availableLanguages: availableLanguages,
      setAvailableDomains: setAvailableDomains,
      igusdomains: igusDomains,
      oldUrl: oldUrl.currentPage,
      fallbackLocales: fallbackLocales,
      locale: locale,
      isProd: isProd
    });
    if (result.status === 'page exists') {
      window.location.href = domain.domain;
      return;
    }
    setNoPageForDomainStatus(function (prev) {
      var _a;
      return Object.assign(Object.assign({}, prev), {
        countryHomePageLink: domain.domain,
        countryHomeText: "".concat((_a = CountryData[selectedCountry]) === null || _a === void 0 ? void 0 : _a.name, " (").concat(domain.langName, ")")
      });
    });
    setIsModalAlternateOpen(true);
  };
  var handleKeyDown = function handleKeyDown(e, domain) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleAlternatePage(domain);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("dialog", {
    className: chainConditionalClassnames(css$W.countrySwitch__modal, conditionalClassname(isModalAlternateOpen, css$W.hidden)),
    ref: modalRef
  }, /*#__PURE__*/React.createElement("button", {
    className: css$W.countrySwitch__closeIcon,
    onClick: function onClick() {
      closeModal(setIsModalOpen, setSelectedCountry);
    },
    "aria-label": "Close modal",
    title: "Close modal"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: css$W.countrySwitch__wrapper
  }, /*#__PURE__*/React.createElement(Col, {
    className: css$W.countrySwitch__selection__wrapper
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H2,
    className: css$W.countrySwitch__headline
  }, countryOrRegionText), /*#__PURE__*/React.createElement("p", null, notificationText), /*#__PURE__*/React.createElement(CountrySwitchInput, {
    isDropdownOpen: isDropdownOpen,
    searchInput: searchInput,
    onClearSelection: handleClearSelection,
    dropdownRef: dropdownRef,
    onSearchInputChange: handleSearchInputChange,
    selectedCountry: selectedCountry,
    toggleDropdown: toggleDropdown,
    dropdownButtonRef: dropdownButtonRef,
    inputPlaceholderText: inputPlaceholderText
  }, /*#__PURE__*/React.createElement(CountrySwitchDropdown, {
    onSelectCountry: handleSelectCountry,
    selectedCountry: selectedCountry,
    countries: filteredCountries,
    isOpen: isDropdownOpen
  }))), /*#__PURE__*/React.createElement(Col, {
    className: css$W.countrySwitch__links__wrapper
  }, /*#__PURE__*/React.createElement(Separator, {
    className: css$W.countrySwitch__separator
  }), /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H2,
    className: css$W.countrySwitch__headline
  }, languageSettingsHeadline), /*#__PURE__*/React.createElement("p", null, requestLanguageChangeText, ":"), isDomainMounted.current && (availableDomains === null || availableDomains === void 0 ? void 0 : availableDomains.length) > 0 && (/*#__PURE__*/React.createElement("ul", {
    className: css$W.countrySwitch__links_wrapper
  }, availableDomains.map(function (domain) {
    var _a, _b;
    return /*#__PURE__*/React.createElement("li", {
      className: css$W.countrySwitch__links,
      key: domain.langName
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        e.preventDefault();
        handleAlternatePage(domain);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, domain);
      }
    }, /*#__PURE__*/React.createElement(Link, {
      href: domain.domain,
      variant: LinkVariant.Primary,
      title: "".concat((_a = CountryData[selectedCountry]) === null || _a === void 0 ? void 0 : _a.name, " (").concat(domain.langName, ")"),
      target: TargetValues.Self,
      external: true,
      showExternalIcon: false,
      onCountrySwitch: true
    }, "".concat((_b = CountryData[selectedCountry]) === null || _b === void 0 ? void 0 : _b.name, " (").concat(domain.langName, ")"))));
  }))), isDomainMounted.current && !(availableDomains.length > 0) && selectedCountry && /*#__PURE__*/React.createElement("p", null, unavailableLinksText), !selectedCountry && /*#__PURE__*/React.createElement("p", null, internationalLinksText), error && /*#__PURE__*/React.createElement("p", null, checkConditionStaticText.ERROR_TEXT), /*#__PURE__*/React.createElement(Separator, {
    className: css$W.countrySwitch__separator_2
  }), /*#__PURE__*/React.createElement(InternationalLinks, {
    alternateLinks: alternateLinksForCountrySwitch,
    internationalLinks: internationalLinks,
    internationalLinkTextEn: internationalLinkTextEn,
    internationalLinkTitleEn: internationalLinkTitleEn,
    internationalLinkTextEs: internationalLinkTextEs,
    internationalLinkTitleEs: internationalLinkTitleEs,
    setNoPageForDomain: setNoPageForDomainStatus,
    setIsModalAlternateOpen: setIsModalAlternateOpen,
    urlPath: urlPath,
    locale: locale,
    internationalLinkEs: internationalLinkEs,
    internationalLinkEn: internationalLinkEn
  })))), /*#__PURE__*/React.createElement("section", {
    id: "country-switch"
  }), isModalAlternateOpen && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(NoPageDialog, {
    countryHomePageLink: noPageForDomainStatus.countryHomePageLink,
    languageSettingsHeadline: languageSettingsHeadline,
    unavailablePageText: unavailablePageText,
    switchToCountryHomepageText: switchToCountryHomepageText,
    cancelButtonText: cancelButtonText,
    okayButtonText: okayButtonText,
    homepageText: homepageText,
    euEnglishText: noPageForDomainStatus.countryHomeText
  }), document.querySelector('#country-switch')));
};

/**
 * Fetches and combines alternate links for a given slug.
 * This is done in two scenarios:
 * 1. When on a fallback language - the alternates are not part of the data, so we need to fetch them separately
 * 2. When on a main locale that might be a fallback for others - we need to ensure we have all possible alternates
 */
var fetchAndCombineAlternateLinks = function fetchAndCombineAlternateLinks(slug, currentAlternates) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _a, storyblokApi, _yield$storyblokApi$g, data, existingSlugs, newAlternates, processedNewAlternates;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          storyblokApi = getStoryblokApi$1();
          _context.next = 4;
          return storyblokApi.get("cdn/stories/".concat(pathToSlug(slug)), {
            version: 'published',
            token: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN
          });
        case 4:
          _yield$storyblokApi$g = _context.sent;
          data = _yield$storyblokApi$g.data;
          if (!((_a = data === null || data === void 0 ? void 0 : data.story) === null || _a === void 0 ? void 0 : _a.alternates)) {
            _context.next = 11;
            break;
          }
          existingSlugs = new Set(currentAlternates.map(function (link) {
            return link.full_slug;
          }));
          newAlternates = data.story.alternates.filter(function (alt) {
            return !existingSlugs.has(alt.full_slug);
          });
          processedNewAlternates = newAlternates.map(function (alt) {
            return Object.assign(Object.assign({}, alt), {
              published: alt.published !== false
            });
          });
          return _context.abrupt("return", [].concat(_toConsumableArray(currentAlternates), _toConsumableArray(processedNewAlternates)));
        case 11:
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", currentAlternates);
        case 16:
          return _context.abrupt("return", currentAlternates);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  }));
};

/**
 * Custom hook that enhances alternate links by including the current page as a candidate.
 *
 * This ensures the current page is always considered when checking for available
 * country/language versions, improving the accuracy of country switching logic.
 *
 * @param alternateLinks - Array of existing alternate links from Storyblok
 * @param currentUrlPath - The current page URL path (e.g., "/products/chains")
 * @param currentLocale - The current locale (e.g., "en-US", "de-DE")
 *
 * @returns Enhanced alternate links array that includes current page if not already present
 */
var useAlternateLinksWithCurrentPage = function useAlternateLinksWithCurrentPage(alternateLinks, currentUrlPath, currentLocale) {
  var linksWithCurrentPage = useMemo(function () {
    if (!currentUrlPath || !currentLocale) {
      return alternateLinks;
    }
    var currentPageSlug = currentLocale && !currentUrlPath.toLowerCase().includes(currentLocale.toLowerCase()) ? "".concat(currentLocale.toLowerCase()).concat(currentUrlPath) : currentUrlPath;
    var currentPageExists = alternateLinks.some(function (link) {
      return link.full_slug === currentPageSlug;
    });
    if (!currentPageExists) {
      return [].concat(_toConsumableArray(alternateLinks), [{
        full_slug: currentPageSlug,
        locale: currentLocale,
        published: true
      }]);
    }
    return alternateLinks;
  }, [alternateLinks, currentUrlPath, currentLocale]);
  return linksWithCurrentPage;
};

var CountrySwitch = function CountrySwitch(_ref) {
  var alternateLinksForCountrySwitch = _ref.alternateLinksForCountrySwitch,
    countryOrRegionText = _ref.countryOrRegionText,
    notificationText = _ref.notificationText,
    languageSettingsHeadline = _ref.languageSettingsHeadline,
    requestLanguageChangeText = _ref.requestLanguageChangeText,
    linkTitle = _ref.linkTitle,
    unavailableLinksText = _ref.unavailableLinksText,
    internationalLinksText = _ref.internationalLinksText,
    unavailablePageText = _ref.unavailablePageText,
    cancelButtonText = _ref.cancelButtonText,
    okayButtonText = _ref.okayButtonText,
    inputPlaceholderText = _ref.inputPlaceholderText,
    internationalLinkTitleEn = _ref.internationalLinkTitleEn,
    internationalLinkTextEn = _ref.internationalLinkTextEn,
    internationalLinkTitleEs = _ref.internationalLinkTitleEs,
    internationalLinkTextEs = _ref.internationalLinkTextEs,
    switchToCountryHomepageText = _ref.switchToCountryHomepageText,
    homepageText = _ref.homepageText,
    internationalLinkEs = _ref.internationalLinkEs,
    internationalLinkEn = _ref.internationalLinkEn,
    locale = _ref.locale,
    urlPath = _ref.urlPath,
    isProd = _ref.isProd;
  var _useContext = useContext(CountrySwitchContext),
    isModalOpen = _useContext.isModalOpen,
    setSelectedCountry = _useContext.setSelectedCountry;
  var _useState = useState(''),
    searchInput = _useState[0],
    setSearchInput = _useState[1];
  var _useState2 = useState(alternateLinksForCountrySwitch),
    mergedAlternateLinks = _useState2[0],
    setMergedAlternateLinks = _useState2[1];
  useEffect(function () {
    var _a, _b, _c;
    if (!locale || isIgusEuDomain(locale)) return;
    var defaultLocale = (_a = locale.split('-')[1]) !== null && _a !== void 0 ? _a : '';
    setSelectedCountry(defaultLocale);
    setSearchInput((_c = (_b = CountryData[defaultLocale]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '');
  }, [locale, setSelectedCountry, isIgusEuDomain, CountryData, isModalOpen]);
  useEffect(function () {
    var mergeFallbackLinks = function mergeFallbackLinks() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var publishedStory, mainLocale, combinedLinks;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!(alternateLinksForCountrySwitch === null || alternateLinksForCountrySwitch === void 0 ? void 0 : alternateLinksForCountrySwitch.length) || !locale)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              publishedStory = alternateLinksForCountrySwitch.find(function (link) {
                return (link === null || link === void 0 ? void 0 : link.full_slug) && link.published === true;
              });
              if (publishedStory === null || publishedStory === void 0 ? void 0 : publishedStory.full_slug) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              mainLocale = findMainLocaleFromFallback(locale.toLowerCase(), fallbackLang);
              if (!(mainLocale || Object.values(fallbackLang).includes(locale.toLowerCase()))) {
                _context.next = 11;
                break;
              }
              _context.next = 9;
              return fetchAndCombineAlternateLinks(publishedStory.full_slug, alternateLinksForCountrySwitch);
            case 9:
              combinedLinks = _context.sent;
              setMergedAlternateLinks(combinedLinks);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    void mergeFallbackLinks();
  }, [alternateLinksForCountrySwitch, locale]);
  var alternateLinksWithCurrentPage = useAlternateLinksWithCurrentPage(mergedAlternateLinks, urlPath, locale);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    id: "country-switch"
  }), isModalOpen && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(CountrySwitchModal, {
    domainsforCountrySwitch: igusDomains,
    alternateLinksForCountrySwitch: alternateLinksWithCurrentPage,
    countryOrRegionText: countryOrRegionText,
    notificationText: notificationText,
    languageSettingsHeadline: languageSettingsHeadline,
    requestLanguageChangeText: requestLanguageChangeText,
    linkTitle: linkTitle,
    unavailableLinksText: unavailableLinksText,
    internationalLinksText: internationalLinksText,
    unavailablePageText: unavailablePageText,
    switchToCountryHomepageText: switchToCountryHomepageText,
    cancelButtonText: cancelButtonText,
    okayButtonText: okayButtonText,
    inputPlaceholderText: inputPlaceholderText,
    internationalLinkTitleEn: internationalLinkTitleEn,
    internationalLinkTextEn: internationalLinkTextEn,
    internationalLinkTitleEs: internationalLinkTitleEs,
    internationalLinkTextEs: internationalLinkTextEs,
    homepageText: homepageText,
    searchInput: searchInput,
    setSearchInput: setSearchInput,
    internationalLinkEs: internationalLinkEs,
    internationalLinkEn: internationalLinkEn,
    locale: locale,
    urlPath: urlPath,
    fallbackLocales: fallbackLang,
    isProd: isProd
  }), document.querySelector('#country-switch')));
};

var css$U = {"cta__button_mode":"Cta-module_cta__button_mode__gF7dz","ctaprimary":"Cta-module_ctaprimary__WN6U4","ctasecondary":"Cta-module_ctasecondary__OHiLl","cta__center_link":"Cta-module_cta__center_link__zOrQN"};

var mapCTALinkProps = function mapCTALinkProps(_ref) {
  var icon = _ref.icon,
    button_text = _ref.button_text,
    background_color = _ref.background_color,
    linkData = _ref.linkData;
  var _a, _b, _c, _d, _e, _f, _g;
  if (!linkData) {
    return null;
  }
  var component = linkData.component,
    link = linkData.link,
    asset = linkData.asset;
  var download = component === 'download';
  var external = (link === null || link === void 0 ? void 0 : link.linktype) === 'url' || false;
  var linkUrl = download ? (_a = asset === null || asset === void 0 ? void 0 : asset.item) === null || _a === void 0 ? void 0 : _a.embed_link : ((_b = link === null || link === void 0 ? void 0 : link.story) === null || _b === void 0 ? void 0 : _b.url) || (link === null || link === void 0 ? void 0 : link.cached_url);
  var target = external ? TargetValues.Blank : TargetValues.Self;
  var iconPlace = external ? IconPosition.After : IconPosition.Before;
  var className = background_color === '#F07D00' || !background_color ? css$U.ctaprimary : css$U.ctasecondary;
  var iconProp = !!icon || false;
  return Object.assign({
    icon: external ? false : iconProp,
    iconPosition: iconPlace,
    iconSource: '',
    title: button_text,
    target: target,
    external: ((_c = linkData.link) === null || _c === void 0 ? void 0 : _c.linktype) === ContactType.Email || external,
    download: download,
    className: className,
    variant: LinkVariant.Button,
    href: linkUrl || '',
    children: button_text,
    piwik_click_id: linkData.piwik_click_id,
    anchor: (_d = linkData === null || linkData === void 0 ? void 0 : linkData.link) === null || _d === void 0 ? void 0 : _d.anchor,
    contact_type: determineContactType((_e = linkData.link) === null || _e === void 0 ? void 0 : _e.url, (_f = linkData.link) === null || _f === void 0 ? void 0 : _f.linktype)
  }, ((_g = linkData === null || linkData === void 0 ? void 0 : linkData.link) === null || _g === void 0 ? void 0 : _g.rel) && {
    rel: linkData.link.rel
  });
};
var CTALink = function CTALink(_ref2) {
  var icon = _ref2.icon,
    background_color = _ref2.background_color,
    button_text = _ref2.button_text,
    linkData = _ref2.linkData;
  var _a, _b;
  var props = mapCTALinkProps({
    icon: icon,
    background_color: background_color,
    button_text: button_text,
    linkData: linkData
  });
  var className = background_color === '#F07D00' || !background_color ? css$U.ctaprimary : css$U.ctasecondary;
  if (!button_text) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  if (!props) {
    return /*#__PURE__*/React.createElement(Link, Object.assign({
      href: "/",
      target: TargetValues.Blank,
      title: button_text,
      variant: LinkVariant.Button,
      piwik_click_id: linkData === null || linkData === void 0 ? void 0 : linkData.piwik_click_id,
      anchor: (_a = linkData === null || linkData === void 0 ? void 0 : linkData.link) === null || _a === void 0 ? void 0 : _a.anchor,
      className: className
    }, ((_b = linkData === null || linkData === void 0 ? void 0 : linkData.link) === null || _b === void 0 ? void 0 : _b.rel) && {
      rel: linkData.link.rel
    }), button_text);
  }
  if (props.download) {
    return /*#__PURE__*/React.createElement(Link, Object.assign({
      href: props.href,
      download: true,
      icon: true,
      title: props.title,
      className: props.className,
      downloadIcon: linkData === null || linkData === void 0 ? void 0 : linkData.icon,
      target: TargetValues.Self,
      variant: props.variant,
      piwik_click_id: props === null || props === void 0 ? void 0 : props.piwik_click_id,
      anchor: props.anchor
    }, props.rel && {
      rel: props.rel
    }), button_text);
  }
  return /*#__PURE__*/React.createElement(Link, Object.assign({}, props));
};

var CTA = function CTA(_ref) {
  var _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? false : _ref$separator,
    button_text = _ref.button_text,
    background_color = _ref.background_color,
    link = _ref.link,
    icon = _ref.icon,
    className = _ref.className,
    _ref$useAsChild = _ref.useAsChild,
    useAsChild = _ref$useAsChild === void 0 ? false : _ref$useAsChild,
    text = _ref.text,
    _ref$noSpacingGrid = _ref.noSpacingGrid,
    noSpacingGrid = _ref$noSpacingGrid === void 0 ? false : _ref$noSpacingGrid,
    _ref$center_link = _ref.center_link,
    center_link = _ref$center_link === void 0 ? false : _ref$center_link;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: useAsChild ? css$U.cta__button_mode : '',
    noSpacing: !separator || noSpacingGrid,
    spacingWithSeparator: !separator && !noSpacingGrid
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12,
    className: className || ''
  }, text && hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })), /*#__PURE__*/React.createElement("div", {
    className: conditionalClassname(center_link, "".concat(css$U.cta__center_link))
  }, /*#__PURE__*/React.createElement(CTALink, {
    icon: icon,
    button_text: button_text || '',
    background_color: (background_color === null || background_color === void 0 ? void 0 : background_color.value) || '',
    linkData: link && link[0]
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$T = {"delivery_notification__wrapper":"DeliveryLocationNotification-module_delivery_notification__wrapper__7nTpv","show":"DeliveryLocationNotification-module_show__-2TK4","delivery_notification__headline":"DeliveryLocationNotification-module_delivery_notification__headline__lVf4o","delivery_notification_subtext":"DeliveryLocationNotification-module_delivery_notification_subtext__e1rbb","delivery_notification_links":"DeliveryLocationNotification-module_delivery_notification_links__MiEDX","close_button":"DeliveryLocationNotification-module_close_button__pMFup","alternate_domain_link":"DeliveryLocationNotification-module_alternate_domain_link__oINBX","button_outline_variant":"DeliveryLocationNotification-module_button_outline_variant__1WJBV","close__icon":"DeliveryLocationNotification-module_close__icon__N7hcW"};

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}

var CookieHandler = /*#__PURE__*/function () {
  function CookieHandler(cookieName) {
    var _this = this;
    _classCallCheck(this, CookieHandler);
    this.getShoppingCardValue = function () {
      var cartArticleCount = _this.getCookie();
      if (cartArticleCount) {
        return cartArticleCount;
      }
      return '0';
    };
    this.cookieName = cookieName;
  }
  return _createClass(CookieHandler, [{
    key: "setCookie",
    value: function setCookie(value) {
      if (typeof window !== 'undefined') {
        document.cookie = "".concat(this.cookieName, "=").concat(value, ";max-age=session;path=/;Secure;SameSite=Strict");
      }
    }
  }, {
    key: "getCookie",
    value: function getCookie() {
      var _this2 = this;
      if (typeof window !== 'undefined') {
        var cookies = document.cookie.split(';');
        var cookie = cookies.find(function (cookie) {
          return cookie.includes(_this2.cookieName);
        });
        return cookie === null || cookie === void 0 ? void 0 : cookie.split('=')[1];
      }
      return undefined;
    }
  }, {
    key: "getBrowserLanguage",
    value: function getBrowserLanguage() {
      if (typeof window !== 'undefined') {
        var language = window.navigator.language;
        return language;
      }
      return undefined;
    }
  }]);
}();

var deliveryLocationCookie = new CookieHandler('PriceDomainInfo');
var DEFAULT_DOMAIN = 'https://www.igus.eu/?C=DE&L=en/';
var COUNTRY_CODE_MAP = {
  uk: 'gb'
};
/**
 * Ensures a domain URL has the https:// protocol prefix.
 * Prevents relative URL bugs where "www.igus.eu" becomes "https://current-domain.com/www.igus.eu"
 *
 * @param domain - The domain URL (with or without protocol)
 * @returns The domain with https:// protocol prefix
 * @example
 * ensureProtocol('www.igus.eu') // returns 'https://www.igus.eu'
 * ensureProtocol('https://www.igus.de') // returns 'https://www.igus.de'
 */
var ensureProtocol = function ensureProtocol(domain) {
  if (!domain || typeof domain !== 'string') {
    return '';
  }
  var trimmedDomain = domain.trim();
  if (!trimmedDomain) {
    return '';
  }
  if (/^https?:\/\//i.test(trimmedDomain)) {
    return trimmedDomain;
  }
  return "https://".concat(trimmedDomain);
};
/**
 * Custom hook to determine if the current locale matches the country from session and get the local domain
 *
 * @param {object} params - Hook parameters
 * @param {string} params.language - The current language string in format 'language-COUNTRY'
 * @param {string} params.countryFromSession - The country code from the user session
 * @returns {[boolean, string]} A tuple containing:
 *   - boolean indicating if the locale domain matches the country from session
 *   - string representing the local domain for the country from session
 */
var useLocaleDomainInfo = function useLocaleDomainInfo(_ref) {
  var locale = _ref.locale,
    countryFromSession = _ref.countryFromSession,
    alternateLinksForCountry = _ref.alternateLinksForCountry,
    isProd = _ref.isProd;
  var _a, _b, _c, _d, _e;
  var countryCode = (_b = COUNTRY_CODE_MAP[(_a = countryFromSession === null || countryFromSession === void 0 ? void 0 : countryFromSession.toLowerCase()) !== null && _a !== void 0 ? _a : '']) !== null && _b !== void 0 ? _b : countryFromSession;
  var countryDomain = (_c = locale === null || locale === void 0 ? void 0 : locale.split('-')[1]) === null || _c === void 0 ? void 0 : _c.toLowerCase();
  var isLocaleDomain = countryDomain === countryCode;
  var deliveryLocationResult = checkDeliveryLocationForCountry({
    alternateLinksForCountry: alternateLinksForCountry,
    countryFromSession: countryCode,
    igusDomains: igusDomains,
    fallbackLocales: fallbackLang,
    isProd: isProd
  });
  var localeDomain = (_e = (_d = deliveryLocationResult.countryDomain) !== null && _d !== void 0 ? _d : deliveryLocationResult.countryHomePage) !== null && _e !== void 0 ? _e : getLocaleDomain(countryCode);
  return [isLocaleDomain, localeDomain];
};
var getLocaleDomain = function getLocaleDomain(country) {
  var _a, _b;
  var localeDomain = igusDomains.filter(function (domain) {
    var _a;
    return ((_a = domain === null || domain === void 0 ? void 0 : domain.defaultLocale.split('-')[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (country === null || country === void 0 ? void 0 : country.toLowerCase());
  });
  var domain = (_b = (_a = localeDomain[0]) === null || _a === void 0 ? void 0 : _a.domain) !== null && _b !== void 0 ? _b : DEFAULT_DOMAIN;
  return ensureProtocol(domain);
};
var isPriceDomainInfo = function isPriceDomainInfo() {
  return deliveryLocationCookie.getCookie() === '1';
};
var setPriceDomainInfo = function setPriceDomainInfo() {
  deliveryLocationCookie.setCookie('1');
};
var getHostName = function getHostName(url) {
  if (!url || typeof url !== 'string' || !url.trim()) {
    console.warn('[getHostName] Invalid URL provided:', "\"".concat(url, "\"."), 'Expected a valid URL string like "https://www.igus.de" or "www.igus.de"');
    return '';
  }
  try {
    var trimmedUrl = url.trim();
    var hasProtocol = /^https?:\/\//i.test(trimmedUrl);
    if (!hasProtocol) {
      console.warn("[getHostName] URL missing protocol: \"".concat(url, "\". Adding \"https://\" prefix. Consider providing full URLs with protocol."));
    }
    var hostname = new URL(hasProtocol ? trimmedUrl : "https://".concat(trimmedUrl)).hostname;
    if (hostname !== 'localhost' && !hostname.includes('.')) {
      throw new Error('Invalid hostname format');
    }
    return hostname;
  } catch (urlError) {
    console.warn("[getHostName] Failed to parse URL: \"".concat(url, "\"."), "Error: ".concat(urlError instanceof Error ? urlError.message : 'Unknown error', "."), 'Expected format: "https://www.igus.de"');
    return '';
  }
};
/**
 * Checks if there's a valid alternate link for the country a user visits from
 * Checks if a page exists for the selected country and returns the appropriate status
 *
 * @param {CheckDeliveryLocationParams} params - Parameters for checking page existence
 * @returns {CountryPageStatus} Status object indicating if page exists and potential redirect domain
 */
var checkDeliveryLocationForCountry = function checkDeliveryLocationForCountry(_ref2) {
  var alternateLinksForCountry = _ref2.alternateLinksForCountry,
    _ref2$countryFromSess = _ref2.countryFromSession,
    countryFromSession = _ref2$countryFromSess === void 0 ? '' : _ref2$countryFromSess,
    igusDomains = _ref2.igusDomains,
    _ref2$fallbackLocales = _ref2.fallbackLocales,
    fallbackLocales = _ref2$fallbackLocales === void 0 ? {} : _ref2$fallbackLocales,
    _ref2$isProd = _ref2.isProd,
    isProd = _ref2$isProd === void 0 ? 'www' : _ref2$isProd;
  var _a, _b, _c;
  try {
    if (!alternateLinksForCountry || !Array.isArray(alternateLinksForCountry)) {
      console.warn('alternateLinksForCountry is not a valid array:', alternateLinksForCountry);
      return {
        status: 'invalid alternate links'
      };
    }
    if (!igusDomains || !Array.isArray(igusDomains)) {
      console.warn('igusDomains is not a valid array:', igusDomains);
      return {
        status: 'invalid domains configuration'
      };
    }
    if (!checkCountryExists(countryFromSession, igusDomains)) {
      return {
        status: 'country does not exist'
      };
    }
    var linkExists = linkExistsForCountry(alternateLinksForCountry, countryFromSession, fallbackLocales);
    if (linkExists) {
      var _domainsForCountry = getDomainsForCountry(countryFromSession, igusDomains, linkExists, isProd);
      return {
        status: 'page exists',
        countryDomain: ensureProtocol((_a = _domainsForCountry[0]) === null || _a === void 0 ? void 0 : _a.domain)
      };
    }
    var domainsForCountry = getDomainsForCountry(countryFromSession, igusDomains, alternateLinksForCountry, isProd);
    var localeDomain = (_c = (_b = domainsForCountry[0]) === null || _b === void 0 ? void 0 : _b.domain) !== null && _c !== void 0 ? _c : getLocaleDomain(countryFromSession);
    return {
      status: 'no page for domain',
      countryHomePage: ensureProtocol(localeDomain)
    };
  } catch (error) {
    console.error('Error checking delivery location for country:', {
      error: error
    });
    return {
      status: 'an error occurred',
      countryDomain: ensureProtocol(getLocaleDomain(countryFromSession))
    };
  }
};

var DeliveryLocationNotification = function DeliveryLocationNotification(_ref) {
  var locale = _ref.locale,
    _ref$countryFromSessi = _ref.countryFromSession,
    countryFromSession = _ref$countryFromSessi === void 0 ? '' : _ref$countryFromSessi,
    headline = _ref.headline,
    subtext = _ref.subtext,
    buttonViewAllLocation = _ref.buttonViewAllLocation,
    buttonGoToLocaleDomain = _ref.buttonGoToLocaleDomain,
    alternateLinksForCountry = _ref.alternateLinksForCountry,
    isProd = _ref.isProd,
    openCountrySwitchModal = _ref.openCountrySwitchModal,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? ComponentVersion.v1 : _ref$version;
  var router = routerExports.useRouter();
  var _useLocaleDomainInfo = useLocaleDomainInfo({
      locale: locale !== null && locale !== void 0 ? locale : router === null || router === void 0 ? void 0 : router.locale,
      countryFromSession: countryFromSession,
      alternateLinksForCountry: alternateLinksForCountry,
      isProd: isProd
    }),
    _useLocaleDomainInfo2 = _slicedToArray(_useLocaleDomainInfo, 2),
    isLocaleDomain = _useLocaleDomainInfo2[0],
    localeDomain = _useLocaleDomainInfo2[1];
  var _useState = useState(false),
    toggleNotification = _useState[0],
    setToggleNotification = _useState[1];
  var _useState2 = useState(false),
    displayNotification = _useState2[0],
    setDisplayNotification = _useState2[1];
  var toggleCountrySwitch = function toggleCountrySwitch() {
    openCountrySwitchModal(function (prevState) {
      return !prevState;
    });
  };
  var hideNotification = function hideNotification() {
    setToggleNotification(false);
    setPriceDomainInfo();
  };
  useEffect(function () {
    if (!isPriceDomainInfo() && !isLocaleDomain) {
      setDisplayNotification(true);
      setTimeout(function () {
        setToggleNotification(true);
      }, 500);
    } else {
      setDisplayNotification(false);
      setToggleNotification(false);
    }
  }, [isLocaleDomain]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, displayNotification && (/*#__PURE__*/React.createElement("div", {
    className: "delivery-notification-wrapper ".concat(css$T.delivery_notification__wrapper, " ").concat(conditionalClassname(toggleNotification, css$T.show))
  }, /*#__PURE__*/React.createElement(Container, {
    noSpacing: true,
    version: version
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xl: 6,
    lg: 6
  }, /*#__PURE__*/React.createElement(Headline, {
    className: css$T.delivery_notification__headline,
    tag: HeadlineTags.H4
  }, headline), /*#__PURE__*/React.createElement("p", {
    className: css$T.delivery_notification_subtext
  }, subtext)), /*#__PURE__*/React.createElement(Col, {
    xl: 6,
    lg: 6,
    className: css$T.delivery_notification_links
  }, /*#__PURE__*/React.createElement("button", {
    className: css$T.button_outline_variant,
    onClick: toggleCountrySwitch
  }, buttonViewAllLocation), /*#__PURE__*/React.createElement(Link, {
    className: css$T.alternate_domain_link,
    variant: LinkVariant.Button,
    href: localeDomain,
    title: localeDomain,
    target: TargetValues.Self
  }, "".concat(buttonGoToLocaleDomain, " ").concat(getHostName(localeDomain))), /*#__PURE__*/React.createElement("button", {
    title: "Close notification",
    "aria-label": "Close notification",
    onClick: hideNotification,
    className: css$T.close_button
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: css$T.close__icon
  }))))))));
};

var RenderAssetOnComponent;
(function (RenderAssetOnComponent) {
  RenderAssetOnComponent[RenderAssetOnComponent["TEXT_IMAGE_THREE_COLUMN"] = 3] = "TEXT_IMAGE_THREE_COLUMN";
  RenderAssetOnComponent[RenderAssetOnComponent["TEXT_IMAGE_TWO_COLUMN"] = 2] = "TEXT_IMAGE_TWO_COLUMN";
  RenderAssetOnComponent[RenderAssetOnComponent["TEXT_IMAGE_FOUR_COLUMN"] = 4] = "TEXT_IMAGE_FOUR_COLUMN";
  RenderAssetOnComponent["SLIDER"] = "slider";
  RenderAssetOnComponent["TEASER_BIG"] = "teaser_big";
})(RenderAssetOnComponent || (RenderAssetOnComponent = {}));
var TextImageImageHeight;
(function (TextImageImageHeight) {
  TextImageImageHeight["LARGE"] = "large";
  TextImageImageHeight["MEDIUM"] = "medium";
  TextImageImageHeight["SMALL"] = "small";
  TextImageImageHeight["16_9"] = "169";
})(TextImageImageHeight || (TextImageImageHeight = {}));

var css$S = {"captionWrapper":"Caption-module_captionWrapper__eKDl3"};

var Caption = function Caption(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("figcaption", {
    className: css$S.captionWrapper
  }, text);
};

var css$R = {"enlarge__main__wrapper":"Enlarge-module_enlarge__main__wrapper__6b0h5","enlarge__dialog__content":"Enlarge-module_enlarge__dialog__content__ywGJ1","enlarge__image__wrapper":"Enlarge-module_enlarge__image__wrapper__H-Wzg","enlarge__image":"Enlarge-module_enlarge__image__VPojs","enlarge__close__button":"Enlarge-module_enlarge__close__button__9p3VJ","enlarge__open__button":"Enlarge-module_enlarge__open__button__1SaRJ","enlarge__open__icon":"Enlarge-module_enlarge__open__icon__g5kfP","enlarge__close__icon":"Enlarge-module_enlarge__close__icon__hFUwl"};

var ImageEnlarge = function ImageEnlarge(_ref) {
  var imageUrl = _ref.imageUrl,
    imageAltText = _ref.imageAltText,
    _ref$enlargeImage = _ref.enlargeImage,
    enlargeImage = _ref$enlargeImage === void 0 ? false : _ref$enlargeImage;
  var dialogRef = useRef(null);
  var openButtonRef = useRef(null);
  var handleOpenModal = function handleOpenModal() {
    var _a;
    (_a = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _a === void 0 ? void 0 : _a.showModal();
  };
  var handleCloseModal = function handleCloseModal() {
    var _a, _b;
    (_a = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _a === void 0 ? void 0 : _a.close();
    (_b = openButtonRef === null || openButtonRef === void 0 ? void 0 : openButtonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
  };
  var enlargeImageSrcSetSizes = [{
    width: 1136,
    height: 515
  }, {
    width: 1056,
    height: 473
  }, {
    width: 795,
    height: 511
  }, {
    width: 680,
    height: 236
  }, {
    width: 505,
    height: 236
  }, {
    width: 480,
    height: 236
  }, {
    width: 321,
    height: 236
  }];
  var formatUrl = function formatUrl() {
    var urlObj = new URL(imageUrl);
    var params = urlObj.searchParams;
    params["delete"]('u');
    params["delete"]('color');
    urlObj.search = params.toString();
    return urlObj.toString();
  };
  var updatedImageUrl = formatUrl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, enlargeImage && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EnlargeButton, {
    buttonRef: openButtonRef,
    enlargeButtonFunction: handleOpenModal
  }), /*#__PURE__*/React.createElement("dialog", {
    ref: dialogRef,
    className: css$R.enlarge__main__wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css$R.enlarge__dialog__content
  }, /*#__PURE__*/React.createElement("div", {
    className: css$R.enlarge__image__wrapper
  }, /*#__PURE__*/React.createElement(Image, {
    src: updatedImageUrl,
    imageSizes: enlargeImageSrcSetSizes,
    sizes: "100vw",
    alt: imageAltText,
    className: css$R.enlarge__image
  }), /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseModal,
    className: css$R.enlarge__close__button,
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: css$R.enlarge__close__icon
  }))))))));
};
var EnlargeButton = function EnlargeButton(_ref2) {
  var enlargeButtonFunction = _ref2.enlargeButtonFunction,
    buttonRef = _ref2.buttonRef;
  return /*#__PURE__*/React.createElement("button", {
    ref: buttonRef,
    className: css$R.enlarge__open__button,
    onClick: enlargeButtonFunction,
    "aria-label": "Enlarge Image"
  }, /*#__PURE__*/React.createElement("svg", {
    className: css$R.enlarge__open__icon,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33333V0H6.66667L8.86 2.19333L2.19333 8.86L0 6.66667V12H5.33333L3.14 9.80667L9.80667 3.14L12 5.33333Z",
    fill: "currentColor"
  })));
};

var imageSizes$1 = {
  vertical: {
    sizes: '(max-width: 719px) 45vw, (max-width: 939px) 50vw, (max-width: 1200px) 50vw, 530px'
  },
  horizontal: {
    sizes: '(max-width: 939px) 45vw, (max-width: 1200px) 15vw, 260px'
  }
};
var horizontalImageSrcSetSizes = {
  large: [{
    width: 877,
    height: 584
  }, {
    width: 650,
    height: 433
  }, {
    width: 500,
    height: 333
  }, {
    width: 260,
    height: 173
  }],
  small: [{
    width: 877,
    height: 350
  }, {
    width: 650,
    height: 260
  }, {
    width: 500,
    height: 200
  }, {
    width: 260,
    height: 104
  }]
};
var verticalImageSrcSetSizes = {
  large: [{
    width: 659,
    height: 329
  }, {
    width: 530,
    height: 300
  }, {
    width: 420,
    height: 200
  }, {
    width: 300,
    height: 200
  }],
  small: [{
    width: 659,
    height: 263
  }, {
    width: 530,
    height: 212
  }, {
    width: 400,
    height: 160
  }, {
    width: 300,
    height: 120
  }]
};
var getLocalAssetSrc = function getLocalAssetSrc(asset) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  if (!hasAssetData(asset, MediaType.IMAGE) && !hasAssetData(asset, MediaType.VIDEO) && !hasAssetData(asset, MediaType.YOUTUBE)) return '';
  if (hasAssetData(asset, MediaType.IMAGE)) {
    var image = (_c = (_b = (_a = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _a === void 0 ? void 0 : _a.local_image) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.local_image;
    if (!image || image && !Object.keys(image).length) {
      image = (_d = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _d === void 0 ? void 0 : _d.image;
    }
    var imageSrc = generateImageSrc(image);
    return imageSrc || '';
  }
  if (hasAssetData(asset, MediaType.VIDEO)) {
    var localVideo = (_j = (_h = (_g = (_f = (_e = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _e === void 0 ? void 0 : _e.local_video) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.video) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.embed_link;
    var defaultVideo = (_m = (_l = (_k = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _k === void 0 ? void 0 : _k.video) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.embed_link;
    return localVideo || defaultVideo || '';
  }
  if (hasAssetData(asset, MediaType.YOUTUBE)) {
    var localYoutubeId = (_q = (_p = (_o = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _o === void 0 ? void 0 : _o.local_youtube) === null || _p === void 0 ? void 0 : _p[0]) === null || _q === void 0 ? void 0 : _q.youtube_id;
    var defaultYoutubeId = (_r = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _r === void 0 ? void 0 : _r.youtube_id;
    return localYoutubeId || defaultYoutubeId || '';
  }
  return '';
};

var css$Q = {"breakpoints":"'../../../styling/breakpoints.css'","lg":"i__const_lg_0","md":"i__const_md_1","wrapper":"TextImage-module_wrapper__bYiBA","image_container__wrapper":"TextImage-module_image_container__wrapper__HnWlx","image__container":"TextImage-module_image__container__OGu5A","image__container_large":"TextImage-module_image__container_large__XPhQE","image__container_medium":"TextImage-module_image__container_medium__7lkLg","image__container_small":"TextImage-module_image__container_small__RcijZ","image__container_16_9":"TextImage-module_image__container_16_9__OzDKX","image":"TextImage-module_image__9xFXW","asset__right":"TextImage-module_asset__right__TvuIa","button__wrapper":"TextImage-module_button__wrapper__-cHQ6","form__landing_page__wrapper":"TextImage-module_form__landing_page__wrapper__YeM0o","homepageBanner":"TextImage-module_homepageBanner__C3q70","text__image__form__landing__background":"TextImage-module_text__image__form__landing__background__56pyV","homepageBanner__themed_primary":"TextImage-module_homepageBanner__themed_primary__BcTmG","homepageBanner__themed_secondary":"TextImage-module_homepageBanner__themed_secondary__uweSU","homepageBanner__themed_color1":"TextImage-module_homepageBanner__themed_color1__HxfUR","homepageBanner__themed_color2":"TextImage-module_homepageBanner__themed_color2__M2-Wj","outline__themed_primary":"TextImage-module_outline__themed_primary__etmJT","outline__themed_secondary":"TextImage-module_outline__themed_secondary__uT4Su","outline__themed_color1":"TextImage-module_outline__themed_color1__O9WVJ","outline__themed_color2":"TextImage-module_outline__themed_color2__-SLEp","iframe__asset":"TextImage-module_iframe__asset__uDau4","button__wrapper_row":"TextImage-module_button__wrapper_row__XP6pe"};

var ImageShadow;
(function (ImageShadow) {
  ImageShadow["Micro"] = "shadow_1";
  ImageShadow["Small"] = "shadow_2";
  ImageShadow["Regular"] = "shadow_3";
  ImageShadow["Medium"] = "shadow_4";
  ImageShadow["Large"] = "shadow_5";
  ImageShadow["Ultra"] = "shadow_6";
})(ImageShadow || (ImageShadow = {}));
var Breakpoints;
(function (Breakpoints) {
  Breakpoints[Breakpoints["xs"] = 345] = "xs";
  Breakpoints[Breakpoints["sm"] = 536] = "sm";
  Breakpoints[Breakpoints["md"] = 720] = "md";
  Breakpoints[Breakpoints["lg"] = 940] = "lg";
  Breakpoints[Breakpoints["xl"] = 1200] = "xl";
})(Breakpoints || (Breakpoints = {}));

var sliderSrcSetSizes = {
  169: [{
    width: 659,
    height: 370
  }, {
    width: 310,
    height: 174
  }, {
    width: 270,
    height: 152
  }, {
    width: 240,
    height: 135
  }],
  large: [{
    width: 659,
    height: 439
  }, {
    width: 310,
    height: 207
  }, {
    width: 270,
    height: 180
  }, {
    width: 240,
    height: 160
  }],
  small: [{
    width: 659,
    height: 264
  }, {
    width: 310,
    height: 124
  }, {
    width: 250,
    height: 100
  }, {
    width: 200,
    height: 80
  }]
};
var textImageTwoSrcSetSizes = {
  169: [{
    width: 689,
    height: 387
  }, {
    width: 570,
    height: 320
  }, {
    width: 450,
    height: 253
  }, {
    width: 320,
    height: 180
  }],
  large: [{
    width: 680,
    height: 453
  }, {
    width: 570,
    height: 380
  }, {
    width: 450,
    height: 300
  }, {
    width: 320,
    height: 213
  }],
  medium: [{
    width: 680,
    height: 408
  }, {
    width: 570,
    height: 342
  }, {
    width: 450,
    height: 270
  }, {
    width: 320,
    height: 192
  }],
  small: [{
    width: 680,
    height: 272
  }, {
    width: 570,
    height: 228
  }, {
    width: 450,
    height: 180
  }, {
    width: 320,
    height: 128
  }]
};
var textImageThreeSrcSetSizes = {
  169: [{
    width: 689,
    height: 387
  }, {
    width: 600,
    height: 337
  }, {
    width: 450,
    height: 253
  }, {
    width: 370,
    height: 208
  }],
  large: [{
    width: 689,
    height: 459
  }, {
    width: 600,
    height: 400
  }, {
    width: 450,
    height: 300
  }, {
    width: 370,
    height: 247
  }],
  medium: [{
    width: 689,
    height: 413
  }, {
    width: 600,
    height: 360
  }, {
    width: 500,
    height: 300
  }, {
    width: 370,
    height: 222
  }],
  small: [{
    width: 689,
    height: 276
  }, {
    width: 600,
    height: 240
  }, {
    width: 500,
    height: 200
  }, {
    width: 370,
    height: 148
  }]
};
var textImageFourSrcSetSizes = {
  169: [{
    width: 689,
    height: 387
  }, {
    width: 570,
    height: 320
  }, {
    width: 440,
    height: 247
  }, {
    width: 270,
    height: 152
  }],
  large: [{
    width: 689,
    height: 459
  }, {
    width: 600,
    height: 400
  }, {
    width: 440,
    height: 293
  }, {
    width: 270,
    height: 180
  }],
  medium: [{
    width: 689,
    height: 413
  }, {
    width: 600,
    height: 360
  }, {
    width: 440,
    height: 264
  }, {
    width: 270,
    height: 162
  }],
  small: [{
    width: 689,
    height: 276
  }, {
    width: 600,
    height: 240
  }, {
    width: 440,
    height: 176
  }, {
    width: 270,
    height: 108
  }]
};
var teaserBigSrcSetSizes = {
  169: [{
    width: 657,
    height: 387
  }, {
    width: 570,
    height: 320
  }, {
    width: 440,
    height: 240
  }, {
    width: 270,
    height: 162
  }],
  large: [{
    width: 657,
    height: 438
  }, {
    width: 600,
    height: 400
  }, {
    width: 525,
    height: 350
  }, {
    width: 375,
    height: 250
  }, {
    width: 300,
    height: 200
  }],
  small: [{
    width: 680,
    height: 272
  }, {
    width: 600,
    height: 240
  }, {
    width: 525,
    height: 210
  }, {
    width: 400,
    height: 160
  }, {
    width: 300,
    height: 120
  }]
};
var sliderSizes = '(max-width: 719px) 90vw, (max-width: 1200px) 20vw, 310px';
var textImageTwoSizes = '(max-width: 719px) 90vw, (max-width: 1200px) 45vw, 570px';
var textImageThreeSizes = '(max-width: 719px) 90vw, (max-width: 939px) 45vw, (max-width: 1200px) 30vw, 370px';
var textImageFourSizes = '(max-width: 719px) 90vw, (max-width: 939px) 45vw, (max-width: 1200px) 30vw, 270px';
var teaserBigSizes = '(max-width: 719px) 90vw, (max-width: 1200px) 45vw, 525px';
var getSrcSetsForComponent = function getSrcSetsForComponent(componentType, assetRatio) {
  var _a, _b, _c, _d, _e;
  switch (componentType) {
    case RenderAssetOnComponent.SLIDER:
      return (_a = sliderSrcSetSizes[assetRatio || 'large']) !== null && _a !== void 0 ? _a : [];
    case RenderAssetOnComponent.TEXT_IMAGE_THREE_COLUMN:
      return (_b = textImageThreeSrcSetSizes[assetRatio || 'large']) !== null && _b !== void 0 ? _b : [];
    case RenderAssetOnComponent.TEXT_IMAGE_FOUR_COLUMN:
      return (_c = textImageFourSrcSetSizes[assetRatio || 'large']) !== null && _c !== void 0 ? _c : [];
    case RenderAssetOnComponent.TEASER_BIG:
      return (_d = teaserBigSrcSetSizes[assetRatio || 'large']) !== null && _d !== void 0 ? _d : [];
    default:
      return (_e = textImageTwoSrcSetSizes[assetRatio || 'large']) !== null && _e !== void 0 ? _e : [];
  }
};
var sizesForComponent = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RenderAssetOnComponent.SLIDER, sliderSizes), RenderAssetOnComponent.TEXT_IMAGE_THREE_COLUMN, textImageThreeSizes), RenderAssetOnComponent.TEXT_IMAGE_FOUR_COLUMN, textImageFourSizes), RenderAssetOnComponent.TEASER_BIG, teaserBigSizes);
var getSizesForComponent = function getSizesForComponent(componentType) {
  return sizesForComponent[componentType !== null && componentType !== void 0 ? componentType : RenderAssetOnComponent.TEXT_IMAGE_TWO_COLUMN] || textImageTwoSizes;
};
var checkLegendComponent = function checkLegendComponent(component) {
  var allowedComponent = [RenderAssetOnComponent.TEXT_IMAGE_TWO_COLUMN, RenderAssetOnComponent.TEXT_IMAGE_THREE_COLUMN, RenderAssetOnComponent.TEXT_IMAGE_FOUR_COLUMN, RenderAssetOnComponent.TEASER_BIG];
  if (component) {
    return allowedComponent.includes(component);
  }
  return false;
};
var calculateImageHoverShadow = function calculateImageHoverShadow(imageNotClickable, shadow) {
  if (imageNotClickable) {
    return shadow ? shadow : '';
  }
  if (!shadow) {
    return ImageShadow.Micro;
  }
  switch (shadow) {
    case ImageShadow.Micro:
      return ImageShadow.Small;
    case ImageShadow.Small:
      return ImageShadow.Regular;
    case ImageShadow.Regular:
      return ImageShadow.Medium;
    case ImageShadow.Medium:
      return ImageShadow.Large;
    case ImageShadow.Large:
      return ImageShadow.Ultra;
    default:
      return ImageShadow.Ultra;
  }
};
var isImageClickable = function isImageClickable(teaserElement) {
  var links = teaserElement.links;
  var isImageNotClickable = teaserElement.image_not_clickable;
  if (isImageNotClickable) {
    return false;
  }
  if (!links) return false;
  return !!links.length && !isImageNotClickable;
};

var renderAsset = function renderAsset(_ref) {
  var asset = _ref.asset,
    headline = _ref.headline,
    caption = _ref.caption,
    assetRatio = _ref.assetRatio,
    componentType = _ref.componentType,
    _ref$showOutline = _ref.showOutline,
    showOutline = _ref$showOutline === void 0 ? false : _ref$showOutline,
    variant = _ref.variant,
    center = _ref.center,
    imageNotClickable = _ref.imageNotClickable;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
  var showLegend = checkLegendComponent(componentType);
  var legendText = (_a = asset[0]) === null || _a === void 0 ? void 0 : _a.legend;
  var iframeHeight = "".concat(((_b = asset[0]) === null || _b === void 0 ? void 0 : _b.height) || 380, "px");
  var videoRatio = assetRatio === TextImageImageHeight.SMALL && '5/2' || assetRatio === TextImageImageHeight.MEDIUM && '5/3' || assetRatio === TextImageImageHeight.LARGE && '3/2' || assetRatio === TextImageImageHeight['16_9'] && '16/9' || '3/2';
  var renderAssetSrc = getLocalAssetSrc(asset);
  var imageShadow = calculateImageHoverShadow(imageNotClickable || false, (_c = asset[0]) === null || _c === void 0 ? void 0 : _c.Shadow);
  if (hasAssetData(asset, MediaType.VIDEO)) {
    return /*#__PURE__*/React.createElement(Videos, {
      preload: "metadata",
      height: "auto",
      width: "100%",
      aspectRatio: videoRatio,
      caption: caption,
      controls: true,
      src: "".concat(renderAssetSrc),
      thumbnailUrl: ((_e = (_d = asset[0]) === null || _d === void 0 ? void 0 : _d.preview_image) === null || _e === void 0 ? void 0 : _e.length) && ((_h = (_g = (_f = asset[0]) === null || _f === void 0 ? void 0 : _f.preview_image[0]) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.item) ? (_o = (_m = (_l = (_k = (_j = asset[0]) === null || _j === void 0 ? void 0 : _j.preview_image[0]) === null || _k === void 0 ? void 0 : _k.image) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.focal_embed_link) !== null && _o !== void 0 ? _o : (_s = (_r = (_q = (_p = asset[0]) === null || _p === void 0 ? void 0 : _p.preview_image[0]) === null || _q === void 0 ? void 0 : _q.image) === null || _r === void 0 ? void 0 : _r.item) === null || _s === void 0 ? void 0 : _s.embed_link : ((_x = (_w = (_v = (_u = (_t = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _t === void 0 ? void 0 : _t.local_video) === null || _u === void 0 ? void 0 : _u[0]) === null || _v === void 0 ? void 0 : _v.video) === null || _w === void 0 ? void 0 : _w.item) === null || _x === void 0 ? void 0 : _x.thumbnail_link) || ((_0 = (_z = (_y = asset[0]) === null || _y === void 0 ? void 0 : _y.video) === null || _z === void 0 ? void 0 : _z.item) === null || _0 === void 0 ? void 0 : _0.thumbnail_link),
      background: (_2 = (_1 = asset[0]) === null || _1 === void 0 ? void 0 : _1.video) === null || _2 === void 0 ? void 0 : _2.color,
      controlsList: "nodownload",
      legend: (_3 = asset[0]) === null || _3 === void 0 ? void 0 : _3.legend
    });
  }
  if (hasAssetData(asset, MediaType.YOUTUBE) && ((_4 = asset[0]) === null || _4 === void 0 ? void 0 : _4.youtube_id)) {
    return /*#__PURE__*/React.createElement(Videos, {
      youtubeId: renderAssetSrc,
      title: caption || headline || 'YouTube Video',
      height: "auto",
      width: "100%",
      aspectRatio: videoRatio,
      caption: caption,
      legend: (_5 = asset[0]) === null || _5 === void 0 ? void 0 : _5.legend
    });
  }
  if (hasAssetData(asset, MediaType.IMAGE) && asset[0]) {
    return /*#__PURE__*/React.createElement("figure", {
      className: css$Q.wrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$Q.image__container, " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === TextImageImageHeight.LARGE, css$Q.image__container_large), conditionalClassname(assetRatio === TextImageImageHeight.MEDIUM, css$Q.image__container_medium), conditionalClassname(assetRatio === TextImageImageHeight.SMALL, css$Q.image__container_small), conditionalClassname(assetRatio === TextImageImageHeight['16_9'], css$Q.image__container_16_9)), "\n      ")
    }, /*#__PURE__*/React.createElement(Image, {
      src: renderAssetSrc,
      alt: asset[0].alt_text,
      className: "".concat(css$Q.image, " ").concat(imageCss[imageShadow], " ").concat(showOutline && variant ? getVariantClassName(variant, css$Q, ComponentNames.Outline) : ''),
      RoundedCorners: (_6 = asset[0]) === null || _6 === void 0 ? void 0 : _6.RoundedCorners,
      Shadow: (_7 = asset[0]) === null || _7 === void 0 ? void 0 : _7.Shadow,
      imageSizes: getSrcSetsForComponent(componentType, assetRatio),
      priority: true,
      copyrightText: (_8 = asset[0]) === null || _8 === void 0 ? void 0 : _8.copyright,
      sizes: getSizesForComponent(componentType),
      center: center
    }), caption && /*#__PURE__*/React.createElement(Caption, {
      text: caption
    }), asset[0].enlarge_image && (/*#__PURE__*/React.createElement(ImageEnlarge, {
      imageAltText: (_9 = asset[0]) === null || _9 === void 0 ? void 0 : _9.alt_text,
      imageUrl: renderAssetSrc,
      enlargeImage: asset[0].enlarge_image
    }))), legendText && showLegend && hasTextContent(legendText) && (/*#__PURE__*/React.createElement(LegendComponent, {
      legend: legendText
    })));
  }
  if (asset && ((_10 = asset[0]) === null || _10 === void 0 ? void 0 : _10.component) === 'iframe_with_height') {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$Q.image__container, " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === TextImageImageHeight.LARGE, css$Q.image__container_large), conditionalClassname(assetRatio === TextImageImageHeight.MEDIUM, css$Q.image__container_medium), conditionalClassname(assetRatio === TextImageImageHeight.SMALL, css$Q.image__container_small), conditionalClassname(assetRatio === TextImageImageHeight['16_9'], css$Q.image__container_16_9)), "\n "),
      style: {
        height: iframeHeight
      }
    }, /*#__PURE__*/React.createElement("iframe", {
      src: (_11 = asset[0]) === null || _11 === void 0 ? void 0 : _11.iframe_link,
      title: (_12 = asset[0]) === null || _12 === void 0 ? void 0 : _12.iframe_link,
      className: "".concat(css$Q.iframe__asset, " ").concat(showOutline && variant ? getVariantClassName(variant, css$Q, ComponentNames.Outline) : '', " ")
    }), caption && /*#__PURE__*/React.createElement(Caption, {
      text: caption
    }));
  }
  if (asset && ((_13 = asset[0]) === null || _13 === void 0 ? void 0 : _13.component) === 'iframe') {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$Q.image__container, " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === TextImageImageHeight.LARGE, css$Q.image__container_large), conditionalClassname(assetRatio === TextImageImageHeight.MEDIUM, css$Q.image__container_medium), conditionalClassname(assetRatio === TextImageImageHeight.SMALL, css$Q.image__container_small), conditionalClassname(assetRatio === TextImageImageHeight['16_9'], css$Q.image__container_16_9)), "\n ")
    }, /*#__PURE__*/React.createElement("iframe", {
      src: (_14 = asset[0]) === null || _14 === void 0 ? void 0 : _14.iframe_link,
      title: (_15 = asset[0]) === null || _15 === void 0 ? void 0 : _15.iframe_link,
      className: "".concat(css$Q.iframe__asset, " ").concat(showOutline && variant ? getVariantClassName(variant, css$Q, ComponentNames.Outline) : '', " ")
    }), caption && /*#__PURE__*/React.createElement(Caption, {
      text: caption
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
var TextImageTwoColumn = function TextImageTwoColumn(_ref2) {
  var text = _ref2.text,
    asset = _ref2.asset,
    headline = _ref2.headline,
    headline_level = _ref2.headline_level,
    separator = _ref2.separator,
    asset_position = _ref2.asset_position,
    button = _ref2.button,
    caption = _ref2.caption,
    _ref2$noSpacingGrid = _ref2.noSpacingGrid,
    noSpacingGrid = _ref2$noSpacingGrid === void 0 ? false : _ref2$noSpacingGrid,
    _ref2$onOrangeBackgro = _ref2.onOrangeBackground,
    onOrangeBackground = _ref2$onOrangeBackgro === void 0 ? false : _ref2$onOrangeBackgro,
    asset_ratio = _ref2.asset_ratio,
    _ref2$isHomepageBanne = _ref2.isHomepageBanner,
    isHomepageBanner = _ref2$isHomepageBanne === void 0 ? false : _ref2$isHomepageBanne,
    variant = _ref2.variant,
    outline_variant = _ref2.outline_variant,
    exclude_from_toc = _ref2.exclude_from_toc;
  var _a, _b, _c, _d;
  var requiresVerticalButtonLayout = button.some(function (item) {
    return item.variant === LinkVariant.Primary || item.variant === LinkVariant.Secondary;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    className: "".concat(onOrangeBackground ? css$Q.form__landing_page__wrapper : '', " ").concat(isHomepageBanner ? css$Q.homepageBanner : '', " ").concat(variant && isHomepageBanner ? getVariantClassName(variant, css$Q, ComponentNames.HomepageBanner) : '')
  }, headline && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Headline, {
    tag: headline_level || '',
    variant: variant,
    exclude_from_toc: exclude_from_toc
  }, headline || '')))), /*#__PURE__*/React.createElement(Row, {
    className: "".concat(conditionalClassname(!!asset_position, css$Q.asset__right))
  }, /*#__PURE__*/React.createElement(Col, {
    md: asset && asset.length > 0 && ((_a = asset[0]) === null || _a === void 0 ? void 0 : _a.image_small) ? 4 : 6,
    lg: asset && asset.length > 0 && ((_b = asset[0]) === null || _b === void 0 ? void 0 : _b.image_small) ? 4 : 6,
    className: css$Q.image_container__wrapper
  }, renderAsset({
    asset: asset,
    caption: caption,
    headline: headline,
    assetRatio: asset_ratio,
    componentType: RenderAssetOnComponent.TEXT_IMAGE_TWO_COLUMN,
    showOutline: outline_variant ? true : false,
    variant: outline_variant
  })), /*#__PURE__*/React.createElement(Col, {
    md: asset && asset.length > 0 && ((_c = asset[0]) === null || _c === void 0 ? void 0 : _c.image_small) ? 8 : 6,
    lg: asset && asset.length > 0 && ((_d = asset[0]) === null || _d === void 0 ? void 0 : _d.image_small) ? 8 : 6
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$Q.button__wrapper, " ").concat(!requiresVerticalButtonLayout ? css$Q.button__wrapper_row : '')
  }, (button === null || button === void 0 ? void 0 : button.length) > 0 && (button === null || button === void 0 ? void 0 : button.map(function (linkElement) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      key: linkElement._uid,
      linkType: linkElement,
      onOrangeBackground: onOrangeBackground
    });
  })))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$P = {"facts__headline":"Factbox-module_facts__headline__O6O84","facts__separator":"Factbox-module_facts__separator__NvrSC","facts__wrapper":"Factbox-module_facts__wrapper__2-kzL","factbox__intro__text":"Factbox-module_factbox__intro__text__gVzaO","factbox__on__orange__background":"Factbox-module_factbox__on__orange__background__FQVI7","factbox__on__orange__background__separator":"Factbox-module_factbox__on__orange__background__separator__wVzs-","button__wrapper":"Factbox-module_button__wrapper__lLm76","factbox__content__wrapper":"Factbox-module_factbox__content__wrapper__YXWze","asset__text__wrapper":"Factbox-module_asset__text__wrapper__NGTHU","top__facts__separator":"Factbox-module_top__facts__separator__B-Ii-","facts__headline__asset":"Factbox-module_facts__headline__asset__vWajX","factdata__asset__text":"Factbox-module_factdata__asset__text__03ucf","factdata__text":"Factbox-module_factdata__text__0qLJn","factbox__content__asset__left":"Factbox-module_factbox__content__asset__left__-fjmR","factbox__text__wrapper":"Factbox-module_factbox__text__wrapper__7F8GL","factbox__text__wrapper__asset":"Factbox-module_factbox__text__wrapper__asset__qKzSr","asset__wrapper":"Factbox-module_asset__wrapper__khs0z"};

var Factbox = function Factbox(_ref) {
  var facts = _ref.facts,
    text = _ref.text,
    additional_text = _ref.additional_text,
    asset = _ref.asset,
    asset_ratio = _ref.asset_ratio,
    caption = _ref.caption,
    separator = _ref.separator,
    outline_variant = _ref.outline_variant,
    button = _ref.button,
    factbox_position = _ref.factbox_position,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: !separator,
    className: "".concat(onOrangeBackground ? css$P.factbox__on__orange__background : '')
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: css$P.factbox__intro__text
  }, text && hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }))), /*#__PURE__*/React.createElement(Col, {
    className: "".concat(css$P.factbox__content__wrapper, " ").concat(factbox_position ? css$P.factbox__content__asset__left : '')
  }, asset && asset.length > 0 && (/*#__PURE__*/React.createElement("div", {
    className: css$P.asset__wrapper
  }, renderAsset({
    asset: asset,
    caption: caption,
    assetRatio: asset_ratio,
    componentType: RenderAssetOnComponent.TEXT_IMAGE_TWO_COLUMN,
    showOutline: outline_variant ? true : false,
    variant: outline_variant
  }), additional_text && hasTextContent(additional_text) && (/*#__PURE__*/React.createElement("div", {
    className: css$P.asset__text__wrapper
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(additional_text.content)
  }))), /*#__PURE__*/React.createElement("div", {
    className: css$P.button__wrapper
  }, button && (button === null || button === void 0 ? void 0 : button.length) > 0 && (button === null || button === void 0 ? void 0 : button.map(function (linkElement) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      key: linkElement._uid,
      linkType: linkElement,
      onOrangeBackground: onOrangeBackground
    });
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$P.factbox__text__wrapper, " ").concat(asset && asset.length > 0 ? css$P.factbox__text__wrapper__asset : '')
  }, /*#__PURE__*/React.createElement(Separator, {
    className: onOrangeBackground ? css$P.factbox__on__orange__background__separator : css$P.top__facts__separator
  }), facts === null || facts === void 0 ? void 0 : facts.map(function (factData) {
    var _a;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      key: factData._uid,
      className: css$P.facts__wrapper
    }, /*#__PURE__*/React.createElement(Headline, {
      className: "".concat((asset === null || asset === void 0 ? void 0 : asset.length) > 0 ? css$P.facts__headline__asset : css$P.facts__headline),
      tag: HeadlineTags.H5,
      variant: factData.variant
    }, factData === null || factData === void 0 ? void 0 : factData.title), hasTextContent(factData === null || factData === void 0 ? void 0 : factData.text) && (/*#__PURE__*/React.createElement("div", {
      className: "".concat(asset && asset.length > 0 ? css$P.factdata__asset__text : css$P.factdata__text)
    }, /*#__PURE__*/React.createElement(RichTextRenderer, {
      content: mappedProps((_a = factData === null || factData === void 0 ? void 0 : factData.text) === null || _a === void 0 ? void 0 : _a.content)
    })))), /*#__PURE__*/React.createElement(Separator, {
      className: onOrangeBackground ? css$P.factbox__on__orange__background__separator : css$P.facts__separator
    }));
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$O = {"overview__wrapper":"FairsOverview-module_overview__wrapper__YclM0","highlight_wrapper":"FairsOverview-module_highlight_wrapper__wBlXu","highlighted_fair":"FairsOverview-module_highlighted_fair__fOEWN","highlight_headline":"FairsOverview-module_highlight_headline__PyOBz","fairs_wrapper":"FairsOverview-module_fairs_wrapper__roXI6","fairs":"FairsOverview-module_fairs__J2qMZ","text_wrapper":"FairsOverview-module_text_wrapper__08vFy","title_wrapper":"FairsOverview-module_title_wrapper__lytVi","date":"FairsOverview-module_date__TOlSK","textAndLink":"FairsOverview-module_textAndLink__vmOIF","country_wrapper":"FairsOverview-module_country_wrapper__iFQAh","text":"FairsOverview-module_text__kNQpV","location":"FairsOverview-module_location__WfMVm","filter_by__title":"FairsOverview-module_filter_by__title__kFBIk","select_wrapper":"FairsOverview-module_select_wrapper__Cr5GW","fairs_select":"FairsOverview-module_fairs_select__WezgL","date_select":"FairsOverview-module_date_select__Uk1Jf","date__icon":"FairsOverview-module_date__icon__1pLm0","date__select_wrapper":"FairsOverview-module_date__select_wrapper__Ka6FB","country_city__select_wrapper":"FairsOverview-module_country_city__select_wrapper__09ux5","links__wrapper":"FairsOverview-module_links__wrapper__aKevB","container":"FairsOverview-module_container__DaC6u"};

var isHomepage = function isHomepage(asPath) {
  return asPath === '/website' || asPath === '' || asPath === '/';
};

var getCountryKey = function getCountryKey(country) {
  var countryKey = Object.keys(CountryData).find(function (key) {
    var _a;
    return ((_a = CountryData[key]) === null || _a === void 0 ? void 0 : _a.name.toLowerCase()) === (country === null || country === void 0 ? void 0 : country.toLowerCase());
  });
  return countryKey || '';
};
var iconSizes$1 = [{
  width: 96,
  height: 96
}];
var filterFairs = function filterFairs(fairs, filters) {
  return fairs === null || fairs === void 0 ? void 0 : fairs.filter(function (fair) {
    var fairDateFrom = new Date(fair.date_from);
    var fairDateTo = new Date(fair.date_to);
    var filterDateFrom = filters.dateFrom ? new Date(filters.dateFrom) : null;
    var filterDateTo = filters.dateTo ? new Date(filters.dateTo) : null;
    var isWithinDateRange = (!filterDateFrom || fairDateFrom >= filterDateFrom) && (!filterDateTo || fairDateTo <= filterDateTo);
    return (filters.country ? fair.country === filters.country : true) && (filters.city ? fair.city === filters.city : true) && isWithinDateRange;
  });
};
var sortFairs = function sortFairs(fairs, countryCode, getCountryKey) {
  var sorted = _toConsumableArray(fairs).sort(function (fairA, fairB) {
    var _a;
    var fairACountryKey = getCountryKey(fairA.country);
    var fairBCountryKey = getCountryKey(fairB.country);
    if (fairACountryKey === countryCode && fairBCountryKey !== countryCode) {
      return -1;
    }
    if (fairACountryKey !== countryCode && fairBCountryKey === countryCode) {
      return 1;
    }
    var countryComparison = (_a = fairA === null || fairA === void 0 ? void 0 : fairA.country) === null || _a === void 0 ? void 0 : _a.localeCompare(fairB === null || fairB === void 0 ? void 0 : fairB.country);
    if (countryComparison !== 0) {
      return countryComparison;
    }
    var startDateA = new Date(fairA.date_from);
    var startDateB = new Date(fairB.date_from);
    return startDateA.getTime() - startDateB.getTime();
  });
  return sorted;
};
var countryAndLocalName = function countryAndLocalName(country) {
  var _a;
  var countryKey = getCountryKey(country);
  var localName = ((_a = CountryData[countryKey]) === null || _a === void 0 ? void 0 : _a.localName) || '';
  return localName ? "".concat(country, " - ").concat(localName) : country;
};
var getLocaleFairs = function getLocaleFairs(fairs, locale) {
  return fairs.map(function (fair) {
    var _a;
    var country = fair.country,
      date_from = fair.date_from,
      date_to = fair.date_to,
      highlight = fair.highlight,
      translated_fairs = fair.translated_fairs,
      Link = fair.Link,
      city = fair.city,
      remainingFields = __rest(fair, ["country", "date_from", "date_to", "highlight", "translated_fairs", "Link", "city"]);
    if (translated_fairs && locale) {
      var foundLocaleFair = translated_fairs.find(function (item) {
        var _a;
        return ((_a = item.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === locale.toLowerCase();
      });
      if (foundLocaleFair && foundLocaleFair.fair[0]) {
        var localeFair = Object.assign(Object.assign({}, foundLocaleFair.fair[0]), remainingFields);
        localeFair.country = country;
        localeFair.date_from = date_from;
        localeFair.date_to = date_to;
        localeFair.highlight = highlight;
        localeFair.Link = (_a = foundLocaleFair.fair[0].Link) !== null && _a !== void 0 ? _a : Link;
        localeFair.city = city;
        return localeFair;
      }
    }
    return fair;
  });
};
var getCountryCities = function getCountryCities(fair_detail, filters) {
  if (!fair_detail) {
    return [];
  }
  return fair_detail.filter(function (fair) {
    return fair && filters.country === fair.country;
  }).map(function (data) {
    return {
      _uid: data._uid,
      label: data.city,
      value: data.city
    };
  });
};
var fairIdentity = function fairIdentity(fair) {
  return "".concat(fair._uid, "-").concat(fair.date_from || 'na');
};

var FairsSelectComponent = function FairsSelectComponent(_ref) {
  var options = _ref.options,
    onChange = _ref.onChange;
  var uniqueOptions = options.filter(function (option, index, self) {
    return index === self.findIndex(function (t) {
      return t.value === option.value;
    });
  });
  return /*#__PURE__*/React.createElement("select", {
    className: css$O.fairs_select,
    onChange: onChange
  }, uniqueOptions && uniqueOptions.length > 0 && uniqueOptions.map(function (option, index) {
    return /*#__PURE__*/React.createElement("option", {
      key: "".concat(option._uid, "-").concat(index),
      value: option.value || option.label
    }, option.label);
  }));
};
var DatePicker = function DatePicker(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    placeHolderText = _ref2.placeHolderText;
  var _React$useState = React.useState('text'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputType = _React$useState2[0],
    setInputType = _React$useState2[1];
  var handleFocus = function handleFocus() {
    setInputType('date');
  };
  var handleBlur = function handleBlur(event) {
    if (!event.target.value) {
      setInputType('text');
    }
  };
  return /*#__PURE__*/React.createElement("input", {
    type: inputType,
    value: value,
    onFocus: handleFocus,
    onBlur: handleBlur,
    className: "".concat(css$O.date_select, " ").concat(conditionalClassname(inputType === 'text', css$O.date__icon)),
    onChange: onChange,
    placeholder: placeHolderText
  });
};
var Fair = function Fair(_ref3) {
  var _uid = _ref3._uid,
    city = _ref3.city,
    hall = _ref3.hall,
    booth = _ref3.booth,
    title = _ref3.title,
    country = _ref3.country,
    date_to = _ref3.date_to,
    date_from = _ref3.date_from,
    link = _ref3.Link,
    image_link = _ref3.image_link,
    currentLocale = _ref3.currentLocale;
  var _a;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var formattedFromDate = date_from ? new Date(date_from).toLocaleDateString(currentLocale, {
    day: '2-digit',
    month: '2-digit'
  }).replace(/[/.]$/, '') : '';
  var formattedToDate = date_to ? new Date(date_to).toLocaleDateString(currentLocale) : '';
  var countryKey = getCountryKey(country);
  return /*#__PURE__*/React.createElement("div", {
    key: _uid,
    className: css$O.fairs
  }, /*#__PURE__*/React.createElement("div", {
    className: css$O.text_wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css$O.title_wrapper
  }, (formattedFromDate || formattedToDate) && (/*#__PURE__*/React.createElement("p", {
    className: css$O.date
  }, formattedFromDate, formattedToDate && " - ".concat(formattedToDate))), /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H5
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: css$O.textAndLink
  }, /*#__PURE__*/React.createElement("div", {
    className: css$O.text
  }, /*#__PURE__*/React.createElement("span", {
    className: css$O.country_wrapper
  }, country && (/*#__PURE__*/React.createElement("img", {
    src: getFlagUrl(countryKey),
    alt: (_a = CountryData[getCountryKey(country)]) === null || _a === void 0 ? void 0 : _a.name,
    width: 16,
    height: 16,
    className: css$O.country
  })), (country || city) && (/*#__PURE__*/React.createElement("span", null, country, city && ", ".concat(city)))), (hall || booth) && (/*#__PURE__*/React.createElement("span", {
    className: css$O.location
  }, /*#__PURE__*/React.createElement(LocationIcon, null), formatMessage({
    id: 'FAIRS_OVERVIEW_HALL_BOOTH'
  }), " : ", hall, booth && "/".concat(booth)))), link && hasLink(link) && (/*#__PURE__*/React.createElement("div", {
    className: css$O.links__wrapper
  }, link.map(function (linkType) {
    return /*#__PURE__*/React.createElement(RenderButtonType$1, {
      key: linkType._uid,
      linkType: linkType,
      onOrangeBackground: false,
      linkVariant: linkType.variant
    });
  }))))), image_link && /*#__PURE__*/React.createElement(FairImage, {
    image_link: image_link
  }));
};
var FairImage = function FairImage(_ref4) {
  var image_link = _ref4.image_link;
  return /*#__PURE__*/React.createElement(React.Fragment, null, image_link && image_link.length > 0 && image_link.map(function (image) {
    var _a, _b, _c, _d;
    var link = image.link && image.link.length > 0 ? image.link[0] : '';
    var imageUrl = image.image ? ((_a = image.image.item) === null || _a === void 0 ? void 0 : _a.focal_embed_link) || ((_b = image.image.item) === null || _b === void 0 ? void 0 : _b.embed_link) : '';
    return /*#__PURE__*/React.createElement("div", {
      className: css$O.image_wrapper,
      key: image._uid
    }, imageUrl && (link ? (/*#__PURE__*/React.createElement(Link, {
      href: ((_c = link.link) === null || _c === void 0 ? void 0 : _c.url) || ((_d = link.link) === null || _d === void 0 ? void 0 : _d.cached_url) || '',
      variant: link.variant,
      title: link.name,
      target: TargetValues.Self,
      external: true,
      showExternalIcon: false
    }, /*#__PURE__*/React.createElement(Image, {
      src: imageUrl,
      alt: image.alt_text || 'Fair Image',
      imageSizes: iconSizes$1,
      className: css$O.image
    }))) : (/*#__PURE__*/React.createElement(Image, {
      src: imageUrl,
      alt: image.alt_text || 'Fair Image',
      imageSizes: iconSizes$1,
      className: css$O.image
    }))));
  }));
};
var FairsJsonLd = function FairsJsonLd(_ref5) {
  var fairs = _ref5.fairs;
  var eventsJsonLd = fairs.map(function (fair) {
    var _a, _b, _c, _d;
    return {
      '@context': 'https://schema.org',
      '@type': 'Event',
      name: fair.title,
      startDate: fair.date_from,
      endDate: fair.date_to,
      location: {
        '@type': 'Place',
        name: fair.city,
        address: {
          '@type': 'PostalAddress',
          addressLocality: fair.city,
          addressCountry: getCountryKey(fair.country).toUpperCase()
        }
      },
      image: [((_d = (_c = (_b = (_a = fair.image_link) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.item) === null || _d === void 0 ? void 0 : _d.embed_link) || '']
    };
  });
  var router = useRouter();
  var isHome = isHomepage(router.asPath);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isHome ? (/*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(eventsJsonLd)
    }
  })) : (/*#__PURE__*/React.createElement("script", null)));
};

var FairsOverview = function FairsOverview(_ref) {
  var fair_detail = _ref.fair_detail,
    current_locale = _ref.current_locale;
  var _a, _b, _c, _d;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var countryCode = ((_a = current_locale === null || current_locale === void 0 ? void 0 : current_locale.split('-')[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'de-de';
  var _useState = useState({
      country: ((_b = CountryData[countryCode]) === null || _b === void 0 ? void 0 : _b.name) || '',
      city: '',
      dateFrom: '',
      dateTo: ''
    }),
    filters = _useState[0],
    setFilters = _useState[1];
  var handleFilterChange = function handleFilterChange(filterName) {
    return function (event) {
      var value = event.target.value;
      setFilters(Object.assign(Object.assign({}, filters), _defineProperty({}, filterName, value === 'Country' || value === 'City' ? '' : value)));
    };
  };
  var handleDateChange = function handleDateChange(filterName) {
    return function (event) {
      setFilters(Object.assign(Object.assign({}, filters), _defineProperty({}, filterName, event.target.value)));
    };
  };
  var filteredFairs = filterFairs(fair_detail || [], filters);
  var highlightedFairs = fair_detail && fair_detail.length > 0 && fair_detail.filter(function (fair) {
    return fair.highlight && getCountryKey(fair.country) === countryCode;
  });
  var sortedFairs = sortFairs(filteredFairs, countryCode, getCountryKey);
  var sortedHighlightedFairs = sortFairs(getLocaleFairs(highlightedFairs || [], current_locale), countryCode, getCountryKey);
  var renderLocaleFairs = getLocaleFairs(sortedFairs, current_locale);
  var countryCitiesOptions = getCountryCities(fair_detail, filters);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FairsJsonLd, {
    fairs: renderLocaleFairs
  }), highlightedFairs && highlightedFairs.length > 0 && (/*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true,
    className: css$O.container
  }, /*#__PURE__*/React.createElement(Col, {
    className: css$O.highlight_wrapper
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H2,
    className: css$O.highlight_headline
  }, formatMessage({
    id: 'FAIRS_OVERVIEW_HIGHLIGHTED_HEADLINE'
  })), /*#__PURE__*/React.createElement("div", {
    className: css$O.highlighted_fair
  }, sortedHighlightedFairs === null || sortedHighlightedFairs === void 0 ? void 0 : sortedHighlightedFairs.map(function (fair, index) {
    return /*#__PURE__*/React.createElement(Fair, {
      key: "".concat(fair._uid, "-").concat(index),
      Continent: fair.Continent,
      city: fair.city,
      hall: fair.hall,
      text: fair.text,
      booth: fair.booth,
      title: fair.title,
      country: fair.country,
      date_to: fair.date_to,
      date_from: fair.date_from,
      highlight: fair.highlight,
      Link: fair.Link,
      image_link: fair.image_link,
      currentLocale: current_locale
    });
  }))))), /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true,
    className: css$O.overview__wrapper
  }, /*#__PURE__*/React.createElement("div", null, fair_detail && fair_detail.length > 1 && (/*#__PURE__*/React.createElement(Col, {
    className: css$O.filter_by__title
  }, /*#__PURE__*/React.createElement("p", null, formatMessage({
    id: 'FAIRS_OVERVIEW_FILTER_BY'
  }), ":"))), fair_detail && fair_detail.length > 1 && (/*#__PURE__*/React.createElement(Col, {
    className: css$O.select_wrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: css$O.country_city__select_wrapper
  }, /*#__PURE__*/React.createElement(FairsSelectComponent, {
    options: [{
      label: countryAndLocalName(((_c = CountryData[countryCode]) === null || _c === void 0 ? void 0 : _c.name) || 'Country') || formatMessage({
        id: 'FAIRS_OVERVIEW_COUNTRY'
      }),
      value: ((_d = CountryData[countryCode]) === null || _d === void 0 ? void 0 : _d.name) || 'Country'
    }].concat(_toConsumableArray(fair_detail.map(function (fair) {
      return {
        _uid: fair._uid,
        label: countryAndLocalName(fair.country),
        value: fair.country
      };
    }))),
    onChange: handleFilterChange('country')
  }), /*#__PURE__*/React.createElement(FairsSelectComponent, {
    options: [{
      label: formatMessage({
        id: 'FAIRS_OVERVIEW_CITY'
      }),
      value: 'City'
    }].concat(_toConsumableArray(countryCitiesOptions)),
    onChange: handleFilterChange('city')
  })), /*#__PURE__*/React.createElement("span", {
    className: css$O.date__select_wrapper
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: filters.dateFrom,
    onChange: handleDateChange('dateFrom'),
    placeHolderText: formatMessage({
      id: 'FAIRS_OVERVIEW_START_DATE'
    })
  }), /*#__PURE__*/React.createElement(DatePicker, {
    value: filters.dateTo,
    onChange: handleDateChange('dateTo'),
    placeHolderText: formatMessage({
      id: 'FAIRS_OVERVIEW_END_DATE'
    })
  }))))), /*#__PURE__*/React.createElement(Row, {
    className: css$O.fairs_wrapper
  }, renderLocaleFairs && renderLocaleFairs.length > 0 && renderLocaleFairs.map(function (fair) {
    return /*#__PURE__*/React.createElement(Fair, {
      key: fairIdentity(fair),
      _uid: fair._uid,
      Continent: fair.Continent,
      city: fair.city,
      hall: fair.hall,
      text: fair.text,
      booth: fair.booth,
      title: fair.title,
      country: fair.country,
      date_to: fair.date_to,
      date_from: fair.date_from,
      highlight: fair.highlight,
      Link: fair.Link,
      image_link: fair.image_link,
      currentLocale: current_locale
    });
  }))));
};

var css$N = {"filter__container":"ContactOverview-module_filter__container__GKdvc","filter_by__title":"ContactOverview-module_filter_by__title__CiCFT","filter__wrapper":"ContactOverview-module_filter__wrapper__yGD-x","filter__input_wrapper":"ContactOverview-module_filter__input_wrapper__4OHbi","country":"ContactOverview-module_country__gyYbi","country_spacing":"ContactOverview-module_country_spacing__6I4Ps","arrowUp":"ContactOverview-module_arrowUp__1LG-j","arrowDown":"ContactOverview-module_arrowDown__tnT0n","contact_select":"ContactOverview-module_contact_select__XuE06","contact_select__btn_toggle":"ContactOverview-module_contact_select__btn_toggle__qFgbA","contact_select__dropdown_btn":"ContactOverview-module_contact_select__dropdown_btn__RgPXj","contact_select__text":"ContactOverview-module_contact_select__text__lDToA","contact_select_dropdown":"ContactOverview-module_contact_select_dropdown__PMebh","contact_select_dropdown__btn_active":"ContactOverview-module_contact_select_dropdown__btn_active__zbMEJ","contact_zipcode":"ContactOverview-module_contact_zipcode__qGyq-","contacts":"ContactOverview-module_contacts__1A3Fz","contact":"ContactOverview-module_contact__wTDjR","contact__description":"ContactOverview-module_contact__description__D6Tfh","contact__img":"ContactOverview-module_contact__img__QmD1E","contact__img_fallback":"ContactOverview-module_contact__img_fallback__25sxH","contact__name":"ContactOverview-module_contact__name__rDttI","contact__job_title":"ContactOverview-module_contact__job_title__1R7dL","contact__detail":"ContactOverview-module_contact__detail__jSO9q","contact__name_mb":"ContactOverview-module_contact__name_mb__XxGMW","text_center":"ContactOverview-module_text_center__oL8fy"};

var FilterOption;
(function (FilterOption) {
  FilterOption["DEFAULT"] = "header";
  FilterOption["FIXED"] = "fix_contact";
  FilterOption["ZIP_CODES"] = "zip_codes";
  FilterOption["REGIONS"] = "regions";
})(FilterOption || (FilterOption = {}));
var ImageColor;
(function (ImageColor) {
  ImageColor["Yellow"] = "CFAA00";
})(ImageColor || (ImageColor = {}));

var EmailIcon$1 = function EmailIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4H4.5C3.4 4 2.51 4.9 2.51 6L2.5 18C2.5 19.1 3.4 20 4.5 20H20.5C21.6 20 22.5 19.1 22.5 18V6C22.5 4.9 21.6 4 20.5 4ZM20.5 18H4.5V8L12.5 13L20.5 8V18ZM12.5 11L4.5 6H20.5L12.5 11Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0.5)"
  }))));
};

var MsTeamsIcon = function MsTeamsIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xlinkHref: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    width: "24",
    height: "24",
    fill: "url(#pattern0_84_56)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_84_56",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_84_56",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_84_56",
    width: "24",
    height: "24",
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ7SURBVHgB1VVNaBNREJ55uxuJaagFi1orFs1BKGpFEdqTBRGhNQdrxV7UgvZqEaRoEaOgoAfxVGhArILgSYKlpx7sTSkRW39ORRKMRA1KUmJT2b9xNlurm23WVQziB4+3++a9b76dNzMLUGOg3437YiR3iE/DAHQKiOoFiseyqZ+JxTakvc4J8IkOkbuNQDFW1IyIYQKKapKYHoyl1nidk/2QX7yS32mCdtxlIGwMiuAQP523XqN9yRMI5mE2qEjmucSD9rQvBwZpTVglmByq9dZ86NiTk0x+x17lb0Vpz/7eZJuvEElI2Wo2Ms15m1JqrzC1hFbhDrmrZ3KUxQ2AB57PvijPgUAAIpEIKIpikwNkDaJbtgNzrvJKUVcz4lfkP0NVVSgWi0vSYcrQzIPXl7JIlSDO04jNDAVCGLTuALt7Juk7QTgs8wg4SEsLOhTm1R+qiPrHHx4YqyaieyC5enx09yJnWpnX4SDatYnHZqgL2Xf/hclT6SJcvTG7TBAOwcy6po2FUHCtg3ih9BVSbz841ghxypFFjyYy5dF3dAtsb22AC5eeuRSigDa0Yl2RVUrAnZCCqNV3of0JODSipg4s/P8OVmwVr17nIZdbhJo5eMkO/ga4437kTII3v3NIln3/QrgocVrWJWOvbOI2FxGPcD1McL4v93uJG4skWbPiItM0vWKF0tyfLnvKOTs8F5dAOu1QJSRudkHX3nyhOPYu+1llwgAX4wyUlLuJxK6C5/9AUequseojXLkNXvs41umRm1v7V7J5pqnVKQ3QOy2CqpsQnhqm2Vnd7ANDsfctssAokOjlNtxcXiRKCYH3c5nGe/E4avCv8A3MGNKNfIw95wAAAABJRU5ErkJggg=="
  })));
};

var css$M = {"wrapper":"Pagination-module_wrapper__c3LAt","prevNext_buttons":"Pagination-module_prevNext_buttons__UiqQq","prevNext_buttons_text":"Pagination-module_prevNext_buttons_text__BKjKs","button_wrapper":"Pagination-module_button_wrapper__J3axP","arrow_left":"Pagination-module_arrow_left__qImN-","active_button":"Pagination-module_active_button__g4B7A","inactive_button":"Pagination-module_inactive_button__xjT1Y","ellipsis":"Pagination-module_ellipsis__T-IBv"};

var setTotalPagesAndSize = function setTotalPagesAndSize(formation_teaserview, pages) {
  var pageSize;
  switch (formation_teaserview) {
    case ColumnView.Two:
      pageSize = 8;
      break;
    case ColumnView.Three:
      pageSize = 12;
      break;
    default:
      pageSize = 16;
  }
  var totalPages = Math.ceil(pages.length / pageSize);
  return {
    totalPages: totalPages,
    pageSize: pageSize
  };
};
var getCurrentPageItems = function getCurrentPageItems(pages, currentPage, pageSize) {
  var startIndex = (currentPage - 1) * pageSize;
  var endIndex = startIndex + pageSize;
  return pages.slice(startIndex, endIndex);
};
var handlePaginationTruncation = function handlePaginationTruncation(currentPageNumber, totalNumberOfPages) {
  var paginationItems = [1];
  if (currentPageNumber > 1) {
    if (currentPageNumber > 3) {
      paginationItems.push('...', currentPageNumber - 1);
    } else if (currentPageNumber === 3) {
      paginationItems.push(2);
    }
    paginationItems.push(currentPageNumber);
  }
  if (currentPageNumber < totalNumberOfPages - 1) {
    paginationItems.push(currentPageNumber + 1);
    if (currentPageNumber < totalNumberOfPages - 2) {
      paginationItems.push('...');
    }
  }
  if (currentPageNumber !== totalNumberOfPages) {
    paginationItems.push(totalNumberOfPages);
  }
  return paginationItems;
};

var Pagination$1 = function Pagination(_ref) {
  var _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? 0 : _ref$totalPages,
    onNextPage = _ref.onNextPage,
    onPreviousPage = _ref.onPreviousPage,
    onPageClick = _ref.onPageClick;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var paginationItems = handlePaginationTruncation(currentPage, totalPages);
  var handlePageClick = function handlePageClick(page) {
    if (onPageClick) {
      onPageClick(page);
    }
  };
  return /*#__PURE__*/React.createElement(Container, {
    className: css$M.wrapper,
    spacingWithSeparator: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("button", {
    className: css$M.prevNext_buttons,
    onClick: onPreviousPage,
    disabled: currentPage === 1
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    className: css$M.arrow_left
  }), /*#__PURE__*/React.createElement("span", {
    className: css$M.prevNext_buttons_text
  }, formatMessage({
    id: 'PAGINATION_PREVIOUS'
  }))), /*#__PURE__*/React.createElement("span", {
    className: css$M.button_wrapper
  }, paginationItems.map(function (page) {
    return typeof page === 'number' ? (/*#__PURE__*/React.createElement("button", {
      key: page,
      className: "".concat(page === currentPage ? css$M.active_button : css$M.inactive_button),
      onClick: function onClick() {
        return handlePageClick(page);
      }
    }, page)) : (/*#__PURE__*/React.createElement("span", {
      className: css$M.ellipsis
    }, page));
  })), /*#__PURE__*/React.createElement("button", {
    className: css$M.prevNext_buttons,
    onClick: onNextPage,
    disabled: currentPage === totalPages
  }, /*#__PURE__*/React.createElement("span", {
    className: css$M.prevNext_buttons_text
  }, formatMessage({
    id: 'PAGINATION_NEXT'
  })), /*#__PURE__*/React.createElement(ArrowIcon, null))));
};

var ContactsContext = /*#__PURE__*/createContext(undefined);
var useContactsContext = function useContactsContext() {
  var ctx = useContext(ContactsContext);
  if (!ctx) {
    throw new Error('Please provide ContactsContext');
  }
  return ctx;
};
var ContactsContextProvider = function ContactsContextProvider(_ref) {
  var showTeamsMessage = _ref.showTeamsMessage,
    defaultFormSlug = _ref.defaultFormSlug,
    mainCountry = _ref.mainCountry,
    selectedCountry = _ref.selectedCountry,
    translatedSalesText = _ref.translatedSalesText,
    children = _ref.children;
  var value = {
    showTeamsMessage: showTeamsMessage,
    defaultFormSlug: defaultFormSlug,
    mainCountry: mainCountry,
    selectedCountry: selectedCountry,
    translatedSalesText: translatedSalesText
  };
  return /*#__PURE__*/React.createElement(ContactsContext.Provider, {
    value: value
  }, children);
};

/**
 * Utility functions for image URL manipulation
 */
/**
 * Replaces the 'keep=c' parameter with 'keep=n' in image URLs
 * This changes the crop positioning from center to north (top)
 *
 * @param {string} imageUrl - The original image URL
 * @returns {string} The modified image URL with keep=n instead of keep=c
 *
 * @example
 * // Input: "https://igus.widen.net/content/sakesszmeq/webp/image.jpeg?crop=true&keep=c&u=ynfd0c&w=144&h=170"
 * // Output: "https://igus.widen.net/content/sakesszmeq/webp/image.jpeg?crop=true&keep=n&u=ynfd0c&w=144&h=170"
 */
var replaceKeepCenterWithNorth = function replaceKeepCenterWithNorth(imageUrl) {
  if (!imageUrl) return imageUrl;
  return imageUrl.replace(/keep=c(?=&|$)/g, 'keep=n');
};
/**
 * Applies focal point adjustment to image URL by replacing keep=c with keep=n
 * Alias for replaceKeepCenterWithNorth for better semantic naming
 *
 * @param {string} imageUrl - The original image URL
 * @returns {string} The modified image URL with north focal point
 */
var applyNorthFocalPoint = function applyNorthFocalPoint(imageUrl) {
  return replaceKeepCenterWithNorth(imageUrl);
};
/**
 * Changes the crop parameter from false to true in image URLs
 * This enables cropping functionality for better image fitting
 *
 * @param {string} imageUrl - The original image URL
 * @returns {string} The modified image URL with crop=true instead of crop=false
 *
 * @example
 * // Input: "https://igus.widen.net/content/sakesszmeq/webp/image.jpeg?crop=false&keep=c&u=ynfd0c&w=144&h=170"
 * // Output: "https://igus.widen.net/content/sakesszmeq/webp/image.jpeg?crop=true&keep=c&u=ynfd0c&w=144&h=170"
 */
var enableCropping = function enableCropping(imageUrl) {
  if (!imageUrl) return imageUrl;
  return imageUrl.replace(/crop=false(?=&|$)/g, 'crop=true');
};
/**
 * Adds a color parameter to an image URL
 * The color parameter is typically used for background or overlay colors
 *
 * @param {string} imageUrl - The original image URL
 * @param {string} colorValue - The hex color value (without #, e.g., "CFAA00")
 * @returns {string} The modified image URL with the color parameter added
 *
 * @example
 * // Input: "https://igus.widen.net/content/sakesszmeq/webp/image.jpeg?crop=true&keep=n&u=ynfd0c&w=144&h=170"
 * // Output: "https://igus.widen.net/content/sakesszmeq/webp/image.jpeg?crop=true&keep=n&u=ynfd0c&w=144&h=170&color=CFAA00"
 */
var addColorParameter = function addColorParameter(imageUrl, colorValue) {
  if (!imageUrl || !colorValue) return imageUrl;
  var cleanColor = colorValue.replace(/^#/, '');
  var hasQueryParams = imageUrl.includes('?');
  var separator = hasQueryParams ? '&' : '?';
  return "".concat(imageUrl).concat(separator, "color=").concat(cleanColor);
};
/**
 * Applies comprehensive image transformations including focal point, cropping, and color
 * This is a convenience function that combines multiple transformations
 *
 * @param {string} imageUrl - The original image URL
 * @param {Object} options - Transformation options
 * @param {boolean} options.useNorthFocalPoint - Whether to apply north focal point (default: true)
 * @param {boolean} options.enableCropping - Whether to enable cropping (change crop=false to crop=true) (default: true)
 * @param {string} options.color - Hex color value to add as parameter (optional)
 * @returns {string} The modified image URL with all transformations applied
 *
 * @example
 * // Apply all transformations
 * applyImageTransformations(imageUrl, { useNorthFocalPoint: true, enableCropping: true, color: "CFAA00" })
 *
 * // Apply only color parameter and cropping
 * applyImageTransformations(imageUrl, { useNorthFocalPoint: false, enableCropping: true, color: "FF0000" })
 */
var applyImageTransformations = function applyImageTransformations(imageUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!imageUrl) return imageUrl;
  var transformedUrl = imageUrl;
  if (options.enableCropping !== false) {
    transformedUrl = enableCropping(transformedUrl);
  }
  if (options.useNorthFocalPoint !== false) {
    transformedUrl = applyNorthFocalPoint(transformedUrl);
  }
  if (options.color) {
    transformedUrl = addColorParameter(transformedUrl, options.color);
  }
  return transformedUrl;
};

//#region src/throttlePromise.ts
var AbortError = class extends Error {
	constructor(msg) {
		super(msg);
		this.name = "AbortError";
	}
};
function throttledQueue(fn, limit, interval) {
	if (!Number.isFinite(limit)) throw new TypeError("Expected `limit` to be a finite number");
	if (!Number.isFinite(interval)) throw new TypeError("Expected `interval` to be a finite number");
	const queue = [];
	let timeouts = [];
	let activeCount = 0;
	let isAborted = false;
	const next = async () => {
		activeCount++;
		const x = queue.shift();
		if (x) try {
			const res = await fn(...x.args);
			x.resolve(res);
		} catch (error) {
			x.reject(error);
		}
		const id = setTimeout(() => {
			activeCount--;
			if (queue.length > 0) next();
			timeouts = timeouts.filter((currentId) => currentId !== id);
		}, interval);
		if (!timeouts.includes(id)) timeouts.push(id);
	};
	const throttled = (...args) => {
		if (isAborted) return Promise.reject(/* @__PURE__ */ new Error("Throttled function is already aborted and not accepting new promises"));
		return new Promise((resolve, reject) => {
			queue.push({
				resolve,
				reject,
				args
			});
			if (activeCount < limit) next();
		});
	};
	throttled.abort = () => {
		isAborted = true;
		timeouts.forEach(clearTimeout);
		timeouts = [];
		queue.forEach((x) => x.reject(() => new AbortError("Throttle function aborted")));
		queue.length = 0;
	};
	return throttled;
}
var throttlePromise_default = throttledQueue;

//#endregion
//#region src/utils.ts
/**
* Checks if a URL is a CDN URL
* @param url - The URL to check
* @returns boolean indicating if the URL is a CDN URL
*/
const isCDNUrl = (url = "") => url.includes("/cdn/");
/**
* Gets pagination options for the API request
* @param options - The base options
* @param perPage - Number of items per page
* @param page - Current page number
* @returns Object with pagination options
*/
const getOptionsPage = (options, perPage = 25, page = 1) => ({
	...options,
	per_page: perPage,
	page
});
/**
* Creates a promise that resolves after the specified milliseconds
* @param ms - Milliseconds to delay
* @returns Promise that resolves after the delay
*/
const delay = (ms) => new Promise((res) => setTimeout(res, ms));
/**
* Creates an array of specified length using a mapping function
* @param length - Length of the array
* @param func - Mapping function
* @returns Array of specified length
*/
const arrayFrom = (length = 0, func) => Array.from({ length }, func);
/**
* Creates an array of numbers in the specified range
* @param start - Start of the range
* @param end - End of the range
* @returns Array of numbers in the range
*/
const range = (start = 0, end = start) => {
	const length = Math.abs(end - start) || 0;
	const step = start < end ? 1 : -1;
	return arrayFrom(length, (_, i) => i * step + start);
};
/**
* Maps an array asynchronously
* @param arr - Array to map
* @param func - Async mapping function
* @returns Promise resolving to mapped array
*/
const asyncMap = async (arr, func) => Promise.all(arr.map(func));
/**
* Flattens an array using a mapping function
* @param arr - Array to flatten
* @param func - Mapping function
* @returns Flattened array
*/
const flatMap = (arr = [], func) => arr.map(func).reduce((xs, ys) => [...xs, ...ys], []);
/**
* Stringifies an object into a URL query string
* @param params - Parameters to stringify
* @param prefix - Prefix for nested keys
* @param isArray - Whether the current level is an array
* @returns Stringified query parameters
*/
const stringify = (params, prefix, isArray) => {
	const pairs = [];
	for (const key in params) {
		if (!Object.prototype.hasOwnProperty.call(params, key)) continue;
		const value = params[key];
		if (value === null || value === void 0) continue;
		const enkey = isArray ? "" : encodeURIComponent(key);
		let pair;
		if (typeof value === "object") pair = stringify(value, prefix ? prefix + encodeURIComponent(`[${enkey}]`) : enkey, Array.isArray(value));
		else pair = `${prefix ? prefix + encodeURIComponent(`[${enkey}]`) : enkey}=${encodeURIComponent(value)}`;
		pairs.push(pair);
	}
	return pairs.join("&");
};
/**
* Gets the base URL for a specific region
* @param regionCode - Region code (eu, us, cn, ap, ca)
* @returns Base URL for the region
*/
const getRegionURL = (regionCode) => {
	const REGION_URLS = {
		eu: "api.storyblok.com",
		us: "api-us.storyblok.com",
		cn: "app.storyblokchina.cn",
		ap: "api-ap.storyblok.com",
		ca: "api-ca.storyblok.com"
	};
	return REGION_URLS[regionCode] ?? REGION_URLS.eu;
};

//#endregion
//#region src/sbFetch.ts
var SbFetch = class {
	baseURL;
	timeout;
	headers;
	responseInterceptor;
	fetch;
	ejectInterceptor;
	url;
	parameters;
	fetchOptions;
	constructor($c) {
		this.baseURL = $c.baseURL;
		this.headers = $c.headers || new Headers();
		this.timeout = $c?.timeout ? $c.timeout * 1e3 : 0;
		this.responseInterceptor = $c.responseInterceptor;
		this.fetch = (...args) => $c.fetch ? $c.fetch(...args) : fetch(...args);
		this.ejectInterceptor = false;
		this.url = "";
		this.parameters = {};
		this.fetchOptions = {};
	}
	/**
	*
	* @param url string
	* @param params ISbStoriesParams
	* @returns Promise<ISbResponse | Error>
	*/
	get(url, params) {
		this.url = url;
		this.parameters = params;
		return this._methodHandler("get");
	}
	post(url, params) {
		this.url = url;
		this.parameters = params;
		return this._methodHandler("post");
	}
	put(url, params) {
		this.url = url;
		this.parameters = params;
		return this._methodHandler("put");
	}
	delete(url, params) {
		this.url = url;
		this.parameters = params ?? {};
		return this._methodHandler("delete");
	}
	async _responseHandler(res) {
		const headers = [];
		const response = {
			data: {},
			headers: {},
			status: 0,
			statusText: ""
		};
		if (res.status !== 204) await res.json().then(($r) => {
			response.data = $r;
		});
		for (const pair of res.headers.entries()) headers[pair[0]] = pair[1];
		response.headers = { ...headers };
		response.status = res.status;
		response.statusText = res.statusText;
		return response;
	}
	async _methodHandler(method) {
		let urlString = `${this.baseURL}${this.url}`;
		let body = null;
		if (method === "get") urlString = `${this.baseURL}${this.url}?${stringify(this.parameters)}`;
		else body = JSON.stringify(this.parameters);
		const url = new URL(urlString);
		const controller = new AbortController();
		const { signal } = controller;
		let timeout;
		if (this.timeout) timeout = setTimeout(() => controller.abort(), this.timeout);
		try {
			const fetchResponse = await this.fetch(`${url}`, {
				method,
				headers: this.headers,
				body,
				signal,
				...this.fetchOptions
			});
			if (this.timeout) clearTimeout(timeout);
			const response = await this._responseHandler(fetchResponse);
			if (this.responseInterceptor && !this.ejectInterceptor) return this._statusHandler(this.responseInterceptor(response));
			else return this._statusHandler(response);
		} catch (err) {
			const error = { message: err };
			return error;
		}
	}
	setFetchOptions(fetchOptions = {}) {
		if (Object.keys(fetchOptions).length > 0 && "method" in fetchOptions) delete fetchOptions.method;
		this.fetchOptions = { ...fetchOptions };
	}
	eject() {
		this.ejectInterceptor = true;
	}
	/**
	* Normalizes error messages from different response structures
	* @param data The response data that might contain error information
	* @returns A normalized error message string
	*/
	_normalizeErrorMessage(data) {
		if (Array.isArray(data)) return data[0] || "Unknown error";
		if (data && typeof data === "object") {
			if (data.error) return data.error;
			for (const key in data) {
				if (Array.isArray(data[key])) return `${key}: ${data[key][0]}`;
				if (typeof data[key] === "string") return `${key}: ${data[key]}`;
			}
			if (data.slug) return data.slug;
		}
		return "Unknown error";
	}
	_statusHandler(res) {
		const statusOk = /20[0-6]/g;
		return new Promise((resolve, reject) => {
			if (statusOk.test(`${res.status}`)) return resolve(res);
			const error = {
				message: this._normalizeErrorMessage(res.data),
				status: res.status,
				response: res
			};
			reject(error);
		});
	}
};
var sbFetch_default = SbFetch;

//#endregion
//#region src/constants.ts
const STORYBLOK_AGENT = "SB-Agent";
const STORYBLOK_JS_CLIENT_AGENT = {
	defaultAgentName: "SB-JS-CLIENT",
	defaultAgentVersion: "SB-Agent-Version",
	packageVersion: "7.0.0"
};
const StoryblokContentVersion = {
	PUBLISHED: "published"
};

//#endregion
//#region src/index.ts
let memory = {};
const cacheVersions = {};
var Storyblok = class {
	client;
	maxRetries;
	retriesDelay;
	throttle;
	accessToken;
	cache;
	resolveCounter;
	relations;
	links;
	version;
	/**
	* @deprecated This property is deprecated. Use the standalone `richTextResolver` from `@storyblok/richtext` instead.
	* @see https://github.com/storyblok/richtext
	*/
	richTextResolver;
	resolveNestedRelations;
	stringifiedStoriesCache;
	inlineAssets;
	/**
	*
	* @param config ISbConfig interface
	* @param pEndpoint string, optional
	*/
	constructor(config, pEndpoint) {
		let endpoint = config.endpoint || pEndpoint;
		if (!endpoint) {
			const protocol = config.https === false ? "http" : "https";
			if (!config.oauthToken) endpoint = `${protocol}://${getRegionURL(config.region)}/v2`;
			else endpoint = `${protocol}://${getRegionURL(config.region)}/v1`;
		}
		const headers = new Headers();
		headers.set("Content-Type", "application/json");
		headers.set("Accept", "application/json");
		if (config.headers) {
			const entries = config.headers.constructor.name === "Headers" ? config.headers.entries().toArray() : Object.entries(config.headers);
			entries.forEach(([key, value]) => {
				headers.set(key, value);
			});
		}
		if (!headers.has(STORYBLOK_AGENT)) {
			headers.set(STORYBLOK_AGENT, STORYBLOK_JS_CLIENT_AGENT.defaultAgentName);
			headers.set(STORYBLOK_JS_CLIENT_AGENT.defaultAgentVersion, STORYBLOK_JS_CLIENT_AGENT.packageVersion);
		}
		let rateLimit = 5;
		if (config.oauthToken) {
			headers.set("Authorization", config.oauthToken);
			rateLimit = 3;
		}
		if (config.rateLimit) rateLimit = config.rateLimit;
		this.maxRetries = config.maxRetries || 10;
		this.retriesDelay = 300;
		this.throttle = throttlePromise_default(this.throttledRequest.bind(this), rateLimit, 1e3);
		this.accessToken = config.accessToken || "";
		this.relations = {};
		this.links = {};
		this.cache = config.cache || { clear: "manual" };
		this.resolveCounter = 0;
		this.resolveNestedRelations = config.resolveNestedRelations || true;
		this.stringifiedStoriesCache = {};
		this.version = config.version || StoryblokContentVersion.PUBLISHED;
		this.inlineAssets = config.inlineAssets || false;
		this.client = new sbFetch_default({
			baseURL: endpoint,
			timeout: config.timeout || 0,
			headers,
			responseInterceptor: config.responseInterceptor,
			fetch: config.fetch
		});
	}
	parseParams(params) {
		if (!params.token) params.token = this.getToken();
		if (!params.cv) params.cv = cacheVersions[params.token];
		if (Array.isArray(params.resolve_relations)) params.resolve_relations = params.resolve_relations.join(",");
		if (typeof params.resolve_relations !== "undefined") params.resolve_level = 2;
		return params;
	}
	factoryParamOptions(url, params) {
		if (isCDNUrl(url)) return this.parseParams(params);
		return params;
	}
	makeRequest(url, params, per_page, page, fetchOptions) {
		const query = this.factoryParamOptions(url, getOptionsPage(params, per_page, page));
		return this.cacheResponse(url, query, void 0, fetchOptions);
	}
	get(slug, params = {}, fetchOptions) {
		if (!params) params = {};
		const url = `/${slug}`;
		if (isCDNUrl(url)) params.version = params.version || this.version;
		const query = this.factoryParamOptions(url, params);
		return this.cacheResponse(url, query, void 0, fetchOptions);
	}
	async getAll(slug, params = {}, entity, fetchOptions) {
		const perPage = params?.per_page || 25;
		const url = `/${slug}`.replace(/\/$/, "");
		const e = entity ?? url.substring(url.lastIndexOf("/") + 1);
		params.version = params.version || this.version;
		const firstPage = 1;
		const firstRes = await this.makeRequest(url, params, perPage, firstPage, fetchOptions);
		const lastPage = firstRes.total ? Math.ceil(firstRes.total / (firstRes.perPage || perPage)) : 1;
		const restRes = await asyncMap(range(firstPage, lastPage), (i) => {
			return this.makeRequest(url, params, perPage, i + 1, fetchOptions);
		});
		return flatMap([firstRes, ...restRes], (res) => Object.values(res.data[e]));
	}
	post(slug, params = {}, fetchOptions) {
		const url = `/${slug}`;
		return this.throttle("post", url, params, fetchOptions);
	}
	put(slug, params = {}, fetchOptions) {
		const url = `/${slug}`;
		return this.throttle("put", url, params, fetchOptions);
	}
	delete(slug, params = {}, fetchOptions) {
		if (!params) params = {};
		const url = `/${slug}`;
		return this.throttle("delete", url, params, fetchOptions);
	}
	getStories(params = {}, fetchOptions) {
		this._addResolveLevel(params);
		return this.get("cdn/stories", params, fetchOptions);
	}
	getStory(slug, params = {}, fetchOptions) {
		this._addResolveLevel(params);
		return this.get(`cdn/stories/${slug}`, params, fetchOptions);
	}
	getToken() {
		return this.accessToken;
	}
	ejectInterceptor() {
		this.client.eject();
	}
	_addResolveLevel(params) {
		if (typeof params.resolve_relations !== "undefined") params.resolve_level = 2;
	}
	_cleanCopy(value) {
		return JSON.parse(JSON.stringify(value));
	}
	_insertLinks(jtree, treeItem, resolveId) {
		const node = jtree[treeItem];
		if (node && node.fieldtype === "multilink" && node.linktype === "story" && typeof node.id === "string" && this.links[resolveId][node.id]) node.story = this._cleanCopy(this.links[resolveId][node.id]);
		else if (node && node.linktype === "story" && typeof node.uuid === "string" && this.links[resolveId][node.uuid]) node.story = this._cleanCopy(this.links[resolveId][node.uuid]);
	}
	/**
	*
	* @param resolveId A counter number as a string
	* @param uuid The uuid of the story
	* @returns string | object
	*/
	getStoryReference(resolveId, uuid) {
		const result = this.relations[resolveId][uuid] ? JSON.parse(this.stringifiedStoriesCache[uuid] || JSON.stringify(this.relations[resolveId][uuid])) : uuid;
		return result;
	}
	/**
	* Resolves a field's value by replacing UUIDs with their corresponding story references
	* @param jtree - The JSON tree object containing the field to resolve
	* @param treeItem - The key of the field to resolve
	* @param resolveId - The unique identifier for the current resolution context
	*
	* This method handles both single string UUIDs and arrays of UUIDs:
	* - For single strings: directly replaces the UUID with the story reference
	* - For arrays: maps through each UUID and replaces with corresponding story references
	*/
	_resolveField(jtree, treeItem, resolveId) {
		const item = jtree[treeItem];
		if (typeof item === "string") jtree[treeItem] = this.getStoryReference(resolveId, item);
		else if (Array.isArray(item)) jtree[treeItem] = item.map((uuid) => this.getStoryReference(resolveId, uuid)).filter(Boolean);
	}
	/**
	* Inserts relations into the JSON tree by resolving references
	* @param jtree - The JSON tree object to process
	* @param treeItem - The current field being processed
	* @param fields - The relation patterns to resolve (string or array of strings)
	* @param resolveId - The unique identifier for the current resolution context
	*
	* This method handles two types of relation patterns:
	* 1. Nested relations: matches fields that end with the current field name
	*    Example: If treeItem is "event_type", it matches patterns like "*.event_type"
	*
	* 2. Direct component relations: matches exact component.field patterns
	*    Example: "event.event_type" for component "event" and field "event_type"
	*
	* The method supports both string and array formats for the fields parameter,
	* allowing flexible specification of relation patterns.
	*/
	_insertRelations(jtree, treeItem, fields, resolveId) {
		const fieldPattern = Array.isArray(fields) ? fields.find((f) => f.endsWith(`.${treeItem}`)) : fields.endsWith(`.${treeItem}`);
		if (fieldPattern) {
			this._resolveField(jtree, treeItem, resolveId);
			return;
		}
		const fieldPath = jtree.component ? `${jtree.component}.${treeItem}` : treeItem;
		if (Array.isArray(fields) ? fields.includes(fieldPath) : fields === fieldPath) this._resolveField(jtree, treeItem, resolveId);
	}
	/**
	* Recursively traverses and resolves relations in the story content tree
	* @param story - The story object containing the content to process
	* @param fields - The relation patterns to resolve
	* @param resolveId - The unique identifier for the current resolution context
	*/
	iterateTree(story, fields, resolveId) {
		const enrich = (jtree, path = "") => {
			if (!jtree || jtree._stopResolving) return;
			if (Array.isArray(jtree)) jtree.forEach((item, index) => enrich(item, `${path}[${index}]`));
			else if (typeof jtree === "object") for (const key in jtree) {
				const newPath = path ? `${path}.${key}` : key;
				if (jtree.component && jtree._uid || jtree.type === "link") {
					this._insertRelations(jtree, key, fields, resolveId);
					this._insertLinks(jtree, key, resolveId);
				}
				enrich(jtree[key], newPath);
			}
		};
		enrich(story.content);
	}
	async resolveLinks(responseData, params, resolveId) {
		let links = [];
		if (responseData.link_uuids) {
			const relSize = responseData.link_uuids.length;
			const chunks = [];
			const chunkSize = 50;
			for (let i = 0; i < relSize; i += chunkSize) {
				const end = Math.min(relSize, i + chunkSize);
				chunks.push(responseData.link_uuids.slice(i, end));
			}
			for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
				const linksRes = await this.getStories({
					per_page: chunkSize,
					language: params.language,
					version: params.version,
					starts_with: params.starts_with,
					by_uuids: chunks[chunkIndex].join(",")
				});
				linksRes.data.stories.forEach((rel) => {
					links.push(rel);
				});
			}
		} else links = responseData.links;
		links.forEach((story) => {
			this.links[resolveId][story.uuid] = {
				...story,
				_stopResolving: true
			};
		});
	}
	async resolveRelations(responseData, params, resolveId) {
		let relations = [];
		if (responseData.rel_uuids) {
			const relSize = responseData.rel_uuids.length;
			const chunks = [];
			const chunkSize = 50;
			for (let i = 0; i < relSize; i += chunkSize) {
				const end = Math.min(relSize, i + chunkSize);
				chunks.push(responseData.rel_uuids.slice(i, end));
			}
			for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
				const relationsRes = await this.getStories({
					per_page: chunkSize,
					language: params.language,
					version: params.version,
					starts_with: params.starts_with,
					by_uuids: chunks[chunkIndex].join(","),
					excluding_fields: params.excluding_fields
				});
				relationsRes.data.stories.forEach((rel) => {
					relations.push(rel);
				});
			}
			if (relations.length > 0) {
				responseData.rels = relations;
				delete responseData.rel_uuids;
			}
		} else relations = responseData.rels;
		if (relations && relations.length > 0) relations.forEach((story) => {
			this.relations[resolveId][story.uuid] = {
				...story,
				_stopResolving: true
			};
		});
	}
	/**
	*
	* @param responseData
	* @param params
	* @param resolveId
	* @description Resolves the relations and links of the stories
	* @returns Promise<void>
	*
	*/
	async resolveStories(responseData, params, resolveId) {
		let relationParams = [];
		this.links[resolveId] = {};
		this.relations[resolveId] = {};
		if (typeof params.resolve_relations !== "undefined" && params.resolve_relations.length > 0) {
			if (typeof params.resolve_relations === "string") relationParams = params.resolve_relations.split(",");
			await this.resolveRelations(responseData, params, resolveId);
		}
		if (params.resolve_links && [
			"1",
			"story",
			"url",
			"link"
		].includes(params.resolve_links) && (responseData.links?.length || responseData.link_uuids?.length)) await this.resolveLinks(responseData, params, resolveId);
		if (this.resolveNestedRelations) for (const relUuid in this.relations[resolveId]) this.iterateTree(this.relations[resolveId][relUuid], relationParams, resolveId);
		if (responseData.story) this.iterateTree(responseData.story, relationParams, resolveId);
		else responseData.stories.forEach((story) => {
			this.iterateTree(story, relationParams, resolveId);
		});
		this.stringifiedStoriesCache = {};
		delete this.links[resolveId];
		delete this.relations[resolveId];
	}
	async cacheResponse(url, params, retries, fetchOptions) {
		const cacheKey = stringify({
			url,
			params
		});
		const provider = this.cacheProvider();
		if (params.version === "published" && url !== "/cdn/spaces/me") {
			const cache = await provider.get(cacheKey);
			if (cache) return Promise.resolve(cache);
		}
		return new Promise(async (resolve, reject) => {
			try {
				const res = await this.throttle("get", url, params, fetchOptions);
				if (res.status !== 200) return reject(res);
				let response = {
					data: res.data,
					headers: res.headers
				};
				if (res.headers?.["per-page"]) response = Object.assign({}, response, {
					perPage: res.headers["per-page"] ? Number.parseInt(res.headers["per-page"]) : 0,
					total: res.headers["per-page"] ? Number.parseInt(res.headers.total) : 0
				});
				if (response.data.story || response.data.stories) {
					const resolveId = this.resolveCounter = ++this.resolveCounter % 1e3;
					await this.resolveStories(response.data, params, `${resolveId}`);
					response = await this.processInlineAssets(response);
				}
				if (params.version === "published" && url !== "/cdn/spaces/me") await provider.set(cacheKey, response);
				const isCacheClearable = this.cache.clear === "onpreview" && params.version === "draft" || this.cache.clear === "auto";
				if (params.token && response.data.cv) {
					if (isCacheClearable && cacheVersions[params.token] && cacheVersions[params.token] !== response.data.cv) await this.flushCache();
					cacheVersions[params.token] = response.data.cv;
				}
				return resolve(response);
			} catch (error) {
				if (error.response && error.status === 429) {
					retries = typeof retries === "undefined" ? 0 : retries + 1;
					if (retries < this.maxRetries) {
						console.log(`Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`);
						await delay(this.retriesDelay);
						return this.cacheResponse(url, params, retries).then(resolve).catch(reject);
					}
				}
				reject(error);
			}
		});
	}
	throttledRequest(type, url, params, fetchOptions) {
		this.client.setFetchOptions(fetchOptions);
		return this.client[type](url, params);
	}
	cacheVersions() {
		return cacheVersions;
	}
	cacheVersion() {
		return cacheVersions[this.accessToken];
	}
	setCacheVersion(cv) {
		if (this.accessToken) cacheVersions[this.accessToken] = cv;
	}
	clearCacheVersion() {
		if (this.accessToken) cacheVersions[this.accessToken] = 0;
	}
	cacheProvider() {
		switch (this.cache.type) {
			case "memory": return {
				get(key) {
					return Promise.resolve(memory[key]);
				},
				getAll() {
					return Promise.resolve(memory);
				},
				set(key, content) {
					memory[key] = content;
					return Promise.resolve(void 0);
				},
				flush() {
					memory = {};
					return Promise.resolve(void 0);
				}
			};
			case "custom": if (this.cache.custom) return this.cache.custom;
			default: return {
				get() {
					return Promise.resolve();
				},
				getAll() {
					return Promise.resolve(void 0);
				},
				set() {
					return Promise.resolve(void 0);
				},
				flush() {
					return Promise.resolve(void 0);
				}
			};
		}
	}
	async flushCache() {
		await this.cacheProvider().flush();
		this.clearCacheVersion();
		return this;
	}
	async processInlineAssets(response) {
		if (!this.inlineAssets) return response;
		const processNode = (node) => {
			if (!node || typeof node !== "object") return node;
			if (Array.isArray(node)) return node.map((item) => processNode(item));
			let processedNode = { ...node };
			if (processedNode.fieldtype === "asset" && Array.isArray(response.data.assets)) processedNode = {
				...processedNode,
				...response.data.assets.find((asset) => asset.id === processedNode.id)
			};
			for (const key in processedNode) if (typeof processedNode[key] === "object") processedNode[key] = processNode(processedNode[key]);
			return processedNode;
		};
		if (response.data.story) response.data.story.content = processNode(response.data.story.content);
		if (response.data.stories) response.data.stories = response.data.stories.map((story) => {
			story.content = processNode(story.content);
			return story;
		});
		return response;
	}
};
var src_default = Storyblok;

function _createForOfIteratorHelper$2(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getStoryblokApi = function getStoryblokApi() {
  return new src_default({
    accessToken: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN
  });
};
var formatSelectOptions = function formatSelectOptions(placeholder, list) {
  return [{
    name: placeholder,
    value: '',
    id: 1
  }].concat(_toConsumableArray(list));
};
var PER_PAGE = 100;
var INITIAL_PAGE_NUMBER = 1;
var getTranslatedDepartmentsAndBusinessUnits = function getTranslatedDepartmentsAndBusinessUnits(filterData, departmentsFromDataSource, businessUnitsFromDataSource) {
  try {
    var departments = departmentsFromDataSource === null || departmentsFromDataSource === void 0 ? void 0 : departmentsFromDataSource.filter(function (dataSource) {
      return filterData.departments.includes(dataSource.value.trim().toLowerCase());
    }).map(function (department) {
      return Object.assign(Object.assign({}, department), {
        name: department.dimension_value || department.name
      });
    });
    var businessUnits = businessUnitsFromDataSource === null || businessUnitsFromDataSource === void 0 ? void 0 : businessUnitsFromDataSource.filter(function (dataSource) {
      return filterData.businessUnits.includes(dataSource.value);
    }).map(function (unit) {
      return Object.assign(Object.assign({}, unit), {
        name: unit.dimension_value || unit.name
      });
    });
    return {
      translatedDepartments: departments,
      translatedBusinessUnits: businessUnits
    };
  } catch (error) {
    console.error('Getting translated departments and units error', error);
  }
  return {
    translatedBusinessUnits: [],
    translatedDepartments: []
  };
};
var getContacts = function getContacts(locale, page, filter) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var storyblokApi, fetchOption, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          storyblokApi = getStoryblokApi();
          fetchOption = getFetchOptions(locale, page, filter);
          _context.next = 4;
          return storyblokApi.get('cdn/stories', fetchOption);
        case 4:
          res = _context.sent;
          return _context.abrupt("return", {
            data: res.data.stories,
            total: res.total
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var getFetchOptions = function getFetchOptions(locale, page, filter) {
  var token = process.env.NEXT_PUBLIC_STORYBLOK_TOKEN;
  var starts_with = getContactUrlPath(locale);
  var fetchOptions = {
    token: token,
    starts_with: starts_with,
    version: 'published',
    excluding_fields: 'alternates, tag_list',
    sort_by: 'content.Sort:desc:float:nulls_last',
    page: page,
    per_page: PER_PAGE
  };
  var excludingFilter = {
    Exclude_from_contact_overview: {
      is: false
    }
  };
  fetchOptions['filter_query'] = filter ? Object.assign(Object.assign({}, filter), excludingFilter) : excludingFilter;
  return fetchOptions;
};
var setLocales = new Set(locales);
var formatLocaleToMatchExistingLocales = function formatLocaleToMatchExistingLocales(locale) {
  return locale.split('-').map(function (value, index) {
    return index > 0 ? value.toUpperCase() : value;
  }).join('-');
};
/**
 * This function helps distinguish cms locale and non-cms locale path
 * @param locale string
 * @returns string
 */
var getContactUrlPath = function getContactUrlPath(locale) {
  var formattedLocale = formatLocaleToMatchExistingLocales(locale);
  return setLocales.has(formattedLocale) ? "".concat(locale, "/configs/contacts/") : "contacts-global/".concat(locale, "/");
};
var transformContacts = function transformContacts(contacts) {
  var formattedContacts = [];
  contacts.forEach(function (contact) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    formattedContacts.push({
      id: contact.id.toString(),
      uuid: contact.uuid,
      name: contact.content.first_name ? "".concat(contact.content.first_name, " ").concat(contact.content.last_name) : contact.content.company,
      contactType: contact.content.component,
      jobTitle: ((_a = contact.content) === null || _a === void 0 ? void 0 : _a.job_title) || '',
      sort: +contact.content.Sort,
      email: ((_b = contact.content) === null || _b === void 0 ? void 0 : _b.email) || '',
      phone: ((_c = contact.content) === null || _c === void 0 ? void 0 : _c.phone) || ((_d = contact.content) === null || _d === void 0 ? void 0 : _d.mobile) || '',
      departments: transformToArray((_e = contact.content) === null || _e === void 0 ? void 0 : _e.select_department),
      businessUnits: Array.isArray((_f = contact.content) === null || _f === void 0 ? void 0 : _f.select_products) ? (_g = contact.content) === null || _g === void 0 ? void 0 : _g.select_products : [],
      imgInfo: {
        src: Array.isArray((_h = contact.content) === null || _h === void 0 ? void 0 : _h.image) ? ((_o = (_m = (_l = (_k = (_j = contact.content) === null || _j === void 0 ? void 0 : _j.image) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.image) === null || _m === void 0 ? void 0 : _m.item) === null || _o === void 0 ? void 0 : _o.focal_embed_link) || ((_t = (_s = (_r = (_q = (_p = contact === null || contact === void 0 ? void 0 : contact.content) === null || _p === void 0 ? void 0 : _p.image) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.image) === null || _s === void 0 ? void 0 : _s.item) === null || _t === void 0 ? void 0 : _t.embed_link) : '',
        alt: ((_v = (_u = contact.content) === null || _u === void 0 ? void 0 : _u.image[0]) === null || _v === void 0 ? void 0 : _v.alt_text) || ''
      },
      regions: Array.isArray((_w = contact.content) === null || _w === void 0 ? void 0 : _w.select_region) ? (_x = contact.content) === null || _x === void 0 ? void 0 : _x.select_region : []
    });
  });
  return formattedContacts;
};
var transformToArray = function transformToArray(departments) {
  if (Array.isArray(departments)) {
    return departments;
  }
  if (!departments) {
    return [];
  }
  return [departments];
};
var getLatestContacts = function getLatestContacts(selectedLocale, page, filter) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result, filteredContacts;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return getContacts(selectedLocale, page, filter);
        case 2:
          result = _context2.sent;
          filteredContacts = result.data.filter(function (contact) {
            return !contact.content.Exclude_from_contact_overview;
          });
          return _context2.abrupt("return", {
            data: transformContacts(filteredContacts),
            total: result.total
          });
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};
var getFilteringOption = function getFilteringOption(locale) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _a, _b, storyblokApi, token, _yield$storyblokApi$g, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          storyblokApi = getStoryblokApi();
          token = process.env.NEXT_PUBLIC_STORYBLOK_TOKEN;
          _context3.next = 4;
          return storyblokApi.get('cdn/stories', {
            starts_with: "".concat(locale, "/configs/header"),
            token: token
          });
        case 4:
          _yield$storyblokApi$g = _context3.sent;
          data = _yield$storyblokApi$g.data;
          return _context3.abrupt("return", ((_b = (_a = data === null || data === void 0 ? void 0 : data.stories[0]) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.select_contact_view) || FilterOption.FIXED);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};
var getSelectedCountryName = function getSelectedCountryName(locale) {
  var _a;
  return ((_a = CountryData[locale]) === null || _a === void 0 ? void 0 : _a.name) || '';
};
var getOnlySupportedCountries = function getOnlySupportedCountries(countriesWithContacts) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var onlySupportedCountries = {};
  var _loop = function _loop(key) {
    var existingCountry = countriesWithContacts.find(function (country) {
      return country.value.toLowerCase() === key.toLowerCase();
    });
    if (existingCountry) {
      onlySupportedCountries[key] = Object.assign({}, CountryData[key]);
    }
  };
  for (var key in CountryData) {
    _loop(key);
  }
  return onlySupportedCountries;
};
var filterForBusinessUnit = function filterForBusinessUnit(contacts, filterCheck) {
  return contacts.filter(function (contact) {
    return contact.businessUnits.some(function (unit) {
      return unit === filterCheck;
    });
  });
};
var filterForDepartment = function filterForDepartment(contacts, filterCheck) {
  return contacts.filter(function (contact) {
    return contact.departments.some(function (department) {
      return department === filterCheck;
    });
  });
};
var getSortNumbers = function getSortNumbers(contacts) {
  var result = new Map();
  var _iterator = _createForOfIteratorHelper$2(contacts),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var contact = _step.value;
      var sortValue = contact.sort.toString();
      if (result.has(sortValue)) {
        var updatedNumber = result.get(sortValue) + 1;
        result.set(sortValue, updatedNumber);
      } else {
        result.set(sortValue, 1);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};
var sortContacts = function sortContacts(contacts) {
  var updatedContacts = contacts.map(function (contact) {
    if (Number.isNaN(contact.sort)) {
      return Object.assign(Object.assign({}, contact), {
        sort: 0
      });
    }
    return contact;
  });
  var sortValues = getSortNumbers(updatedContacts);
  var _iterator2 = _createForOfIteratorHelper$2(sortValues),
    _step2;
  try {
    var _loop2 = function _loop2() {
      var value = _step2.value;
      if (value[1] < 2) {
        return 1; // continue
      }
      var startIndex = updatedContacts.findIndex(function (contact) {
        return contact.sort === +value[0];
      });
      var filteredContacts = updatedContacts.filter(function (contact) {
        return contact.sort === +value[0];
      });
      filteredContacts.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        } else if (b.name > a.name) {
          return -1;
        } else {
          return 0;
        }
      });
      updatedContacts.splice.apply(updatedContacts, [startIndex, value[1]].concat(_toConsumableArray(filteredContacts)));
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      if (_loop2()) continue;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return updatedContacts;
};
var getContactsByUUID = function getContactsByUUID(locale, contactUUIDs, page, filter) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var storyblokApi, fetchOption, data, filteredContacts;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          storyblokApi = getStoryblokApi();
          fetchOption = getFetchOptions(locale, page, filter);
          fetchOption['by_uuids'] = contactUUIDs.join(',');
          _context4.next = 5;
          return storyblokApi.getAll('cdn/stories', fetchOption);
        case 5:
          data = _context4.sent;
          filteredContacts = data.filter(function (contact) {
            return !contact.content.Exclude_from_contact_overview;
          });
          return _context4.abrupt("return", transformContacts(filteredContacts));
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};
var getZipCode = function getZipCode(locale) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var token, storyblokApi, zipcodes;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          token = process.env.NEXT_PUBLIC_STORYBLOK_TOKEN;
          storyblokApi = getStoryblokApi();
          _context5.next = 4;
          return storyblokApi.getAll('cdn/stories', {
            token: token,
            starts_with: pathToSlug("".concat(locale, "/configs/regions")),
            version: 'published'
          });
        case 4:
          zipcodes = _context5.sent;
          return _context5.abrupt("return", zipcodes.map(function (zipcode) {
            var contactsByUUID = [];
            var _iterator3 = _createForOfIteratorHelper$2(zipcode.content.area_or_district),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var area = _step3.value;
                for (var key in area) {
                  if (key.includes('contacts')) {
                    contactsByUUID.push.apply(contactsByUUID, _toConsumableArray(area[key]));
                  }
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            return {
              to: +zipcode.content.area_or_district[0].to,
              from: +zipcode.content.area_or_district[0].from,
              contactsByUUID: contactsByUUID
            };
          }));
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
};
var getStoryblokContactFilter = function getStoryblokContactFilter(department, businessUnit) {
  if (businessUnit && department) {
    return {
      select_products: {
        all_in_array: businessUnit
      },
      select_department: {
        all_in_array: department
      }
    };
  }
  if (businessUnit) {
    return {
      select_products: {
        all_in_array: businessUnit
      }
    };
  }
  if (department) {
    return {
      select_department: {
        all_in_array: department
      }
    };
  }
  return undefined;
};
var getRegions = function getRegions(locale, storyVersion) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var storyblokApi, token, regions;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          storyblokApi = getStoryblokApi();
          token = !storyVersion || storyVersion === 'published' ? process.env.NEXT_PUBLIC_STORYBLOK_TOKEN : process.env.NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN;
          _context6.next = 4;
          return storyblokApi.getAll('cdn/stories', {
            token: token,
            starts_with: pathToSlug("".concat(locale, "/configs/regions")),
            version: 'published',
            filter_query: {
              'area_or_district.0.contacts': {
                is: 'not_empty_array'
              }
            }
          });
        case 4:
          regions = _context6.sent;
          return _context6.abrupt("return", regions.map(function (region) {
            return {
              id: region.id,
              name: region.name,
              value: region.uuid,
              contacts: region.content.area_or_district[0].contacts
            };
          }));
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
};
var useOutsideClick = function useOutsideClick(onOutsideClick) {
  React.useEffect(function () {
    document.addEventListener('mousedown', onOutsideClick);
    return function () {
      document.removeEventListener('mousedown', onOutsideClick);
    };
  }, [onOutsideClick]);
};
var getQueryParams = function getQueryParams(params, departments, businessUnits) {
  var _a;
  var department = params.department,
    unit = params.unit,
    country = params.country;
  var lowerCaseForDepartment = department ? department.toLowerCase() : '';
  var lowerCaseForBusinessUnit = unit ? unit.toLowerCase() : '';
  var departmentFromQuery = undefined;
  var businessUnitFromQuery = undefined;
  if (lowerCaseForDepartment) {
    departmentFromQuery = departments.find(function (dept) {
      return dept.value.toLocaleLowerCase() === lowerCaseForDepartment;
    });
  }
  if (lowerCaseForBusinessUnit) {
    businessUnitFromQuery = businessUnits.find(function (unit) {
      return unit.value.toLocaleLowerCase() === lowerCaseForBusinessUnit;
    });
  }
  return {
    departmentFromQuery: departmentFromQuery,
    businessUnitFromQuery: businessUnitFromQuery,
    country: (_a = country === null || country === void 0 ? void 0 : country.toLowerCase()) !== null && _a !== void 0 ? _a : ''
  };
};
var getTranslatedSalesTexts = function getTranslatedSalesTexts(translatedDepartments) {
  var translatedSalesTexts = [];
  translatedDepartments.forEach(function (translatedDepartment) {
    if (['inside sales', 'field sales'].includes(translatedDepartment.value.toLowerCase())) {
      translatedSalesTexts.push(translatedDepartment);
    }
  });
  return translatedSalesTexts;
};
var getLocaleUsingSelectedCountry = function getLocaleUsingSelectedCountry(selectedCountry, currentLocale) {
  var _a;
  if (!selectedCountry) {
    return currentLocale.toLowerCase();
  }
  var locale = (_a = CountryData[selectedCountry]) === null || _a === void 0 ? void 0 : _a.url;
  var igusDomain = igusDomains.find(function (igusDomain) {
    return igusDomain.defaultLocale.toLowerCase() === locale;
  });
  if (!igusDomain) {
    return locale;
  }
  var preferredLocale = igusDomain.locales.find(function (igusLocale) {
    return igusLocale === currentLocale;
  });
  if (preferredLocale) {
    return preferredLocale.toLowerCase();
  }
  return locale;
};
var getDepartmentAndBusinessUnits = function getDepartmentAndBusinessUnits(middlewareBaseUrl, locale) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          url = new URL('/data/departments-and-units', middlewareBaseUrl);
          url.search = new URLSearchParams({
            locale: locale
          }).toString();
          _context7.prev = 2;
          _context7.next = 5;
          return fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 5:
          response = _context7.sent;
          return _context7.abrupt("return", response.json());
        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](2);
          throw new Error("Failed to fetch departments and business units for locale: ".concat(locale, " with error: ").concat((_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message) || _context7.t0));
        case 12:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[2, 9]]);
  }));
};

var ContactSelect = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var options = _ref.options,
    placeholder = _ref.placeholder,
    selectedItem = _ref.selectedItem,
    onSelectItem = _ref.onSelectItem,
    onResetSelection = _ref.onResetSelection,
    onHideDropdownList = _ref.onHideDropdownList;
  var containerRef = React.useRef(null);
  var handleOutsideClick = React.useCallback(function (event) {
    var _a;
    if (!((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
      setShowList(false);
    }
  }, []);
  useOutsideClick(handleOutsideClick);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showList = _React$useState2[0],
    setShowList = _React$useState2[1];
  React.useImperativeHandle(ref, function () {
    return {
      onHide: function onHide() {
        setShowList(false);
      },
      currentDropdownState: showList
    };
  }, [showList]);
  var onClearSelection = function onClearSelection() {
    setShowList(false);
    onResetSelection();
  };
  var toggleDropdown = function toggleDropdown() {
    setShowList(!showList);
    onHideDropdownList();
  };
  var makeTextEllipsis = function makeTextEllipsis(text, length) {
    if ((typeof window === "undefined" ? "undefined" : _typeof$1(window)) === 'object' && window.innerWidth > 1200) {
      return text.length > length ? "".concat(text.substring(0, length), "...") : text;
    }
    return text;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css$N.contact_select,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: css$N.contact_select__btn_toggle
  }, /*#__PURE__*/React.createElement("span", {
    onClick: toggleDropdown,
    className: css$N.contact_select__text
  }, selectedItem ? makeTextEllipsis(selectedItem.name, 28) : makeTextEllipsis(placeholder, 28)), /*#__PURE__*/React.createElement("span", null, !!selectedItem && (/*#__PURE__*/React.createElement(CloseInputButton, {
    onClearSelection: onClearSelection
  })), /*#__PURE__*/React.createElement("button", {
    className: showList ? css$N.arrowUp : css$N.arrowDown,
    onClick: toggleDropdown
  }, /*#__PURE__*/React.createElement(ArrowFill, null)))), showList && (/*#__PURE__*/React.createElement("div", {
    className: css$N.contact_select_dropdown
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("button", {
      className: "".concat(css$N.contact_select__dropdown_btn, " ").concat((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === option.id ? css$N.contact_select_dropdown__btn_active : ''),
      key: option.id,
      onClick: function onClick() {
        onSelectItem(option.id);
        setShowList(false);
      }
    }, option.name);
  }))));
});
var ContactZipcodeComponent = function ContactZipcodeComponent(_a) {
  var onClearSelection = _a.onClearSelection,
    props = __rest(_a, ["onClearSelection"]);
  var className = props.className,
    remainingProps = __rest(props, ["className"]);
  return /*#__PURE__*/React.createElement("div", {
    className: css$N.contact_zipcode
  }, /*#__PURE__*/React.createElement("input", Object.assign({}, remainingProps, {
    className: className
  })), props.value ? (/*#__PURE__*/React.createElement(CloseInputButton, {
    onClearSelection: onClearSelection
  })) : '');
};
var Contact = function Contact(_ref2) {
  var name = _ref2.name,
    jobTitle = _ref2.jobTitle,
    email = _ref2.email,
    phone = _ref2.phone,
    imgInfo = _ref2.imgInfo,
    businessUnits = _ref2.businessUnits,
    contactType = _ref2.contactType,
    uuid = _ref2.uuid,
    departments = _ref2.departments;
  var _a;
  var _useContactsContext = useContactsContext(),
    showTeamsMessage = _useContactsContext.showTeamsMessage,
    defaultFormSlug = _useContactsContext.defaultFormSlug,
    mainCountry = _useContactsContext.mainCountry,
    selectedCountry = _useContactsContext.selectedCountry,
    translatedSalesText = _useContactsContext.translatedSalesText;
  var hasEitherBusinessUnitOrJobtitle = businessUnits.length > 0 || jobTitle;
  var imageUrl = applyImageTransformations(imgInfo.src, {
    useNorthFocalPoint: true,
    enableCropping: true,
    color: ImageColor.Yellow
  });
  var contactImage = '';
  var translatedDepartment = translatedSalesText.find(function (item) {
    return departments.find(function (dept) {
      return dept.toLowerCase() === item.value.toLowerCase();
    });
  });
  if (imageUrl && contactType === 'contact') {
    contactImage = /*#__PURE__*/React.createElement(Image, {
      src: imageUrl,
      alt: imgInfo.alt,
      imageSizes: [{
        width: 144,
        height: 144
      }],
      className: css$N.contact__img
    });
  } else if (!imageUrl && contactType === 'contact') {
    contactImage = /*#__PURE__*/React.createElement("div", {
      className: css$N.contact__img_fallback
    }, /*#__PURE__*/React.createElement(FallbackProfile$1, null));
  }
  var queryParams = "contact=".concat(uuid);
  if (selectedCountry !== mainCountry) {
    queryParams += "&locale=".concat((_a = CountryData[selectedCountry]) === null || _a === void 0 ? void 0 : _a.url);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css$N.contact
  }, contactImage, /*#__PURE__*/React.createElement("div", {
    className: css$N.contact__description
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H6,
    className: "".concat(css$N.contact__name, " ").concat(!hasEitherBusinessUnitOrJobtitle ? css$N.contact__name_mb : '')
  }, name), /*#__PURE__*/React.createElement("p", {
    className: css$N.contact__job_title
  }, jobTitle && (/*#__PURE__*/React.createElement("span", null, jobTitle, /*#__PURE__*/React.createElement("br", null))), translatedDepartment && (/*#__PURE__*/React.createElement("span", null, translatedDepartment === null || translatedDepartment === void 0 ? void 0 : translatedDepartment.name, /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement("span", null, businessUnits.join(' & '))), phone && (/*#__PURE__*/React.createElement("div", {
    className: css$N.contact__detail
  }, /*#__PURE__*/React.createElement(CurvedPhoneIcon, null), /*#__PURE__*/React.createElement(Link$1, {
    href: "tel:".concat(phone)
  }, phone))), email && (/*#__PURE__*/React.createElement("div", {
    className: css$N.contact__detail
  }, /*#__PURE__*/React.createElement(EmailIcon$1, null), /*#__PURE__*/React.createElement(Link, {
    href: "".concat(defaultFormSlug, "?").concat(queryParams),
    target: TargetValues.Self,
    title: "Get email",
    variant: LinkVariant.Primary
  }, email))), email && showTeamsMessage ? (/*#__PURE__*/React.createElement("div", {
    className: css$N.contact__detail
  }, /*#__PURE__*/React.createElement(MsTeamsIcon, null), /*#__PURE__*/React.createElement(Link$1, {
    href: "https://teams.microsoft.com/l/chat/0/0?users=".concat(email),
    target: "_blank"
  }, "MS Teams Message"))) : ''));
};
var Contacts = function Contacts(_ref3) {
  var contacts = _ref3.contacts,
    currentPage = _ref3.currentPage,
    totalPages = _ref3.totalPages,
    onNextPage = _ref3.onNextPage,
    onPageClick = _ref3.onPageClick,
    onPreviousPage = _ref3.onPreviousPage;
  return /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(Row, {
    className: css$N.contacts
  }, contacts.map(function (contact) {
    return /*#__PURE__*/React.createElement(Contact, {
      key: contact.id,
      name: contact.name,
      jobTitle: contact.jobTitle,
      email: contact.email,
      phone: contact.phone,
      businessUnits: contact.businessUnits,
      imgInfo: contact.imgInfo,
      contactType: contact.contactType,
      uuid: contact.uuid,
      departments: contact.departments
    });
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Pagination$1, {
    currentPage: currentPage,
    totalPages: totalPages,
    onNextPage: onNextPage,
    onPreviousPage: onPreviousPage,
    onPageClick: onPageClick
  })));
};
var ContactFilter = function ContactFilter(_ref4) {
  var translatedDepartments = _ref4.translatedDepartments,
    translatedBusinessUnits = _ref4.translatedBusinessUnits,
    showCountryFilter = _ref4.showCountryFilter,
    currentLocale = _ref4.currentLocale,
    filterOption = _ref4.filterOption,
    enteredZipcode = _ref4.enteredZipcode,
    selectedCountry = _ref4.selectedCountry,
    searchInput = _ref4.searchInput,
    regions = _ref4.regions,
    selectedRegion = _ref4.selectedRegion,
    isDropdownOpen = _ref4.isDropdownOpen,
    countriesWithContacts = _ref4.countriesWithContacts,
    selectedBusinessUnit = _ref4.selectedBusinessUnit,
    selectedDepartment = _ref4.selectedDepartment,
    onHideFilters = _ref4.onHideFilters,
    onSetIsDropdown = _ref4.onSetIsDropdown,
    onClearSelection = _ref4.onClearSelection,
    onToggleDropdown = _ref4.onToggleDropdown,
    onSearchInputChange = _ref4.onSearchInputChange,
    onSelectCountry = _ref4.onSelectCountry,
    onRegionReset = _ref4.onRegionReset,
    onRegionChange = _ref4.onRegionChange,
    onZipcodeChange = _ref4.onZipcodeChange,
    onZipcodeReset = _ref4.onZipcodeReset,
    onSelectBusinessUnit = _ref4.onSelectBusinessUnit,
    onResetSelectedBusinessUnit = _ref4.onResetSelectedBusinessUnit,
    onSelectDepartment = _ref4.onSelectDepartment,
    onResetSelectedDepartment = _ref4.onResetSelectedDepartment;
  var _a;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var dropdownRef = React.useRef(null);
  var dropdownButtonRef = React.useRef(null);
  var regionRef = React.useRef(null);
  var departmentRef = React.useRef(null);
  var businessUnitRef = React.useRef(null);
  var handleOutsideClick = React.useCallback(function (event) {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      return;
    }
    onSetIsDropdown(false);
  }, []);
  useOutsideClick(handleOutsideClick);
  var filteredCountries = useFilteredCountries(isDropdownOpen, searchInput, getOnlySupportedCountries(countriesWithContacts));
  var hideFilters = function hideFilters() {
    var _a, _b, _c;
    if ((_a = regionRef.current) === null || _a === void 0 ? void 0 : _a.currentDropdownState) regionRef.current.onHide();
    if ((_b = departmentRef.current) === null || _b === void 0 ? void 0 : _b.currentDropdownState) departmentRef.current.onHide();
    if ((_c = businessUnitRef.current) === null || _c === void 0 ? void 0 : _c.currentDropdownState) businessUnitRef.current.onHide();
    onHideFilters();
  };
  var toggleDropdown = function toggleDropdown() {
    var _a, _b, _c;
    onToggleDropdown();
    (_a = regionRef.current) === null || _a === void 0 ? void 0 : _a.onHide();
    (_b = departmentRef.current) === null || _b === void 0 ? void 0 : _b.onHide();
    (_c = businessUnitRef.current) === null || _c === void 0 ? void 0 : _c.onHide();
  };
  return /*#__PURE__*/React.createElement(Container, {
    className: css$N.filter__container
  }, /*#__PURE__*/React.createElement(Col, {
    className: css$N.filter_by__title
  }, /*#__PURE__*/React.createElement("p", null, formatMessage({
    id: 'FAIRS_OVERVIEW_FILTER_BY'
  }), ":")), /*#__PURE__*/React.createElement(Col, {
    className: css$N.filter__wrapper
  }, showCountryFilter ? (/*#__PURE__*/React.createElement("div", {
    className: css$N.filter__input_wrapper
  }, /*#__PURE__*/React.createElement(CountrySwitchInput, {
    className: "".concat(css$N.country, " ").concat(selectedCountry ? css$N.country_spacing : ''),
    hideCloseBtn: currentLocale === ((_a = CountryData[selectedCountry]) === null || _a === void 0 ? void 0 : _a.url),
    isDropdownOpen: isDropdownOpen,
    searchInput: searchInput,
    onClearSelection: onClearSelection,
    dropdownRef: dropdownRef,
    onSearchInputChange: onSearchInputChange,
    selectedCountry: selectedCountry,
    toggleDropdown: toggleDropdown,
    dropdownButtonRef: dropdownButtonRef,
    inputPlaceholderText: formatMessage({
      id: 'COUNTRY_SELECT_INPUT_PLACEHOLDER_TEXT'
    })
  }, /*#__PURE__*/React.createElement(CountrySwitchDropdown, {
    onSelectCountry: onSelectCountry,
    selectedCountry: selectedCountry,
    countries: filteredCountries,
    isOpen: isDropdownOpen
  })))) : null, filterOption === FilterOption.REGIONS ? (/*#__PURE__*/React.createElement("div", {
    className: css$N.filter__input_wrapper
  }, /*#__PURE__*/React.createElement(ContactSelect, {
    options: regions,
    placeholder: formatMessage({
      id: 'SELECT_PLACEHOLDER'
    }),
    onSelectItem: onRegionChange,
    selectedItem: selectedRegion,
    onResetSelection: onRegionReset,
    ref: regionRef,
    onHideDropdownList: hideFilters
  }))) : '', filterOption === FilterOption.ZIP_CODES ? (/*#__PURE__*/React.createElement("div", {
    className: css$N.filter__input_wrapper
  }, /*#__PURE__*/React.createElement(ContactZipcodeComponent, {
    placeholder: formatMessage({
      id: 'ZIP_CODE_PLACEHOLDER'
    }),
    onChange: onZipcodeChange,
    value: enteredZipcode,
    onClearSelection: onZipcodeReset
  }))) : '', translatedDepartments.length ? (/*#__PURE__*/React.createElement("div", {
    className: css$N.filter__input_wrapper
  }, /*#__PURE__*/React.createElement(ContactSelect, {
    options: translatedDepartments,
    selectedItem: selectedDepartment,
    placeholder: formatMessage({
      id: 'CONTACT_OVERVIEW_DEPARTMENT'
    }),
    onSelectItem: onSelectDepartment,
    onResetSelection: onResetSelectedDepartment,
    ref: departmentRef,
    onHideDropdownList: hideFilters
  }))) : '', translatedBusinessUnits.length ? (/*#__PURE__*/React.createElement("div", {
    className: css$N.filter__input_wrapper
  }, /*#__PURE__*/React.createElement(ContactSelect, {
    options: translatedBusinessUnits,
    selectedItem: selectedBusinessUnit,
    placeholder: formatMessage({
      id: 'CONTACT_OVERVIEW_BUSINESS_UNIT'
    }),
    onSelectItem: onSelectBusinessUnit,
    onResetSelection: onResetSelectedBusinessUnit,
    ref: businessUnitRef,
    onHideDropdownList: hideFilters
  }))) : ''));
};

var css$L = {"loader__icon":"Loader-module_loader__icon__G--0Z","loader__wrapper":"Loader-module_loader__wrapper__jTAgZ","loader__wrapper_parent":"Loader-module_loader__wrapper_parent__Z1Vhu"};

var Loader = function Loader(_ref) {
  var hasParent = _ref.hasParent;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$L.loader__wrapper, " ").concat(hasParent ? css$L.loader__wrapper_parent : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: css$L.loader__icon
  }));
};

var ContactOverview = function ContactOverview(_ref) {
  var businessUnits = _ref.businessUnits,
    currentLocale = _ref.currentLocale,
    departments = _ref.departments,
    showTeamsMessage = _ref.showTeamsMessage,
    showCountryFilter = _ref.showCountryFilter,
    countriesWithContacts = _ref.countriesWithContacts,
    _ref$defaultFormSlug = _ref.defaultFormSlug,
    defaultFormSlug = _ref$defaultFormSlug === void 0 ? null : _ref$defaultFormSlug,
    districtOrZipFilter = _ref.districtOrZipFilter,
    middlewareBaseUrl = _ref.middlewareBaseUrl;
  var _a;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var timerRef = React.useRef();
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isDropdownOpen = _React$useState4[0],
    setIsDropdownOpen = _React$useState4[1];
  var _React$useState5 = React.useState(districtOrZipFilter !== null && districtOrZipFilter !== void 0 ? districtOrZipFilter : undefined),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    filterOption = _React$useState6[0],
    setFilterOption = _React$useState6[1];
  var _useState = useState(1),
    pageNumber = _useState[0],
    setPageNumber = _useState[1];
  var _useState2 = useState(''),
    enteredZipcode = _useState2[0],
    setEnteredZipcode = _useState2[1];
  var _useState3 = useState([]),
    regions = _useState3[0],
    setRegions = _useState3[1];
  var _useState4 = useState([]),
    zipcodes = _useState4[0],
    setZipcodes = _useState4[1];
  var _useState5 = useState({
      data: [],
      total: 0
    }),
    contacts = _useState5[0],
    setContacts = _useState5[1];
  var _useState6 = useState({
      businessUnits: [],
      departments: []
    }),
    filterData = _useState6[0],
    setFilterData = _useState6[1];
  var _useState7 = useState(),
    selectedDepartment = _useState7[0],
    setSelectedDepartment = _useState7[1];
  var _useState8 = useState(),
    selectedBusinessUnit = _useState8[0],
    setSelectedBusinessUnit = _useState8[1];
  var _useState9 = useState(),
    selectedRegion = _useState9[0],
    setSelectedRegion = _useState9[1];
  var _useState0 = useState(false),
    hasError = _useState0[0],
    setHasError = _useState0[1];
  var defaultLocale = ((_a = currentLocale.split('-')[1]) !== null && _a !== void 0 ? _a : '').toLowerCase();
  var _useState1 = useState(defaultLocale),
    selectedCountry = _useState1[0],
    setSelectedCountry = _useState1[1];
  var previousSelectedCountry = useRef(defaultLocale);
  var preferredLocale = useMemo(function () {
    return getLocaleUsingSelectedCountry(selectedCountry, currentLocale);
  }, [selectedCountry, currentLocale]);
  var _useState10 = useState(getSelectedCountryName(preferredLocale)),
    searchInput = _useState10[0],
    setSearchInput = _useState10[1];
  /**
   * responsible for handling query params passed in during page load
   */
  var router = useRouter();
  var _getQueryParams = getQueryParams(router.query, departments, businessUnits),
    countryFromQuery = _getQueryParams.country,
    businessUnitFromQuery = _getQueryParams.businessUnitFromQuery,
    departmentFromQuery = _getQueryParams.departmentFromQuery;
  useEffect(function () {
    if (departmentFromQuery) {
      setSelectedDepartment(departmentFromQuery);
    }
    if (businessUnitFromQuery) {
      setSelectedBusinessUnit(businessUnitFromQuery);
    }
    if (countryFromQuery) {
      setSelectedCountry(countryFromQuery);
    }
  }, [countryFromQuery, businessUnitFromQuery, departmentFromQuery]);
  useEffect(function () {
    var fetchFilterOption = function fetchFilterOption() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getFilteringOption(preferredLocale);
            case 3:
              result = _context.sent;
              setFilterOption(result);
              _context.next = 11;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setFilterOption(FilterOption.FIXED);
              setHasError(true);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
    };
    if (!setLocales.has(formatLocaleToMatchExistingLocales(preferredLocale))) {
      setFilterOption(FilterOption.FIXED);
      return;
    }
    if (districtOrZipFilter === FilterOption.DEFAULT || !districtOrZipFilter) {
      fetchFilterOption();
    }
  }, [preferredLocale, districtOrZipFilter]);
  useEffect(function () {
    var fetchEitherRegionOrZipCode = function fetchEitherRegionOrZipCode() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _zipcodes, _regions;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!(filterOption === FilterOption.ZIP_CODES)) {
                _context2.next = 8;
                break;
              }
              _context2.next = 4;
              return getZipCode(preferredLocale);
            case 4:
              _zipcodes = _context2.sent;
              setZipcodes(_zipcodes);
              _context2.next = 13;
              break;
            case 8:
              if (!(filterOption === FilterOption.REGIONS)) {
                _context2.next = 13;
                break;
              }
              _context2.next = 11;
              return getRegions(preferredLocale);
            case 11:
              _regions = _context2.sent;
              setRegions(_regions);
            case 13:
              _context2.next = 18;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](0);
              console.error('Failed to fetch region or zipcode', _context2.t0);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 15]]);
      }));
    };
    if (filterOption !== FilterOption.FIXED) {
      fetchEitherRegionOrZipCode();
    }
  }, [filterOption, preferredLocale]);
  useEffect(function () {
    var fetchDepartmentAndUnits = function fetchDepartmentAndUnits() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var departmentsAndBusinessUnits;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return getDepartmentAndBusinessUnits(middlewareBaseUrl, preferredLocale);
            case 3:
              departmentsAndBusinessUnits = _context3.sent;
              setFilterData(departmentsAndBusinessUnits);
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }));
    };
    fetchDepartmentAndUnits();
  }, [preferredLocale]);
  useEffect(function () {
    var fetchContacts = function fetchContacts() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return getLatestContacts(preferredLocale, pageNumber);
            case 3:
              data = _context4.sent;
              setContacts(data);
              _context4.next = 10;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              setHasError(true);
            case 10:
              setIsLoading(false);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }));
    };
    if (isLoading) {
      fetchContacts();
    }
  }, [isLoading, preferredLocale]);
  var handleDepartmentReset = function handleDepartmentReset() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _a, _b;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setSelectedDepartment(undefined);
            _context5.prev = 1;
            if (!selectedRegion) {
              _context5.next = 7;
              break;
            }
            _context5.next = 5;
            return filterViaRegion(selectedRegion, '', (_a = selectedBusinessUnit === null || selectedBusinessUnit === void 0 ? void 0 : selectedBusinessUnit.value) !== null && _a !== void 0 ? _a : '');
          case 5:
            _context5.next = 13;
            break;
          case 7:
            if (!enteredZipcode) {
              _context5.next = 12;
              break;
            }
            _context5.next = 10;
            return filterViaZipcode(+enteredZipcode, '', (_b = selectedBusinessUnit === null || selectedBusinessUnit === void 0 ? void 0 : selectedBusinessUnit.value) !== null && _b !== void 0 ? _b : '');
          case 10:
            _context5.next = 13;
            break;
          case 12:
            setIsLoading(true);
          case 13:
            _context5.next = 18;
            break;
          case 15:
            _context5.prev = 15;
            _context5.t0 = _context5["catch"](1);
            setHasError(true);
          case 18:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 15]]);
    }));
  };
  var handleZipcodeReset = function handleZipcodeReset() {
    setEnteredZipcode('');
    setIsLoading(true);
  };
  var handleZipcodeChange = function handleZipcodeChange(event) {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    var value = event.currentTarget.value;
    var preferredZipcode = parseInt(value);
    setEnteredZipcode(value);
    if (!value) {
      setIsLoading(true);
      return;
    }
    timerRef.current = setTimeout(function () {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _a, _b, initialPageNumber;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              initialPageNumber = 1;
              setPageNumber(initialPageNumber);
              _context6.prev = 2;
              _context6.next = 5;
              return filterViaZipcode(preferredZipcode, (_a = selectedDepartment === null || selectedDepartment === void 0 ? void 0 : selectedDepartment.value) !== null && _a !== void 0 ? _a : '', (_b = selectedBusinessUnit === null || selectedBusinessUnit === void 0 ? void 0 : selectedBusinessUnit.value) !== null && _b !== void 0 ? _b : '');
            case 5:
              _context6.next = 10;
              break;
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](2);
              setHasError(true);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[2, 7]]);
      }));
    }, 500);
  };
  var handleDepartmentChange = function handleDepartmentChange(id) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var _a, _b, _c, selectedItem, data;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            selectedItem = departments.find(function (dept) {
              return dept.id === id;
            });
            setSelectedDepartment(Object.assign(Object.assign({}, selectedItem), {
              name: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.dimension_value) || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name)
            }));
            setPageNumber(INITIAL_PAGE_NUMBER);
            _context7.prev = 3;
            if (!selectedRegion) {
              _context7.next = 9;
              break;
            }
            _context7.next = 7;
            return filterViaRegion(selectedRegion, selectedItem.value, (_a = selectedBusinessUnit === null || selectedBusinessUnit === void 0 ? void 0 : selectedBusinessUnit.value) !== null && _a !== void 0 ? _a : '');
          case 7:
            _context7.next = 18;
            break;
          case 9:
            if (!enteredZipcode) {
              _context7.next = 14;
              break;
            }
            _context7.next = 12;
            return filterViaZipcode(+enteredZipcode, selectedItem.value, (_b = selectedBusinessUnit === null || selectedBusinessUnit === void 0 ? void 0 : selectedBusinessUnit.value) !== null && _b !== void 0 ? _b : '');
          case 12:
            _context7.next = 18;
            break;
          case 14:
            _context7.next = 16;
            return getLatestContacts(preferredLocale, INITIAL_PAGE_NUMBER, getStoryblokContactFilter(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value, (_c = selectedBusinessUnit === null || selectedBusinessUnit === void 0 ? void 0 : selectedBusinessUnit.value) !== null && _c !== void 0 ? _c : ''));
          case 16:
            data = _context7.sent;
            setContacts(data);
          case 18:
            _context7.next = 23;
            break;
          case 20:
            _context7.prev = 20;
            _context7.t0 = _context7["catch"](3);
            console.error('Failed to fetch contacts with preferred department, error is', _context7.t0);
          case 23:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[3, 20]]);
    }));
  };
  var handleBusinessUnitReset = function handleBusinessUnitReset() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var _a, _b;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            setSelectedBusinessUnit(undefined);
            _context8.prev = 1;
            if (!selectedRegion) {
              _context8.next = 7;
              break;
            }
            _context8.next = 5;
            return filterViaRegion(selectedRegion, (_a = selectedDepartment === null || selectedDepartment === void 0 ? void 0 : selectedDepartment.value) !== null && _a !== void 0 ? _a : '', '');
          case 5:
            _context8.next = 13;
            break;
          case 7:
            if (!enteredZipcode) {
              _context8.next = 12;
              break;
            }
            _context8.next = 10;
            return filterViaZipcode(+enteredZipcode, (_b = selectedDepartment === null || selectedDepartment === void 0 ? void 0 : selectedDepartment.value) !== null && _b !== void 0 ? _b : '', '');
          case 10:
            _context8.next = 13;
            break;
          case 12:
            setIsLoading(true);
          case 13:
            _context8.next = 18;
            break;
          case 15:
            _context8.prev = 15;
            _context8.t0 = _context8["catch"](1);
            setHasError(true);
          case 18:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[1, 15]]);
    }));
  };
  var handleBusinessUnit = function handleBusinessUnit(id) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var _a, _b, _c, _d, selectedItem, data;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            selectedItem = businessUnits.find(function (unit) {
              return unit.id === id;
            });
            setSelectedBusinessUnit(selectedItem);
            setPageNumber(INITIAL_PAGE_NUMBER);
            _context9.prev = 3;
            if (!selectedRegion) {
              _context9.next = 9;
              break;
            }
            _context9.next = 7;
            return filterViaRegion(selectedRegion, (_a = selectedDepartment === null || selectedDepartment === void 0 ? void 0 : selectedDepartment.value) !== null && _a !== void 0 ? _a : '', selectedItem.value);
          case 7:
            _context9.next = 18;
            break;
          case 9:
            if (!enteredZipcode) {
              _context9.next = 14;
              break;
            }
            _context9.next = 12;
            return filterViaZipcode(+enteredZipcode, (_b = selectedDepartment === null || selectedDepartment === void 0 ? void 0 : selectedDepartment.value) !== null && _b !== void 0 ? _b : '', selectedItem.value);
          case 12:
            _context9.next = 18;
            break;
          case 14:
            _context9.next = 16;
            return getLatestContacts(preferredLocale, INITIAL_PAGE_NUMBER, getStoryblokContactFilter((_c = selectedDepartment === null || selectedDepartment === void 0 ? void 0 : selectedDepartment.value) !== null && _c !== void 0 ? _c : '', (_d = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) !== null && _d !== void 0 ? _d : ''));
          case 16:
            data = _context9.sent;
            setContacts(data);
          case 18:
            _context9.next = 23;
            break;
          case 20:
            _context9.prev = 20;
            _context9.t0 = _context9["catch"](3);
            console.error('Failed to fetch contacts with preferred business unit, error is', _context9.t0);
          case 23:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[3, 20]]);
    }));
  };
  var handleRegionReset = function handleRegionReset() {
    setSelectedRegion(undefined);
    setIsLoading(true);
  };
  var handleRegionChange = function handleRegionChange(id) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
      var _a, _b, selectedItem;
      return _regeneratorRuntime.wrap(function _callee0$(_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            selectedItem = regions.find(function (region) {
              return region.id === id;
            });
            setSelectedRegion(selectedItem);
            setHasError(false);
            setPageNumber(INITIAL_PAGE_NUMBER);
            _context0.prev = 4;
            _context0.next = 7;
            return filterViaRegion(selectedItem, (_a = selectedDepartment === null || selectedDepartment === void 0 ? void 0 : selectedDepartment.value) !== null && _a !== void 0 ? _a : '', (_b = selectedBusinessUnit === null || selectedBusinessUnit === void 0 ? void 0 : selectedBusinessUnit.value) !== null && _b !== void 0 ? _b : '');
          case 7:
            _context0.next = 12;
            break;
          case 9:
            _context0.prev = 9;
            _context0.t0 = _context0["catch"](4);
            setHasError(true);
          case 12:
            setIsLoading(false);
          case 13:
          case "end":
            return _context0.stop();
        }
      }, _callee0, null, [[4, 9]]);
    }));
  };
  var filterViaRegion = useCallback(function (value, department, businessUnit) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
      var contacts;
      return _regeneratorRuntime.wrap(function _callee1$(_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            _context1.next = 2;
            return getContactsByUUID(preferredLocale, value.contacts, INITIAL_PAGE_NUMBER, getStoryblokContactFilter(department, businessUnit));
          case 2:
            contacts = _context1.sent;
            setContacts({
              data: contacts,
              total: contacts.length
            });
          case 4:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
  }, [selectedCountry, currentLocale]);
  var filterViaZipcode = useCallback(function (preferredZipcode, department, businessUnit) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var zipcode, contacts;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            zipcode = zipcodes.find(function (zipcode) {
              return preferredZipcode >= zipcode.from && preferredZipcode <= zipcode.to;
            });
            if (zipcode) {
              _context10.next = 4;
              break;
            }
            setContacts({
              data: [],
              total: 0
            });
            return _context10.abrupt("return");
          case 4:
            _context10.next = 6;
            return getContactsByUUID(preferredLocale, zipcode.contactsByUUID, INITIAL_PAGE_NUMBER, getStoryblokContactFilter(department, businessUnit));
          case 6:
            contacts = _context10.sent;
            setContacts({
              data: contacts,
              total: contacts.length
            });
          case 8:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
  }, [selectedCountry, zipcodes, currentLocale]);
  var scrollToContactText = useCallback(function () {
    var top = 300;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }, []);
  var handlePageClick = function handlePageClick(page) {
    setPageNumber(page);
    setIsLoading(true);
    scrollToContactText();
  };
  var handleNextPage = function handleNextPage() {
    setPageNumber(function (prevPage) {
      return prevPage + 1;
    });
    scrollToContactText();
  };
  var handlePreviousPage = function handlePreviousPage() {
    setPageNumber(function (prevPage) {
      return prevPage - 1;
    });
    setIsLoading(true);
    scrollToContactText();
  };
  var hideFilters = function hideFilters() {
    if (isDropdownOpen) {
      setIsDropdownOpen(false);
    }
  };
  var toggleDropdown = function toggleDropdown() {
    setIsDropdownOpen(!isDropdownOpen);
  };
  var handleCountrySelection = function handleCountrySelection(countryCode) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var country;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            toggleDropdown();
            if (!(previousSelectedCountry.current === countryCode)) {
              _context11.next = 3;
              break;
            }
            return _context11.abrupt("return");
          case 3:
            previousSelectedCountry.current = countryCode;
            country = getSelectedCountryName(countryCode);
            setSelectedCountry(countryCode);
            setSearchInput(country);
            setPageNumber(1);
            setSelectedDepartment(undefined);
            setSelectedBusinessUnit(undefined);
            setIsLoading(true);
          case 11:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
  };
  var handleClearSelection = function handleClearSelection() {
    setSelectedCountry('');
    setSearchInput('');
    setEnteredZipcode('');
    setSelectedRegion(undefined);
    setSelectedDepartment(undefined);
    setSelectedBusinessUnit(undefined);
  };
  var handleSearchInputChange = function handleSearchInputChange(_ref2) {
    var value = _ref2.target.value;
    setSearchInput(value);
    if (!value) setSelectedCountry('');
  };
  var sortedContacts = sortContacts(contacts.data);
  var _getTranslatedDepartm = getTranslatedDepartmentsAndBusinessUnits(filterData, departments, businessUnits),
    translatedBusinessUnits = _getTranslatedDepartm.translatedBusinessUnits,
    translatedDepartments = _getTranslatedDepartm.translatedDepartments;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContactFilter, {
    currentLocale: currentLocale,
    translatedBusinessUnits: translatedBusinessUnits,
    translatedDepartments: translatedDepartments,
    enteredZipcode: enteredZipcode,
    filterOption: filterOption,
    isDropdownOpen: isDropdownOpen,
    searchInput: searchInput,
    regions: regions,
    selectedCountry: selectedCountry,
    showCountryFilter: showCountryFilter,
    countriesWithContacts: countriesWithContacts,
    selectedRegion: selectedRegion,
    onHideFilters: hideFilters,
    onSearchInputChange: handleSearchInputChange,
    onSetIsDropdown: setIsDropdownOpen,
    onToggleDropdown: toggleDropdown,
    onClearSelection: handleClearSelection,
    onSelectCountry: handleCountrySelection,
    onRegionChange: handleRegionChange,
    onRegionReset: handleRegionReset,
    onZipcodeChange: handleZipcodeChange,
    onZipcodeReset: handleZipcodeReset,
    selectedBusinessUnit: selectedBusinessUnit,
    selectedDepartment: selectedDepartment,
    onSelectBusinessUnit: handleBusinessUnit,
    onResetSelectedBusinessUnit: handleBusinessUnitReset,
    onSelectDepartment: handleDepartmentChange,
    onResetSelectedDepartment: handleDepartmentReset
  }), isLoading ? /*#__PURE__*/React.createElement(Loader, null) : '', !isLoading && sortedContacts.length === 0 ? (/*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, hasError ? (/*#__PURE__*/React.createElement("p", {
    className: css$N.text_center
  }, formatMessage({
    id: 'UNEXPECTED_ERROR_OCCURRED'
  }))) : (/*#__PURE__*/React.createElement("p", {
    className: css$N.text_center
  }, formatMessage({
    id: 'PAGETAGS_SEARCH_NO_RESULTS'
  }))))) : (/*#__PURE__*/React.createElement(ContactsContextProvider, {
    showTeamsMessage: showTeamsMessage,
    defaultFormSlug: defaultFormSlug,
    mainCountry: currentLocale,
    selectedCountry: selectedCountry,
    translatedSalesText: getTranslatedSalesTexts(translatedDepartments)
  }, /*#__PURE__*/React.createElement(Contacts, {
    contacts: sortedContacts,
    currentPage: pageNumber,
    totalPages: contacts.total ? Math.ceil(contacts.total / PER_PAGE) : 0,
    onPageClick: handlePageClick,
    onNextPage: handleNextPage,
    onPreviousPage: handlePreviousPage
  }))));
};

var css$K = {"feedback":"Feedback-module_feedback__77xN5","feedback__text":"Feedback-module_feedback__text__rxFjG","feedback__link":"Feedback-module_feedback__link__Oqgqc"};

var extractLanguageAndCountry = function extractLanguageAndCountry(country) {
  var _country$split = country.split('-'),
    _country$split2 = _slicedToArray(_country$split, 2),
    _country$split2$ = _country$split2[0],
    languageCode = _country$split2$ === void 0 ? '' : _country$split2$,
    _country$split2$2 = _country$split2[1],
    countryCode = _country$split2$2 === void 0 ? '' : _country$split2$2;
  return [languageCode, countryCode];
};
var awardSizes = {
  rectangle_horizontal: [{
    height: 80,
    width: 160
  }],
  rectangle_vertical: [{
    height: 120,
    width: 80
  }],
  square: [{
    height: 80,
    width: 80
  }],
  circle: [{
    height: 80,
    width: 80
  }]
};
/**
 * Returns the appropriate href string from a given link object.
 *
 * The function checks for the presence of a `story` object with both `url` and `slug` properties,
 * then falls back to `url`, and finally to `cached_url`. If none are present, it returns an empty string.
 *
 * @param link - The link object containing possible navigation targets.
 * @returns The resolved href string, or an empty string if no valid link is found.
 */
var getLinkHref = function getLinkHref(link) {
  if (!(link === null || link === void 0 ? void 0 : link.link)) return '';
  var _link$link = link.link,
    story = _link$link.story,
    url = _link$link.url,
    cached_url = _link$link.cached_url;
  if ((story === null || story === void 0 ? void 0 : story.url) && (story === null || story === void 0 ? void 0 : story.slug)) return story.url;
  if (url) return url;
  if (cached_url) return cached_url;
  return '';
};

var Feedback = function Feedback(_ref) {
  var text = _ref.text,
    link = _ref.link;
  var _a;
  if (text) return /*#__PURE__*/React.createElement("section", {
    className: css$K.feedback
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("p", {
    className: css$K.feedback__text
  }, text), (link === null || link === void 0 ? void 0 : link.link) && (/*#__PURE__*/React.createElement(LinkAtom, {
    type: 'link',
    title: link === null || link === void 0 ? void 0 : link.name,
    target: TargetValues.Self,
    href: getLinkHref(link),
    variant: LinkVariant.ButtonTertiary,
    className: css$K.feedback__link,
    showExternalIcon: false,
    external: link.link.linktype === ContactType.Email || !!((_a = link === null || link === void 0 ? void 0 : link.link) === null || _a === void 0 ? void 0 : _a.url),
    piwik_click_id: link === null || link === void 0 ? void 0 : link.piwik_click_id,
    contact_type: determineContactType(link.link.url, link.link.linktype)
  }, (link === null || link === void 0 ? void 0 : link.name) && link.name))));
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

var HomepageBanner = function HomepageBanner(_ref) {
  var asset = _ref.asset,
    button = _ref.button,
    headline = _ref.headline,
    text = _ref.text,
    headline_level = _ref.headline_level,
    separator = _ref.separator,
    asset_ratio = _ref.asset_ratio,
    asset_position = _ref.asset_position,
    caption = _ref.caption,
    noSpacingGrid = _ref.noSpacingGrid,
    variant = _ref.variant,
    outline_variant = _ref.outline_variant;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid
  }, /*#__PURE__*/React.createElement(TextImageTwoColumn, {
    asset: asset,
    headline: headline,
    headline_level: headline_level,
    asset_ratio: asset_ratio,
    asset_position: asset_position,
    button: button,
    text: text,
    caption: caption,
    noSpacingGrid: noSpacingGrid,
    isHomepageBanner: true,
    variant: variant,
    outline_variant: outline_variant
  })), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Separator, null))));
};

/**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */
/* eslint-disable no-param-reassign */
function isObject$4(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend$2(target = {}, src = {}) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$4(src[key]) && isObject$4(target[key]) && Object.keys(src[key]).length > 0) {
      extend$2(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ''
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {}
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== 'undefined' ? window : {};
  extend$2(win, ssrWindow);
  return win;
}

function classesToTokens(classes = '') {
  return classes.trim().split(' ').filter(c => !!c.trim());
}

function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {
      // no getter for object
    }
    try {
      delete object[key];
    } catch (e) {
      // something got wrong
    }
  });
}
function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window = getWindow();
  let style;
  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis = 'x') {
  const window = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);
  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    }
    // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case
    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }
  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$3(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend$1(...args) {
  const to = Object(args[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];
    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (isObject$3(to[nextKey]) && isObject$3(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$3(to[nextKey]) && isObject$3(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';
  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };
  const animate = () => {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };
  animate();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function elementChildren(element, selector = '') {
  const window = getWindow();
  const children = [...element.children];
  if (window.HTMLSlotElement && element instanceof HTMLSlotElement) {
    children.push(...element.assignedElements());
  }
  if (!selector) {
    return children;
  }
  return children.filter(el => el.matches(selector));
}
function elementIsChildOfSlot(el, slot) {
  // Breadth-first search through all parent's children and assigned elements
  const elementsQueue = [slot];
  while (elementsQueue.length > 0) {
    const elementToCheck = elementsQueue.shift();
    if (el === elementToCheck) {
      return true;
    }
    elementsQueue.push(...elementToCheck.children, ...(elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : []), ...(elementToCheck.assignedElements ? elementToCheck.assignedElements() : []));
  }
}
function elementIsChildOf(el, parent) {
  const window = getWindow();
  let isChild = parent.contains(el);
  if (!isChild && window.HTMLSlotElement && parent instanceof HTMLSlotElement) {
    const children = [...parent.assignedElements()];
    isChild = children.includes(el);
    if (!isChild) {
      isChild = elementIsChildOfSlot(el, parent);
    }
  }
  return isChild;
}
function showWarning(text) {
  try {
    console.warn(text);
    return;
  } catch (err) {
    // err
  }
}
function createElement(tag, classes = []) {
  const el = document.createElement(tag);
  el.classList.add(...(Array.isArray(classes) ? classes : classesToTokens(classes)));
  return el;
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window = getWindow();
  return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
function elementParents(el, selector) {
  const parents = []; // eslint-disable-line
  let parent = el.parentElement; // eslint-disable-line
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    el.removeEventListener('transitionend', fireCallBack);
  }
  if (callback) {
    el.addEventListener('transitionend', fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  const window = getWindow();
  {
    return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
  }
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter(e => !!e);
}
function getRotateFix(swiper) {
  return v => {
    if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) {
      return v + 0.001;
    }
    return v;
  };
}
function setInnerHTML(el, html = '') {
  if (typeof trustedTypes !== 'undefined') {
    el.innerHTML = trustedTypes.createPolicy('html', {
      createHTML: s => s
    }).createHTML(html);
  } else {
    el.innerHTML = html;
  }
}

function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = createElement('div', checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}

const arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
function Navigation$1({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    prevEl: null
  };
  function getEl(el) {
    let res;
    if (el && typeof el === 'string' && swiper.isElement) {
      res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
      if (res) return res;
    }
    if (el) {
      if (typeof el === 'string') res = [...document.querySelectorAll(el)];
      if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
        res = swiper.el.querySelector(el);
      } else if (res && res.length === 1) {
        res = res[0];
      }
    }
    if (el && !res) return el;
    // if (Array.isArray(res) && res.length === 1) res = res[0];
    return res;
  }
  function toggleEl(el, disabled) {
    const params = swiper.params.navigation;
    el = makeElementsArray(el);
    el.forEach(subEl => {
      if (subEl) {
        subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
        if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        }
      }
    });
  }
  function update() {
    // Update Navigation Buttons
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (swiper.params.loop) {
      toggleEl(prevEl, false);
      toggleEl(nextEl, false);
      return;
    }
    toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }
  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }
  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    let nextEl = getEl(params.nextEl);
    let prevEl = getEl(params.prevEl);
    Object.assign(swiper.navigation, {
      nextEl,
      prevEl
    });
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const initButton = (el, dir) => {
      if (el) {
        if (el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
          setInnerHTML(el, arrowSvg);
        }
        el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
      }
      if (!swiper.enabled && el) {
        el.classList.add(...params.lockClass.split(' '));
      }
    };
    nextEl.forEach(el => initButton(el, 'next'));
    prevEl.forEach(el => initButton(el, 'prev'));
  }
  function destroy() {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const destroyButton = (el, dir) => {
      el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
      el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
    };
    nextEl.forEach(el => destroyButton(el, 'next'));
    prevEl.forEach(el => destroyButton(el, 'prev'));
  }
  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (swiper.enabled) {
      update();
      return;
    }
    [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.add(swiper.params.navigation.lockClass));
  });
  on('click', (_s, e) => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const targetEl = e.target;
    let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
    if (swiper.isElement && !targetIsButton) {
      const path = e.path || e.composedPath && e.composedPath();
      if (path) {
        targetIsButton = path.find(pathEl => nextEl.includes(pathEl) || prevEl.includes(pathEl));
      }
    }
    if (swiper.params.navigation.hideOnClick && !targetIsButton) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;
      if (nextEl.length) {
        isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      } else if (prevEl.length) {
        isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }
      [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.toggle(swiper.params.navigation.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
    init();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}

function classesToSelector(classes = '') {
  return `.${classes.trim().replace(/([\.:!+\/()[\]])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}

function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl) return;
    bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function getMoveDirection(prevIndex, nextIndex, length) {
    prevIndex = prevIndex % length;
    nextIndex = nextIndex % length;
    if (nextIndex === prevIndex + 1) {
      return 'next';
    } else if (nextIndex === prevIndex - 1) {
      return 'previous';
    }
    return;
  }
  function onBulletClick(e) {
    const bulletEl = e.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e.preventDefault();
    const index = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index) return;
      const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
      if (moveDirection === 'next') {
        swiper.slideNext();
      } else if (moveDirection === 'previous') {
        swiper.slidePrev();
      } else {
        swiper.slideToLoop(index);
      }
    } else {
      swiper.slideTo(index);
    }
  }
  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    // Current/Total
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? 'width' : 'height');
        el.forEach(subEl => {
          subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach(bulletEl => {
        const classesToRemove = [...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`)].map(s => typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach(bullet => {
          const bulletIndex = elementIndex(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(' '));
          } else if (swiper.isElement) {
            bullet.setAttribute('part', 'bullet');
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, 'prev');
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, 'next');
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(' '));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            if (bullets[i]) {
              bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
          }
          setSideBullets(firstDisplayedBullet, 'prev');
          setSideBullets(lastDisplayedBullet, 'next');
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.forEach(bullet => {
          bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === 'fraction') {
        subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach(fractionEl => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach(totalEl => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === 'progressbar') {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach(progressEl => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === 'custom' && params.renderCustom) {
        setInnerHTML(subEl, params.renderCustom(swiper, current + 1, total));
        if (subElIndex === 0) emit('paginationRender', subEl);
      } else {
        if (subElIndex === 0) emit('paginationRender', subEl);
        emit('paginationUpdate', subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
      }
    });
  }
  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let paginationHTML = '';
    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          // prettier-ignore
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach(subEl => {
      if (params.type !== 'custom') {
        setInnerHTML(subEl, paginationHTML || '');
      }
      if (params.type === 'bullets') {
        swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
      }
    });
    if (params.type !== 'custom') {
      emit('paginationRender', el[0]);
    }
  }
  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let el;
    if (typeof params.el === 'string' && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === 'string') {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      // check if it belongs to another nested Swiper
      if (el.length > 1) {
        el = el.find(subEl => {
          if (elementParents(subEl, '.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }
    if (Array.isArray(el) && el.length === 1) el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = makeElementsArray(el);
    el.forEach(subEl => {
      if (params.type === 'bullets' && params.clickable) {
        subEl.classList.add(...(params.clickableClass || '').split(' '));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === 'bullets' && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener('click', onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    if (el) {
      el = makeElementsArray(el);
      el.forEach(subEl => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || '').split(' '));
          subEl.removeEventListener('click', onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(subEl => subEl.classList.remove(...params.bulletActiveClass.split(' ')));
  }
  on('changeDirection', () => {
    if (!swiper.pagination || !swiper.pagination.el) return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    update();
  });
  on('snapGridLengthChange', () => {
    render();
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach(subEl => subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const el = makeElementsArray(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }
      el.forEach(subEl => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach(subEl => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init();
    render();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach(subEl => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}

function A11y({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null,
      scrollOnFocus: true,
      wrapperLiveRegion: true
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;
  let preventFocusHandler;
  let focusTargetSlideEl;
  let visibilityChangedTimestamp = new Date().getTime();
  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    setInnerHTML(notification, message);
  }
  function getRandomNumber(size = 16) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);
    return 'x'.repeat(size).replace(/x/g, randomChar);
  }
  function makeElFocusable(el) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '0');
    });
  }
  function makeElNotFocusable(el) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '-1');
    });
  }
  function addElRole(el, role) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('role', role);
    });
  }
  function addElRoleDescription(el, description) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-roledescription', description);
    });
  }
  function addElControls(el, controls) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-controls', controls);
    });
  }
  function addElLabel(el, label) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-label', label);
    });
  }
  function addElId(el, id) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('id', id);
    });
  }
  function addElLive(el, live) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-live', live);
    });
  }
  function disableEl(el) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', true);
    });
  }
  function enableEl(el) {
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', false);
    });
  }
  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const targetEl = e.target;
    if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
      if (!e.target.matches(classesToSelector(swiper.params.pagination.bulletClass))) return;
    }
    if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
      const prevEls = makeElementsArray(swiper.navigation.prevEl);
      const nextEls = makeElementsArray(swiper.navigation.nextEl);
      if (nextEls.includes(targetEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          notify(params.lastSlideMessage);
        } else {
          notify(params.nextSlideMessage);
        }
      }
      if (prevEls.includes(targetEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          notify(params.firstSlideMessage);
        } else {
          notify(params.prevSlideMessage);
        }
      }
    }
    if (swiper.pagination && targetEl.matches(classesToSelector(swiper.params.pagination.bulletClass))) {
      targetEl.click();
    }
  }
  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (prevEl) {
      if (swiper.isBeginning) {
        disableEl(prevEl);
        makeElNotFocusable(prevEl);
      } else {
        enableEl(prevEl);
        makeElFocusable(prevEl);
      }
    }
    if (nextEl) {
      if (swiper.isEnd) {
        disableEl(nextEl);
        makeElNotFocusable(nextEl);
      } else {
        enableEl(nextEl);
        makeElFocusable(nextEl);
      }
    }
  }
  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }
  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }
  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.forEach(bulletEl => {
      if (swiper.params.pagination.clickable) {
        makeElFocusable(bulletEl);
        if (!swiper.params.pagination.renderBullet) {
          addElRole(bulletEl, 'button');
          addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, elementIndex(bulletEl) + 1));
        }
      }
      if (bulletEl.matches(classesToSelector(swiper.params.pagination.bulletActiveClass))) {
        bulletEl.setAttribute('aria-current', 'true');
      } else {
        bulletEl.removeAttribute('aria-current');
      }
    });
  }
  const initNavEl = (el, wrapperId, message) => {
    makeElFocusable(el);
    if (el.tagName !== 'BUTTON') {
      addElRole(el, 'button');
      el.addEventListener('keydown', onEnterOrSpaceKey);
    }
    addElLabel(el, message);
    addElControls(el, wrapperId);
  };
  const handlePointerDown = e => {
    if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) {
      preventFocusHandler = true;
    }
    swiper.a11y.clicked = true;
  };
  const handlePointerUp = () => {
    preventFocusHandler = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };
  const onVisibilityChange = e => {
    visibilityChangedTimestamp = new Date().getTime();
  };
  const handleFocus = e => {
    if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
    if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    focusTargetSlideEl = slideEl;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }
    requestAnimationFrame(() => {
      if (preventFocusHandler) return;
      if (swiper.params.loop) {
        swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
      } else {
        swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
      }
      preventFocusHandler = false;
    });
  };
  const initSlides = () => {
    const params = swiper.params.a11y;
    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
    }
    if (params.slideRole) {
      addElRole(swiper.slides, params.slideRole);
    }
    const slidesLength = swiper.slides.length;
    if (params.slideLabelMessage) {
      swiper.slides.forEach((slideEl, index) => {
        const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel(slideEl, ariaLabelMessage);
      });
    }
  };
  const init = () => {
    const params = swiper.params.a11y;
    swiper.el.append(liveRegion);

    // Container
    const containerEl = swiper.el;
    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
    }
    if (params.containerMessage) {
      addElLabel(containerEl, params.containerMessage);
    }
    if (params.containerRole) {
      addElRole(containerEl, params.containerRole);
    }

    // Wrapper
    const wrapperEl = swiper.wrapperEl;
    const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    addElId(wrapperEl, wrapperId);
    if (params.wrapperLiveRegion) {
      const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
      addElLive(wrapperEl, live);
    }

    // Slide
    initSlides();

    // Navigation
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach(el => initNavEl(el, wrapperId, params.nextSlideMessage));
    }
    if (prevEl) {
      prevEl.forEach(el => initNavEl(el, wrapperId, params.prevSlideMessage));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = makeElementsArray(swiper.pagination.el);
      paginationEl.forEach(el => {
        el.addEventListener('keydown', onEnterOrSpaceKey);
      });
    }

    // Tab focus
    const document = getDocument();
    document.addEventListener('visibilitychange', onVisibilityChange);
    swiper.el.addEventListener('focus', handleFocus, true);
    swiper.el.addEventListener('focus', handleFocus, true);
    swiper.el.addEventListener('pointerdown', handlePointerDown, true);
    swiper.el.addEventListener('pointerup', handlePointerUp, true);
  };
  function destroy() {
    if (liveRegion) liveRegion.remove();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }
    if (prevEl) {
      prevEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = makeElementsArray(swiper.pagination.el);
      paginationEl.forEach(el => {
        el.removeEventListener('keydown', onEnterOrSpaceKey);
      });
    }
    const document = getDocument();
    document.removeEventListener('visibilitychange', onVisibilityChange);
    // Tab focus
    if (swiper.el && typeof swiper.el !== 'string') {
      swiper.el.removeEventListener('focus', handleFocus, true);
      swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
      swiper.el.removeEventListener('pointerup', handlePointerUp, true);
    }
  }
  on('beforeInit', () => {
    liveRegion = createElement('span', swiper.params.a11y.notificationClass);
    liveRegion.setAttribute('aria-live', 'assertive');
    liveRegion.setAttribute('aria-atomic', 'true');
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}

/* eslint no-underscore-dangle: "off" */
/* eslint no-use-before-define: "off" */
function Autoplay({
  swiper,
  extendParams,
  on,
  emit,
  params
}) {
  swiper.autoplay = {
    running: false,
    paused: false,
    timeLeft: 0
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: false,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });
  let timeout;
  let raf;
  let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
  let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
  let autoplayTimeLeft;
  let autoplayStartTime = new Date().getTime();
  let wasPaused;
  let isTouched;
  let pausedByTouch;
  let touchStartTimeout;
  let slideChanged;
  let pausedByInteraction;
  let pausedByPointerEnter;
  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
    if (e.target !== swiper.wrapperEl) return;
    swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
    if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) {
      return;
    }
    resume();
  }
  const calcTimeLeft = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.autoplay.paused) {
      wasPaused = true;
    } else if (wasPaused) {
      autoplayDelayCurrent = autoplayTimeLeft;
      wasPaused = false;
    }
    const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
    swiper.autoplay.timeLeft = timeLeft;
    emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
    raf = requestAnimationFrame(() => {
      calcTimeLeft();
    });
  };
  const getSlideDelay = () => {
    let activeSlideEl;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      activeSlideEl = swiper.slides.find(slideEl => slideEl.classList.contains('swiper-slide-active'));
    } else {
      activeSlideEl = swiper.slides[swiper.activeIndex];
    }
    if (!activeSlideEl) return undefined;
    const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
    return currentSlideDelay;
  };
  const run = delayForce => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    cancelAnimationFrame(raf);
    calcTimeLeft();
    let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
    autoplayDelayTotal = swiper.params.autoplay.delay;
    autoplayDelayCurrent = swiper.params.autoplay.delay;
    const currentSlideDelay = getSlideDelay();
    if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
      delay = currentSlideDelay;
      autoplayDelayTotal = currentSlideDelay;
      autoplayDelayCurrent = currentSlideDelay;
    }
    autoplayTimeLeft = delay;
    const speed = swiper.params.speed;
    const proceed = () => {
      if (!swiper || swiper.destroyed) return;
      if (swiper.params.autoplay.reverseDirection) {
        if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
          swiper.slidePrev(speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, speed, true, true);
          emit('autoplay');
        }
      } else {
        if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
          swiper.slideNext(speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, speed, true, true);
          emit('autoplay');
        }
      }
      if (swiper.params.cssMode) {
        autoplayStartTime = new Date().getTime();
        requestAnimationFrame(() => {
          run();
        });
      }
    };
    if (delay > 0) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        proceed();
      }, delay);
    } else {
      requestAnimationFrame(() => {
        proceed();
      });
    }

    // eslint-disable-next-line
    return delay;
  };
  const start = () => {
    autoplayStartTime = new Date().getTime();
    swiper.autoplay.running = true;
    run();
    emit('autoplayStart');
  };
  const stop = () => {
    swiper.autoplay.running = false;
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
    emit('autoplayStop');
  };
  const pause = (internal, reset) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    clearTimeout(timeout);
    if (!internal) {
      pausedByInteraction = true;
    }
    const proceed = () => {
      emit('autoplayPause');
      if (swiper.params.autoplay.waitForTransition) {
        swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
      } else {
        resume();
      }
    };
    swiper.autoplay.paused = true;
    if (reset) {
      if (slideChanged) {
        autoplayTimeLeft = swiper.params.autoplay.delay;
      }
      slideChanged = false;
      proceed();
      return;
    }
    const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
    autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
    if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
    proceed();
  };
  const resume = () => {
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
    autoplayStartTime = new Date().getTime();
    if (pausedByInteraction) {
      pausedByInteraction = false;
      run(autoplayTimeLeft);
    } else {
      run();
    }
    swiper.autoplay.paused = false;
    emit('autoplayResume');
  };
  const onVisibilityChange = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    const document = getDocument();
    if (document.visibilityState === 'hidden') {
      pausedByInteraction = true;
      pause(true);
    }
    if (document.visibilityState === 'visible') {
      resume();
    }
  };
  const onPointerEnter = e => {
    if (e.pointerType !== 'mouse') return;
    pausedByInteraction = true;
    pausedByPointerEnter = true;
    if (swiper.animating || swiper.autoplay.paused) return;
    pause(true);
  };
  const onPointerLeave = e => {
    if (e.pointerType !== 'mouse') return;
    pausedByPointerEnter = false;
    if (swiper.autoplay.paused) {
      resume();
    }
  };
  const attachMouseEvents = () => {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.el.addEventListener('pointerenter', onPointerEnter);
      swiper.el.addEventListener('pointerleave', onPointerLeave);
    }
  };
  const detachMouseEvents = () => {
    if (swiper.el && typeof swiper.el !== 'string') {
      swiper.el.removeEventListener('pointerenter', onPointerEnter);
      swiper.el.removeEventListener('pointerleave', onPointerLeave);
    }
  };
  const attachDocumentEvents = () => {
    const document = getDocument();
    document.addEventListener('visibilitychange', onVisibilityChange);
  };
  const detachDocumentEvents = () => {
    const document = getDocument();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      attachMouseEvents();
      attachDocumentEvents();
      start();
    }
  });
  on('destroy', () => {
    detachMouseEvents();
    detachDocumentEvents();
    if (swiper.autoplay.running) {
      stop();
    }
  });
  on('_freeModeStaticRelease', () => {
    if (pausedByTouch || pausedByInteraction) {
      resume();
    }
  });
  on('_freeModeNoMomentumRelease', () => {
    if (!swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (internal || !swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
      return;
    }
    isTouched = true;
    pausedByTouch = false;
    pausedByInteraction = false;
    touchStartTimeout = setTimeout(() => {
      pausedByInteraction = true;
      pausedByTouch = true;
      pause(true);
    }, 200);
  });
  on('touchEnd', () => {
    if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
    clearTimeout(touchStartTimeout);
    clearTimeout(timeout);
    if (swiper.params.autoplay.disableOnInteraction) {
      pausedByTouch = false;
      isTouched = false;
      return;
    }
    if (pausedByTouch && swiper.params.cssMode) resume();
    pausedByTouch = false;
    isTouched = false;
  });
  on('slideChange', () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    slideChanged = true;
  });
  Object.assign(swiper.autoplay, {
    start,
    stop,
    pause,
    resume
  });
}

function effectInit(params) {
  const {
    effect,
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on('beforeInit', () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on('setTranslate _virtualUpdated', () => {
    if (swiper.params.effect !== effect) return;
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition(duration);
  });
  on('transitionEnd', () => {
    if (swiper.params.effect !== effect) return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows) return;
      // remove shadows
      swiper.slides.forEach(slideEl => {
        slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => shadowEl.remove());
      });
      // create new one
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on('virtualUpdate', () => {
    if (swiper.params.effect !== effect) return;
    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate();
        requireUpdateOnVirtual = false;
      }
    });
  });
}

function effectTarget(effectParams, slideEl) {
  const transformEl = getSlideTransformEl(slideEl);
  if (transformEl !== slideEl) {
    transformEl.style.backfaceVisibility = 'hidden';
    transformEl.style['-webkit-backface-visibility'] = 'hidden';
  }
  return transformEl;
}

function effectVirtualTransitionEnd({
  swiper,
  duration,
  transformElements,
  allSlides
}) {
  const {
    activeIndex
  } = swiper;
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let transitionEndTarget;
    {
      transitionEndTarget = transformElements;
    }
    transitionEndTarget.forEach(el => {
      elementTransitionEnd(el, () => {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        const evt = new window.CustomEvent('transitionend', {
          bubbles: true,
          cancelable: true
        });
        swiper.wrapperEl.dispatchEvent(evt);
      });
    });
  }
}

function createShadow(suffix, slideEl, side) {
  const shadowClass = `swiper-slide-shadow${''}${` swiper-slide-shadow-${suffix}` }`;
  const shadowContainer = getSlideTransformEl(slideEl);
  let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
  if (!shadowEl) {
    shadowEl = createElement('div', shadowClass.split(' '));
    shadowContainer.append(shadowEl);
  }
  return shadowEl;
}

function EffectCreative({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };
  const setTranslate = () => {
    const {
      slides,
      wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;
    const rotateFix = getRotateFix(swiper);
    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;
      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
      }
      const offset = slideEl.swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;
      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }
      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };
      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      }
      // set translate
      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      });
      // set rotates
      r.forEach((value, index) => {
        let val = data.rotate[index] * Math.abs(progress * multiplier);
        r[index] = val;
      });
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;

      // Set shadows
      if (custom && data.shadow || !custom) {
        let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
        if (!shadowEl && data.shadow) {
          shadowEl = createShadow('creative', slideEl);
        }
        if (shadowEl) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
      targetEl.style.opacity = opacityString;
      if (data.origin) {
        targetEl.style.transformOrigin = data.origin;
      }
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effectInit({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

let support;
function calcSupport() {
  const window = getWindow();
  const document = getDocument();
  return {
    smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}

let deviceCached;
function calcDevice({
  userAgent
} = {}) {
  const support = getSupport();
  const window = getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel';

  // iPadOs 13 fix
  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  }

  // Android
  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }

  // Export object
  return device;
}
function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}

let browser;
function calcBrowser() {
  const window = getWindow();
  const device = getDevice();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  if (isSafari()) {
    const ua = String(window.navigator.userAgent);
    if (ua.includes('Version/')) {
      const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map(num => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
  const isSafariBrowser = isSafari();
  const need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix,
    need3dFix,
    isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

function Resize({
  swiper,
  on,
  emit
}) {
  const window = getWindow();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };
  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window = getWindow();
  const attach = (target, options = {}) => {
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };
  const init = () => {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = elementParents(swiper.hostEl);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    // Observe container
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });

    // Observe wrapper
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */

var eventsEmitter = {
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    function onceHandler(...args) {
      self.off(events, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt(elementStyle(el, 'padding-left') || 0, 10) - parseInt(elementStyle(el, 'padding-right') || 0, 10);
  height = height - parseInt(elementStyle(el, 'padding-top') || 0, 10) - parseInt(elementStyle(el, 'padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  const swiper = this;
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  const swiperSize = swiper.size - offsetBefore - offsetAfter;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;

  // reset margins
  slides.forEach(slideEl => {
    if (rtl) {
      slideEl.style.marginLeft = '';
    } else {
      slideEl.style.marginRight = '';
    }
    slideEl.style.marginBottom = '';
    slideEl.style.marginTop = '';
  });

  // reset cssMode offsets
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(wrapperEl, '--swiper-centered-offset-before', '');
    setCSSProperty(wrapperEl, '--swiper-centered-offset-after', '');
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }

  // Calc slides
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides[i];
    if (slide) {
      if (gridEnabled) {
        swiper.grid.updateSlide(i, slide, slides);
      }
      if (elementStyle(slide, 'display') === 'none') continue; // eslint-disable-line
    }

    if (isVirtual && params.slidesPerView === 'auto') {
      if (params.virtual.slidesPerViewAutoSlideSize) {
        slideSize = params.virtual.slidesPerViewAutoSlideSize;
      }
      if (slideSize && slide) {
        if (params.roundLengths) slideSize = Math.floor(slideSize);
        slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
      }
    } else if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slide.style[swiper.getDirectionLabel('width')] = ``;
      }
      const slideStyles = getComputedStyle(slide);
      const currentTransform = slide.style.transform;
      const currentWebKitTransform = slide.style.webkitTransform;
      if (currentTransform) {
        slide.style.transform = 'none';
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? elementOuterSize(slide, 'width') : elementOuterSize(slide, 'height');
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');
        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slide) {
        slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
      }
    }
    if (slide) {
      slide.swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach(slideEl => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
    snapGrid = snapGrid.map(snap => {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const offsetSize = (offsetBefore || 0) + (offsetAfter || 0);
    if (allSlidesSize + offsetSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    setCSSProperty(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit('slidesUpdated');
  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}

function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  // eslint-disable-next-line
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}

const toggleSlideClasses$1 = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesProgress(translate = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate;
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
    }
    toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
    toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}

function updateProgress(translate) {
  const swiper = this;
  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    // eslint-disable-next-line
    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }
  swiper.emit('progress', progress);
}

const toggleSlideClasses = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const getFilteredSlide = selector => {
    return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  let activeSlide;
  let prevSlide;
  let nextSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.find(slideEl => slideEl.column === activeIndex);
      nextSlide = slides.find(slideEl => slideEl.column === activeIndex + 1);
      prevSlide = slides.find(slideEl => slideEl.column === activeIndex - 1);
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    if (!gridEnabled) {
      // Next Slide
      nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }

      // Prev Slide
      prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
    }
  }
  slides.forEach(slideEl => {
    toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
    toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
    toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
  });
  swiper.emitSlidesClasses();
}

const processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        // init later
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl) lazyEl.remove();
  }
};
const unlazy = (swiper, index) => {
  if (!swiper.slides[index]) return;
  const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute('loading');
};
const preload = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper, i);
      }
    }
  }
};

function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== 'undefined') {
      if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = aIndex => {
    let realIndex = aIndex - swiper.virtual.slidesBefore;
    if (realIndex < 0) {
      realIndex = swiper.virtual.slides.length + realIndex;
    }
    if (realIndex >= swiper.virtual.slides.length) {
      realIndex -= swiper.virtual.slides.length;
    }
    return realIndex;
  };
  if (typeof activeIndex === 'undefined') {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;

  // Get real index
  let realIndex;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (gridEnabled) {
    const firstSlideInColumn = swiper.slides.find(slideEl => slideEl.column === activeIndex);
    let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach(pathEl => {
      if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }
  let currentTranslate = getTranslate(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
  }

  // Check if we need to update progress
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }
  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;

  // Update progress
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          swiper.animating = false;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};

function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
  }
  swiper.emit('setTransition', duration, byController);
}

function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && dir === 'reset') {
    swiper.emit(`slideResetTransition${step}`);
  } else if (runCallbacks && activeIndex !== previousIndex) {
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}

function transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}

var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};

function slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
  if (typeof index === 'string') {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex];
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  // Update progress
  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // initial virtual
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  const isInitialVirtual = isVirtual && initial;
  // Update Index
  if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;
    if (speed === 0) {
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }
    return true;
  }
  const browser = getBrowser();
  const isSafari = browser.isSafari;
  if (isVirtual && !initial && isSafari && swiper.isElement) {
    swiper.virtual.update(false, false, slideIndex);
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}

function slideToLoop(index = 0, speed, runCallbacks = true, internal) {
  if (typeof index === 'string') {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      // eslint-disable-next-line
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      let targetSlideIndex;
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      const {
        centeredSlides,
        slidesOffsetBefore,
        slidesOffsetAfter
      } = swiper.params;
      const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
      let slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      let needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (bothDirections) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) {
        needLoopFix = false;
      }
      if (needLoopFix) {
        const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
        swiper.loopFix({
          direction,
          slideTo: true,
          activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
        });
      }
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(() => {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'next'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'prev'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  const isFreeMode = params.freeMode && params.freeMode.enabled;
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks = true, internal) {
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  const swiper = this;
  if (swiper.destroyed) return;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      swiper.slideToLoop(realIndex);
    } else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};

function loopCreate(slideRealIndex, initial) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  const initSlides = () => {
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index) => {
      el.setAttribute('data-swiper-slide-index', index);
    });
  };
  const clearBlankSlides = () => {
    const slides = elementChildren(slidesEl, `.${params.slideBlankClass}`);
    slides.forEach(el => {
      el.remove();
    });
    if (slides.length > 0) {
      swiper.recalcSlides();
      swiper.updateSlides();
    }
  };
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) {
    clearBlankSlides();
  }
  const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  const addBlankSlides = amountOfSlides => {
    for (let i = 0; i < amountOfSlides; i += 1) {
      const slideEl = swiper.isElement ? createElement('swiper-slide', [params.slideBlankClass]) : createElement('div', [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      showWarning('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      showWarning('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else {
    initSlides();
  }
  const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
  swiper.loopFix({
    slideRealIndex,
    direction: bothDirections ? undefined : 'next',
    initial
  });
}

function loopFix({
  slideRealIndex,
  slideTo = true,
  direction,
  setTranslate,
  activeSlideIndex,
  initial,
  byController,
  byMousewheel
} = {}) {
  const swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit('beforeLoopFix');
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  const {
    centeredSlides,
    slidesOffsetBefore,
    slidesOffsetAfter,
    initialSlide
  } = params;
  const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo) {
      if (!bothDirections && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (bothDirections && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
    return;
  }
  let slidesPerView = params.slidesPerView;
  if (slidesPerView === 'auto') {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (bothDirections && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
    showWarning('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
  } else if (gridEnabled && params.grid.fill === 'row') {
    showWarning('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
  }
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
  let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
  if (typeof activeSlideIndex === 'undefined') {
    activeSlideIndex = swiper.getSlideIndex(slides.find(el => el.classList.contains(params.slideActiveClass)));
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === 'next' || !direction;
  const isPrev = direction === 'prev' || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
  // prepend last slides before start
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        const colIndexToPrepend = cols - index - 1;
        for (let i = slides.length - 1; i >= 0; i -= 1) {
          if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
        }
        // slides.forEach((slide, slideIndex) => {
        //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
        // });
      } else {
        prependSlidesIndexes.push(cols - index - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
    if (isInitialOverflow) {
      slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
    }
    for (let i = 0; i < slidesAppended; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        slides.forEach((slide, slideIndex) => {
          if (slide.column === index) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index);
      }
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(() => {
    swiper.__preventObserver__ = false;
  });
  if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
    if (appendSlidesIndexes.includes(activeSlideIndex)) {
      appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (prependSlidesIndexes.includes(activeSlideIndex)) {
      prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach(index => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach(index => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === 'auto') {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach((slide, slideIndex) => {
      swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate) {
          const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach(c => {
        if (!c.destroyed && c.params.loop) c.loopFix({
          ...loopParams,
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
      });
    }
  }
  swiper.emit('loopFix');
}

function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach(slideEl => {
    const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach(slideEl => {
    slideEl.removeAttribute('data-swiper-slide-index');
  });
  newSlidesOrder.forEach(slideEl => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}

var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};

function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};

// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  const window = getWindow();
  const {
    params
  } = swiper;
  const edgeSwipeDetection = params.edgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  const swiper = this;
  const document = getDocument();
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  const data = swiper.touchEventsData;
  if (e.type === 'pointerdown') {
    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
      return;
    }
    data.pointerId = e.pointerId;
  } else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
    data.touchId = e.targetTouches[0].identifier;
  }
  if (e.type === 'touchstart') {
    // don't proceed touch event
    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
    return;
  }
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let targetEl = e.target;
  if (params.touchEventsTarget === 'wrapper') {
    if (!elementIsChildOf(targetEl, swiper.wrapperEl)) return;
  }
  if ('which' in e && e.which === 3) return;
  if ('button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;

  // change target el for shadow root component
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
  // eslint-disable-next-line
  const eventPath = e.composedPath ? e.composedPath() : e.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);

  // use closestElement for shadow root element to get the actual closest for nested shadow root element
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  if (!preventEdgeSwipe(swiper, e, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === 'SELECT') {
      data.isTouched = false;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) {
    document.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  const document = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (e.type === 'pointermove') {
    if (data.touchId !== null) return; // return from pointer if we use touch
    const id = e.pointerId;
    if (id !== data.pointerId) return;
  }
  let targetTouch;
  if (e.type === 'touchmove') {
    targetTouch = [...e.changedTouches].find(t => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
      return;
    } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
      return;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== e.target && e.pointerType !== 'mouse') {
    document.activeElement.blur();
  }
  if (document.activeElement) {
    if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent('transitionend', {
        bubbles: true,
        cancelable: true,
        detail: {
          bySwiperTouchMove: true
        }
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  new Date().getTime();
  if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
      swiper.loopFix({
        direction: 'prev',
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: 'next',
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;

  // Update active index in free mode
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let targetTouch;
  const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
  if (!isTouchEvent) {
    if (data.touchId !== null) return; // return from pointer if we use touch
    if (e.pointerId !== data.pointerId) return;
    targetTouch = e;
  } else {
    targetTouch = [...e.changedTouches].find(t => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
    const proceed = ['pointercancel', 'contextmenu'].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }
  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }

  // Find current slide
  const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  // Find current slide size
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  // eslint-disable-next-line
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit('setTranslate', swiper.translate, false);
}

function onLoad(e) {
  const swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}

function onDocumentTouchStart() {
  const swiper = this;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = 'auto';
  }
}

const events = (swiper, method) => {
  const document = getDocument();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method;
  if (!el || typeof el === 'string') return;

  // Touch Events
  document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
    passive: false,
    capture
  });
  el[domMethod]('touchstart', swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]('pointerdown', swiper.onTouchStart, {
    passive: false
  });
  document[domMethod]('touchmove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('pointermove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('touchend', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerup', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointercancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('touchcancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerout', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerleave', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('contextmenu', swiper.onTouchEnd, {
    passive: true
  });

  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  }

  // Resize handler
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }

  // Images loader
  el[domMethod]('load', swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, 'on');
}
function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}
var events$1 = {
  attachEvents,
  detachEvents
};

const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
  const document = getDocument();

  // Get breakpoint for window/container width and update parameters
  const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
  const breakpointContainer = ['window', 'container'].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document.querySelector(params.breakpointsBase);
  const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasGrabCursor = swiper.params.grabCursor;
  const isGrabCursor = breakpointParams.grabCursor;
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  if (wasGrabCursor && !isGrabCursor) {
    swiper.unsetGrabCursor();
  } else if (!wasGrabCursor && isGrabCursor) {
    swiper.setGrabCursor();
  }

  // Toggle navigation, pagination, scrollbar
  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    if (typeof breakpointParams[prop] === 'undefined') return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend$1(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint,
  getBreakpoint
};

function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  // prettier-ignore
  const suffixes = prepareClasses(['initialized', params.direction, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}

function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  if (!el || typeof el === 'string') return;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}

var classes = {
  addClasses,
  removeClasses
};

function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}
var checkOverflow$1 = {
  checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  oneWayMovement: false,
  swiperElementNodeName: 'SWIPER-CONTAINER',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: 'swiper',
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-blank',
  slideActiveClass: 'swiper-slide-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideFullyVisibleClass: 'swiper-slide-fully-visible',
  slideNextClass: 'swiper-slide-next',
  slidePrevClass: 'swiper-slide-prev',
  wrapperClass: 'swiper-wrapper',
  lazyPreloaderClass: 'swiper-lazy-preloader',
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== 'object' || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend$1(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
let Swiper$1 = class Swiper {
  constructor(...args) {
    let el;
    let params;
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;
    const document = getDocument();
    if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document.querySelectorAll(params.el).forEach(containerEl => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      // eslint-disable-next-line no-constructor-return
      return swipers;
    }

    // Swiper Instance
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });

    // Extend defaults with modules params
    const swiperParams = extend$1({}, defaults, allModulesParams);

    // Extend defaults with passed params
    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params);

    // add event listeners
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }

    // Extend Swiper
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        // Returns 0 unless `translate` is > 2**23
        // Should be subtracted from css values to prevent overflow
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        startMoving: undefined,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper');

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    // eslint-disable-next-line no-constructor-return
    return swiper;
  }
  getDirectionLabel(property) {
    if (this.isHorizontal()) {
      return property;
    }
    // prettier-ignore
    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = elementIndex(slides[0]);
    return elementIndex(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
  }
  getSlideIndexWhenGrid(index) {
    if (this.grid && this.params.grid && this.params.grid.rows > 1) {
      if (this.params.grid.fill === 'column') {
        index = Math.floor(index / this.params.grid.rows);
      } else if (this.params.grid.fill === 'row') {
        index = index % Math.ceil(this.slides.length / this.params.grid.rows);
      }
    }
    return index;
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit('enable');
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit('disable');
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.forEach(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }
  slidesPerViewDynamic(view = 'current', exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === 'number') return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += Math.ceil(slides[i].swiperSlideSize);
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit('update');
  }
  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }
    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted) return true;

    // Find el
    let el = element || swiper.params.el;
    if (typeof el === 'string') {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        // Children needs to return slot items
        return res;
      }
      return elementChildren(el, getWrapperSelector())[0];
    };
    // Find Wrapper
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = createElement('div', swiper.params.wrapperClass);
      el.append(wrapperEl);
      elementChildren(el, `.${swiper.params.slideClass}`).forEach(slideEl => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || elementStyle(el, 'direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || elementStyle(el, 'direction') === 'rtl'),
      wrongRTL: elementStyle(wrapperEl, 'display') === '-webkit-box'
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit');

    // Set breakpoint
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Add Classes
    swiper.addClasses();

    // Update size
    swiper.updateSize();

    // Update slides
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }

    // Set Grab Cursor
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    // Slide To Initial Slide
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }

    // Create loop
    if (swiper.params.loop) {
      swiper.loopCreate(undefined, true);
    }

    // Attach events
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener('load', e => {
          processLazyPreloader(swiper, e.target);
        });
      }
    });
    preload(swiper);

    // Init Flag
    swiper.initialized = true;
    preload(swiper);

    // Emit
    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }
  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }
    swiper.emit('beforeDestroy');

    // Init Flag
    swiper.initialized = false;

    // Detach events
    swiper.detachEvents();

    // Destroy loop
    if (params.loop) {
      swiper.loopDestroy();
    }

    // Cleanup styles
    if (cleanStyles) {
      swiper.removeClasses();
      if (el && typeof el !== 'string') {
        el.removeAttribute('style');
      }
      if (wrapperEl) {
        wrapperEl.removeAttribute('style');
      }
      if (slides && slides.length) {
        slides.forEach(slideEl => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute('style');
          slideEl.removeAttribute('data-swiper-slide-index');
        });
      }
    }
    swiper.emit('destroy');

    // Detach emitter events
    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      if (swiper.el && typeof swiper.el !== 'string') {
        swiper.el.swiper = null;
      }
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
};
Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);

/* underscore in name -> watch for changes */
const paramsList = ['eventsPrefix', 'injectStyles', 'injectStylesUrls', 'modules', 'init', '_direction', 'oneWayMovement', 'swiperElementNodeName', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', 'breakpointsBase', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_loop', 'loopAdditionalSlides', 'loopAddBlankSlides', 'loopPreventsSliding', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideActiveClass', 'slideVisibleClass', 'slideFullyVisibleClass', 'slideNextClass', 'slidePrevClass', 'slideBlankClass', 'wrapperClass', 'lazyPreloaderClass', 'lazyPreloadPrevNext', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren',
// modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom', 'control'];

function isObject$2(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object' && !o.__swiper__;
}
function extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}
function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}
function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === 'undefined';
}
function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}
function uniqueClasses(classNames = '') {
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}
function wrapperClass(className = '') {
  if (!className) return 'swiper-wrapper';
  if (!className.includes('swiper-wrapper')) return `swiper-wrapper ${className}`;
  return className;
}

function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction' && key !== 'wrapperClass');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  let loopNeedDestroy;
  let loopNeedEnable;
  let loopNeedReloop;
  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && !passedParams.thumbs.swiper.destroyed && currentParams.thumbs && (!currentParams.thumbs.swiper || currentParams.thumbs.swiper.destroyed)) {
    needThumbsInit = true;
  }
  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();
    if (mod === 'navigation') {
      if (swiper.isElement) {
        swiper[mod].prevEl.remove();
        swiper[mod].nextEl.remove();
      }
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      if (swiper.isElement) {
        swiper[mod].el.remove();
      }
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };
  if (changedParams.includes('loop') && swiper.isElement) {
    if (currentParams.loop && !passedParams.loop) {
      loopNeedDestroy = true;
    } else if (!currentParams.loop && passedParams.loop) {
      loopNeedEnable = true;
    } else {
      loopNeedReloop = true;
    }
  }
  updateParams.forEach(key => {
    if (isObject$2(currentParams[key]) && isObject$2(passedParams[key])) {
      Object.assign(currentParams[key], passedParams[key]);
      if ((key === 'navigation' || key === 'pagination' || key === 'scrollbar') && 'enabled' in passedParams[key] && !passedParams[key].enabled) {
        destroyModule(key);
      }
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('virtual') && virtual && currentParams.virtual.enabled) {
    if (slides) virtual.slides = slides;
    virtual.update(true);
  }
  if (changedParams.includes('children') && slides && currentParams.loop) {
    loopNeedReloop = true;
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (swiper.isElement && (!paginationEl || typeof paginationEl === 'string')) {
      paginationEl = document.createElement('div');
      paginationEl.classList.add('swiper-pagination');
      paginationEl.part.add('pagination');
      swiper.el.appendChild(paginationEl);
    }
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === 'string')) {
      scrollbarEl = document.createElement('div');
      scrollbarEl.classList.add('swiper-scrollbar');
      scrollbarEl.part.add('scrollbar');
      swiper.el.appendChild(scrollbarEl);
    }
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (swiper.isElement) {
      if (!nextEl || typeof nextEl === 'string') {
        nextEl = document.createElement('div');
        nextEl.classList.add('swiper-button-next');
        setInnerHTML(nextEl, swiper.hostEl.constructor.nextButtonSvg);
        nextEl.part.add('button-next');
        swiper.el.appendChild(nextEl);
      }
      if (!prevEl || typeof prevEl === 'string') {
        prevEl = document.createElement('div');
        prevEl.classList.add('swiper-button-prev');
        setInnerHTML(prevEl, swiper.hostEl.constructor.prevButtonSvg);
        prevEl.part.add('button-prev');
        swiper.el.appendChild(prevEl);
      }
    }
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }
  if (loopNeedDestroy || loopNeedReloop) {
    swiper.loopDestroy();
  }
  if (loopNeedEnable || loopNeedReloop) {
    swiper.loopCreate();
  }
  swiper.update();
}

function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  extend(params, defaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject$2(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}

function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;
  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };
  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }
  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (isObject$2(swiperParams[key]) && isObject$2(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  swiper.emit('_virtualUpdated');
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};

/**
 * Swiper React 12.0.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 11, 2025
 */


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}
function processChildren(c) {
  const slides = [];
  React.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}
function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const getSlideIndex = index => {
    let slideIndex = index;
    if (index < 0) {
      slideIndex = slides.length + index;
    } else if (slideIndex >= slides.length) {
      // eslint-disable-next-line
      slideIndex = slideIndex - slides.length;
    }
    return slideIndex;
  };
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  const {
    from,
    to
  } = virtualData;
  const loopFrom = swiper.params.loop ? -slides.length : 0;
  const loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
  const slidesToRender = [];
  for (let i = loopFrom; i < loopTo; i += 1) {
    if (i >= from && i <= to) {
      slidesToRender.push(slides[getSlideIndex(i)]);
    }
  }
  return slidesToRender.map((child, index) => {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper,
      style,
      key: child.props.virtualIndex || child.key || `slide-${index}`
    });
  });
}

function useIsomorphicLayoutEffect$1(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}

const SwiperSlideContext = /*#__PURE__*/createContext(null);
const SwiperContext = /*#__PURE__*/createContext(null);
const useSwiper = () => {
  return useContext(SwiperContext);
};

const Swiper = /*#__PURE__*/forwardRef(({
  className,
  tag: Tag = 'div',
  wrapperTag: WrapperTag = 'div',
  children,
  onSwiper,
  ...rest
} = {}, externalElRef) => {
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = useState('swiper');
  const [virtualData, setVirtualData] = useState(null);
  const [breakpointChanged, setBreakpointChanged] = useState(false);
  const initializedRef = useRef(false);
  const swiperElRef = useRef(null);
  const swiperRef = useRef(null);
  const oldPassedParamsRef = useRef(null);
  const oldSlides = useRef(null);
  const nextElRef = useRef(null);
  const prevElRef = useRef(null);
  const paginationElRef = useRef(null);
  const scrollbarElRef = useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });
  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    const passParams = {
      ...swiperParams
    };
    delete passParams.wrapperClass;
    swiperRef.current = new Swiper$1(passParams);
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }

  // Listen for breakpoints change
  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }
  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };
  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };
  useEffect(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  });

  // set initialized flag
  useEffect(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });

  // mount swiper
  useIsomorphicLayoutEffect$1(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current) return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper && !swiperRef.current.destroyed) onSwiper(swiperRef.current);
    // eslint-disable-next-line
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);

  // watch for params change
  useIsomorphicLayoutEffect$1(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents();
    };
  });

  // update on virtual update
  useIsomorphicLayoutEffect$1(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);

  // bypass swiper instance to slides
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    return slides.map((child, index) => {
      return /*#__PURE__*/React.cloneElement(child, {
        swiper: swiperRef.current,
        swiperSlideIndex: index
      });
    });
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/React.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/React.createElement(WrapperTag, {
    className: wrapperClass(swiperParams.wrapperClass)
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';

const SwiperSlide = /*#__PURE__*/forwardRef(({
  tag: Tag = 'div',
  children,
  className = '',
  swiper,
  zoom,
  lazy,
  virtualIndex,
  swiperSlideIndex,
  ...rest
} = {}, externalRef) => {
  const slideElRef = useRef(null);
  const [slideClasses, setSlideClasses] = useState('swiper-slide');
  const [lazyLoaded, setLazyLoaded] = useState(false);
  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }
  useIsomorphicLayoutEffect$1(() => {
    if (typeof swiperSlideIndex !== 'undefined') {
      slideElRef.current.swiperSlideIndex = swiperSlideIndex;
    }
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }
      return;
    }
    swiper.on('_slideClass', updateClasses);
    // eslint-disable-next-line
    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect$1(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0
  };
  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };
  const onLoad = () => {
    setLazyLoaded(true);
  };
  return /*#__PURE__*/React.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex,
    onLoad: onLoad
  }, rest), zoom && /*#__PURE__*/React.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, /*#__PURE__*/React.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/React.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !zoom && /*#__PURE__*/React.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/React.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
SwiperSlide.displayName = 'SwiperSlide';

var a11yMessages = function a11yMessages(moduleName) {
  return {
    enabled: true,
    containerMessage: moduleName,
    firstSlideMessage: "This is the first ".concat(moduleName),
    prevSlideMessage: "Previous ".concat(moduleName),
    nextSlideMessage: "Next ".concat(moduleName),
    paginationBulletMessage: "Go to ".concat(moduleName, " {{index}}"),
    lastSlideMessage: "This is the last ".concat(moduleName),
    slideRole: 'group',
    id: null,
    slideLabelMessage: "".concat(moduleName, " {{index}}/{{slidesLength}}")
  };
};

var css$J = {"breakpoints":"'../../../styling/breakpoints.css'","md":"i__const_md_0","main__wrapper":"Slider-module_main__wrapper__AKbWu","slider__buttons__wrapper":"Slider-module_slider__buttons__wrapper__kYX9O","slider__wrapper":"Slider-module_slider__wrapper__sXYOk","slider__image_wrapper":"Slider-module_slider__image_wrapper__msYy8","slider__image_right":"Slider-module_slider__image_right__2FjF7","slider_slide__wrapper":"Slider-module_slider_slide__wrapper__BnR0P","slider__text_wrapper":"Slider-module_slider__text_wrapper__M7AVP","slider_slide__links":"Slider-module_slider_slide__links__KGUB9","slider__slide_link":"Slider-module_slider__slide_link__q7d6W","linkIconPrimary":"Slider-module_linkIconPrimary__A8-pE","linkIconSecondary":"Slider-module_linkIconSecondary__5Xi6-","arrows":"Slider-module_arrows__TgrhA","arrows__on__orange":"Slider-module_arrows__on__orange__5siAG","arrow__disabled":"Slider-module_arrow__disabled__pE-xj","arrow__left":"Slider-module_arrow__left__Cr3BD","arrow__right":"Slider-module_arrow__right__zlW9I","slider__arrows":"Slider-module_slider__arrows__Hur2s","slider__themed_primary":"Slider-module_slider__themed_primary__dSflz","slider__themed_secondary":"Slider-module_slider__themed_secondary__GOdY8","slider__themed_color1":"Slider-module_slider__themed_color1__5Ik0L","slider__themed_color2":"Slider-module_slider__themed_color2__zvKvE","slider__themed_color3":"Slider-module_slider__themed_color3__O0ljn","pagination_bullet":"Slider-module_pagination_bullet__KAsoX","pagination_bullet_active":"Slider-module_pagination_bullet_active__R2kZk","themed_pagination_bullet_active":"Slider-module_themed_pagination_bullet_active__d9ZBi","slider__themed_primary_font":"Slider-module_slider__themed_primary_font__IMc2I","slider__themed_secondary_font":"Slider-module_slider__themed_secondary_font__1gPkN","slider__themed_color1_font":"Slider-module_slider__themed_color1_font__i2l79","slider__themed_color2_font":"Slider-module_slider__themed_color2_font__5sND0","slider__brackground":"Slider-module_slider__brackground__6u20g"};

var SliderAssetRatio;
(function (SliderAssetRatio) {
  SliderAssetRatio["LARGE"] = "large";
  SliderAssetRatio["MEDIUM"] = "medium";
  SliderAssetRatio["SMALL"] = "small";
  SliderAssetRatio["16_9"] = "169";
})(SliderAssetRatio || (SliderAssetRatio = {}));

var SliderSlides = function SliderSlides(_ref) {
  var imageRight = _ref.imageRight,
    text = _ref.text,
    asset = _ref.asset,
    links = _ref.links,
    caption = _ref.caption,
    variant = _ref.variant,
    _ref$assetRatio = _ref.assetRatio,
    assetRatio = _ref$assetRatio === void 0 ? SliderAssetRatio.LARGE : _ref$assetRatio;
  return /*#__PURE__*/React.createElement(Row, {
    className: "".concat(conditionalClassname(imageRight, css$J.slider__image_right), " ").concat(css$J.slider_slide__wrapper, " ").concat(variant ? getVariantClassName(variant, css$J, ComponentNames.Slider) : '', " ")
  }, asset.length > 0 ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    md: 4,
    className: css$J.slider__image_wrapper
  }, renderAsset({
    asset: asset,
    caption: caption,
    assetRatio: assetRatio,
    componentType: RenderAssetOnComponent.SLIDER
  })), /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement("div", {
    className: css$J.slider__text_wrapper
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    hasAnchor: false,
    content: mappedProps(text.content)
  }))), links.length > 0 && (/*#__PURE__*/React.createElement("menu", {
    className: css$J.slider_slide__links
  }, links.map(function (linkElement, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(index, "_slideLink"),
      className: css$J.slider__slide_link
    }, /*#__PURE__*/React.createElement(RenderButtonType, {
      key: linkElement._uid,
      linkType: linkElement
    }));
  }))))))) : (/*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: css$J.slider__text_wrapper
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    hasAnchor: false,
    content: mappedProps(text.content)
  }))), links.length > 0 && (/*#__PURE__*/React.createElement("menu", {
    className: css$J.slider_slide__links
  }, links.map(function (linkElement, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(index, "_slideLink"),
      className: css$J.slider__slide_link
    }, /*#__PURE__*/React.createElement(RenderButtonType, {
      key: linkElement._uid,
      linkType: linkElement
    }));
  })))))));
};
var SliderArrow = function SliderArrow(_ref2) {
  var direction = _ref2.direction,
    disabled = _ref2.disabled,
    className = _ref2.className,
    clickHandler = _ref2.clickHandler,
    _ref2$onOrangeBackgro = _ref2.onOrangeBackground,
    onOrangeBackground = _ref2$onOrangeBackgro === void 0 ? false : _ref2$onOrangeBackgro,
    variant = _ref2.variant;
  return /*#__PURE__*/React.createElement("svg", {
    onClick: clickHandler,
    className: "".concat(className ? className : '', " ").concat(css$J.arrows, " ").concat(direction === 'left' ? css$J.arrow__left : css$J.arrow__right, " ").concat(conditionalClassname(!!disabled, css$J.arrow__disabled), " ").concat(onOrangeBackground ? css$J.arrows__on__orange : '', " ").concat(variant ? getVariantClassName(variant, css$J, ComponentNames.Slider) : '', "\n    "),
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4991_3811)"
  }, direction === 'left' ? (/*#__PURE__*/React.createElement("path", {
    d: "M28.825 35L31.175 32.65L23.5417 25L31.175 17.35L28.825 15L18.825 25L28.825 35Z"
  })) : (/*#__PURE__*/React.createElement("path", {
    d: "M21.175 15L18.825 17.35L26.4583 25L18.825 32.65L21.175 35L31.175 25L21.175 15Z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(13 13)"
  })));
};

var css$I = {"homepage_carousel_headline":"HomepageCarousel-module_homepage_carousel_headline__aKBbZ","carousel_arrows__wrapper":"HomepageCarousel-module_carousel_arrows__wrapper__tdZRY","overlay":"HomepageCarousel-module_overlay__4h-WL","carousel_image__wrapper":"HomepageCarousel-module_carousel_image__wrapper__dFudF","carousel_image":"HomepageCarousel-module_carousel_image__YrtvK","carousel_subtitle":"HomepageCarousel-module_carousel_subtitle__vRDxj","carousel_subtitle_headline":"HomepageCarousel-module_carousel_subtitle_headline__DklhL","pagination_bullet":"HomepageCarousel-module_pagination_bullet__hvWT2","pagination_bullet_active":"HomepageCarousel-module_pagination_bullet_active__CXJtb","carousel__image_large":"HomepageCarousel-module_carousel__image_large__QLztY","carousel__image_medium":"HomepageCarousel-module_carousel__image_medium__nVPN7","carousel__image_small":"HomepageCarousel-module_carousel__image_small__bZqzx","carousel__wrapper":"HomepageCarousel-module_carousel__wrapper__mGTFH"};

var CarouselElement = function CarouselElement(_ref) {
  var headline = _ref.headline,
    image = _ref.image,
    link = _ref.link,
    assetRatio = _ref.assetRatio,
    title = _ref.title;
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var linkProps = Object.assign(Object.assign({}, link), {
    link: Object.assign({}, linkPropsMapper({
      link: link
    })),
    story: link.story || {}
  });
  return /*#__PURE__*/React.createElement("div", {
    className: css$I.carousel_element__wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$I.carousel_image__wrapper, " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === PageIntroImageHeight.LARGE, css$I.carousel__image_large), conditionalClassname(assetRatio === PageIntroImageHeight.MEDIUM, css$I.carousel__image_medium), conditionalClassname(assetRatio === PageIntroImageHeight.SMALL, css$I.carousel__image_small)))
  }, /*#__PURE__*/React.createElement(Image, {
    src: generateImageSrc((_a = image === null || image === void 0 ? void 0 : image[0]) === null || _a === void 0 ? void 0 : _a.image),
    className: css$I.carousel_image,
    alt: ((_b = image[0]) === null || _b === void 0 ? void 0 : _b.alt_text) || '',
    imageSizes: sizes$1[assetRatio || 'large'],
    sizes: "(max-width: 344px) 33vw, (max-width: 719px) 50vw, (max-width: 939px) 70vw, 1200px",
    copyrightText: (_c = image[0]) === null || _c === void 0 ? void 0 : _c.copyright,
    priority: true
  })), /*#__PURE__*/React.createElement("div", {
    className: css$I.carousel_subtitle
  }, /*#__PURE__*/React.createElement(Headline, {
    className: css$I.carousel_subtitle_headline,
    tag: HeadlineTags.H2
  }, headline), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(LinkIcon, {
    className: css$I.link_icon
  }), /*#__PURE__*/React.createElement(Link, {
    href: (_d = linkProps === null || linkProps === void 0 ? void 0 : linkProps.link) === null || _d === void 0 ? void 0 : _d.href,
    title: (_e = linkProps === null || linkProps === void 0 ? void 0 : linkProps.story) === null || _e === void 0 ? void 0 : _e.name,
    target: linkProps === null || linkProps === void 0 ? void 0 : linkProps.target,
    variant: LinkVariant.Primary,
    piwik_click_id: (_f = linkProps === null || linkProps === void 0 ? void 0 : linkProps.link) === null || _f === void 0 ? void 0 : _f.piwik_click_id,
    anchor: (_g = linkProps === null || linkProps === void 0 ? void 0 : linkProps.link) === null || _g === void 0 ? void 0 : _g.anchor
  }, title || ((_h = linkProps === null || linkProps === void 0 ? void 0 : linkProps.story) === null || _h === void 0 ? void 0 : _h.name) || ''))));
};

var HomepageCarousel = function HomepageCarousel(_ref) {
  var asset_ratio = _ref.asset_ratio,
    carousel_elements = _ref.carousel_elements,
    headline = _ref.headline;
  var _a, _b, _c, _d, _e;
  var _useState = useState({
      isStartSlide: true,
      isLastSlide: false
    }),
    disable = _useState[0],
    setSliderArrowState = _useState[1];
  var swiperRef = useRef();
  var a11yData = a11yMessages('Carousel');
  var imageHeight = getImageHeightFromAspectRatio({
    imageHeight: [234, 292, 390],
    assetRatio: asset_ratio
  });
  return /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: css$I.homepage_carousel_headline
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H1
  }, headline)), carousel_elements && ((_a = carousel_elements[0]) === null || _a === void 0 ? void 0 : _a.images) ? (/*#__PURE__*/React.createElement(Col, {
    xs: 12,
    className: css$I.carousel_element__wrapper
  }, /*#__PURE__*/React.createElement(Swiper, {
    className: "".concat(css$I.carousel__wrapper, " carousel__swiper"),
    onSlideChange: function onSlideChange(swiper) {
      setSliderArrowState({
        isLastSlide: swiper.isEnd,
        isStartSlide: swiper.isBeginning
      });
    },
    autoplay: {
      pauseOnMouseEnter: true,
      delay: 2500
    },
    slidesPerView: 1,
    onBeforeInit: function onBeforeInit(swiper) {
      swiperRef.current = swiper;
    },
    modules: [Autoplay, Pagination, A11y],
    pagination: {
      clickable: true,
      bulletClass: "".concat(css$I.pagination_bullet),
      bulletActiveClass: "".concat(css$I.pagination_bullet_active)
    },
    a11y: a11yData
  }, (_c = (_b = carousel_elements[0]) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.map(function (slide) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: "".concat(slide._uid, "_slide")
    }, /*#__PURE__*/React.createElement(CarouselElement, {
      _uid: slide._uid,
      headline: slide.headline,
      image: slide.image,
      assetRatio: asset_ratio,
      link: slide.link,
      title: slide.title
    }), /*#__PURE__*/React.createElement("div", {
      className: css$I.overlay
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: css$I.carousel_arrows__wrapper
  }, /*#__PURE__*/React.createElement(SliderArrow, {
    className: "".concat(css$I.slider__arrows, " "),
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    },
    direction: "left",
    disabled: disable === null || disable === void 0 ? void 0 : disable.isStartSlide
  }), /*#__PURE__*/React.createElement(SliderArrow, {
    className: css$I.slider__arrows,
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    },
    direction: "right",
    disabled: disable === null || disable === void 0 ? void 0 : disable.isLastSlide
  }))))) : (/*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(MoodVideo, {
    assetRatio: asset_ratio,
    imageHeight: imageHeight,
    video: (_d = carousel_elements[0]) === null || _d === void 0 ? void 0 : _d.video,
    fallback_image: (_e = carousel_elements[0]) === null || _e === void 0 ? void 0 : _e.fallback_image
  })))));
};

var ScreenWidthTypes;
(function (ScreenWidthTypes) {
  ScreenWidthTypes["MEDIUM"] = "md";
  ScreenWidthTypes["LARGE"] = "lg";
  ScreenWidthTypes["XLARGE"] = "xl";
})(ScreenWidthTypes || (ScreenWidthTypes = {}));
var ScreenWidthSizes;
(function (ScreenWidthSizes) {
  ScreenWidthSizes[ScreenWidthSizes["MEDIUM"] = 720] = "MEDIUM";
  ScreenWidthSizes[ScreenWidthSizes["LARGE"] = 940] = "LARGE";
  ScreenWidthSizes[ScreenWidthSizes["XLARGE"] = 1200] = "XLARGE";
})(ScreenWidthSizes || (ScreenWidthSizes = {}));

var css$H = {"category_list__wrapper":"HomepageProductOverview-module_category_list__wrapper__tvcfT","category_tile__wrapper":"HomepageProductOverview-module_category_tile__wrapper__O1Djh","sub_category_list__wrapper":"HomepageProductOverview-module_sub_category_list__wrapper__5-78C","sub_category_tile__wrapper":"HomepageProductOverview-module_sub_category_tile__wrapper__QazSF","sub_category_tile":"HomepageProductOverview-module_sub_category_tile__3xPwt","sub_category_tile_text":"HomepageProductOverview-module_sub_category_tile_text__eNCDY","sub_category_image":"HomepageProductOverview-module_sub_category_image__FXF33","active_sub_category":"HomepageProductOverview-module_active_sub_category__zLVUI","inactive_sub_category":"HomepageProductOverview-module_inactive_sub_category__cfVKv","ribbon_wrapper":"HomepageProductOverview-module_ribbon_wrapper__Svr7f","sub_category_section":"HomepageProductOverview-module_sub_category_section__ZZuKV","category_image__wrapper":"HomepageProductOverview-module_category_image__wrapper__x2Dc-","category_image":"HomepageProductOverview-module_category_image__IGsnw","category_title":"HomepageProductOverview-module_category_title__JAeGp","active_category":"HomepageProductOverview-module_active_category__2KYeg"};

var getHeightProperties = function getHeightProperties(width) {
  var properties = new Map();
  properties.set(ScreenWidthTypes.LARGE, {
    columns: 5,
    rowHeight: 145
  });
  properties.set(ScreenWidthTypes.XLARGE, {
    columns: 7,
    rowHeight: 160
  });
  return properties.get(width);
};
var categoryImageSize = [{
  width: 62,
  height: 116
}];
var subCategoryImageSize = [{
  width: 192,
  height: 64
}, {
  width: 158,
  height: 53
}, {
  width: 146,
  height: 49
}, {
  width: 210,
  height: 84
}];

var ProductCategoryTile = function ProductCategoryTile(_ref) {
  var _uid = _ref._uid,
    active = _ref.active,
    image = _ref.image,
    sub_categories = _ref.sub_categories,
    title = _ref.title,
    onHover = _ref.onHover,
    onToggle = _ref.onToggle,
    onLeave = _ref.onLeave,
    isDesktop = _ref.isDesktop,
    imagePriority = _ref.imagePriority;
  var _a, _b, _c;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    onMouseLeave: function onMouseLeave() {
      return onLeave();
    },
    onMouseOver: function onMouseOver() {
      return onHover();
    },
    className: "".concat(css$H.category_tile__wrapper, " ").concat(conditionalClassname(active, "".concat(css$H.active_category))),
    onClick: function onClick() {
      return onToggle(_uid);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: css$H.category_title
  }, title), /*#__PURE__*/React.createElement("span", {
    className: css$H.category_image__wrapper
  }, isDesktop && ((_a = image === null || image === void 0 ? void 0 : image[0]) === null || _a === void 0 ? void 0 : _a.image) ? (/*#__PURE__*/React.createElement(Image, {
    src: generateImageSrc((_b = image === null || image === void 0 ? void 0 : image[0]) === null || _b === void 0 ? void 0 : _b.image),
    alt: ((_c = image[0]) === null || _c === void 0 ? void 0 : _c.alt_text) || '',
    imageSizes: categoryImageSize,
    className: css$H.category_image,
    priority: imagePriority
  })) : (/*#__PURE__*/React.createElement(ChevronIcon, {
    direction: active ? ChevronDirection.Up : ChevronDirection.Down,
    key: _uid
  })))), !isDesktop && (/*#__PURE__*/React.createElement(Row, {
    className: active ? css$H.active_sub_category : css$H.inactive_sub_category
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("ul", {
    className: css$H.sub_category_list__wrapper
  }, sub_categories.map(function (subCategory) {
    return /*#__PURE__*/React.createElement(ProductSubCategoryTile, Object.assign({
      key: subCategory._uid
    }, subCategory, {
      imagePriority: imagePriority
    }));
  }))))));
};
var ProductSubCategoryTile = function ProductSubCategoryTile(_ref2) {
  var image = _ref2.image,
    link = _ref2.link,
    title = _ref2.title,
    ribbon = _ref2.ribbon,
    imagePriority = _ref2.imagePriority;
  var _a, _b;
  return /*#__PURE__*/React.createElement("li", {
    className: css$H.sub_category_tile__wrapper
  }, ribbon && /*#__PURE__*/React.createElement("span", {
    className: css$H.ribbon_wrapper
  }, ribbon), /*#__PURE__*/React.createElement(Link, {
    className: css$H.sub_category_tile,
    title: title,
    variant: LinkVariant.Tertiary,
    href: (link === null || link === void 0 ? void 0 : link.cached_url) || '',
    target: TargetValues.Self
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
    src: generateImageSrc((_a = image === null || image === void 0 ? void 0 : image[0]) === null || _a === void 0 ? void 0 : _a.image),
    alt: ((_b = image[0]) === null || _b === void 0 ? void 0 : _b.alt_text) || '',
    imageSizes: subCategoryImageSize,
    className: css$H.sub_category_image,
    priority: imagePriority
  }), /*#__PURE__*/React.createElement("p", {
    className: css$H.sub_category_tile_text
  }, title))));
};

var HomepageProductOverview = function HomepageProductOverview(_ref) {
  var product_categories = _ref.product_categories,
    text = _ref.text,
    imagePriority = _ref.imagePriority;
  var _a, _b;
  var _useState = useState(true),
    desktop = _useState[0],
    setDesktop = _useState[1];
  var _useState2 = useState({
      columns: 5,
      rowHeight: 145
    }),
    heightProperties = _useState2[0],
    setHeightProperties = _useState2[1];
  var firstProductCategory = ((_a = product_categories[0]) === null || _a === void 0 ? void 0 : _a._uid) || '';
  var _useState3 = useState({
      current: firstProductCategory,
      previous: ''
    }),
    activeCategory = _useState3[0],
    setActiveCategory = _useState3[1];
  var _useState4 = useState(((_b = product_categories[0]) === null || _b === void 0 ? void 0 : _b.sub_categories) || []),
    activeSubCategory = _useState4[0],
    setActiveSubCategory = _useState4[1];
  var handleCategorySwitch = function handleCategorySwitch(key) {
    var activeSubCategory = product_categories.find(function (cat) {
      return cat._uid === key;
    });
    setActiveSubCategory(activeSubCategory ? activeSubCategory.sub_categories : []);
  };
  var handleToggle = function handleToggle(key) {
    if (desktop) {
      handleCategorySwitch(key);
      setActiveCategory({
        current: key,
        previous: key
      });
    } else {
      setActiveCategory({
        current: activeCategory.current !== key ? key : '',
        previous: key
      });
    }
  };
  var handleHover = function handleHover() {
    if (desktop) {
      setActiveCategory({
        current: '',
        previous: activeCategory.previous ? activeCategory.previous : activeCategory.current
      });
    }
  };
  var handleActiveCategoryReset = function handleActiveCategoryReset() {
    if (desktop) setActiveCategory({
      current: activeCategory.previous
    });
  };
  var handleResize = function handleResize() {
    setDesktop(window.innerWidth >= ScreenWidthSizes.LARGE);
    if (window.innerWidth >= ScreenWidthSizes.XLARGE) {
      setHeightProperties(getHeightProperties(ScreenWidthTypes.XLARGE));
    }
  };
  var getSubcategoryHeight = function getSubcategoryHeight() {
    var hasEqualHeights = product_categories.every(function (subCategory) {
      var _a;
      return subCategory.sub_categories.length === ((_a = product_categories[0]) === null || _a === void 0 ? void 0 : _a.sub_categories.length);
    });
    if (!hasEqualHeights) {
      var highestLength = Math.max.apply(Math, _toConsumableArray(product_categories.map(function (subCategories) {
        return subCategories.sub_categories.length;
      })));
      return {
        height: "".concat(Math.ceil(highestLength / heightProperties.columns) * heightProperties.rowHeight, "px")
      };
    }
    return {};
  };
  useEffect(function () {
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [desktop]);
  return /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(Row, null, hasTextContent(text) && (/*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  }))), /*#__PURE__*/React.createElement(Col, {
    className: css$H.category_list__wrapper
  }, product_categories === null || product_categories === void 0 ? void 0 : product_categories.map(function (category) {
    return /*#__PURE__*/React.createElement(ProductCategoryTile, {
      isDesktop: desktop,
      key: category._uid,
      active: activeCategory.current === category._uid,
      onLeave: function onLeave() {
        return handleActiveCategoryReset();
      },
      onHover: function onHover() {
        return handleHover();
      },
      onToggle: function onToggle() {
        return handleToggle(category._uid);
      },
      sub_categories: category.sub_categories,
      title: category.title,
      _uid: category._uid,
      image: category.image,
      imagePriority: imagePriority
    });
  })), desktop && (/*#__PURE__*/React.createElement(Col, {
    className: css$H.sub_category_section,
    style: Object.assign({}, getSubcategoryHeight())
  }, /*#__PURE__*/React.createElement("ul", {
    className: css$H.sub_category_list__wrapper
  }, activeSubCategory === null || activeSubCategory === void 0 ? void 0 : activeSubCategory.map(function (subCategory) {
    return /*#__PURE__*/React.createElement(ProductSubCategoryTile, Object.assign({
      key: subCategory._uid
    }, subCategory, {
      imagePriority: imagePriority
    }));
  }))))));
};

var imageSizes = {
  teaser: {
    sizes: '(max-width: 370px) 42vw, (max-width: 574px) 45vw, (max-width: 939px) 47vw, 263px'
  },
  center: {
    sizes: '(max-width: 719px) 90vw, (max-width: 1200px) 45vw, 570px'
  }
};
var centerImageSizes = [{
  width: 320,
  height: 213
}, {
  width: 450,
  height: 300
}, {
  width: 570,
  height: 380
}, {
  width: 680,
  height: 453
}];
var teaserImageSizes = [{
  width: 879,
  height: 96
}, {
  width: 659,
  height: 96
}, {
  width: 475,
  height: 96
}, {
  width: 285,
  height: 96
}, {
  width: 263,
  height: 96
}];

var css$G = {"breakpoints":"'../../../styling/breakpoints.css'","md":"i__const_md_0","lg":"i__const_lg_1","xl":"i__const_xl_2","wrapper":"HomepageTeaserCompilation-module_wrapper__rl22A","teaser":"HomepageTeaserCompilation-module_teaser__vGW3A","teaserWidth_small":"HomepageTeaserCompilation-module_teaserWidth_small__-vtcj","teaserWidth_large":"HomepageTeaserCompilation-module_teaserWidth_large__B83JE","teaserHeight":"HomepageTeaserCompilation-module_teaserHeight__DvW3A","teaser_title":"HomepageTeaserCompilation-module_teaser_title__WHjP8","homepageTeaserCompilation__themed_primary":"HomepageTeaserCompilation-module_homepageTeaserCompilation__themed_primary__T3jjJ","centerWrapper_withImage__container":"HomepageTeaserCompilation-module_centerWrapper_withImage__container__ESYAk","homepageTeaserCompilation__themed_secondary":"HomepageTeaserCompilation-module_homepageTeaserCompilation__themed_secondary__g76w9","homepageTeaserCompilation__themed_color1":"HomepageTeaserCompilation-module_homepageTeaserCompilation__themed_color1__iV17W","homepageTeaserCompilation__themed_color2":"HomepageTeaserCompilation-module_homepageTeaserCompilation__themed_color2__jObMO","link":"HomepageTeaserCompilation-module_link__0cz8B","teaser_withIcon":"HomepageTeaserCompilation-module_teaser_withIcon__kUmll","teaserIcon_wrapper":"HomepageTeaserCompilation-module_teaserIcon_wrapper__3Q2FN","teaserIcon_container":"HomepageTeaserCompilation-module_teaserIcon_container__9-gJ9","teaserImage__wrapper_large":"HomepageTeaserCompilation-module_teaserImage__wrapper_large__E7r44","teaserImage_wrapper":"HomepageTeaserCompilation-module_teaserImage_wrapper__M8HY6","teaser_withImage":"HomepageTeaserCompilation-module_teaser_withImage__guLol","centerWrapper_withIframe":"HomepageTeaserCompilation-module_centerWrapper_withIframe__2im1n","centerWrapper_withImage":"HomepageTeaserCompilation-module_centerWrapper_withImage__OLIJf","center__image_wrapper":"HomepageTeaserCompilation-module_center__image_wrapper__Ti-qR","center__iframe_container_with_teaser":"HomepageTeaserCompilation-module_center__iframe_container_with_teaser__dnZ0S","center__iframe_wrapper_with_teaser":"HomepageTeaserCompilation-module_center__iframe_wrapper_with_teaser__DfOAR","teaser_icon":"HomepageTeaserCompilation-module_teaser_icon__MKve6","teaser_image":"HomepageTeaserCompilation-module_teaser_image__gOqOa","center__image":"HomepageTeaserCompilation-module_center__image__GqsqL","teaser_left":"HomepageTeaserCompilation-module_teaser_left__0bLIt","teaser_right":"HomepageTeaserCompilation-module_teaser_right__ta5OA","center":"HomepageTeaserCompilation-module_center__Vayo2","center__iframe_wrapper":"HomepageTeaserCompilation-module_center__iframe_wrapper__4udaC","centerWrapper_width":"HomepageTeaserCompilation-module_centerWrapper_width__9LIha","center_iframe":"HomepageTeaserCompilation-module_center_iframe__wdEcA","center_teaser":"HomepageTeaserCompilation-module_center_teaser__J6Mfw","teaser_content":"HomepageTeaserCompilation-module_teaser_content__qmHho","homepage__icon__font":"HomepageTeaserCompilation-module_homepage__icon__font__MKlvp","center770":"HomepageTeaserCompilation-module_center770__TgKb-","center570":"HomepageTeaserCompilation-module_center570__qVIYJ","wrapper_small":"HomepageTeaserCompilation-module_wrapper_small__Amk7G","wrapper_large":"HomepageTeaserCompilation-module_wrapper_large__8qkJE","centerWrapper_withImage__container_height_545":"HomepageTeaserCompilation-module_centerWrapper_withImage__container_height_545__J7T3m","teaser_text":"HomepageTeaserCompilation-module_teaser_text__ADpCR","teaser__center_height":"HomepageTeaserCompilation-module_teaser__center_height__bW8m6","custom__link__wrapper":"HomepageTeaserCompilation-module_custom__link__wrapper__gF9em","headline__wrapper":"HomepageTeaserCompilation-module_headline__wrapper__xdpY5","headline_text":"HomepageTeaserCompilation-module_headline_text__qAzkG"};

var TeaserCompilationCenterComponent;
(function (TeaserCompilationCenterComponent) {
  TeaserCompilationCenterComponent["Iframe"] = "homepage_iframe";
  TeaserCompilationCenterComponent["ImageCenter"] = "homepage_image_center";
})(TeaserCompilationCenterComponent || (TeaserCompilationCenterComponent = {}));
var HomepageTeaserVariants;
(function (HomepageTeaserVariants) {
  HomepageTeaserVariants["ICON"] = "homepage_teaser_icon_text";
  HomepageTeaserVariants["IMAGE"] = "homepage_teaser_image_text";
})(HomepageTeaserVariants || (HomepageTeaserVariants = {}));

var IconTeaser = function IconTeaser(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    text = _ref.text,
    _uid = _ref._uid,
    _ref$isCenter = _ref.isCenter,
    isCenter = _ref$isCenter === void 0 ? false : _ref$isCenter,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? false : _ref$view,
    background_color = _ref.background_color,
    link = _ref.link,
    imagePriority = _ref.imagePriority;
  var _a;
  var linkProps = linkPropsMapper({
    link: link
  });
  var iconSizes = [{
    width: 48,
    height: 48
  }];
  var content = /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$G.teaser, " ").concat(background_color ? getVariantClassName(background_color, css$G, ComponentNames.HomepageTeaserCompilation) : '', " ").concat(css$G.teaser_withIcon, " ").concat(conditionalClassname(isCenter, css$G.teaserHeight), " ").concat(conditionalClassname(!view && isCenter, css$G.teaserWidth_large), " ").concat(conditionalClassname(isCenter, css$G.teaserWidth_small), " ").concat(conditionalClassname(!isCenter, css$G.teaser__center_height))
  }, /*#__PURE__*/React.createElement("div", {
    className: css$G.teaser_content
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "".concat(conditionalClassname(isCenter && view, css$G.teaser_text))
  }, text)), icon && (hasAssetData(icon, MediaType.IMAGE) || ((_a = icon[0]) === null || _a === void 0 ? void 0 : _a.component) === 'icon_atom') && icon.map(function (icon, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(_uid, "-").concat(index),
      className: css$G.teaserIcon_wrapper
    }, /*#__PURE__*/React.createElement("span", {
      className: css$G.teaserIcon_container
    }, (icon === null || icon === void 0 ? void 0 : icon.component) === 'icon_atom' && icon.icon ? (/*#__PURE__*/React.createElement(IconFont, {
      icon: icon.icon,
      className: "".concat(css$G.homepage__icon__font)
    })) : (/*#__PURE__*/React.createElement(Image, {
      src: generateImageSrc(icon === null || icon === void 0 ? void 0 : icon.image),
      imageSizes: iconSizes,
      alt: icon.alt_text,
      className: css$G.teaser_icon,
      priority: imagePriority
    }))));
  }));
  return link ? (/*#__PURE__*/React.createElement(Link, {
    href: linkProps.href,
    title: linkProps.title,
    target: linkProps.target,
    external: (linkProps === null || linkProps === void 0 ? void 0 : linkProps.external) || true,
    showExternalIcon: false,
    variant: linkProps.variant,
    className: css$G.link,
    piwik_click_id: linkProps === null || linkProps === void 0 ? void 0 : linkProps.piwik_click_id,
    anchor: linkProps === null || linkProps === void 0 ? void 0 : linkProps.anchor
  }, content)) : content;
};
var ImageTeaser = function ImageTeaser(_ref2) {
  var image = _ref2.image,
    title = _ref2.title,
    text = _ref2.text,
    _uid = _ref2._uid,
    _ref2$isCenter = _ref2.isCenter,
    isCenter = _ref2$isCenter === void 0 ? false : _ref2$isCenter,
    _ref2$view = _ref2.view,
    view = _ref2$view === void 0 ? false : _ref2$view,
    background_color = _ref2.background_color,
    link = _ref2.link,
    imagePriority = _ref2.imagePriority;
  var linkProps = linkPropsMapper({
    link: link
  });
  var content = /*#__PURE__*/React.createElement("div", {
    className: "".concat(conditionalClassname(isCenter, css$G.teaserHeight), " ").concat(conditionalClassname(!view && isCenter, css$G.teaserWidth_large), " ").concat(conditionalClassname(isCenter, css$G.teaserWidth_small), " ").concat(css$G.teaser, " ").concat(background_color ? getVariantClassName(background_color, css$G, ComponentNames.HomepageTeaserCompilation) : '', " ").concat(css$G.teaser_withImage)
  }, image && hasAssetData(image, MediaType.IMAGE) && (image === null || image === void 0 ? void 0 : image.map(function (image, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(_uid, "-").concat(index),
      className: "".concat(css$G.teaserImage_wrapper, " ").concat(conditionalClassname(!view, css$G.teaserImage__wrapper_large))
    }, /*#__PURE__*/React.createElement(Image, {
      src: generateImageSrc(image === null || image === void 0 ? void 0 : image.image),
      alt: image.alt_text,
      imageSizes: teaserImageSizes,
      sizes: imageSizes.teaser.sizes,
      className: css$G.teaser_image,
      priority: imagePriority
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: css$G.teaser_content
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "".concat(conditionalClassname(isCenter && view || !view, css$G.teaser_text))
  }, text)));
  return link ? (/*#__PURE__*/React.createElement(Link, {
    href: linkProps.href,
    title: linkProps.title,
    target: linkProps.target,
    external: (linkProps === null || linkProps === void 0 ? void 0 : linkProps.external) || true,
    showExternalIcon: false,
    variant: linkProps.variant,
    className: css$G.link,
    piwik_click_id: linkProps === null || linkProps === void 0 ? void 0 : linkProps.piwik_click_id,
    anchor: linkProps === null || linkProps === void 0 ? void 0 : linkProps.anchor
  }, content)) : content;
};
var COMPONENTS = _defineProperty(_defineProperty({}, HomepageTeaserVariants.ICON, IconTeaser), HomepageTeaserVariants.IMAGE, ImageTeaser);
var HomepageTeaser = function HomepageTeaser(props) {
  var Component = COMPONENTS[props.component] || /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props));
};

var HomepageIframe = function HomepageIframe(_ref) {
  var iframe_link = _ref.iframe_link,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? false : _ref$view,
    link = _ref.link,
    iframeHeadLine = _ref.iframeHeadLine;
  var linkProps = linkPropsMapper({
    name: link.title,
    link: link.link
  });
  var homepageTeaserIframeCustomLink = Object.assign(Object.assign({}, linkProps), {
    href: link.cached_url,
    rel: link.rel
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$G.centerWrapper_withIframe, " ").concat(conditionalClassname(!view, css$G.centerWrapper_width), " ").concat(css$G.center__iframe_wrapper)
  }, iframeHeadLine && (/*#__PURE__*/React.createElement("div", {
    className: css$G.headline__wrapper
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4,
    className: css$G.headline_text
  }, iframeHeadLine))), /*#__PURE__*/React.createElement("iframe", {
    title: iframe_link || 'iframe',
    src: iframe_link,
    className: css$G.center_iframe
  }), homepageTeaserIframeCustomLink.title && (/*#__PURE__*/React.createElement("div", {
    className: css$G.custom__link__wrapper
  }, /*#__PURE__*/React.createElement(LinkIcon, null), /*#__PURE__*/React.createElement(Link, {
    href: homepageTeaserIframeCustomLink.href,
    title: homepageTeaserIframeCustomLink.title,
    target: homepageTeaserIframeCustomLink.target,
    external: homepageTeaserIframeCustomLink.external,
    showExternalIcon: false,
    variant: homepageTeaserIframeCustomLink.variant,
    piwik_click_id: homepageTeaserIframeCustomLink === null || homepageTeaserIframeCustomLink === void 0 ? void 0 : homepageTeaserIframeCustomLink.piwik_click_id,
    anchor: homepageTeaserIframeCustomLink === null || homepageTeaserIframeCustomLink === void 0 ? void 0 : homepageTeaserIframeCustomLink.anchor
  }, homepageTeaserIframeCustomLink.title))));
};
var HomepageImageCenter = function HomepageImageCenter(_ref2) {
  var teaser = _ref2.teaser,
    center_image = _ref2.center_image,
    _ref2$view = _ref2.view,
    view = _ref2$view === void 0 ? false : _ref2$view,
    iframe_height = _ref2.iframe_height,
    imagePriority = _ref2.imagePriority;
  var _a, _b;
  var link = (_a = teaser[0]) === null || _a === void 0 ? void 0 : _a.link;
  var linkProps = linkPropsMapper({
    link: link
  });
  var homepageImageCenterCustomLink = Object.assign(Object.assign({}, linkProps), {
    title: (_b = teaser[0]) === null || _b === void 0 ? void 0 : _b.link.title
  });
  return /*#__PURE__*/React.createElement("div", {
    className: css$G.centerWrapper_withImage
  }, center_image && center_image.length > 0 && center_image.map(function (image, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(image._uid, "-").concat(index),
      className: "".concat(image.image ? css$G.centerWrapper_withImage__container : css$G.center__iframe_container_with_teaser, " ").concat(image.background ? getVariantClassName(image.background, css$G, ComponentNames.HomepageTeaserCompilation) : '', " ").concat(!view ? css$G.centerWrapper_withImage__container_height_545 : '')
    }, image.image && hasAssetData(image.image, MediaType.IMAGE) && image.image.map(function (image, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(image.image ? css$G.center__image_wrapper : '')
      }, /*#__PURE__*/React.createElement(Image, {
        key: "".concat(image._uid, "-").concat(index),
        src: generateImageSrc(image === null || image === void 0 ? void 0 : image.image),
        alt: image.alt_text,
        imageSizes: centerImageSizes,
        sizes: imageSizes.center.sizes,
        className: css$G.center__image,
        priority: imagePriority
      }));
    }), image.iframe_link && (/*#__PURE__*/React.createElement("div", {
      style: {
        height: "".concat(iframe_height, "px")
      },
      className: css$G.center__iframe_wrapper_with_teaser
    }, /*#__PURE__*/React.createElement("iframe", {
      title: image.iframe_link || 'iframe',
      src: image.iframe_link,
      className: css$G.center_iframe
    }))));
  }), teaser && teaser.length > 0 && teaser.map(function (teaserItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(teaserItem._uid, "-").concat(index),
      className: css$G.center_teaser
    }, /*#__PURE__*/React.createElement(HomepageTeaser, Object.assign({}, teaserItem, {
      imagePriority: imagePriority
    })));
  }), homepageImageCenterCustomLink.title && (/*#__PURE__*/React.createElement("div", {
    className: css$G.custom__link__wrapper
  }, /*#__PURE__*/React.createElement(LinkIcon, null), /*#__PURE__*/React.createElement(Link, {
    href: homepageImageCenterCustomLink.href,
    title: homepageImageCenterCustomLink.title,
    target: homepageImageCenterCustomLink.target,
    external: homepageImageCenterCustomLink.external,
    showExternalIcon: false,
    variant: homepageImageCenterCustomLink.variant,
    piwik_click_id: homepageImageCenterCustomLink === null || homepageImageCenterCustomLink === void 0 ? void 0 : homepageImageCenterCustomLink.piwik_click_id,
    anchor: homepageImageCenterCustomLink === null || homepageImageCenterCustomLink === void 0 ? void 0 : homepageImageCenterCustomLink.anchor
  }, homepageImageCenterCustomLink.title))));
};
var HomepageTeaserCenter = function HomepageTeaserCenter(props) {
  var componentName = (props === null || props === void 0 ? void 0 : props.component) || '';
  if (componentName === '') {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  if (componentName === TeaserCompilationCenterComponent.ImageCenter) {
    return /*#__PURE__*/React.createElement(HomepageImageCenter, Object.assign({}, props));
  }
  return /*#__PURE__*/React.createElement(HomepageIframe, Object.assign({}, props));
};

var HomepageTeaserCompilation = function HomepageTeaserCompilation(_ref) {
  var teaser_left = _ref.teaser_left,
    teaser_right = _ref.teaser_right,
    text = _ref.text,
    iframe_or_image = _ref.iframe_or_image,
    view = _ref.view,
    iframeHeadLine = _ref.iframeHeadLine,
    imagePriority = _ref.imagePriority;
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, text && hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$G.wrapper, " ").concat(view ? css$G.wrapper_small : css$G.wrapper_large)
  }, view && (/*#__PURE__*/React.createElement(Col, {
    lg: 3,
    className: css$G.teaser_left
  }, teaser_left.map(function (teaser) {
    return /*#__PURE__*/React.createElement(HomepageTeaser, Object.assign({
      key: teaser._uid,
      isCenter: true,
      view: view
    }, teaser, {
      imagePriority: imagePriority
    }));
  }))), /*#__PURE__*/React.createElement(Col, {
    className: "".concat(css$G.center, " ").concat(!view ? css$G.center770 : css$G.center570, " ")
  }, /*#__PURE__*/React.createElement(HomepageTeaserCenter, Object.assign({}, iframe_or_image[0], {
    view: view,
    iframeHeadLine: iframeHeadLine,
    imagePriority: imagePriority
  }))), /*#__PURE__*/React.createElement(Col, {
    lg: 3,
    className: css$G.teaser_right
  }, teaser_right.map(function (teaser) {
    return /*#__PURE__*/React.createElement(HomepageTeaser, Object.assign({
      key: teaser._uid,
      isCenter: true,
      view: view,
      imagePriority: imagePriority
    }, teaser));
  })))));
};

var css$F = {"icons__wrapper":"IconLinks-module_icons__wrapper__SwS7l","iconLinks__wrapper":"IconLinks-module_iconLinks__wrapper__vZx5s","iconLinks__link":"IconLinks-module_iconLinks__link__Meb9-","iconLinks__icon__fonts":"IconLinks-module_iconLinks__icon__fonts__Y-8qN","iconLinks__image_wrapper":"IconLinks-module_iconLinks__image_wrapper__37uXX","iconLinks__image":"IconLinks-module_iconLinks__image__3kHVL","iconLinks__title":"IconLinks-module_iconLinks__title__qGW83","iconLinks__arrow_right":"IconLinks-module_iconLinks__arrow_right__BQANw","iconLinks__arrow_left":"IconLinks-module_iconLinks__arrow_left__7LpXy","iconLinks__button":"IconLinks-module_iconLinks__button__wuENL","material__icon":"IconLinks-module_material__icon__YEKo1"};

var Icons = function Icons(_ref) {
  var icon = _ref.icon,
    link = _ref.link,
    title = _ref.title;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
  var linkProps = Object.assign(Object.assign({}, link), {
    link: Object.assign({}, linkPropsMapper({
      link: link
    })),
    story: link.story || {}
  });
  var iconSizes = [{
    width: 64,
    height: 64
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: css$F.icons__wrapper
  }, icon && (/*#__PURE__*/React.createElement("div", {
    className: css$F.iconLinks__image_wrapper
  }, link && (/*#__PURE__*/React.createElement(Link, Object.assign({
    href: (_a = linkProps.link) === null || _a === void 0 ? void 0 : _a.href,
    title: title || linkProps.story.name,
    target: TargetValues.Self,
    variant: LinkVariant.Secondary,
    className: css$F.iconLinks__link,
    external: (_b = linkProps.link) === null || _b === void 0 ? void 0 : _b.external,
    showExternalIcon: false,
    piwik_click_id: linkProps === null || linkProps === void 0 ? void 0 : linkProps.piwik_click_id,
    anchor: (_c = linkProps === null || linkProps === void 0 ? void 0 : linkProps.link) === null || _c === void 0 ? void 0 : _c.anchor
  }, ((_d = linkProps.link) === null || _d === void 0 ? void 0 : _d.rel) && {
    rel: (_e = linkProps.link) === null || _e === void 0 ? void 0 : _e.rel
  }), /*#__PURE__*/React.createElement(React.Fragment, null, ((_f = icon[0]) === null || _f === void 0 ? void 0 : _f.icon) && ((_g = icon[0]) === null || _g === void 0 ? void 0 : _g.component) === 'icon_atom' ? (/*#__PURE__*/React.createElement(IconFont, {
    icon: (_h = icon[0]) === null || _h === void 0 ? void 0 : _h.icon,
    className: "".concat(((_j = icon[0]) === null || _j === void 0 ? void 0 : _j.icon.type) === 'igus' ? css$F.iconLinks__icon__fonts : css$F.material__icon)
  })) : icon && hasAssetData(icon, MediaType.IMAGE) && (/*#__PURE__*/React.createElement(Image, {
    src: "".concat(generateImageSrc(((_m = (_l = (_k = icon === null || icon === void 0 ? void 0 : icon[0]) === null || _k === void 0 ? void 0 : _k.local_image) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.local_image) || ((_o = icon === null || icon === void 0 ? void 0 : icon[0]) === null || _o === void 0 ? void 0 : _o.image))),
    alt: "".concat((_p = icon[0]) === null || _p === void 0 ? void 0 : _p.alt_text),
    className: css$F.iconLinks__image,
    imageSizes: iconSizes
  })), title ? (/*#__PURE__*/React.createElement("span", {
    className: css$F.iconLinks__title
  }, title)) : (/*#__PURE__*/React.createElement("span", {
    className: css$F.iconLinks__title
  }, linkProps.story.name))))))));
};

var IconLinks$1 = function IconLinks(_ref) {
  var text = _ref.text,
    icon_element = _ref.icon_element;
  var _useState = useState({
      startSlide: true,
      lastSlide: false
    }),
    disableArrow = _useState[0],
    setDisableArrow = _useState[1];
  var swiperRef = useRef();
  var a11yData = a11yMessages('IconLinks');
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: true,
    spacingWithoutSeparator: true
  }, text && /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }), icon_element && icon_element.length > 7 ? (/*#__PURE__*/React.createElement(Swiper, {
    className: 'iconLinks__swiper',
    slidesPerView: 8,
    onBeforeInit: function onBeforeInit(swiper) {
      swiperRef.current = swiper;
    },
    modules: [A11y],
    onSlideChange: function onSlideChange(swiper) {
      setDisableArrow({
        startSlide: swiper.activeIndex === 0,
        lastSlide: swiper.activeIndex === swiper.slides.length - 7
      });
    },
    a11y: a11yData,
    breakpoints: {
      200: {
        slidesPerView: 'auto',
        watchOverflow: false,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,
        allowTouchMove: false
      },
      1200: {
        enabled: true,
        watchOverflow: true,
        slidesOffsetAfter: 90,
        slidesOffsetBefore: 72,
        spaceBetween: 10,
        noSwipingSelector: 'button'
      }
    }
  }, icon_element.map(function (icon) {
    return /*#__PURE__*/React.createElement(SwiperSlide, null, /*#__PURE__*/React.createElement(Icons, {
      icon: icon.icon,
      link: icon.link,
      title: icon.title,
      key: icon._uid
    }));
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(SliderArrow, {
    className: css$F.iconLinks__arrow_left,
    disabled: disableArrow.startSlide,
    direction: "left",
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    }
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("button", {
    className: css$F.iconLinks__button,
    disabled: disableArrow.lastSlide,
    "aria-label": "Slider button"
  }, /*#__PURE__*/React.createElement(SliderArrow, {
    className: css$F.iconLinks__arrow_right,
    disabled: disableArrow.lastSlide,
    direction: "right",
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    }
  }))))) : (/*#__PURE__*/React.createElement("div", {
    className: css$F.iconLinks__wrapper
  }, icon_element && icon_element.length > 0 && icon_element.map(function (icon) {
    return /*#__PURE__*/React.createElement(Icons, {
      icon: icon.icon,
      link: icon.link,
      title: icon.title,
      key: icon._uid
    });
  })))));
};

var css$E = {"image":"imagemolecule-module_image__JS2mp","image__buttons__wrapper":"imagemolecule-module_image__buttons__wrapper__e3BFk","image__container":"imagemolecule-module_image__container__PvkQc","image__container_large":"imagemolecule-module_image__container_large__o6XYa","image__container_medium":"imagemolecule-module_image__container_medium__CAU23","image__container_small":"imagemolecule-module_image__container_small__nLk8l","image__on__orange__background":"imagemolecule-module_image__on__orange__background__r1qgu","image__on__orange__background__background":"imagemolecule-module_image__on__orange__background__background__ZhJ2a"};

var ImageMoleculeBlokImageHeight;
(function (ImageMoleculeBlokImageHeight) {
  ImageMoleculeBlokImageHeight["LARGE"] = "large";
  ImageMoleculeBlokImageHeight["MEDIUM"] = "medium";
  ImageMoleculeBlokImageHeight["SMALL"] = "small";
  ImageMoleculeBlokImageHeight["SIXTEEN_BY_NINE"] = "169";
})(ImageMoleculeBlokImageHeight || (ImageMoleculeBlokImageHeight = {}));
var ImageMolecule = function ImageMolecule(_ref) {
  var headline = _ref.headline,
    image = _ref.image,
    separator = _ref.separator,
    caption = _ref.caption,
    copyright = _ref.copyright,
    enlarge_image = _ref.enlarge_image,
    text = _ref.text,
    _ref$noSpacingGrid = _ref.noSpacingGrid,
    noSpacingGrid = _ref$noSpacingGrid === void 0 ? false : _ref$noSpacingGrid,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    _ref$assetRatio = _ref.assetRatio,
    assetRatio = _ref$assetRatio === void 0 ? ImageMoleculeBlokImageHeight.LARGE : _ref$assetRatio,
    variant = _ref.variant,
    button = _ref.button,
    imagePriority = _ref.imagePriority,
    image_not_clickable = _ref.image_not_clickable;
  var _a, _b, _c, _d, _e, _f, _g;
  var buttons = useMemo(function () {
    return button === null || button === void 0 ? void 0 : button.map(function (linkElement) {
      return /*#__PURE__*/React.createElement(RenderButtonType, {
        key: linkElement._uid,
        linkType: linkElement,
        onOrangeBackground: onOrangeBackground
      });
    });
  }, [button]);
  var imageComponent = /*#__PURE__*/React.createElement(ImageComponent$1, {
    caption: caption,
    copyright: copyright,
    enlarge_image: enlarge_image,
    assetRatio: assetRatio,
    image: image,
    imagePriority: imagePriority,
    image_not_clickable: !image_not_clickable && !(button === null || button === void 0 ? void 0 : button.length)
  });
  if (image === null || image === void 0 ? void 0 : image.legend) {
    imageComponent = /*#__PURE__*/React.createElement("figure", null, imageComponent, (image === null || image === void 0 ? void 0 : image.legend) && hasTextContent(image === null || image === void 0 ? void 0 : image.legend) && (/*#__PURE__*/React.createElement(LegendComponent, {
      legend: image === null || image === void 0 ? void 0 : image.legend
    })));
  }
  if ((buttons === null || buttons === void 0 ? void 0 : buttons.length) && !image_not_clickable) {
    imageComponent = /*#__PURE__*/React.createElement(Link, {
      target: TargetValues.Self,
      title: "",
      variant: LinkVariant.Primary,
      href: ((_b = (_a = button === null || button === void 0 ? void 0 : button[0]) === null || _a === void 0 ? void 0 : _a.link) === null || _b === void 0 ? void 0 : _b.url) || ((_e = (_d = (_c = button === null || button === void 0 ? void 0 : button[0]) === null || _c === void 0 ? void 0 : _c.link) === null || _d === void 0 ? void 0 : _d.story) === null || _e === void 0 ? void 0 : _e.url) || ((_g = (_f = button === null || button === void 0 ? void 0 : button[0]) === null || _f === void 0 ? void 0 : _f.link) === null || _g === void 0 ? void 0 : _g.cached_url) || ''
    }, imageComponent);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    style: css$E,
    className: onOrangeBackground ? css$E.image__on__orange__background : ''
  }, /*#__PURE__*/React.createElement(Row, null, headline && (/*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: headline.level,
    variant: variant
  }, headline.text))), text && hasTextContent(text) && (/*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }))), button && (button === null || button === void 0 ? void 0 : button.length) > 0 && (/*#__PURE__*/React.createElement(Col, {
    className: css$E.pageIntro__button_wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css$E.image__buttons__wrapper
  }, buttons))), /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, imageComponent))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};
var ImageComponent$1 = function ImageComponent(_ref2) {
  var caption = _ref2.caption,
    copyright = _ref2.copyright,
    enlarge_image = _ref2.enlarge_image,
    image = _ref2.image,
    _ref2$assetRatio = _ref2.assetRatio,
    assetRatio = _ref2$assetRatio === void 0 ? ImageMoleculeBlokImageHeight.LARGE : _ref2$assetRatio,
    imagePriority = _ref2.imagePriority,
    image_not_clickable = _ref2.image_not_clickable;
  var imageShadow = calculateImageHoverShadow(image_not_clickable);
  return /*#__PURE__*/React.createElement("figure", {
    className: "".concat(css$E.image__container, " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === ImageMoleculeBlokImageHeight.LARGE, css$E.image__container_large), conditionalClassname(assetRatio === ImageMoleculeBlokImageHeight.MEDIUM, css$E.image__container_medium), conditionalClassname(assetRatio === ImageMoleculeBlokImageHeight.SMALL, css$E.image__container_small)))
  }, (image === null || image === void 0 ? void 0 : image.src) && (/*#__PURE__*/React.createElement(Image, {
    src: image.src,
    alt: image.alt,
    className: "".concat(css$E.image, " ").concat(imageCss[imageShadow]),
    imageSizes: sizes$1[assetRatio || 'large'],
    copyrightText: copyright,
    sizes: "(max-width: 344px) 33vw, (max-width: 719px) 50vw, (max-width: 939px) 70vw, 1200px",
    priority: imagePriority
  })), caption && /*#__PURE__*/React.createElement(Caption, {
    text: caption
  }), enlarge_image && (/*#__PURE__*/React.createElement(ImageEnlarge, {
    imageAltText: image === null || image === void 0 ? void 0 : image.alt,
    imageUrl: "".concat(image === null || image === void 0 ? void 0 : image.src),
    enlargeImage: enlarge_image
  })));
};

var open_button = "Show more content";
var close_button = "Show less content";
var buttonText = {
	open_button: open_button,
	close_button: close_button
};

var css$D = {"iframeContainer":"IncludeExternalPage-module_iframeContainer__7L8XX","iframe":"IncludeExternalPage-module_iframe__V6CEd","secondaryButton":"IncludeExternalPage-module_secondaryButton__MdZkE"};

var IncludeExternalPage = function IncludeExternalPage(_ref) {
  var height = _ref.height,
    expand_height = _ref.expand_height,
    link = _ref.link,
    text = _ref.text,
    expand = _ref.expand,
    separator = _ref.separator,
    _ref$noSpacingGrid = _ref.noSpacingGrid,
    noSpacingGrid = _ref$noSpacingGrid === void 0 ? false : _ref$noSpacingGrid;
  var _useState = useState(false),
    expanded = _useState[0],
    setExpanded = _useState[1];
  var toggleExpanded = function toggleExpanded() {
    setExpanded(function (prevExpanded) {
      return !prevExpanded;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    noSpacing: !separator || noSpacingGrid
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    className: css$D.iframeContainer
  }, /*#__PURE__*/React.createElement("iframe", {
    height: expanded ? expand_height : height,
    src: link,
    title: link,
    className: css$D.iframe
  }), expand && (
  /*#__PURE__*/
  // TODO: Add button component on storyblok to avoid hardcoding button text
  React.createElement("button", {
    onClick: toggleExpanded,
    className: css$D.secondaryButton
  }, expanded ? buttonText.close_button : buttonText.open_button))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var ShowAllIcon = function ShowAllIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className ? className : ''
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08748 0L1.91248 1.175L5.72914 5L1.91248 8.825L3.08748 10L8.08748 5L3.08748 0Z",
    fill: "#F07D00"
  }));
};

var css$C = {"inpage_navigation__wrapper":"InPageNavigation-module_inpage_navigation__wrapper__TVSuV","inpage_navigation_content":"InPageNavigation-module_inpage_navigation_content__coSbK","headline_one_list__wrapper":"InPageNavigation-module_headline_one_list__wrapper__YY8At","headline_one_list_link":"InPageNavigation-module_headline_one_list_link__hqoa-","toggle_button":"InPageNavigation-module_toggle_button__EaSxz","nav_list__wrapper":"InPageNavigation-module_nav_list__wrapper__IY7U0","h3_indent_level":"InPageNavigation-module_h3_indent_level__Es-mI","nav_item_icon":"InPageNavigation-module_nav_item_icon__T2NPX","nav_list_close":"InPageNavigation-module_nav_list_close__p67Gx","nav_list_open":"InPageNavigation-module_nav_list_open__NEJtP","show_all_icon":"InPageNavigation-module_show_all_icon__AAW-4","show_all_icon_active":"InPageNavigation-module_show_all_icon_active__kXcTb","design_content_navigation__wrapper":"InPageNavigation-module_design_content_navigation__wrapper__kndnq","content_navigation__wrapper":"InPageNavigation-module_content_navigation__wrapper__gmE5C","headline__wrapper":"InPageNavigation-module_headline__wrapper__-Lb9E","content_navigation__content":"InPageNavigation-module_content_navigation__content__brQjg"};

var InPageNavigationList = function InPageNavigationList(_ref) {
  var navItems = _ref.navItems;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ol", {
    className: css$C.nav_list__wrapper
  }, navItems && navItems.map(function (navItem, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(index, "_nav_list"),
      className: conditionalClassname(navItem.level === HeadlineTags.H3, "".concat(css$C.h3_indent_level))
    }, /*#__PURE__*/React.createElement(Link, {
      target: TargetValues.Self,
      href: navItem.href,
      title: navItem.content || '',
      variant: LinkVariant.Primary
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkIcon, {
      className: css$C.nav_item_icon
    }), navItem.content || '')));
  })));
};

var getAllAnchorHeadlines = function getAllAnchorHeadlines() {
  if (typeof window !== 'undefined') {
    var inPageNavElement = window.document.querySelector('[data-modulename="InPageNavigation"]');
    if (!inPageNavElement) {
      return getAllHeadlinesOriginal();
    }
    var headlines = window.document.querySelectorAll('h2, h3');
    var anchorLinks = [];
    headlines.forEach(function (headline) {
      var hasExcludeFromTocClass = headline.classList.contains('exclude-from-toc');
      var isAfterNavigation = inPageNavElement.compareDocumentPosition(headline) & Node.DOCUMENT_POSITION_FOLLOWING;
      if (headline.id && !hasExcludeFromTocClass && isAfterNavigation) {
        anchorLinks.push({
          level: headline.localName,
          href: "de/website".concat(window.location.pathname, "#").concat(headline.id),
          content: headline.textContent
        });
      }
    });
    return anchorLinks;
  }
  return [];
};
var getAllHeadlinesOriginal = function getAllHeadlinesOriginal() {
  var headlines = window.document.querySelectorAll('h2, h3');
  var anchorLinks = [];
  headlines.forEach(function (headline) {
    var hasExcludeFromTocClass = headline.classList.contains('exclude-from-toc');
    if (headline.id && !hasExcludeFromTocClass) {
      anchorLinks.push({
        level: headline.localName,
        href: "de/website".concat(window.location.pathname, "#").concat(headline.id),
        content: headline.textContent
      });
    }
  });
  return anchorLinks;
};
var getOnlyHeadlineTwo = function getOnlyHeadlineTwo(headlines) {
  return headlines.filter(function (headline) {
    return headline.level === HeadlineTags.H2;
  });
};

var InPageNavigation = function InPageNavigation(_ref) {
  var headline = _ref.headline,
    link_display = _ref.link_display,
    _ref$design_content_n = _ref.design_content_navigation,
    design_content_navigation = _ref$design_content_n === void 0 ? false : _ref$design_content_n;
  var _useState = useState([]),
    headlines = _useState[0],
    setHeadlines = _useState[1];
  var allHeadlineTwo = getOnlyHeadlineTwo(headlines);
  var _useState2 = useState(false),
    showAll = _useState2[0],
    setShowAll = _useState2[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  useEffect(function () {
    var navs = getAllAnchorHeadlines();
    setHeadlines(navs);
  }, []);
  return /*#__PURE__*/React.createElement(Container, {
    className: chainConditionalClassnames(css$C.inpage_navigation__wrapper, conditionalClassname(design_content_navigation, css$C.design_content_navigation__wrapper)),
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(Row, {
    className: chainConditionalClassnames(css$C.inpage_navigation_content, conditionalClassname(design_content_navigation, css$C.content_navigation__wrapper))
  }, /*#__PURE__*/React.createElement(Col, {
    className: conditionalClassname(design_content_navigation, css$C.headline__wrapper)
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline)), !design_content_navigation ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("ul", {
    className: css$C.headline_one_list__wrapper
  }, allHeadlineTwo && allHeadlineTwo.length > 0 && allHeadlineTwo.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(index, "_nav_item"),
      className: css$C.headline_one_list_link
    }, /*#__PURE__*/React.createElement(Link, {
      title: (item === null || item === void 0 ? void 0 : item.content) || '',
      variant: LinkVariant.Primary,
      target: TargetValues.Self,
      href: item.href
    }, (item === null || item === void 0 ? void 0 : item.content) || ''));
  }))), link_display && (/*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("button", {
    className: css$C.toggle_button,
    onClick: function onClick() {
      return setShowAll(!showAll);
    }
  }, /*#__PURE__*/React.createElement(ShowAllIcon, {
    className: showAll ? css$C.show_all_icon_active : css$C.show_all_icon
  }), formatMessage({
    id: 'SHOW_ALL_INPAGE_NAVIGATION_BUTTON_TEXT'
  })), /*#__PURE__*/React.createElement("div", {
    className: showAll ? css$C.nav_list_open : css$C.nav_list_close
  }, /*#__PURE__*/React.createElement(InPageNavigationList, {
    navItems: headlines
  })))))) : (/*#__PURE__*/React.createElement("div", {
    className: css$C.content_navigation__content
  }, allHeadlineTwo && allHeadlineTwo.length > 0 && allHeadlineTwo.map(function (item) {
    return (
      /*#__PURE__*/
      // @ts-expect-error we don't need the variant prop here
      React.createElement(NavigationCard, {
        key: item.href,
        href: item.href,
        target: TargetValues.Self,
        title: item.content || '',
        teaser_view: false
      })
    );
  })))));
};

var css$B = {"linkList":"LinkList-module_linkList__Eg6tQ","linkListLink":"LinkList-module_linkListLink__6Q2uj","linkIcon":"LinkList-module_linkIcon__8LwvV","linkList__on__orange__background":"LinkList-module_linkList__on__orange__background__2C6me","oneColumnLinkList":"LinkList-module_oneColumnLinkList__jilaN","twoColumnLinkList":"LinkList-module_twoColumnLinkList__I1xVE","threeColumnLinkList":"LinkList-module_threeColumnLinkList__32HEb"};

var LinkListColumn;
(function (LinkListColumn) {
  LinkListColumn["OneColumn"] = "1";
  LinkListColumn["TwoColumn"] = "2";
  LinkListColumn["ThreeColumn"] = "3";
})(LinkListColumn || (LinkListColumn = {}));

var setFormation = function setFormation(formation) {
  var columns = new Map();
  columns.set(LinkListColumn.OneColumn, css$B.oneColumnLinkList);
  columns.set(LinkListColumn.TwoColumn, css$B.twoColumnLinkList);
  columns.set(LinkListColumn.ThreeColumn, css$B.threeColumnLinkList);
  return columns.get(formation);
};
var LinkList = function LinkList(_ref) {
  var text = _ref.text,
    formation = _ref.formation,
    separator = _ref.separator,
    links = _ref.links,
    preview = _ref.preview,
    _ref$noSpacingGrid = _ref.noSpacingGrid,
    noSpacingGrid = _ref$noSpacingGrid === void 0 ? false : _ref$noSpacingGrid,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    className: "".concat(onOrangeBackground ? css$B.linkList__on__orange__background : '')
  }, hasTextContent(text) && text && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement("menu", {
    className: "".concat(css$B.linkList, " ").concat(formation && setFormation(formation))
  }, links.map(function (link, index) {
    if (preview) return /*#__PURE__*/React.createElement("li", {
      key: "".concat(index, " linklList"),
      className: css$B.linkListLink
    }, /*#__PURE__*/React.createElement(LinkIcon, {
      className: css$B.linkIcon
    }), /*#__PURE__*/React.createElement(Link, Object.assign({
      title: link === null || link === void 0 ? void 0 : link.title,
      href: link === null || link === void 0 ? void 0 : link.href,
      external: link === null || link === void 0 ? void 0 : link.external,
      target: link === null || link === void 0 ? void 0 : link.target,
      variant: LinkVariant.Primary,
      icon: link === null || link === void 0 ? void 0 : link.icon,
      piwik_click_id: link === null || link === void 0 ? void 0 : link.piwik_click_id,
      anchor: link === null || link === void 0 ? void 0 : link.anchor
    }, (link === null || link === void 0 ? void 0 : link.rel) && {
      rel: link.rel
    }), link.altText || link.title || 'broken link'));
    if (link === null || link === void 0 ? void 0 : link.title) return /*#__PURE__*/React.createElement("li", {
      key: "".concat(index, " linklList"),
      className: css$B.linkListLink
    }, /*#__PURE__*/React.createElement(LinkIcon, {
      className: css$B.linkIcon
    }), /*#__PURE__*/React.createElement(Link, Object.assign({
      title: link === null || link === void 0 ? void 0 : link.title,
      href: link === null || link === void 0 ? void 0 : link.href,
      external: link === null || link === void 0 ? void 0 : link.external,
      target: link === null || link === void 0 ? void 0 : link.target,
      variant: LinkVariant.Primary,
      icon: link === null || link === void 0 ? void 0 : link.icon,
      piwik_click_id: link === null || link === void 0 ? void 0 : link.piwik_click_id,
      anchor: link === null || link === void 0 ? void 0 : link.anchor
    }, (link === null || link === void 0 ? void 0 : link.rel) && {
      rel: link.rel
    }), link.altText || link.title || 'broken link'));
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$A = {"linklist__wrapper":"LinkListHorizontal-module_linklist__wrapper__6xOXe","links_list":"LinkListHorizontal-module_links_list__-DuK9","copyright_year":"LinkListHorizontal-module_copyright_year__BQEA-","link":"LinkListHorizontal-module_link__bHdN1","with_cookie":"LinkListHorizontal-module_with_cookie__juHFD","with_cookie_button":"LinkListHorizontal-module_with_cookie_button__KGpI3"};

var LinkListHorizontal = function LinkListHorizontal(_ref) {
  var links = _ref.links,
    cookieSettingLabel = _ref.cookieSettingLabel;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: css$A.linklist__wrapper
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement("ul", {
    className: css$A.links_list
  }, /*#__PURE__*/React.createElement("li", {
    className: css$A.copyright_year
  }, "\xA9", " igus, ".concat(new Date().getFullYear())), links === null || links === void 0 ? void 0 : links.map(function (link) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: link._uid
    }, link.link ? (/*#__PURE__*/React.createElement(React.Fragment, null, link.name && (/*#__PURE__*/React.createElement("li", {
      className: css$A.link
    }, /*#__PURE__*/React.createElement(Link, Object.assign({}, linkPropsMapper(link), {
      variant: LinkVariant.Secondary
    })))))) : (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
      className: "".concat(css$A.link, " ").concat(css$A.with_cookie)
    }, /*#__PURE__*/React.createElement("div", {
      id: "ppms_cm_privacy_settings",
      "data-editor-centralize": "true",
      "data-main-container": "true",
      "data-root": "true"
    }, /*#__PURE__*/React.createElement("div", {
      "data-disable-select": "true"
    }, /*#__PURE__*/React.createElement("button", {
      className: "".concat(css$A.with_cookie_button),
      id: "ppms_cm_privacy_settings_button"
    }, link.name || cookieSettingLabel)))))));
  }))))));
};

var PageIntroHomepage = function PageIntroHomepage(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, Object.assign({}, props)));
};

var css$z = {"customGridWrapper":"Teaser-module_customGridWrapper__ggack","twoColumnTeaser":"Teaser-module_twoColumnTeaser__ceT0k","center_content":"Teaser-module_center_content__Sp453","columTeaserButton":"Teaser-module_columTeaserButton__cW8u5","center_intro":"Teaser-module_center_intro__4yeXF","center__teaserItems":"Teaser-module_center__teaserItems__wFZXp","center_fourColumn__teaserItems":"Teaser-module_center_fourColumn__teaserItems__27oTs","addTopMargin":"Teaser-module_addTopMargin__Oi-s2","teaser_divider_fullwidth__wrapper":"Teaser-module_teaser_divider_fullwidth__wrapper__-y-I9","teaser_divider__wrapper":"Teaser-module_teaser_divider__wrapper__15q-O","teaser_divider_fourColumn__wrapper":"Teaser-module_teaser_divider_fourColumn__wrapper__-V-jy","teaser_divider_twoColumn__wrapper":"Teaser-module_teaser_divider_twoColumn__wrapper__5E4en","teaser_divider_leftAligned__wrapper":"Teaser-module_teaser_divider_leftAligned__wrapper__wuqG-","teaser_divider_rightAligned__wrapper":"Teaser-module_teaser_divider_rightAligned__wrapper__8zyuJ","teaser_divider_threeColumn__wrapper":"Teaser-module_teaser_divider_threeColumn__wrapper__B6cET"};

var EmailIcon = function EmailIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91669 16.6667C2.58335 16.6667 2.29169 16.5417 2.04169 16.2917C1.79169 16.0417 1.66669 15.75 1.66669 15.4167V4.58337C1.66669 4.25004 1.79169 3.95837 2.04169 3.70837C2.29169 3.45837 2.58335 3.33337 2.91669 3.33337H17.0834C17.4167 3.33337 17.7084 3.45837 17.9584 3.70837C18.2084 3.95837 18.3334 4.25004 18.3334 4.58337V15.4167C18.3334 15.75 18.2084 16.0417 17.9584 16.2917C17.7084 16.5417 17.4167 16.6667 17.0834 16.6667H2.91669ZM10 10.375L17.0834 5.72921V4.58337L10 9.12504L2.91669 4.58337V5.72921L10 10.375Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "20",
    fill: "white"
  }))));
};

var FallbackImage = function FallbackImage(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$18.image__fallback, " ").concat(className ? className : '')
  }, /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    viewBox: "0 0 371 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4472_4096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.796 107.257C142.796 106.825 142.538 106.643 142.025 106.643H141.222V108.772H141.569V107.861H141.888L142.436 108.772H142.828L142.235 107.836C142.311 107.839 142.387 107.826 142.457 107.798C142.528 107.77 142.592 107.727 142.645 107.672C142.698 107.618 142.739 107.552 142.765 107.481C142.791 107.409 142.801 107.333 142.796 107.257ZM141.569 107.577V106.944H141.99C142.2 106.944 142.449 106.972 142.449 107.228C142.449 107.548 142.219 107.548 141.958 107.548L141.569 107.577Z",
    fill: "#EF7D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.948 105.751C141.698 105.747 141.449 105.794 141.217 105.89C140.984 105.985 140.774 106.126 140.598 106.306C140.422 106.485 140.284 106.698 140.193 106.933C140.101 107.167 140.058 107.418 140.066 107.669C140.055 107.923 140.096 108.177 140.186 108.415C140.276 108.652 140.412 108.869 140.588 109.053C140.763 109.236 140.974 109.382 141.207 109.482C141.44 109.582 141.69 109.633 141.944 109.633C142.197 109.633 142.448 109.582 142.681 109.482C142.914 109.382 143.124 109.236 143.3 109.053C143.475 108.869 143.612 108.652 143.701 108.415C143.791 108.177 143.832 107.923 143.821 107.669C143.829 107.418 143.786 107.169 143.695 106.935C143.605 106.701 143.467 106.488 143.293 106.309C143.118 106.13 142.908 105.988 142.677 105.892C142.446 105.796 142.198 105.748 141.948 105.751ZM141.948 109.268C141.037 109.268 140.474 108.555 140.474 107.669C140.46 107.468 140.488 107.265 140.556 107.075C140.624 106.885 140.73 106.71 140.868 106.563C141.005 106.415 141.172 106.297 141.357 106.217C141.541 106.137 141.741 106.095 141.942 106.095C142.143 106.095 142.343 106.137 142.528 106.217C142.712 106.297 142.879 106.415 143.016 106.563C143.154 106.71 143.26 106.885 143.328 107.075C143.396 107.265 143.424 107.468 143.411 107.669C143.425 107.871 143.398 108.074 143.331 108.266C143.264 108.457 143.159 108.632 143.022 108.781C142.885 108.93 142.719 109.049 142.534 109.131C142.35 109.213 142.15 109.256 141.948 109.258V109.268Z",
    fill: "#EF7D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.725 117.103C139.096 116.236 138.27 115.532 137.317 115.048C134.641 113.635 130.694 113.321 126.078 113.321C122.67 113.321 121.603 112.087 121.603 110.125C121.603 108.814 122.852 105.767 128.554 105.758C133.246 105.758 135.702 108.357 135.59 109.629H139.639C139.798 104.421 133.236 101.694 128.547 101.701C121.511 101.701 117.561 105.182 117.561 110.224C117.561 112.193 118.058 113.842 119.153 115.057C120.045 116.045 121.335 116.748 123.081 117.113H116.71V115.048V101.733H112.814V117.103H92.7682C92.7682 116.979 92.7682 116.854 92.7682 116.726V115.048V101.733H88.4455V115.048V117.103H87.8944V101.733H83.868V106.189C82.5824 104.785 81.0215 103.663 79.2833 102.892C77.5451 102.122 75.667 101.721 73.7669 101.713C66.4404 101.713 60.4422 107.548 59.7127 115.029C59.6626 115.538 59.6381 116.051 59.6394 116.563C59.6394 116.736 59.6394 116.912 59.6394 117.084H59.0852V101.733H55.0524V115.048V117.103H49V117.938H55.0524V125.37V131.445H59.0979V125.37V117.938H59.7095C59.9299 120.608 60.8509 123.173 62.3789 125.37C63.5402 127.095 65.0758 128.534 66.8704 129.578C68.665 130.622 70.672 131.244 72.7407 131.398C74.8093 131.552 76.8857 131.233 78.8141 130.466C80.7424 129.699 82.4725 128.503 83.8744 126.969V131.349C83.8522 132.843 83.5361 134.319 82.9442 135.69C81.3515 139.395 77.8475 141.966 73.7733 141.966C69.6991 141.966 66.2015 139.389 64.6087 135.684C64.0081 134.314 63.6833 132.838 63.6531 131.342H59.6362C59.653 132.814 59.8783 134.276 60.3052 135.684C62.1305 141.675 67.4756 146 73.7669 146C80.0582 146 85.4034 141.675 87.2255 135.684C87.6526 134.277 87.8779 132.816 87.8944 131.345V117.938H88.4997C88.7239 120.61 89.6493 123.174 91.1818 125.37C92.4519 127.23 94.1515 128.754 96.1357 129.812C98.1198 130.87 100.33 131.43 102.576 131.445C104.47 131.439 106.342 131.042 108.075 130.278C109.809 129.514 111.367 128.4 112.652 127.004V131.445H116.704V125.37V117.938H133.462C136.393 118.606 136.966 119.875 136.966 121.729C136.994 122.416 136.867 123.099 136.595 123.73C136.323 124.36 135.913 124.921 135.396 125.37C133.95 126.63 131.573 127.237 128.547 127.237C125.881 127.237 123.957 126.454 122.734 125.367C121.558 124.328 121.026 123.011 121.093 121.851H117.041C117 123.061 117.238 124.264 117.736 125.367C119.348 128.948 123.581 131.298 128.547 131.298C132.841 131.298 138.454 130.019 140.333 125.367C140.79 124.207 141.013 122.967 140.99 121.72C141.023 120.416 140.755 119.123 140.206 117.941H147.01V117.103H139.725ZM79.8671 125.37C78.1854 126.679 76.1179 127.389 73.9899 127.389C71.8619 127.389 69.7944 126.679 68.1127 125.37C66.9628 124.472 66.0039 123.351 65.2927 122.075C64.5814 120.798 64.1323 119.391 63.9716 117.938H84.0177C83.8563 119.392 83.4058 120.799 82.6928 122.076C81.9799 123.353 81.019 124.473 79.8671 125.37ZM84.0719 117.11H63.892C63.892 116.934 63.892 116.758 63.892 116.579C63.8859 116.067 63.9125 115.556 63.9716 115.048C64.6724 109.795 68.8868 105.754 73.9835 105.754C79.0803 105.754 83.2914 109.795 83.9859 115.048C84.0511 115.553 84.0841 116.063 84.0846 116.573C84.0846 116.739 84.0814 116.927 84.0719 117.103V117.11ZM108.68 125.37C106.995 126.687 104.921 127.403 102.786 127.403C100.651 127.403 98.5775 126.687 96.8933 125.37C95.7441 124.473 94.7857 123.353 94.0745 122.078C93.3632 120.802 92.9137 119.397 92.7522 117.944H112.798C112.64 119.395 112.194 120.799 111.486 122.075C110.779 123.35 109.825 124.471 108.68 125.37Z",
    fill: "#EF7D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0623 99.0441C57.4615 99.0453 57.8521 98.9277 58.1846 98.7059C58.5171 98.4842 58.7765 98.1684 58.93 97.7986C59.0835 97.4287 59.1242 97.0215 59.0468 96.6284C58.9695 96.2354 58.7776 95.8742 58.4956 95.5907C58.2135 95.3071 57.8539 95.114 57.4624 95.0358C57.0709 94.9575 56.665 94.9977 56.2963 95.1512C55.9275 95.3046 55.6124 95.5645 55.391 95.8978C55.1695 96.2312 55.0516 96.623 55.0522 97.0236C55.0531 97.5587 55.265 98.0716 55.6417 98.4502C56.0184 98.8289 56.5291 99.0424 57.0623 99.0441Z",
    fill: "#EF7D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.044 117.628H159.803V119.475H159.879C160.774 118.168 161.822 117.27 163.944 117.27C165.556 117.27 167.062 117.963 167.652 119.475C168.649 118.117 169.85 117.27 171.793 117.27C174.58 117.27 176.214 118.526 176.214 121.745V130.904H173.3V123.133C173.3 121.003 173.172 119.565 170.898 119.565C168.929 119.565 168.085 120.844 168.085 123.107V130.879H165.17V122.375C165.17 120.527 164.61 119.578 162.845 119.578C161.338 119.578 159.956 120.837 159.956 123.018V130.891H157.044V117.628Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.135 124.248C177.135 120.22 179.588 117.27 183.805 117.27C188.023 117.27 190.479 120.22 190.479 124.248C190.479 128.328 188.023 131.25 183.805 131.25C179.588 131.25 177.135 128.328 177.135 124.248ZM187.564 124.248C187.564 121.966 186.414 119.578 183.805 119.578C181.196 119.578 180.05 121.966 180.05 124.248C180.05 126.531 181.2 128.941 183.805 128.941C186.411 128.941 187.567 126.556 187.567 124.248H187.564Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.042 117.628H192.24V113.651H195.155V117.628H197.786V119.808H195.155V126.889C195.155 128.097 195.257 128.711 196.56 128.711C196.971 128.728 197.383 128.694 197.786 128.609V130.866C197.16 130.955 196.53 131.006 195.897 131.019C192.827 131.019 192.317 129.84 192.24 127.634V119.808H190.042V117.628Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.936 112.583H201.851V115.355H198.936V112.583ZM198.936 117.637H201.851V130.901H198.936V117.637Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.874 124.248C202.874 120.22 205.326 117.27 209.544 117.27C213.761 117.27 216.233 120.22 216.233 124.248C216.233 128.328 213.777 131.25 209.544 131.25C205.31 131.25 202.874 128.328 202.874 124.248ZM213.303 124.248C213.303 121.966 212.153 119.578 209.544 119.578C206.935 119.578 205.788 121.966 205.788 124.248C205.788 126.531 206.938 128.941 209.544 128.941C212.15 128.941 213.303 126.556 213.303 124.248Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.109 117.628H219.871V119.578L219.922 119.629C220.344 118.91 220.946 118.315 221.668 117.901C222.39 117.487 223.207 117.27 224.038 117.27C226.927 117.27 228.717 118.782 228.717 121.784V130.891H225.793V122.554C225.716 120.476 224.949 119.578 223.21 119.578C221.266 119.578 220.024 121.119 220.024 123.065V130.891H217.109V117.628Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.009 117.628H240.764V119.424H240.812C241.631 117.883 243.192 117.27 244.906 117.27C249.069 117.27 251.092 120.425 251.092 124.325C251.092 127.915 249.276 131.25 245.39 131.25C243.701 131.25 241.863 130.636 240.968 129.172H240.917V135.792H238.003L238.009 117.628ZM244.526 119.578C242.074 119.578 240.819 121.425 240.819 124.274C240.819 126.94 242.176 128.941 244.526 128.941C247.186 128.941 248.183 126.582 248.183 124.274C248.183 121.886 246.928 119.578 244.526 119.578Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.092 112.583H255.007V130.901H252.092V112.583Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.71 127.928C267.71 128.647 267.863 128.929 268.401 128.929C268.64 128.939 268.879 128.925 269.115 128.887V130.914C268.517 131.098 267.899 131.206 267.274 131.234C266.073 131.234 265.254 130.824 265.025 129.635C263.875 130.764 262.008 131.234 260.447 131.234C258.02 131.234 255.924 129.955 255.924 127.362C255.924 124.104 258.453 123.526 260.884 123.232L262.492 123.024C264.283 122.794 264.974 122.512 264.974 121.358C264.974 119.817 263.381 119.562 262.238 119.562C260.6 119.562 259.45 120.23 259.323 121.665H256.408C256.615 118.254 259.476 117.254 262.416 117.254C264.999 117.254 267.707 118.305 267.707 121.09L267.71 127.928ZM264.799 124.236C264.209 124.594 263.776 124.696 262.547 124.849L261.371 125.003C260.043 125.185 258.842 125.697 258.842 127.106C258.842 128.443 260.094 128.929 261.346 128.929C262.878 128.929 264.799 128.264 264.799 126.416V124.236Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.539 126.649C272.721 128.369 273.973 128.957 275.531 128.957C276.655 128.957 278.547 128.727 278.471 127.212C278.394 125.697 276.273 125.495 274.151 125.006C272.03 124.517 269.908 123.772 269.908 121.067C269.908 118.168 273.027 117.27 275.429 117.27C278.139 117.27 280.618 118.372 280.952 121.349H277.91C277.627 119.936 276.531 119.578 275.225 119.578C274.381 119.578 272.823 119.782 272.823 120.94C272.823 122.375 274.97 122.605 277.117 123.065C279.264 123.526 281.385 124.325 281.385 126.94C281.385 130.095 278.216 131.25 275.48 131.25C272.132 131.25 269.704 129.763 269.628 126.633L272.539 126.649Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.258 117.628H283.45V113.651H286.364V117.628H288.996V119.808H286.364V126.889C286.364 128.097 286.466 128.711 287.769 128.711C288.181 128.728 288.593 128.694 288.996 128.609V130.866C288.368 130.955 287.737 131.006 287.103 131.019C284.036 131.019 283.526 129.84 283.45 127.634V119.808H281.252L281.258 117.628Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.139 112.583H293.054V115.355H290.139V112.583ZM290.139 117.637H293.054V130.901H290.139V117.637Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.11 122.068C302.881 120.425 301.731 119.578 300.097 119.578C298.587 119.578 296.465 120.399 296.465 124.402C296.465 126.608 297.421 128.941 299.969 128.941C301.68 128.941 302.836 127.838 303.11 125.914H306.025C305.49 129.376 303.368 131.25 299.973 131.25C295.832 131.25 293.554 128.302 293.554 124.402C293.554 120.399 295.73 117.27 300.075 117.27C303.142 117.27 305.748 118.807 306.028 122.065L303.11 122.068Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.57 126.649C309.749 128.369 311.004 128.957 312.562 128.957C313.686 128.957 315.578 128.727 315.502 127.212C315.425 125.697 313.304 125.495 311.182 125.006C309.061 124.517 306.946 123.772 306.946 121.067C306.946 118.168 310.064 117.27 312.466 117.27C315.177 117.27 317.655 118.372 317.99 121.349H314.947C314.664 119.936 313.565 119.578 312.262 119.578C311.418 119.578 309.86 119.782 309.86 120.94C309.86 122.375 312.007 122.605 314.154 123.065C316.301 123.526 318.423 124.325 318.423 126.94C318.423 130.095 315.253 131.25 312.517 131.25C309.169 131.25 306.742 129.763 306.662 126.633L309.57 126.649Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.188 121.342C319.944 121.348 319.701 121.304 319.475 121.212C319.249 121.12 319.045 120.983 318.874 120.809C318.702 120.634 318.569 120.427 318.481 120.198C318.393 119.97 318.353 119.726 318.362 119.482C318.369 119.123 318.481 118.773 318.685 118.478C318.889 118.183 319.175 117.954 319.508 117.821C319.84 117.688 320.204 117.657 320.555 117.731C320.905 117.804 321.226 117.98 321.477 118.236C321.728 118.492 321.898 118.817 321.966 119.17C322.035 119.522 321.997 119.887 321.86 120.219C321.722 120.551 321.49 120.834 321.193 121.034C320.895 121.234 320.545 121.341 320.188 121.342ZM320.188 117.947C319.991 117.948 319.798 117.988 319.618 118.067C319.438 118.146 319.277 118.26 319.143 118.404C319.009 118.548 318.906 118.718 318.84 118.903C318.775 119.089 318.747 119.285 318.76 119.482C318.76 120.329 319.305 121.019 320.188 121.019C320.573 120.989 320.932 120.814 321.194 120.529C321.456 120.244 321.602 119.871 321.602 119.483C321.602 119.096 321.456 118.722 321.194 118.438C320.932 118.153 320.573 117.978 320.188 117.947ZM319.821 120.546H319.484V118.488H320.261C320.758 118.488 321.009 118.663 321.009 119.079C321.014 119.152 321.003 119.225 320.978 119.293C320.953 119.362 320.914 119.425 320.864 119.477C320.814 119.53 320.753 119.572 320.686 119.6C320.619 119.629 320.547 119.643 320.474 119.642L321.048 120.546H320.669L320.137 119.667H319.818L319.821 120.546ZM320.197 119.379C320.449 119.379 320.672 119.354 320.672 119.06C320.672 118.766 320.426 118.782 320.226 118.782H319.821V119.383L320.197 119.379Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: "273",
    height: "51",
    fill: "white",
    transform: "translate(49 95)"
  })))));
};

var css$y = {"breakpoints":"'../../../styling/breakpoints.css'","lg":"i__const_lg_0","md":"i__const_md_1","teaser__wrapper":"TeaserAsset-module_teaser__wrapper__-KJcu","asset__wrapper":"TeaserAsset-module_asset__wrapper__5FlwE","asset__wrapper_large":"TeaserAsset-module_asset__wrapper_large__r-R-a","asset__wrapper_small":"TeaserAsset-module_asset__wrapper_small__fZMoP","asset__wrapper_16_9":"TeaserAsset-module_asset__wrapper_16_9__r6475","richtext__wrapper":"TeaserAsset-module_richtext__wrapper__NKJ3C","link":"TeaserAsset-module_link__Un-LM","link__wrapper":"TeaserAsset-module_link__wrapper__Q-eDv","link__wrapper_center":"TeaserAsset-module_link__wrapper_center__w85uH","linkIconPrimary":"TeaserAsset-module_linkIconPrimary__U-6Ea","linkIconSecondary":"TeaserAsset-module_linkIconSecondary__j-Q-R","link__icon__primary":"TeaserAsset-module_link__icon__primary__Eo6A6","link__icon__secondary":"TeaserAsset-module_link__icon__secondary__z2Q54","teaser__bottom":"TeaserAsset-module_teaser__bottom__JbL4x","headline":"TeaserAsset-module_headline__TW-9-","teaser__content":"TeaserAsset-module_teaser__content__PgX-o","subgrid":"TeaserAsset-module_subgrid__UfTmS","center__text":"TeaserAsset-module_center__text__6aUim","teaser_v2":"TeaserAsset-module_teaser_v2__WLpB2","text_content_wrapper":"TeaserAsset-module_text_content_wrapper__TCfB8","teaser__bottom_alignment":"TeaserAsset-module_teaser__bottom_alignment__D4xfv","teaser__bottom_alignment_center":"TeaserAsset-module_teaser__bottom_alignment_center__i8Twi","headline_mx":"TeaserAsset-module_headline_mx__8vCL8","teaser__body":"TeaserAsset-module_teaser__body__Kelab","themed__button__width":"TeaserAsset-module_themed__button__width__OrYY-","asset__image":"TeaserAsset-module_asset__image__rcPW5","outline__themed_primary":"TeaserAsset-module_outline__themed_primary__wE-XH","outline__themed_secondary":"TeaserAsset-module_outline__themed_secondary__cALH-","outline__themed_color1":"TeaserAsset-module_outline__themed_color1__5rd1t","outline__themed_color2":"TeaserAsset-module_outline__themed_color2__9vsqi","asset_info_icon__button":"TeaserAsset-module_asset_info_icon__button__ctAaG","asset_info__dialog":"TeaserAsset-module_asset_info__dialog__6Za1h","asset_info__wrapper":"TeaserAsset-module_asset_info__wrapper__T1K0z","asset_info__close":"TeaserAsset-module_asset_info__close__knORo","teaser__bottom--flex-row":"TeaserAsset-module_teaser__bottom--flex-row__pYgZs","align__text":"TeaserAsset-module_align__text__xvhlf","image__default":"TeaserAsset-module_image__default__2Vly-","subline":"TeaserAsset-module_subline__t0YJH","two__columns":"TeaserAsset-module_two__columns__jEXOP","three__columns":"TeaserAsset-module_three__columns__oqz4w","four__columns":"TeaserAsset-module_four__columns__9zGR3","image__right":"TeaserAsset-module_image__right__2qsIF","image__fullwidth":"TeaserAsset-module_image__fullwidth__YzpNX","asset__fullwidth":"TeaserAsset-module_asset__fullwidth__ddKJj","asset__halfwidth":"TeaserAsset-module_asset__halfwidth__dULYu","asset__fallback":"TeaserAsset-module_asset__fallback__8OOz8","richtext__wrapper__half__image":"TeaserAsset-module_richtext__wrapper__half__image__Vs5C0","center_content":"TeaserAsset-module_center_content__-9GIS","center_content_right":"TeaserAsset-module_center_content_right__43lBe","divider_font":"TeaserAsset-module_divider_font__CJm2o","img_shadow__micro":"TeaserAsset-module_img_shadow__micro__lu2dD","img_shadow__small":"TeaserAsset-module_img_shadow__small__vhV1H","img_shadow__regular":"TeaserAsset-module_img_shadow__regular__yJSFo","img_shadow__medium":"TeaserAsset-module_img_shadow__medium__5Ogua","img_shadow__large":"TeaserAsset-module_img_shadow__large__xfj1H","img_shadow__ultra":"TeaserAsset-module_img_shadow__ultra__rR4g7","noShadow":"TeaserAsset-module_noShadow__Y0pI6","teaser_center__wrapper":"TeaserAsset-module_teaser_center__wrapper__mk5wn","float_legend":"TeaserAsset-module_float_legend__W4EkN","image_float":"TeaserAsset-module_image_float__R8un3","floater_link_mb":"TeaserAsset-module_floater_link_mb__0atx6","center__link":"TeaserAsset-module_center__link__0WaDf","center__link__right":"TeaserAsset-module_center__link__right__NAupg","image_169":"TeaserAsset-module_image_169__5SHZ1","image_small":"TeaserAsset-module_image_small__WoZUs","image_large":"TeaserAsset-module_image_large__ug6z-","teaser__position__small_no_legend":"TeaserAsset-module_teaser__position__small_no_legend__ULvYM","teaser__position__large_no_legend":"TeaserAsset-module_teaser__position__large_no_legend__lik00","teaser__position__169_no_legend":"TeaserAsset-module_teaser__position__169_no_legend__PRcug","teaser__position__169":"TeaserAsset-module_teaser__position__169__b8t3E","teaser__position__small":"TeaserAsset-module_teaser__position__small__Fq1qn","teaser__position__large":"TeaserAsset-module_teaser__position__large__74ps5","no_position_text__wrapper":"TeaserAsset-module_no_position_text__wrapper__y-wsp","no_position_text_center__wrapper":"TeaserAsset-module_no_position_text_center__wrapper__vwvYG","fullwidth_float_text":"TeaserAsset-module_fullwidth_float_text__8954L","teaser_link__small_no_legend":"TeaserAsset-module_teaser_link__small_no_legend__1vzJS","teaser_link__169_no_legend":"TeaserAsset-module_teaser_link__169_no_legend__w-plc","teaser_link__large_no_legend":"TeaserAsset-module_teaser_link__large_no_legend__zINIc"};

function _createForOfIteratorHelper$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var sizes = _defineProperty(_defineProperty(_defineProperty({}, ColumnView.Two, '(max-width: 719px) 90vw, (max-width: 939px) 45vw, (max-width: 1200px) 23vw, 270px'), ColumnView.Three, '(max-width: 719px) 90vw, (max-width: 939px) 45vw, (min-width: 1200px) 30vw, 370px'), ColumnView.Four, '(max-width: 719px) 90vw, (max-width: 939px) 45vw, (min-width: 1200px 23vw, 270px');
var fullWidthSizes = _defineProperty({}, ColumnView.Two, '(max-width: 719px) 90vw, (max-width: 1200px) 45vw, 689px');
var setImagePosition = function setImagePosition(image_position) {
  var imageLayout = new Map();
  imageLayout.set(AssetView.Right, "".concat(css$y.image__default, " ").concat(css$y.image__right));
  imageLayout.set(AssetView.Left, "".concat(css$y.image__default));
  imageLayout.set(AssetView.Fullwidth, css$y.image__fullwidth);
  return imageLayout.get(image_position);
};
var checkImagePosition = function checkImagePosition(view, image_position) {
  return Number(view) === 2 && image_position !== 'fullwidth';
};
var isFullWidth = function isFullWidth(imagePosition) {
  return imagePosition === 'fullwidth';
};
var buttonVariants = ['button', 'button_secondary', 'button_theming_color_1', 'button_theming_color_2', 'button_transparent'];
var fullWidthTwoColumnImageSizes = {
  169: [{
    width: 689,
    height: 387
  }, {
    width: 570,
    height: 320
  }, {
    width: 450,
    height: 253
  }],
  large: [{
    width: 689,
    height: 459
  }, {
    width: 570,
    height: 380
  }, {
    width: 450,
    height: 300
  }, {
    width: 360,
    height: 240
  }],
  small: [{
    width: 689,
    height: 276
  }, {
    width: 570,
    height: 228
  }, {
    width: 450,
    height: 180
  }, {
    width: 350,
    height: 140
  }]
};
var twoColumnImageSizes = {
  169: [{
    width: 689,
    height: 387
  }, {
    width: 440,
    height: 247
  }, {
    width: 282,
    height: 158
  }],
  large: [{
    width: 689,
    height: 460
  }, {
    width: 440,
    height: 293
  }, {
    width: 300,
    height: 200
  }, {
    width: 270,
    height: 180
  }],
  small: [{
    width: 689,
    height: 276
  }, {
    width: 440,
    height: 176
  }, {
    width: 350,
    height: 140
  }, {
    width: 270,
    height: 108
  }]
};
var threeColumnImageSizes = {
  169: [{
    width: 689,
    height: 387
  }, {
    width: 440,
    height: 247
  }, {
    width: 370,
    height: 208
  }, {
    width: 282,
    height: 158
  }],
  large: [{
    width: 680,
    height: 453
  }, {
    width: 500,
    height: 333
  }, {
    width: 370,
    height: 247
  }, {
    width: 300,
    height: 200
  }],
  small: [{
    width: 680,
    height: 272
  }, {
    width: 500,
    height: 200
  }, {
    width: 370,
    height: 148
  }, {
    width: 300,
    height: 120
  }]
};
var fourColumnImageSizes = {
  169: [{
    width: 689,
    height: 387
  }, {
    width: 440,
    height: 247
  }, {
    width: 270,
    height: 158
  }],
  large: [{
    width: 669,
    height: 446
  }, {
    width: 439,
    height: 293
  }, {
    width: 270,
    height: 180
  }],
  small: [{
    width: 669,
    height: 268
  }, {
    width: 439,
    height: 176
  }, {
    width: 270,
    height: 108
  }]
};
var columnViewSizes = {
  twoColumn: twoColumnImageSizes,
  threeColumn: threeColumnImageSizes,
  fourColumn: fourColumnImageSizes
};
function getColumnView(view) {
  switch (view) {
    case ColumnView.Four:
      return 'fourColumn';
    case ColumnView.Three:
      return 'threeColumn';
    case ColumnView.Two:
    default:
      return 'twoColumn';
  }
}
var getAssetClass = function getAssetClass(assetRatio, hasLegend, assetRatioClass) {
  if (!assetRatio || !(assetRatio in assetRatioClass)) {
    return '';
  }
  var ratioClass = assetRatioClass[assetRatio];
  return hasLegend ? ratioClass === null || ratioClass === void 0 ? void 0 : ratioClass.withLegend : ratioClass === null || ratioClass === void 0 ? void 0 : ratioClass.withoutLegend;
};
var getCenterContentClassName = function getCenterContentClassName(center_content, hasTextContent, assetRatio) {
  if (!center_content || hasTextContent) return '';
  switch (assetRatio) {
    case 'small':
      return css$y.image_small;
    case 'large':
      return css$y.image_large;
    case '169':
      return css$y.image_169;
    default:
      return '';
  }
};
/**
 * Determines the appropriate shadow class to apply to a teaser asset
 *
 * @param clickable_image - Whether the image is clickable
 * @param asset - The asset object that may contain shadow settings
 * @param links - Array of links associated with the asset
 * @param shadowClasses - Object mapping shadow names to CSS classes
 * @returns The appropriate shadow class or empty string if no shadow should be applied
 */
var getShadowClass = function getShadowClass(shadowClasses, clickable_image, asset, links) {
  var _a, _b, _c;
  if (!clickable_image) return '';
  if ((_a = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _a === void 0 ? void 0 : _a.Shadow) {
    var shadowKey = asset[0].Shadow;
    return (_b = shadowClasses[shadowKey]) !== null && _b !== void 0 ? _b : '';
  }
  if (links === null || links === void 0 ? void 0 : links.length) {
    return (_c = shadowClasses['shadow_1']) !== null && _c !== void 0 ? _c : '';
  }
  return '';
};
var hasSameVariants = function hasSameVariants(mappedLinks) {
  if (!mappedLinks || Array.isArray(mappedLinks) && !mappedLinks.length) return false;
  var previousVariant = '';
  var _iterator = _createForOfIteratorHelper$1(mappedLinks),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var link = _step.value;
      var variant = link.variant.startsWith('button') ? 'button' : 'text';
      if (previousVariant && previousVariant !== variant) return false;
      previousVariant = variant;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
};

var TeaserAsset = function TeaserAsset(_ref) {
  var asset = _ref.asset,
    view = _ref.view,
    image_position = _ref.image_position,
    showInPageIndex = _ref.showInPageIndex,
    pageIndexAsset = _ref.pageIndexAsset,
    assetRatio = _ref.assetRatio,
    outlineVariant = _ref.outlineVariant,
    _ref$center_content = _ref.center_content,
    center_content = _ref$center_content === void 0 ? false : _ref$center_content,
    _ref$divider = _ref.divider,
    divider = _ref$divider === void 0 ? false : _ref$divider,
    clickable_image = _ref.clickable_image,
    links = _ref.links,
    float_teaser = _ref.float_teaser,
    imagePriority = _ref.imagePriority,
    version = _ref.version;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24;
  var fourColumnView = Number(view) === 4;
  var checkColumnView = Number(view) === 2;
  var twoColumnsTeaser = checkColumnView && image_position !== 'fullwidth' && center_content;
  var shadowClasses = {
    shadow_1: css$y.img_shadow__micro,
    shadow_2: css$y.img_shadow__small,
    shadow_3: css$y.img_shadow__regular,
    shadow_4: css$y.img_shadow__medium,
    shadow_5: css$y.img_shadow__large,
    shadow_6: css$y.img_shadow__ultra
  };
  var shadowClass = getShadowClass(shadowClasses, clickable_image, asset, links);
  var isVersionOne = version === 'v1' || !version;
  var isFloatedTeaser = float_teaser && center_content;
  if (showInPageIndex && pageIndexAsset && (pageIndexAsset === null || pageIndexAsset === void 0 ? void 0 : pageIndexAsset.url)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$y.asset__wrapper, " ").concat(checkImagePosition(view, image_position) ? css$y.asset__halfwidth : css$y.asset__fullwidth, " ").concat(fourColumnView ? css$y.four__column__height : '', " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === TeaserAssetImageHeight.LARGE, css$y.asset__wrapper_large), conditionalClassname(assetRatio === TeaserAssetImageHeight.SMALL, css$y.asset__wrapper_small), conditionalClassname(assetRatio === TeaserAssetImageHeight['16_9'], css$y.asset__wrapper_16_9)))
    }, /*#__PURE__*/React.createElement(Image, {
      src: pageIndexAsset === null || pageIndexAsset === void 0 ? void 0 : pageIndexAsset.url,
      alt: 'Igus Product',
      imageSizes: isFullWidth(image_position) ? fullWidthTwoColumnImageSizes[assetRatio || 'large'] : (_a = columnViewSizes[getColumnView(view)]) === null || _a === void 0 ? void 0 : _a[assetRatio || 'large'],
      sizes: isFullWidth(image_position) ? fullWidthSizes[ColumnView.Two] : sizes[view],
      className: css$y.asset__image,
      copyrightText: pageIndexAsset === null || pageIndexAsset === void 0 ? void 0 : pageIndexAsset.copyright,
      priority: imagePriority
    }));
  }
  if (asset && (hasAssetData(asset, MediaType.IMAGE) || hasAssetData(asset, MediaType.VIDEO) || hasAssetData(asset, MediaType.YOUTUBE))) {
    var videoRatio = assetRatio === TeaserAssetImageHeight.SMALL && '5/2' || assetRatio === TeaserAssetImageHeight.MEDIUM && '4/3' || assetRatio === TeaserAssetImageHeight.LARGE && '3/2' || assetRatio === TeaserAssetImageHeight['16_9'] && '16/9' || '3/2';
    var renderAssetSrc = getLocalAssetSrc(asset);
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$y.asset__wrapper, " ").concat(checkImagePosition(view, image_position) ? css$y.asset__halfwidth : css$y.asset__fullwidth, " ").concat(fourColumnView ? css$y.four__column__height : '', " ")
    }, hasAssetData(asset, MediaType.IMAGE) && ((_b = asset[0]) === null || _b === void 0 ? void 0 : _b.image) && (/*#__PURE__*/React.createElement("div", {
      className: chainConditionalClassnames(twoColumnsTeaser && (image_position == 'left' || !image_position) ? css$y.center_content : '', twoColumnsTeaser && image_position == 'right' ? css$y.center_content_right : '', Number(view) != 2 && divider || image_position == 'fullwidth' && Number(view) == 2 ? css$y.divider_font : '')
    }, /*#__PURE__*/React.createElement(ClickableImage, {
      clickable_image: clickable_image,
      link: (links === null || links === void 0 ? void 0 : links.length) ? links[0] : undefined,
      className: "".concat(chainConditionalClassnames(conditionalClassname(assetRatio === TeaserAssetImageHeight.LARGE, css$y.asset__wrapper_large), conditionalClassname(assetRatio === TeaserAssetImageHeight.SMALL, css$y.asset__wrapper_small), conditionalClassname(assetRatio === TeaserAssetImageHeight['16_9'], css$y.asset__wrapper_16_9)))
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
      src: renderAssetSrc,
      alt: "".concat(asset.length ? (_c = asset[0]) === null || _c === void 0 ? void 0 : _c.alt_text : 'Igus Product'),
      copyrightText: (_d = asset[0]) === null || _d === void 0 ? void 0 : _d.copyright,
      className: chainConditionalClassnames(css$y.asset__image, isVersionOne ? shadowClass : '', outlineVariant && isVersionOne ? getVariantClassName(outlineVariant, css$y, ComponentNames.Outline) : ''),
      imageSizes: isFullWidth(image_position) ? fullWidthTwoColumnImageSizes[assetRatio || 'large'] : (_e = columnViewSizes[getColumnView(view)]) === null || _e === void 0 ? void 0 : _e[assetRatio || 'large'],
      sizes: isFullWidth(image_position) ? fullWidthSizes[ColumnView.Two] : sizes[view],
      RoundedCorners: isVersionOne ? asset[0].RoundedCorners : undefined,
      Shadow: isVersionOne ? asset[0].Shadow : undefined,
      priority: imagePriority
    }), (links === null || links === void 0 ? void 0 : links.length) === 0 && (/*#__PURE__*/React.createElement(ImageEnlarge, {
      imageAltText: (_f = asset[0]) === null || _f === void 0 ? void 0 : _f.alt_text,
      imageUrl: renderAssetSrc,
      enlargeImage: true
    })))), isPreferredVersion(ComponentVersion.v1, version) && (/*#__PURE__*/React.createElement("div", {
      className: "".concat(hasTextContent(asset[0].legend) && isFloatedTeaser ? css$y.float_legend : '', " ")
    }, ((_j = (_h = (_g = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _g === void 0 ? void 0 : _g.legend) === null || _h === void 0 ? void 0 : _h.content) === null || _j === void 0 ? void 0 : _j[0]) && hasTextContent((_k = asset[0]) === null || _k === void 0 ? void 0 : _k.legend) && (/*#__PURE__*/React.createElement(LegendComponent, {
      legend: (_l = asset[0]) === null || _l === void 0 ? void 0 : _l.legend,
      float_teaser: float_teaser,
      center_content: center_content
    })))))), hasAssetData(asset, MediaType.VIDEO) && ((_m = asset[0]) === null || _m === void 0 ? void 0 : _m.video) && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Videos, {
      controls: true,
      preload: 'none',
      width: "100%",
      aspectRatio: videoRatio,
      src: renderAssetSrc,
      title: (_q = (_p = (_o = asset[0]) === null || _o === void 0 ? void 0 : _o.video) === null || _p === void 0 ? void 0 : _p.item) === null || _q === void 0 ? void 0 : _q.alt_text,
      thumbnailUrl: ((_s = (_r = asset[0]) === null || _r === void 0 ? void 0 : _r.preview_image) === null || _s === void 0 ? void 0 : _s.length) && ((_v = (_u = (_t = asset[0]) === null || _t === void 0 ? void 0 : _t.preview_image[0]) === null || _u === void 0 ? void 0 : _u.image) === null || _v === void 0 ? void 0 : _v.item) ? (_0 = (_z = (_y = (_x = (_w = asset[0]) === null || _w === void 0 ? void 0 : _w.preview_image[0]) === null || _x === void 0 ? void 0 : _x.image) === null || _y === void 0 ? void 0 : _y.item) === null || _z === void 0 ? void 0 : _z.focal_embed_link) !== null && _0 !== void 0 ? _0 : (_4 = (_3 = (_2 = (_1 = asset[0]) === null || _1 === void 0 ? void 0 : _1.preview_image[0]) === null || _2 === void 0 ? void 0 : _2.image) === null || _3 === void 0 ? void 0 : _3.item) === null || _4 === void 0 ? void 0 : _4.embed_link : ((_9 = (_8 = (_7 = (_6 = (_5 = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _5 === void 0 ? void 0 : _5.local_video) === null || _6 === void 0 ? void 0 : _6[0]) === null || _7 === void 0 ? void 0 : _7.video) === null || _8 === void 0 ? void 0 : _8.item) === null || _9 === void 0 ? void 0 : _9.thumbnail_link) || ((_12 = (_11 = (_10 = asset[0]) === null || _10 === void 0 ? void 0 : _10.video) === null || _11 === void 0 ? void 0 : _11.item) === null || _12 === void 0 ? void 0 : _12.thumbnail_link),
      background: (_14 = (_13 = asset[0]) === null || _13 === void 0 ? void 0 : _13.video) === null || _14 === void 0 ? void 0 : _14.color
    }), ((_17 = (_16 = (_15 = asset[0]) === null || _15 === void 0 ? void 0 : _15.legend) === null || _16 === void 0 ? void 0 : _16.content) === null || _17 === void 0 ? void 0 : _17[0]) && hasTextContent((_18 = asset[0]) === null || _18 === void 0 ? void 0 : _18.legend) && (/*#__PURE__*/React.createElement(LegendComponent, {
      legend: (_19 = asset[0]) === null || _19 === void 0 ? void 0 : _19.legend
    })))), hasAssetData(asset, MediaType.YOUTUBE) && ((_20 = asset[0]) === null || _20 === void 0 ? void 0 : _20.youtube_id) && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Videos, {
      width: "100%",
      aspectRatio: videoRatio,
      title: '',
      youtubeId: renderAssetSrc
    }), ((_22 = (_21 = asset[0].legend) === null || _21 === void 0 ? void 0 : _21.content) === null || _22 === void 0 ? void 0 : _22[0]) && hasTextContent((_23 = asset[0]) === null || _23 === void 0 ? void 0 : _23.legend) && (/*#__PURE__*/React.createElement(LegendComponent, {
      legend: (_24 = asset[0]) === null || _24 === void 0 ? void 0 : _24.legend
    })))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
  // TODO ADD Fallback Image after Go Live
  // return (
  //   <FallbackImage
  //     className={`${css.asset__wrapper} ${
  //       checkImagePosition(view, image_position)
  //         ? css.asset__halfwidth
  //         : css.asset__fullwidth
  //     } ${css.asset__fallback} ${chainConditionalClassnames(
  //       conditionalClassname(
  //         assetRatio === TeaserAssetImageHeight.LARGE,
  //         css.asset__wrapper_large,
  //       ),
  //       conditionalClassname(
  //         assetRatio === TeaserAssetImageHeight.SMALL,
  //         css.asset__wrapper_small,
  //       ),
  //       conditionalClassname(
  //         assetRatio === TeaserAssetImageHeight['16_9'],
  //         css.asset__wrapper_16_9,
  //       ),
  //     )}`}
  //   />
  // )
};
var AssetInfoButton = function AssetInfoButton(_ref2) {
  var toggleAssetInfo = _ref2.toggleAssetInfo;
  return /*#__PURE__*/React.createElement("button", {
    className: css$y.asset_info_icon__button,
    onClick: toggleAssetInfo,
    "aria-label": "Asset info button"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "100%",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333496C3.31992 0.333496 0.333252 3.32016 0.333252 7.00016C0.333252 10.6802 3.31992 13.6668 6.99992 13.6668C10.6799 13.6668 13.6666 10.6802 13.6666 7.00016C13.6666 3.32016 10.6799 0.333496 6.99992 0.333496ZM7.66659 10.3335H6.33325V6.3335H7.66659V10.3335ZM7.66659 5.00016H6.33325V3.66683H7.66659V5.00016Z",
    fill: "#363636"
  })));
};
var AssetInfoComponent = function AssetInfoComponent(_ref3) {
  var assetInfoIcon = _ref3.assetInfoIcon,
    assetRatio = _ref3.assetRatio,
    outlineVariant = _ref3.outlineVariant,
    imagePriority = _ref3.imagePriority;
  var _a, _b, _c;
  var assetInfoRef = useRef(null);
  var _useState = useState(false),
    assetInfo = _useState[0],
    setAssetInfo = _useState[1];
  var handleOpen = function handleOpen() {
    setAssetInfo(true);
  };
  var handleClose = function handleClose() {
    var _a;
    (_a = assetInfoRef.current) === null || _a === void 0 ? void 0 : _a.close();
    setAssetInfo(false);
  };
  useEffect(function () {
    var handleEscapeKey = function handleEscapeKey(event) {
      var _a;
      if (event.key === 'Escape') {
        (_a = assetInfoRef.current) === null || _a === void 0 ? void 0 : _a.close();
        setAssetInfo(false);
      }
    };
    window.addEventListener('keydown', handleEscapeKey);
    return function () {
      window.removeEventListener('keydown', handleEscapeKey);
    };
  }, [assetInfo]);
  useEffect(function () {
    var _a;
    if (assetInfo) {
      (_a = assetInfoRef.current) === null || _a === void 0 ? void 0 : _a.showModal();
    }
  }, [assetInfo]);
  useEffect(function () {
    var dialogElement = document.querySelector('dialog');
    var handleOutsideClick = function handleOutsideClick(event) {
      var _a;
      if (event.target === dialogElement) {
        (_a = assetInfoRef.current) === null || _a === void 0 ? void 0 : _a.close();
        setAssetInfo(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return function () {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AssetInfoButton, {
    toggleAssetInfo: handleOpen
  }), assetInfo && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("dialog", {
    className: css$y.asset_info__dialog,
    ref: assetInfoRef
  }, /*#__PURE__*/React.createElement("button", {
    className: css$y.asset_info__close,
    "aria-label": "Close info modal",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$y.asset_info__wrapper, " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === TeaserAssetImageHeight.LARGE, css$y.asset__wrapper_large), conditionalClassname(assetRatio === TeaserAssetImageHeight.SMALL, css$y.asset__wrapper_small)))
  }, assetInfoIcon && hasAssetData(assetInfoIcon, MediaType.IMAGE) && (/*#__PURE__*/React.createElement(Image, {
    src: generateImageSrc((_a = assetInfoIcon === null || assetInfoIcon === void 0 ? void 0 : assetInfoIcon[0]) === null || _a === void 0 ? void 0 : _a.image),
    alt: ((_b = assetInfoIcon[0]) === null || _b === void 0 ? void 0 : _b.alt_text) || 'Igus Product',
    imageSizes: fullWidthTwoColumnImageSizes[assetRatio || 'large'],
    sizes: fullWidthSizes[ColumnView.Two],
    className: chainConditionalClassnames(css$y.asset__image, outlineVariant ? getVariantClassName(outlineVariant, css$y, ComponentNames.Outline) : ''),
    copyrightText: (_c = assetInfoIcon[0]) === null || _c === void 0 ? void 0 : _c.copyright,
    priority: imagePriority
  })))), document.querySelector('#asset-info-modal')));
};
var TwoColumnTeaser = function TwoColumnTeaser(_ref4) {
  var view = _ref4.view,
    image_position = _ref4.image_position,
    headline = _ref4.headline,
    asset = _ref4.asset,
    text = _ref4.text,
    checkColumnView = _ref4.checkColumnView,
    mappedLinks = _ref4.mappedLinks,
    showInPageIndex = _ref4.showInPageIndex,
    pageIndexAsset = _ref4.pageIndexAsset,
    pageIndexDescription = _ref4.pageIndexDescription,
    assetRatio = _ref4.assetRatio,
    outlineVariant = _ref4.outlineVariant,
    assetInfoIcon = _ref4.assetInfoIcon,
    variant = _ref4.variant,
    center_content = _ref4.center_content,
    clickable_image = _ref4.clickable_image,
    links = _ref4.links,
    float_teaser = _ref4.float_teaser,
    imagePriority = _ref4.imagePriority,
    version = _ref4.version;
  var _a;
  var assetRatioClass = {
    '169': {
      withLegend: css$y.teaser__position__169,
      withoutLegend: css$y.teaser__position__169_no_legend
    },
    small: {
      withLegend: css$y.teaser__position__small,
      withoutLegend: css$y.teaser__position__small_no_legend
    },
    large: {
      withLegend: css$y.teaser__position__large,
      withoutLegend: css$y.teaser__position__large_no_legend
    }
  };
  var assetRatioClassLink = {
    169: css$y.teaser_link__169_no_legend,
    small: css$y.teaser_link__small_no_legend,
    large: css$y.teaser_link__large_no_legend
  };
  var assetClassLink = assetRatio ? assetRatioClassLink[assetRatio] : '';
  var isFloatedTeaser = float_teaser && center_content;
  var hasLinks = isFloatedTeaser && (Array.isArray(mappedLinks) && (mappedLinks === null || mappedLinks === void 0 ? void 0 : mappedLinks.length) > 0 || hasTextContent(text));
  var isCenteredLeft = center_content && image_position == 'left';
  var isCenteredRight = center_content && image_position == 'right';
  var hasLegend = asset && hasTextContent((_a = asset[0]) === null || _a === void 0 ? void 0 : _a.legend);
  var assetClass = getAssetClass(assetRatio, hasLegend, assetRatioClass);
  var linkWithoutLegend = Array.isArray(mappedLinks) && (mappedLinks === null || mappedLinks === void 0 ? void 0 : mappedLinks.length) > 0 && !hasLegend && !hasTextContent(text);
  var centerContentNoTextContent = getCenterContentClassName(center_content, hasTextContent(text), assetRatio);
  return /*#__PURE__*/React.createElement("section", {
    className: css$y.subgrid
  }, headline && (/*#__PURE__*/React.createElement(Headline, {
    className: css$y.headline,
    tag: showInPageIndex ? 'h3' : 'h4',
    variant: variant
  }, /*#__PURE__*/React.createElement(React.Fragment, null, headline, assetInfoIcon && hasAssetData(assetInfoIcon, MediaType.IMAGE) && (/*#__PURE__*/React.createElement(AssetInfoComponent, {
    assetInfoIcon: assetInfoIcon,
    assetRatio: assetRatio,
    outlineVariant: outlineVariant,
    imagePriority: imagePriority
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$y.teaser__content, " ").concat(checkColumnView ? setImagePosition(image_position) : '', " ").concat(css$y.teaser__body, " \n      ").concat(isFloatedTeaser ? css$y.teaser_center__wrapper : '', "\n     ").concat(center_content && (image_position == 'left' || image_position == 'right') ? assetClass : '', "\n      ")
  }, /*#__PURE__*/React.createElement(TeaserAsset, {
    asset: asset,
    view: view,
    image_position: image_position,
    showInPageIndex: showInPageIndex,
    pageIndexAsset: pageIndexAsset,
    assetRatio: assetRatio,
    outlineVariant: outlineVariant,
    center_content: center_content,
    clickable_image: clickable_image,
    links: links,
    float_teaser: float_teaser,
    imagePriority: imagePriority,
    version: version
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$y.richtext__wrapper, " ").concat(checkImagePosition(view, image_position) && css$y.richtext__wrapper__half__image, " ").concat(hasTextContent(text) && isFloatedTeaser && image_position != 'fullwidth' ? css$y.align__text : '', " ").concat(hasTextContent(text) && image_position == 'fullwidth' && isFloatedTeaser ? css$y.fullwidth_text__wrapper : '', "\n        ").concat(!image_position && center_content ? css$y.no_position_text_center__wrapper : '', "\n         ").concat(!image_position && hasLinks ? css$y.no_position_text__wrapper : '', "\n         ").concat(center_content && linkWithoutLegend ? assetClassLink : '', "\n         ").concat(centerContentNoTextContent, "\n         ").concat(isFloatedTeaser && !hasTextContent(text) && assetRatio ? css$y.image_float : '', "\n        ")
  }, showInPageIndex ? (/*#__PURE__*/React.createElement("p", null, pageIndexDescription)) : hasTextContent(text) && text && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(isCenteredLeft ? css$y.center__link : '', " \n              ").concat(isCenteredRight ? css$y.center__link__right : '', "\n              ")
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }))), mappedLinks && (mappedLinks === null || mappedLinks === void 0 ? void 0 : mappedLinks.map(function (linkItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: chainConditionalClassnames(css$y.link__wrapper, conditionalClassname(isCenteredLeft !== null && isCenteredLeft !== void 0 ? isCenteredLeft : false, css$y.center__link), conditionalClassname(isCenteredRight !== null && isCenteredRight !== void 0 ? isCenteredRight : false, css$y.center__link__right)),
      key: "".concat(linkItem.title).concat(index)
    }, !buttonVariants.includes(linkItem.variant) && isPreferredVersion(ComponentVersion.v1, version) && (/*#__PURE__*/React.createElement(LinkIcon, {
      className: "".concat((linkItem === null || linkItem === void 0 ? void 0 : linkItem.variant) === 'secondary' ? css$y.link__icon__secondary : css$y.link__icon__primary)
    })), (linkItem === null || linkItem === void 0 ? void 0 : linkItem.href) && isPreferredVersion(ComponentVersion.v1, version) && (/*#__PURE__*/React.createElement(Link, Object.assign({
      external: linkItem.linkType === ContactType.Email || linkItem.external,
      href: linkItem.href,
      title: linkItem.altText || linkItem.title,
      variant: linkItem.variant,
      icon: linkItem.icon,
      target: linkItem.target,
      className: "".concat(css$y.link, " ").concat(center_content && !float_teaser ? css$y.floater_link_mb : ''),
      piwik_click_id: linkItem === null || linkItem === void 0 ? void 0 : linkItem.piwik_click_id,
      anchor: linkItem === null || linkItem === void 0 ? void 0 : linkItem.anchor,
      contact_type: determineContactType(linkItem.href, linkItem.linkType)
    }, linkItem.rel && {
      rel: linkItem.rel
    }), linkItem.altText || linkItem.title)), (linkItem === null || linkItem === void 0 ? void 0 : linkItem.href) && isPreferredVersion(ComponentVersion.v2, version) && (/*#__PURE__*/React.createElement(Link_v2, Object.assign({
      external: linkItem.linkType === ContactType.Email || linkItem.external,
      href: linkItem.href,
      mode: "light",
      variant: linkItem.variant,
      icon: isTextLink(linkItem.variant),
      target: linkItem.target,
      className: "".concat(css$y.link, " ").concat(center_content && !float_teaser ? css$y.floater_link_mb : ''),
      piwik_click_id: linkItem === null || linkItem === void 0 ? void 0 : linkItem.piwik_click_id,
      anchor: linkItem === null || linkItem === void 0 ? void 0 : linkItem.anchor,
      contact_type: determineContactType(linkItem.href, linkItem.linkType)
    }, linkItem.rel && {
      rel: linkItem.rel
    }), linkItem.altText || linkItem.title)));
  })))));
};
var Teaser = function Teaser(_ref5) {
  var view = _ref5.view,
    image_position = _ref5.image_position,
    headline = _ref5.headline,
    asset = _ref5.asset,
    text = _ref5.text,
    mappedLinks = _ref5.mappedLinks,
    showInPageIndex = _ref5.showInPageIndex,
    pageIndexAsset = _ref5.pageIndexAsset,
    pageIndexDescription = _ref5.pageIndexDescription,
    assetRatio = _ref5.assetRatio,
    outlineVariant = _ref5.outlineVariant,
    assetInfoIcon = _ref5.assetInfoIcon,
    variant = _ref5.variant,
    center_content = _ref5.center_content,
    divider = _ref5.divider,
    clickable_image = _ref5.clickable_image,
    links = _ref5.links,
    float_teaser = _ref5.float_teaser,
    imagePriority = _ref5.imagePriority,
    _ref5$version = _ref5.version,
    version = _ref5$version === void 0 ? ComponentVersion.v1 : _ref5$version,
    subline = _ref5.subline;
  var _a, _b, _c;
  var subGridRef = useRef(null);
  var isFloatedTeaser = float_teaser && center_content;
  var isFullWidth = image_position == 'fullwidth';
  var gridChildrenLength = (_c = (_b = (_a = subGridRef === null || subGridRef === void 0 ? void 0 : subGridRef.current) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
  var gridRow = "auto / span ".concat(gridChildrenLength);
  return /*#__PURE__*/React.createElement("section", {
    ref: subGridRef,
    style: {
      gridRow: gridRow
    },
    className: chainConditionalClassnames(css$y.subgrid, conditionalClassname(isPreferredVersion(ComponentVersion.v2, version), css$y.teaser_v2))
  }, headline && (/*#__PURE__*/React.createElement(Headline, {
    className: chainConditionalClassnames(css$y.headline, conditionalClassname(isPreferredVersion(ComponentVersion.v2, version), css$y.headline_mx)),
    tag: showInPageIndex ? 'h3' : 'h4',
    variant: variant
  }, /*#__PURE__*/React.createElement(React.Fragment, null, headline, assetInfoIcon && hasAssetData(assetInfoIcon, MediaType.IMAGE) && (/*#__PURE__*/React.createElement(AssetInfoComponent, {
    assetInfoIcon: assetInfoIcon,
    assetRatio: assetRatio,
    outlineVariant: outlineVariant,
    imagePriority: imagePriority
  }))))), /*#__PURE__*/React.createElement(TeaserAsset, {
    asset: asset,
    view: view,
    image_position: image_position,
    showInPageIndex: showInPageIndex,
    pageIndexAsset: pageIndexAsset,
    assetRatio: assetRatio,
    outlineVariant: outlineVariant,
    assetInfoIcon: assetInfoIcon,
    center_content: center_content,
    divider: divider,
    clickable_image: clickable_image,
    links: links,
    float_teaser: float_teaser,
    imagePriority: imagePriority,
    version: version
  }), /*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames(conditionalClassname(isFloatedTeaser !== null && isFloatedTeaser !== void 0 ? isFloatedTeaser : false, css$y.fullwidth_float_text), conditionalClassname(isPreferredVersion(ComponentVersion.v2, version), css$y.text_content_wrapper), conditionalClassname(center_content !== null && center_content !== void 0 ? center_content : false, css$y.center__text))
  }, subline && /*#__PURE__*/React.createElement("p", {
    className: css$y.subline
  }, subline), showInPageIndex ? (/*#__PURE__*/React.createElement("p", null, pageIndexDescription)) : hasTextContent(text) && text && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(isFloatedTeaser && !isFullWidth ? css$y.align__text : '', " ").concat(isFullWidth && isFloatedTeaser ? css$y.fullwidth_text__wrapper : '')
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content),
    center_content: center_content
  })))), /*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames(css$y.teaser__bottom, conditionalClassname(isPreferredVersion(ComponentVersion.v2, version), css$y.teaser__bottom_alignment), conditionalClassname(isPreferredVersion(ComponentVersion.v2, version) && hasSameVariants(mappedLinks), css$y['teaser__bottom--flex-row']), conditionalClassname(center_content !== null && center_content !== void 0 ? center_content : false, css$y.teaser__bottom_alignment_center))
  }, mappedLinks && (mappedLinks === null || mappedLinks === void 0 ? void 0 : mappedLinks.map(function (linkItem, index) {
    return isPreferredVersion(ComponentVersion.v1, version) ? (/*#__PURE__*/React.createElement("div", {
      className: chainConditionalClassnames(css$y.link__wrapper, conditionalClassname(center_content !== null && center_content !== void 0 ? center_content : false, css$y.link__wrapper_center)),
      key: "".concat(linkItem.title).concat(index)
    }, /*#__PURE__*/React.createElement(RenderLink, Object.assign({
      el: "v1"
    }, linkItem)))) : (/*#__PURE__*/React.createElement(RenderLink, Object.assign({
      el: "v2"
    }, linkItem, {
      mode: "light",
      key: "".concat(linkItem.title).concat(index)
    })));
  }))));
};
var RenderLink = function RenderLink(props) {
  if (props.el === 'v1') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !buttonVariants.includes(props.variant) && (/*#__PURE__*/React.createElement(LinkIcon, {
      className: "".concat((props === null || props === void 0 ? void 0 : props.variant) === 'secondary' ? css$y.link__icon__secondary : css$y.link__icon__primary)
    })), /*#__PURE__*/React.createElement(Link, Object.assign({
      external: props.linkType === ContactType.Email || props.external,
      href: props.href,
      title: props.title,
      variant: props.variant,
      icon: props.icon,
      target: props.target,
      className: chainConditionalClassnames(css$y.link, conditionalClassname(buttonVariants.includes(props.variant), css$y.themed__button__width)),
      piwik_click_id: props === null || props === void 0 ? void 0 : props.piwik_click_id,
      anchor: props === null || props === void 0 ? void 0 : props.anchor,
      contact_type: determineContactType(props.href, props.linkType)
    }, props.rel && {
      rel: props.rel
    }), props.title));
  }
  return /*#__PURE__*/React.createElement(Link_v2, Object.assign({
    external: props.linkType === ContactType.Email || props.external,
    href: props.href,
    variant: props.variant,
    icon: isTextLink(props.variant),
    target: props.target,
    mode: props.mode,
    className: chainConditionalClassnames(css$y.link, conditionalClassname(buttonVariants.includes(props.variant), css$y.themed__button__width)),
    piwik_click_id: props === null || props === void 0 ? void 0 : props.piwik_click_id,
    anchor: props === null || props === void 0 ? void 0 : props.anchor,
    contact_type: determineContactType(props.href, props.linkType)
  }, props.rel && {
    rel: props.rel
  }), props.children);
};
var ClickableImage = function ClickableImage(_ref6) {
  var children = _ref6.children,
    clickable_image = _ref6.clickable_image,
    link = _ref6.link,
    className = _ref6.className;
  if (!clickable_image || !link) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$y.image__default, " ").concat(conditionalClassname(!!className, className))
    }, children);
  }
  var _ref7 = link || {},
    _ref7$href = _ref7.href,
    href = _ref7$href === void 0 ? '' : _ref7$href,
    _ref7$target = _ref7.target,
    target = _ref7$target === void 0 ? TargetValues.Self : _ref7$target,
    piwik_click_id = _ref7.piwik_click_id,
    anchor = _ref7.anchor,
    rel = _ref7.rel;
  return /*#__PURE__*/React.createElement(Link, Object.assign({
    href: href,
    variant: LinkVariant.Primary,
    target: target,
    external: false,
    title: "",
    showExternalIcon: false,
    piwik_click_id: piwik_click_id,
    anchor: anchor
  }, rel && {
    rel: rel
  }), children);
};

var TeaserCard = function TeaserCard(_ref) {
  var view = _ref.view,
    image_position = _ref.image_position,
    headline = _ref.headline,
    asset = _ref.asset,
    text = _ref.text,
    links = _ref.links,
    showInPageIndex = _ref.showInPageIndex,
    pageIndexLink = _ref.pageIndexLink,
    pageIndexTitle = _ref.pageIndexTitle,
    pageIndexAsset = _ref.pageIndexAsset,
    pageIndexDescription = _ref.pageIndexDescription,
    assetRatio = _ref.assetRatio,
    outlineVariant = _ref.outlineVariant,
    assetInfoIcon = _ref.assetInfoIcon,
    variant = _ref.variant,
    center_content = _ref.center_content,
    divider = _ref.divider,
    clickable_image = _ref.clickable_image,
    float_teaser = _ref.float_teaser,
    imagePriority = _ref.imagePriority,
    version = _ref.version,
    subline = _ref.subline;
  var checkColumnView = Number(view) === 2;
  var twoColumnsTeaser = checkColumnView && image_position !== 'fullwidth';
  var mappedLinks = showInPageIndex ? pageIndexLink : links;
  var isTwoColumnFullwidth = float_teaser && image_position == 'fullwidth' && checkColumnView;
  if (twoColumnsTeaser) {
    return /*#__PURE__*/React.createElement(TwoColumnTeaser, {
      image_position: image_position,
      view: view,
      headline: showInPageIndex ? pageIndexTitle : headline,
      asset: asset,
      checkColumnView: checkColumnView,
      text: text,
      mappedLinks: mappedLinks,
      showInPageIndex: showInPageIndex,
      pageIndexLink: pageIndexLink,
      pageIndexAsset: pageIndexAsset,
      pageIndexDescription: pageIndexDescription,
      assetRatio: assetRatio,
      outlineVariant: outlineVariant,
      assetInfoIcon: assetInfoIcon,
      variant: variant,
      center_content: center_content,
      clickable_image: clickable_image,
      links: links,
      float_teaser: float_teaser,
      imagePriority: imagePriority,
      version: version
    });
  }
  return /*#__PURE__*/React.createElement(Teaser, {
    image_position: image_position,
    view: view,
    headline: showInPageIndex ? pageIndexTitle : headline,
    asset: asset,
    text: text,
    showInPageIndex: showInPageIndex,
    mappedLinks: mappedLinks,
    pageIndexLink: pageIndexLink,
    pageIndexAsset: pageIndexAsset,
    pageIndexDescription: pageIndexDescription,
    assetRatio: assetRatio,
    outlineVariant: outlineVariant,
    assetInfoIcon: assetInfoIcon,
    variant: variant,
    divider: divider,
    clickable_image: clickable_image,
    links: links,
    float_teaser: isTwoColumnFullwidth,
    center_content: center_content,
    imagePriority: imagePriority,
    version: version,
    subline: subline
  });
};

var TeaserAssetRatio;
(function (TeaserAssetRatio) {
  TeaserAssetRatio["LARGE"] = "large";
  TeaserAssetRatio["MEDIUM"] = "medium";
  TeaserAssetRatio["SMALL"] = "small";
  TeaserAssetRatio["16_9"] = "169";
})(TeaserAssetRatio || (TeaserAssetRatio = {}));

var renderTeaserTypeData = function renderTeaserTypeData(showInPageIndex, pageIndexTeaser, teaser) {
  var _a, _b;
  if (showInPageIndex) {
    var _teaserData = (_a = pageIndexTeaser === null || pageIndexTeaser === void 0 ? void 0 : pageIndexTeaser.map(function (item) {
      var _a, _b, _c, _d;
      return {
        pageIndexLink: (item === null || item === void 0 ? void 0 : item.link) ? [Object.assign(Object.assign({}, item.link), {
          altText: item.text || ''
        })] : [],
        pageIndexTitle: (_a = item === null || item === void 0 ? void 0 : item.teaserTitle) !== null && _a !== void 0 ? _a : '',
        pageIndexAsset: {
          url: (_b = item === null || item === void 0 ? void 0 : item.teaserImage) !== null && _b !== void 0 ? _b : '',
          copyright: (_c = item === null || item === void 0 ? void 0 : item.copyright) !== null && _c !== void 0 ? _c : ''
        },
        pageIndexDescription: (_d = item === null || item === void 0 ? void 0 : item.teaserDescription) !== null && _d !== void 0 ? _d : ''
      };
    })) !== null && _a !== void 0 ? _a : [];
    return _teaserData;
  }
  var teaserData = (_b = teaser === null || teaser === void 0 ? void 0 : teaser.map(function (item) {
    var _a, _b, _c;
    return {
      _uid: item._uid,
      links: (_a = item === null || item === void 0 ? void 0 : item.links) === null || _a === void 0 ? void 0 : _a.map(function (linkData) {
        var _a, _b, _c;
        var mappedLink = linkPropsMapper(linkData);
        var href = ((_b = (_a = linkData.local_asset) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.embed_link) || mappedLink.href;
        return Object.assign(Object.assign({}, mappedLink), {
          href: href,
          linkType: (_c = linkData.link) === null || _c === void 0 ? void 0 : _c.linktype
        });
      }),
      asset: (_b = item === null || item === void 0 ? void 0 : item.asset) !== null && _b !== void 0 ? _b : [],
      headline: (_c = item === null || item === void 0 ? void 0 : item.headline) !== null && _c !== void 0 ? _c : '',
      text: item === null || item === void 0 ? void 0 : item.text,
      outlineVariant: item === null || item === void 0 ? void 0 : item.outline_variant,
      asset_info_icon: item === null || item === void 0 ? void 0 : item.asset_info_icon,
      variant: item === null || item === void 0 ? void 0 : item.variant,
      clickable_image: item.clickable_image,
      subline: item === null || item === void 0 ? void 0 : item.subline
    };
  })) !== null && _b !== void 0 ? _b : [];
  return teaserData;
};
var shouldAddMoreTopMargin = function shouldAddMoreTopMargin(view, imagePosition, teaser) {
  var _a, _b;
  if (view !== ColumnView.Two || !teaser) {
    return false;
  }
  if (!(imagePosition === AssetView.Right && teaser.length === 4)) {
    return false;
  }
  var buttonLength = (_b = (_a = teaser[3]) === null || _a === void 0 ? void 0 : _a.links) === null || _b === void 0 ? void 0 : _b.length;
  if (!buttonLength) {
    return false;
  }
  return buttonLength === 2;
};

var TeaserCardList = function TeaserCardList(_ref) {
  var pageIndexTeaser = _ref.pageIndexTeaser,
    teaser = _ref.teaser,
    _ref$showInPageIndex = _ref.showInPageIndex,
    showInPageIndex = _ref$showInPageIndex === void 0 ? false : _ref$showInPageIndex,
    image_position = _ref.image_position,
    view = _ref.view,
    _ref$asset_ratio = _ref.asset_ratio,
    asset_ratio = _ref$asset_ratio === void 0 ? TeaserAssetRatio.LARGE : _ref$asset_ratio,
    _ref$center_content = _ref.center_content,
    center_content = _ref$center_content === void 0 ? false : _ref$center_content,
    _ref$divider = _ref.divider,
    divider = _ref$divider === void 0 ? false : _ref$divider,
    _ref$float_teaser = _ref.float_teaser,
    float_teaser = _ref$float_teaser === void 0 ? false : _ref$float_teaser,
    _ref$imagePriority = _ref.imagePriority,
    imagePriority = _ref$imagePriority === void 0 ? false : _ref$imagePriority,
    version = _ref.version;
  var _a, _b;
  var columnSize = Number(view);
  var DEFAULT_COLUMN_SIZE = 2;
  var twoColumnsTeaser = columnSize === DEFAULT_COLUMN_SIZE && image_position !== 'fullwidth';
  var teaserRenderData = renderTeaserTypeData(showInPageIndex, pageIndexTeaser, teaser);
  var twoTeaserItems = ((_a = teaser === null || teaser === void 0 ? void 0 : teaser.length) !== null && _a !== void 0 ? _a : 0) == 2;
  var threeTeaserItems = ((_b = teaser === null || teaser === void 0 ? void 0 : teaser.length) !== null && _b !== void 0 ? _b : 0) == 3;
  var leftAligned = image_position == 'left' && !center_content;
  var rightAligned = image_position == 'right' && !center_content;
  var fullwidth = image_position == 'fullwidth';
  var isCenter = columnSize == 3 && twoTeaserItems || columnSize == 4 && threeTeaserItems;
  var teaserFourColumnsTwoTeasers = columnSize == 4 && twoTeaserItems;
  return /*#__PURE__*/React.createElement(Row, {
    className: chainConditionalClassnames(css$z.customGridWrapper, twoColumnsTeaser ? css$z.twoColumnTeaser : '', image_position ? css$z.twoColumnTeaser : ''),
    style: {
      gridTemplateColumns: "repeat(".concat(columnSize, ", 1fr)")
    }
  }, teaserRenderData && isPreferredVersion(ComponentVersion.v1, version) && teaserRenderData.map(function (teaserItem, ind) {
    return /*#__PURE__*/React.createElement("div", {
      key: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem._uid,
      className: chainConditionalClassnames(center_content ? css$z.center_content : '', center_content && isCenter ? css$z.center__teaserItems : '', center_content && teaserFourColumnsTwoTeasers ? css$z.center_fourColumn__teaserItems : '', divider && columnSize != 2 ? css$z.teaser_divider__wrapper : '', divider && center_content && twoColumnsTeaser && columnSize == 2 ? css$z.teaser_divider_twoColumn__wrapper : '', divider && fullwidth && columnSize == 2 ? css$z.teaser_divider_fullwidth__wrapper : '', divider && fullwidth && columnSize == 2 && center_content ? css$z.teaser_divider_fullwidth__wrapper : '', divider && leftAligned && twoColumnsTeaser && columnSize == 2 ? css$z.teaser_divider_leftAligned__wrapper : '', divider && rightAligned && twoColumnsTeaser && columnSize == 2 ? css$z.teaser_divider_rightAligned__wrapper : '', divider && columnSize == 3 ? css$z.teaser_divider_threeColumn__wrapper : '', divider && columnSize == 4 ? css$z.teaser_divider_fourColumn__wrapper : '')
    }, /*#__PURE__*/React.createElement(TeaserCard, {
      key: "".concat(teaserItem._uid, "-").concat(ind),
      image_position: image_position,
      view: view,
      headline: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.headline,
      asset: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.asset,
      links: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.links,
      text: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.text,
      showInPageIndex: showInPageIndex,
      pageIndexLink: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.pageIndexLink,
      pageIndexTitle: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.pageIndexTitle,
      pageIndexAsset: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.pageIndexAsset,
      pageIndexDescription: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.pageIndexDescription,
      assetRatio: asset_ratio,
      outlineVariant: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.outlineVariant,
      assetInfoIcon: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.asset_info_icon,
      variant: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.variant,
      center_content: center_content,
      divider: divider,
      clickable_image: !teaserItem.clickable_image,
      float_teaser: float_teaser,
      imagePriority: imagePriority,
      version: version,
      subline: teaserItem.subline
    }));
  }), teaserRenderData && isPreferredVersion(ComponentVersion.v2, version) && teaserRenderData.map(function (teaserItem, ind) {
    return /*#__PURE__*/React.createElement(TeaserCard, {
      key: "".concat(teaserItem._uid, "-").concat(ind),
      image_position: image_position,
      view: view,
      headline: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.headline,
      asset: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.asset,
      links: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.links,
      text: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.text,
      showInPageIndex: showInPageIndex,
      pageIndexLink: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.pageIndexLink,
      pageIndexTitle: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.pageIndexTitle,
      pageIndexAsset: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.pageIndexAsset,
      pageIndexDescription: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.pageIndexDescription,
      assetRatio: asset_ratio,
      outlineVariant: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.outlineVariant,
      assetInfoIcon: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.asset_info_icon,
      variant: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.variant,
      center_content: center_content,
      divider: divider,
      clickable_image: !teaserItem.clickable_image,
      float_teaser: float_teaser,
      imagePriority: imagePriority,
      version: version,
      subline: teaserItem.subline
    });
  }));
};

var TeaserComponent = function TeaserComponent(_a) {
  var text = _a.text,
    separator = _a.separator,
    _a$noSpacingGrid = _a.noSpacingGrid,
    noSpacingGrid = _a$noSpacingGrid === void 0 ? false : _a$noSpacingGrid,
    teaser_button = _a.teaser_button,
    imagePriority = _a.imagePriority,
    _a$version = _a.version,
    version = _a$version === void 0 ? ComponentVersion.v1 : _a$version,
    props = __rest(_a, ["text", "separator", "noSpacingGrid", "teaser_button", "imagePriority", "version"]);
  return /*#__PURE__*/React.createElement("div", {
    className: props.isSubComponent && props.sis_classname || ''
  }, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    version: version
  }, /*#__PURE__*/React.createElement("div", {
    id: "asset-info-modal"
  }), hasTextContent(text) && text && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "".concat(props.center_content ? css$z.center_intro : '')
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content),
    exclude_from_toc: props.exclude_from_toc
  })))), /*#__PURE__*/React.createElement(TeaserCardList, Object.assign({}, props, {
    imagePriority: imagePriority,
    version: version,
    asset_ratio:
    // when version two of the teaser is used, the asset_ratio has no effect
    isPreferredVersion(ComponentVersion.v1, version) ? props.asset_ratio : undefined
  })), teaser_button && (teaser_button === null || teaser_button === void 0 ? void 0 : teaser_button.length) > 0 && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames(css$z.columTeaserButton, conditionalClassname(shouldAddMoreTopMargin(props.view, props.image_position, props.teaser), css$z.addTopMargin))
  }, teaser_button === null || teaser_button === void 0 ? void 0 : teaser_button.map(function (link) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      key: link._uid,
      linkType: link,
      version: version
    });
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$x = {"container":"PageTagsSearch-module_container__jjbb-","headline":"PageTagsSearch-module_headline__kY99l","wrapper":"PageTagsSearch-module_wrapper__rtV15","select__field_wrapper":"PageTagsSearch-module_select__field_wrapper__Qstch","select__field":"PageTagsSearch-module_select__field__nwpbi","button__wrapper":"PageTagsSearch-module_button__wrapper__LeJkB","button":"PageTagsSearch-module_button__cpOS7","loader":"PageTagsSearch-module_loader__ZwgFI","no_results__wrapper":"PageTagsSearch-module_no_results__wrapper__ED-Fq","error__text":"PageTagsSearch-module_error__text__0TeLj","teaser__wrapper":"PageTagsSearch-module_teaser__wrapper__5bP3o","link__wrapper":"PageTagsSearch-module_link__wrapper__KCNCg","teaser_wrapper__paginated":"PageTagsSearch-module_teaser_wrapper__paginated__Vldkn"};

var NoResults = function NoResults() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Container, {
    className: css$x.no_results__wrapper,
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, formatMessage({
    id: 'PAGETAGS_SEARCH_NO_RESULTS'
  })), /*#__PURE__*/React.createElement("p", null, formatMessage({
    id: 'PAGETAGS_SEARCH_NO_RESULTS_DESCRIPTION'
  })));
};

var PageTagsSearchComponents;
(function (PageTagsSearchComponents) {
  PageTagsSearchComponents["PageTagsSearch"] = "page_tags_search";
  PageTagsSearchComponents["TagList"] = "tag_list";
  PageTagsSearchComponents["TagListMajor"] = "tag_list_major";
  PageTagsSearchComponents["TagListSecondThird"] = "tag_list_second_third";
})(PageTagsSearchComponents || (PageTagsSearchComponents = {}));
var Tags;
(function (Tags) {
  Tags["INDUSTRIES"] = "tag_selection_industries";
  Tags["PROBLEM_SOLUTION"] = "tag_selection_problem_solution";
  Tags["ALL"] = "All";
  Tags["PRODUCTS"] = "tag_selection_products";
  Tags["3_AXIS_SALES"] = "three_axis_tag_sales";
  Tags["3_AXIS_PRODUCTS"] = "three_axis_tags_product";
  Tags["PAGE_OWNERSHIP"] = "page_ownership";
})(Tags || (Tags = {}));
var TagSelection;
(function (TagSelection) {
  TagSelection["PRODUCTS"] = "products";
  TagSelection["INDUSTRIES"] = "industries";
  TagSelection["PROBLEM_SOLUTION"] = "problem_solution";
  TagSelection["THREE_AXIS_PRODUCT"] = "3_axis_products";
  TagSelection["THREE_AXIS_SALES"] = "3_axis_sales";
  TagSelection["PAGE_OWNERSHIP"] = "page_ownership";
})(TagSelection || (TagSelection = {}));

// Constants for tag types and selections
var INDUSTRY_TAG = 'industry_tag';
var PROBLEM_SOLUTION_TAG = 'problemsolution_tag';
var THREE_AXIS_TAG_PRODUCTS = 'three_axis_tag_products';
var THREE_AXIS_TAG_SALES = 'three_axis_tag_sales';
var TAG_SELECTION_INDUSTRIES = 'tag_selection_industries';
var TAG_SELECTION_PROBLEM_SOLUTION = 'tag_selection_problem_solution';
var TAG_SELECTION_PRODUCTS = 'tag_selection_products';
var TAG_SELECTION_PAGE_OWNERSHIP = 'page_ownership';
var PAGE_OWNERSHIP = 'page_ownership';
var ALL = 'All';
var PRODUCTS_TAG = 'products_tag';
var THREE_AXIS_SALES_TAG = 'three_axis_tag_sales';
var THREE_AXIS_PRODUCTS_TAG = 'three_axis_tags_product';
var MAJOR_TAG_TYPE = 'majorTagType';
var MAJOR_TAG_VALUE = 'majorTagValue';
var FIRST_MINOR_TAG_TYPE = 'firstMinorTagType';
var SECOND_MINOR_TAG_TYPE = 'secondMinorTagType';
var FIRST_MINOR_TAG_VALUE = 'minorTagValue';
var SECOND_MINOR_TAG_VALUE = 'secondMinorTagValue';
var UPDATE_TAG_VALUES = 'UPDATE_TAG_VALUES';
/**
 * Retrieves major tag options based on the major tag type and available stories
 *
 * @param majorTagType - The type of major tag
 * @param problemSolutions - Available problem solution tags
 * @param industries - Available industry tags
 * @param products - Available product tags
 * @param pageOwnership - Available page ownership tags
 * @param allStories - All available stories
 * @param threeAxisTag - The three-axis tag key
 * @returns An array of major tag options as [key, value] pairs
 */
var getMajorTagOptions = function getMajorTagOptions(majorTagType, problemSolutions, industries, products, pageOwnership, allStories) {
  var selectedTags;
  var majorTagKey = getTagKey(majorTagType);
  // Check if the majorTagKey is a three-axis tag
  if (majorTagKey === THREE_AXIS_TAG_PRODUCTS || majorTagKey === THREE_AXIS_TAG_SALES) {
    var threeAxisOptions = allStories.reduce(function (options, story) {
      var tagContent = story.content[majorTagKey];
      if (Array.isArray(tagContent)) {
        tagContent.forEach(function (tag) {
          if (_typeof$1(tag) === 'object' && tag !== null && tag.name) {
            options.add(tag.name);
          }
        });
      } else if (_typeof$1(tagContent) === 'object' && tagContent !== null && tagContent.name) {
        options.add(tagContent.name);
      }
      return options;
    }, new Set());
    return Array.from(threeAxisOptions).map(function (option) {
      return [option, option];
    });
  }
  // Handle non-three-axis tags
  switch (majorTagType) {
    case Tags.INDUSTRIES:
      selectedTags = industries;
      break;
    case Tags.PROBLEM_SOLUTION:
      selectedTags = problemSolutions;
      break;
    case Tags.PRODUCTS:
      selectedTags = products;
      break;
    case Tags.PAGE_OWNERSHIP:
      selectedTags = pageOwnership;
      break;
    default:
      return [];
  }
  var filteredMajorTags = allStories.reduce(function (tags, story) {
    var storyTags = story.content[majorTagKey] && Array.isArray(story.content[majorTagKey]) ? story.content[majorTagKey].map(function (tag) {
      return tag;
    }) : [story.content[majorTagKey]];
    return _toConsumableArray(new Set([].concat(_toConsumableArray(tags), _toConsumableArray(storyTags))));
  }, []);
  var selectedTagEntries = Object.entries(selectedTags || {}).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2);
      _ref2[0];
      var value = _ref2[1];
    return filteredMajorTags.includes(value.value);
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      _ref4$ = _ref4[1],
      value = _ref4$.value,
      dimension_value = _ref4$.dimension_value;
    return [key, dimension_value || value];
  });
  return selectedTagEntries;
};
/**
 * Retrieves minor tag options from a list of filtered minor tags
 *
 * @param filteredMinorTags - An array of filtered minor tags
 * @returns An array of [key, value] pairs for the minor tags
 */
var getMinorTagOptions = function getMinorTagOptions(filteredMinorTags) {
  var uniqueFilteredMinorTags = _toConsumableArray(new Set(filteredMinorTags));
  return uniqueFilteredMinorTags.map(function (tag) {
    return [tag, tag];
  });
};
/**
 * Retrieves the tag key based on the tag type
 *
 * @param tagType - The type of tag
 * @returns The corresponding tag key
 */
var getTagKey = function getTagKey(tagType) {
  switch (tagType) {
    case TAG_SELECTION_INDUSTRIES:
      return INDUSTRY_TAG;
    case TAG_SELECTION_PROBLEM_SOLUTION:
      return PROBLEM_SOLUTION_TAG;
    case TAG_SELECTION_PRODUCTS:
      return PRODUCTS_TAG;
    case TAG_SELECTION_PAGE_OWNERSHIP:
      return PAGE_OWNERSHIP;
    case THREE_AXIS_PRODUCTS_TAG:
      return THREE_AXIS_TAG_PRODUCTS;
    case THREE_AXIS_SALES_TAG:
      return THREE_AXIS_TAG_SALES;
    default:
      return '';
  }
};
/**
 * Retrieves the tag ID for a given tag typee. This fetches the i18n tag ID from Storyblok when no tag ID is provided to be used as the header for the tag selected.
 *
 * @param tagType - The type of tag
 * @returns The corresponding tag ID
 */
var getTagIdForI18n = function getTagIdForI18n(tagType) {
  switch (tagType) {
    case TAG_SELECTION_INDUSTRIES:
      return 'INDUSTRY_TAG';
    case TAG_SELECTION_PRODUCTS:
      return 'PRODUCTS_TAG';
    case TAG_SELECTION_PROBLEM_SOLUTION:
      return 'PROBLEM_SOLUTION_TAG';
    case THREE_AXIS_SALES_TAG:
      return 'THREE_AXIS_SALES_TAG';
    case THREE_AXIS_PRODUCTS_TAG:
      return 'THREE_AXIS_PRODUCTS_TAG';
    case TAG_SELECTION_PAGE_OWNERSHIP:
      return 'PAGE_OWNERSHIP';
    default:
      return '';
  }
};
/**
 * Filters tags from an array of stories based on the tag key
 *
 * @param stories - An array of stories
 * @param tagKey - The key of the tag to filter by
 * @returns An array of unique tags
 */
var filterTags = function filterTags(stories, tagKey) {
  return stories.reduce(function (tags, story) {
    var storyTags = story.content[tagKey];
    var processedTags;
    if (Array.isArray(storyTags)) {
      processedTags = storyTags.map(function (tag) {
        return _typeof$1(tag) === 'object' && tag !== null ? tag.name || tag.tag || '' // Handle both three-axis tags and regular tag objects
        : tag;
      });
    } else if (_typeof$1(storyTags) === 'object' && storyTags !== null) {
      // Handle single three-axis tag object
      processedTags = [storyTags.name || ''];
    } else {
      // Handle single string tag
      processedTags = [storyTags];
    }
    return _toConsumableArray(new Set([].concat(_toConsumableArray(tags), _toConsumableArray(processedTags.filter(function (tag) {
      return tag !== '';
    })))));
  }, []);
};
/**
 * Filters pages based on the tag key and tag value
 * Handles both regular tags and three-axis tags (which are arrays of objects with a 'name' property)
 *
 * @param stories - An array of stories (pages) to filter
 * @param tagKey - The key of the tag to filter by
 * @param tagValue - The value of the tag to filter by
 * @returns An array of filtered pages
 */
var filterPagesByTagValue = function filterPagesByTagValue(stories, tagKey, tagValue) {
  return stories.filter(function (story) {
    var tagContent = story.content[tagKey];
    if (Array.isArray(tagContent)) {
      // Handle array of objects (three-axis tags) or array of strings
      return tagContent.some(function (tag) {
        return _typeof$1(tag) === 'object' && tag !== null ? tag.name === tagValue // Three-axis tag
        : tag === tagValue;
      });
    } else if (_typeof$1(tagContent) === 'object' && tagContent !== null) {
      // Handle single object (three-axis tag)
      return tagContent.name === tagValue;
    } else {
      // Handle single string value
      return tagContent === tagValue;
    }
  });
};
/**
 * Filters pages based on the major tag type, minor tag type, major tag value, minor tag value, and all stories
 *
 * @param majorTagType - The type of major tag
 * @param minorTagType - The type of minor tag
 * @param majorTagValue - The value of the major tag
 * @param minorTagValue - The value of the minor tag
 * @param allStories - An array of all stories
 * @param setFilteredMinorTags - A function to set the filtered minor tags
 * @param secondMinorTagType - The type of the second minor tag (optional)
 * @returns An array of filtered pages
 */
var filterPagesByTagType = function filterPagesByTagType(majorTagType, minorTagType, majorTagValue, minorTagValue, allStories, setFilteredMinorTags, secondMinorTagType) {
  var majorTagKey = '';
  var minorTagKey = '';
  var secondMinorTagKey = '';
  var filteredMinorTags = [];
  var filteredSecondMinorTags = [];
  // Get the tag keys for major, minor, and second minor tags
  majorTagKey = getTagKey(majorTagType);
  minorTagKey = getTagKey(minorTagType);
  if (secondMinorTagType) {
    secondMinorTagKey = getTagKey(secondMinorTagType);
  }
  if (majorTagValue === ALL) {
    filteredMinorTags = filterTags(allStories, minorTagKey);
    // If a second minor tag type is provided, filter the second minor tags
    if (secondMinorTagType) {
      filteredSecondMinorTags = filterTags(allStories, secondMinorTagKey);
      // Set the filtered minor tags
      setFilteredMinorTags({
        firstMinorTags: filteredMinorTags,
        secondMinorTags: filteredSecondMinorTags
      });
    } else {
      setFilteredMinorTags({
        firstMinorTags: filteredMinorTags,
        secondMinorTags: []
      });
    }
    // If the minor tag value is not 'All', filter the pages by the minor tag value
    if (minorTagValue !== ALL) {
      var _pages = filterPagesByTagValue(allStories, minorTagKey, minorTagValue);
      if (secondMinorTagType) {
        filteredSecondMinorTags = filterTags(_pages, secondMinorTagKey);
        setFilteredMinorTags({
          firstMinorTags: filteredMinorTags,
          secondMinorTags: filteredSecondMinorTags
        });
        return _pages;
      }
      setFilteredMinorTags({
        firstMinorTags: filteredMinorTags,
        secondMinorTags: []
      });
      return _pages;
    }
    return allStories;
  }
  // Filter pages by major tag value
  var pages = filterPagesByTagValue(allStories, majorTagKey, majorTagValue);
  // Filter pages by minor tag value
  var filteredPages = filterPagesByTagValue(pages, minorTagKey, minorTagValue);
  filteredMinorTags = filterTags(pages, minorTagKey);
  // If a second minor tag type is provided, filter the second minor tags
  if (secondMinorTagType) {
    filteredSecondMinorTags = filterTags(filteredPages, secondMinorTagKey);
    setFilteredMinorTags({
      firstMinorTags: filteredMinorTags,
      secondMinorTags: filteredSecondMinorTags
    });
    if (minorTagValue === ALL && secondMinorTagType) {
      filteredSecondMinorTags = filterTags(pages, secondMinorTagKey);
      setFilteredMinorTags({
        firstMinorTags: filteredMinorTags,
        secondMinorTags: filteredSecondMinorTags
      });
      return pages;
    }
    return filteredPages;
  } else {
    setFilteredMinorTags({
      firstMinorTags: filteredMinorTags,
      secondMinorTags: []
    });
  }
  // If the major tag value is not 'All', filter the pages by the major tag value
  if (majorTagValue && minorTagValue === '') {
    return pages;
  }
  if (minorTagValue !== ALL) {
    return filterPagesByTagValue(pages, minorTagKey, minorTagValue);
  }
  return pages;
};
/**
 * Maps pages to teaser details
 *
 * @param pages - An array of pages
 * @returns An array of teaser details
 */
var mapPagesToTeaser = function mapPagesToTeaser(pages) {
  return pages.map(function (page) {
    var _a, _b, _c, _d;
    return {
      link: {
        href: page.full_slug,
        cached_url: page.full_slug,
        title: page.content.title
      },
      teaserImage: ((_b = (_a = page.content.teaserimage) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.embed_link) || ((_d = (_c = page.content.teaserimage) === null || _c === void 0 ? void 0 : _c.item) === null || _d === void 0 ? void 0 : _d.focal_embed_link),
      teaserDescription: page.content.teaserdescription || page.content.description,
      teaserTitle: page.content.teasertitle || page.content.title,
      copyright: page.content.copyright
    };
  });
};
/**
 * Maps pages to link list
 *
 * @param pages - An array of pages
 * @returns An array of link list
 */
var mapPagesToLinkList = function mapPagesToLinkList(pages) {
  return pages.map(function (page) {
    return {
      href: page.full_slug,
      cached_url: page.full_slug,
      title: page.content.title
    };
  });
};
/**
 * Updates the major tag type and value
 *
 * @param tagList - The tag list
 * @param tagTypeKey - The key of the tag type
 * @param tagValueKey - The key of the tag value
 * @param dispatch - The dispatch function
 * @param all - Whether to set the value to 'All'
 */
var updateMajorTagTypeAndValue = function updateMajorTagTypeAndValue(tagList, tagTypeKey, tagValueKey, dispatch) {
  var all = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var _a, _b;
  var tagSelection = tagList === null || tagList === void 0 ? void 0 : tagList.tag_list_selection;
  if (!tagSelection) {
    return;
  }
  var tagValue;
  switch (tagSelection) {
    case TagSelection.PRODUCTS:
      tagValue = tagList === null || tagList === void 0 ? void 0 : tagList['tag_selection_product2'];
      break;
    case TagSelection.INDUSTRIES:
      tagValue = tagList === null || tagList === void 0 ? void 0 : tagList['tag_selection_industries2'];
      break;
    case TagSelection.PROBLEM_SOLUTION:
      tagValue = tagList === null || tagList === void 0 ? void 0 : tagList['tag_selection_problem_solution2'];
      break;
    case TagSelection.THREE_AXIS_PRODUCT:
      {
        var threeAxisTagProducts = tagList === null || tagList === void 0 ? void 0 : tagList['three_axis_tag_products2'];
        tagValue = Array.isArray(threeAxisTagProducts) && threeAxisTagProducts.length > 0 ? ((_a = threeAxisTagProducts[0]) === null || _a === void 0 ? void 0 : _a.name) || '' : '';
        break;
      }
    case TagSelection.THREE_AXIS_SALES:
      {
        var threeAxisTagSales = tagList === null || tagList === void 0 ? void 0 : tagList['three_axis_tag_sales2'];
        tagValue = Array.isArray(threeAxisTagSales) && threeAxisTagSales.length > 0 ? ((_b = threeAxisTagSales[0]) === null || _b === void 0 ? void 0 : _b.name) || '' : '';
        break;
      }
    case TagSelection.PAGE_OWNERSHIP:
      tagValue = tagList === null || tagList === void 0 ? void 0 : tagList['page_ownership2'];
  }
  // Update the tag values in the reducer
  dispatch({
    type: UPDATE_TAG_VALUES,
    payload: _defineProperty(_defineProperty({}, tagTypeKey, Tags[tagSelection.toUpperCase()]), tagValueKey, all && !tagValue ? ALL : tagValue)
  });
};
/**
 * Updates the minor tag type and value
 *
 * @param tagList - The tag list
 * @param tagTypeKey - The key of the tag type
 * @param minorTagValueKey - The key of the minor tag value
 * @param dispatch - The dispatch function
 * @param all - Whether to set the value to 'All'
 */
var updateMinorTagType = function updateMinorTagType(tagList, tagTypeKey, minorTagValueKey, dispatch) {
  var all = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var _a;
  var tagSelection = (_a = tagList === null || tagList === void 0 ? void 0 : tagList.tag_list[0]) === null || _a === void 0 ? void 0 : _a.tag_list_selection;
  if (!tagSelection) {
    return;
  }
  dispatch({
    type: UPDATE_TAG_VALUES,
    payload: _defineProperty(_defineProperty({}, tagTypeKey, Tags[tagSelection.toUpperCase()]), minorTagValueKey, all ? ALL : '')
  });
};
/**
 * Fetches all stories from Storyblok
 *
 * @param slug - The slug of the stories
 * @param preview - Whether to use the preview token
 * @param per_page - The number of stories to fetch per page
 * @returns An array of stories
 */
var getAllStories = function getAllStories(slug_1) {
  for (var _len = arguments.length, args_1 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args_1[_key - 1] = arguments[_key];
  }
  return __awaiter(void 0, [slug_1].concat(args_1), void 0, function (slug) {
    var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var per_page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var storyblokApi, token, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            storyblokApi = getStoryblokApi$1();
            token = preview ? process.env.NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN : process.env.NEXT_PUBLIC_STORYBLOK_TOKEN;
            _context.next = 5;
            return storyblokApi.getAll('cdn/stories', {
              starts_with: pathToSlug(slug),
              per_page: per_page,
              token: token,
              version: 'published'
            });
          case 5:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", []);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    })();
  });
};
/**
 * Fetches all tags from Storyblok
 *
 * @param locale - The locale of the tags
 * @param preview - Whether to use the preview token
 * @returns An object containing all the tags
 */
var getAllTags = function getAllTags(locale_1) {
  for (var _len2 = arguments.length, args_1 = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args_1[_key2 - 1] = arguments[_key2];
  }
  return __awaiter(void 0, [locale_1].concat(args_1), void 0, function (locale) {
    var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var DATASOURCES, storyblokApi, token, fetchDataSource, _yield$Promise$all, _yield$Promise$all2, productTags, industryTags, problemSolutionTags, pageOwnershipTags;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            DATASOURCES = ['product-tag', 'industry-tag', 'problem-solution-tag', 'content-group'];
            storyblokApi = getStoryblokApi$1();
            token = preview ? process.env.NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN : process.env.NEXT_PUBLIC_STORYBLOK_TOKEN;
            fetchDataSource = function fetchDataSource(datasource) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var _yield$storyblokApi$g, data;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return storyblokApi.get('cdn/datasource_entries', {
                        datasource: datasource,
                        token: token,
                        cv: Date.now(),
                        per_page: 1000,
                        dimension: locale
                      });
                    case 2:
                      _yield$storyblokApi$g = _context2.sent;
                      data = _yield$storyblokApi$g.data;
                      return _context2.abrupt("return", data.datasource_entries.reduce(function (acc, _ref5) {
                        var name = _ref5.name,
                          value = _ref5.value,
                          dimension_value = _ref5.dimension_value;
                        acc[name] = {
                          dimension_value: dimension_value,
                          value: value
                        };
                        return acc;
                      }, {}));
                    case 5:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
            };
            _context3.next = 6;
            return Promise.all(DATASOURCES.map(fetchDataSource));
          case 6:
            _yield$Promise$all = _context3.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
            productTags = _yield$Promise$all2[0];
            industryTags = _yield$Promise$all2[1];
            problemSolutionTags = _yield$Promise$all2[2];
            pageOwnershipTags = _yield$Promise$all2[3];
            return _context3.abrupt("return", {
              productTags: productTags || {},
              industryTags: industryTags || {},
              problemSolutionTags: problemSolutionTags || {},
              pageOwnershipTags: pageOwnershipTags || {}
            });
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })();
  });
};

var SelectField = function SelectField(_ref) {
  var majorTagType = _ref.majorTagType,
    firstMinorTagType = _ref.firstMinorTagType,
    secondMinorTagType = _ref.secondMinorTagType,
    tagValue = _ref.tagValue,
    setTagValue = _ref.setTagValue,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    headline = _ref.headline,
    _ref$all = _ref.all,
    all = _ref$all === void 0 ? false : _ref$all,
    setIsButtonClicked = _ref.setIsButtonClicked,
    majorTagOptions = _ref.majorTagOptions,
    minorTagOptions = _ref.minorTagOptions;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: css$x.select__field
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "select - ".concat(majorTagType)
  }, majorTagType && headline ? headline : majorTagType && formatMessage({
    id: getTagIdForI18n(majorTagType)
  }), firstMinorTagType && headline ? headline : firstMinorTagType && formatMessage({
    id: getTagIdForI18n(firstMinorTagType)
  }), secondMinorTagType && headline ? headline : secondMinorTagType && formatMessage({
    id: getTagIdForI18n(secondMinorTagType)
  })), isLoading ? (/*#__PURE__*/React.createElement(PageTagsSearchLoader, null)) : (/*#__PURE__*/React.createElement("select", {
    value: tagValue,
    onChange: function onChange(e) {
      setTagValue(e.target.value);
      setIsButtonClicked(false);
    },
    disabled: disabled
  }, all && disabled ? (/*#__PURE__*/React.createElement("option", null, "--")) : all && (/*#__PURE__*/React.createElement("option", {
    value: "All"
  }, formatMessage({
    id: 'ALL_TAGS'
  }))), majorTagOptions && majorTagOptions.length > 0 && majorTagOptions.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return key && (/*#__PURE__*/React.createElement("option", {
      key: key,
      value: key
    }, value));
  }), disabled ? (/*#__PURE__*/React.createElement("option", null, "--")) : minorTagOptions && minorTagOptions.length > 0 && minorTagOptions.map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return key && (/*#__PURE__*/React.createElement("option", {
      key: key,
      value: value
    }, value));
  }))));
};
var PageTagsSearchLoader = function PageTagsSearchLoader() {
  return /*#__PURE__*/React.createElement("div", {
    className: css$x.loader
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null));
};

/**
 * Action types for the PageTagsSearch reducer
 */
var ActionTypes = {
  SET_INTERACTION_STATE: 'SET_INTERACTION_STATE',
  SET_TAG_VALUES: 'SET_TAG_VALUES',
  SET_FILTERED_MINOR_TAGS: 'SET_FILTERED_MINOR_TAGS',
  SET_FILTERED_PAGES: 'SET_FILTERED_PAGES',
  SET_MAJOR_TAG_OPTIONS: 'SET_MAJOR_TAG_OPTIONS',
  SET_MINOR_TAG_OPTIONS: 'SET_MINOR_TAG_OPTIONS',
  SET_ERROR: 'SET_ERROR',
  SET_TAGS: 'SET_TAGS',
  UPDATE_TAG_VALUES: 'UPDATE_TAG_VALUES',
  SET_PAGES: 'SET_PAGES',
  SET_PAGINATION_STATE: 'SET_PAGINATION_STATE'
};
/**
 * Initial state for the PageTagsSearch component
 */
var initialState = {
  interactionState: {
    isSelectFieldLoading: false,
    isButtonClicked: false,
    showFoundPages: false
  },
  tagValues: {
    majorTagType: '',
    firstMinorTagType: '',
    secondMinorTagType: '',
    majorTagValue: '',
    minorTagValue: '',
    secondMinorTagValue: ''
  },
  filteredMinorTags: {
    firstMinorTags: [],
    secondMinorTags: []
  },
  filteredPages: [],
  majorTagOptions: {
    majorTagOptions: []
  },
  minorTagOptions: {
    firstMinorTagOptions: [],
    secondMinorTagOptions: []
  },
  tags: {
    industryTags: {},
    problemSolutionTags: {},
    productTags: {},
    pageOwnershipTags: {}
  },
  error: '',
  pages: [],
  paginationData: {
    currentPage: 1,
    totalPages: 0,
    pageSize: 0,
    pages: []
  },
  allPageTags: []
};
/**
 * Reducer function for the PageTagsSearch component
 *
 * @param {State} state - The current state
 * @param {Action} action - The action to be performed
 * @returns {State} The new state after applying the action
 */
var reducer = function reducer(state, action) {
  switch (action.type) {
    case ActionTypes.SET_INTERACTION_STATE:
      return Object.assign(Object.assign({}, state), {
        interactionState: Object.assign(Object.assign({}, state.interactionState), action.payload)
      });
    case ActionTypes.SET_TAG_VALUES:
      return Object.assign(Object.assign({}, state), {
        tagValues: Object.assign(Object.assign({}, state.tagValues), action.payload)
      });
    case ActionTypes.SET_FILTERED_MINOR_TAGS:
      return Object.assign(Object.assign({}, state), {
        filteredMinorTags: {
          firstMinorTags: action.payload.firstMinorTags,
          secondMinorTags: action.payload.secondMinorTags
        }
      });
    case ActionTypes.SET_FILTERED_PAGES:
      return Object.assign(Object.assign({}, state), {
        filteredPages: action.payload
      });
    case ActionTypes.SET_MAJOR_TAG_OPTIONS:
      return Object.assign(Object.assign({}, state), {
        majorTagOptions: {
          majorTagOptions: action.payload
        }
      });
    case ActionTypes.SET_MINOR_TAG_OPTIONS:
      return Object.assign(Object.assign({}, state), {
        minorTagOptions: {
          firstMinorTagOptions: getLocalMinorTags(state.allPageTags, action.payload.firstMinorTagOptions),
          secondMinorTagOptions: getLocalMinorTags(state.allPageTags, action.payload.secondMinorTagOptions)
        }
      });
    case ActionTypes.SET_ERROR:
      return Object.assign(Object.assign({}, state), {
        error: action.payload
      });
    case ActionTypes.SET_TAGS:
      return Object.assign(Object.assign({}, state), {
        tags: action.payload,
        allPageTags: Object.values(action.payload).flatMap(function (obj) {
          return Object.entries(obj || {}).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];
            return _defineProperty({}, key, value);
          });
        })
      });
    case ActionTypes.UPDATE_TAG_VALUES:
      return Object.assign(Object.assign({}, state), {
        tagValues: Object.assign(Object.assign({}, state.tagValues), action.payload)
      });
    case ActionTypes.SET_PAGES:
      return Object.assign(Object.assign({}, state), {
        pages: action.payload
      });
    case ActionTypes.SET_PAGINATION_STATE:
      return Object.assign(Object.assign({}, state), {
        paginationData: Object.assign(Object.assign({}, state.paginationData), action.payload)
      });
    default:
      return state;
  }
};
var getLocalMinorTags = function getLocalMinorTags(allTags, minorTags) {
  var minorTagKeys = new Set(minorTags.map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
      key = _ref5[0];
    return key;
  }));
  var filteredTags = allTags === null || allTags === void 0 ? void 0 : allTags.filter(function (tag) {
    return Object.keys(tag).some(function (key) {
      return minorTagKeys.has(key);
    });
  }).map(function (tag) {
    var entry = Object.entries(tag)[0];
    if (!entry) return ['', ''];
    var _entry = _slicedToArray(entry, 2),
      key = _entry[0],
      _entry$ = _entry[1],
      dimension_value = _entry$.dimension_value,
      value = _entry$.value;
    return [key, dimension_value || value || ''];
  });
  var mergedTags = Array.from(new Set([].concat(_toConsumableArray(filteredTags.map(function (tag) {
    return JSON.stringify(tag);
  })), _toConsumableArray(minorTags.map(function (tag) {
    return JSON.stringify(tag);
  }))))).map(function (tag) {
    return JSON.parse(tag);
  });
  return mergedTags;
};

/**
 * PageTagsSearch Component
 *
 * This component provides a complex tag-based search functionality for pages.
 * It allows users to filter pages based on major and minor tags, and displays
 * the results either as teasers or a link list.
 *
 * @component
 * @param {PageTagsSearchProps} props - The properties passed to the component
 * @returns {React.ReactElement} The rendered PageTagsSearch component
 */
var PageTagsSearch = function PageTagsSearch(_ref) {
  var text = _ref.text,
    taglist = _ref.taglist,
    headline = _ref.headline,
    formation = _ref.formation,
    teaserview = _ref.teaserview,
    text_intro = _ref.text_intro,
    major_taglist = _ref.major_taglist,
    image_position = _ref.image_position,
    formation_teaserview = _ref.formation_teaserview,
    _ref$all = _ref.all,
    all = _ref$all === void 0 ? false : _ref$all,
    current_locale = _ref.current_locale,
    preview = _ref.preview;
  var _a, _b;
  var _useReducer = useReducer(reducer, initialState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var resultsRef = useRef(null);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(null),
    cachedPages = _useState[0],
    setCachedPages = _useState[1];
  var _useState2 = useState(false),
    initialPagesLoading = _useState2[0],
    setInitialPagesLoading = _useState2[1];
  /**
   * Fetches all pages from the API
   */
  var fetchPages = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var pages;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setInitialPagesLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return getAllStories("".concat(current_locale, "/website"), preview);
          case 4:
            pages = _context.sent;
            setCachedPages(pages);
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            dispatch({
              type: ActionTypes.SET_ERROR,
              payload: _context.t0
            });
          case 11:
            _context.prev = 11;
            setInitialPagesLoading(false);
            return _context.finish(11);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }));
  }, [current_locale, preview]);
  // Fetch pages on component mount if not already cached
  useEffect(function () {
    if (!cachedPages && !initialPagesLoading) {
      fetchPages();
    }
  }, [cachedPages, initialPagesLoading, fetchPages]);
  /**
   * Updates the filtered pages in the state
   * @param {Array<PageProps>} filteredPages - The filtered pages to set
   */
  var setFilteredPages = useCallback(function (filteredPages) {
    dispatch({
      type: ActionTypes.SET_FILTERED_PAGES,
      payload: filteredPages
    });
  }, []);
  /**
   * Updates the filtered minor tags in the state
   * @param {FilteredMinorTags} filteredMinorTags - The filtered minor tags to set
   */
  var setFilteredMinorTags = useCallback(function (filteredMinorTags) {
    dispatch({
      type: ActionTypes.SET_FILTERED_MINOR_TAGS,
      payload: filteredMinorTags
    });
  }, []);
  // Current tag lists for major and minor tags
  var currentTagLists = {
    major: major_taglist,
    minor: taglist
  };
  /**
   * Handles navigation to the next page of results
   */
  var handleNextPage = function handleNextPage() {
    var _a;
    var newPage = state.paginationData.currentPage + 1;
    dispatch({
      type: ActionTypes.SET_PAGINATION_STATE,
      payload: {
        currentPage: state.paginationData.currentPage + 1,
        totalPages: state.paginationData.totalPages,
        pageSize: state.paginationData.pageSize,
        pages: getCurrentPageItems(state.pages, newPage, state.paginationData.pageSize)
      }
    });
    (_a = resultsRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
      behavior: 'smooth'
    });
  };
  /**
   * Handles navigation to the previous page of results
   */
  var handlePreviousPage = function handlePreviousPage() {
    var _a;
    var newPage = state.paginationData.currentPage - 1;
    dispatch({
      type: ActionTypes.SET_PAGINATION_STATE,
      payload: {
        currentPage: state.paginationData.currentPage - 1,
        totalPages: state.paginationData.totalPages,
        pageSize: state.paginationData.pageSize,
        pages: getCurrentPageItems(state.pages, newPage, state.paginationData.pageSize)
      }
    });
    (_a = resultsRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
      behavior: 'smooth'
    });
  };
  /**
   * Handles navigation to a specific page of results
   * @param {number} page - The page number to navigate to
   */
  var handlePageClick = function handlePageClick(page) {
    var _a;
    dispatch({
      type: ActionTypes.SET_PAGINATION_STATE,
      payload: {
        currentPage: page,
        totalPages: state.paginationData.totalPages,
        pageSize: state.paginationData.pageSize,
        pages: getCurrentPageItems(state.pages, page, state.paginationData.pageSize)
      }
    });
    (_a = resultsRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // Fetch all tags on component mount
  useEffect(function () {
    getAllTags(current_locale).then(function (_ref2) {
      var industryTags = _ref2.industryTags,
        problemSolutionTags = _ref2.problemSolutionTags,
        productTags = _ref2.productTags,
        pageOwnershipTags = _ref2.pageOwnershipTags;
      dispatch({
        type: ActionTypes.SET_TAGS,
        payload: {
          industryTags: industryTags,
          problemSolutionTags: problemSolutionTags,
          productTags: productTags,
          pageOwnershipTags: pageOwnershipTags
        }
      });
    });
  }, [current_locale]);
  // Update tag types and values when taglist or major_taglist changes
  useEffect(function () {
    updateMajorTagTypeAndValue(major_taglist[0], MAJOR_TAG_TYPE, MAJOR_TAG_VALUE, dispatch, all);
    updateMinorTagType(taglist[0], FIRST_MINOR_TAG_TYPE, FIRST_MINOR_TAG_VALUE, dispatch, all);
    updateMinorTagType(taglist[1], SECOND_MINOR_TAG_TYPE, SECOND_MINOR_TAG_VALUE, dispatch, all);
  }, [taglist, major_taglist, all]);
  // Update major and minor tag options based on state changes
  useEffect(function () {
    var updatedMajorOptions = getMajorTagOptions(state.tagValues.majorTagType, state.tags.problemSolutionTags, state.tags.industryTags, state.tags.productTags, state.tags.pageOwnershipTags, state.pages);
    var updatedFirstMinorOptions = getMinorTagOptions(state.filteredMinorTags.firstMinorTags);
    var updatedSecondMinorOptions = getMinorTagOptions(state.filteredMinorTags.secondMinorTags);
    dispatch({
      type: ActionTypes.SET_MAJOR_TAG_OPTIONS,
      payload: updatedMajorOptions
    });
    dispatch({
      type: ActionTypes.SET_MINOR_TAG_OPTIONS,
      payload: {
        firstMinorTagOptions: updatedFirstMinorOptions,
        secondMinorTagOptions: updatedSecondMinorOptions
      }
    });
  }, [state.tagValues, state.tags, state.filteredMinorTags, state.pages]);
  /**
   * Handles the tag selection process
   * This function filters pages based on selected tags and updates the state accordingly
   */
  var handleTagSelection = useCallback(function (majorTagType, firstMinorTagType, majorTagValue, minorTagValue, secondMinorTagType) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var pages, filteredPages, _setTotalPagesAndSize, pageSize, totalPages;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!state.interactionState.isButtonClicked) {
              dispatch({
                type: ActionTypes.SET_INTERACTION_STATE,
                payload: {
                  isSelectFieldLoading: true
                }
              });
            }
            pages = cachedPages || [];
            dispatch({
              type: ActionTypes.SET_PAGES,
              payload: pages
            });
            filteredPages = filterPagesByTagType(majorTagType, firstMinorTagType, majorTagValue, minorTagValue, pages, setFilteredMinorTags, secondMinorTagType);
            _context2.next = 7;
            return new Promise(function (resolve) {
              return setTimeout(resolve);
            });
          case 7:
            if (state.interactionState.isButtonClicked) {
              setFilteredPages(filteredPages);
              dispatch({
                type: ActionTypes.SET_INTERACTION_STATE,
                payload: {
                  showFoundPages: true
                }
              });
              _setTotalPagesAndSize = setTotalPagesAndSize(formation_teaserview, filteredPages), pageSize = _setTotalPagesAndSize.pageSize, totalPages = _setTotalPagesAndSize.totalPages;
              dispatch({
                type: ActionTypes.SET_PAGINATION_STATE,
                payload: {
                  currentPage: 1,
                  totalPages: totalPages,
                  pageSize: pageSize,
                  pages: getCurrentPageItems(filteredPages, 1, pageSize)
                }
              });
            }
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            dispatch({
              type: ActionTypes.SET_ERROR,
              payload: _context2.t0
            });
          case 13:
            _context2.prev = 13;
            dispatch({
              type: ActionTypes.SET_INTERACTION_STATE,
              payload: {
                isSelectFieldLoading: false
              }
            });
            return _context2.finish(13);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 10, 13, 16]]);
    }));
  }, [cachedPages, state.interactionState.isButtonClicked, setFilteredPages, setFilteredMinorTags, formation_teaserview]);
  // Trigger tag selection when tag values change
  useEffect(function () {
    handleTagSelection(state.tagValues.majorTagType, state.tagValues.firstMinorTagType, state.tagValues.majorTagValue, state.tagValues.minorTagValue, state.tagValues.secondMinorTagType);
  }, [handleTagSelection, state.tagValues.majorTagType, state.tagValues.majorTagValue, state.tagValues.firstMinorTagType, state.tagValues.minorTagValue, state.tagValues.secondMinorTagType]);
  /**
   * Handles the search button click
   * Sets the isButtonClicked state to true
   */
  var handleButtonClick = function handleButtonClick() {
    dispatch({
      type: ActionTypes.SET_INTERACTION_STATE,
      payload: {
        isButtonClicked: true
      }
    });
  };
  return /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement("div", {
    className: css$x.container
  }, hasTextContent(text_intro) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text_intro === null || text_intro === void 0 ? void 0 : text_intro.content)
  })), headline && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H3,
    className: css$x.headline
  }, headline)), /*#__PURE__*/React.createElement(Col, {
    className: css$x.wrapper
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  })), /*#__PURE__*/React.createElement("span", {
    className: css$x.select__field_wrapper
  }, currentTagLists.major && currentTagLists.major.map(function (item) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !item.hide_taglist && (/*#__PURE__*/React.createElement(SelectField, {
      key: item._uid,
      majorTagType: state.tagValues.majorTagType,
      tagValue: state.tagValues.majorTagValue,
      setTagValue: function setTagValue(value) {
        return dispatch({
          type: ActionTypes.SET_TAG_VALUES,
          payload: {
            majorTagValue: value
          }
        });
      },
      majorTagOptions: state.majorTagOptions.majorTagOptions,
      all: all,
      setIsButtonClicked: function setIsButtonClicked(value) {
        return dispatch({
          type: ActionTypes.SET_INTERACTION_STATE,
          payload: {
            isButtonClicked: value
          }
        });
      },
      headline: item.headline
    })));
  }), currentTagLists.minor && ((_a = currentTagLists.minor[0]) === null || _a === void 0 ? void 0 : _a.tag_list.map(function (taglistItem) {
    var _a;
    return /*#__PURE__*/React.createElement(SelectField, {
      key: taglistItem._uid,
      firstMinorTagType: state.tagValues.firstMinorTagType,
      tagValue: state.tagValues.minorTagValue,
      setTagValue: function setTagValue(value) {
        return dispatch({
          type: ActionTypes.SET_TAG_VALUES,
          payload: {
            minorTagValue: value
          }
        });
      },
      minorTagOptions: state.minorTagOptions.firstMinorTagOptions.sort(),
      isLoading: state.interactionState.isSelectFieldLoading,
      disabled: state.filteredMinorTags.firstMinorTags.length < 1 && state.tagValues.majorTagValue !== Tags.ALL,
      headline: (_a = currentTagLists.minor[0]) === null || _a === void 0 ? void 0 : _a.headline,
      all: all,
      setIsButtonClicked: function setIsButtonClicked(value) {
        return dispatch({
          type: ActionTypes.SET_INTERACTION_STATE,
          payload: {
            isButtonClicked: value
          }
        });
      }
    });
  })), currentTagLists.minor && ((_b = currentTagLists.minor[1]) === null || _b === void 0 ? void 0 : _b.tag_list.map(function (taglistItem) {
    var _a;
    return /*#__PURE__*/React.createElement(SelectField, {
      key: taglistItem._uid,
      secondMinorTagType: state.tagValues.secondMinorTagType,
      tagValue: state.tagValues.secondMinorTagValue,
      setTagValue: function setTagValue(value) {
        return dispatch({
          type: ActionTypes.SET_TAG_VALUES,
          payload: {
            secondMinorTagValue: value
          }
        });
      },
      minorTagOptions: state.minorTagOptions.secondMinorTagOptions.sort(),
      isLoading: state.interactionState.isSelectFieldLoading,
      disabled: state.filteredMinorTags.secondMinorTags.length < 1,
      headline: (_a = currentTagLists.minor[1]) === null || _a === void 0 ? void 0 : _a.headline,
      all: all,
      setIsButtonClicked: function setIsButtonClicked(value) {
        return dispatch({
          type: ActionTypes.SET_INTERACTION_STATE,
          payload: {
            isButtonClicked: value
          }
        });
      }
    });
  }))), /*#__PURE__*/React.createElement("span", {
    className: css$x.button__wrapper
  }, /*#__PURE__*/React.createElement("button", {
    className: css$x.button,
    onClick: handleButtonClick,
    "aria-label": "Search for pages with the selected tags",
    title: formatMessage({
      id: 'PAGETAGS_SEARCH_BUTTON'
    }),
    disabled: !(major_taglist === null || major_taglist === void 0 ? void 0 : major_taglist.length) && !(taglist === null || taglist === void 0 ? void 0 : taglist.length) || state.tagValues.majorTagValue === Tags.ALL && state.tagValues.minorTagValue === Tags.ALL || state.tagValues.majorTagValue === Tags.ALL && state.tagValues.minorTagValue === ''
  }, formatMessage({
    id: 'PAGETAGS_SEARCH_BUTTON'
  }))))), initialPagesLoading && /*#__PURE__*/React.createElement(PageTagsSearchLoader, null), state.interactionState.showFoundPages && state.filteredPages.length > 0 ? teaserview ? (/*#__PURE__*/React.createElement("span", {
    className: "".concat(css$x.teaser__wrapper, " ").concat(conditionalClassname(state.paginationData.totalPages > 1, css$x.teaser_wrapper__paginated)),
    ref: resultsRef
  }, /*#__PURE__*/React.createElement(TeaserComponent, {
    image_position: image_position,
    view: formation_teaserview,
    showInPageIndex: true,
    separator: false,
    pageIndexTeaser: mapPagesToTeaser(state.paginationData.pages)
  }), state.paginationData.totalPages > 1 && (/*#__PURE__*/React.createElement(Pagination$1, {
    pageSize: state.paginationData.pageSize,
    currentPage: state.paginationData.currentPage,
    totalPages: state.paginationData.totalPages,
    onNextPage: handleNextPage,
    onPreviousPage: handlePreviousPage,
    onPageClick: handlePageClick
  })))) : (/*#__PURE__*/React.createElement("span", {
    className: css$x.link__wrapper
  }, /*#__PURE__*/React.createElement(LinkList, {
    formation: formation,
    links: mapPagesToLinkList(state.filteredPages),
    separator: false
  }))) : state.interactionState.showFoundPages && state.filteredPages.length === 0 && /*#__PURE__*/React.createElement(NoResults, null), state.error && (/*#__PURE__*/React.createElement("p", {
    className: css$x.error__text
  }, formatMessage({
    id: 'PAGETAGS_SEARCH_ERROR'
  }))));
};

var css$w = {"product_tile_slide__slider_row":"ProductTileSlide-module_product_tile_slide__slider_row__vOom0","product_tile_slide__swiper_wrapper_col":"ProductTileSlide-module_product_tile_slide__swiper_wrapper_col__6kYoi","product_tile_slide__arrow_right":"ProductTileSlide-module_product_tile_slide__arrow_right__PdNYh","sub_category_tile_text":"ProductTileSlide-module_sub_category_tile_text__eMtUm","product_tile_slide__slider_item_wrapper":"ProductTileSlide-module_product_tile_slide__slider_item_wrapper__fJBC-","slider_item":"ProductTileSlide-module_slider_item__WuOG-","product_tile_slide__category_title":"ProductTileSlide-module_product_tile_slide__category_title__9f-4a","product_tile_slide__arrow_left":"ProductTileSlide-module_product_tile_slide__arrow_left__Guu2L","product_tile_slide__show_all_link":"ProductTileSlide-module_product_tile_slide__show_all_link__YotP2","product_tile_slide__swiper":"ProductTileSlide-module_product_tile_slide__swiper__Y03DN","product_tile_slide__button_wrapper":"ProductTileSlide-module_product_tile_slide__button_wrapper__0FWAo","product_tile_slide__button":"ProductTileSlide-module_product_tile_slide__button__QDV2Y"};

var ProductTileSlideCategory = function ProductTileSlideCategory(_ref) {
  var sub_categories = _ref.sub_categories,
    title = _ref.title,
    link = _ref.link,
    imagePriority = _ref.imagePriority;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var _useState = useState({
      startSlide: true,
      lastSlide: false
    }),
    disableArrow = _useState[0],
    setDisableArrow = _useState[1];
  var swiperRef = useRef();
  return /*#__PURE__*/React.createElement(Row, {
    className: css$w.product_tile_slide__slider_row
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 2,
    xs: 12,
    className: css$w.product_tile_slide__swiper_wrapper_col
  }, /*#__PURE__*/React.createElement("div", null, link && link.length > 0 && (/*#__PURE__*/React.createElement(Link, {
    title: ((_a = link[0]) === null || _a === void 0 ? void 0 : _a.name) || '',
    href: ((_c = (_b = link[0]) === null || _b === void 0 ? void 0 : _b.link) === null || _c === void 0 ? void 0 : _c.linktype) === 'url' ? (_e = (_d = link[0]) === null || _d === void 0 ? void 0 : _d.link) === null || _e === void 0 ? void 0 : _e.url : (_g = (_f = link[0]) === null || _f === void 0 ? void 0 : _f.link) === null || _g === void 0 ? void 0 : _g.cached_url,
    variant: LinkVariant.Secondary,
    target: TargetValues.Self,
    showExternalIcon: false,
    external: ((_j = (_h = link[0]) === null || _h === void 0 ? void 0 : _h.link) === null || _j === void 0 ? void 0 : _j.linktype) == 'url',
    className: css$w.product_tile_slide__show_all_link,
    piwik_click_id: ((_k = link[0]) === null || _k === void 0 ? void 0 : _k.piwik_click_id) || '',
    anchor: ((_m = (_l = link[0]) === null || _l === void 0 ? void 0 : _l.link) === null || _m === void 0 ? void 0 : _m.anchor) || ''
  }, /*#__PURE__*/React.createElement("div", {
    className: css$w.product_tile_slide__category_title
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, title)), ((_o = link[0]) === null || _o === void 0 ? void 0 : _o.name) || ''))))), /*#__PURE__*/React.createElement(Col, {
    lg: 10,
    className: css$w.product_tile_slide__swiper_wrapper_col
  }, /*#__PURE__*/React.createElement(Swiper, {
    onBeforeInit: function onBeforeInit(swiper) {
      swiperRef.current = swiper;
    },
    wrapperClass: css$w.product_tile_slide__swiper,
    modules: [A11y],
    onSlideChange: function onSlideChange(swiper) {
      setDisableArrow({
        startSlide: swiper.activeIndex === 0,
        lastSlide: swiper.activeIndex === swiper.slides.length - 4
      });
    },
    slidesPerView: 5,
    spaceBetween: 125,
    speed: 800,
    allowTouchMove: true,
    watchOverflow: true,
    slidesPerGroup: 4,
    slidesOffsetAfter: 170,
    slidesOffsetBefore: 50,
    breakpoints: {
      200: {
        spaceBetween: 90
      },
      1200: {
        enabled: true,
        slidesPerView: 4,
        spaceBetween: 125,
        noSwipingSelector: 'button'
      }
    }
  }, sub_categories.map(function (subcategory) {
    var _a, _b, _c, _d;
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: subcategory._uid
    }, /*#__PURE__*/React.createElement("div", {
      className: css$w.product_tile_slide__slider_item_wrapper
    }, /*#__PURE__*/React.createElement(Link, {
      title: subcategory.title,
      variant: LinkVariant.Tertiary,
      external: false,
      href: ((_a = subcategory.link) === null || _a === void 0 ? void 0 : _a.cached_url) || '',
      target: TargetValues.Self
    }, /*#__PURE__*/React.createElement("div", {
      className: css$w.slider_item
    }, /*#__PURE__*/React.createElement(Image, {
      src: generateImageSrc((_c = (_b = subcategory === null || subcategory === void 0 ? void 0 : subcategory.image) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.image),
      alt: ((_d = subcategory.image[0]) === null || _d === void 0 ? void 0 : _d.alt_text) || '',
      imageSizes: subCategoryImageSize,
      priority: imagePriority
    }), /*#__PURE__*/React.createElement("p", {
      className: css$w.sub_category_tile_text
    }, subcategory.title)))));
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(SliderArrow, {
    className: css$w.product_tile_slide__arrow_left,
    disabled: disableArrow.startSlide,
    direction: "left",
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    }
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(SliderArrow, {
    className: css$w.product_tile_slide__arrow_right,
    disabled: disableArrow.lastSlide,
    direction: "right",
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    }
  })))));
};

var ProductTileSlide = function ProductTileSlide(_ref) {
  var product_categories = _ref.product_categories,
    slider_button = _ref.slider_button,
    imagePriority = _ref.imagePriority;
  return /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, product_categories === null || product_categories === void 0 ? void 0 : product_categories.map(function (category) {
    return /*#__PURE__*/React.createElement(ProductTileSlideCategory, {
      sub_categories: category.sub_categories,
      title: category.title,
      _uid: category._uid,
      key: category._uid,
      link: category.link,
      imagePriority: imagePriority
    });
  }), slider_button && (slider_button === null || slider_button === void 0 ? void 0 : slider_button.length) > 0 && (/*#__PURE__*/React.createElement(Row, {
    className: css$w.product_tile_slide__button_wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css$w.product_tile_slide__button
  }, slider_button === null || slider_button === void 0 ? void 0 : slider_button.map(function (link) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      key: link._uid,
      linkType: link
    });
  })))));
};

var QuickInfo = function QuickInfo(_ref) {
  var text = _ref.text,
    view = _ref.view,
    background_color = _ref.background_color,
    info_item = _ref.info_item,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    variant = _ref.variant,
    separator = _ref.separator,
    _ref$text_alignment = _ref.text_alignment,
    text_alignment = _ref$text_alignment === void 0 ? false : _ref$text_alignment,
    button = _ref.button;
  var buttons = useMemo(function () {
    return button === null || button === void 0 ? void 0 : button.map(function (linkElement) {
      return /*#__PURE__*/React.createElement(RenderButtonType, {
        key: linkElement._uid,
        linkType: linkElement,
        onOrangeBackground: onOrangeBackground
      });
    });
  }, [button]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator,
    spacingWithoutSeparator: !separator
  }, /*#__PURE__*/React.createElement(Row, null, text && hasTextContent(text) && (/*#__PURE__*/React.createElement(Col, {
    className: "".concat(css$17.quickInfo__text_wrapper, " ").concat(onOrangeBackground ? css$17.quickInfo__on__orange : '', " ").concat(conditionalClassname(text_alignment, css$17.align_text__left))
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }))), /*#__PURE__*/React.createElement(Col, {
    className: setColumnView(view)
  }, info_item.map(function (item) {
    return /*#__PURE__*/React.createElement(QuickInfoCard, {
      key: item._uid,
      text: item.text,
      headline: item.headline,
      headline_level: item.headline_level,
      image: item.image,
      link: item.link,
      view: view,
      background_color: background_color,
      variant: variant,
      onOrangeBackground: onOrangeBackground,
      text_alignment: text_alignment
    });
  }))), button && (button === null || button === void 0 ? void 0 : button.length) > 0 && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    className: css$17.quickInfo__buttons__wrapper
  }, /*#__PURE__*/React.createElement("div", null, buttons))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$v = {"breakpoints":"'../../../styling/breakpoints.css'","md":"i__const_md_0","lg":"i__const_lg_1","quote__main_wrapper":"Quote-module_quote__main_wrapper__TQCvN","quote_image_wrapper":"Quote-module_quote_image_wrapper__mslPm","quote__image":"Quote-module_quote__image__zbn9K","quote_arrows":"Quote-module_quote_arrows__D9Qa4","quote__arrow_disabled":"Quote-module_quote__arrow_disabled__HdXK6","round__image":"Quote-module_round__image__bQX5r","text__wrapper":"Quote-module_text__wrapper__lvdiy","quote_icon":"Quote-module_quote_icon__kB8Ec","quote__text":"Quote-module_quote__text__vMcDX","quote__name":"Quote-module_quote__name__z3vBy","quote__position":"Quote-module_quote__position__RDaxe","quote__copyright":"Quote-module_quote__copyright__BxSPE","quote__arrow_left":"Quote-module_quote__arrow_left__2AQGO","quote__arrow_right":"Quote-module_quote__arrow_right__dsvPi","quote__on__orange":"Quote-module_quote__on__orange__jrB5I","quote__on__orange__background":"Quote-module_quote__on__orange__background__djQuK","quoteIcon__on__orange":"Quote-module_quoteIcon__on__orange__2omFA","quote__on__orange__bullet":"Quote-module_quote__on__orange__bullet__ZLv5M","quote__bullet":"Quote-module_quote__bullet__P-Vzl","quote__themed_primary":"Quote-module_quote__themed_primary__SdsCY","quote__themed_secondary":"Quote-module_quote__themed_secondary__Wv8vH","quote__themed_color1":"Quote-module_quote__themed_color1__8q1PH","quote__themed_color2":"Quote-module_quote__themed_color2__6dAQO","quote__themed_color3":"Quote-module_quote__themed_color3__LCl91","themed__quoteIcon":"Quote-module_themed__quoteIcon__K384i","quote__bullet_active":"Quote-module_quote__bullet_active__6v98N","themed__quote__bullet_active":"Quote-module_themed__quote__bullet_active__Lsyoa","row__reset":"Quote-module_row__reset__vRWsC","quote_slider_slide__wrapper":"Quote-module_quote_slider_slide__wrapper__bwAiN","multiple__quote":"Quote-module_multiple__quote__lzMx8","quote__image__right":"Quote-module_quote__image__right__I6ZSD"};

var imageExist = function imageExist(quotes) {
  if (Array.isArray(quotes)) {
    return quotes.some(function (quote) {
      return quote.image.length > 0;
    });
  } else {
    return quotes && quotes.image.length > 0;
  }
};
var quoteImageSize = [{
  width: 229,
  height: 229
}, {
  width: 279,
  height: 279
}];

var FallbackProfile = function FallbackProfile(_ref) {
  var image_rectangular = _ref.image_rectangular;
  return image_rectangular ? /*#__PURE__*/React.createElement(RectangularProfile, null) : /*#__PURE__*/React.createElement(CircularProfile, null);
};
var ImageComponent = function ImageComponent(_ref2) {
  var image = _ref2.image,
    image_rectangular = _ref2.image_rectangular,
    variant = _ref2.variant,
    _ref2$onOrnageBackgro = _ref2.onOrnageBackground,
    onOrnageBackground = _ref2$onOrnageBackgro === void 0 ? false : _ref2$onOrnageBackgro,
    imagePriority = _ref2.imagePriority;
  var _a, _b, _c, _d, _e, _f;
  var imageSrc = generateImageSrc(((_c = (_b = (_a = image === null || image === void 0 ? void 0 : image[0]) === null || _a === void 0 ? void 0 : _a.local_image) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.local_image) || ((_d = image === null || image === void 0 ? void 0 : image[0]) === null || _d === void 0 ? void 0 : _d.image));
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$v.quote__image, " ").concat(conditionalClassname(!image_rectangular, css$v.round__image), " ").concat((!onOrnageBackground && variant ? getVariantClassName(variant, css$v, ComponentNames.Quote) : '') || '')
  }, image.length > 0 && imageSrc ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
    src: imageSrc,
    alt: "".concat(image.length ? (_e = image[0]) === null || _e === void 0 ? void 0 : _e.alt_text : 'Profile'),
    className: "".concat(!image_rectangular && css$v.round__image),
    imageSizes: quoteImageSize,
    copyrightText: (_f = image[0]) === null || _f === void 0 ? void 0 : _f.copyright,
    copyrightClassName: "".concat(!image_rectangular ? css$v.quote__copyright : ''),
    priority: imagePriority
  }))) : (/*#__PURE__*/React.createElement(FallbackProfile, {
    image_rectangular: image_rectangular
  })));
};

var QuoteSlider = function QuoteSlider(_ref) {
  var quotes = _ref.quotes,
    image_rectangular = _ref.image_rectangular,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    variant = _ref.variant,
    asset_position = _ref.asset_position,
    imagePriority = _ref.imagePriority;
  var _useState = useState({
      startSlide: true,
      lastSlide: false
    }),
    disableArrow = _useState[0],
    setDisableArrow = _useState[1];
  var hasImage = imageExist(quotes);
  var swiperRef = useRef();
  var a11yData = a11yMessages('Quote');
  return /*#__PURE__*/React.createElement(Swiper, {
    className: "".concat(!onOrangeBackground && variant ? getVariantClassName(variant, css$v, ComponentNames.Quote) : '', " quote__swiper"),
    slidesPerView: 1,
    onBeforeInit: function onBeforeInit(swiper) {
      swiperRef.current = swiper;
    },
    modules: [Pagination, A11y],
    pagination: {
      clickable: true,
      bulletClass: "swiper-pagination-bullet-inactive",
      bulletActiveClass: "".concat(onOrangeBackground ? css$v.quote__on__orange__bullet : css$v.quote__bullet, " ").concat(css$v.quote__bullet_active).concat(variant ? " ".concat(css$v.themed__quote__bullet_active) : '')
    },
    onSlideChange: function onSlideChange(swiper) {
      setDisableArrow({
        startSlide: swiper.isBeginning,
        lastSlide: swiper.isEnd
      });
    },
    a11y: a11yData
  }, quotes.map(function (quote) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: quote._uid
    }, /*#__PURE__*/React.createElement(SingleQuote, {
      quote: quote,
      hasImage: hasImage,
      image_rectangular: image_rectangular,
      className: css$v.multiple__quote,
      onOrangeBackground: onOrangeBackground,
      variant: variant,
      asset_position: asset_position,
      imagePriority: imagePriority
    }));
  }), /*#__PURE__*/React.createElement(SliderArrow, {
    className: chainConditionalClassnames(css$v.quote__arrow_left, onOrangeBackground ? css$v.quote__on__orange__background : '', disableArrow.startSlide ? css$v.quote__arrow_disabled : ''),
    disabled: disableArrow.startSlide,
    direction: "left",
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    },
    onOrangeBackground: onOrangeBackground
  }), /*#__PURE__*/React.createElement(SliderArrow, {
    className: chainConditionalClassnames(css$v.quote__arrow_right, onOrangeBackground ? css$v.quote__on__orange__background : '', disableArrow.lastSlide ? css$v.quote__arrow_disabled : ''),
    disabled: disableArrow.lastSlide,
    direction: "right",
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    },
    onOrangeBackground: onOrangeBackground
  }));
};
var SingleQuote = function SingleQuote(_ref2) {
  var quote = _ref2.quote,
    image_rectangular = _ref2.image_rectangular,
    hasImage = _ref2.hasImage,
    className = _ref2.className,
    _ref2$onOrangeBackgro = _ref2.onOrangeBackground,
    onOrangeBackground = _ref2$onOrangeBackgro === void 0 ? false : _ref2$onOrangeBackgro,
    variant = _ref2.variant,
    asset_position = _ref2.asset_position,
    imagePriority = _ref2.imagePriority;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$v.quote_slider_slide__wrapper, " ").concat(asset_position ? css$v.quote__image__right : '', " ").concat(className ? className : '', " ")
  }, quote && hasImage && (/*#__PURE__*/React.createElement("div", {
    className: css$v.quote_image_wrapper
  }, /*#__PURE__*/React.createElement(ImageComponent, {
    image_rectangular: image_rectangular,
    image: quote === null || quote === void 0 ? void 0 : quote.image,
    variant: variant,
    onOrnageBackground: onOrangeBackground,
    imagePriority: imagePriority
  }))), /*#__PURE__*/React.createElement("div", {
    className: css$v.text__wrapper
  }, /*#__PURE__*/React.createElement(QuoteIcon, {
    className: chainConditionalClassnames(onOrangeBackground ? css$v.quoteIcon__on__orange : '', css$v.themed__quoteIcon, variant ? getVariantClassName(variant, css$v, ComponentNames.Quote) : '')
  }), (quote === null || quote === void 0 ? void 0 : quote.text) && (/*#__PURE__*/React.createElement("blockquote", {
    className: css$v.quote__text
  }, quote === null || quote === void 0 ? void 0 : quote.text)), /*#__PURE__*/React.createElement(Headline, {
    tag: 'h3',
    hasAnchor: false,
    className: "".concat(css$v.quote__name, " ").concat(variant ? getVariantClassName(variant, css$v, ComponentNames.Quote) : '', "\n      ")
  }, quote === null || quote === void 0 ? void 0 : quote.name), /*#__PURE__*/React.createElement("p", {
    className: "".concat(css$v.quote__position, " ").concat(variant ? getVariantClassName(variant, css$v, ComponentNames.Quote) : '')
  }, quote === null || quote === void 0 ? void 0 : quote.position)));
};

var QuoteComponent = function QuoteComponent(_ref) {
  var text = _ref.text,
    quotes = _ref.quotes,
    separator = _ref.separator,
    image_rectangular = _ref.image_rectangular,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    variant = _ref.variant,
    asset_position = _ref.asset_position,
    imagePriority = _ref.imagePriority;
  var hasImage = imageExist(quotes);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator,
    spacingWithoutSeparator: !separator,
    className: onOrangeBackground ? css$v.quote__on__orange : ''
  }, /*#__PURE__*/React.createElement(Row, {
    className: css$v.row__reset
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }))), /*#__PURE__*/React.createElement(Col, null, quotes.length > 1 ? (/*#__PURE__*/React.createElement(QuoteSlider, {
    quotes: quotes,
    image_rectangular: image_rectangular,
    onOrangeBackground: onOrangeBackground,
    variant: variant,
    asset_position: asset_position,
    imagePriority: imagePriority
  })) : (/*#__PURE__*/React.createElement(SingleQuote, {
    hasImage: hasImage,
    quote: quotes[0],
    image_rectangular: image_rectangular,
    onOrangeBackground: onOrangeBackground,
    variant: variant,
    asset_position: asset_position,
    imagePriority: imagePriority
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var Slider = function Slider(_ref) {
  var image_position_left = _ref.image_position_left,
    separator = _ref.separator,
    slides = _ref.slides,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    text = _ref.text,
    variant = _ref.variant,
    asset_ratio = _ref.asset_ratio,
    button = _ref.button,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou;
  var _useState = useState({
      isStartSlide: true,
      isLastSlide: false
    }),
    disable = _useState[0],
    setSliderArrowState = _useState[1];
  var buttons = useMemo(function () {
    return button === null || button === void 0 ? void 0 : button.map(function (linkElement) {
      return /*#__PURE__*/React.createElement(RenderButtonType, {
        key: linkElement._uid,
        linkType: linkElement,
        onOrangeBackground: onOrangeBackground
      });
    });
  }, [button]);
  var swiperRef = useRef();
  var a11yData = a11yMessages('Slider');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: !separator
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  })))), /*#__PURE__*/React.createElement(Row, {
    className: "".concat(css$J.main__wrapper, " ").concat(image_position_left ? css$J.slider__image_right : '', " ").concat(variant ? getVariantClassName(variant, css$J, ComponentNames.Slider) : '')
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Swiper, {
    key: "".concat(autoplay ? 'with' : 'without', "-autoplay"),
    className: "".concat(css$J.slider__wrapper, " ").concat(variant ? getVariantClassName(variant, css$J, ComponentNames.Slider) : '', " slider__swiper"),
    autoplay: autoplay && {
      pauseOnMouseEnter: true,
      delay: 2500
    },
    onSlideChange: function onSlideChange(swiper) {
      setSliderArrowState({
        isLastSlide: swiper.isEnd,
        isStartSlide: swiper.isBeginning
      });
    },
    slidesPerView: 1,
    onBeforeInit: function onBeforeInit(swiper) {
      swiperRef.current = swiper;
    },
    modules: [Autoplay, Pagination, A11y],
    pagination: {
      clickable: true,
      bulletClass: "".concat(css$J.pagination_bullet),
      bulletActiveClass: "".concat(css$J.pagination_bullet_active).concat(variant ? " ".concat(css$J.themed_pagination_bullet_active) : '')
    },
    a11y: a11yData
  }, slides.map(function (slide) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: "".concat(slide._uid, "_slide")
    }, /*#__PURE__*/React.createElement(SliderSlides, {
      imageRight: image_position_left,
      asset: slide.asset,
      links: slide.links,
      text: slide.text,
      caption: slide.caption,
      variant: variant,
      assetRatio: asset_ratio
    }));
  }), /*#__PURE__*/React.createElement(SliderArrow, {
    className: "".concat(css$J.slider__arrows, " ").concat(variant ? getVariantClassName(variant, css$J, ComponentNames.Slider) : ''),
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    },
    direction: "left",
    disabled: disable === null || disable === void 0 ? void 0 : disable.isStartSlide
  }), /*#__PURE__*/React.createElement(SliderArrow, {
    className: css$J.slider__arrows,
    clickHandler: function clickHandler() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    },
    direction: "right",
    disabled: disable === null || disable === void 0 ? void 0 : disable.isLastSlide
  })))), button && (button === null || button === void 0 ? void 0 : button.length) > 0 && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: css$J.slider__buttons__wrapper
  }, buttons))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$u = {"image_container__wrapper":"Table-module_image_container__wrapper__uY1UH","asset__right":"Table-module_asset__right__aF2Cl","table":"Table-module_table__6h1is","tablecell":"Table-module_tablecell__t1GiP","tablehead":"Table-module_tablehead__3Q2vw","button__wrapper":"Table-module_button__wrapper__E3KN2","form__landing_page__wrapper":"Table-module_form__landing_page__wrapper__ZpFqA","center":"Table-module_center__Nvc2r"};

var formattedTableText = function formattedTableText(text, key) {
  var marks = {
    b: function b(text) {
      return /*#__PURE__*/React.createElement("strong", {
        key: key
      }, text);
    },
    i: function i(text) {
      return /*#__PURE__*/React.createElement("em", {
        key: key
      }, text);
    },
    u: function u(text) {
      return /*#__PURE__*/React.createElement("u", {
        key: key
      }, text);
    },
    sub: function sub(text) {
      return /*#__PURE__*/React.createElement("sub", {
        key: key
      }, text);
    },
    sup: function sup(text) {
      return /*#__PURE__*/React.createElement("sup", {
        key: key
      }, text);
    },
    link: function link(text, href) {
      return /*#__PURE__*/React.createElement(Link, {
        key: key,
        href: href || '',
        variant: LinkVariant.Primary,
        title: text,
        target: TargetValues.Self,
        external: true,
        showExternalIcon: false
      }, /*#__PURE__*/React.createElement(React.Fragment, null, text));
    },
    center: function center(text) {
      return /*#__PURE__*/React.createElement("div", {
        key: key,
        className: css$u.center
      }, text);
    }
  };
  var _renderFormattedText = function renderFormattedText(inputText) {
    var tagPattern = /\[(.*?)(?:="(.*?)")?\](.*?)\[\/\1\]/g;
    var segments = _toConsumableArray(inputText.matchAll(tagPattern));
    var lastIndex = 0;
    var formattedTextComponents = segments.flatMap(function (segment) {
      var _a, _b;
      var _segment = _slicedToArray(segment, 4),
        fullMatch = _segment[0],
        tagName = _segment[1],
        tagAttribute = _segment[2],
        innerText = _segment[3];
      var textBeforeTag = inputText.substring(lastIndex, segment.index);
      lastIndex = ((_a = segment === null || segment === void 0 ? void 0 : segment.index) !== null && _a !== void 0 ? _a : 0) + fullMatch.length;
      var components = [];
      if (textBeforeTag) {
        components.push(textBeforeTag);
      }
      if (tagName && marks[tagName] && innerText) {
        var formattedText = (_b = marks[tagName]) === null || _b === void 0 ? void 0 : _b.call(marks, tagPattern.test(innerText) ? _renderFormattedText(innerText) : innerText, tagAttribute);
        components.push(formattedText);
      }
      return components;
    });
    var textAfterLastTag = inputText.substring(lastIndex);
    if (textAfterLastTag) {
      formattedTextComponents.push(textAfterLastTag);
    }
    var textComponent = formattedTextComponents.map(function (text) {
      if (typeof text === 'string') {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: key
        }, text);
      }
      if (/*#__PURE__*/React.isValidElement(text)) {
        return /*#__PURE__*/React.cloneElement(text, {
          key: key
        });
      }
      return null;
    });
    return textComponent;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: key
  }, _renderFormattedText(text));
};

var Table = function Table(_ref) {
  var asset = _ref.asset,
    headline = _ref.headline,
    headline_level = _ref.headline_level,
    separator = _ref.separator,
    asset_position = _ref.asset_position,
    table = _ref.table,
    caption = _ref.caption,
    _ref$noSpacingGrid = _ref.noSpacingGrid,
    noSpacingGrid = _ref$noSpacingGrid === void 0 ? false : _ref$noSpacingGrid,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    asset_ratio = _ref.asset_ratio,
    button = _ref.button,
    text = _ref.text,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    className: conditionalClassname(onOrangeBackground, css$u.form__landing_page__wrapper)
  }, headline && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Headline, {
    tag: headline_level || 'h2',
    variant: variant
  }, headline || '')))), /*#__PURE__*/React.createElement(Row, {
    className: conditionalClassname(!!asset_position, css$u.asset__right)
  }, asset && (/*#__PURE__*/React.createElement(Col, {
    md: 4,
    lg: 4,
    className: css$u.image_container__wrapper
  }, renderAsset({
    asset: asset,
    caption: caption,
    headline: headline,
    assetRatio: asset_ratio,
    componentType: RenderAssetOnComponent.TEXT_IMAGE_TWO_COLUMN
  }))), /*#__PURE__*/React.createElement(Col, {
    md: asset && asset.length > 0 ? 8 : 12,
    lg: asset && asset.length > 0 ? 8 : 12
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: css$u.table
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, table.thead.map(function (tablecell) {
    return /*#__PURE__*/React.createElement("th", {
      key: tablecell._uid,
      className: "".concat(css$u.tablecell, " ").concat(css$u.tablehead)
    }, formattedTableText(tablecell.value, tablecell._uid));
  }))), /*#__PURE__*/React.createElement("tbody", null, table.tbody.map(function (tablerow) {
    return /*#__PURE__*/React.createElement("tr", {
      key: tablerow._uid
    }, tablerow.body.map(function (tablecell) {
      return /*#__PURE__*/React.createElement("td", {
        key: tablecell._uid,
        className: css$u.tablecell
      }, formattedTableText(tablecell.value, tablecell._uid));
    }));
  })))), button && (button === null || button === void 0 ? void 0 : button.length) > 0 && (/*#__PURE__*/React.createElement("div", {
    className: css$u.button__wrapper
  }, button === null || button === void 0 ? void 0 : button.map(function (linkElement) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      key: linkElement._uid,
      linkType: linkElement,
      onOrangeBackground: onOrangeBackground
    });
  })))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$t = {"team__overview__wrapper":"TeamOverview-module_team__overview__wrapper__P9nTu","team__image__wrapper":"TeamOverview-module_team__image__wrapper__BOY50","fallback__profile":"TeamOverview-module_fallback__profile__ZxkVF","team__text__anchor":"TeamOverview-module_team__text__anchor__vzwuI","team__text__wrapper":"TeamOverview-module_team__text__wrapper__nUqHq","team__overview__truncate":"TeamOverview-module_team__overview__truncate__luvoG","team__email":"TeamOverview-module_team__email__POwcd","team__department":"TeamOverview-module_team__department__1-vCh","team__contact__wrapper":"TeamOverview-module_team__contact__wrapper__XRodU","team__two__column":"TeamOverview-module_team__two__column__BQGUd","team__three__column":"TeamOverview-module_team__three__column__spdPB"};

var teamOverviewImgSize = [{
  width: 150,
  height: 150
}];
var getJobTitleAndDepartment = function getJobTitleAndDepartment(department, jobTitle) {
  var result = '';
  if (department) {
    result += department;
  }
  if (department && jobTitle) {
    result += ', ';
  }
  if (jobTitle) {
    result += jobTitle;
  }
  return result;
};

var TeamOverview = function TeamOverview(_ref) {
  var contacts = _ref.contacts,
    team_email_adress = _ref.team_email_adress,
    text = _ref.text,
    _ref$three_columns = _ref.three_columns,
    three_columns = _ref$three_columns === void 0 ? false : _ref$three_columns;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(new Map()),
    renderContacts = _useState[0],
    setRenderContacts = _useState[1];
  var router = useRouter();
  var isEditor = router.asPath.includes('/editor/');
  var locale = isEditor ? router.asPath.split('/')[2] : router.locale;
  // TODO: refactor when NEXT_PUBLIC_MIDDLEWARE_URL is fixed on live environment
  var middlewareBaseURL = 'https://storyblok-cms-middleware.orange.igus.net';
  var env = process.env.NEXT_PUBLIC_WEB_HOSTNAME;
  if (env && env !== 'www') {
    middlewareBaseURL = process.env.NEXT_PUBLIC_MIDDLEWARE_URL;
  }
  var tagContacts = contacts.filter(function (item) {
    var _a;
    return ((_a = item === null || item === void 0 ? void 0 : item.contact[0]) === null || _a === void 0 ? void 0 : _a.component) === 'tag_selection_contact';
  });
  var selectedContacts = contacts.filter(function (item) {
    var _a;
    return ((_a = item === null || item === void 0 ? void 0 : item.contact[0]) === null || _a === void 0 ? void 0 : _a.component) === 'contacts';
  });
  var updateTeamContacts = function updateTeamContacts() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var newContacts, fetchPromises;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            newContacts = new Map(); // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            Array.isArray(selectedContacts) && selectedContacts.forEach(function (item) {
              var _a;
              var headline = item === null || item === void 0 ? void 0 : item.headline;
              var contacts = (_a = item === null || item === void 0 ? void 0 : item.contact[0]) === null || _a === void 0 ? void 0 : _a.contacts;
              contacts === null || contacts === void 0 ? void 0 : contacts.forEach(function (contact) {
                contact.content.region_headline = headline;
                newContacts.set(contact.name, contact);
              });
            });
            fetchPromises = tagContacts.map(function (contactItem) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var headline, tagData, sendData, fetchHeaders, urlPath, tagContacts;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      headline = contactItem.headline;
                      tagData = Array.isArray(contactItem === null || contactItem === void 0 ? void 0 : contactItem.contact) && (contactItem === null || contactItem === void 0 ? void 0 : contactItem.contact[0]);
                      if (tagData) {
                        _context.next = 4;
                        break;
                      }
                      return _context.abrupt("return");
                    case 4:
                      sendData = {
                        region: tagData.region,
                        products: tagData.products,
                        department: tagData.department
                      };
                      fetchHeaders = {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(sendData)
                      };
                      urlPath = "".concat(middlewareBaseURL, "/contact/tag/").concat(locale);
                      _context.next = 9;
                      return fetchUtil(urlPath, fetchHeaders);
                    case 9:
                      tagContacts = _context.sent;
                      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                      Array.isArray(tagContacts) && tagContacts.forEach(function (contact) {
                        contact.content.region_headline = headline;
                        newContacts.set(contact.name, contact);
                      });
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
            });
            _context2.next = 5;
            return Promise.all(fetchPromises);
          case 5:
            setRenderContacts(newContacts);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
  useEffect(function () {
    updateTeamContacts();
  }, [contacts]);
  var teamContacts = Array.from(renderContacts.values());
  return /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, text && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$t.team__overview__wrapper, " ").concat(team_email_adress ? css$t.team__email : '', " ").concat(three_columns ? css$t.team__three__column : css$t.team__two__column)
  }, (teamContacts === null || teamContacts === void 0 ? void 0 : teamContacts.length) > 0 && (teamContacts === null || teamContacts === void 0 ? void 0 : teamContacts.map(function (contactItem) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    return /*#__PURE__*/React.createElement("div", {
      key: contactItem.uuid,
      className: css$t.team__contact__wrapper
    }, ((_c = (_b = (_a = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _a === void 0 ? void 0 : _a.image[0]) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.item) ? (/*#__PURE__*/React.createElement("div", {
      className: css$t.team__image__wrapper
    }, /*#__PURE__*/React.createElement(Image, {
      src: generateImageSrc((_e = (_d = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _d === void 0 ? void 0 : _d.image[0]) === null || _e === void 0 ? void 0 : _e.image),
      alt: (_g = (_f = contactItem.content) === null || _f === void 0 ? void 0 : _f.image[0]) === null || _g === void 0 ? void 0 : _g.alt_text,
      imageSizes: teamOverviewImgSize,
      copyrightText: (_j = (_h = contactItem.content) === null || _h === void 0 ? void 0 : _h.image[0]) === null || _j === void 0 ? void 0 : _j.copyright
    }))) : (/*#__PURE__*/React.createElement("div", {
      className: "".concat(css$t.team__image__wrapper, " ").concat(css$t.fallback__profile)
    }, /*#__PURE__*/React.createElement(FallbackProfile$1, null))), /*#__PURE__*/React.createElement("div", {
      className: css$t.team__text__wrapper
    }, ((_k = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _k === void 0 ? void 0 : _k.region_headline) && (/*#__PURE__*/React.createElement(Headline, {
      tag: HeadlineTags.H3
    }, (_l = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _l === void 0 ? void 0 : _l.region_headline)), ((_m = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _m === void 0 ? void 0 : _m.first_name) && (/*#__PURE__*/React.createElement(Headline, {
      className: css$t.team__overview__truncate,
      title: (_o = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _o === void 0 ? void 0 : _o.name,
      tag: HeadlineTags.H6
    }, getFullName((_p = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _p === void 0 ? void 0 : _p.first_name, (_q = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _q === void 0 ? void 0 : _q.last_name))), ((_r = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _r === void 0 ? void 0 : _r.company) && contactItem.content.component === 'contact_company' && (/*#__PURE__*/React.createElement(Headline, {
      className: css$t.team__overview__truncate,
      title: (_s = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _s === void 0 ? void 0 : _s.name,
      tag: HeadlineTags.H6
    }, (_t = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _t === void 0 ? void 0 : _t.company)), ((_u = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _u === void 0 ? void 0 : _u.job_title) || ((_v = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _v === void 0 ? void 0 : _v.select_department) ? (/*#__PURE__*/React.createElement("p", {
      title: getJobTitleAndDepartment((_w = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _w === void 0 ? void 0 : _w.select_department, (_x = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _x === void 0 ? void 0 : _x.job_title),
      className: "".concat(css$t.team__overview__truncate, " ").concat(css$t.team__department)
    }, getJobTitleAndDepartment((_y = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _y === void 0 ? void 0 : _y.select_department, (_z = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _z === void 0 ? void 0 : _z.job_title))) : null, ((_0 = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _0 === void 0 ? void 0 : _0.phone) && (/*#__PURE__*/React.createElement(Link, {
      href: (_1 = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _1 === void 0 ? void 0 : _1.phone,
      target: TargetValues.Blank,
      title: (_2 = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _2 === void 0 ? void 0 : _2.phone,
      className: css$t.team__text__anchor,
      variant: LinkVariant.Secondary,
      external: true,
      showExternalIcon: false,
      contact_type: ContactType.Phone
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PhoneIcon, null), (_3 = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _3 === void 0 ? void 0 : _3.phone))), ((_4 = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _4 === void 0 ? void 0 : _4.email) && isValidEmail((_5 = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _5 === void 0 ? void 0 : _5.email) && (/*#__PURE__*/React.createElement(Link, {
      href: (_6 = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _6 === void 0 ? void 0 : _6.email,
      target: TargetValues.Blank,
      title: (_7 = contactItem === null || contactItem === void 0 ? void 0 : contactItem.content) === null || _7 === void 0 ? void 0 : _7.email,
      className: css$t.team__text__anchor,
      variant: LinkVariant.Secondary,
      external: true,
      showExternalIcon: false,
      contact_type: ContactType.Email
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmailIcon, null), ' ', formatMessage({
      id: 'TEAM_OVERVIEW_SEND_EMAIL_TEXT'
    }))))));
  }))))), team_email_adress && (/*#__PURE__*/React.createElement(Row, {
    className: css$t.team__email__wrapper
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(team_email_adress.content)
  })))));
};

var css$s = {"breakpoints":"'../../../styling/breakpoints.css'","md":"i__const_md_0","lg":"i__const_lg_1","teaserBig__asset__wrapper":"TeaserBig-module_teaserBig__asset__wrapper__AvVVF","teaserBig__teaser__wrapper":"TeaserBig-module_teaserBig__teaser__wrapper__4tk8h","teaserBig__main__themed_primary":"TeaserBig-module_teaserBig__main__themed_primary__wejcv","teaserBig__main__themed_secondary":"TeaserBig-module_teaserBig__main__themed_secondary__WgVeu","teaserBig__main__themed_color1":"TeaserBig-module_teaserBig__main__themed_color1__u7WpS","teaserBig__main__themed_color2":"TeaserBig-module_teaserBig__main__themed_color2__9UoKQ","single__teaser__themed_primary":"TeaserBig-module_single__teaser__themed_primary__RQi-Z","single__teaser__themed_secondary":"TeaserBig-module_single__teaser__themed_secondary__tDxRP","single__teaser__themed_color1":"TeaserBig-module_single__teaser__themed_color1__8N-Sz","single__teaser__themed_color2":"TeaserBig-module_single__teaser__themed_color2__OR-VB","image__outline__themed_primary":"TeaserBig-module_image__outline__themed_primary__yiBnP","image__outline__themed_secondary":"TeaserBig-module_image__outline__themed_secondary__8QcQM","image__outline__themed_color1":"TeaserBig-module_image__outline__themed_color1__IBjES","image__outline__themed_color2":"TeaserBig-module_image__outline__themed_color2__dDFmR","teaserBig__asset__text__wrapper":"TeaserBig-module_teaserBig__asset__text__wrapper__s9aj6","teaserBig__asset__position":"TeaserBig-module_teaserBig__asset__position__PdFxb","teaserBig__text__wrapper":"TeaserBig-module_teaserBig__text__wrapper__1gpQT","teaserBig__link__wrapper":"TeaserBig-module_teaserBig__link__wrapper__I2dSf","teaserBig__collection__button":"TeaserBig-module_teaserBig__collection__button__WUwm4","themed__anchor__text":"TeaserBig-module_themed__anchor__text__avV5D","download_link_button__themed_primary":"TeaserBig-module_download_link_button__themed_primary__Jz4pW","download_link_button__themed_secondary":"TeaserBig-module_download_link_button__themed_secondary__T2ULl","download_link_button__themed_color1":"TeaserBig-module_download_link_button__themed_color1__BGiC8","download_link_button__themed_color2":"TeaserBig-module_download_link_button__themed_color2__P1M3j","themed__button__width":"TeaserBig-module_themed__button__width__FvZJH","download_link__primary":"TeaserBig-module_download_link__primary__L8Wyc","download_link_button__transparent":"TeaserBig-module_download_link_button__transparent__-1o9L","download_link__secondary":"TeaserBig-module_download_link__secondary__lJAjN","teaserBig__on__orange__background":"TeaserBig-module_teaserBig__on__orange__background__E6SRH","teaserBig__main__themed_primary_font":"TeaserBig-module_teaserBig__main__themed_primary_font__RZBtr","single__teaser__themed_primary_font":"TeaserBig-module_single__teaser__themed_primary_font__k0-NV","teaserBig__main__themed_secondary_font":"TeaserBig-module_teaserBig__main__themed_secondary_font__JN9n4","single__teaser__themed_secondary_font":"TeaserBig-module_single__teaser__themed_secondary_font__TnVXP","teaserBig__main__themed_color1_font":"TeaserBig-module_teaserBig__main__themed_color1_font__-bnw-","single__teaser__themed_color1_font":"TeaserBig-module_single__teaser__themed_color1_font__SK4ra","teaserBig__main__themed_color2_font":"TeaserBig-module_teaserBig__main__themed_color2_font__4moAn","single__teaser__themed_color2_font":"TeaserBig-module_single__teaser__themed_color2_font__QRINK","teaserBig__teaser":"TeaserBig-module_teaserBig__teaser__bHR6R","teaserBig__teaser__headline":"TeaserBig-module_teaserBig__teaser__headline__DcGXq","teaserBig__align__buttons":"TeaserBig-module_teaserBig__align__buttons__mpNGO"};

var TeaserBigThemeSection;
(function (TeaserBigThemeSection) {
  TeaserBigThemeSection["MAINBACKGROUND"] = "teaserBig__main";
  TeaserBigThemeSection["SINGLETEASER"] = "single__teaser";
  TeaserBigThemeSection["IMAGEOUTLINE"] = "image__outline";
})(TeaserBigThemeSection || (TeaserBigThemeSection = {}));

var TeaserBig = function TeaserBig(_ref) {
  var separator = _ref.separator,
    text = _ref.text,
    asset_ratio = _ref.asset_ratio,
    background_color = _ref.background_color,
    teaser_button = _ref.teaser_button,
    teaser = _ref.teaser,
    align_buttons = _ref.align_buttons,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    exclude_from_toc = _ref.exclude_from_toc;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator,
    spacingWithoutSeparator: !separator,
    className: "".concat(onOrangeBackground ? css$s.teaserBig__on__orange__background : '')
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(background_color ? getVariantClassName(background_color, css$s, TeaserBigThemeSection.MAINBACKGROUND) : '')
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content),
    exclude_from_toc: exclude_from_toc
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$s.teaserBig__teaser__wrapper)
  }, (teaser === null || teaser === void 0 ? void 0 : teaser.length) > 0 && (teaser === null || teaser === void 0 ? void 0 : teaser.map(function (teaserElement) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    return /*#__PURE__*/React.createElement("div", {
      key: teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement._uid,
      className: "".concat(css$s.teaserBig__teaser, " ").concat((teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.background) ? getVariantClassName(teaserElement.background, css$s, TeaserBigThemeSection.SINGLETEASER) : '')
    }, (teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.headline) && (/*#__PURE__*/React.createElement(Headline, {
      tag: HeadlineTags.H2,
      className: css$s.teaserBig__teaser__headline,
      variant: teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.variant
    }, teaserElement.headline)), /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$s.teaserBig__asset__text__wrapper, " ").concat(conditionalClassname(
      // eslint-disable-next-line
      teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.asset_position, css$s.teaserBig__asset__position))
    }, (teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.asset) && ((_a = teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.asset) === null || _a === void 0 ? void 0 : _a.length) > 0 && (/*#__PURE__*/React.createElement("div", {
      className: css$s.teaserBig__asset__wrapper
    }, isImageClickable(teaserElement) ? (/*#__PURE__*/React.createElement(Link, {
      target: ((_d = (_c = (_b = teaserElement.links) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.link) === null || _d === void 0 ? void 0 : _d.target) || TargetValues.Self,
      title: "",
      variant: LinkVariant.Primary,
      href: ((_g = (_f = (_e = teaserElement.links) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.link) === null || _g === void 0 ? void 0 : _g.url) || ((_l = (_k = (_j = (_h = teaserElement.links) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.link) === null || _k === void 0 ? void 0 : _k.story) === null || _l === void 0 ? void 0 : _l.url) || ((_p = (_o = (_m = teaserElement.links) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.link) === null || _p === void 0 ? void 0 : _p.cached_url) || ((_t = (_s = (_r = (_q = teaserElement.links) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.asset) === null || _s === void 0 ? void 0 : _s.item) === null || _t === void 0 ? void 0 : _t.embed_link) || ''
    }, renderAsset({
      assetRatio: asset_ratio,
      asset: teaserElement.asset,
      componentType: RenderAssetOnComponent.TEASER_BIG,
      showOutline: teaserElement.outline_variant ? true : false,
      variant: teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.outline_variant,
      imageNotClickable: !isImageClickable(teaserElement)
    }))) : renderAsset({
      assetRatio: asset_ratio,
      asset: teaserElement.asset,
      componentType: RenderAssetOnComponent.TEASER_BIG,
      showOutline: teaserElement.outline_variant ? true : false,
      variant: teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.outline_variant,
      imageNotClickable: !isImageClickable(teaserElement)
    }))), /*#__PURE__*/React.createElement("div", {
      className: "".concat(conditionalClassname(
      // eslint-disable-next-line
      teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.asset_position, css$s.teaserBig__text__wrapper), " ").concat(conditionalClassname(align_buttons, css$s.teaserBig__align__buttons))
    }, hasTextContent(teaserElement.text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
      content: mappedProps((_u = teaserElement.text) === null || _u === void 0 ? void 0 : _u.content)
    })), /*#__PURE__*/React.createElement("div", {
      className: css$s.teaserBig__link__wrapper
    }, (teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.links) && ((_v = teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.links) === null || _v === void 0 ? void 0 : _v.length) > 0 && ((_w = teaserElement === null || teaserElement === void 0 ? void 0 : teaserElement.links) === null || _w === void 0 ? void 0 : _w.map(function (link) {
      return /*#__PURE__*/React.createElement("div", {
        key: link._uid,
        className: "".concat(conditionalClassname(buttonVariants.includes(link.variant), css$s.themed__button__width), " ").concat(css$s.teaserBig__link__wrapper)
      }, /*#__PURE__*/React.createElement(RenderButtonType, {
        linkType: link,
        className: chainConditionalClassnames(conditionalClassname(link.variant === LinkVariant.Primary, css$s.download_link__primary), conditionalClassname(link.variant === LinkVariant.Secondary, css$s.download_link__secondary), conditionalClassname(link.variant === LinkVariant.Button, css$s.download_link_button__themed_primary), conditionalClassname(link.variant === LinkVariant.ButtonSecondary, css$s.download_link_button__themed_secondary), conditionalClassname(link.variant === LinkVariant.ButtonThemingColor1, css$s.download_link_button__themed_color1), conditionalClassname(link.variant === LinkVariant.ButtonThemingColor2, css$s.download_link_button__themed_color2), conditionalClassname(link.variant === LinkVariant.ButtonTransparent, css$s.download_link_button__transparent))
      }));
    }))))));
  }))), teaser_button && (teaser_button === null || teaser_button === void 0 ? void 0 : teaser_button.length) > 0 && (/*#__PURE__*/React.createElement("div", {
    className: css$s.teaserBig__collection__button
  }, teaser_button === null || teaser_button === void 0 ? void 0 : teaser_button.map(function (link) {
    return /*#__PURE__*/React.createElement(RenderButtonType, {
      key: link._uid,
      linkType: link
    });
  }))))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$r = {"text__on__orange__background":"Text-module_text__on__orange__background__NwZCP"};

var Text = function Text(_ref) {
  var text = _ref.text,
    separator = _ref.separator,
    _ref$noSpacingGrid = _ref.noSpacingGrid,
    noSpacingGrid = _ref$noSpacingGrid === void 0 ? false : _ref$noSpacingGrid,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    className: "".concat(onOrangeBackground ? css$r.text__on__orange__background : '')
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$q = {"textImage_contents":"TextImageThreeColumn-module_textImage_contents__AeEAS","text__content__gap":"TextImageThreeColumn-module_text__content__gap__Ze-be","textImage_col_asset__position":"TextImageThreeColumn-module_textImage_col_asset__position__njwRl","textImageThree_centerText":"TextImageThreeColumn-module_textImageThree_centerText__0za6-","center_headline":"TextImageThreeColumn-module_center_headline__EfoZ7","textImageThreeColumn__contents":"TextImageThreeColumn-module_textImageThreeColumn__contents__KymlD","textImageFourColumn__contents":"TextImageThreeColumn-module_textImageFourColumn__contents__m-BrA","textImageFourColumn__col":"TextImageThreeColumn-module_textImageFourColumn__col__iPBZq"};

var TextImageRatio;
(function (TextImageRatio) {
  TextImageRatio["LARGE"] = "large";
})(TextImageRatio || (TextImageRatio = {}));
var TextImageColumn = function TextImageColumn(_ref) {
  var columns = _ref.columns,
    numColumns = _ref.numColumns,
    headline = _ref.headline,
    headline_level = _ref.headline_level,
    noSpacingGrid = _ref.noSpacingGrid,
    separator = _ref.separator,
    _ref$asset_ratio = _ref.asset_ratio,
    asset_ratio = _ref$asset_ratio === void 0 ? TextImageRatio.LARGE : _ref$asset_ratio,
    variant = _ref.variant,
    center = _ref.center,
    exclude_from_toc = _ref.exclude_from_toc;
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid
  }, headline && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Headline, {
    tag: headline_level || '',
    variant: variant,
    className: center ? css$q.center_headline : '',
    exclude_from_toc: exclude_from_toc
  }, headline || '')))), /*#__PURE__*/React.createElement(Row, {
    className: numColumns === 3 ? css$q.textImageThreeColumn__contents : css$q.textImageFourColumn__contents
  }, columns && columns.length > 0 && columns.map(function (column) {
    var _a;
    return /*#__PURE__*/React.createElement(Col, {
      key: column._uid,
      lg: 12 / numColumns,
      md: numColumns === 3 ? 12 / numColumns : 6,
      className: conditionalClassname(numColumns === 4, css$q.textImageFourColumn__col)
    }, /*#__PURE__*/React.createElement("span", {
      className: chainConditionalClassnames(conditionalClassname(!!column.asset_position, css$q.textImage_col_asset__position), css$q.textImage_contents)
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(hasTextContent(column.text) ? css$q.text__content__gap : '', ",\n                    ").concat(center ? css$q.textImageThree_centerText : '', "\n                    ")
    }, hasTextContent(column.text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
      content: mappedProps((_a = column.text) === null || _a === void 0 ? void 0 : _a.content)
    }))), /*#__PURE__*/React.createElement("div", null, column.asset && renderAsset({
      asset: column.asset,
      caption: column.caption,
      assetRatio: column.asset_ratio || asset_ratio,
      componentType: numColumns,
      showOutline: column.outline_variant ? true : false,
      variant: column.outline_variant,
      center: center
    }))), column.button && column.button.length > 0 && column.button.map(function (linkElement) {
      return /*#__PURE__*/React.createElement(RenderButtonType, {
        key: linkElement._uid,
        linkType: linkElement
      });
    }));
  }))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var TextImageFourColumn = function TextImageFourColumn(_ref) {
  var columns = _ref.columns,
    headline = _ref.headline,
    headline_level = _ref.headline_level,
    noSpacingGrid = _ref.noSpacingGrid,
    separator = _ref.separator,
    asset_ratio = _ref.asset_ratio,
    variant = _ref.variant,
    exclude_from_toc = _ref.exclude_from_toc;
  return /*#__PURE__*/React.createElement(TextImageColumn, {
    numColumns: 4,
    columns: columns,
    headline: headline,
    headline_level: headline_level,
    noSpacingGrid: noSpacingGrid,
    separator: separator,
    asset_ratio: asset_ratio,
    variant: variant,
    exclude_from_toc: exclude_from_toc
  });
};

var TextImageThreeColumn = function TextImageThreeColumn(_ref) {
  var columns = _ref.columns,
    headline = _ref.headline,
    headline_level = _ref.headline_level,
    noSpacingGrid = _ref.noSpacingGrid,
    separator = _ref.separator,
    asset_ratio = _ref.asset_ratio,
    variant = _ref.variant,
    center = _ref.center;
  return /*#__PURE__*/React.createElement(TextImageColumn, {
    numColumns: 3,
    columns: columns,
    headline: headline,
    headline_level: headline_level,
    noSpacingGrid: noSpacingGrid,
    separator: separator,
    asset_ratio: asset_ratio,
    variant: variant,
    center: center
  });
};

var css$p = {"youtube__wrapper":"Video-module_youtube__wrapper__XQDn1","video__buttons__wrapper":"Video-module_video__buttons__wrapper__lFna1","video__on__orange":"Video-module_video__on__orange__iDHU3"};

var VideoAspectRatio;
(function (VideoAspectRatio) {
  VideoAspectRatio["LARGE"] = "3/1";
  VideoAspectRatio["MEDIUM"] = "4/1";
  VideoAspectRatio["SMALL"] = "5/1";
  VideoAspectRatio["DEFAULT"] = "16/9";
})(VideoAspectRatio || (VideoAspectRatio = {}));
var getAspectRatio = function getAspectRatio(assetRatio) {
  var aspectRatio = new Map();
  aspectRatio.set(PageIntroImageHeight.LARGE, VideoAspectRatio.LARGE);
  aspectRatio.set(PageIntroImageHeight.MEDIUM, VideoAspectRatio.MEDIUM);
  aspectRatio.set(PageIntroImageHeight.SMALL, VideoAspectRatio.SMALL);
  return aspectRatio.get(assetRatio) || VideoAspectRatio.DEFAULT;
};

var Video = function Video(_ref) {
  var headline = _ref.headline,
    separator = _ref.separator,
    video = _ref.video,
    headline_level = _ref.headline_level,
    preview_image = _ref.preview_image,
    caption = _ref.caption,
    text = _ref.text,
    button = _ref.button,
    _ref$noSpacingGrid = _ref.noSpacingGrid,
    noSpacingGrid = _ref$noSpacingGrid === void 0 ? false : _ref$noSpacingGrid,
    _ref$onOrangeBackgrou = _ref.onOrangeBackground,
    onOrangeBackground = _ref$onOrangeBackgrou === void 0 ? false : _ref$onOrangeBackgrou,
    asset_ratio = _ref.asset_ratio,
    variant = _ref.variant,
    upload_date = _ref.upload_date;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
  var buttons = useMemo(function () {
    return button === null || button === void 0 ? void 0 : button.map(function (linkElement) {
      return /*#__PURE__*/React.createElement(RenderButtonType, {
        key: linkElement._uid,
        linkType: linkElement,
        onOrangeBackground: onOrangeBackground
      });
    });
  }, [button]);
  var localVideo = renderLocalizedAsset(video);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator || noSpacingGrid,
    spacingWithoutSeparator: !separator && !noSpacingGrid,
    className: conditionalClassname(onOrangeBackground, css$p.video__on__orange)
  }, headline && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: headline_level || HeadlineTags.H4,
    variant: variant
  }, headline)))), text && hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })), button && (button === null || button === void 0 ? void 0 : button.length) > 0 && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    className: css$p.pageIntro__button_wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css$p.video__buttons__wrapper
  }, buttons)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, (localVideo === null || localVideo === void 0 ? void 0 : localVideo.youtube_id) && (/*#__PURE__*/React.createElement(Videos, {
    youtubeId: localVideo.youtube_id,
    title: caption || headline || 'YouTube Video',
    height: "auto",
    width: "100%",
    aspectRatio: getAspectRatio(asset_ratio),
    caption: caption,
    legend: localVideo.legend,
    className: css$p.youtube__wrapper
  })), (localVideo === null || localVideo === void 0 ? void 0 : localVideo.video) && ((_a = localVideo === null || localVideo === void 0 ? void 0 : localVideo.video) === null || _a === void 0 ? void 0 : _a.item) && (/*#__PURE__*/React.createElement(Videos, {
    preload: "metadata",
    height: "auto",
    width: "100%",
    aspectRatio: getAspectRatio(asset_ratio),
    controls: true,
    caption: caption,
    src: "".concat((video === null || video === void 0 ? void 0 : video.length) ? (_c = (_b = localVideo === null || localVideo === void 0 ? void 0 : localVideo.video) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.embed_link : (_e = (_d = localVideo === null || localVideo === void 0 ? void 0 : localVideo.video) === null || _d === void 0 ? void 0 : _d.item) === null || _e === void 0 ? void 0 : _e.thumbnail_link),
    thumbnailUrl: (preview_image === null || preview_image === void 0 ? void 0 : preview_image.length) && ((_g = (_f = preview_image[0]) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.item) ? (_l = (_k = (_j = (_h = preview_image[0]) === null || _h === void 0 ? void 0 : _h.image) === null || _j === void 0 ? void 0 : _j.item) === null || _k === void 0 ? void 0 : _k.focal_embed_link) !== null && _l !== void 0 ? _l : (_p = (_o = (_m = preview_image[0]) === null || _m === void 0 ? void 0 : _m.image) === null || _o === void 0 ? void 0 : _o.item) === null || _p === void 0 ? void 0 : _p.embed_link : (_r = (_q = localVideo === null || localVideo === void 0 ? void 0 : localVideo.video) === null || _q === void 0 ? void 0 : _q.item) === null || _r === void 0 ? void 0 : _r.thumbnail_link,
    legend: localVideo.legend,
    controlsList: "nodownload",
    background: (_s = localVideo === null || localVideo === void 0 ? void 0 : localVideo.video) === null || _s === void 0 ? void 0 : _s.color,
    uploadDate: upload_date
  }))))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Separator, null))))));
};
var renderLocalizedAsset = function renderLocalizedAsset(asset) {
  var _a, _b;
  if (!asset || asset.length === 0) return {};
  var videoData = asset && asset[0];
  if ((videoData === null || videoData === void 0 ? void 0 : videoData.component) === 'video_atom') {
    var localVideo = (videoData === null || videoData === void 0 ? void 0 : videoData.local_video) && ((_a = videoData === null || videoData === void 0 ? void 0 : videoData.local_video[0]) === null || _a === void 0 ? void 0 : _a.video);
    if (localVideo) {
      return Object.assign(Object.assign({}, videoData), {
        video: localVideo
      });
    }
    return Object.assign({}, videoData);
  }
  if ((videoData === null || videoData === void 0 ? void 0 : videoData.component) === 'youtube_atom') {
    var _localVideo = (videoData === null || videoData === void 0 ? void 0 : videoData.local_youtube) && ((_b = videoData === null || videoData === void 0 ? void 0 : videoData.local_youtube[0]) === null || _b === void 0 ? void 0 : _b.youtube_id);
    if (_localVideo) {
      return Object.assign(Object.assign({}, videoData), {
        youtube_id: _localVideo
      });
    }
    return Object.assign({}, videoData);
  }
  return {};
};

var css$o = {"wrapperWithPagination":"PageIndex-module_wrapperWithPagination__15AD0"};

var alphabeticSort = function alphabeticSort(array, sortKey) {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    array.sort(function (a, b) {
      return a[sortKey] && a[sortKey].localeCompare(b[sortKey]);
    })
  );
};
var PageIndex = function PageIndex(_ref) {
  var formation = _ref.formation,
    text = _ref.text,
    pages = _ref.pages,
    separator = _ref.separator,
    sort = _ref.sort,
    teaserview = _ref.teaserview,
    preview = _ref.preview,
    image_position = _ref.image_position,
    formation_teaserview = _ref.formation_teaserview;
  var resultsRef = React.useRef(null);
  var initialPagination = setTotalPagesAndSize(formation_teaserview, pages);
  var _useState = useState({
      currentPage: 1,
      totalPages: initialPagination.totalPages,
      pageSize: initialPagination.pageSize,
      pages: pages
    }),
    pagination = _useState[0],
    setPagination = _useState[1];
  useEffect(function () {
    var newPagination = setTotalPagesAndSize(formation_teaserview, pages);
    setPagination(function (prevPagination) {
      return Object.assign(Object.assign({}, prevPagination), {
        totalPages: newPagination.totalPages,
        pageSize: newPagination.pageSize,
        pages: pages
      });
    });
  }, [formation_teaserview, pages]);
  if (teaserview) {
    var teasers = pages;
    if (sort) alphabeticSort(teasers, 'teaserTitle');
    var handleNextPage = function handleNextPage() {
      var _a;
      pagination.currentPage += 1;
      setPagination(Object.assign(Object.assign({}, pagination), {
        pages: getCurrentPageItems(pages, pagination.currentPage, pagination.pageSize)
      }));
      (_a = resultsRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: 'smooth'
      });
    };
    var handlePreviousPage = function handlePreviousPage() {
      var _a;
      pagination.currentPage -= 1;
      setPagination(Object.assign(Object.assign({}, pagination), {
        pages: getCurrentPageItems(pages, pagination.currentPage, pagination.pageSize)
      }));
      (_a = resultsRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: 'smooth'
      });
    };
    var handlePageClick = function handlePageClick(page) {
      var _a;
      pagination.currentPage = page;
      setPagination(Object.assign(Object.assign({}, pagination), {
        pages: getCurrentPageItems(pages, pagination.currentPage, pagination.pageSize)
      }));
      (_a = resultsRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: 'smooth'
      });
    };
    return /*#__PURE__*/React.createElement("div", {
      ref: resultsRef,
      className: conditionalClassname(pagination.totalPages > 1, css$o.wrapperWithPagination)
    }, /*#__PURE__*/React.createElement(TeaserComponent, {
      image_position: image_position,
      view: formation_teaserview,
      text: text,
      showInPageIndex: true,
      separator: separator || false,
      pageIndexTeaser: getCurrentPageItems(teasers, pagination.currentPage, pagination.pageSize)
    }), pagination.totalPages > 1 && (/*#__PURE__*/React.createElement(Pagination$1, {
      pageSize: pagination.pageSize,
      currentPage: pagination.currentPage,
      totalPages: pagination.totalPages,
      onNextPage: handleNextPage,
      onPreviousPage: handlePreviousPage,
      onPageClick: handlePageClick
    })));
  }
  var links = (pages === null || pages === void 0 ? void 0 : pages.map(function (page) {
    return Object.assign(Object.assign(Object.assign({}, page.link), {
      altText: page.text
    }), page.noindex ? {
      rel: RelType.NO_FOLLOW
    } : {});
  })) || [];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (sort) alphabeticSort(links, 'title');
  return /*#__PURE__*/React.createElement(LinkList, {
    links: links,
    text: text,
    formation: formation,
    separator: separator || false,
    preview: preview
  });
};

var DynamicTeaserOverview = function DynamicTeaserOverview(_ref) {
  var image_position = _ref.image_position,
    separator = _ref.separator,
    view = _ref.view,
    text = _ref.text,
    top_pages = _ref.top_pages,
    dynamic_pages = _ref.dynamic_pages;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    noSpacing: !separator,
    spacingWithoutSeparator: !separator
  }, hasTextContent(text) && text && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  })))), (top_pages === null || top_pages === void 0 ? void 0 : top_pages.length) > 0 && (/*#__PURE__*/React.createElement(PageIndex, {
    pages: top_pages,
    image_position: image_position,
    teaserview: true,
    separator: false,
    formation_teaserview: view
  })), (dynamic_pages === null || dynamic_pages === void 0 ? void 0 : dynamic_pages.length) > 0 && (/*#__PURE__*/React.createElement(PageIndex, {
    pages: dynamic_pages,
    image_position: image_position,
    teaserview: true,
    separator: false,
    formation_teaserview: view
  }))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

var css$n = {"md":"720px","lg":"940px","xl":"1200px","footer__wrapper":"Footer-module_footer__wrapper__ugE2S","container":"Footer-module_container__g-MuK","container1":"Footer-module_container1__Rufl0","container2":"Footer-module_container2__J6-Kh","container3":"Footer-module_container3__SAz-3","container1__payment":"Footer-module_container1__payment__jaixu","container1__internal_links":"Footer-module_container1__internal_links__LAnU9","container2__internal_links":"Footer-module_container2__internal_links__1GUBk","container2__award_icons":"Footer-module_container2__award_icons__Myc-H","container3__contact_medium":"Footer-module_container3__contact_medium__Ep3Mm","container3__address":"Footer-module_container3__address__-rk9X","container3__award_icons":"Footer-module_container3__award_icons__uEDE4","footer__links_wrapper":"Footer-module_footer__links_wrapper__2dHJs","footer__links":"Footer-module_footer__links__yMCpA","footer__contact_wrapper":"Footer-module_footer__contact_wrapper__B2PN8","footer__contact__link":"Footer-module_footer__contact__link__SiGaI","footer__award_image__wrapper":"Footer-module_footer__award_image__wrapper__1PtOT","footer__image":"Footer-module_footer__image__UW4kA","footer__image_text__wrapper":"Footer-module_footer__image_text__wrapper__YBq34","footer__award__wrapper":"Footer-module_footer__award__wrapper__ksIFJ","award__icon__image__wrapper":"Footer-module_award__icon__image__wrapper__nXxT7","award__icon__square":"Footer-module_award__icon__square__3C0EP","award__icon__circle":"Footer-module_award__icon__circle__MtrPJ","award__icon__rectangle_horizontal":"Footer-module_award__icon__rectangle_horizontal__m2Twd","award__icon__rectangle_vertical":"Footer-module_award__icon__rectangle_vertical__b4YJi","footer__image_text":"Footer-module_footer__image_text__iOtzY","footer__image_text__text":"Footer-module_footer__image_text__text__rGa3Y","footer__image_text_image":"Footer-module_footer__image_text_image__INyzX","footer__social_media_wrapper":"Footer-module_footer__social_media_wrapper__BaY3D","footer__social_media__icon_wrapper":"Footer-module_footer__social_media__icon_wrapper__sdJAr","footer__payment_icons":"Footer-module_footer__payment_icons__5ycBM","footer__contact_list":"Footer-module_footer__contact_list__RAL03","newsletter__wrapper":"Footer-module_newsletter__wrapper__wc9XG","footer__newsletter_button":"Footer-module_footer__newsletter_button__0PRL6","footer__newsletter_text":"Footer-module_footer__newsletter_text__6fj4b","footer__text":"Footer-module_footer__text__qKfpp","footer__container":"Footer-module_footer__container__6lh6C","footer__address_text":"Footer-module_footer__address_text__-tMI9","footer__countrySwitch__wrapper":"Footer-module_footer__countrySwitch__wrapper__DwhI8","footer__countrySwitch__link":"Footer-module_footer__countrySwitch__link__kBKM7","footer__countrySwitch__language":"Footer-module_footer__countrySwitch__language__q7oU3","footer__countrySwitch__country":"Footer-module_footer__countrySwitch__country__LX6w6"};

var PaymentIcons = {
  PaymentFallback: function PaymentFallback(_ref) {
    var text = _ref.text;
    return /*#__PURE__*/React.createElement("span", {
      className: css$Z.prepayment__wrapper
    }, /*#__PURE__*/React.createElement("span", {
      className: css$Z.prepayment__text
    }, text));
  },
  Visa: function Visa() {
    return /*#__PURE__*/React.createElement("svg", {
      width: "80",
      height: "40",
      viewBox: "0 0 80 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "0.5",
      y: "0.5",
      width: "79",
      height: "39",
      rx: "3.5",
      fill: "white",
      stroke: "#CECECE"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M35.2127 31.6H29.3376L33.0095 8.4143H38.8851L35.2127 31.6ZM24.3952 8.4143L18.7942 24.3616L18.1314 20.9275L18.132 20.9288L16.1551 10.5019C16.1551 10.5019 15.9161 8.4143 13.3682 8.4143H4.10865L4 8.80688C4 8.80688 6.83159 9.4122 10.1455 11.457L15.2497 31.6006H21.371L30.7181 8.4143H24.3952ZM70.6054 31.6H76L71.2966 8.41368H66.5738C64.393 8.41368 63.8618 10.1416 63.8618 10.1416L55.0996 31.6H61.2239L62.4487 28.156H69.9173L70.6054 31.6ZM64.1406 23.3984L67.2276 14.7218L68.9642 23.3984H64.1406ZM55.559 13.9899L56.3974 9.01093C56.3974 9.01093 53.8103 8 51.1133 8C48.1978 8 41.2742 9.30925 41.2742 15.6756C41.2742 21.6656 49.4002 21.74 49.4002 24.8863C49.4002 28.0326 42.1115 27.4688 39.706 25.4848L38.8326 30.6908C38.8326 30.6908 41.4559 32 45.464 32C49.4732 32 55.5215 29.8671 55.5215 24.062C55.5215 18.0336 47.3225 17.4724 47.3225 14.8514C47.3231 12.2298 53.0449 12.5666 55.559 13.9899Z",
      fill: "#2566AF"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.132 20.9282L16.1551 10.5013C16.1551 10.5013 15.9161 8.4137 13.3682 8.4137H4.10865L4 8.80628C4 8.80628 8.4505 9.75395 12.7193 13.3046C16.801 16.6984 18.132 20.9282 18.132 20.9282Z",
      fill: "#E6A540"
    }));
  },
  Mastercard: function Mastercard() {
    return /*#__PURE__*/React.createElement("svg", {
      width: "80",
      height: "40",
      viewBox: "0 0 80 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "0.5",
      y: "0.5",
      width: "79",
      height: "39",
      rx: "3.5",
      fill: "white",
      stroke: "#CECECE"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M27.439 35.6948V33.5842C27.439 32.7748 26.9464 32.2473 26.1378 32.2473C25.7131 32.2473 25.2587 32.3883 24.9419 32.8419C24.6956 32.4546 24.3474 32.2473 23.8165 32.2473C23.6192 32.2388 23.4228 32.2793 23.2449 32.3653C23.067 32.4513 22.9133 32.58 22.7973 32.7399V32.3153H22.1289V35.6922H22.7973V33.76C22.7973 33.1655 23.149 32.8809 23.6416 32.8809C24.1342 32.8809 24.4153 33.1977 24.4153 33.76V35.6948H25.0838V33.76C25.0838 33.1655 25.4354 32.8809 25.928 32.8809C26.4206 32.8809 26.7017 33.1977 26.7017 33.76V35.6948H27.439ZM38.4141 32.3526H37.1826V31.3334H36.5159V32.3526H35.8126V32.9472H36.5159V34.5337C36.5159 35.3075 36.797 35.7653 37.6412 35.7653C37.9611 35.7586 38.2745 35.6741 38.5543 35.519L38.3428 34.9244C38.153 35.0431 37.9329 35.1041 37.7092 35.1003C37.3576 35.1003 37.1817 34.8888 37.1817 34.5371V32.92H38.4133V32.3569L38.4141 32.3526ZM44.6755 32.2473C44.4934 32.2433 44.3134 32.2865 44.1531 32.3729C43.9927 32.4592 43.8575 32.5857 43.7607 32.7399V32.3153H43.0923V35.6922H43.7607V33.7957C43.7607 33.2326 44.0419 32.8809 44.4996 32.8809C44.6541 32.8872 44.8074 32.9108 44.9566 32.9514L45.1681 32.3178C45.0068 32.2772 44.8417 32.2535 44.6755 32.2473ZM35.213 32.5989C34.8613 32.3526 34.3687 32.2473 33.8413 32.2473C32.997 32.2473 32.4696 32.6346 32.4696 33.303C32.4696 33.8662 32.8569 34.1821 33.595 34.2883L33.9466 34.3231C34.3339 34.3936 34.5802 34.5346 34.5802 34.7104C34.5802 34.9567 34.2991 35.1351 33.7708 35.1351C33.3674 35.1434 32.9723 35.0199 32.6454 34.7834L32.2938 35.3109C32.7864 35.6625 33.3843 35.7356 33.7377 35.7356C34.7229 35.7356 35.2503 35.2786 35.2503 34.645C35.2503 34.0505 34.8257 33.7659 34.0893 33.6598L33.7377 33.6249C33.4209 33.5901 33.1431 33.484 33.1431 33.2733C33.1431 33.027 33.4243 32.8487 33.8116 32.8487C34.2362 32.8487 34.6558 33.0245 34.8673 33.1298L35.213 32.5989ZM45.4144 34.0063C45.4144 35.0255 46.0828 35.7653 47.1734 35.7653C47.666 35.7653 48.0176 35.66 48.3692 35.378L48.0176 34.8505C47.7686 35.0522 47.4589 35.1638 47.1385 35.1673C46.544 35.1673 46.0828 34.7104 46.0828 34.042C46.0828 33.3735 46.5381 32.92 47.1385 32.92C47.4589 32.9235 47.7686 33.0352 48.0176 33.2368L48.3692 32.7094C48.0176 32.4282 47.666 32.3221 47.1734 32.3221C46.1176 32.2516 45.4144 32.9905 45.4144 34.0105V34.0063ZM40.7006 32.2473C39.7153 32.2473 39.0469 32.9506 39.0469 34.0063C39.0469 35.062 39.7501 35.7653 40.7702 35.7653C41.2664 35.7758 41.7511 35.6143 42.1419 35.3083L41.7903 34.8157C41.5076 35.0347 41.1625 35.1579 40.805 35.1673C40.3481 35.1673 39.8555 34.8862 39.7858 34.2883H42.2837V34.0071C42.2837 32.9514 41.6501 32.2482 40.7006 32.2482V32.2473ZM40.6657 32.8809C41.1583 32.8809 41.51 33.1977 41.5448 33.7252H39.7162C39.8215 33.2326 40.1408 32.8809 40.6657 32.8809ZM31.5549 34.0063V32.3178H30.8864V32.7425C30.6401 32.4257 30.2919 32.2499 29.7959 32.2499C28.8463 32.2499 28.1422 32.9888 28.1422 34.0088C28.1422 35.0289 28.8455 35.7678 29.7959 35.7678C30.2885 35.7678 30.6401 35.592 30.8864 35.2752V35.6999H31.5549V34.0063ZM28.8463 34.0063C28.8463 33.3727 29.2336 32.8809 29.9021 32.8809C30.5357 32.8809 30.9213 33.3735 30.9213 34.0063C30.9213 34.6747 30.4966 35.1317 29.9021 35.1317C29.2336 35.1665 28.8463 34.6391 28.8463 34.0063ZM54.8429 32.2473C54.6608 32.2433 54.4808 32.2865 54.3205 32.3729C54.1602 32.4592 54.025 32.5857 53.9282 32.7399V32.3153H53.2597V35.6922H53.9273V33.7957C53.9273 33.2326 54.2084 32.8809 54.6662 32.8809C54.8207 32.8872 54.974 32.9108 55.1232 32.9514L55.3347 32.3178C55.1734 32.2772 55.0083 32.2535 54.842 32.2473H54.8429ZM52.2397 34.0063V32.3178H51.5712V32.7425C51.3249 32.4257 50.9767 32.2499 50.4807 32.2499C49.5311 32.2499 48.827 32.9888 48.827 34.0088C48.827 35.0289 49.5303 35.7678 50.4807 35.7678C50.9733 35.7678 51.3249 35.592 51.5712 35.2752V35.6999H52.2397V34.0063ZM49.5311 34.0063C49.5311 33.3727 49.9184 32.8809 50.5869 32.8809C51.2205 32.8809 51.6061 33.3735 51.6061 34.0063C51.6061 34.6747 51.1814 35.1317 50.5869 35.1317C49.9184 35.1665 49.5311 34.6391 49.5311 34.0063ZM59.0293 34.0063V30.981H58.3609V32.7399C58.1145 32.4231 57.7663 32.2473 57.2703 32.2473C56.3207 32.2473 55.6166 32.9862 55.6166 34.0063C55.6166 35.0264 56.3199 35.7653 57.2703 35.7653C57.7629 35.7653 58.1145 35.5895 58.3609 35.2727V35.6973H59.0293V34.0063ZM56.3207 34.0063C56.3207 33.3727 56.708 32.8809 57.3765 32.8809C58.0101 32.8809 58.3957 33.3735 58.3957 34.0063C58.3957 34.6747 57.971 35.1317 57.3765 35.1317C56.7072 35.1673 56.3199 34.6399 56.3199 34.0063H56.3207Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M46.6481 6.7085H34.4414V26.6187H46.6481V6.7085Z",
      fill: "#FF5F00"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M35.6716 16.6636C35.672 14.7483 36.1058 12.8578 36.9403 11.1338C37.7749 9.40983 38.9887 7.89698 40.4908 6.70855C38.6227 5.2398 36.3791 4.3263 34.0164 4.07246C31.6536 3.81863 29.2672 4.23471 27.1297 5.27313C24.9923 6.31156 23.1902 7.93044 21.9294 9.9447C20.6686 11.959 20 14.2873 20 16.6636C20 19.04 20.6686 21.3683 21.9294 23.3826C23.1902 25.3969 24.9923 27.0157 27.1297 28.0542C29.2672 29.0926 31.6536 29.5087 34.0164 29.2548C36.3791 29.001 38.6227 28.0875 40.4908 26.6187C38.9887 25.4303 37.7749 23.9175 36.9403 22.1935C36.1058 20.4695 35.672 18.579 35.6716 16.6636Z",
      fill: "#EB001B"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M61.0002 16.6636C61.0019 19.0382 60.3353 21.3653 59.0765 23.3789C57.8178 25.3924 56.0178 27.011 53.8824 28.0495C51.7469 29.0881 49.3623 29.5047 47.0012 29.2517C44.6402 28.9986 42.398 28.0862 40.5311 26.6187C42.0336 25.4306 43.2476 23.9178 44.0822 22.1938C44.9169 20.4697 45.3504 18.5791 45.3504 16.6636C45.3504 14.7482 44.9169 12.8575 44.0822 11.1335C43.2476 9.40942 42.0336 7.89664 40.5311 6.70852C42.398 5.24104 44.6402 4.3286 47.0012 4.07557C49.3623 3.82254 51.7469 4.23913 53.8824 5.2777C56.0178 6.31626 57.8178 7.93486 59.0765 9.94838C60.3353 11.9619 61.0019 14.289 61.0002 16.6636Z",
      fill: "#F79E1B"
    }));
  },
  Paypal: function Paypal() {
    return /*#__PURE__*/React.createElement("svg", {
      width: "80",
      height: "41",
      viewBox: "0 0 80 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "0.5",
      y: "0.603027",
      width: "79",
      height: "39",
      rx: "3.5",
      fill: "white",
      stroke: "#CECECE"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.1875 11.0344C15.285 10.414 14.1074 10.103 12.6546 10.103H7.03019C6.58482 10.103 6.33877 10.3258 6.29203 10.7708L4.00717 25.1131C3.98343 25.254 4.01867 25.3828 4.11258 25.4999C4.20595 25.6173 4.32339 25.6756 4.46404 25.6756H7.13559C7.60417 25.6756 7.86172 25.4534 7.909 25.0078L8.54164 21.1413C8.56474 20.9539 8.64716 20.8015 8.7878 20.6842C8.92835 20.5671 9.10413 20.4905 9.31505 20.4553C9.52596 20.4205 9.72485 20.403 9.91267 20.403C10.0999 20.403 10.3225 20.4148 10.5807 20.4381C10.8382 20.4615 11.0024 20.4729 11.0728 20.4729C13.088 20.4729 14.6699 19.9051 15.8184 18.7682C16.9663 17.6317 17.541 16.0559 17.541 14.0401C17.541 12.6576 17.0895 11.6557 16.1875 11.0344ZM13.2875 15.3408C13.1699 16.1612 12.8656 16.6999 12.3735 16.9578C11.8813 17.216 11.1783 17.3444 10.2644 17.3444L9.10434 17.3795L9.70207 13.6182C9.7487 13.3606 9.90095 13.2317 10.1589 13.2317H10.827C11.764 13.2317 12.444 13.3667 12.8658 13.6358C13.2875 13.9055 13.4281 14.474 13.2875 15.3408Z",
      fill: "#003087"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M75.5429 10.103H72.9418C72.6834 10.103 72.5313 10.232 72.4849 10.4898L70.1998 25.1132L70.1646 25.1835C70.1646 25.3013 70.2115 25.4121 70.3054 25.5176C70.3987 25.6229 70.5163 25.6756 70.6568 25.6756H72.9771C73.4217 25.6756 73.6679 25.4534 73.7153 25.0078L76.0002 10.6301V10.5951C76.0001 10.2671 75.8473 10.103 75.5429 10.103Z",
      fill: "#009CDE"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M44.1161 15.7624C44.1161 15.6455 44.069 15.5339 43.9758 15.4286C43.8818 15.3232 43.7762 15.2703 43.6594 15.2703H40.9526C40.6943 15.2703 40.4835 15.388 40.3198 15.6217L36.5937 21.1058L35.047 15.8329C34.9293 15.4582 34.6718 15.2703 34.2737 15.2703H31.6368C31.5194 15.2703 31.414 15.3231 31.3208 15.4286C31.2268 15.5339 31.1802 15.6456 31.1802 15.7624C31.1802 15.8096 31.4087 16.5006 31.8656 17.8364C32.3224 19.1725 32.8146 20.6138 33.3419 22.1606C33.8693 23.7071 34.1444 24.5278 34.168 24.6209C32.2462 27.2459 31.2856 28.652 31.2856 28.8392C31.2856 29.1441 31.4377 29.2963 31.7426 29.2963H34.4494C34.707 29.2963 34.9178 29.1794 35.0821 28.9449L44.0461 16.0084C44.0927 15.9619 44.1161 15.8802 44.1161 15.7624Z",
      fill: "#003087"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M69.3209 15.2702H66.6491C66.3208 15.2702 66.1222 15.657 66.0519 16.4304C65.4419 15.4934 64.3294 15.0242 62.7121 15.0242C61.0248 15.0242 59.5891 15.657 58.406 16.9225C57.2224 18.1881 56.6309 19.6765 56.6309 21.3871C56.6309 22.77 57.035 23.8713 57.8434 24.6913C58.6519 25.5121 59.7358 25.9216 61.0954 25.9216C61.7748 25.9216 62.4661 25.7808 63.1691 25.4998C63.8722 25.2186 64.4225 24.8438 64.8215 24.3749C64.8215 24.3985 64.7977 24.5038 64.7512 24.6912C64.7039 24.879 64.6808 25.0198 64.6808 25.113C64.6808 25.4884 64.8327 25.6754 65.1379 25.6754H67.5636C68.0082 25.6754 68.2664 25.4532 68.3366 25.0076L69.778 15.8327C69.8011 15.6921 69.7659 15.5633 69.6724 15.446C69.5784 15.329 69.4615 15.2702 69.3209 15.2702ZM64.7335 22.1955C64.1359 22.7814 63.4154 23.0742 62.5717 23.0742C61.8918 23.0742 61.3415 22.887 60.9195 22.5118C60.4975 22.1375 60.2866 21.6218 60.2866 20.9651C60.2866 20.0986 60.5795 19.3657 61.1656 18.7682C61.7508 18.1705 62.4779 17.8717 63.3451 17.8717C64.0006 17.8717 64.5456 18.0651 64.9796 18.4516C65.4128 18.8384 65.6301 19.3717 65.6301 20.0514C65.63 20.895 65.331 21.6099 64.7335 22.1955Z",
      fill: "#009CDE"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M29.3876 15.2702H26.7159C26.3874 15.2702 26.1886 15.657 26.1182 16.4304C25.4855 15.4934 24.3722 15.0242 22.7786 15.0242C21.0913 15.0242 19.6557 15.657 18.4724 16.9225C17.2888 18.1881 16.6973 19.6765 16.6973 21.3871C16.6973 22.77 17.1016 23.8713 17.9101 24.6913C18.7187 25.5121 19.8023 25.9216 21.1617 25.9216C21.8175 25.9216 22.4976 25.7808 23.2005 25.4998C23.9035 25.2186 24.466 24.8438 24.8878 24.3749C24.7938 24.6561 24.7472 24.9023 24.7472 25.113C24.7472 25.4884 24.8994 25.6754 25.2042 25.6754H27.6297C28.0746 25.6754 28.3327 25.4532 28.4031 25.0076L29.8442 15.8327C29.8673 15.6921 29.8323 15.5633 29.7388 15.446C29.645 15.329 29.5279 15.2702 29.3876 15.2702ZM24.8 22.2129C24.2023 22.7877 23.4696 23.0742 22.6031 23.0742C21.9231 23.0742 21.3782 22.887 20.9684 22.5118C20.558 22.1375 20.3531 21.6218 20.3531 20.9651C20.3531 20.0986 20.6459 19.3657 21.2321 18.7682C21.8175 18.1705 22.5441 17.8717 23.4115 17.8717C24.0674 17.8717 24.6122 18.0651 25.0462 18.4516C25.4794 18.8384 25.6965 19.3717 25.6965 20.0514C25.6965 20.9185 25.3977 21.6394 24.8 22.2129Z",
      fill: "#003087"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M56.1211 11.0344C55.2187 10.414 54.0413 10.103 52.5883 10.103H46.999C46.53 10.103 46.2722 10.3258 46.2256 10.7708L43.9408 25.1131C43.917 25.254 43.9522 25.3828 44.0462 25.4999C44.1392 25.6173 44.257 25.6756 44.3976 25.6756H47.28C47.5612 25.6756 47.7486 25.5235 47.8425 25.2188L48.4754 21.1413C48.4986 20.9539 48.5807 20.8015 48.7214 20.6842C48.8621 20.5671 49.0376 20.4905 49.2488 20.4553C49.4596 20.4205 49.6585 20.403 49.8464 20.403C50.0337 20.403 50.2562 20.4148 50.5141 20.4381C50.7718 20.4615 50.9363 20.4729 51.0062 20.4729C53.0218 20.4729 54.6034 19.9051 55.7519 18.7682C56.9002 17.6317 57.4744 16.0559 57.4744 14.0401C57.4745 12.6576 57.0231 11.6557 56.1211 11.0344ZM52.5179 16.8172C52.0023 17.1686 51.2289 17.3443 50.1979 17.3443L49.073 17.3794L49.6707 13.618C49.7171 13.3605 49.8694 13.2316 50.1276 13.2316H50.7601C51.2755 13.2316 51.6857 13.255 51.9908 13.3017C52.295 13.3489 52.5883 13.495 52.8695 13.7411C53.1509 13.9871 53.2913 14.3447 53.2913 14.8133C53.2913 15.7977 53.0333 16.4654 52.5179 16.8172Z",
      fill: "#009CDE"
    }));
  },
  AmericanExpress: function AmericanExpress() {
    return /*#__PURE__*/React.createElement("svg", {
      width: "80",
      height: "41",
      viewBox: "0 0 80 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "0.5",
      y: "0.603027",
      width: "79",
      height: "39",
      rx: "3.5",
      fill: "white",
      stroke: "#CECECE"
    }), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0_27732_3328)"
    }, /*#__PURE__*/React.createElement("mask", {
      id: "mask0_27732_3328",
      maskUnits: "userSpaceOnUse",
      x: "12",
      y: "4",
      width: "56",
      height: "33"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12.5732 4.10303L67.1505 4.10303V24.1461C67.2861 24.2529 67.3795 24.3727 67.4304 24.5276V25.1486C67.3795 25.304 67.2861 25.4394 67.1505 25.5536V36.103H12.5732V28.103V12.103L12.5732 4.10303Z",
      fill: "white"
    })), /*#__PURE__*/React.createElement("g", {
      mask: "url(#mask0_27732_3328)"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.999 36.103H66.999V4.10303H12.999V36.103Z",
      fill: "url(#paint0_radial_27732_3328)"
    })), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.4848 14.9273L16.4351 12.3784L15.3918 14.9273H17.4848ZM40.5836 13.916C40.3762 14.0338 40.1268 14.0466 39.8262 14.0466H37.9644V12.6233H39.8509C40.1204 12.6233 40.4 12.6333 40.5818 12.732C40.7773 12.8297 40.9015 13.028 40.9015 13.3002C40.9015 13.5825 40.7809 13.8027 40.5836 13.916ZM53.8578 14.9273L52.8017 12.3784L51.752 14.9273H53.8578ZM29.1137 17.6918H27.5433L27.5341 12.679L25.3151 17.6918H23.9703L21.7393 12.668V17.6918H18.6232L18.0366 16.2629H14.8455L14.2535 17.6918H12.5881L15.3279 11.283H17.6073L20.2119 17.3546V11.283H22.716L24.7185 15.6344L26.5621 11.283H29.1137V17.6918ZM35.3708 17.6918H30.2529V11.283H35.3708V12.6233H31.7886V13.7734H35.283V15.0908L31.7886 15.0853V16.3652H35.3708V17.6918ZM42.5889 13.0143C42.5889 14.0274 41.9074 14.5628 41.5127 14.7208C41.8471 14.8496 42.1312 15.0707 42.2646 15.2626C42.4811 15.575 42.524 15.8674 42.524 16.431V17.6918H40.9783L40.9737 16.886C40.9737 16.505 41.0102 15.9496 40.7252 15.6426C40.5014 15.4133 40.1643 15.3658 39.6106 15.3658H37.9644V17.6918H36.4332V11.283H39.9605C40.7389 11.283 41.3181 11.3086 41.8151 11.5937C42.3002 11.8769 42.5889 12.2962 42.5889 13.0143ZM43.4796 17.6918H45.0427V11.2821H43.4796V17.6918ZM63.1771 17.6918H61.0038L58.0986 12.8864L58.1041 17.6918H54.9833L54.3858 16.2629H51.1993L50.6265 17.6918H48.8331C48.0858 17.6918 47.1412 17.5255 46.6123 16.9856C46.0678 16.4383 45.7928 15.7047 45.7928 14.5363C45.7928 13.5862 45.96 12.7183 46.6177 12.0322C47.1138 11.5206 47.8876 11.283 48.9446 11.283H50.4255V12.6552H48.9775C48.4175 12.6552 48.0986 12.7411 47.7935 13.038C47.5359 13.3084 47.3532 13.8182 47.3532 14.4915C47.3532 15.1794 47.4902 15.6691 47.7789 15.9971C48.0091 16.2483 48.4394 16.3241 48.8441 16.3241H49.5329L51.6917 11.283H53.9866L56.5821 17.3455V11.283H58.9181L61.6104 15.7458V11.283H63.1771V17.6918ZM12.5698 18.9543H15.1881L15.7783 17.5255H17.0993L17.6877 18.9543H22.8402V17.8635L23.3006 18.958H25.971L26.4296 17.8498V18.9543H39.2324L39.226 16.6165H39.4736C39.6481 16.6201 39.7002 16.6402 39.7002 16.928V18.9543H46.3172V18.4107C46.8516 18.6976 47.6839 18.9543 48.7729 18.9543H51.5602L52.1549 17.5255H53.4777L54.067 18.9543H59.4297V17.5995L60.2437 18.9543H64.5384V10.0132H60.2866V11.072L59.6928 10.0132H55.3223V11.072L54.7759 10.0132H48.8761C47.8876 10.0132 47.017 10.1493 46.3172 10.5348V10.0132H42.2509V10.5348C41.7986 10.1383 41.1911 10.0132 40.5178 10.0132H25.644L24.6418 12.3254L23.6222 10.0132H18.9383V11.072L18.4185 10.0132H14.4244L12.5698 14.2604V18.9543Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M67.1512 23.6834H64.3538C64.0752 23.6834 63.8898 23.6944 63.7399 23.7976C63.5791 23.9 63.5115 24.0598 63.5115 24.2636C63.5115 24.5011 63.6486 24.6655 63.8523 24.7368C64.0058 24.7934 64.1839 24.808 64.4452 24.8117L65.2656 24.8327C66.1024 24.8565 66.6661 24.999 67.0087 25.3471C67.0662 25.3982 67.1074 25.4594 67.1512 25.5088V23.6834ZM67.1512 27.9105C66.7748 28.4569 66.0504 28.7318 65.0673 28.7318H62.1074V27.3542H65.0582C65.346 27.3542 65.5525 27.3149 65.6794 27.1952C65.7827 27.1011 65.8612 26.9559 65.8612 26.7795C65.8612 26.5904 65.7827 26.4406 65.6758 26.3547C65.5561 26.2533 65.3981 26.2122 65.1331 26.2085C63.6952 26.1638 61.9 26.2533 61.9 24.2261C61.9 23.297 62.4929 22.3186 64.0953 22.3186H67.1512V21.0432H64.3127C63.4558 21.0432 62.8355 21.246 62.3924 21.5694V21.0432H58.1964C57.5322 21.0432 56.7456 21.2104 56.3674 21.5694L56.3729 21.0432H48.8807V21.5694C48.2841 21.1391 47.281 21.0432 46.8105 21.0432H41.8763V21.5694C41.4022 21.1108 40.3589 21.0432 39.7166 21.0432H34.1859L32.9224 22.4172L31.7375 21.0432H23.4761V29.9898H31.5831L32.8877 28.5994L34.1164 29.9898L39.1064 29.9935V27.8895H39.6006C40.2593 27.8987 41.0468 27.8749 41.7356 27.5771V29.9898H45.8549V27.6575H46.0532C46.3071 27.6575 46.3327 27.6721 46.3327 27.9233V29.9898H58.8505C59.6398 29.9898 60.4693 29.7861 60.9334 29.4207V29.9898H64.9047C65.7315 29.9898 66.5345 29.8756 67.1512 29.5805V27.9105ZM61.0367 25.3471C61.3363 25.6577 61.4953 26.0496 61.4953 26.7064C61.4953 28.0896 60.632 28.7318 59.0898 28.7318H56.1016V27.3542H59.0761C59.3703 27.3542 59.574 27.3149 59.7074 27.1952C59.8088 27.1011 59.8837 26.9559 59.8837 26.7795C59.8837 26.5904 59.8015 26.4406 59.6965 26.3547C59.5786 26.2533 59.4187 26.2122 59.1529 26.2085C57.7158 26.1638 55.9261 26.2533 55.9261 24.2261C55.9261 23.297 56.5099 22.3186 58.1105 22.3186H61.1865V23.6834H58.38C58.0977 23.6834 57.9141 23.6944 57.7606 23.7976C57.5943 23.9 57.5322 24.0598 57.5322 24.2636C57.5322 24.5011 57.6747 24.6655 57.8693 24.7368C58.0265 24.7934 58.1964 24.808 58.4604 24.8117L59.2863 24.8327C60.1231 24.8565 60.6886 24.999 61.0367 25.3471ZM47.2098 24.9542C47.0088 25.0721 46.7521 25.0839 46.457 25.0839H44.5942V23.6478H46.4816C46.7521 23.6478 47.0298 23.6533 47.2098 23.7583C47.4089 23.8662 47.5277 24.0635 47.5277 24.3403C47.5277 24.6116 47.4089 24.8327 47.2098 24.9542ZM48.1361 25.7518C48.4769 25.8751 48.7555 26.1017 48.8862 26.2889C49.1018 26.6032 49.1374 26.8956 49.1392 27.4592V28.7318H47.6044V27.9306C47.6044 27.5415 47.6419 26.9723 47.355 26.6763C47.1339 26.4406 46.7913 26.3885 46.2341 26.3885H44.5942V28.7318H43.0567V22.3186H46.5913C47.3696 22.3186 47.9351 22.3505 48.4367 22.6219C48.92 22.9115 49.2196 23.318 49.2196 24.048C49.2196 25.0666 48.5399 25.5891 48.1361 25.7518ZM50.072 22.3186H55.188V23.6478H51.5986V24.808H55.0985V26.1172H51.5986V27.3916L55.188 27.3989V28.7318H50.072V22.3186ZM39.7377 25.2758H37.7534V23.6478H39.7541C40.3068 23.6478 40.6896 23.868 40.6896 24.4335C40.6896 24.9862 40.3251 25.2758 39.7377 25.2758ZM36.2277 28.1499L33.8798 25.538L36.2277 23.0074V28.1499ZM30.1543 27.3916H26.3876V26.1172H29.7505V24.808H26.3876V23.6478H30.2283L31.901 25.5124L30.1543 27.3916ZM42.3331 24.4335C42.3331 26.2085 41.0084 26.5795 39.6655 26.5795H37.7534V28.7318H34.7797L32.8923 26.6105L30.9317 28.7318H24.8647V22.3186H31.0258L32.9105 24.4189L34.8583 22.3186H39.7541C40.971 22.3186 42.3331 22.6538 42.3331 24.4335Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M42.5888 13.0153C42.5888 14.0294 41.9081 14.5629 41.5144 14.721C41.8488 14.8498 42.1329 15.0727 42.2663 15.2627C42.4828 15.577 42.5248 15.8675 42.5248 16.433V17.6919H40.98L40.9736 16.8871C40.9736 16.5052 41.0119 15.9497 40.726 15.6428C40.5012 15.4135 40.166 15.366 39.6105 15.366H37.9661V17.6919H36.4331V11.2832H39.9622C40.7388 11.2832 41.3189 11.3088 41.815 11.5938C42.3019 11.877 42.5888 12.2964 42.5888 13.0153Z",
      fill: "#2F9BCA"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35.3731 17.6918H30.2534V11.2822H35.3731V12.6233H31.7891V13.7735H35.2835V15.0909L31.7891 15.0873V16.3672H35.3731",
      fill: "#2EA3D0"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.114 17.6918H27.5436L27.5345 12.6791L25.3172 17.6918H23.9725L21.7397 12.6699V17.6918H18.6244L18.037 16.2639H14.8459L14.2557 17.6918H12.5894L15.3292 11.2822H17.6076L20.2122 17.3557V11.2822H22.7172L24.7207 15.6363L26.5624 11.2822H29.114",
      fill: "#55B2D8"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.5836 13.916C40.3753 14.0357 40.1259 14.0466 39.8271 14.0466H37.9644V12.6233H39.8509C40.1204 12.6233 40.399 12.6333 40.5799 12.7338C40.7772 12.8298 40.9006 13.028 40.9006 13.3012C40.9006 13.5825 40.7809 13.8045 40.5836 13.916Z",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.484 14.9273L16.4334 12.3784L15.3901 14.9273",
      fill: "white"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
      id: "paint0_radial_27732_3328",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(909.883 560.002) scale(6400.1 3792.65)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#88CDE7"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "1",
      stopColor: "#2274AD"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0_27732_3328"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "13",
      y: "4.10303",
      width: "54",
      height: "32",
      rx: "2",
      fill: "white"
    }))));
  },
  Jcb: function Jcb() {
    return /*#__PURE__*/React.createElement("svg", {
      width: "80",
      height: "40",
      viewBox: "0 0 80 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "0.5",
      y: "0.5",
      width: "79",
      height: "39",
      rx: "3.5",
      fill: "white",
      stroke: "#CECECE"
    }), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0_1336_4714)",
      transform: "translate(21.5, 5.5)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M36.7529 23.2164C36.7529 26.3707 34.1919 28.9392 31.0468 28.9392H0V6.27341C0 3.11913 2.56102 0.550644 5.70613 0.550644H36.7529V23.2164Z",
      fill: "white"
    }), ' ', /*#__PURE__*/React.createElement("path", {
      d: "M26.6436 17.4035H29.0024C29.0698 17.4035 29.2271 17.381 29.2945 17.381C29.7438 17.2909 30.1257 16.8853 30.1257 16.3221C30.1257 15.7813 29.7438 15.3758 29.2945 15.2631C29.2271 15.2406 29.0923 15.2406 29.0024 15.2406H26.6436V17.4035Z",
      fill: "url(#paint0_linear_1336_4714)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M28.7328 2.46574C26.4863 2.46574 24.6442 4.29072 24.6442 6.56631V10.8246H30.4177C30.5525 10.8246 30.7098 10.8246 30.8221 10.8471C32.1251 10.9147 33.0911 11.5906 33.0911 12.7622C33.0911 13.686 32.4396 14.4745 31.2265 14.6323V14.6773C32.5519 14.7674 33.5628 15.511 33.5628 16.66C33.5628 17.8992 32.4396 18.7103 30.9569 18.7103H24.6217V27.0466H30.6199C32.8664 27.0466 34.7086 25.2216 34.7086 22.9461V2.46574H28.7328Z",
      fill: "url(#paint1_linear_1336_4714)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M29.8336 13.0326C29.8336 12.4919 29.4517 12.1314 29.0024 12.0638C28.9575 12.0638 28.8452 12.0412 28.7778 12.0412H26.6436V14.0239H28.7778C28.8452 14.0239 28.98 14.0239 29.0024 14.0014C29.4517 13.9338 29.8336 13.5733 29.8336 13.0326Z",
      fill: "url(#paint2_linear_1336_4714)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6.13296 2.46574C3.88645 2.46574 2.04432 4.29072 2.04432 6.56631V16.6825C3.19004 17.2458 4.38069 17.6063 5.57133 17.6063C6.98664 17.6063 7.75045 16.7501 7.75045 15.5785V10.8021H11.255V15.556C11.255 17.4035 10.1093 18.9131 6.22282 18.9131C3.86399 18.9131 2.02185 18.3949 2.02185 18.3949V27.0241H8.02003C10.2665 27.0241 12.1087 25.1991 12.1087 22.9235V2.46574H6.13296Z",
      fill: "url(#paint3_linear_1336_4714)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.4329 2.46574C15.1864 2.46574 13.3443 4.29072 13.3443 6.56631V11.9286C14.3777 11.0499 16.1749 10.4866 19.0729 10.6218C20.623 10.6894 22.2854 11.1175 22.2854 11.1175V12.8523C21.4542 12.4243 20.4657 12.0412 19.1852 11.9511C16.9836 11.7934 15.6582 12.8749 15.6582 14.7674C15.6582 16.6825 16.9836 17.764 19.1852 17.5838C20.4657 17.4937 21.4542 17.0881 22.2854 16.6825V18.4174C22.2854 18.4174 20.6454 18.8455 19.0729 18.9131C16.1749 19.0483 14.3777 18.485 13.3443 17.6063V27.0692H19.3424C21.589 27.0692 23.4311 25.2442 23.4311 22.9686V2.46574H17.4329Z",
      fill: "url(#paint4_linear_1336_4714)"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint0_linear_1336_4714",
      x1: "24.6404",
      y1: "16.3248",
      x2: "34.7357",
      y2: "16.3248",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#007940"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.229",
      stopColor: "#00873F"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.743",
      stopColor: "#40A737"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "1",
      stopColor: "#5CB531"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint1_linear_1336_4714",
      x1: "24.6402",
      y1: "14.7463",
      x2: "34.7362",
      y2: "14.7463",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#007940"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.229",
      stopColor: "#00873F"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.743",
      stopColor: "#40A737"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "1",
      stopColor: "#5CB531"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint2_linear_1336_4714",
      x1: "24.6401",
      y1: "13.0297",
      x2: "34.7357",
      y2: "13.0297",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#007940"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.229",
      stopColor: "#00873F"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.743",
      stopColor: "#40A737"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "1",
      stopColor: "#5CB531"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint3_linear_1336_4714",
      x1: "2.0396",
      y1: "14.7463",
      x2: "12.2911",
      y2: "14.7463",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#1F286F"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.475",
      stopColor: "#004E94"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.826",
      stopColor: "#0066B1"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "1",
      stopColor: "#006FBC"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "paint4_linear_1336_4714",
      x1: "13.2861",
      y1: "14.7463",
      x2: "23.2428",
      y2: "14.7463",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#6C2C2F"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.173",
      stopColor: "#882730"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.573",
      stopColor: "#BE1833"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "0.859",
      stopColor: "#DC0436"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: "1",
      stopColor: "#E60039"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0_1336_4714"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "37",
      height: "29",
      fill: "white"
    }))));
  }
};

var PaymentIconProps;
(function (PaymentIconProps) {
  PaymentIconProps["MasterCard"] = "payment_icon_1";
  PaymentIconProps["Visa"] = "payment_icon_2";
  PaymentIconProps["PayPal"] = "payment_icon_3";
  PaymentIconProps["AmericanXpress"] = "payment_icon_4";
  PaymentIconProps["JCB"] = "payment_icon_5";
})(PaymentIconProps || (PaymentIconProps = {}));
var AwardsIconType;
(function (AwardsIconType) {
  AwardsIconType["RECTANGLE_HORIZONTAL"] = "rectangle_horizontal";
  AwardsIconType["RECTANGLE_VERTICAL"] = "rectangle_vertical";
  AwardsIconType["SQUARE"] = "square";
  AwardsIconType["CIRCLE"] = "circle";
})(AwardsIconType || (AwardsIconType = {}));
var ContactMediumIconProps;
(function (ContactMediumIconProps) {
  ContactMediumIconProps["Whatsapp"] = "whatsapp";
  ContactMediumIconProps["Phone"] = "phone";
  ContactMediumIconProps["Cellphone"] = "cell_phone";
  ContactMediumIconProps["Email"] = "email";
})(ContactMediumIconProps || (ContactMediumIconProps = {}));
var SocialMediaIconProps;
(function (SocialMediaIconProps) {
  SocialMediaIconProps["Instagram"] = "instagram";
  SocialMediaIconProps["Facebook"] = "facebook";
  SocialMediaIconProps["X"] = "x";
  SocialMediaIconProps["Youtube"] = "youtube";
  SocialMediaIconProps["Linkedin"] = "linkedin";
  SocialMediaIconProps["Tiktok"] = "tiktok";
  SocialMediaIconProps["Pinterest"] = "pinterest";
  SocialMediaIconProps["Line"] = "line";
  SocialMediaIconProps["Whatsapp"] = "whatsapp";
})(SocialMediaIconProps || (SocialMediaIconProps = {}));

var Address = function Address(_ref) {
  var headline = _ref.headline,
    text = _ref.text,
    className = _ref.className,
    component = _ref.component;
  return /*#__PURE__*/React.createElement("address", {
    className: "".concat(css$n["".concat(className)], " ").concat(css$n["".concat(className, "__address")])
  }, headline && component === 'address' && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline)), text && /*#__PURE__*/React.createElement("p", {
    className: css$n.footer__address_text
  }, text));
};

var AwardIcons = function AwardIcons(_ref) {
  var award_icons = _ref.award_icons,
    headline = _ref.headline,
    className = _ref.className;
  var iconTypeClasses = [css$n.award__icon__circle, css$n.award__icon__square, css$n.award__icon__rectangle_horizontal, css$n.award__icon__rectangle_vertical];
  var variantClassName = classNameMapper(Object.values(AwardsIconType), iconTypeClasses);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$n["".concat(className)], " ").concat(css$n["".concat(className, "__award_icons")])
  }, headline && /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline), /*#__PURE__*/React.createElement("div", {
    className: css$n.footer__award__wrapper
  }, award_icons && award_icons.length > 0 && award_icons.map(function (award) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (award.component === 'award_id') return /*#__PURE__*/React.createElement("div", {
      key: award._uid,
      id: award.id
    });
    if ((award === null || award === void 0 ? void 0 : award.icon_image) && ((_a = award === null || award === void 0 ? void 0 : award.icon_image) === null || _a === void 0 ? void 0 : _a.length) > 0 && (award === null || award === void 0 ? void 0 : award.icon_link.length) > 0) {
      return ((_b = award.icon_link[0]) === null || _b === void 0 ? void 0 : _b.link) && (/*#__PURE__*/React.createElement(Link, {
        key: award._uid,
        title: ((_d = (_c = award.icon_link[0]) === null || _c === void 0 ? void 0 : _c.link) === null || _d === void 0 ? void 0 : _d.cached_url) || '',
        href: getLinkHref(award.icon_link[0]) || ((_f = (_e = award.icon_link[0]) === null || _e === void 0 ? void 0 : _e.link) === null || _f === void 0 ? void 0 : _f.url) || '',
        external: !!((_h = (_g = award.icon_link[0]) === null || _g === void 0 ? void 0 : _g.link) === null || _h === void 0 ? void 0 : _h.url),
        variant: LinkVariant.Secondary,
        target: TargetValues.Self,
        showExternalIcon: false,
        piwik_click_id: (_j = award.icon_link[0]) === null || _j === void 0 ? void 0 : _j.piwik_click_id
      }, /*#__PURE__*/React.createElement("div", {
        className: css$n.award__icon__image__wrapper
      }, (award === null || award === void 0 ? void 0 : award.icon_image) && ((_k = award === null || award === void 0 ? void 0 : award.icon_image) === null || _k === void 0 ? void 0 : _k.length) > 0 && ((_m = (_l = award.icon_image[0]) === null || _l === void 0 ? void 0 : _l.image) === null || _m === void 0 ? void 0 : _m.item) && (/*#__PURE__*/React.createElement(AwardImage, {
        icon_type_className: variantClassName.get(award.icon_type),
        icon_image: award === null || award === void 0 ? void 0 : award.icon_image,
        imageSizes: awardSizes[award.icon_type || AwardsIconType.RECTANGLE_HORIZONTAL] || []
      })))));
    }
    if ((award === null || award === void 0 ? void 0 : award.icon_image) && ((_o = award === null || award === void 0 ? void 0 : award.icon_image) === null || _o === void 0 ? void 0 : _o.length) > 0 && !((_p = award === null || award === void 0 ? void 0 : award.icon_link) === null || _p === void 0 ? void 0 : _p.length)) return /*#__PURE__*/React.createElement(AwardImage, {
      key: award.icon_type,
      icon_type_className: variantClassName.get(award.icon_type),
      icon_image: award === null || award === void 0 ? void 0 : award.icon_image,
      imageSizes: awardSizes[award.icon_type || AwardsIconType.RECTANGLE_HORIZONTAL] || []
    });
  })));
};
var AwardImage = function AwardImage(_ref2) {
  var icon_image = _ref2.icon_image,
    imageSizes = _ref2.imageSizes,
    icon_type_className = _ref2.icon_type_className;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  return /*#__PURE__*/React.createElement("div", {
    className: icon_type_className
  }, icon_image && (icon_image === null || icon_image === void 0 ? void 0 : icon_image.length) > 0 && ((_b = (_a = icon_image[0]) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.item) && (/*#__PURE__*/React.createElement("div", {
    className: css$n.footer__award_image__wrapper
  }, /*#__PURE__*/React.createElement(Image, {
    key: (_c = icon_image[0]) === null || _c === void 0 ? void 0 : _c._uid,
    src: ((_f = (_e = (_d = icon_image[0]) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.focal_embed_link) || ((_j = (_h = (_g = icon_image[0]) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.embed_link),
    alt: icon_image[0].alt_text,
    imageSizes: imageSizes
  }))));
};

var ContactList = function ContactList(_ref) {
  var contact_medium = _ref.contact_medium,
    headline = _ref.headline,
    className = _ref.className,
    _uid = _ref._uid,
    component = _ref.component,
    link = _ref.link;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$n.footer__contact_list, " ").concat(css$n["".concat(className)], " ").concat(css$n["".concat(className, "__contact_medium")]),
    key: _uid
  }, headline && component === 'footer_contact' && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline)), contact_medium && contact_medium.length > 0 && contact_medium.map(function (contact) {
    var _a, _b;
    return /*#__PURE__*/React.createElement("address", {
      key: contact._uid,
      className: css$n.footer__links
    }, contact.component === 'contact_atom' ? (/*#__PURE__*/React.createElement(Link, {
      href: contact.contact_text,
      contact_type: contact.contact_icon,
      variant: LinkVariant.Secondary,
      title: contact.contact_icon,
      target: TargetValues.Self,
      external: true,
      showExternalIcon: false,
      className: css$n.footer__contact_wrapper
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RenderContactFormIcon, Object.assign({}, contact)), contact.name || contact.contact_icon === ContactMediumIconProps.Whatsapp && 'WhatsApp' || contact.contact_icon === ContactMediumIconProps.Email && 'Contact form' || contact.contact_text))) : contact.component === 'contact_atom_form' && (/*#__PURE__*/React.createElement(Link, {
      href: contact.link.cached_url,
      variant: LinkVariant.Secondary,
      title: contact.name,
      target: contact.link.target,
      external: ((_a = contact.link) === null || _a === void 0 ? void 0 : _a.linktype) === 'url' || ((_b = contact.link) === null || _b === void 0 ? void 0 : _b.linktype) === 'email',
      showExternalIcon: false,
      className: css$n.footer__contact_wrapper
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RenderContactFormIcon, {
      contact_icon: ContactMediumIconProps.Email
    }), contact.name))));
  }), link && link.length > 0 && (link === null || link === void 0 ? void 0 : link.map(function (linkItem) {
    var _a, _b, _c;
    return /*#__PURE__*/React.createElement(Link, {
      key: linkItem._uid,
      title: (linkItem === null || linkItem === void 0 ? void 0 : linkItem.name) || ((_a = linkItem === null || linkItem === void 0 ? void 0 : linkItem.link) === null || _a === void 0 ? void 0 : _a.cached_url),
      href: ((_b = linkItem === null || linkItem === void 0 ? void 0 : linkItem.link) === null || _b === void 0 ? void 0 : _b.cached_url) || ((_c = linkItem === null || linkItem === void 0 ? void 0 : linkItem.link) === null || _c === void 0 ? void 0 : _c.url),
      variant: LinkVariant.Secondary,
      target: TargetValues.Self,
      showExternalIcon: false,
      external: !!linkItem.link.url,
      className: css$n.footer__contact__link,
      piwik_click_id: linkItem === null || linkItem === void 0 ? void 0 : linkItem.piwik_click_id
    }, linkItem === null || linkItem === void 0 ? void 0 : linkItem.name);
  })));
};

var FooterText = function FooterText(_ref) {
  var headline = _ref.headline,
    text = _ref.text,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: css$n["".concat(className)]
  }, headline && /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline), text && /*#__PURE__*/React.createElement("p", {
    className: css$n.footer__text
  }, text));
};

var FooterImageText = function FooterImageText(_ref) {
  var image = _ref.image,
    image_link = _ref.image_link,
    display_text_on_right = _ref.display_text_on_right,
    className = _ref.className,
    headline = _ref.headline,
    component = _ref.component;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$n.footer__image_text__wrapper, "  ").concat(css$n["".concat(className)])
  }, headline && component === 'footer_image_text' && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline)), /*#__PURE__*/React.createElement("div", {
    className: css$n.footer__image_text
  }, image && image.map(function (image) {
    var _a, _b, _c, _d;
    return /*#__PURE__*/React.createElement(Image, {
      key: image._uid,
      src: ((_b = (_a = image === null || image === void 0 ? void 0 : image.image) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.focal_embed_link) || ((_d = (_c = image === null || image === void 0 ? void 0 : image.image) === null || _c === void 0 ? void 0 : _c.item) === null || _d === void 0 ? void 0 : _d.embed_link),
      alt: image.alt_text,
      imageSizes: [{
        width: 60,
        height: 60
      }],
      className: css$n.footer__image_text_image
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: css$n.footer__image_text__text
  }, display_text_on_right && /*#__PURE__*/React.createElement("p", null, display_text_on_right), image_link && image_link.map(function (link) {
    var _a, _b;
    return /*#__PURE__*/React.createElement(Link, {
      key: "".concat(link._uid),
      title: link.name,
      href: ((_a = link.link) === null || _a === void 0 ? void 0 : _a.cached_url) || '',
      variant: LinkVariant.Secondary,
      target: TargetValues.Self,
      showExternalIcon: false,
      className: css$n.footer__links,
      piwik_click_id: link === null || link === void 0 ? void 0 : link.piwik_click_id,
      anchor: (_b = link === null || link === void 0 ? void 0 : link.link) === null || _b === void 0 ? void 0 : _b.anchor
    }, link.name);
  }))));
};

var NewsLetterButton = function NewsLetterButton(_ref) {
  var button_text = _ref.button_text,
    text = _ref.text,
    className = _ref.className,
    component = _ref.component,
    headline = _ref.headline,
    link = _ref.link;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$n.newsletter__wrapper, " ").concat(css$n["".concat(className)])
  }, headline && component === 'newsletter' && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4,
    className: css$n.footer__newsletter_text
  }, headline)), text && component === 'newsletter' && (/*#__PURE__*/React.createElement("p", {
    className: css$n.footer__newsletter_text
  }, text)), button_text && link && (/*#__PURE__*/React.createElement(Link, {
    title: (link === null || link === void 0 ? void 0 : link.url) || 'Newsletter',
    href: link.cached_url || (link === null || link === void 0 ? void 0 : link.url),
    variant: LinkVariant.Button,
    target: TargetValues.Self,
    className: css$n.footer__newsletter_button,
    showExternalIcon: false,
    external: !!(link === null || link === void 0 ? void 0 : link.url)
  }, button_text)));
};

var Payment = function Payment(_ref) {
  var list_with_icons = _ref.list_with_icons,
    option_text = _ref.option_text,
    headline = _ref.headline,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$n["".concat(className)], " ").concat(css$n["".concat(className, "__payment")])
  }, headline && /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline), option_text && hasTextContent(option_text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(option_text.content)
  })), /*#__PURE__*/React.createElement("span", {
    className: css$n.footer__payment_icons
  }, list_with_icons && list_with_icons.map(function (link) {
    if ((link === null || link === void 0 ? void 0 : link.name) && !link.icon) return /*#__PURE__*/React.createElement(PaymentIcons.PaymentFallback, {
      text: link === null || link === void 0 ? void 0 : link.name,
      key: link._uid
    });
    return /*#__PURE__*/React.createElement(RenderPaymentIcons, Object.assign({}, link, {
      key: link._uid
    }));
  })));
};

var QuickNavigation = function QuickNavigation(_ref) {
  var internal_links = _ref.internal_links,
    headline = _ref.headline,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$n["".concat(className)], " ").concat(css$n["".concat(className, "__internal_links")])
  }, headline && /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline), internal_links && internal_links.length > 0 && (/*#__PURE__*/React.createElement("ul", {
    className: css$n.footer__links_wrapper
  }, internal_links.map(function (link) {
    var _a, _b;
    return /*#__PURE__*/React.createElement("li", {
      key: link._uid,
      className: css$n.footer__links
    }, /*#__PURE__*/React.createElement(Link, {
      title: link.name,
      href: getLinkHref(link),
      variant: LinkVariant.Secondary,
      target: TargetValues.Self,
      showExternalIcon: false,
      external: ((_a = link.link) === null || _a === void 0 ? void 0 : _a.linktype) == 'url',
      className: css$n.footer__links,
      piwik_click_id: link === null || link === void 0 ? void 0 : link.piwik_click_id,
      anchor: (_b = link === null || link === void 0 ? void 0 : link.link) === null || _b === void 0 ? void 0 : _b.anchor
    }, link.name));
  }))));
};

var SocialMediaLinks = function SocialMediaLinks(props) {
  var social_media_sources = props.social_media_sources,
    headline = props.headline,
    text = props.text,
    className = props.className,
    _uid = props._uid,
    component = props.component;
  return /*#__PURE__*/React.createElement("div", {
    className: css$n["".concat(className)],
    key: _uid
  }, headline && component === 'social_media' && (/*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4
  }, headline)), text && component === 'social_media' && /*#__PURE__*/React.createElement("p", null, text), /*#__PURE__*/React.createElement("span", {
    className: css$n.footer__social_media_wrapper
  }, social_media_sources && social_media_sources.length > 0 && social_media_sources.map(function (social) {
    var _a, _b, _c, _d;
    return /*#__PURE__*/React.createElement(Link, {
      key: social._uid,
      title: ((_a = social.link) === null || _a === void 0 ? void 0 : _a.cached_url) || 'Igus Social Media',
      href: ((_b = social === null || social === void 0 ? void 0 : social.link) === null || _b === void 0 ? void 0 : _b.url) || ((_c = social.link) === null || _c === void 0 ? void 0 : _c.cached_url),
      variant: LinkVariant.Secondary,
      target: TargetValues.Self,
      showExternalIcon: false,
      external: !!((_d = social === null || social === void 0 ? void 0 : social.link) === null || _d === void 0 ? void 0 : _d.url),
      rel: "nofollow"
    }, /*#__PURE__*/React.createElement("span", {
      className: css$n.footer__social_media__icon_wrapper
    }, /*#__PURE__*/React.createElement(RenderSocialMediaIcon, Object.assign({}, social))));
  })));
};

var RenderSocialMediaIcon = function RenderSocialMediaIcon(icon) {
  var social_media_icon = icon.social_media_icon;
  switch (social_media_icon) {
    case 'instagram':
      return /*#__PURE__*/React.createElement(InstagramIcon, null);
    case 'linkedin':
      return /*#__PURE__*/React.createElement(LinkedInIcon, null);
    case 'x':
      return /*#__PURE__*/React.createElement(TwitterIcon, null);
    case 'youtube':
      return /*#__PURE__*/React.createElement(YoutubeIcon, null);
    case 'tiktok':
      return /*#__PURE__*/React.createElement(TiktokIcon, null);
    case 'pinterest':
      return /*#__PURE__*/React.createElement(PinterestIcon, null);
    case 'line':
      return /*#__PURE__*/React.createElement(LineIcon, null);
    case 'whatsapp':
      return /*#__PURE__*/React.createElement(WhatsAppIcon2, null);
    default:
      return /*#__PURE__*/React.createElement(FacebookIcon, null);
  }
};
var RenderContactFormIcon = function RenderContactFormIcon(icon) {
  var contact_icon = icon.contact_icon;
  switch (contact_icon) {
    case 'whatsapp':
      return /*#__PURE__*/React.createElement(WhatsappIcon, null);
    case 'email':
      return /*#__PURE__*/React.createElement(ContactFormIcon, null);
    case 'cell_phone':
      return /*#__PURE__*/React.createElement(PhoneIcon, null);
    default:
      return /*#__PURE__*/React.createElement(PhoneIcon, null);
  }
};
var RenderPaymentIcons = function RenderPaymentIcons(paymenticon) {
  var icon = paymenticon.icon;
  switch (icon) {
    case PaymentIconProps.MasterCard:
      return /*#__PURE__*/React.createElement(PaymentIcons.Mastercard, null);
    case PaymentIconProps.Visa:
      return /*#__PURE__*/React.createElement(PaymentIcons.Visa, null);
    case PaymentIconProps.PayPal:
      return /*#__PURE__*/React.createElement(PaymentIcons.Paypal, null);
    case PaymentIconProps.AmericanXpress:
      return /*#__PURE__*/React.createElement(PaymentIcons.AmericanExpress, null);
    case PaymentIconProps.JCB:
      return /*#__PURE__*/React.createElement(PaymentIcons.Jcb, null);
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};
var FooterComponents = function FooterComponents(props) {
  switch (props.component) {
    case 'footer_text':
      return /*#__PURE__*/React.createElement(FooterText, Object.assign({}, props));
    case 'quick_navigation':
      return /*#__PURE__*/React.createElement(QuickNavigation, Object.assign({}, props));
    case 'payment':
      return /*#__PURE__*/React.createElement(Payment, Object.assign({}, props));
    case 'awards':
      return /*#__PURE__*/React.createElement(AwardIcons, Object.assign({}, props));
    case 'address':
      return /*#__PURE__*/React.createElement(Address, Object.assign({}, props));
    case 'footer_contact':
      return /*#__PURE__*/React.createElement(ContactList, Object.assign({}, props));
    case 'social_media':
      return /*#__PURE__*/React.createElement(SocialMediaLinks, Object.assign({}, props));
    case 'footer_image_text':
      return /*#__PURE__*/React.createElement(FooterImageText, Object.assign({}, props));
    case 'newsletter':
      return /*#__PURE__*/React.createElement(NewsLetterButton, Object.assign({}, props));
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};
var CountrySwitcher$1 = function CountrySwitcher(_ref) {
  var language = _ref.language,
    country = _ref.country,
    footerLanguage = _ref.footerLanguage,
    footerCountry = _ref.footerCountry;
  var _a, _b;
  var _useContext = useContext(CountrySwitchContext),
    setIsModalOpen = _useContext.setIsModalOpen;
  var toggleCountrySwitch = function toggleCountrySwitch() {
    setIsModalOpen(function (prevState) {
      return !prevState;
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css$n.footer__countrySwitch__wrapper
  }, /*#__PURE__*/React.createElement("button", {
    title: footerLanguage,
    className: "".concat(css$n.footer__countrySwitch__link, " ").concat(css$n.footer__countrySwitch__language),
    onClick: toggleCountrySwitch
  }, /*#__PURE__*/React.createElement(GlobeIcon, null), "".concat(footerLanguage, ": "), language ? languageMap[language] : 'English'), /*#__PURE__*/React.createElement("button", {
    title: footerCountry,
    className: "".concat(css$n.footer__countrySwitch__link, " ").concat(css$n.footer__countrySwitch__country),
    onClick: toggleCountrySwitch
  }, "".concat(footerCountry, ": "), country ? ((_a = CountryData[country.toLowerCase()]) === null || _a === void 0 ? void 0 : _a.localName) || ((_b = CountryData[country.toLowerCase()]) === null || _b === void 0 ? void 0 : _b.name) : 'International'));
};

var css$m = {"footer__legal__text":"FooterLegal-module_footer__legal__text__-8w25"};

var FooterLegal = function FooterLegal(_ref) {
  var legalText = _ref.legalText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, {
    className: css$m.footer__legal__text
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(legalText === null || legalText === void 0 ? void 0 : legalText.content)
  })))));
};

var Footer = function Footer(_ref) {
  var container_1 = _ref.container_1,
    container_2 = _ref.container_2,
    container_3 = _ref.container_3,
    locale = _ref.locale,
    feedback_text = _ref.feedback_text,
    feedback_link = _ref.feedback_link,
    linklist = _ref.linklist,
    legal = _ref.legal,
    className = _ref.className,
    cookieSettingLabel = _ref.cookieSettingLabel,
    footerLanguage = _ref.footerLanguage,
    footerCountry = _ref.footerCountry;
  var _extractLanguageAndCo = extractLanguageAndCountry(locale),
    _extractLanguageAndCo2 = _slicedToArray(_extractLanguageAndCo, 2),
    languageCode = _extractLanguageAndCo2[0],
    countryCode = _extractLanguageAndCo2[1];
  return /*#__PURE__*/React.createElement("footer", {
    className: className,
    id: "disclaimer"
  }, /*#__PURE__*/React.createElement(Feedback, {
    text: feedback_text,
    link: feedback_link[0]
  }), /*#__PURE__*/React.createElement("div", {
    className: css$n.footer__wrapper
  }, /*#__PURE__*/React.createElement(Container, {
    className: css$n.container
  }, container_1 === null || container_1 === void 0 ? void 0 : container_1.map(function (item) {
    return /*#__PURE__*/React.createElement(FooterComponents, Object.assign({
      key: item._uid
    }, item, {
      className: 'container1'
    }));
  }), container_2 === null || container_2 === void 0 ? void 0 : container_2.map(function (item) {
    return /*#__PURE__*/React.createElement(FooterComponents, Object.assign({
      key: item._uid
    }, item, {
      className: 'container2'
    }));
  }), container_3 === null || container_3 === void 0 ? void 0 : container_3.map(function (item) {
    return /*#__PURE__*/React.createElement(FooterComponents, Object.assign({
      key: item._uid
    }, item, {
      className: 'container3'
    }));
  }), /*#__PURE__*/React.createElement(CountrySwitcher$1, {
    language: languageCode,
    country: countryCode,
    locale: "",
    footerLanguage: footerLanguage,
    footerCountry: footerCountry
  })), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Separator, null)), /*#__PURE__*/React.createElement(LinkListHorizontal, {
    links: linklist,
    cookieSettingLabel: cookieSettingLabel
  }), /*#__PURE__*/React.createElement(FooterLegal, {
    legalText: legal
  })));
};

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject$1 = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject$1(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject$1(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (!(isWeb && (data instanceof Blob || isFileListInstance)) &&
        (isArray || isObject$1(data))) {
        copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
        if (!isArray && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    copy[key] = cloneObject(data[key]);
                }
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var isKey = (value) => /^\w*$/.test(value);

var isUndefined = (val) => val === undefined;

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

var get = (object, path, defaultValue) => {
    if (!path || !isObject$1(object)) {
        return defaultValue;
    }
    const result = (isKey(path) ? [path] : stringToPath(path)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object
        ? isUndefined(object[path])
            ? defaultValue
            : object[path]
        : result;
};

var isBoolean = (value) => typeof value === 'boolean';

var set = (object, path, value) => {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject$1(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            return;
        }
        object[key] = newValue;
        object = object[key];
    }
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout'};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = React.createContext(null);
HookFormContext.displayName = 'HookFormContext';

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                return formState[_key];
            },
        });
    }
    return result;
};

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName),
            get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) {
        return true;
    }
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject$1(val1) && isObject$1(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2, _internal_visited)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var createSubject = () => {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
};

var isEmptyObject = (value) => isObject$1(value) && !Object.keys(value).length;

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioInput = (element) => element.type === 'radio';

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject$1(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject$1(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject$1(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject$1(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject$1(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var isRegex = (value) => value instanceof RegExp;

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject$1(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

const ASYNC_FUNCTION = 'AsyncFunction';
var hasPromiseValidation = (fieldReference) => !!fieldReference &&
    !!fieldReference.validate &&
    !!((isFunction(fieldReference.validate) &&
        fieldReference.validate.constructor.name === ASYNC_FUNCTION) ||
        (isObject$1(fieldReference.validate) &&
            Object.values(fieldReference.validate).find((validateFunction) => validateFunction.constructor.name === ASYNC_FUNCTION)));

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
                    return true;
                }
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
                    return true;
                }
                else {
                    if (iterateFieldsByAction(currentField, action)) {
                        break;
                    }
                }
            }
            else if (isObject$1(currentField)) {
                if (iterateFieldsByAction(currentField, action)) {
                    break;
                }
            }
        }
    }
    return;
};

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        if (foundError && foundError.root && foundError.root.type) {
            return {
                name: `${fieldName}.root`,
                error: foundError.root,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var shouldSubscribeByName = (name, signalName, exact) => !name ||
    !signalName ||
    name === signalName ||
    convertToArrayPayload(name).some((currentName) => currentName &&
        (exact
            ? currentName === signalName
            : currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = convertToArrayPayload(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isMessage = (value) => isString(value);

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject$1(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabledFieldNames.has(name)) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject$1(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false,
    };
    let _fields = {};
    let _defaultValues = isObject$1(_options.defaultValues) || isObject$1(_options.values)
        ? cloneObject(_options.defaultValues || _options.values) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState,
    };
    const _subjects = {
        array: createSubject(),
        state: createSubject(),
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _setValid = async (shouldUpdateValid) => {
        if (!_options.disabled &&
            (_proxyFormState.isValid ||
                _proxySubscribeFormState.isValid ||
                shouldUpdateValid)) {
            const isValid = _options.resolver
                ? isEmptyObject((await _runSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (names, isValidating) => {
        if (!_options.disabled &&
            (_proxyFormState.isValidating ||
                _proxyFormState.validatingFields ||
                _proxySubscribeFormState.isValidating ||
                _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name) => {
                if (name) {
                    isValidating
                        ? set(_formState.validatingFields, name, isValidating)
                        : unset(_formState.validatingFields, name);
                }
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !isEmptyObject(_formState.validatingFields),
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields ||
                _proxySubscribeFormState.touchedFields) &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const _setErrors = (errors) => {
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
                isPreviousDirty = !!get(_formState.dirtyFields, name);
                isCurrentFieldPristine
                    ? unset(_formState.dirtyFields, name)
                    : set(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        ((_proxyFormState.dirtyFields ||
                            _proxySubscribeFormState.dirtyFields) &&
                            isPreviousDirty !== !isCurrentFieldPristine);
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = get(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    set(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField =
                        shouldUpdateField ||
                            ((_proxyFormState.touchedFields ||
                                _proxySubscribeFormState.touchedFields) &&
                                isPreviousFieldTouched !== isBlurEvent);
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name) => {
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _runSchema(names);
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) {
                        _updateIsValidating([name], true);
                    }
                    const fieldError = await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) {
                        _updateIsValidating([name]);
                    }
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                !isEmptyObject(fieldValue) &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => !_options.disabled &&
        (name && data && set(_formValues, name, data),
            !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.forEach((checkboxRef) => {
                            if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                                if (Array.isArray(fieldValue)) {
                                    checkboxRef.checked = !!fieldValue.find((data) => data === checkboxRef.value);
                                }
                                else {
                                    checkboxRef.checked =
                                        fieldValue === checkboxRef.value || !!fieldValue;
                                }
                            }
                        });
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.state.next({
                            name,
                            values: cloneObject(_formValues),
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            if (!value.hasOwnProperty(fieldKey)) {
                return;
            }
            const fieldValue = value[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                isObject$1(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: cloneObject(_formValues),
            });
            if ((_proxyFormState.isDirty ||
                _proxyFormState.dirtyFields ||
                _proxySubscribeFormState.isDirty ||
                _proxySubscribeFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState, name });
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: cloneObject(_formValues),
        });
    };
    const onChange = async (event) => {
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue) => {
            isFieldValueUpdated =
                Number.isNaN(fieldValue) ||
                    (isDateObject(fieldValue) && isNaN(fieldValue.getTime())) ||
                    deepEqual(fieldValue, get(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = getValidationModes(_options.mode);
        const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type
                ? getFieldValue(field._f)
                : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.state.next({
                    name,
                    type: event.type,
                    values: cloneObject(_formValues),
                });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) {
                            _setValid();
                        }
                    }
                    else if (!isBlurEvent) {
                        _setValid();
                    }
                }
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            if (_options.resolver) {
                const { errors } = await _runSchema([name]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            }
            else {
                _updateIsValidating([name], true);
                error = (await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([name]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid ||
                        _proxySubscribeFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key) => {
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                ((_proxyFormState.isValid || _proxySubscribeFormState.isValid) &&
                    isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
        });
        options.shouldFocus &&
            !validationResult &&
            iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ...(_state.mount ? _formValues : _defaultValues),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        error: get((formState || _formState).errors, name),
        isValidating: !!get(_formState.validatingFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        const currentError = get(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message, type, ...restOfErrorTree } = currentError;
        set(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.state.subscribe({
            next: (payload) => 'values' in payload &&
                name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const _subscribe = (props) => _subjects.state.subscribe({
        next: (formState) => {
            if (shouldSubscribeByName(props.name, formState.name, props.exact) &&
                shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) {
                props.callback({
                    values: { ..._formValues },
                    ..._formState,
                    ...formState,
                    defaultValues: _defaultValues,
                });
            }
        },
    }).unsubscribe;
    const subscribe = (props) => {
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState,
        };
        return _subscribe({
            ...props,
            formState: _proxySubscribeFormState,
        });
    };
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating &&
                unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: cloneObject(_formValues),
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled, name, }) => {
        if ((isBoolean(disabled) && _state.mount) ||
            !!disabled ||
            _names.disabled.has(name)) {
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
        }
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        if (field) {
            _setDisabledField({
                disabled: isBoolean(options.disabled)
                    ? options.disabled
                    : _options.disabled,
                name,
            });
        }
        else {
            updateValidAndValue(name, true, options.value);
        }
        return {
            ...(disabledIsDefined
                ? { disabled: options.disabled || _options.disabled }
                : {}),
            ...(_options.progressive
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled) => {
        if (isBoolean(disabled)) {
            _subjects.state.next({ disabled });
            iterateFieldsByAction(_fields, (ref, name) => {
                const currentField = get(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) {
                        currentField._f.refs.forEach((inputRef) => {
                            inputRef.disabled = currentField._f.disabled || disabled;
                        });
                    }
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        let onValidError = undefined;
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist &&
                e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _runSchema();
            _formState.errors = errors;
            fieldValues = cloneObject(values);
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        if (_names.disabled.size) {
            for (const name of _names.disabled) {
                unset(fieldValues, name);
            }
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            try {
                await onValid(fieldValues, e);
            }
            catch (error) {
                onValidError = error;
            }
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
        if (onValidError) {
            throw onValidError;
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, cloneObject(get(_defaultValues, name)));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, cloneObject(get(_defaultValues, name)))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const isEmptyResetValues = isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys(getDirtyFields(_defaultValues, _formValues)),
                ]);
                for (const fieldName of Array.from(fieldsToCheck)) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) {
                    for (const fieldName of _names.mount) {
                        setValue(fieldName, get(values, fieldName));
                    }
                }
                else {
                    _fields = {};
                }
            }
            _formValues = _options.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneObject(values);
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.state.next({
                values: { ...values },
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _state.mount =
            !_proxyFormState.isValid ||
                !!keepStateOptions.keepIsValid ||
                !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: isEmptyResetValues
                ? false
                : keepStateOptions.keepDirty
                    ? _formState.isDirty
                    : !!(keepStateOptions.keepDefaultValues &&
                        !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: isEmptyResetValues
                ? {}
                : keepStateOptions.keepDirtyValues
                    ? keepStateOptions.keepDefaultValues && _formValues
                        ? getDirtyFields(_defaultValues, _formValues)
                        : _formState.dirtyFields
                    : keepStateOptions.keepDefaultValues && formValues
                        ? getDirtyFields(_defaultValues, formValues)
                        : keepStateOptions.keepDirty
                            ? _formState.dirtyFields
                            : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful
                ? _formState.isSubmitSuccessful
                : false,
            isSubmitting: false,
            defaultValues: _defaultValues,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect &&
                    isFunction(fieldRef.select) &&
                    fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    const methods = {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _subscribe,
            _runSchema,
            _focusError,
            _getWatch,
            _getDirty,
            _setValid,
            _setFieldArray,
            _setDisabledField,
            _setErrors,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _removeUnmounted,
            _disableForm,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        subscribe,
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
    return {
        ...methods,
        formControl: methods,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = React.useRef(undefined);
    const _values = React.useRef(undefined);
    const [formState, updateFormState] = React.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState,
            };
            if (props.defaultValues && !isFunction(props.defaultValues)) {
                props.formControl.reset(props.defaultValues, props.resetOptions);
            }
        }
        else {
            const { formControl, ...rest } = createFormControl(props);
            _formControl.current = {
                ...rest,
                formState,
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    useIsomorphicLayoutEffect(() => {
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: () => updateFormState({ ...control._formState }),
            reRenderRoot: true,
        });
        updateFormState((data) => ({
            ...data,
            isReady: true,
        }));
        control._formState.isReady = true;
        return sub;
    }, [control]);
    React.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
    React.useEffect(() => {
        if (props.mode) {
            control._options.mode = props.mode;
        }
        if (props.reValidateMode) {
            control._options.reValidateMode = props.reValidateMode;
        }
    }, [control, props.mode, props.reValidateMode]);
    React.useEffect(() => {
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [control, props.errors]);
    React.useEffect(() => {
        props.shouldUnregister &&
            control._subjects.state.next({
                values: control._getWatch(),
            });
    }, [control, props.shouldUnregister]);
    React.useEffect(() => {
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) {
                control._subjects.state.next({
                    isDirty,
                });
            }
        }
    }, [control, formState.isDirty]);
    React.useEffect(() => {
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions,
            });
            _values.current = props.values;
            updateFormState((state) => ({ ...state }));
        }
        else {
            control._resetDefaultValues();
        }
    }, [control, props.values]);
    React.useEffect(() => {
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}

const r=(t,r,o)=>{if(t&&"reportValidity"in t){const s=get(o,r);t.setCustomValidity(s&&s.message||""),t.reportValidity();}},o$1=(e,t)=>{for(const o in t.fields){const s=t.fields[o];s&&s.ref&&"reportValidity"in s.ref?r(s.ref,o,e):s&&s.refs&&s.refs.forEach(t=>r(t,o,e));}},s=(r,s)=>{s.shouldUseNativeValidation&&o$1(r,s);const n={};for(const o in r){const f=get(s.fields,o),c=Object.assign(r[o]||{},{ref:f&&f.ref});if(i(s.names||Object.keys(r),o)){const r=Object.assign({},get(n,o));set(r,"root",c),set(n,o,r);}else set(n,o,c);}return n},i=(e,t)=>{const r=n(t);return e.some(e=>n(e).match(`^${r}\\.\\d+`))};function n(e){return e.replace(/\]|\[/g,"")}

function o(o,n,s$1){return void 0===s$1&&(s$1={}),function(a,i,c){try{return Promise.resolve(function(t,r){try{var u=(null!=n&&n.context&&"development"===process.env.NODE_ENV&&console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"),Promise.resolve(o["sync"===s$1.mode?"validateSync":"validate"](a,Object.assign({abortEarly:!1},n,{context:i}))).then(function(t){return c.shouldUseNativeValidation&&o$1({},c),{values:s$1.raw?Object.assign({},a):t,errors:{}}}));}catch(e){return r(e)}return u&&u.then?u.then(void 0,r):u}(0,function(e){if(!e.inner)throw e;return {values:{},errors:s((o=e,n=!c.shouldUseNativeValidation&&"all"===c.criteriaMode,(o.inner||[]).reduce(function(e,t){if(e[t.path]||(e[t.path]={message:t.message,type:t.type}),n){var o=e[t.path].types,s=o&&o[t.type];e[t.path]=appendErrors(t.path,n,e,t.type,s?[].concat(s,t.message):t.message);}return e},{})),c)};var o,n;}))}catch(e){return Promise.reject(e)}}}

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

var propertyExpr;
var hasRequiredPropertyExpr;

function requirePropertyExpr () {
	if (hasRequiredPropertyExpr) return propertyExpr;
	hasRequiredPropertyExpr = 1;

	function Cache(maxSize) {
	  this._maxSize = maxSize;
	  this.clear();
	}
	Cache.prototype.clear = function () {
	  this._size = 0;
	  this._values = Object.create(null);
	};
	Cache.prototype.get = function (key) {
	  return this._values[key]
	};
	Cache.prototype.set = function (key, value) {
	  this._size >= this._maxSize && this.clear();
	  if (!(key in this._values)) this._size++;

	  return (this._values[key] = value)
	};

	var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
	  DIGIT_REGEX = /^\d+$/,
	  LEAD_DIGIT_REGEX = /^\d/,
	  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
	  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
	  MAX_CACHE_SIZE = 512;

	var pathCache = new Cache(MAX_CACHE_SIZE),
	  setCache = new Cache(MAX_CACHE_SIZE),
	  getCache = new Cache(MAX_CACHE_SIZE);

	propertyExpr = {
	  Cache: Cache,

	  split: split,

	  normalizePath: normalizePath,

	  setter: function (path) {
	    var parts = normalizePath(path);

	    return (
	      setCache.get(path) ||
	      setCache.set(path, function setter(obj, value) {
	        var index = 0;
	        var len = parts.length;
	        var data = obj;

	        while (index < len - 1) {
	          var part = parts[index];
	          if (
	            part === '__proto__' ||
	            part === 'constructor' ||
	            part === 'prototype'
	          ) {
	            return obj
	          }

	          data = data[parts[index++]];
	        }
	        data[parts[index]] = value;
	      })
	    )
	  },

	  getter: function (path, safe) {
	    var parts = normalizePath(path);
	    return (
	      getCache.get(path) ||
	      getCache.set(path, function getter(data) {
	        var index = 0,
	          len = parts.length;
	        while (index < len) {
	          if (data != null || !safe) data = data[parts[index++]];
	          else return
	        }
	        return data
	      })
	    )
	  },

	  join: function (segments) {
	    return segments.reduce(function (path, part) {
	      return (
	        path +
	        (isQuoted(part) || DIGIT_REGEX.test(part)
	          ? '[' + part + ']'
	          : (path ? '.' : '') + part)
	      )
	    }, '')
	  },

	  forEach: function (path, cb, thisArg) {
	    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
	  },
	};

	function normalizePath(path) {
	  return (
	    pathCache.get(path) ||
	    pathCache.set(
	      path,
	      split(path).map(function (part) {
	        return part.replace(CLEAN_QUOTES_REGEX, '$2')
	      })
	    )
	  )
	}

	function split(path) {
	  return path.match(SPLIT_REGEX) || ['']
	}

	function forEach(parts, iter, thisArg) {
	  var len = parts.length,
	    part,
	    idx,
	    isArray,
	    isBracket;

	  for (idx = 0; idx < len; idx++) {
	    part = parts[idx];

	    if (part) {
	      if (shouldBeQuoted(part)) {
	        part = '"' + part + '"';
	      }

	      isBracket = isQuoted(part);
	      isArray = !isBracket && /^\d+$/.test(part);

	      iter.call(thisArg, part, isBracket, isArray, idx, parts);
	    }
	  }
	}

	function isQuoted(str) {
	  return (
	    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
	  )
	}

	function hasLeadingNumber(part) {
	  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
	}

	function hasSpecialChars(part) {
	  return SPEC_CHAR_REGEX.test(part)
	}

	function shouldBeQuoted(part) {
	  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
	}
	return propertyExpr;
}

var propertyExprExports = requirePropertyExpr();

var tinyCase;
var hasRequiredTinyCase;

function requireTinyCase () {
	if (hasRequiredTinyCase) return tinyCase;
	hasRequiredTinyCase = 1;
	const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;

	const words = (str) => str.match(reWords) || [];

	const upperFirst = (str) => str[0].toUpperCase() + str.slice(1);

	const join = (str, d) => words(str).join(d).toLowerCase();

	const camelCase = (str) =>
	  words(str).reduce(
	    (acc, next) =>
	      `${acc}${
	        !acc
	          ? next.toLowerCase()
	          : next[0].toUpperCase() + next.slice(1).toLowerCase()
	      }`,
	    '',
	  );

	const pascalCase = (str) => upperFirst(camelCase(str));

	const snakeCase = (str) => join(str, '_');

	const kebabCase = (str) => join(str, '-');

	const sentenceCase = (str) => upperFirst(join(str, ' '));

	const titleCase = (str) => words(str).map(upperFirst).join(' ');

	tinyCase = {
	  words,
	  upperFirst,
	  camelCase,
	  pascalCase,
	  snakeCase,
	  kebabCase,
	  sentenceCase,
	  titleCase,
	};
	return tinyCase;
}

var tinyCaseExports = requireTinyCase();

var toposort$1 = {exports: {}};

var hasRequiredToposort;

function requireToposort () {
	if (hasRequiredToposort) return toposort$1.exports;
	hasRequiredToposort = 1;
	/**
	 * Topological sorting function
	 *
	 * @param {Array} edges
	 * @returns {Array}
	 */

	toposort$1.exports = function(edges) {
	  return toposort(uniqueNodes(edges), edges)
	};

	toposort$1.exports.array = toposort;

	function toposort(nodes, edges) {
	  var cursor = nodes.length
	    , sorted = new Array(cursor)
	    , visited = {}
	    , i = cursor
	    // Better data structures make algorithm much faster.
	    , outgoingEdges = makeOutgoingEdges(edges)
	    , nodesHash = makeNodesHash(nodes);

	  // check for unknown nodes
	  edges.forEach(function(edge) {
	    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
	      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
	    }
	  });

	  while (i--) {
	    if (!visited[i]) visit(nodes[i], i, new Set());
	  }

	  return sorted

	  function visit(node, i, predecessors) {
	    if(predecessors.has(node)) {
	      var nodeRep;
	      try {
	        nodeRep = ", node was:" + JSON.stringify(node);
	      } catch(e) {
	        nodeRep = "";
	      }
	      throw new Error('Cyclic dependency' + nodeRep)
	    }

	    if (!nodesHash.has(node)) {
	      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
	    }

	    if (visited[i]) return;
	    visited[i] = true;

	    var outgoing = outgoingEdges.get(node) || new Set();
	    outgoing = Array.from(outgoing);

	    if (i = outgoing.length) {
	      predecessors.add(node);
	      do {
	        var child = outgoing[--i];
	        visit(child, nodesHash.get(child), predecessors);
	      } while (i)
	      predecessors.delete(node);
	    }

	    sorted[--cursor] = node;
	  }
	}

	function uniqueNodes(arr){
	  var res = new Set();
	  for (var i = 0, len = arr.length; i < len; i++) {
	    var edge = arr[i];
	    res.add(edge[0]);
	    res.add(edge[1]);
	  }
	  return Array.from(res)
	}

	function makeOutgoingEdges(arr){
	  var edges = new Map();
	  for (var i = 0, len = arr.length; i < len; i++) {
	    var edge = arr[i];
	    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
	    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
	    edges.get(edge[0]).add(edge[1]);
	  }
	  return edges
	}

	function makeNodesHash(arr){
	  var res = new Map();
	  for (var i = 0, len = arr.length; i < len; i++) {
	    res.set(arr[i], i);
	  }
	  return res
	}
	return toposort$1.exports;
}

var toposortExports = requireToposort();
var toposort = /*@__PURE__*/getDefaultExportFromCjs(toposortExports);

const toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(errorOrErrors, value, field, type) {
    this.name = void 0;
    this.message = void 0;
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = 'Error';
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params) {
    // Attempt to make the path more friendly for error message interpolation.
    const path = params.label || params.path || 'this';
    // Store the original path under `originalPath` so it isn't lost to custom
    // message functions; e.g., ones provided in `setLocale()` calls.
    params = Object.assign({}, params, {
      path,
      originalPath: params.path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === 'ValidationError';
  }
  constructor(errorOrErrors, value, field, type, disableStack) {
    const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
    if (disableStack) {
      return errorNoStack;
    }
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = [];
    this.inner = [];
    this[_Symbol$toStringTag2] = 'Error';
    this.name = errorNoStack.name;
    this.message = errorNoStack.message;
    this.type = errorNoStack.type;
    this.value = errorNoStack.value;
    this.path = errorNoStack.path;
    this.errors = errorNoStack.errors;
    this.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
  static [_Symbol$hasInstance](inst) {
    return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
  }
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  defined: '${path} must be defined',
  notNull: '${path} cannot be null',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.';
    return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${printValue(value, true)}\`` + castMsg;
  }
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  datetime: '${path} must be a valid ISO date-time',
  datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}',
  exact: '${path} object contains unknown properties: ${properties}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
let tuple = {
  notType: params => {
    const {
      path,
      value,
      spec
    } = params;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
      if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
  tuple
});

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = config;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map(ref =>
    // TODO: ? operator here?
    ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn(values, base, options);
    if (schema === undefined ||
    // @ts-ignore this can be base
    schema === base) {
      return base;
    }
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }
}

const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExprExports.getter(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }

  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}

// @ts-ignore
Reference.prototype.__isYupRef = true;

const isAbsent = value => value == null;

function createValidation(config) {
  function validate({
    value,
    path = '',
    options,
    originalValue,
    schema
  }, panic, next) {
    const {
      name,
      test,
      params,
      message,
      skipAbsent
    } = config;
    let {
      parent,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options;
    const resolveOptions = {
      value,
      parent,
      context
    };
    function createError(overrides = {}) {
      const nextParams = resolveParams(Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params), resolveOptions);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
      error.params = nextParams;
      return error;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent,
      type: name,
      from: options.from,
      createError,
      resolve(item) {
        return resolveMaybeRef(item, resolveOptions);
      },
      options,
      originalValue,
      schema
    };
    const handleResult = validOrError => {
      if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
    };
    const handleError = err => {
      if (ValidationError.isError(err)) invalid(err);else panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result;
    try {
      var _result;
      result = test.call(ctx, value, ctx);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
        if (options.sync) {
          throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}

// Warning: mutates the input
function resolveParams(params, options) {
  if (!params) return params;
  for (const key of Object.keys(params)) {
    params[key] = resolveMaybeRef(params[key], options);
  }
  return params;
}
function resolveMaybeRef(item, options) {
  return Reference.isRef(item) ? item.getValue(options.value, options.parent, options.context) : item;
}

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug;

  // root path: ''
  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExprExports.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    let isTuple = schema.type === 'tuple';
    let idx = isArray ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }

    // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach(value => next.add(value));
    removeItems.forEach(value => next.delete(value));
    return next;
  }
}

// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function clone(src, seen = new Map()) {
  if (isSchema(src) || !src || typeof src !== 'object') return src;
  if (seen.has(src)) return seen.get(src);
  let copy;
  if (src instanceof Date) {
    // Date
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    // RegExp
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    // Array
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++) copy[i] = clone(src[i], seen);
  } else if (src instanceof Map) {
    // Map
    copy = new Map();
    seen.set(src, copy);
    for (const [k, v] of src.entries()) copy.set(k, clone(v, seen));
  } else if (src instanceof Set) {
    // Set
    copy = new Set();
    seen.set(src, copy);
    for (const v of src) copy.add(clone(v, seen));
  } else if (src instanceof Object) {
    // Object
    copy = {};
    seen.set(src, copy);
    for (const [k, v] of Object.entries(src)) copy[k] = clone(v, seen);
  } else {
    throw Error(`Unable to clone ${src}`);
  }
  return copy;
}

/**
 * Copied from @standard-schema/spec to avoid having a dependency on it.
 * https://github.com/standard-schema/standard-schema/blob/main/packages/spec/src/index.ts
 */

function createStandardPath(path) {
  if (!(path != null && path.length)) {
    return undefined;
  }

  // Array to store the final path segments
  const segments = [];
  // Buffer for building the current segment
  let currentSegment = '';
  // Track if we're inside square brackets (array/property access)
  let inBrackets = false;
  // Track if we're inside quotes (for property names with special chars)
  let inQuotes = false;
  for (let i = 0; i < path.length; i++) {
    const char = path[i];
    if (char === '[' && !inQuotes) {
      // When entering brackets, push any accumulated segment after splitting on dots
      if (currentSegment) {
        segments.push(...currentSegment.split('.').filter(Boolean));
        currentSegment = '';
      }
      inBrackets = true;
      continue;
    }
    if (char === ']' && !inQuotes) {
      if (currentSegment) {
        // Handle numeric indices (e.g. arr[0])
        if (/^\d+$/.test(currentSegment)) {
          segments.push(currentSegment);
        } else {
          // Handle quoted property names (e.g. obj["foo.bar"])
          segments.push(currentSegment.replace(/^"|"$/g, ''));
        }
        currentSegment = '';
      }
      inBrackets = false;
      continue;
    }
    if (char === '"') {
      // Toggle quote state for handling quoted property names
      inQuotes = !inQuotes;
      continue;
    }
    if (char === '.' && !inBrackets && !inQuotes) {
      // On dots outside brackets/quotes, push current segment
      if (currentSegment) {
        segments.push(currentSegment);
        currentSegment = '';
      }
      continue;
    }
    currentSegment += char;
  }

  // Push any remaining segment after splitting on dots
  if (currentSegment) {
    segments.push(...currentSegment.split('.').filter(Boolean));
  }
  return segments;
}
function createStandardIssues(error, parentPath) {
  const path = parentPath ? `${parentPath}.${error.path}` : error.path;
  return error.errors.map(err => ({
    message: err,
    path: createStandardPath(path)
  }));
}
function issuesFromValidationError(error, parentPath) {
  var _error$inner;
  if (!((_error$inner = error.inner) != null && _error$inner.length) && error.errors.length) {
    return createStandardIssues(error, parentPath);
  }
  const path = parentPath ? `${parentPath}.${error.path}` : error.path;
  return error.inner.flatMap(err => issuesFromValidationError(err, path));
}

// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation(s => {
      s.nonNullable();
    });
  }

  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    }

    // if the nested value is a schema we can skip cloning, since
    // they are already immutable
    const next = Object.create(Object.getPrototypeOf(this));

    // @ts-expect-error this is readonly
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);

    // @ts-expect-error this is readonly
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

    // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

    // start with the current tests
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;

    // manually add the new tests to ensure
    // the deduping logic is consistent
    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null) return true;
      if (this.spec.optional && v === undefined) return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }

  /**
   * Run the configured transform pipeline over an input value.
   */

  cast(value, options = {}) {
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options));
    let allowOptionality = options.assert === 'ignore-optionality';
    let result = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }
    return result;
  }
  _cast(rawValue, options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this), rawValue);
    if (value === undefined) {
      value = this.getDefault(options);
    }
    return value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test of Object.values(this.internalTests)) {
      if (test) initialTests.push(test);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, initialErrors => {
      // even if we aren't ending early we can't proceed further if the types aren't correct
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }

  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = arg => {
      if (fired) return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = arg => {
      if (fired) return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count) return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test = tests[i];
      test(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest({
    key,
    index,
    parent,
    parentPath,
    originalParent,
    options
  }) {
    const k = key != null ? key : index;
    if (k == null) {
      throw TypeError('Must include `key` or `index` for nested validations');
    }
    const isIndex = typeof k === 'number';
    let value = parent[k];
    const testOptions = Object.assign({}, options, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent,
      value,
      originalValue: originalParent[k],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: undefined,
      // index: undefined,
      [isIndex ? 'index' : 'key']: k,
      path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
    });
    return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      reject(error);
    }, (errors, validated) => {
      if (errors.length) reject(new ValidationError(errors, validated, undefined, undefined, disableStackTrace));else resolve(validated);
    }));
  }
  validateSync(value, options) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result;
    let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      throw error;
    }, (errors, validated) => {
      if (errors.length) throw new ValidationError(errors, value, undefined, undefined, disableStackTrace);
      result = validated;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }
  _getDefault(options) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === 'function' ? defaultValue.call(this, options) : clone(defaultValue);
  }
  getDefault(options
  // If schema is defaulted we know it's at least not undefined
  ) {
    let schema = this.resolve(options || {});
    return schema._getDefault(options);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: 'nullable',
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: 'optionality',
      test(value) {
        return value === undefined ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined(message = mixed.defined) {
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable(message = mixed.notNull) {
    return this.nullability(false, message);
  }
  required(message = mixed.required) {
    return this.clone().withMutation(next => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation(next => next.nullable().optional());
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */

  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }
    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }
    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore readonly array
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: 'typeError',
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value)) return this.createError({
          params: {
            type: this.schema.type
          }
        });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: 'oneOf',
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(', '),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: 'notOneOf',
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: Array.from(invalids).join(', '),
            resolved
          }
        });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.filter((n, idx, list) => list.findIndex(c => c.OPTIONS.name === n.OPTIONS.name) === idx).map(fn => {
        const params = fn.OPTIONS.params && options ? resolveParams(Object.assign({}, fn.OPTIONS.params), options) : fn.OPTIONS.params;
        return {
          name: fn.OPTIONS.name,
          params
        };
      })
    };
    return description;
  }
  get ['~standard']() {
    const schema = this;
    const standard = {
      version: 1,
      vendor: 'yup',
      async validate(value) {
        try {
          const result = await schema.validate(value, {
            abortEarly: false
          });
          return {
            value: result
          };
        } catch (err) {
          if (err instanceof ValidationError) {
            return {
              issues: issuesFromValidationError(err)
            };
          }
          throw err;
        }
      }
    };
    return standard;
  }
}
// @ts-expect-error
Schema.prototype.__isYupSchema__ = true;
for (const method of ['validate', 'validateSync']) Schema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], Object.assign({}, options, {
    parent,
    path
  }));
};
for (const alias of ['equals', 'is']) Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ['not', 'nope']) Schema.prototype[alias] = Schema.prototype.notOneOf;

const returnsTrue = () => true;
function create$8(spec) {
  return new MixedSchema(spec);
}
class MixedSchema extends Schema {
  constructor(spec) {
    super(typeof spec === 'function' ? {
      type: 'mixed',
      check: spec
    } : Object.assign({
      type: 'mixed',
      check: returnsTrue
    }, spec));
  }
}
create$8.prototype = MixedSchema.prototype;

/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */

// prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  const struct = parseDateStruct(date);
  if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;

  // timestamps without timezone identifiers should be considered local time
  if (struct.z === undefined && struct.plusMinus === undefined) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date) {
  var _regexResult$7$length, _regexResult$;
  const regexResult = isoReg.exec(date);
  if (!regexResult) return null;

  // use of toNumber() avoids NaN timestamps caused by “undefined”
  // values being passed to Date constructor
  return {
    year: toNumber(regexResult[1]),
    month: toNumber(regexResult[2], 1) - 1,
    day: toNumber(regexResult[3], 1),
    hour: toNumber(regexResult[4]),
    minute: toNumber(regexResult[5]),
    second: toNumber(regexResult[6]),
    millisecond: regexResult[7] ?
    // allow arbitrary sub-second precision beyond milliseconds
    toNumber(regexResult[7].substring(0, 3)) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
    z: regexResult[8] || undefined,
    plusMinus: regexResult[9] || undefined,
    hourOffset: toNumber(regexResult[10]),
    minuteOffset: toNumber(regexResult[11])
  };
}
function toNumber(str, defaultValue = 0) {
  return Number(str) || defaultValue;
}

// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let rEmail =
// eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let rUrl =
// eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

// eslint-disable-next-line
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let rIsoDateTime = new RegExp(`${yearMonthDay}T${hourMinuteSecond}(\\.\\d+)?${zOrOffset}$`);
let isTrimmed = value => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: 'string',
      check(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value)) return value;

        // don't ever convert arrays
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;

        // no one wants plain objects converted to [Object object]
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }
  required(message) {
    return super.required(message).withMutation(schema => schema.test({
      message: message || mixed.required,
      name: 'required',
      skipAbsent: true,
      test: value => !!value.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation(schema => {
      schema.tests = schema.tests.filter(t => t.OPTIONS.name !== 'required');
      return schema;
    });
  }
  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      skipAbsent: true,
      test: value => value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  }
  datetime(options) {
    let message = '';
    let allowOffset;
    let precision;
    if (options) {
      if (typeof options === 'object') {
        ({
          message = '',
          allowOffset = false,
          precision = undefined
        } = options);
      } else {
        message = options;
      }
    }
    return this.matches(rIsoDateTime, {
      name: 'datetime',
      message: message || string.datetime,
      excludeEmptyString: true
    }).test({
      name: 'datetime_offset',
      message: message || string.datetime_offset,
      params: {
        allowOffset
      },
      skipAbsent: true,
      test: value => {
        if (!value || allowOffset) return true;
        const struct = parseDateStruct(value);
        if (!struct) return false;
        return !!struct.z;
      }
    }).test({
      name: 'datetime_precision',
      message: message || string.datetime_precision,
      params: {
        precision
      },
      skipAbsent: true,
      test: value => {
        if (!value || precision == undefined) return true;
        const struct = parseDateStruct(value);
        if (!struct) return false;
        return struct.precision === precision;
      }
    });
  }

  //-- transforms --
  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }
  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;

//
// Number Interfaces
//

let invalidDate = new Date('');
let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
class DateSchema extends Schema {
  constructor() {
    super({
      type: 'date',
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
        value = parseIsoDate(value);

        // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;

// @ts-expect-error
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
  function addNode(depPath, key) {
    let node = propertyExprExports.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }
  for (const key of Object.keys(fields)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }
  return toposort.array(Array.from(nodes), edges).reverse();
}

function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

const parseJson = (value, _, ctx) => {
  if (typeof value !== 'string') {
    return value;
  }
  let parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
    /* */
  }
  return ctx.isType(parsed) ? parsed : value;
};

// @ts-ignore
function deepPartial(schema) {
  if ('fields' in schema) {
    const partial = {};
    for (const [key, fieldSchema] of Object.entries(schema.fields)) {
      partial[key] = deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === 'array') {
    const nextArray = schema.optional();
    if (nextArray.innerType) nextArray.innerType = deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === 'tuple') {
    return schema.optional().clone({
      types: schema.spec.types.map(deepPartial)
    });
  }
  if ('optional' in schema) {
    return schema.optional();
  }
  return schema;
}
const deepHas = (obj, p) => {
  const path = [...propertyExprExports.normalizePath(p)];
  if (path.length === 1) return path[0] in obj;
  let last = path.pop();
  let parent = propertyExprExports.getter(propertyExprExports.join(path), true)(obj);
  return !!(parent && last in parent);
};
let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
class ObjectSchema extends Schema {
  constructor(spec) {
    super({
      type: 'object',
      check(value) {
        return isObject(value) || typeof value === 'function';
      }
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _cast(_value, options = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options);

    //should ignore nulls here
    if (value === undefined) return this.getDefault(options);
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = [].concat(this._nodes, Object.keys(value).filter(v => !this._nodes.includes(v)));
    let intermediateValue = {}; // is filled during the transform below
    let innerOptions = Object.assign({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = (prop in value);
      if (field) {
        let fieldValue;
        let inputValue = value[prop];

        // safe to mutate since this is fired in sequence
        innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = field instanceof Schema ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec != null && fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ?
        // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      from = [],
      originalValue = _value,
      recursive = this.spec.recursive
    } = options;
    options.from = [{
      schema: this,
      value: originalValue
    }, ...from];
    // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating
    options.__validating = true;
    options.originalValue = originalValue;
    super._validate(_value, options, panic, (objectErrors, value) => {
      if (!recursive || !isObject(value)) {
        next(objectErrors, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = [];
      for (let key of this._nodes) {
        let field = this.fields[key];
        if (!field || Reference.isRef(field)) {
          continue;
        }
        tests.push(field.asNestedTest({
          options,
          key,
          parent: value,
          parentPath: options.path,
          originalParent: originalValue
        }));
      }
      this.runTests({
        tests,
        value,
        originalValue,
        options
      }, panic, fieldErrors => {
        next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
      });
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = Object.assign({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      nextFields[field] = target === undefined ? schemaOrRef : target;
    }
    return next.withMutation(s =>
    // XXX: excludes here is wrong
    s.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges]));
  }
  _getDefault(options) {
    if ('default' in this.spec) {
      return super._getDefault(options);
    }

    // if there is no default set invent one
    if (!this._nodes.length) {
      return undefined;
    }
    let dft = {};
    this._nodes.forEach(key => {
      var _innerOptions;
      const field = this.fields[key];
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
    });
    return dft;
  }
  setFields(shape, excludedEdges) {
    let next = this.clone();
    next.fields = shape;
    next._nodes = sortFields(shape, excludedEdges);
    next._sortErrors = sortByKeyOrder(Object.keys(shape));
    // XXX: this carries over edges which may not be what you want
    if (excludedEdges) next._excludedEdges = excludedEdges;
    return next;
  }
  shape(additions, excludes = []) {
    return this.clone().withMutation(next => {
      let edges = next._excludedEdges;
      if (excludes.length) {
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        edges = [...next._excludedEdges, ...excludes];
      }

      // XXX: excludes here is wrong
      return next.setFields(Object.assign(next.fields, additions), edges);
    });
  }
  partial() {
    const partial = {};
    for (const [key, schema] of Object.entries(this.fields)) {
      partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
    }
    return this.setFields(partial);
  }
  deepPartial() {
    const next = deepPartial(this);
    return next;
  }
  pick(keys) {
    const picked = {};
    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }
    return this.setFields(picked, this._excludedEdges.filter(([a, b]) => keys.includes(a) && keys.includes(b)));
  }
  omit(keys) {
    const remaining = [];
    for (const key of Object.keys(this.fields)) {
      if (keys.includes(key)) continue;
      remaining.push(key);
    }
    return this.pick(remaining);
  }
  from(from, to, alias) {
    let fromGetter = propertyExprExports.getter(from, true);
    return this.transform(obj => {
      if (!obj) return obj;
      let newObj = obj;
      if (deepHas(obj, from)) {
        newObj = Object.assign({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }

  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(message) {
    return this.test({
      name: 'exact',
      exclusive: true,
      message: message || object.exact,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return unknownKeys.length === 0 || this.createError({
          params: {
            properties: unknownKeys.join(', ')
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: true
    });
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow !== 'boolean') {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn) {
    return this.transform(obj => {
      if (!obj) return obj;
      const result = {};
      for (const key of Object.keys(obj)) result[fn(key)] = obj[key];
      return result;
    });
  }
  camelCase() {
    return this.transformKeys(tinyCaseExports.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tinyCaseExports.snakeCase);
  }
  constantCase() {
    return this.transformKeys(key => tinyCaseExports.snakeCase(key).toUpperCase());
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    base.fields = {};
    for (const [key, value] of Object.entries(next.fields)) {
      var _innerOptions2;
      let innerOptions = options;
      if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      base.fields[key] = value.describe(innerOptions);
    }
    return base;
  }
}
create$3.prototype = ObjectSchema.prototype;

/**
 * Adapted from remix-utils/honeypot
 * Original: https://github.com/sergiodxa/remix-utils
 * License: MIT
 */
var HoneypotContext = /*#__PURE__*/createContext({});
var HoneypotField = function HoneypotField(_ref) {
  var label = _ref.label,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '__honeypot_inputs' : _ref$className;
  var context = useContext(HoneypotContext);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _context$nameFieldNam = context.nameFieldName,
    nameFieldName = _context$nameFieldNam === void 0 ? 'website_url' : _context$nameFieldNam,
    _context$validFromFie = context.validFromFieldName,
    validFromFieldName = _context$validFromFie === void 0 ? 'form_timestamp' : _context$validFromFie,
    encryptedValidFrom = context.encryptedValidFrom;
  var honeypotLabel = label || formatMessage({
    id: 'HONEYPOT_FIELD_LABEL',
    defaultMessage: 'Website'
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "".concat(nameFieldName, "_wrap"),
    "data-testid": "".concat(nameFieldName, "_wrap"),
    className: className,
    style: {
      position: 'absolute',
      left: '-9999px',
      top: '-9999px',
      visibility: 'hidden',
      opacity: 0,
      height: 0,
      width: 0,
      overflow: 'hidden'
    },
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: nameFieldName
  }, honeypotLabel), /*#__PURE__*/React.createElement("input", {
    id: nameFieldName,
    name: nameFieldName,
    type: "text",
    defaultValue: "",
    autoComplete: "new-password",
    tabIndex: -1,
    placeholder: honeypotLabel
  }), validFromFieldName && encryptedValidFrom ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: validFromFieldName
  }, honeypotLabel), /*#__PURE__*/React.createElement("input", {
    id: validFromFieldName,
    name: validFromFieldName,
    type: "text",
    value: encryptedValidFrom,
    readOnly: true,
    autoComplete: "off",
    tabIndex: -1
  }))) : null);
};
var HoneypotProvider = function HoneypotProvider(_a) {
  var children = _a.children,
    context = __rest(_a, ["children"]);
  return /*#__PURE__*/React.createElement(HoneypotContext.Provider, {
    value: context
  }, children);
};

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof$1(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}

function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _construct(t, e, r) {
  if (_isNativeReflectConstruct$1()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}

function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

/**
 * Adapted from remix-utils/honeypot
 * Original: https://github.com/sergiodxa/remix-utils
 * License: MIT
 */
/**
 * Generate a random string of specified length
 */
function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var result = '';
  for (var i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
/**
 * Simple encryption function using XOR cipher
 * Note: This is for obfuscation, not cryptographic security
 */
function encrypt(value, seed) {
  var delimiter = "\x01";
  var combined = value + delimiter + Date.now();
  var encrypted = [];
  for (var i = 0; i < combined.length; i++) {
    var charCode = combined.charCodeAt(i);
    var seedChar = seed.charCodeAt(i % seed.length);
    encrypted.push(charCode ^ seedChar);
  }
  // Convert to base64-safe string using JSON
  return btoa(JSON.stringify(encrypted));
}
/**
 * Decrypt the encrypted value
 */
function decrypt(encryptedValue, seed) {
  try {
    var encryptedData = atob(encryptedValue);
    var encrypted = JSON.parse(encryptedData);
    var decrypted = '';
    for (var i = 0; i < encrypted.length; i++) {
      var charCode = encrypted[i];
      if (typeof charCode !== 'number') {
        return null;
      }
      var seedChar = seed.charCodeAt(i % seed.length);
      decrypted += String.fromCharCode(charCode ^ seedChar);
    }
    var delimiter = "\x01";
    var parts = decrypted.split(delimiter);
    return parts.length === 2 ? parts[0] : null;
  } catch (_a) {
    return null;
  }
}

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * The error thrown when the Honeypot fails, meaning some automated bot filled
 * the form and the request is probably spam.
 */
var SpamError = /*#__PURE__*/function (_Error) {
  function SpamError() {
    var _this;
    _classCallCheck(this, SpamError);
    _this = _callSuper(this, SpamError, arguments);
    _this.name = 'SpamError';
    return _this;
  }
  _inherits(SpamError, _Error);
  return _createClass(SpamError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var DEFAULT_NAME_FIELD_NAME = 'website_url';
var DEFAULT_VALID_FROM_FIELD_NAME = 'form_timestamp';
/**
 * Module used to implement a Honeypot.
 * A Honeypot is a visually hidden input that is used to detect spam bots. This
 * field is expected to be left empty by users because they don't see it, but
 * bots will fill it falling in the honeypot trap.
 */
var Honeypot = /*#__PURE__*/function () {
  function Honeypot() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Honeypot);
    this.generatedEncryptionSeed = this.randomValue();
    this.config = config;
  }
  /**
   * Get the HoneypotInputProps to be used in your forms.
   * @param options The options for the input props.
   * @param options.validFromTimestamp Since when the timestamp is valid.
   * @returns The props to be used in the form.
   */
  return _createClass(Honeypot, [{
    key: "getInputProps",
    value: function getInputProps() {
      return __awaiter(this, arguments, void 0, function () {
        var _this2 = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$validFromTimesta = _ref.validFromTimestamp,
          validFromTimestamp = _ref$validFromTimesta === void 0 ? Date.now() : _ref$validFromTimesta;
        return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _this2.nameFieldName;
                _context.t1 = _this2.validFromFieldName;
                _context.next = 4;
                return _this2.encrypt(validFromTimestamp.toString());
              case 4:
                _context.t2 = _context.sent;
                return _context.abrupt("return", {
                  nameFieldName: _context.t0,
                  validFromFieldName: _context.t1,
                  encryptedValidFrom: _context.t2
                });
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })();
      });
    }
  }, {
    key: "check",
    value: function check(formData) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _a, nameFieldName, actualName, honeypotValue, validFrom, time;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              nameFieldName = (_a = this.config.nameFieldName) !== null && _a !== void 0 ? _a : DEFAULT_NAME_FIELD_NAME;
              if (this.config.randomizeNameFieldName) {
                actualName = this.getRandomizedNameFieldName(nameFieldName, formData);
                if (actualName) nameFieldName = actualName;
              }
              if (this.shouldCheckHoneypot(formData, nameFieldName)) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              if (formData.has(nameFieldName)) {
                _context2.next = 6;
                break;
              }
              throw new SpamError('Missing honeypot input');
            case 6:
              honeypotValue = formData.get(nameFieldName);
              if (!(honeypotValue !== '')) {
                _context2.next = 9;
                break;
              }
              throw new SpamError('Honeypot input not empty');
            case 9:
              if (this.validFromFieldName) {
                _context2.next = 11;
                break;
              }
              return _context2.abrupt("return");
            case 11:
              validFrom = formData.get(this.validFromFieldName);
              if (validFrom) {
                _context2.next = 14;
                break;
              }
              throw new SpamError('Missing honeypot valid from input');
            case 14:
              _context2.next = 16;
              return this.decrypt(validFrom);
            case 16:
              time = _context2.sent;
              if (time) {
                _context2.next = 19;
                break;
              }
              throw new SpamError('Invalid honeypot valid from input');
            case 19:
              if (this.isValidTimeStamp(Number(time))) {
                _context2.next = 21;
                break;
              }
              throw new SpamError('Invalid honeypot valid from input');
            case 21:
              if (!this.isFuture(Number(time))) {
                _context2.next = 23;
                break;
              }
              throw new SpamError('Honeypot valid from is in future');
            case 23:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * Remove honeypot fields from FormData before sending to backend
     */
  }, {
    key: "removeHoneypotFields",
    value: function removeHoneypotFields(formData) {
      var fieldsToRemove = [this.nameFieldName, this.validFromFieldName].filter(Boolean);
      fieldsToRemove.forEach(function (field) {
        if (field && formData.has(field)) {
          formData["delete"](field);
        }
      });
    }
  }, {
    key: "nameFieldName",
    get: function get() {
      var _a;
      var fieldName = (_a = this.config.nameFieldName) !== null && _a !== void 0 ? _a : DEFAULT_NAME_FIELD_NAME;
      if (!this.config.randomizeNameFieldName) return fieldName;
      return "".concat(fieldName, "_").concat(this.randomValue());
    }
  }, {
    key: "validFromFieldName",
    get: function get() {
      if (this.config.validFromFieldName === undefined) {
        return DEFAULT_VALID_FROM_FIELD_NAME;
      }
      return this.config.validFromFieldName;
    }
  }, {
    key: "encryptionSeed",
    get: function get() {
      var _a;
      return (_a = this.config.encryptionSeed) !== null && _a !== void 0 ? _a : this.generatedEncryptionSeed;
    }
  }, {
    key: "getRandomizedNameFieldName",
    value: function getRandomizedNameFieldName(nameFieldName, formData) {
      var _iterator = _createForOfIteratorHelper(formData.keys()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          if (!key.startsWith(nameFieldName)) continue;
          return key;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "shouldCheckHoneypot",
    value: function shouldCheckHoneypot(formData, nameFieldName) {
      return formData.has(nameFieldName) || Boolean(this.validFromFieldName && formData.has(this.validFromFieldName));
    }
  }, {
    key: "randomValue",
    value: function randomValue() {
      return randomString();
    }
  }, {
    key: "encrypt",
    value: function encrypt$1(value) {
      return encrypt(value, this.encryptionSeed);
    }
  }, {
    key: "decrypt",
    value: function decrypt$1(value) {
      return decrypt(value, this.encryptionSeed);
    }
  }, {
    key: "isFuture",
    value: function isFuture(timestamp) {
      return timestamp > Date.now();
    }
  }, {
    key: "isValidTimeStamp",
    value: function isValidTimeStamp(timestamp) {
      if (Number.isNaN(timestamp)) return false;
      if (timestamp <= 0) return false;
      if (timestamp >= Number.MAX_SAFE_INTEGER) return false;
      return true;
    }
  }]);
}();

var SPAM_MARKETING_ACTION = 'MA00013385';
/**
 * Custom hook for honeypot spam detection and handling
 */
var useHoneypotValidation = function useHoneypotValidation(config) {
  var _useState = useState(null),
    honeypotProps = _useState[0],
    setHoneypotProps = _useState[1];
  var _useState2 = useState(true),
    isInitializing = _useState2[0],
    setIsInitializing = _useState2[1];
  var _useState3 = useState(null),
    honeypotInstance = _useState3[0],
    setHoneypotInstance = _useState3[1];
  var marketingAction = config.marketingAction,
    submitHandler = config.submitHandler,
    locale = config.locale,
    utmProps = config.utmProps,
    contactPerson = config.contactPerson;
  useEffect(function () {
    var initHoneypot = function initHoneypot() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var honeypot, props;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              honeypot = new Honeypot({
                randomizeNameFieldName: true,
                nameFieldName: 'website_url',
                validFromFieldName: 'form_timestamp'
              });
              _context.next = 4;
              return honeypot.getInputProps();
            case 4:
              props = _context.sent;
              setHoneypotProps(props);
              setHoneypotInstance(honeypot);
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              setHoneypotProps({
                nameFieldName: 'website_url',
                validFromFieldName: 'form_timestamp',
                encryptedValidFrom: ''
              });
            case 12:
              _context.prev = 12;
              setIsInitializing(false);
              return _context.finish(12);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9, 12, 15]]);
      }));
    };
    initHoneypot();
  }, []);
  /**
   * Validate form data against honeypot protection
   * @param formData - The form data to validate
   * @returns Promise<boolean> - true if spam detected (and handled), false if legitimate
   */
  var validateHoneypot = useCallback(function (formData) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _a, _b, formElement, formDataForValidation, localeArray, formattedLocale, parts, spamData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!honeypotProps || !honeypotInstance)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", false);
          case 2:
            formElement = document.querySelector('form');
            if (formElement) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", false);
          case 5:
            formDataForValidation = new FormData(formElement);
            _context2.prev = 6;
            _context2.next = 9;
            return honeypotInstance.check(formDataForValidation);
          case 9:
            return _context2.abrupt("return", false);
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](6);
            if (!(_context2.t0 instanceof SpamError)) {
              _context2.next = 27;
              break;
            }
            _context2.prev = 15;
            localeArray = Array.isArray(locale) ? locale : [locale];
            if (localeArray.length >= 2) {
              // Handle array format: ['en', 'de'] -> 'en_DE'
              formattedLocale = "".concat(localeArray[0], "_").concat((_a = localeArray[1]) === null || _a === void 0 ? void 0 : _a.toUpperCase());
            } else if (localeArray[0] && localeArray[0].includes('-')) {
              // Handle hyphen format: 'en-de' -> 'en_DE'
              parts = localeArray[0].split('-');
              formattedLocale = "".concat(parts[0], "_").concat((_b = parts[1]) === null || _b === void 0 ? void 0 : _b.toUpperCase());
            } else {
              // Use as-is or default
              formattedLocale = localeArray[0] || 'en_DE';
            }
            spamData = Object.assign(Object.assign({}, formData), {
              locale: formattedLocale,
              source: SPAM_MARKETING_ACTION,
              spam_detection_reason: _context2.t0.message,
              spam_detection_timestamp: new Date().toISOString(),
              original_marketing_action: marketingAction,
              user_agent: typeof window !== 'undefined' ? navigator.userAgent : '',
              utmProps: utmProps
            });
            _context2.next = 21;
            return submitHandler(spamData, contactPerson);
          case 21:
            _context2.next = 26;
            break;
          case 23:
            _context2.prev = 23;
            _context2.t1 = _context2["catch"](15);
            console.error('Failed to log spam attempt:', _context2.t1);
          case 26:
            return _context2.abrupt("return", true);
          case 27:
            throw _context2.t0;
          case 28:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[6, 12], [15, 23]]);
    }));
  }, [honeypotProps, honeypotInstance, marketingAction, submitHandler, locale, utmProps, contactPerson]);
  return {
    honeypotProps: honeypotProps,
    validateHoneypot: validateHoneypot,
    isInitializing: isInitializing
  };
};

var css$l = {"error_message__wrapper":"ErrorMessage-module_error_message__wrapper__hFzEN"};

var ErrorMessage = function ErrorMessage(_ref) {
  var id = _ref.id,
    errorMessage = _ref.errorMessage,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    id: "".concat(id, "_errorDesc"),
    className: "".concat(className, " ").concat(css$l.error_message__wrapper)
  }, errorMessage);
};

var css$k = {"tooltip__wrapper":"ToolTip-module_tooltip__wrapper__8qGA2","tooltip__wrapper_icon":"ToolTip-module_tooltip__wrapper_icon__5uZCC","tooltip__wrapper_text":"ToolTip-module_tooltip__wrapper_text__UVzyu"};

function Tooltip(_ref) {
  var message = _ref.message,
    ariaDescribedBy = _ref.ariaDescribedBy;
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var tooltipRef = useRef(null);
  var tooltipTextRef = useRef(null);
  var tooltipId = useId();
  useEffect(function () {
    function handleClickOutside(event) {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setVisible(false);
      }
    }
    var handleKeydown = function handleKeydown(event) {
      if (event.key === 'Escape') {
        setVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeydown);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);
  var handleMouseEnter = function handleMouseEnter() {
    if (!('ontouchstart' in window)) {
      setVisible(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (!('ontouchstart' in window)) {
      setVisible(false);
    }
  };
  var handleTouch = function handleTouch() {
    if ('ontouchstart' in window) {
      setVisible(!visible);
    }
  };
  return /*#__PURE__*/React.createElement("button", {
    ref: tooltipRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onTouchEnd: handleTouch,
    className: css$k.tooltip__wrapper,
    "aria-label": message,
    "aria-describedby": ariaDescribedBy,
    "aria-roledescription": "tooltip",
    onFocus: handleMouseEnter,
    onBlur: handleMouseLeave
  }, /*#__PURE__*/React.createElement("svg", {
    className: css$k.tooltip__wrapper_icon,
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333496C3.31992 0.333496 0.333252 3.32016 0.333252 7.00016C0.333252 10.6802 3.31992 13.6668 6.99992 13.6668C10.6799 13.6668 13.6666 10.6802 13.6666 7.00016C13.6666 3.32016 10.6799 0.333496 6.99992 0.333496ZM7.66659 10.3335H6.33325V6.3335H7.66659V10.3335ZM7.66659 5.00016H6.33325V3.66683H7.66659V5.00016Z",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("span", {
    className: css$k.tooltip__wrapper_text,
    ref: tooltipTextRef,
    id: "".concat(ariaDescribedBy).concat(tooltipId),
    role: "tooltip"
  }, message));
}

var Label = function Label(_ref) {
  var id = _ref.id,
    labelText = _ref.labelText,
    toolTip = _ref.toolTip,
    required = _ref.required;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, labelText, required && '*', ' ', toolTip && /*#__PURE__*/React.createElement(Tooltip, {
    message: toolTip,
    ariaDescribedBy: "tooltip".concat(id)
  }));
};

var css$j = {"form_element__wrapper":"FormSelection-module_form_element__wrapper__qjC9w","form__wrapper":"FormSelection-module_form__wrapper__6t3yt","form__alignment":"FormSelection-module_form__alignment__1j1ge","submit_button__wrapper":"FormSelection-module_submit_button__wrapper__79oF-","form_submit_button":"FormSelection-module_form_submit_button__M10VE","marketing_consent__wrapper":"FormSelection-module_marketing_consent__wrapper__nlkHh","marketing_consent_checkbox__wrapper":"FormSelection-module_marketing_consent_checkbox__wrapper__qhEgg","marketing_consent_checkbox":"FormSelection-module_marketing_consent_checkbox__uZk-T","marketing_consent_text":"FormSelection-module_marketing_consent_text__Xz1nv","file_upload_text":"FormSelection-module_file_upload_text__icVph","required_fields_note":"FormSelection-module_required_fields_note__hB7dw","form_structure_headline":"FormSelection-module_form_structure_headline__07gAK","form_structure_line":"FormSelection-module_form_structure_line__1sGzy","form_global_errormessage":"FormSelection-module_form_global_errormessage__Bonne","form_two_column":"FormSelection-module_form_two_column__UaRl8","contact__person__wrapper":"FormSelection-module_contact__person__wrapper__v-LcK","contact__image__wrapper":"FormSelection-module_contact__image__wrapper__RkSiW","contact__detail__wrapper":"FormSelection-module_contact__detail__wrapper__BVVTO","text__anchor":"FormSelection-module_text__anchor__Jd8Qg","phone__icon":"FormSelection-module_phone__icon__obsoM","contact__person__name":"FormSelection-module_contact__person__name__0s-l-","form__error__message":"FormSelection-module_form__error__message__12ZIH","form__selected__image":"FormSelection-module_form__selected__image__VYhUB","form__text__wrapper":"FormSelection-module_form__text__wrapper__V44qf","file__input__wrapper":"FormSelection-module_file__input__wrapper__3YX-0"};

var css$i = {"checkbox__wrapper":"Checkbox-module_checkbox__wrapper__S8R7u","checkbox__wrapper_error":"Checkbox-module_checkbox__wrapper_error__JDqan","checkbox__label":"Checkbox-module_checkbox__label__DenD5","checkbox__description":"Checkbox-module_checkbox__description__KNvmc","checkbox__element":"Checkbox-module_checkbox__element__xXjz3","checkbox__wrapper_errormessage":"Checkbox-module_checkbox__wrapper_errormessage__W-x0R"};

var Checkbox = function Checkbox(_ref) {
  var _uid = _ref._uid,
    label = _ref.label,
    tooltip = _ref.tooltip,
    error_message = _ref.error_message,
    translation = _ref.translation,
    hasError = _ref.hasError,
    required = _ref.required,
    language = _ref.language,
    options = _ref.options,
    description = _ref.description,
    field_name = _ref.name,
    register = _ref.register;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var tooltipText = tooltip;
  var errorMessage = error_message;
  var checkboxOption = options;
  var checkboxDescription = description;
  var labelText = label;
  var translate = translation === null || translation === void 0 ? void 0 : translation.filter(function (item) {
    var _a, _b, _c;
    return ((_a = item.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (language === null || language === void 0 ? void 0 : language.toLowerCase()) || ((_b = item.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = fallbackLang[language !== null && language !== void 0 ? language : '']) === null || _c === void 0 ? void 0 : _c.toLowerCase());
  });
  if (translate && translate.length > 0) {
    tooltipText = (_b = (_a = translate[0]) === null || _a === void 0 ? void 0 : _a.tooltip) !== null && _b !== void 0 ? _b : tooltipText;
    errorMessage = (_d = (_c = translate[0]) === null || _c === void 0 ? void 0 : _c.error_message) !== null && _d !== void 0 ? _d : errorMessage;
    checkboxOption = (_f = (_e = translate[0]) === null || _e === void 0 ? void 0 : _e.options) !== null && _f !== void 0 ? _f : checkboxOption;
    checkboxDescription = (_h = (_g = translate[0]) === null || _g === void 0 ? void 0 : _g.description) !== null && _h !== void 0 ? _h : checkboxDescription;
    labelText = (_k = (_j = translate[0]) === null || _j === void 0 ? void 0 : _j.label) !== null && _k !== void 0 ? _k : labelText;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$i.checkbox__wrapper, " ").concat(hasError ? css$i.checkbox__wrapper_error : '')
  }, /*#__PURE__*/React.createElement("p", {
    className: css$i.checkbox__label
  }, labelText, required && ' *', ' ', tooltipText && (/*#__PURE__*/React.createElement(Tooltip, {
    message: tooltipText,
    ariaDescribedBy: "tooltip".concat(_uid)
  }))), /*#__PURE__*/React.createElement("div", null, checkboxOption === null || checkboxOption === void 0 ? void 0 : checkboxOption.map(function (optionItem, ind) {
    return /*#__PURE__*/React.createElement("span", {
      key: "checkbox-wrap-".concat(ind),
      className: css$i.checkbox__element
    }, /*#__PURE__*/React.createElement("input", Object.assign({
      key: optionItem._uid,
      type: "checkbox",
      value: optionItem.value,
      id: optionItem._uid
    }, register === null || register === void 0 ? void 0 : register("".concat(replaceSpaceInName(field_name))))), /*#__PURE__*/React.createElement(Label, {
      id: optionItem._uid,
      labelText: optionItem.name
    }));
  }), checkboxDescription && (/*#__PURE__*/React.createElement("p", {
    className: css$i.checkbox__description
  }, checkboxDescription)), /*#__PURE__*/React.createElement(ErrorMessage, {
    id: _uid,
    errorMessage: errorMessage,
    className: "".concat(css$i.checkbox__wrapper_errormessage, " ").concat(hasError ? css$i.checkbox__wrapper_error : '')
  })));
};

var css$h = {"dropdown__wrapper":"Dropdown-module_dropdown__wrapper__zldhr","dropdown__wrapper_error":"Dropdown-module_dropdown__wrapper_error__zH-Rk","dropdown__wrapper_errormessage":"Dropdown-module_dropdown__wrapper_errormessage__4RlAS"};

var DropDownDefaultOption = function DropDownDefaultOption(_ref) {
  var placeHolder = _ref.placeHolder,
    labelText = _ref.labelText;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement("option", {
    selected: true,
    value: "",
    disabled: true
  }, placeHolder || formatMessage({
    id: 'DROPDOWN_DEFAULT_PLACEHOLDER'
  }, {
    labelText: labelText
  }));
};
var DropwDown = function DropwDown(_ref2) {
  var _uid = _ref2._uid,
    label = _ref2.label,
    default_value = _ref2.default_value,
    tooltip = _ref2.tooltip,
    placeholder = _ref2.placeholder,
    error_message = _ref2.error_message,
    translation = _ref2.translation,
    hasError = _ref2.hasError,
    required = _ref2.required,
    language = _ref2.language,
    options = _ref2.options,
    register = _ref2.register;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
  var labelText = label;
  var tooltipText = tooltip;
  var errorMessage = error_message;
  var dropdownOption = options;
  var placeHolder = placeholder;
  var defaultValue = default_value;
  var translate = translation === null || translation === void 0 ? void 0 : translation.filter(function (item) {
    var _a, _b, _c;
    return (language === null || language === void 0 ? void 0 : language.toLowerCase()) === ((_a = item.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || ((_b = item.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = fallbackLang[language !== null && language !== void 0 ? language : '']) === null || _c === void 0 ? void 0 : _c.toLowerCase());
  });
  if (translate && translate.length > 0) {
    labelText = (_b = (_a = translate[0]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : labelText;
    tooltipText = (_d = (_c = translate[0]) === null || _c === void 0 ? void 0 : _c.tooltip) !== null && _d !== void 0 ? _d : tooltipText;
    errorMessage = (_f = (_e = translate[0]) === null || _e === void 0 ? void 0 : _e.error_message) !== null && _f !== void 0 ? _f : errorMessage;
    dropdownOption = (_h = (_g = translate[0]) === null || _g === void 0 ? void 0 : _g.options) !== null && _h !== void 0 ? _h : dropdownOption;
    placeHolder = (_k = (_j = translate[0]) === null || _j === void 0 ? void 0 : _j.placeholder) !== null && _k !== void 0 ? _k : placeHolder;
    defaultValue = (_m = (_l = translate[0]) === null || _l === void 0 ? void 0 : _l.default_value) !== null && _m !== void 0 ? _m : defaultValue;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$h.dropdown__wrapper, " ").concat(hasError ? css$h.dropdown__wrapper_error : '')
  }, /*#__PURE__*/React.createElement(Label, {
    id: _uid,
    labelText: labelText,
    required: required,
    toolTip: tooltipText
  }), /*#__PURE__*/React.createElement("select", Object.assign({
    id: _uid
  }, register), /*#__PURE__*/React.createElement(DropDownDefaultOption, {
    labelText: labelText,
    placeHolder: placeHolder
  }), dropdownOption.map(function (optionItem, index) {
    return /*#__PURE__*/React.createElement("option", {
      selected: optionItem.value === defaultValue,
      key: "".concat(optionItem, "_").concat(index),
      value: optionItem.value
    }, optionItem.name);
  })), /*#__PURE__*/React.createElement(ErrorMessage, {
    id: _uid,
    errorMessage: errorMessage,
    className: "".concat(css$h.dropdown__wrapper_errormessage, " ").concat(hasError ? css$h.dropdown__wrapper_error : '')
  }));
};

var InputHidden = function InputHidden(_ref) {
  var value = _ref.value,
    description = _ref.description,
    language = _ref.language,
    register = _ref.register,
    translation = _ref.translation;
  var _a, _b, _c, _d;
  var valueText = value;
  var descriptionText = description;
  var translate = translation === null || translation === void 0 ? void 0 : translation.filter(function (item) {
    var _a, _b, _c;
    return ((_a = item.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (language === null || language === void 0 ? void 0 : language.toLowerCase()) || ((_b = item.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = fallbackLang[language !== null && language !== void 0 ? language : '']) === null || _c === void 0 ? void 0 : _c.toLowerCase());
  });
  if (translate) {
    valueText = (_b = (_a = translate[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : valueText;
    descriptionText = (_d = (_c = translate[0]) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : descriptionText;
  }
  return /*#__PURE__*/React.createElement("input", Object.assign({
    type: "hidden"
  }, register, {
    id: descriptionText,
    name: descriptionText,
    value: valueText
  }));
};

var css$g = {"input__wrapper":"InputText-module_input__wrapper__NkT0I","input__wrapper_error":"InputText-module_input__wrapper_error__Pvp8c","input__wrapper_errormessage":"InputText-module_input__wrapper_errormessage__sG2fh"};

var inputTypes;
(function (inputTypes) {
  inputTypes["TEXT"] = "text";
  inputTypes["NUMBER"] = "number";
  inputTypes["EMAIL"] = "email";
  inputTypes["DATE"] = "date";
  inputTypes["PASSWORD"] = "password";
})(inputTypes || (inputTypes = {}));
var InputText = function InputText(_ref) {
  var _uid = _ref._uid,
    label = _ref.label,
    tooltip = _ref.tooltip,
    description = _ref.description,
    error_message = _ref.error_message,
    translation = _ref.translation,
    hasError = _ref.hasError,
    required = _ref.required,
    language = _ref.language,
    register = _ref.register,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? inputTypes.TEXT : _ref$type;
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var labelText = label;
  var tooltipText = tooltip;
  var descriptionText = description;
  var errorMessage = error_message;
  var translate = translation === null || translation === void 0 ? void 0 : translation.filter(function (item) {
    var _a, _b, _c;
    return ((_a = item.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (language === null || language === void 0 ? void 0 : language.toLowerCase()) || ((_b = item.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = fallbackLang[language !== null && language !== void 0 ? language : '']) === null || _c === void 0 ? void 0 : _c.toLowerCase());
  });
  if (translate && translate.length > 0) {
    labelText = (_b = (_a = translate[0]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : labelText;
    tooltipText = (_d = (_c = translate[0]) === null || _c === void 0 ? void 0 : _c.tooltip) !== null && _d !== void 0 ? _d : tooltipText;
    descriptionText = (_f = (_e = translate[0]) === null || _e === void 0 ? void 0 : _e.description) !== null && _f !== void 0 ? _f : descriptionText;
    errorMessage = (_h = (_g = translate[0]) === null || _g === void 0 ? void 0 : _g.error_message) !== null && _h !== void 0 ? _h : errorMessage;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$g.input__wrapper, " ").concat(hasError ? css$g.input__wrapper_error : '')
  }, /*#__PURE__*/React.createElement(Label, {
    id: _uid,
    labelText: labelText,
    required: required,
    toolTip: tooltipText
  }), /*#__PURE__*/React.createElement("input", Object.assign({
    type: type,
    id: _uid,
    placeholder: descriptionText || labelText,
    "aria-describedby": "".concat(_uid, "_errorDesc"),
    required: required
  }, register)), /*#__PURE__*/React.createElement(ErrorMessage, {
    id: _uid,
    errorMessage: errorMessage,
    className: "".concat(css$g.input__wrapper_errormessage, " ").concat(hasError ? css$g.input__wrapper_error : '')
  }));
};

var css$f = {"textarea_wrapper":"InputTextMultiline-module_textarea_wrapper__giPJ8","textarea_wrapper_error":"InputTextMultiline-module_textarea_wrapper_error__BHxlU","textarea_wrapper_errormessage":"InputTextMultiline-module_textarea_wrapper_errormessage__WqOgc"};

var InputTextMultiline = function InputTextMultiline(_ref) {
  var _uid = _ref._uid,
    label = _ref.label,
    tooltip = _ref.tooltip,
    description = _ref.description,
    language = _ref.language,
    translation = _ref.translation,
    error_message = _ref.error_message,
    hasError = _ref.hasError,
    required = _ref.required,
    register = _ref.register;
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var labelText = label;
  var tooltipText = tooltip;
  var errorMessage = error_message;
  var textAreaDescription = description;
  var translate = translation === null || translation === void 0 ? void 0 : translation.filter(function (item) {
    var _a, _b, _c;
    return ((_a = item.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (language === null || language === void 0 ? void 0 : language.toLowerCase()) || ((_b = item.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = fallbackLang[language !== null && language !== void 0 ? language : '']) === null || _c === void 0 ? void 0 : _c.toLowerCase());
  });
  if (translate && translate.length > 0) {
    labelText = (_b = (_a = translate[0]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : labelText;
    tooltipText = (_d = (_c = translate[0]) === null || _c === void 0 ? void 0 : _c.tooltip) !== null && _d !== void 0 ? _d : tooltipText;
    errorMessage = (_f = (_e = translate[0]) === null || _e === void 0 ? void 0 : _e.error_message) !== null && _f !== void 0 ? _f : errorMessage;
    textAreaDescription = (_h = (_g = translate[0]) === null || _g === void 0 ? void 0 : _g.description) !== null && _h !== void 0 ? _h : textAreaDescription;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$f.textarea_wrapper, " ").concat(hasError ? css$f.textarea_wrapper_error : '')
  }, /*#__PURE__*/React.createElement(Label, {
    id: _uid,
    labelText: labelText,
    required: required,
    toolTip: tooltipText
  }), /*#__PURE__*/React.createElement("textarea", Object.assign({
    id: _uid,
    "aria-describedby": "".concat(_uid, "_errorDesc"),
    "aria-required": required,
    placeholder: textAreaDescription || labelText
  }, register)), /*#__PURE__*/React.createElement(ErrorMessage, {
    id: _uid,
    errorMessage: errorMessage,
    className: "".concat(css$f.textarea_wrapper_errormessage, " ").concat(hasError ? css$f.textarea_wrapper_error : '')
  }));
};

var css$e = {"radiobutton__wrapper":"Radiobutton-module_radiobutton__wrapper__I8fqR","radiobutton__wrapper_error":"Radiobutton-module_radiobutton__wrapper_error__0Cd62","radiobutton__label":"Radiobutton-module_radiobutton__label__PSmPx","radiobutton__description":"Radiobutton-module_radiobutton__description__q3ujr","radiobutton__element":"Radiobutton-module_radiobutton__element__Uq85k","radiobutton__wrapper_errormessage":"Radiobutton-module_radiobutton__wrapper_errormessage__LiLn2"};

var Radiobutton = function Radiobutton(_ref) {
  var _uid = _ref._uid,
    label = _ref.label,
    tooltip = _ref.tooltip,
    error_message = _ref.error_message,
    translation = _ref.translation,
    hasError = _ref.hasError,
    required = _ref.required,
    language = _ref.language,
    options = _ref.options,
    description = _ref.description,
    default_value = _ref.default_value,
    register = _ref.register,
    name = _ref.name;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var tooltipText = tooltip;
  var errorMessage = error_message;
  var radiobuttonOption = options;
  var radiobuttonDescription = description;
  var labelText = label;
  var translate = translation === null || translation === void 0 ? void 0 : translation.filter(function (item) {
    var _a, _b, _c;
    return (language === null || language === void 0 ? void 0 : language.toLowerCase()) === ((_a = item.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || ((_b = item.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = fallbackLang[language !== null && language !== void 0 ? language : '']) === null || _c === void 0 ? void 0 : _c.toLowerCase());
  });
  if (translate) {
    tooltipText = (_b = (_a = translate[0]) === null || _a === void 0 ? void 0 : _a.tooltip) !== null && _b !== void 0 ? _b : tooltipText;
    errorMessage = (_d = (_c = translate[0]) === null || _c === void 0 ? void 0 : _c.error_message) !== null && _d !== void 0 ? _d : errorMessage;
    radiobuttonOption = (_f = (_e = translate[0]) === null || _e === void 0 ? void 0 : _e.options) !== null && _f !== void 0 ? _f : radiobuttonOption;
    radiobuttonDescription = (_h = (_g = translate[0]) === null || _g === void 0 ? void 0 : _g.description) !== null && _h !== void 0 ? _h : radiobuttonDescription;
    labelText = (_k = (_j = translate[0]) === null || _j === void 0 ? void 0 : _j.label) !== null && _k !== void 0 ? _k : labelText;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$e.radiobutton__wrapper, " ").concat(hasError ? css$e.radiobutton__wrapper_error : '')
  }, /*#__PURE__*/React.createElement("p", {
    className: css$e.radiobutton__label
  }, labelText, required && ' *', ' ', tooltipText && (/*#__PURE__*/React.createElement(Tooltip, {
    message: tooltipText,
    ariaDescribedBy: "tooltip".concat(_uid)
  }))), /*#__PURE__*/React.createElement("div", null, radiobuttonOption.map(function (optionItem) {
    return /*#__PURE__*/React.createElement("span", {
      key: optionItem._uid,
      className: css$e.radiobutton__element
    }, /*#__PURE__*/React.createElement("input", Object.assign({
      type: "radio",
      id: optionItem._uid,
      value: optionItem.value,
      defaultChecked: optionItem.value === default_value
    }, register, {
      name: "".concat(name).concat(language ? "-".concat(language) : '') || ''
    })), /*#__PURE__*/React.createElement(Label, {
      id: optionItem._uid,
      labelText: optionItem.name
    }));
  }), radiobuttonDescription && (/*#__PURE__*/React.createElement("p", {
    className: css$e.radiobutton__description
  }, radiobuttonDescription)), /*#__PURE__*/React.createElement(ErrorMessage, {
    id: _uid,
    errorMessage: errorMessage,
    className: "".concat(css$e.radiobutton__wrapper_errormessage, " ").concat(hasError ? css$e.radiobutton__wrapper_error : '')
  })));
};

var APIResultStatus;
(function (APIResultStatus) {
  APIResultStatus[APIResultStatus["error"] = 0] = "error";
  APIResultStatus[APIResultStatus["success"] = 1] = "success";
})(APIResultStatus || (APIResultStatus = {}));
var FormElementColumn;
(function (FormElementColumn) {
  FormElementColumn["One"] = "form_elements_one_column";
  FormElementColumn["Two"] = "form_elements_two_columns";
  FormElementColumn["Structure"] = "form_structure_elements";
})(FormElementColumn || (FormElementColumn = {}));
var TextFormElement;
(function (TextFormElement) {
  TextFormElement["Text"] = "text_two_columns";
})(TextFormElement || (TextFormElement = {}));
var TwoColumnElement;
(function (TwoColumnElement) {
  TwoColumnElement["TEXT"] = "text_two_columns";
  TwoColumnElement["SELECT"] = "select_form_element";
})(TwoColumnElement || (TwoColumnElement = {}));

var setElementColumn = function setElementColumn(component) {
  var elementLayout = new Map();
  elementLayout.set(FormElementColumn.One, {
    xs: 12,
    lg: 12
  });
  elementLayout.set(FormElementColumn.Two, {
    xs: 12,
    lg: 6
  });
  elementLayout.set(FormElementColumn.Structure, {
    xs: 12,
    lg: 12
  });
  return elementLayout.get(component);
};
var ElementTypeComponent = new Map();
ElementTypeComponent.set('input_text_for_entity', InputText);
ElementTypeComponent.set('input_email_for_entity', InputText);
ElementTypeComponent.set('input_date_for_entity', InputText);
ElementTypeComponent.set('input_text_multiline_for_entity', InputTextMultiline);
ElementTypeComponent.set('input_text_multiline', InputTextMultiline);
ElementTypeComponent.set('dropdown_for_entity', DropwDown);
ElementTypeComponent.set('checkbox_for_entity', Checkbox);
ElementTypeComponent.set('radiobutton_for_entity', Radiobutton);
ElementTypeComponent.set('input_number_for_entity', InputText);
ElementTypeComponent.set('input_hidden_for_entity', InputHidden);
ElementTypeComponent.set('input_hidden_query_for_entity', InputHidden);
var ElementSchema;
(function (ElementSchema) {
  ElementSchema["InputText"] = "input_text_for_entity";
  ElementSchema["InputTextMultiline"] = "input_text_multiline_for_entity";
  ElementSchema["InputEmail"] = "input_email_for_entity";
  ElementSchema["Dropdown"] = "dropdown_for_entity";
  ElementSchema["Checkbox"] = "checkbox_for_entity";
  ElementSchema["InputDate"] = "input_date_for_entity";
  ElementSchema["RadioButton"] = "radiobutton_for_entity";
  ElementSchema["InputNumber"] = "input_number_for_entity";
  ElementSchema["InputHidden"] = "input_hidden_for_entity";
  ElementSchema["InputHiddenWithQuery"] = "input_hidden_query_for_entity";
})(ElementSchema || (ElementSchema = {}));
var inputTypeComponent = function inputTypeComponent(component) {
  var InputText = new Map();
  InputText.set('input_text_for_entity', inputTypes.TEXT);
  InputText.set('input_email_for_entity', inputTypes.EMAIL);
  InputText.set('input_date_for_entity', inputTypes.DATE);
  InputText.set('input_number_for_entity', inputTypes.NUMBER);
  return InputText.get(component);
};
var hasRequiredField = function hasRequiredField(form) {
  return form === null || form === void 0 ? void 0 : form.some(function (formElement) {
    if (formElement.component === FormElementColumn.One) {
      return !!(formElement === null || formElement === void 0 ? void 0 : formElement.required);
    }
    return !!(formElement === null || formElement === void 0 ? void 0 : formElement.required_field1) || !!(formElement === null || formElement === void 0 ? void 0 : formElement.required_field2);
  });
};
var replaceSpaceInName = function replaceSpaceInName(name) {
  return name === null || name === void 0 ? void 0 : name.replace(/[_\s.]+/g, '');
};
var santizeQuery = function santizeQuery(text) {
  if (typeof window !== 'undefined') {
    return DOMPurify.sanitize(text || '');
  }
  return text || '';
};
var getCaseInsensitiveValue = function getCaseInsensitiveValue(obj, fieldName) {
  if (!obj) return undefined;
  var lowerCaseKey = fieldName.toLowerCase();
  var foundKey = Object.keys(obj).find(function (k) {
    return k.toLowerCase() === lowerCaseKey;
  });
  return foundKey ? obj[foundKey] : undefined;
};
var mappedUTMProps = function mappedUTMProps(queryParams) {
  return {
    utm_source: santizeQuery(queryParams === null || queryParams === void 0 ? void 0 : queryParams.utm_source),
    utm_medium: santizeQuery(queryParams === null || queryParams === void 0 ? void 0 : queryParams.utm_medium),
    utm_campaign: santizeQuery(queryParams === null || queryParams === void 0 ? void 0 : queryParams.utm_campaign),
    utm_term: santizeQuery(queryParams === null || queryParams === void 0 ? void 0 : queryParams.utm_term),
    utm_content: santizeQuery(queryParams === null || queryParams === void 0 ? void 0 : queryParams.utm_content)
  };
};
var convertFileSizeToKB = function convertFileSizeToKB(fileSizeInBytes) {
  var fileSizeInKB = fileSizeInBytes / 1024;
  return fileSizeInKB;
};
var isFileTypeAllowed = function isFileTypeAllowed(fileName, allowedExtensions) {
  var _a;
  var fileExtensionMatch = fileName.match(/\.([^.]+)$/);
  var fileExtension = fileExtensionMatch && ((_a = fileExtensionMatch[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase());
  return !!fileExtension && allowedExtensions.includes(fileExtension);
};
var isImage = function isImage(fileType) {
  return fileType.startsWith('image/');
};
var formatThankYouLink = function formatThankYouLink(href) {
  return href.replace(/^[^/]+\/website\//, '');
};
var getMarketingAction = function getMarketingAction(marketing_action) {
  if (marketing_action && marketing_action.length > 0) {
    var action = marketing_action[0];
    return (action === null || action === void 0 ? void 0 : action.local_ma) || (action === null || action === void 0 ? void 0 : action.ma_default) || '';
  }
  return '';
};
var setLocalizedForm = function setLocalizedForm(form, locale) {
  var _a, _b, _c;
  var localeForm = (_a = form === null || form === void 0 ? void 0 : form.translated_form) === null || _a === void 0 ? void 0 : _a.filter(function (form) {
    var _a, _b, _c;
    return ((_a = form.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) || ((_b = form.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = fallbackLang[locale]) === null || _c === void 0 ? void 0 : _c.toLowerCase());
  });
  if (localeForm && localeForm.length > 0 && ((_b = localeForm[0]) === null || _b === void 0 ? void 0 : _b.form)) {
    var mappedLocaleForm = (_c = localeForm[0]) === null || _c === void 0 ? void 0 : _c.form.map(function (item) {
      var _a, _b;
      if (item.component === FormElementColumn.One) {
        var formElement = Array.isArray(item.form_element) && ((_b = (_a = item.form_element[0]) === null || _a === void 0 ? void 0 : _a.form_element) === null || _b === void 0 ? void 0 : _b.content);
        var newElement = Object.assign(Object.assign({}, item), {
          form_element: [formElement]
        });
        return newElement;
      }
      if (item.component === FormElementColumn.Two) {
        var formElements = item.form_elements.map(function (element) {
          var _a;
          if (element.component === TwoColumnElement.SELECT) {
            return (_a = element.form_element) === null || _a === void 0 ? void 0 : _a.content;
          }
          return element;
        });
        var _newElement = Object.assign(Object.assign({}, item), {
          form_element: formElements
        });
        return _newElement;
      }
      return item;
    });
    return Object.assign(Object.assign({}, form), {
      form: mappedLocaleForm
    });
  }
  return form;
};
var getLocale = function getLocale(urlPath, locale) {
  var isEditor = urlPath.includes('/editor/');
  var domainLocale = isEditor ? urlPath.split('/')[2] : locale;
  return domainLocale || '';
};

var MarketingConsentField = function MarketingConsentField(_ref) {
  var marketing_consent = _ref.marketing_consent,
    marketing_consent_localisation = _ref.marketing_consent_localisation,
    register = _ref.register,
    privacyLink = _ref.privacyLink;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useRouter = useRouter(),
    locale = _useRouter.locale;
  var effectiveMarketingConsent = marketing_consent;
  if (marketing_consent_localisation && marketing_consent_localisation.length > 0 && locale) {
    var currentLocaleConsent = marketing_consent_localisation.find(function (loc) {
      return loc.language && loc.language.toLowerCase() === locale && typeof loc.marketing_consent === 'boolean';
    });
    if (currentLocaleConsent && typeof currentLocaleConsent.marketing_consent === 'boolean') {
      effectiveMarketingConsent = currentLocaleConsent.marketing_consent;
    }
  }
  return /*#__PURE__*/React.createElement(Col, {
    className: "".concat(css$j.marketing_consent__wrapper, " ").concat(css$j.form_element__wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css$j.marketing_consent_checkbox__wrapper
  }, effectiveMarketingConsent ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", Object.assign({
    className: css$j.marketing_consent_checkbox,
    type: "checkbox"
  }, register, {
    title: formatMessage({
      id: 'MARKETING_CONSENT_INPUT_TITLE_TEXT'
    })
  })), /*#__PURE__*/React.createElement("p", {
    className: css$j.marketing_consent_text
  }, formatMessage({
    id: 'MARKETING_CONSENT_TEXT'
  })))) : (/*#__PURE__*/React.createElement("div", {
    className: css$j.marketing_consent__wrapper
  }, /*#__PURE__*/React.createElement("p", {
    className: css$j.marketing_consent_text
  }, formatMessage({
    id: 'MARKETING_CONSENT_TEXT'
  })), /*#__PURE__*/React.createElement("p", {
    className: css$j.marketing_consent_text
  }, formatMessage({
    id: 'MARKETING_CONSENT_NO_CHECKBOX_ADDITIONAL_TEXT'
  }))))), /*#__PURE__*/React.createElement("p", {
    className: css$j.marketing_consent_text
  }, formatMessage({
    id: 'MARKETING_CONSENT_MORE_INFO'
  }), privacyLink && (/*#__PURE__*/React.createElement(Link, {
    variant: LinkVariant.Primary,
    target: TargetValues.Blank,
    href: privacyLink,
    title: formatMessage({
      id: 'MARKETING_CONSENT_DATA_LINK'
    })
  }, formatMessage({
    id: 'MARKETING_CONSENT_DATA_LINK'
  })))));
};
var FileUploadField = function FileUploadField(_ref2) {
  var _uid = _ref2._uid,
    labelText = _ref2.labelText,
    required = _ref2.required,
    tooltipText = _ref2.tooltipText,
    allowed_file_types = _ref2.allowed_file_types,
    file_size = _ref2.file_size,
    index = _ref2.index,
    handleFileChange = _ref2.handleFileChange,
    fileData = _ref2.fileData,
    error_message = _ref2.error_message;
  var _a;
  var _useState = useState(),
    selectedFile = _useState[0],
    setSelectedFile = _useState[1];
  var _useState2 = useState(''),
    fileError = _useState2[0],
    setFileError = _useState2[1];
  var _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  var imageSize = [{
    width: 100,
    height: 75
  }];
  var handleFileSelection = function handleFileSelection(event) {
    var _a;
    var uploadedFile = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
    if (!uploadedFile) return;
    if (convertFileSizeToKB(Number(uploadedFile.size)) > Number(file_size || 1024)) {
      return setFileError("".concat(formatMessage({
        id: 'FILE_SIZE_ERROR'
      }), " ").concat(file_size || 1024, " kB"));
    }
    if (allowed_file_types && !isFileTypeAllowed(uploadedFile.name, allowed_file_types)) {
      return setFileError("".concat(formatMessage({
        id: 'ALLOWED_FILES_ERROR'
      }), ": ").concat(allowed_file_types.join(', ')));
    }
    setFileError('');
    setSelectedFile(uploadedFile);
  };
  return /*#__PURE__*/React.createElement(Col, {
    className: "".concat(css$j.form_element__wrapper, " ").concat(css$j.file_upload_text)
  }, /*#__PURE__*/React.createElement("div", {
    className: css$j.file__input__wrapper
  }, /*#__PURE__*/React.createElement(Label, {
    id: _uid,
    labelText: labelText || '',
    required: required,
    toolTip: tooltipText
  }), /*#__PURE__*/React.createElement("input", {
    id: _uid,
    type: "file",
    onChange: function onChange(e) {
      var _a, _b;
      handleFileSelection(e);
      handleFileChange({
        index: index,
        file: (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0],
        label: replaceSpaceInName(labelText) || "file-".concat(index + 1),
        file_size: file_size || '1024'
      });
    },
    title: formatMessage({
      id: 'FILE_UPLOAD_INPUT_TITLE_TEXT'
    })
  })), !!fileError && (/*#__PURE__*/React.createElement(ErrorMessage, {
    id: "file_input",
    errorMessage: fileError || '',
    className: css$j.form__error__message
  })), ((_a = fileData[index]) === null || _a === void 0 ? void 0 : _a.required_error) && (/*#__PURE__*/React.createElement(ErrorMessage, {
    id: "file_input",
    errorMessage: error_message || formatMessage({
      id: 'FILE_REQUIRED_ERROR'
    }),
    className: css$j.form__error__message
  })), !fileError && selectedFile && isImage(selectedFile.type) && (/*#__PURE__*/React.createElement("div", {
    className: css$j.form__selected__image
  }, /*#__PURE__*/React.createElement(Image, {
    src: URL.createObjectURL(selectedFile),
    imageSizes: imageSize,
    alt: "selected image"
  }))));
};

var RenderFormElement = function RenderFormElement(_ref) {
  var formField = _ref.formField,
    errorData = _ref.errorData,
    register = _ref.register,
    queryParams = _ref.queryParams,
    setValue = _ref.setValue,
    locale = _ref.locale;
  var component = formField.component,
    rest = __rest(formField, ["component"]);
  if (component === FormElementColumn.Structure) {
    return /*#__PURE__*/React.createElement(FormStructureElement, {
      headline: rest === null || rest === void 0 ? void 0 : rest.headline,
      text: rest === null || rest === void 0 ? void 0 : rest.text,
      line: rest === null || rest === void 0 ? void 0 : rest.line,
      translation: rest === null || rest === void 0 ? void 0 : rest.translation
    });
  }
  return /*#__PURE__*/React.createElement(FormElementComponent, {
    formElement: formField,
    register: register,
    errors: errorData,
    queryParams: queryParams,
    setValue: setValue,
    locale: locale
  });
};
var FormStructureElement = function FormStructureElement(_ref2) {
  var headline = _ref2.headline,
    line = _ref2.line,
    text = _ref2.text,
    translation = _ref2.translation;
  var _a;
  var router = useRouter();
  var locale = getLocale(router.asPath, router.locale);
  var translationData = translation === null || translation === void 0 ? void 0 : translation.find(function (item) {
    var _a, _b, _c;
    return ((_a = item.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) || ((_b = item.language) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === ((_c = fallbackLang[locale !== null && locale !== void 0 ? locale : '']) === null || _c === void 0 ? void 0 : _c.toLowerCase());
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H2,
    className: css$j.form_structure_headline
  }, (translationData === null || translationData === void 0 ? void 0 : translationData.headline) || headline), (hasTextContent(translationData === null || translationData === void 0 ? void 0 : translationData.text) || hasTextContent(text)) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(((_a = translationData === null || translationData === void 0 ? void 0 : translationData.text) === null || _a === void 0 ? void 0 : _a.content) || (text === null || text === void 0 ? void 0 : text.content))
  })), ((translationData === null || translationData === void 0 ? void 0 : translationData.line) || line) && (/*#__PURE__*/React.createElement(Separator, {
    className: css$j.form_structure_line
  })));
};
var FormElementComponent = function FormElementComponent(_ref3) {
  var register = _ref3.register,
    formElement = _ref3.formElement,
    errors = _ref3.errors,
    queryParams = _ref3.queryParams,
    setValue = _ref3.setValue,
    locale = _ref3.locale;
  var _a;
  useEffect(function () {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    Array.isArray(formElement === null || formElement === void 0 ? void 0 : formElement.form_element) && ((_a = formElement === null || formElement === void 0 ? void 0 : formElement.form_element) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
      var fieldName = (item === null || item === void 0 ? void 0 : item.field_name) || '';
      var queryValue = getCaseInsensitiveValue(queryParams, replaceSpaceInName(fieldName));
      if (queryValue) {
        setValue(replaceSpaceInName(fieldName), santizeQuery(queryValue));
      }
    }));
  }, [queryParams]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(formElement.component === FormElementColumn.Two ? css$j.form_two_column : '')
  }, Array.isArray(formElement === null || formElement === void 0 ? void 0 : formElement.form_element) && ((_a = formElement === null || formElement === void 0 ? void 0 : formElement.form_element) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
    var _a, _b, _c, _d, _e, _f;
    if ((item === null || item === void 0 ? void 0 : item.component) === TextFormElement.Text) {
      return /*#__PURE__*/React.createElement(TextFormElementComponent, {
        key: item._uid,
        formElement: item
      });
    }
    if (((_a = item === null || item === void 0 ? void 0 : item.element_type[0]) === null || _a === void 0 ? void 0 : _a.component) === ElementSchema.InputHiddenWithQuery) {
      return /*#__PURE__*/React.createElement(InputQueryComponent, {
        key: "".concat(item._uid, "-").concat(index),
        item: item,
        queryParams: queryParams,
        setValue: setValue,
        register: register
      });
    }
    return item && /*#__PURE__*/createElement$1(ElementTypeComponent.get((_b = item === null || item === void 0 ? void 0 : item.element_type[0]) === null || _b === void 0 ? void 0 : _b.component), Object.assign(Object.assign({
      key: "".concat(item._uid, "-").concat(index),
      type: inputTypeComponent((_c = item === null || item === void 0 ? void 0 : item.element_type[0]) === null || _c === void 0 ? void 0 : _c.component),
      name: replaceSpaceInName(item === null || item === void 0 ? void 0 : item.field_name) || replaceSpaceInName(item === null || item === void 0 ? void 0 : item.name),
      required: item === null || item === void 0 ? void 0 : item.required,
      language: locale,
      hasError: !!((_d = errors[replaceSpaceInName(item === null || item === void 0 ? void 0 : item.field_name)]) === null || _d === void 0 ? void 0 : _d.message)
    }, item === null || item === void 0 ? void 0 : item.element_type[0]), {
      error_message: (_e = errors["".concat(replaceSpaceInName(item.field_name))]) === null || _e === void 0 ? void 0 : _e.message,
      register: ((_f = item === null || item === void 0 ? void 0 : item.element_type[0]) === null || _f === void 0 ? void 0 : _f.component) === 'checkbox_for_entity' ? register : register("".concat(replaceSpaceInName((item === null || item === void 0 ? void 0 : item.field_name) || (item === null || item === void 0 ? void 0 : item.name))))
    }));
  })));
};
var InputQueryComponent = function InputQueryComponent(_ref4) {
  var item = _ref4.item,
    _ref4$queryParams = _ref4.queryParams,
    queryParams = _ref4$queryParams === void 0 ? {} : _ref4$queryParams,
    setValue = _ref4.setValue,
    register = _ref4.register;
  var _a, _b;
  var cmsQueryName = ((_a = item.element_type[0]) === null || _a === void 0 ? void 0 : _a.name_of_param) || '';
  var queryValue = queryParams[cmsQueryName] || '';
  useEffect(function () {
    setValue(replaceSpaceInName((item === null || item === void 0 ? void 0 : item.field_name) || item.name), santizeQuery(queryValue));
  }, [item === null || item === void 0 ? void 0 : item.field_name, item.name, queryValue, setValue]);
  return /*#__PURE__*/React.createElement(InputHidden, {
    value: santizeQuery(queryValue),
    description: (_b = item.element_type[0]) === null || _b === void 0 ? void 0 : _b.description,
    register: register(replaceSpaceInName((item === null || item === void 0 ? void 0 : item.field_name) || item.name))
  });
};
var FormContactPerson = function FormContactPerson(_ref5) {
  var contactPerson = _ref5.contactPerson;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var contactPersonData = contactPerson && ((_a = contactPerson[0]) === null || _a === void 0 ? void 0 : _a.content);
  var imageSize = [{
    width: 150,
    height: 150
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, contactPerson && (/*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: css$j.contact__person__wrapper
  }, ((_c = (_b = contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.image[0]) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.item) && (/*#__PURE__*/React.createElement("div", {
    className: css$j.contact__image__wrapper
  }, /*#__PURE__*/React.createElement(Image, {
    src: ((_f = (_e = (_d = contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.image[0]) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.focal_embed_link) || ((_j = (_h = (_g = contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.image[0]) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.embed_link),
    imageSizes: imageSize,
    alt: (_k = contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.image[0]) === null || _k === void 0 ? void 0 : _k.alt_text
  }))), /*#__PURE__*/React.createElement("div", {
    className: css$j.contact__detail__wrapper
  }, /*#__PURE__*/React.createElement("strong", {
    className: css$j.contact__person__name
  }, (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.component) === 'contact_company' ? contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.company : "".concat(contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.first_name, " ").concat(contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.last_name)), ((contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.phone) || (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.mobile)) && (/*#__PURE__*/React.createElement(Link, {
    href: (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.phone) || (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.mobile),
    external: true,
    target: TargetValues.Blank,
    title: (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.phone) || (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.mobile),
    variant: LinkVariant.Primary,
    className: css$j.text__anchor,
    contact_type: contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.contact_type,
    showExternalIcon: false
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PhoneIcon, {
    className: css$j.phone__icon
  }), (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.phone) || (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.mobile)))), (contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.job_title) && (/*#__PURE__*/React.createElement("span", {
    className: css$j.text__anchor
  }, contactPersonData === null || contactPersonData === void 0 ? void 0 : contactPersonData.job_title)))))))));
};
var TextFormElementComponent = function TextFormElementComponent(_ref6) {
  var formElement = _ref6.formElement,
    key = _ref6.key;
  var _a, _b, _c;
  var router = useRouter();
  var locale = getLocale(router.asPath, router.locale);
  var translationData = (_a = formElement === null || formElement === void 0 ? void 0 : formElement.translation) === null || _a === void 0 ? void 0 : _a.find(function (data) {
    var _a;
    return ((_a = data === null || data === void 0 ? void 0 : data.language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === locale.toLowerCase();
  });
  return /*#__PURE__*/React.createElement("div", {
    key: key
  }, (hasTextContent(translationData === null || translationData === void 0 ? void 0 : translationData.text) || hasTextContent(formElement === null || formElement === void 0 ? void 0 : formElement.text)) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(((_b = translationData === null || translationData === void 0 ? void 0 : translationData.text) === null || _b === void 0 ? void 0 : _b.content) || ((_c = formElement.text) === null || _c === void 0 ? void 0 : _c.content) || [])
  })));
};

var formSchemaMapper = function formSchemaMapper(form, formatMessage) {
  var schema = form === null || form === void 0 ? void 0 : form.map(function (element) {
    var _a;
    if ((element === null || element === void 0 ? void 0 : element.component) === FormElementColumn.One) {
      return (_a = element === null || element === void 0 ? void 0 : element.form_element) === null || _a === void 0 ? void 0 : _a.map(function (item) {
        item && (item.required = element === null || element === void 0 ? void 0 : element.required);
        return _defineProperty({}, "".concat(replaceSpaceInName((item === null || item === void 0 ? void 0 : item.field_name) || (item === null || item === void 0 ? void 0 : item.name))), elementSchemaMapper(item, formatMessage));
      });
    } else if (element.component === FormElementColumn.Two) {
      return element.form_element.map(function (item, index) {
        if ((item === null || item === void 0 ? void 0 : item.component) === TextFormElement.Text) return null;
        item && (item.required = index === 0 ? element.required_field1 : element.required_field2);
        return _defineProperty({}, "".concat(replaceSpaceInName((item === null || item === void 0 ? void 0 : item.field_name) || (item === null || item === void 0 ? void 0 : item.name))), elementSchemaMapper(item, formatMessage));
      });
    }
  }).flat().reduce(function (accumulatedSchema, currentSchema) {
    return Object.assign(Object.assign({}, accumulatedSchema), currentSchema);
  }, {});
  return schema;
};
var elementSchemaMapper = function elementSchemaMapper(element, formatMessage) {
  var _a;
  var props = {
    required: element === null || element === void 0 ? void 0 : element.required,
    element_type: element === null || element === void 0 ? void 0 : element.element_type[0],
    formatMessage: formatMessage
  };
  var schemaTypes = new Map();
  schemaTypes.set(ElementSchema.InputText, inputTextSchema(props));
  schemaTypes.set(ElementSchema.InputTextMultiline, inputTextSchema(props));
  schemaTypes.set(ElementSchema.InputEmail, inputEmailSchema(props));
  schemaTypes.set(ElementSchema.Dropdown, dropdownSchema(props));
  schemaTypes.set(ElementSchema.Checkbox, checkBoxSchema());
  schemaTypes.set(ElementSchema.InputDate, inputTextSchema(props));
  schemaTypes.set(ElementSchema.RadioButton, dropdownSchema(props));
  schemaTypes.set(ElementSchema.InputNumber, inputTextSchema(props));
  schemaTypes.set(ElementSchema.InputHidden, hiddenSchema());
  schemaTypes.set(ElementSchema.InputHiddenWithQuery, hiddenSchema());
  var elementComponent = (_a = element === null || element === void 0 ? void 0 : element.element_type[0]) === null || _a === void 0 ? void 0 : _a.component;
  return schemaTypes.get(elementComponent);
};
var inputTextSchema = function inputTextSchema(_ref3) {
  var required = _ref3.required,
    element_type = _ref3.element_type,
    formatMessage = _ref3.formatMessage;
  var _ref4 = element_type || {},
    error_message = _ref4.error_message,
    max_length = _ref4.max_length,
    label = _ref4.label;
  var defaultErrorMessage = "".concat(label, " must be at most ").concat(max_length, " characters");
  var schema = create$6().max(Number(max_length), error_message || defaultErrorMessage);
  if (max_length) {
    return required ? schema.required("".concat(label, " ").concat(formatMessage({
      id: 'REQUIRED_FIELDS_ERROR_MESSAGE'
    }))) : schema;
  }
  return required ? create$6().required("".concat(label, " ").concat(formatMessage({
    id: 'REQUIRED_FIELDS_ERROR_MESSAGE'
  }))) : create$6();
};
var inputEmailSchema = function inputEmailSchema(_ref5) {
  var required = _ref5.required,
    element_type = _ref5.element_type,
    formatMessage = _ref5.formatMessage;
  var _ref6 = element_type || {},
    label = _ref6.label,
    error_message = _ref6.error_message;
  var errorMessage = error_message || "".concat(label, " ").concat(formatMessage({
    id: 'VALID_EMAIL_ERROR_MESSAGE'
  }));
  return required ? create$6().email(errorMessage).required("".concat(label, " ").concat(formatMessage({
    id: 'REQUIRED_FIELDS_ERROR_MESSAGE'
  }))) : create$6().email(errorMessage);
};
var dropdownSchema = function dropdownSchema(_ref7) {
  var required = _ref7.required,
    element_type = _ref7.element_type,
    formatMessage = _ref7.formatMessage;
  var _ref8 = element_type || {},
    label = _ref8.label,
    options = _ref8.options;
  var validOptions = (options === null || options === void 0 ? void 0 : options.map(function (option) {
    return option === null || option === void 0 ? void 0 : option.value;
  })) || [];
  return required ? create$8().required("".concat(label, " ").concat(formatMessage({
    id: 'REQUIRED_FIELDS_ERROR_MESSAGE'
  }))).oneOf(validOptions) : create$8();
};
var checkBoxSchema = function checkBoxSchema() {
  return create$8().nullable();
};
var hiddenSchema = function hiddenSchema() {
  return create$8().required().nullable();
};

var FormSelection = function FormSelection(_ref) {
  var marketing_action_value = _ref.marketing_action_value,
    form = _ref.form,
    submitHandler = _ref.submitHandler,
    thank_you_page = _ref.thank_you_page,
    marketing_action = _ref.marketing_action,
    showInFormPage = _ref.showInFormPage,
    text = _ref.text,
    privacyLink = _ref.privacyLink,
    component = _ref.component,
    contactPerson = _ref.contactPerson;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var router = useRouter();
  var isEditor = router.asPath.includes('/editor/');
  var locale = isEditor ? router.asPath.split('/')[2] : router.locale;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var localeFormData = setLocalizedForm(form, locale || 'en-de');
  var showRequiredNote = hasRequiredField(localeFormData === null || localeFormData === void 0 ? void 0 : localeFormData.form);
  var formSchema = formSchemaMapper(localeFormData === null || localeFormData === void 0 ? void 0 : localeFormData.form, formatMessage);
  var _useState = useState(''),
    globalError = _useState[0],
    setGlobalError = _useState[1];
  var _useState2 = useState(false),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState([]),
    uuidContact = _useState3[0],
    setUuidContact = _useState3[1];
  var _useState4 = useState(((_a = localeFormData.files) === null || _a === void 0 ? void 0 : _a.map(function (fileItem, index) {
      return {
        file: null,
        required_error: false,
        file_size: fileItem.file_size,
        label: fileItem.label || "file-".concat(index + 1)
      };
    })) || []),
    fileData = _useState4[0],
    setFileData = _useState4[1];
  var queryParams = router.query;
  var utmProps = mappedUTMProps(router.query);
  var _useForm = useForm({
      resolver: o(create$3(formSchema)),
      mode: 'onChange'
    }),
    handleSubmit = _useForm.handleSubmit,
    register = _useForm.register,
    reset = _useForm.reset,
    setValue = _useForm.setValue,
    _useForm$formState = _useForm.formState,
    errors = _useForm$formState.errors,
    isValid = _useForm$formState.isValid,
    isDirty = _useForm$formState.isDirty;
  var currentLocale = (locale === null || locale === void 0 ? void 0 : locale.split('-')) || "".concat(router.defaultLocale);
  var localeFromQueryParam = (_b = router.query) === null || _b === void 0 ? void 0 : _b.locale;
  var actualContactPerson = localeFromQueryParam ? "".concat((_e = (_d = (_c = uuidContact[0]) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.first_name) !== null && _e !== void 0 ? _e : '', " ").concat((_h = (_g = (_f = uuidContact[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.last_name) !== null && _h !== void 0 ? _h : '') : contactPerson;
  var thankYouPageURL = thank_you_page && thank_you_page.linktype === 'url' ? thank_you_page === null || thank_you_page === void 0 ? void 0 : thank_you_page.cached_url : "/".concat(formatThankYouLink((thank_you_page === null || thank_you_page === void 0 ? void 0 : thank_you_page.cached_url) || ''));
  var handleFileChange = function handleFileChange(_ref2) {
    var index = _ref2.index,
      file = _ref2.file,
      label = _ref2.label,
      file_size = _ref2.file_size;
    var fileInputs = _toConsumableArray(fileData);
    fileInputs[index] = {
      file: file,
      required_error: false,
      label: label,
      file_size: file_size
    };
    setFileData(fileInputs);
  };
  var contactPersonUid = ((_j = router.query) === null || _j === void 0 ? void 0 : _j.contact) && ((_k = router.query) === null || _k === void 0 ? void 0 : _k.contact);
  var contactPersonMarketingAction = contactPersonUid && (uuidContact === null || uuidContact === void 0 ? void 0 : uuidContact.length) > 0 && ((_m = (_l = uuidContact[0]) === null || _l === void 0 ? void 0 : _l.content) === null || _m === void 0 ? void 0 : _m.marketing_action);
  var marketingAction = marketing_action_value || contactPersonMarketingAction || getMarketingAction(marketing_action);
  var _useHoneypotValidatio = useHoneypotValidation({
      marketingAction: marketingAction,
      submitHandler: submitHandler,
      locale: currentLocale,
      utmProps: utmProps,
      contactPerson: actualContactPerson
    }),
    honeypotProps = _useHoneypotValidatio.honeypotProps,
    validateHoneypot = _useHoneypotValidatio.validateHoneypot,
    isInitializing = _useHoneypotValidatio.isInitializing;
  // TODO: refactor when NEXT_PUBLIC_MIDDLEWARE_URL is fixed on live environment
  var baseUrl = 'https://storyblok-cms-middleware.orange.igus.net';
  var env = process.env.NEXT_PUBLIC_WEB_HOSTNAME;
  if (env && env !== 'www') {
    baseUrl = process.env.NEXT_PUBLIC_MIDDLEWARE_URL;
  }
  var onSubmit = function onSubmit(formData) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _a, isSpam, requiredError, newFileInputs, fetchPromises, uploadedFiles, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return validateHoneypot(formData);
          case 3:
            isSpam = _context2.sent;
            if (!isSpam) {
              _context2.next = 7;
              break;
            }
            setLoading(false);
            return _context2.abrupt("return");
          case 7:
            if (!(localeFormData.files && localeFormData.file_upload)) {
              _context2.next = 12;
              break;
            }
            requiredError = false;
            newFileInputs = fileData === null || fileData === void 0 ? void 0 : fileData.map(function (input, index) {
              var _a;
              if ((localeFormData === null || localeFormData === void 0 ? void 0 : localeFormData.files) && ((_a = localeFormData === null || localeFormData === void 0 ? void 0 : localeFormData.files[index]) === null || _a === void 0 ? void 0 : _a.required_field) && !input.file) {
                requiredError = true;
                return Object.assign(Object.assign({}, input), {
                  required_error: true
                });
              }
              return input;
            });
            if (!requiredError) {
              _context2.next = 12;
              break;
            }
            return _context2.abrupt("return", setFileData(newFileInputs));
          case 12:
            setLoading(true);
            fetchPromises = fileData === null || fileData === void 0 ? void 0 : fileData.map(function (fileItem) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var fileFormData, res, _fileData;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!fileItem.file) {
                        _context.next = 11;
                        break;
                      }
                      fileFormData = new FormData();
                      fileFormData.append(fileItem.label, fileItem.file);
                      fileFormData.append('file_size', fileItem.file_size || '1024');
                      _context.next = 6;
                      return fetch("/api/cms/file-upload?key=".concat(fileItem.label), {
                        method: 'POST',
                        body: fileFormData
                      });
                    case 6:
                      res = _context.sent;
                      _context.next = 9;
                      return res.json();
                    case 9:
                      _fileData = _context.sent;
                      return _context.abrupt("return", {
                        label: fileItem.label,
                        fileUrl: _fileData.fileUrl
                      });
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
            });
            _context2.next = 16;
            return Promise.all(fetchPromises);
          case 16:
            uploadedFiles = _context2.sent;
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            localeFormData.file_upload && uploadedFiles.forEach(function (item) {
              return item && (formData[item === null || item === void 0 ? void 0 : item.label] = item === null || item === void 0 ? void 0 : item.fileUrl);
            });
            formData.utmProps = utmProps;
            _context2.next = 21;
            return submitHandler(Object.assign(Object.assign({}, formData), {
              locale: "".concat(currentLocale[0], "_").concat((_a = currentLocale[1]) === null || _a === void 0 ? void 0 : _a.toUpperCase()),
              source: marketingAction
            }), actualContactPerson);
          case 21:
            response = _context2.sent;
            setLoading(false);
            if ((response === null || response === void 0 ? void 0 : response.status) === APIResultStatus.success) {
              setGlobalError('');
              reset();
              router.push(thankYouPageURL);
            } else {
              console.error(response);
              setGlobalError(formatMessage({
                id: response.message
              }));
            }
            _context2.next = 30;
            break;
          case 26:
            _context2.prev = 26;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);
            setGlobalError(formatMessage({
              id: 'CANNOT_SUBMIT_FORM'
            }));
          case 30:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 26]]);
    }));
  };
  var fetchContactByUuid = function fetchContactByUuid() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var urlPath, contact, _urlPath, _contact;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(contactPersonUid && component !== 'form_landingpage')) {
              _context3.next = 8;
              break;
            }
            urlPath = "".concat(baseUrl, "/contact/uuid/").concat(locale === null || locale === void 0 ? void 0 : locale.toLowerCase(), "?uuid=").concat(contactPersonUid);
            _context3.next = 4;
            return fetchUtil(urlPath);
          case 4:
            contact = _context3.sent;
            setUuidContact(contact);
            _context3.next = 14;
            break;
          case 8:
            if (!(localeFromQueryParam && contactPersonUid)) {
              _context3.next = 14;
              break;
            }
            _urlPath = "".concat(baseUrl, "/contact/uuid/").concat(localeFromQueryParam, "?uuid=").concat(contactPersonUid);
            _context3.next = 12;
            return fetchUtil(_urlPath);
          case 12:
            _contact = _context3.sent;
            setUuidContact(_contact);
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  useEffect(function () {
    fetchContactByUuid();
  }, [contactPersonUid]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (localeFormData === null || localeFormData === void 0 ? void 0 : localeFormData.contact_person) && showInFormPage && (uuidContact === null || uuidContact === void 0 ? void 0 : uuidContact.length) > 0 && (/*#__PURE__*/React.createElement(FormContactPerson, {
    contactPerson: uuidContact
  })), /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: true
  }, (loading || isInitializing) && /*#__PURE__*/React.createElement(Loader, {
    hasParent: true
  }), honeypotProps && !isInitializing ? (/*#__PURE__*/React.createElement(HoneypotProvider, Object.assign({}, honeypotProps), /*#__PURE__*/React.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(HoneypotField, null), globalError && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(conditionalClassname(!!globalError, "".concat(css$j.form_global_errormessage)))
  }, globalError)))), /*#__PURE__*/React.createElement(Row, {
    className: "".concat(css$j.form__wrapper, " ").concat(conditionalClassname(!!showInFormPage, "".concat(css$j.form__alignment)))
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Col, {
    className: css$j.form__text__wrapper
  }, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  }))), /*#__PURE__*/React.createElement(Col, null, (_o = localeFormData.form) === null || _o === void 0 ? void 0 : _o.map(function (form_data) {
    return /*#__PURE__*/React.createElement("div", {
      key: form_data._uid,
      className: css$j.form_element__wrapper
    }, /*#__PURE__*/React.createElement(RenderFormElement, {
      formField: form_data,
      errorData: errors,
      register: register,
      queryParams: queryParams,
      setValue: setValue,
      locale: locale
    }));
  })), localeFormData.file_upload && localeFormData.files && localeFormData.files.map(function (fileItem, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileUploadField, {
      key: fileItem._uid,
      _uid: fileItem._uid,
      labelText: fileItem === null || fileItem === void 0 ? void 0 : fileItem.label,
      tooltipText: fileItem === null || fileItem === void 0 ? void 0 : fileItem.tooltip,
      allowed_file_types: fileItem === null || fileItem === void 0 ? void 0 : fileItem.allowed_file_types,
      file_size: fileItem === null || fileItem === void 0 ? void 0 : fileItem.file_size,
      required: fileItem.required_field,
      index: index,
      handleFileChange: handleFileChange,
      fileData: fileData,
      error_message: fileItem.error_message
    }));
  }), showRequiredNote && (/*#__PURE__*/React.createElement(Col, {
    className: css$j.form_element__wrapper
  }, /*#__PURE__*/React.createElement("p", {
    className: css$j.required_fields_note
  }, formatMessage({
    id: 'REQUIRED_FIELDS_NOTE'
  })))), /*#__PURE__*/React.createElement(MarketingConsentField, {
    register: register('markerting_consent'),
    marketing_consent: localeFormData.marketing_consent,
    marketing_consent_localisation: localeFormData.marketing_consent_localisation || [],
    privacyLink: privacyLink
  }), /*#__PURE__*/React.createElement(Col, {
    className: "".concat(css$j.submit_button__wrapper, " ").concat(css$j.form_element__wrapper)
  }, /*#__PURE__*/React.createElement("button", {
    disabled: showRequiredNote && !isDirty || !isValid,
    className: css$j.form_submit_button,
    type: "submit"
  }, formatMessage({
    id: 'FORM_SUBMIT_TEXT'
  }))))))) : (/*#__PURE__*/React.createElement(React.Fragment, null))));
};

var css$d = {"nav_bar__wrapper":"NavigationBar-module_nav_bar__wrapper__UWWR2","country_switcher__mobile_wrapper":"NavigationBar-module_country_switcher__mobile_wrapper__UnnTB","country_switcher_button":"NavigationBar-module_country_switcher_button__0EMxS","country_switcher_mobile__display":"NavigationBar-module_country_switcher_mobile__display__Zrof7","nav_bar__wrapper_open":"NavigationBar-module_nav_bar__wrapper_open__hCMyN","contactPerson__menu":"NavigationBar-module_contactPerson__menu__nnYf6","nav_group__wrapper":"NavigationBar-module_nav_group__wrapper__yZJl5","nav__item_logo":"NavigationBar-module_nav__item_logo__EoA8W","mobile__navheader":"NavigationBar-module_mobile__navheader__jf1Ly","header__wrapper":"NavigationBar-module_header__wrapper__igViu","header_logo__wrapper":"NavigationBar-module_header_logo__wrapper__y3VJm","nav__backdrop":"NavigationBar-module_nav__backdrop__bWl77","nav__backdrop_open":"NavigationBar-module_nav__backdrop_open__AI0b1","nav_bar__wrapper_v2":"NavigationBar-module_nav_bar__wrapper_v2__zmKci","nav_bar_content__wrapper":"NavigationBar-module_nav_bar_content__wrapper__wtUMT","nav_version2":"NavigationBar-module_nav_version2__aJWrC"};

var NavigationContext = /*#__PURE__*/createContext(undefined);
var useNavigation = function useNavigation() {
  var context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};
var NavigationProvider = function NavigationProvider(_ref) {
  var children = _ref.children,
    _ref$initialOpen = _ref.initialOpen,
    initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen;
  var _useState = useState(initialOpen),
    isNavigationOpen = _useState[0],
    setNavigationOpen = _useState[1];
  var _useState2 = useState(false),
    isContactPersonOpen = _useState2[0],
    setIsContactPersonOpen = _useState2[1];
  var _useState3 = useState([]),
    navigationData = _useState3[0],
    setNavigationData = _useState3[1];
  var toggleNavigation = useCallback(function () {
    setNavigationOpen(function (prevState) {
      return !prevState;
    });
  }, [navigationData]);
  var closeNav = useCallback(function () {
    setNavigationOpen(false);
  }, [navigationData]);
  var backDrop = useRef(null);
  var contextValue = useMemo(function () {
    return {
      isNavigationOpen: isNavigationOpen,
      toggleNavigation: toggleNavigation,
      setNavigationData: setNavigationData,
      closeNav: closeNav,
      backDrop: backDrop,
      isContactPersonOpen: isContactPersonOpen,
      setIsContactPersonOpen: setIsContactPersonOpen
    };
  }, [isNavigationOpen, toggleNavigation, closeNav, backDrop, isContactPersonOpen]);
  useEffect(function () {
    function handleClickOutsideNavigation(event) {
      if (backDrop.current && backDrop.current.contains(event.target)) {
        setNavigationOpen(false);
      }
    }
    function handleEscapeKey(event) {
      if (event.key === 'Escape') {
        setNavigationOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutsideNavigation);
    document.addEventListener('keydown', handleEscapeKey);
    return function () {
      document.removeEventListener('mousedown', handleClickOutsideNavigation);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [backDrop]);
  useEffect(function () {
    if (isNavigationOpen) {
      document.body.classList.add('nav-open');
    }
    return function () {
      document.body.classList.remove('nav-open');
    };
  }, [isNavigationOpen]);
  return /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: contextValue
  }, children, /*#__PURE__*/React.createElement("div", {
    ref: backDrop,
    className: chainConditionalClassnames(css$d.nav__backdrop, conditionalClassname(isNavigationOpen, css$d.nav__backdrop_open))
  }));
};

var css$c = {"burger__icon":"BurgerButton-module_burger__icon__D44HD","burger__icon_open":"BurgerButton-module_burger__icon_open__Hu-Yo","burger__icon_close":"BurgerButton-module_burger__icon_close__u716g"};

var BurgerButton = function BurgerButton() {
  var _useNavigation = useNavigation(),
    isNavigationOpen = _useNavigation.isNavigationOpen,
    toggleNavigation = _useNavigation.toggleNavigation;
  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(event) {
      event.preventDefault();
      toggleNavigation();
    },
    className: css$c.burger__icon,
    "aria-label": 'Mobile Navigation'
  }, /*#__PURE__*/React.createElement("span", {
    className: isNavigationOpen ? css$c.burger__icon_close : css$c.burger__icon_open
  }));
};

var css$b = {"header__main__wrapper":"HeaderBar-module_header__main__wrapper__DuuJn","header__main__wrapper_v2":"HeaderBar-module_header__main__wrapper_v2__lmyQj","header__transition":"HeaderBar-module_header__transition__641ef","header__wrapper":"HeaderBar-module_header__wrapper__tWjJ-","header_logo__wrapper":"HeaderBar-module_header_logo__wrapper__MPj9F","motion_platics_logo__wrapper":"HeaderBar-module_motion_platics_logo__wrapper__mW71B","header__input__wrapper":"HeaderBar-module_header__input__wrapper__wM7zs","header__input__transition":"HeaderBar-module_header__input__transition__mUY9B","header__icons__wrapper":"HeaderBar-module_header__icons__wrapper__hIT2U","header__link":"HeaderBar-module_header__link__qUnRX","header__link__text":"HeaderBar-module_header__link__text__b0zeg","header__cart":"HeaderBar-module_header__cart__VjoAl","header__search__icon":"HeaderBar-module_header__search__icon__NFZ24","header-bar-wrapper-v2":"HeaderBar-module_header-bar-wrapper-v2__nISU5","country_switcher_button":"HeaderBar-module_country_switcher_button__6G-7B"};

var LogoStructuredData = function LogoStructuredData() {
  var router = routerExports.useRouter();
  var domains = igusDomains;
  var url = domains.find(function (domain) {
    return domain.defaultLocale === (router === null || router === void 0 ? void 0 : router.locale);
  });
  var ishome = isHomepage(router === null || router === void 0 ? void 0 : router.asPath);
  var organizationName = 'igus';
  return /*#__PURE__*/React.createElement(React.Fragment, null, ishome ? (/*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: "".concat(organizationName),
        url: "https://".concat(url === null || url === void 0 ? void 0 : url.domain),
        logo: 'https://igus.widen.net/content/u0xxfvj54l/webp/'
      })
    }
  })) : (/*#__PURE__*/React.createElement(React.Fragment, null)));
};

var HeaderBar = function HeaderBar(_ref) {
  var searchBarPlaceholder = _ref.searchBarPlaceholder,
    shoppingCartName = _ref.shoppingCartName,
    _ref$shoppingCartValu = _ref.shoppingCartValue,
    shoppingCartValue = _ref$shoppingCartValu === void 0 ? 0 : _ref$shoppingCartValu,
    _ref$preview = _ref.preview,
    preview = _ref$preview === void 0 ? false : _ref$preview,
    country = _ref.country,
    with_country_switch = _ref.with_country_switch,
    openCountrySwitchModal = _ref.openCountrySwitchModal,
    _ref$myIgusDomain = _ref.myIgusDomain,
    myIgusDomain = _ref$myIgusDomain === void 0 ? '/myigus/default.aspx?page=login' : _ref$myIgusDomain,
    router = _ref.router,
    profileText = _ref.profileText,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? ComponentVersion.v1 : _ref$version;
  var _useState = useState(false),
    showSearch = _useState[0],
    setShowSearch = _useState[1];
  var countryCode = (country === null || country === void 0 ? void 0 : country.split('-')[1]) || 'de-de';
  var language = (country === null || country === void 0 ? void 0 : country.split('-')[0]) || '';
  var toggleCountrySwitch = function toggleCountrySwitch() {
    openCountrySwitchModal(function (prevState) {
      return !prevState;
    });
  };
  var isIgusEU = isIgusEuDomain(country || '');
  var countrySwitchHeader = igusEuDomainHeader(country || '', countryCode, language);
  return /*#__PURE__*/React.createElement(Container, {
    className: "header-bar-wrapper ".concat(css$b['header-bar-wrapper-v2']),
    version: version
  }, /*#__PURE__*/React.createElement(LogoStructuredData, null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: chainConditionalClassnames(css$b.header__main__wrapper, conditionalClassname(showSearch, css$b.header__transition), conditionalClassname(isPreferredVersion(ComponentVersion.v2, version), css$b.header__main__wrapper_v2))
  }, /*#__PURE__*/React.createElement("nav", {
    className: css$b.header__wrapper
  }, /*#__PURE__*/React.createElement(BurgerButton, null), /*#__PURE__*/React.createElement(Link, {
    variant: LinkVariant.Secondary,
    target: TargetValues.Top,
    title: "Home",
    href: "/",
    external: false,
    className: css$b.header_logo__wrapper,
    isNav: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IgusLogo, null), /*#__PURE__*/React.createElement(MotionPlasticsLogo, {
    className: css$b.motion_platics_logo__wrapper
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$b.header__input__wrapper, " ").concat(conditionalClassname(showSearch, "".concat(css$b.header__input__transition)))
  }, /*#__PURE__*/React.createElement(SearchBar, {
    className: css$b.main,
    placeholder: searchBarPlaceholder,
    preview: preview,
    router: router,
    locale: country
  })), /*#__PURE__*/React.createElement("div", {
    className: css$b.header__icons__wrapper
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Search",
    className: css$b.header__search__icon,
    onClick: function onClick() {
      return setShowSearch(function (prev) {
        return !prev;
      });
    }
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), /*#__PURE__*/React.createElement(Link, {
    showExternalIcon: false,
    icon: false,
    title: "myigus",
    target: TargetValues.Self,
    href: myIgusDomain,
    variant: LinkVariant.Secondary,
    external: true,
    isNav: true
  }, /*#__PURE__*/React.createElement("span", {
    className: css$b.header__link
  }, /*#__PURE__*/React.createElement(PersonIcon, null), /*#__PURE__*/React.createElement("span", {
    className: css$b.header__link__text
  }, profileText))), /*#__PURE__*/React.createElement(Link, {
    showExternalIcon: false,
    icon: false,
    title: "Shoping Cart",
    target: TargetValues.Self,
    href: "/cart",
    variant: LinkVariant.Secondary,
    external: true,
    isNav: true
  }, /*#__PURE__*/React.createElement("span", {
    className: css$b.header__link
  }, /*#__PURE__*/React.createElement(CartIcon, null), /*#__PURE__*/React.createElement("span", {
    className: css$b.header__link__text
  }, shoppingCartName), /*#__PURE__*/React.createElement("span", {
    className: css$b.header__cart,
    translate: "no"
  }, "(".concat(shoppingCartValue, ")"))))), with_country_switch && (/*#__PURE__*/React.createElement("button", {
    className: css$b.country_switcher_button,
    onClick: toggleCountrySwitch,
    title: "".concat(countrySwitchHeader.country.toUpperCase(), "(").concat(countrySwitchHeader.language.toUpperCase(), ")")
  }, !isIgusEU && (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: getFlagUrl(countryCode),
    alt: "".concat(countryCode, " flag"),
    width: 24,
    height: 16,
    className: css$b.country__flag
  }))), "".concat(countrySwitchHeader.country.toUpperCase(), " (").concat(countrySwitchHeader.language.toUpperCase(), ")")))))));
};

var css$a = {"icon__links_wrapper":"IconLinksBar-module_icon__links_wrapper__xvsqa","bg__grey":"IconLinksBar-module_bg__grey__M1dTP","bg__dark_grey":"IconLinksBar-module_bg__dark_grey__EP0DZ","bg__orange":"IconLinksBar-module_bg__orange__Q5zFR","bg__dark_orange":"IconLinksBar-module_bg__dark_orange__M6goq","bg__purple":"IconLinksBar-module_bg__purple__8fGeA","icon__links":"IconLinksBar-module_icon__links__pfwO3","icon__links_icon_wrapper":"IconLinksBar-module_icon__links_icon_wrapper__1FyDb","icon__links_icon":"IconLinksBar-module_icon__links_icon__fSMo-","text__dark":"IconLinksBar-module_text__dark__eiMJM","text__light":"IconLinksBar-module_text__light__8e9tN","icon__font":"IconLinksBar-module_icon__font__SGx1m","icon__font__white":"IconLinksBar-module_icon__font__white__muhik"};

var ColorValue;
(function (ColorValue) {
  ColorValue["LIGHT_GREY"] = "#EFEFEF";
  ColorValue["DARK_GREY"] = "#363636";
  ColorValue["ORANGE"] = "#F07D00";
  ColorValue["DARK_ORANGE"] = "#A45500";
  ColorValue["PURPLE"] = "#572C86";
})(ColorValue || (ColorValue = {}));

var IconLinks = function IconLinks(_ref) {
  var links = _ref.links,
    background_color = _ref.background_color;
  var linkVariant = (background_color === null || background_color === void 0 ? void 0 : background_color.value) === ColorValue.LIGHT_GREY ? LinkVariant.Secondary : LinkVariant.Tertiary;
  var textColor = (background_color === null || background_color === void 0 ? void 0 : background_color.value) === ColorValue.LIGHT_GREY ? css$a.text__dark : css$a.text__light;
  var iconlinks = links.map(function (link) {
    return Object.assign(Object.assign({}, link), {
      link: Object.assign({}, linkPropsMapper({
        name: link.text,
        link: link.link
      }))
    });
  });
  var imageSizes = [{
    width: 24,
    height: 24
  }];
  return /*#__PURE__*/React.createElement("ul", {
    className: css$a.icon__links_wrapper
  }, iconlinks.map(function (item) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return /*#__PURE__*/React.createElement("li", {
      key: item._uid,
      className: css$a.icon__links
    }, ((_a = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _a === void 0 ? void 0 : _a.icon) && ((_b = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _b === void 0 ? void 0 : _b.component) === 'icon_atom' && (/*#__PURE__*/React.createElement(IconFont, {
      icon: (_c = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _c === void 0 ? void 0 : _c.icon,
      className: "".concat(css$a.icon__font, " ").concat((background_color === null || background_color === void 0 ? void 0 : background_color.value) === ColorValue.ORANGE ? css$a.icon__font__white : '')
    })), item.link.href ? (/*#__PURE__*/React.createElement(Link, {
      variant: linkVariant,
      showExternalIcon: false,
      href: item.link.external ? item.link.href : formatLink(item.link.href),
      title: item.link.title,
      target: item.link.target,
      external: true,
      piwik_click_id: (_d = item === null || item === void 0 ? void 0 : item.link) === null || _d === void 0 ? void 0 : _d.piwik_click_id,
      anchor: (_e = item === null || item === void 0 ? void 0 : item.link) === null || _e === void 0 ? void 0 : _e.anchor,
      contact_type: determineContactType(item.link.href)
    }, /*#__PURE__*/React.createElement("span", {
      className: css$a.icon__links
    }, item.icon && hasAssetData(item.icon, MediaType.IMAGE) && (/*#__PURE__*/React.createElement("span", {
      className: css$a.icon__links_icon_wrapper
    }, /*#__PURE__*/React.createElement(Image, {
      src: "".concat(((_f = item.icon[0]) === null || _f === void 0 ? void 0 : _f.image.item.focal_embed_link) || ((_g = item.icon[0]) === null || _g === void 0 ? void 0 : _g.image.item.embed_link)),
      alt: "".concat((_h = item.icon[0]) === null || _h === void 0 ? void 0 : _h.alt_text),
      className: css$a.icon__links_icon,
      priority: true,
      imageSizes: imageSizes
    }))), item.text || item.link.title))) : (/*#__PURE__*/React.createElement(React.Fragment, null, ((_j = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _j === void 0 ? void 0 : _j.icon) && ((_k = item.icon[0]) === null || _k === void 0 ? void 0 : _k.component) === 'icon_atom' ? (/*#__PURE__*/React.createElement("div", {
      className: css$a.icon__font__wrapper
    }, /*#__PURE__*/React.createElement(IconFont, {
      icon: (_l = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _l === void 0 ? void 0 : _l.icon,
      className: css$a.icon__font
    }))) : (item === null || item === void 0 ? void 0 : item.icon) && hasAssetData(item.icon, MediaType.IMAGE) && (/*#__PURE__*/React.createElement("span", {
      className: css$a.icon__links_icon_wrapper
    }, /*#__PURE__*/React.createElement(Image, {
      src: "".concat(((_m = item.icon[0]) === null || _m === void 0 ? void 0 : _m.image.item.focal_embed_link) || ((_o = item.icon[0]) === null || _o === void 0 ? void 0 : _o.image.item.embed_link)),
      alt: "".concat((_p = item.icon[0]) === null || _p === void 0 ? void 0 : _p.alt_text),
      className: css$a.icon__links_icon,
      priority: true,
      imageSizes: imageSizes
    }))), item.text && /*#__PURE__*/React.createElement("span", {
      className: textColor
    }, item.text))));
  }));
};

var IconLinksBar = function IconLinksBar(_ref) {
  var links = _ref.links,
    _ref$background_color = _ref.background_color,
    background_color = _ref$background_color === void 0 ? {
      value: ColorValue.DARK_GREY
    } : _ref$background_color,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? ComponentVersion.v1 : _ref$version;
  return /*#__PURE__*/React.createElement("nav", {
    className: "icon-links-wrapper ".concat(chainConditionalClassnames(conditionalClassname((background_color === null || background_color === void 0 ? void 0 : background_color.value) === ColorValue.LIGHT_GREY, css$a.bg__grey), conditionalClassname((background_color === null || background_color === void 0 ? void 0 : background_color.value) === ColorValue.DARK_GREY, css$a.bg__dark_grey), conditionalClassname((background_color === null || background_color === void 0 ? void 0 : background_color.value) === ColorValue.ORANGE, css$a.bg__orange), conditionalClassname((background_color === null || background_color === void 0 ? void 0 : background_color.value) === ColorValue.DARK_ORANGE, css$a.bg__dark_orange), conditionalClassname((background_color === null || background_color === void 0 ? void 0 : background_color.value) === ColorValue.PURPLE, css$a.bg__purple)))
  }, /*#__PURE__*/React.createElement(Container, {
    version: version
  }, /*#__PURE__*/React.createElement(IconLinks, {
    links: links,
    background_color: background_color
  })));
};

function navigationHelper(event, backDrop, setDesktopNavStatus, setDesktopHoverStatus, navigation) {
  if (backDrop.current && backDrop.current.contains(event.target)) {
    var totalItems = _countAllNavigationItems(navigation);
    setDesktopNavStatus(new Array(totalItems).fill(false));
    setDesktopHoverStatus(new Array(totalItems).fill(false));
  }
}
function handleEscapeKey(event, setDesktopNavStatus, setDesktopHoverStatus, navigation) {
  if (event.key === 'Escape') {
    var totalItems = _countAllNavigationItems(navigation);
    setDesktopNavStatus(new Array(totalItems).fill(false));
    setDesktopHoverStatus(new Array(totalItems).fill(false));
  }
}
var navigationTeaserImageSrcSetSize = [{
  width: 659,
  height: 142
}, {
  width: 500,
  height: 108
}, {
  width: 460,
  height: 100
}, {
  width: 400,
  height: 86
}, {
  width: 350,
  height: 75
}, {
  width: 270,
  height: 142
}];
var _countAllNavigationItems = function countAllNavigationItems(items) {
  var count = items.length;
  items.forEach(function (item) {
    if (item.link_children && item.link_children.length > 0) {
      count += _countAllNavigationItems(item.link_children);
    }
  });
  return count;
};

var css$9 = {"linkwrapper":"NavigationElement-module_linkwrapper__yJ5i1","off_canvas_menu":"NavigationElement-module_off_canvas_menu__Ipdtb","touchicon":"NavigationElement-module_touchicon__x-hFG","off_canvas_container":"NavigationElement-module_off_canvas_container__xQKdT","contact":"NavigationElement-module_contact__WNEhz","icon__font":"NavigationElement-module_icon__font__Zu-ih","off_canvas_menu__open":"NavigationElement-module_off_canvas_menu__open__woYwx","off_canvas_menu__active":"NavigationElement-module_off_canvas_menu__active__GSoUr","off_canvas_menu_arrow__back":"NavigationElement-module_off_canvas_menu_arrow__back__Ek-oh","off_canvas_menu__button":"NavigationElement-module_off_canvas_menu__button__pGCLd","off_canvas_menu__button_back":"NavigationElement-module_off_canvas_menu__button_back__X-4cf","level0":"NavigationElement-module_level0__SjTLS","level1":"NavigationElement-module_level1__nFh-l","level2":"NavigationElement-module_level2__q2Jcs","level3":"NavigationElement-module_level3__tNc9D","level4":"NavigationElement-module_level4__gndjk","teaser_box":"NavigationElement-module_teaser_box__GnSyv","teaser_box__headline":"NavigationElement-module_teaser_box__headline__hsJFR","teaser_box__link_text":"NavigationElement-module_teaser_box__link_text__8BjYF","teaser_box__image_level_2":"NavigationElement-module_teaser_box__image_level_2__lTjld","teaser_box__image":"NavigationElement-module_teaser_box__image__OxALU","teaser_box__multiview":"NavigationElement-module_teaser_box__multiview__ZynMC","teaser_box__link":"NavigationElement-module_teaser_box__link__iXpWh","desktop_left_wrapper":"NavigationElement-module_desktop_left_wrapper__5DFhA","off_canvas_menu_v2":"NavigationElement-module_off_canvas_menu_v2__tWwlZ","contactPerson__menu":"NavigationElement-module_contactPerson__menu__Wih3z","contact_person__active":"NavigationElement-module_contact_person__active__JMBA4","level0__nav__button__active":"NavigationElement-module_level0__nav__button__active__8aWS-","contact_link":"NavigationElement-module_contact_link__5p3Rn","country_switcher__wrapper":"NavigationElement-module_country_switcher__wrapper__AD2tL","country__wrapper":"NavigationElement-module_country__wrapper__ybg1K","country_switcher__text":"NavigationElement-module_country_switcher__text__6Hf-8","country__switcher__display":"NavigationElement-module_country__switcher__display__zQYMD","country_switcher_button":"NavigationElement-module_country_switcher_button__8cWf-","contact_link__button":"NavigationElement-module_contact_link__button__icIvt","link__noIcon":"NavigationElement-module_link__noIcon__ueID6","level2__active":"NavigationElement-module_level2__active__5JqVt","link__active":"NavigationElement-module_link__active__Lss0V","country__switcher__menu__open":"NavigationElement-module_country__switcher__menu__open__eYby4","teaser_view":"NavigationElement-module_teaser_view__ivzRw","off_canvas_menu__button_active":"NavigationElement-module_off_canvas_menu__button_active__M5NJd","single_teaser_view":"NavigationElement-module_single_teaser_view__-FjiC","level3Category":"NavigationElement-module_level3Category__9X595","nav_close__icon":"NavigationElement-module_nav_close__icon__jAjYS","no_link":"NavigationElement-module_no_link__YyEmF","icon__font__wrapper":"NavigationElement-module_icon__font__wrapper__T1i8K","with__icon__font":"NavigationElement-module_with__icon__font__5l8Wa","material__icons":"NavigationElement-module_material__icons__qjsYp"};

function NavigationSingleTeaser(_ref) {
  var teaser_link = _ref.teaser_link,
    teaser_name = _ref.teaser_name,
    teaser_image = _ref.teaser_image,
    level = _ref.level,
    desktop = _ref.desktop,
    findOutMoreText = _ref.findOutMoreText,
    asPath = _ref.asPath,
    locale = _ref.locale;
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var hasTeaserImage = teaser_image && teaser_image.length > 0;
  var externalLink = (teaser_link === null || teaser_link === void 0 ? void 0 : teaser_link.linktype) === 'url' || isExternalLink(teaser_link === null || teaser_link === void 0 ? void 0 : teaser_link.linktype) || false;
  var imageSrc = hasTeaserImage ? ((_c = (_b = (_a = teaser_image[0]) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.embed_link) || ((_f = (_e = (_d = teaser_image[0]) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.focal_embed_link) : '';
  var imageAlt = hasTeaserImage ? (_g = teaser_image[0]) === null || _g === void 0 ? void 0 : _g.alt_text : '';
  if (desktop) return /*#__PURE__*/React.createElement("li", {
    className: css$9.teaser_box
  }, level && level >= 2 && !desktop && (/*#__PURE__*/React.createElement("p", {
    className: css$9.teaser_box__headline
  }, teaser_name)), /*#__PURE__*/React.createElement(Link, {
    target: TargetValues.Self,
    title: (teaser_link === null || teaser_link === void 0 ? void 0 : teaser_link.title) || teaser_name || '',
    rel: (teaser_link === null || teaser_link === void 0 ? void 0 : teaser_link.rel) || '',
    variant: LinkVariant.Tertiary,
    href: ((_h = teaser_link === null || teaser_link === void 0 ? void 0 : teaser_link.story) === null || _h === void 0 ? void 0 : _h.url) || (teaser_link === null || teaser_link === void 0 ? void 0 : teaser_link.url) || (teaser_link === null || teaser_link === void 0 ? void 0 : teaser_link.cached_url) || '',
    className: css$9.teaser_box__link,
    external: externalLink,
    showExternalIcon: false,
    isNav: true,
    asPath: asPath,
    locale: locale
  }, /*#__PURE__*/React.createElement(React.Fragment, null, imageSrc && (/*#__PURE__*/React.createElement(Image, {
    src: imageSrc,
    alt: imageAlt || '',
    imageSizes: navigationTeaserImageSrcSetSize,
    className: "".concat(level && level >= 2 && desktop ? css$9.teaser_box__image_level_2 : '', " ").concat(css$9.teaser_box__image),
    sizes: "(max-width: 535px) 40vw, (max-width: 739px) 50vw, (max-width: 1024px) 20vw, 270px"
  })), level && level >= 2 && !desktop && (/*#__PURE__*/React.createElement("p", {
    className: css$9.teaser_box__link_text
  }, /*#__PURE__*/React.createElement(LinkIcon, null), findOutMoreText)), (level === 1 || desktop) && /*#__PURE__*/React.createElement("p", null, teaser_name))));
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}

function NavigationTeaser(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
  var child = props.child,
    level = props.level,
    desktop = props.desktop;
  var link_name = child.link_name,
    link = child.link,
    teaser_image = child.teaser_image,
    image = child.image,
    teaser_name = child.teaser_name;
  var hasTeaserImage = teaser_image && teaser_image.length > 0;
  var hasImage = image && image.length > 0;
  var imageSrc = hasTeaserImage ? ((_c = (_b = (_a = teaser_image[0]) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.embed_link) || ((_f = (_e = (_d = teaser_image[0]) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.focal_embed_link) : hasImage ? ((_j = (_h = (_g = image[0]) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.embed_link) || ((_m = (_l = (_k = image[0]) === null || _k === void 0 ? void 0 : _k.image) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.focal_embed_link) : '';
  var imageAlt = hasTeaserImage ? (_o = teaser_image[0]) === null || _o === void 0 ? void 0 : _o.alt_text : hasImage ? (_p = image[0]) === null || _p === void 0 ? void 0 : _p.alt_text : '';
  var externalLink = (link === null || link === void 0 ? void 0 : link.linktype) === 'url' || isExternalLink(link === null || link === void 0 ? void 0 : link.linktype) || false;
  return /*#__PURE__*/React.createElement("li", {
    className: "".concat(css$9.teaser_box, " ").concat(css$9.teaser_box__multiview)
  }, /*#__PURE__*/React.createElement(Link, {
    target: TargetValues.Self,
    title: (link === null || link === void 0 ? void 0 : link.title) || link_name || '',
    rel: (link === null || link === void 0 ? void 0 : link.rel) || '',
    variant: LinkVariant.Tertiary,
    href: (link === null || link === void 0 ? void 0 : link.cached_url) || '',
    className: css$9.teaser_box__link,
    external: externalLink,
    showExternalIcon: false,
    isNav: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, imageSrc && (/*#__PURE__*/React.createElement(Image, {
    src: imageSrc,
    alt: imageAlt || '',
    imageSizes: navigationTeaserImageSrcSetSize,
    sizes: "(max-width: 535px) 40vw, (max-width: 739px) 50vw, (max-width: 1024px) 20vw, 270px",
    className: "".concat(level >= 2 && desktop ? css$9.teaser_box__image_level_2 : '', " ").concat(css$9.teaser_box__image)
  })), (level === 1 || desktop) && /*#__PURE__*/React.createElement("p", null, teaser_name || link_name))));
}

var NavigationLinkContent = function NavigationLinkContent(_ref) {
  var item = _ref.item,
    iconSizes = _ref.iconSizes;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (item === null || item === void 0 ? void 0 : item.icon) && ((_a = item.icon[0]) === null || _a === void 0 ? void 0 : _a.component) === 'icon_atom' ? (/*#__PURE__*/React.createElement("div", {
    className: css$9.icon__font__wrapper
  }, /*#__PURE__*/React.createElement(IconFont, {
    icon: (_b = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _b === void 0 ? void 0 : _b.icon,
    className: "".concat(css$9.icon__font, " ").concat(((_c = item.icon[0]) === null || _c === void 0 ? void 0 : _c.icon.type) === 'material' ? css$9.material__icons : '')
  }))) : (item === null || item === void 0 ? void 0 : item.icon) && ((_f = (_e = (_d = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.embed_link) && (/*#__PURE__*/React.createElement(Image, {
    src: ((_j = (_h = (_g = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.embed_link) || ((_m = (_l = (_k = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _k === void 0 ? void 0 : _k.image) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.focal_embed_link) || '',
    alt: ((_o = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _o === void 0 ? void 0 : _o.alt_text) || (item === null || item === void 0 ? void 0 : item.link_name) || '',
    imageSizes: iconSizes
  })), item.link_name);
};
var NavigationLinkContentWithIcons = function NavigationLinkContentWithIcons(_ref2) {
  var item = _ref2.item,
    iconSizes = _ref2.iconSizes,
    showIcons = _ref2.showIcons;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (item === null || item === void 0 ? void 0 : item.icon) && ((_a = item.icon[0]) === null || _a === void 0 ? void 0 : _a.component) === 'icon_atom' ? (/*#__PURE__*/React.createElement("div", {
    className: css$9.icon__font__wrapper
  }, /*#__PURE__*/React.createElement(IconFont, {
    icon: (_b = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _b === void 0 ? void 0 : _b.icon,
    className: "".concat(css$9.icon__font, " ").concat(((_c = item.icon[0]) === null || _c === void 0 ? void 0 : _c.icon.type) === 'material' ? css$9.material__icons : '')
  }))) : (item === null || item === void 0 ? void 0 : item.icon) && ((_f = (_e = (_d = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.embed_link) && showIcons && (/*#__PURE__*/React.createElement(Image, {
    src: ((_j = (_h = (_g = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.embed_link) || ((_m = (_l = (_k = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _k === void 0 ? void 0 : _k.image) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.focal_embed_link) || '',
    alt: ((_o = item === null || item === void 0 ? void 0 : item.icon[0]) === null || _o === void 0 ? void 0 : _o.alt_text) || (item === null || item === void 0 ? void 0 : item.link_name) || '',
    imageSizes: iconSizes
  })), item.link_name);
};
var NavigationButton = function NavigationButton(_ref3) {
  var showComponent = _ref3.showComponent,
    className = _ref3.className,
    handleClick = _ref3.handleClick,
    children = _ref3.children;
  return showComponent ? (/*#__PURE__*/React.createElement("button", {
    className: "".concat(css$9.off_canvas_menu__button, " ").concat(className),
    onClick: handleClick
  }, children)) : (/*#__PURE__*/React.createElement(React.Fragment, null));
};
var NavigationList = function NavigationList(_ref4) {
  var onMouseEnter = _ref4.onMouseEnter,
    className = _ref4.className,
    children = _ref4.children;
  return /*#__PURE__*/React.createElement("li", {
    onMouseEnter: onMouseEnter && onMouseEnter,
    className: className
  }, children);
};
var ConditionalWrapper = function ConditionalWrapper(_ref5) {
  var condition = _ref5.condition,
    children = _ref5.children;
  if (condition) {
    return /*#__PURE__*/React.createElement("div", {
      className: css$9.desktop_left_wrapper
    }, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var iconSizes = [{
  width: 32,
  height: 32
}];
var getLevelClass = {
  0: css$9.level0,
  1: css$9.level1,
  2: css$9.level2,
  3: css$9.level3,
  4: css$9.level4
};
var isExternalLink = function isExternalLink(href) {
  return (href === null || href === void 0 ? void 0 : href.startsWith('http://')) || (href === null || href === void 0 ? void 0 : href.startsWith('https://')) || false;
};
var _NavigationItem = function NavigationItem(_ref) {
  var item = _ref.item,
    level = _ref.level,
    menuIndex = _ref.menuIndex,
    handleClose = _ref.handleClose,
    backButtonLabel = _ref.backButtonLabel,
    backButtonLinkData = _ref.backButtonLinkData,
    desktop = _ref.desktop,
    handleDesktopClick = _ref.handleDesktopClick,
    desktopNavStatus = _ref.desktopNavStatus,
    handleDesktopHover = _ref.handleDesktopHover,
    desktopHoverForLevel2Status = _ref.desktopHoverForLevel2Status,
    showIcons = _ref.showIcons,
    showLevel2Content = _ref.showLevel2Content,
    overViewLinkText = _ref.overViewLinkText,
    findOutMoreText = _ref.findOutMoreText,
    handleCloseBtn = _ref.handleCloseBtn,
    asPath = _ref.asPath,
    locale = _ref.locale,
    _ref$version = _ref.version;
    _ref$version === void 0 ? ComponentVersion.v1 : _ref$version;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
  var hasChildren = item.link_children && item.link_children.length > 0;
  var _useState = useState(false),
    active = _useState[0],
    setActive = _useState[1];
  var _useState2 = useState(false),
    isClient = _useState2[0],
    setIsClient = _useState2[1];
  useEffect(function () {
    if (!isClient) {
      setIsClient(true);
    }
  }, [isClient]);
  var handleClickOpen = function handleClickOpen() {
    setActive(true);
    if (window && window.innerWidth <= 1025) {
      document.querySelector('ul.' + getLevelClass[0]).scrollTop = 0;
      document.querySelectorAll('ul.' + getLevelClass[1]).forEach(function (el) {
        return el.scrollTop = 0;
      });
      document.querySelectorAll('ul.' + getLevelClass[2]).forEach(function (el) {
        return el.scrollTop = 0;
      });
      document.querySelectorAll('ul.' + getLevelClass[3]).forEach(function (el) {
        return el.scrollTop = 0;
      });
    }
  };
  var handleClickClose = function handleClickClose() {
    setActive(false);
  };
  var desktopHover = function desktopHover(index, level) {
    if (level === 2 && desktop) {
      handleDesktopHover === null || handleDesktopHover === void 0 ? void 0 : handleDesktopHover(index, level);
    }
  };
  var desktopToggle = function desktopToggle(index, hasChildren) {
    handleDesktopClick === null || handleDesktopClick === void 0 ? void 0 : handleDesktopClick(index, hasChildren);
  };
  var externalLink = ((_a = item === null || item === void 0 ? void 0 : item.link) === null || _a === void 0 ? void 0 : _a.linktype) === 'url' || isExternalLink(((_b = item === null || item === void 0 ? void 0 : item.link) === null || _b === void 0 ? void 0 : _b.url) || ((_c = item === null || item === void 0 ? void 0 : item.link) === null || _c === void 0 ? void 0 : _c.cached_url)) || false;
  var levelClass = getLevelClass[level !== null && level !== void 0 ? level : 0];
  var conditionalWrapperCondition = level && level === 1 && !item.show_as_teaser;
  var shouldRenderMobileOverviewLink = function shouldRenderMobileOverviewLink() {
    var _a;
    var hasLevel = level !== undefined && level > 1;
    var isMobile = !desktop;
    var isFirstMenu = menuIndex === 0;
    var hasBackButtonLink = !!((_a = backButtonLinkData === null || backButtonLinkData === void 0 ? void 0 : backButtonLinkData.story) === null || _a === void 0 ? void 0 : _a.url) || !!(backButtonLinkData === null || backButtonLinkData === void 0 ? void 0 : backButtonLinkData.url);
    return !!(hasLevel && isMobile && isFirstMenu && hasBackButtonLink);
  };
  var renderOverviewLink = function renderOverviewLink() {
    var _a, _b;
    if (shouldRenderMobileOverviewLink()) {
      return /*#__PURE__*/React.createElement("span", {
        className: css$9.linkwrapper
      }, /*#__PURE__*/React.createElement(Link, {
        external: externalLink,
        title: overViewLinkText || 'Overview',
        rel: ((_a = item === null || item === void 0 ? void 0 : item.link) === null || _a === void 0 ? void 0 : _a.rel) || '',
        altText: overViewLinkText,
        href: ((_b = backButtonLinkData === null || backButtonLinkData === void 0 ? void 0 : backButtonLinkData.story) === null || _b === void 0 ? void 0 : _b.url) || (backButtonLinkData === null || backButtonLinkData === void 0 ? void 0 : backButtonLinkData.url) || (backButtonLinkData === null || backButtonLinkData === void 0 ? void 0 : backButtonLinkData.cached_url) || '',
        variant: LinkVariant.Tertiary,
        showExternalIcon: false,
        target: TargetValues.Self,
        className: level === 3 ? css$9.level3Category : '',
        isNav: true
      }, /*#__PURE__*/React.createElement("strong", null, overViewLinkText || 'Overview')));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasChildren ? (/*#__PURE__*/React.createElement(NavigationList, {
    className: "".concat(levelClass, " ").concat((desktopHoverForLevel2Status === null || desktopHoverForLevel2Status === void 0 ? void 0 : desktopHoverForLevel2Status[menuIndex !== null && menuIndex !== void 0 ? menuIndex : 0]) && level === 2 ? css$9.level2__active : ''),
    onMouseEnter: function onMouseEnter() {
      if (level && desktop) {
        desktopHover === null || desktopHover === void 0 ? void 0 : desktopHover(menuIndex !== null && menuIndex !== void 0 ? menuIndex : 0, level);
      }
    }
  }, level && level > 1 && menuIndex === 0 && (/*#__PURE__*/React.createElement(NavigationButton, {
    showComponent: level && level > 1 && menuIndex === 0 || false,
    handleClick: handleClose,
    className: "".concat(css$9.off_canvas_menu__button_back, " ").concat(level === 2 ? css$9.off_canvas_menu__button_active : '')
  }, /*#__PURE__*/React.createElement(NavArrowIcon, {
    className: css$9.off_canvas_menu_arrow__back
  }), ' ', backButtonLabel)), renderOverviewLink(), level && level > 1 && desktop ? (/*#__PURE__*/React.createElement("span", {
    className: "".concat(css$9.linkwrapper, "  ").concat((desktopHoverForLevel2Status === null || desktopHoverForLevel2Status === void 0 ? void 0 : desktopHoverForLevel2Status[menuIndex !== null && menuIndex !== void 0 ? menuIndex : 0]) && level === 2 ? css$9.link__active : '')
  }, /*#__PURE__*/React.createElement(Link, {
    external: externalLink,
    title: ((_d = item === null || item === void 0 ? void 0 : item.link) === null || _d === void 0 ? void 0 : _d.title) || (item === null || item === void 0 ? void 0 : item.link_name) || '',
    rel: ((_e = item === null || item === void 0 ? void 0 : item.link) === null || _e === void 0 ? void 0 : _e.rel) || '',
    altText: (item === null || item === void 0 ? void 0 : item.link_name) || '',
    href: ((_g = (_f = item === null || item === void 0 ? void 0 : item.link) === null || _f === void 0 ? void 0 : _f.story) === null || _g === void 0 ? void 0 : _g.url) || ((_h = item === null || item === void 0 ? void 0 : item.link) === null || _h === void 0 ? void 0 : _h.url) || ((_j = item === null || item === void 0 ? void 0 : item.link) === null || _j === void 0 ? void 0 : _j.cached_url) || '',
    variant: LinkVariant.Tertiary,
    showExternalIcon: false,
    target: TargetValues.Self,
    className: "".concat(level === 3 ? css$9.level3Category : '', " ").concat((item === null || item === void 0 ? void 0 : item.icon) && ((_k = item.icon[0]) === null || _k === void 0 ? void 0 : _k.component) === 'icon_atom' ? css$9.with__icon__font : ''),
    isNav: true,
    onClickHandler: handleCloseBtn,
    asPath: asPath,
    locale: locale
  }, /*#__PURE__*/React.createElement(NavigationLinkContent, {
    item: item,
    iconSizes: iconSizes
  })), /*#__PURE__*/React.createElement(NavArrowIcon, {
    className: css$9.touchicon
  }))) : (/*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      if (desktop && level === 1) showLevel2Content === null || showLevel2Content === void 0 ? void 0 : showLevel2Content();
      // FIXME! Fix the code and do not ignore the linter error.
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      desktop ? desktopToggle === null || desktopToggle === void 0 ? void 0 : desktopToggle(menuIndex !== null && menuIndex !== void 0 ? menuIndex : 0, hasChildren) : handleClickOpen();
    },
    className: "".concat(css$9.off_canvas_menu__button, " ").concat(levelClass, " ").concat((desktopNavStatus === null || desktopNavStatus === void 0 ? void 0 : desktopNavStatus[menuIndex !== null && menuIndex !== void 0 ? menuIndex : 0]) && desktop ? css$9.level0__nav__button__active : '', "  ")
  }, item.link_name, /*#__PURE__*/React.createElement(NavArrowIcon, null))), /*#__PURE__*/React.createElement("ul", {
    className: "".concat(levelClass, " ").concat(active || (desktopNavStatus === null || desktopNavStatus === void 0 ? void 0 : desktopNavStatus[menuIndex !== null && menuIndex !== void 0 ? menuIndex : 0]) || level === 2 && (desktopHoverForLevel2Status === null || desktopHoverForLevel2Status === void 0 ? void 0 : desktopHoverForLevel2Status[menuIndex !== null && menuIndex !== void 0 ? menuIndex : 0]) ? css$9.off_canvas_menu__active : '', " ").concat((item === null || item === void 0 ? void 0 : item.show_as_teaser) ? css$9.teaser_view : '').concat(level === 2 && item.teaser_name !== '' ? css$9.single_teaser_view : '')
  }, /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: conditionalWrapperCondition
  }, (_l = item === null || item === void 0 ? void 0 : item.link_children) === null || _l === void 0 ? void 0 : _l.map(function (child, index) {
    var _a;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: child._uid
    }, item.show_as_teaser && level === 1 || item.show_as_teaser && level === 2 ? (/*#__PURE__*/React.createElement(React.Fragment, null, index === 0 && (/*#__PURE__*/React.createElement("button", {
      onClick: handleClickClose,
      className: "".concat(css$9.off_canvas_menu__button, " ").concat(css$9.off_canvas_menu__button_back, " ")
    }, /*#__PURE__*/React.createElement(NavArrowIcon, {
      className: css$9.off_canvas_menu_arrow__back
    }), item.link_name)), /*#__PURE__*/React.createElement(NavigationTeaser, {
      level: level || 0,
      child: child,
      desktop: desktop || false
    }))) : (/*#__PURE__*/React.createElement(_NavigationItem, {
      item: child,
      level: (_a = level && level + 1) !== null && _a !== void 0 ? _a : 1,
      menuIndex: index,
      backButtonLabel: item.link_name,
      backButtonLinkData: item.link,
      desktop: desktop,
      handleClose: handleClickClose,
      handleDesktopHover: handleDesktopHover,
      desktopHoverForLevel2Status: desktopHoverForLevel2Status,
      showIcons: item === null || item === void 0 ? void 0 : item.show_icons,
      handleCloseBtn: handleCloseBtn,
      overViewLinkText: overViewLinkText,
      asPath: asPath,
      locale: locale
    })));
  })), item.teaser_image && item.teaser_name && item.teaser_link && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationSingleTeaser, {
    level: level || 0,
    desktop: desktop || false,
    teaser_image: item.teaser_image,
    teaser_name: item.teaser_name,
    teaser_link: item.teaser_link,
    findOutMoreText: findOutMoreText,
    asPath: asPath,
    locale: locale
  })))))) : (/*#__PURE__*/React.createElement(NavigationList, null, level && level > 1 && menuIndex === 0 && (/*#__PURE__*/React.createElement("button", {
    onClick: handleClose,
    className: "".concat(css$9.off_canvas_menu__button, " ").concat(css$9.off_canvas_menu__button_back, " ")
  }, /*#__PURE__*/React.createElement(NavArrowIcon, {
    className: css$9.off_canvas_menu_arrow__back
  }), ' ', backButtonLabel)), renderOverviewLink(), isClient ? (/*#__PURE__*/React.createElement(Link, {
    external: externalLink,
    title: ((_m = item === null || item === void 0 ? void 0 : item.link) === null || _m === void 0 ? void 0 : _m.title) || (item === null || item === void 0 ? void 0 : item.link_name) || '',
    rel: ((_o = item === null || item === void 0 ? void 0 : item.link) === null || _o === void 0 ? void 0 : _o.rel) || '',
    altText: (item === null || item === void 0 ? void 0 : item.link_name) || '',
    href: ((_q = (_p = item === null || item === void 0 ? void 0 : item.link) === null || _p === void 0 ? void 0 : _p.story) === null || _q === void 0 ? void 0 : _q.url) || ((_r = item === null || item === void 0 ? void 0 : item.link) === null || _r === void 0 ? void 0 : _r.url) || ((_s = item === null || item === void 0 ? void 0 : item.link) === null || _s === void 0 ? void 0 : _s.cached_url) || '',
    variant: LinkVariant.Tertiary,
    showExternalIcon: false,
    target: TargetValues.Self,
    onMouseEnterEvent: function onMouseEnterEvent() {
      if (level && desktop) {
        desktopHover === null || desktopHover === void 0 ? void 0 : desktopHover(menuIndex !== null && menuIndex !== void 0 ? menuIndex : 0, level);
      }
    },
    className: (item === null || item === void 0 ? void 0 : item.icon) && ((_t = item.icon[0]) === null || _t === void 0 ? void 0 : _t.component) === 'icon_atom' ? css$9.with__icon__font : css$9.link__noIcon,
    isNav: true,
    onClickHandler: handleCloseBtn,
    asPath: asPath,
    locale: locale
  }, /*#__PURE__*/React.createElement(NavigationLinkContentWithIcons, {
    item: item,
    iconSizes: iconSizes,
    showIcons: showIcons
  }))) : (/*#__PURE__*/React.createElement("span", {
    className: (item === null || item === void 0 ? void 0 : item.icon) && ((_u = item.icon[0]) === null || _u === void 0 ? void 0 : _u.component) === 'icon_atom' ? "".concat(css$9.with__icon__font, " ").concat(css$9.no_link) : "".concat(css$9.link__noIcon, " ").concat(css$9.no_link)
  }, /*#__PURE__*/React.createElement(NavigationLinkContentWithIcons, {
    item: item,
    iconSizes: iconSizes,
    showIcons: showIcons
  }))))));
};

var CountrySwitcher = function CountrySwitcher(_ref) {
  var language = _ref.language,
    country = _ref.country,
    isNavigationOpen = _ref.isNavigationOpen,
    locale = _ref.locale,
    openCountrySwitchModal = _ref.openCountrySwitchModal;
  var toggleCountrySwitch = function toggleCountrySwitch() {
    if (openCountrySwitchModal) {
      openCountrySwitchModal(function (prevState) {
        return !prevState;
      });
    }
  };
  var isIgusEU = isIgusEuDomain(locale || '');
  var countrySwitchHeader = igusEuDomainHeader(locale || '', country, language);
  return /*#__PURE__*/React.createElement("div", {
    className: css$9.country__switcher__wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$9.level0, " ").concat(css$9.contact, " ").concat(isNavigationOpen ? css$9.country__switcher__menu__open : '')
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(css$9.country_switcher_button, " ").concat(css$9.country__switcher__display),
    onClick: toggleCountrySwitch,
    title: "".concat(countrySwitchHeader.country.toUpperCase(), "(").concat(countrySwitchHeader.language.toUpperCase(), ")")
  }, !isIgusEU && (/*#__PURE__*/React.createElement("img", {
    src: getFlagUrl(countrySwitchHeader.country),
    alt: "".concat(countrySwitchHeader.country, " flag"),
    width: 24,
    height: 16
  })), "".concat(countrySwitchHeader.country.toUpperCase()), ' ', /*#__PURE__*/React.createElement("span", {
    className: "".concat(css$9.country_switcher__text)
  }, "(", "".concat(countrySwitchHeader.language.toUpperCase()), ")"))));
};

var Navigation = function Navigation(_ref) {
  var navigation = _ref.navigation,
    with_contact = _ref.with_contact,
    myContactLabel = _ref.myContactLabel,
    defaultFormSlug = _ref.defaultFormSlug,
    select_contact_view = _ref.select_contact_view,
    overViewLinkText = _ref.overViewLinkText,
    selectLocationText = _ref.selectLocationText,
    selectPlaceholderText = _ref.selectPlaceholderText,
    noContactFoundText = _ref.noContactFoundText,
    changeLocationText = _ref.changeLocationText,
    sendMessageText = _ref.sendMessageText,
    locationDescriptionText = _ref.locationDescriptionText,
    zipCodePlaceholderText = _ref.zipCodePlaceholderText,
    locationErrorText = _ref.locationErrorText,
    findOutMoreText = _ref.findOutMoreText,
    contact_link = _ref.contact_link,
    openCountrySwitchModal = _ref.openCountrySwitchModal,
    country = _ref.country,
    with_country_switch = _ref.with_country_switch,
    middlewareBaseURL = _ref.middlewareBaseURL,
    asPath = _ref.asPath,
    locale = _ref.locale,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? ComponentVersion.v1 : _ref$version;
  var _useNavigation = useNavigation(),
    isNavigationOpen = _useNavigation.isNavigationOpen,
    setNavigationData = _useNavigation.setNavigationData,
    toggleNavigation = _useNavigation.toggleNavigation,
    closeNav = _useNavigation.closeNav,
    backDrop = _useNavigation.backDrop,
    isContactPersonOpen = _useNavigation.isContactPersonOpen,
    setIsContactPersonOpen = _useNavigation.setIsContactPersonOpen;
  var _useState = useState(false),
    desktop = _useState[0],
    setDesktop = _useState[1];
  var totalNavItems = useMemo(function () {
    return _countAllNavigationItems(navigation);
  }, [navigation]);
  var _useState2 = useState(new Array(totalNavItems).fill(false)),
    desktopNavStatus = _useState2[0],
    setDesktopNavStatus = _useState2[1];
  var _useState3 = useState(new Array(totalNavItems).fill(false)),
    desktopHoverForLevel2Status = _useState3[0],
    setDesktopHoverForLevel2Status = _useState3[1];
  var _useMemo = useMemo(function () {
      return extractLanguageAndCountry(country);
    }, [country]),
    languageCode = _useMemo[0],
    countryCode = _useMemo[1];
  var handleDesktopHover = function handleDesktopHover(index, level) {
    if (level === 2) {
      setDesktopHoverForLevel2Status(desktopHoverForLevel2Status.map(function (_, i) {
        return i === index;
      }));
    }
  };
  var showLevel2Content = function showLevel2Content() {
    setDesktopHoverForLevel2Status(function () {
      var newState = new Array(_countAllNavigationItems(navigation)).fill(false);
      if (newState.length > 0) {
        newState[0] = true; // always show first item as hovered
      }
      return newState;
    });
  };
  var handleDesktopClick = function handleDesktopClick(index, hasChildren) {
    var status = desktopNavStatus.map(function (element, i) {
      var value = index == i;
      return element == value ? false : value;
    });
    setDesktopNavStatus(status);
    /*
    IS NEEDED TO PREVENT REMOVING THE BACKDROP
    AFTER CLICKING ANOTHER LINK WHILE NAVIGATION
    IS OPEN
    */
    if (!isNavigationOpen) {
      toggleNavigation();
      // !! FIX FOR HOVER
      showLevel2Content();
      return;
    }
    /*
    IS NEEDED TO CLOSE THE NAVIGATION IF ALL VALUES
    IN desktopNavStatus<Array<boolean>> ARE FALSE
    */
    if (!status.includes(true)) {
      closeNav();
      return;
    }
    if (!hasChildren) {
      return;
    }
  };
  var _useState4 = useState(false),
    showContactPerson = _useState4[0],
    setShowContactPerson = _useState4[1];
  var handleContactPerson = function handleContactPerson() {
    if (isNavigationOpen) {
      closeNav();
      setDesktopNavStatus(new Array(totalNavItems).fill(false));
      setDesktopHoverForLevel2Status(new Array(totalNavItems).fill(false));
    }
    setShowContactPerson(function (prevState) {
      return !prevState;
    });
    if (setIsContactPersonOpen) {
      setIsContactPersonOpen(true);
    }
  };
  var handleCloseBtn = function handleCloseBtn() {
    if (isNavigationOpen) {
      closeNav();
      setDesktopNavStatus(new Array(totalNavItems).fill(false));
      setDesktopHoverForLevel2Status(new Array(totalNavItems).fill(false));
    }
  };
  useEffect(function () {
    document.addEventListener('mousedown', function (e) {
      return navigationHelper(e, backDrop, setDesktopNavStatus, setDesktopHoverForLevel2Status, navigation);
    });
    document.addEventListener('keydown', function (e) {
      return handleEscapeKey(e, setDesktopNavStatus, setDesktopHoverForLevel2Status, navigation);
    });
    var handleOutsideClick = function handleOutsideClick(e) {
      var contactPersonContainer = document.getElementById('contactPersonContainer');
      var contactPerson = document.getElementById('contactPerson');
      if (contactPersonContainer && !contactPersonContainer.contains(e.target) && contactPerson && !contactPerson.contains(e.target)) {
        setShowContactPerson(false);
        if (setIsContactPersonOpen) {
          setIsContactPersonOpen(false);
        }
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    // remove the event listener when the component unmounts
    return function () {
      document.addEventListener('mousedown', function (e) {
        return navigationHelper(e, backDrop, setDesktopNavStatus, setDesktopHoverForLevel2Status, navigation);
      });
      document.addEventListener('keydown', function (e) {
        return handleEscapeKey(e, setDesktopNavStatus, setDesktopHoverForLevel2Status, navigation);
      });
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [backDrop, navigation]);
  useEffect(function () {
    var myObserver = new ResizeObserver(function (entries) {
      setDesktop(entries[0].contentRect.width >= 1025);
      if (entries[0].contentRect.width <= 1025) {
        closeNav();
        setDesktopNavStatus(new Array(totalNavItems).fill(false));
        setDesktopHoverForLevel2Status(new Array(totalNavItems).fill(false));
      }
    });
    myObserver.observe(document.body);
  }, []);
  useEffect(function () {
    setNavigationData(navigation);
  }, [navigation, setNavigationData, setShowContactPerson]);
  return /*#__PURE__*/React.createElement("div", {
    className: css$9.off_canvas_container
  }, /*#__PURE__*/React.createElement("nav", {
    className: chainConditionalClassnames(css$9.off_canvas_menu, conditionalClassname(isNavigationOpen || desktopNavStatus.includes(true), css$9.off_canvas_menu__open), conditionalClassname(isPreferredVersion(ComponentVersion.v2, version), css$9.off_canvas_menu_v2)),
    id: "main-nav",
    "aria-label": "Main"
  }, desktop && isNavigationOpen && (/*#__PURE__*/React.createElement("button", {
    "aria-label": "Close navigation",
    className: conditionalClassname(isNavigationOpen, css$9.nav_close__icon),
    onClick: handleCloseBtn
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement("ul", {
    className: "".concat(css$9.level0, " ").concat(isNavigationOpen ? css$9.off_canvas_menu__active : '')
  }, navigation.length > 0 && navigation.map(function (item, index) {
    return /*#__PURE__*/React.createElement(_NavigationItem, {
      key: item._uid,
      item: item,
      level: 1,
      menuIndex: index,
      desktop: desktop,
      desktopNavStatus: desktopNavStatus,
      desktopHoverForLevel2Status: desktopHoverForLevel2Status,
      handleDesktopClick: handleDesktopClick,
      handleDesktopHover: handleDesktopHover,
      showLevel2Content: showLevel2Content,
      overViewLinkText: overViewLinkText,
      findOutMoreText: findOutMoreText,
      handleCloseBtn: handleCloseBtn,
      asPath: asPath,
      locale: locale
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$9.country_switcher__wrapper)
  }, with_contact && (/*#__PURE__*/React.createElement("ul", {
    className: "".concat(css$9.level0, " ").concat(css$9.contact, " ").concat(css$9.off_canvas_menu, " ").concat(isNavigationOpen ? css$9.off_canvas_menu__open : '')
  }, /*#__PURE__*/React.createElement("li", {
    className: css$9.contact_link
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(css$9.contact_link__button, " ").concat(isContactPersonOpen ? css$9.contact_person__active : ''),
    id: "contactPersonContainer",
    onClick: handleContactPerson,
    title: myContactLabel,
    "aria-label": "Contact person"
  }, myContactLabel)))), with_country_switch && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(css$9.country__wrapper)
  }, /*#__PURE__*/React.createElement(CountrySwitcher, {
    language: languageCode,
    country: countryCode,
    locale: country,
    openCountrySwitchModal: openCountrySwitchModal,
    isNavigationOpen: isNavigationOpen,
    footerLanguage: "",
    footerCountry: ""
  }))))), showContactPerson && (/*#__PURE__*/React.createElement(ContactPerson, {
    id: "contactPerson",
    classname: css$9.contactPerson__menu,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    defaultFormSlug: defaultFormSlug,
    select_contact_view: select_contact_view,
    selectLocationText: selectLocationText,
    selectPlaceholderText: selectPlaceholderText,
    noContactFoundText: noContactFoundText,
    changeLocationText: changeLocationText,
    sendMessageText: sendMessageText,
    locationDescriptionText: locationDescriptionText,
    zipCodePlaceholderText: zipCodePlaceholderText,
    locationErrorText: locationErrorText,
    contact_link: contact_link,
    locale: country,
    middlewareBaseURL: middlewareBaseURL
  })));
};

var NavigationBar = function NavigationBar(_ref) {
  var navigation = _ref.navigation,
    with_contact = _ref.with_contact,
    myContactLabel = _ref.myContactLabel,
    defaultFormSlug = _ref.defaultFormSlug,
    select_contact_view = _ref.select_contact_view,
    overViewLinkText = _ref.overViewLinkText,
    selectLocationText = _ref.selectLocationText,
    selectPlaceholderText = _ref.selectPlaceholderText,
    noContactFoundText = _ref.noContactFoundText,
    changeLocationText = _ref.changeLocationText,
    sendMessageText = _ref.sendMessageText,
    locationDescriptionText = _ref.locationDescriptionText,
    zipCodePlaceholderText = _ref.zipCodePlaceholderText,
    locationErrorText = _ref.locationErrorText,
    findOutMoreText = _ref.findOutMoreText,
    contact_link = _ref.contact_link,
    countrySwitchNav = _ref.countrySwitchNav,
    country = _ref.country,
    openCountrySwitchModal = _ref.openCountrySwitchModal,
    with_country_switch = _ref.with_country_switch,
    middlewareBaseURL = _ref.middlewareBaseURL,
    locale = _ref.locale,
    asPath = _ref.asPath,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? ComponentVersion.v1 : _ref$version;
  var _useNavigation = useNavigation(),
    isNavigationOpen = _useNavigation.isNavigationOpen,
    isContactPersonOpen = _useNavigation.isContactPersonOpen;
  var countryCode = (country === null || country === void 0 ? void 0 : country.split('-')[1]) || 'de-de';
  var language = (country === null || country === void 0 ? void 0 : country.split('-')[0]) || '';
  var toggleCountrySwitch = function toggleCountrySwitch() {
    openCountrySwitchModal(function (prevState) {
      return !prevState;
    });
  };
  var isIgusEU = isIgusEuDomain(country || '');
  var countrySwitchHeader = igusEuDomainHeader(country || '', countryCode, language);
  return /*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames('main-navigation-wrapper', css$d.nav_bar__wrapper, conditionalClassname(isNavigationOpen, css$d.nav_bar__wrapper_open), conditionalClassname(Boolean(isContactPersonOpen), css$d.contactPerson__menu), conditionalClassname(isPreferredVersion(ComponentVersion.v2, version), css$d.nav_bar__wrapper_v2))
  }, /*#__PURE__*/React.createElement(Container, {
    className: css$d.mobile__navheader
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("nav", {
    className: css$d.header__wrapper
  }, /*#__PURE__*/React.createElement(BurgerButton, null), /*#__PURE__*/React.createElement(Link, {
    variant: LinkVariant.Secondary,
    target: TargetValues.Top,
    title: "Home",
    href: "/",
    external: false,
    className: css$d.header_logo__wrapper,
    isNav: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IgusLogo, null), /*#__PURE__*/React.createElement(MotionPlasticsLogo, {
    className: css$d.nav__item_logo
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames(conditionalClassname(isPreferredVersion(ComponentVersion.v2, version), css$d.nav_version2))
  }, /*#__PURE__*/React.createElement(Container, {
    className: css$d.nav_bar,
    version: version
  }, /*#__PURE__*/React.createElement(Row, {
    className: css$d.nav_bar_content__wrapper
  }, navigation && (/*#__PURE__*/React.createElement(Col, {
    xs: 12,
    className: css$d.nav_group__wrapper
  }, /*#__PURE__*/React.createElement(Navigation, {
    with_contact: with_contact,
    navigation: navigation,
    myContactLabel: myContactLabel,
    defaultFormSlug: defaultFormSlug,
    select_contact_view: select_contact_view,
    overViewLinkText: overViewLinkText,
    selectLocationText: selectLocationText,
    selectPlaceholderText: selectPlaceholderText,
    noContactFoundText: noContactFoundText,
    changeLocationText: changeLocationText,
    sendMessageText: sendMessageText,
    locationDescriptionText: locationDescriptionText,
    zipCodePlaceholderText: zipCodePlaceholderText,
    locationErrorText: locationErrorText,
    findOutMoreText: findOutMoreText,
    contact_link: contact_link,
    openCountrySwitchModal: openCountrySwitchModal,
    country: country,
    with_country_switch: with_country_switch,
    middlewareBaseURL: middlewareBaseURL,
    locale: locale,
    asPath: asPath,
    version: version
  })))))), with_country_switch && (/*#__PURE__*/React.createElement("div", {
    className: "".concat(css$d.country_switcher__mobile_wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: css$d.country_switcher_mobile__display
  }, countrySwitchNav, " :", /*#__PURE__*/React.createElement("button", {
    className: css$d.country_switcher_button,
    onClick: toggleCountrySwitch,
    title: "".concat(countrySwitchHeader.country.toUpperCase(), "(").concat(countrySwitchHeader.language.toUpperCase(), ")")
  }, !isIgusEU && (/*#__PURE__*/React.createElement("img", {
    src: getFlagUrl(countryCode),
    alt: "".concat(countryCode, " flags"),
    width: 24,
    height: 16,
    className: css$d.country__flag
  })), "".concat(countrySwitchHeader.country.toUpperCase(), " (").concat(countrySwitchHeader.language.toUpperCase(), ")"))))));
};

var css$8 = {"process__horizontal_swiper":"Process-module_process__horizontal_swiper__GLN9S","process__element":"Process-module_process__element__clQnP","process__slider":"Process-module_process__slider__eREdg","process__arrow_left":"Process-module_process__arrow_left__6tJj4","process__arrow_right":"Process-module_process__arrow_right__KGd1O","process__arrows":"Process-module_process__arrows__zYQqF","process__arrows_text":"Process-module_process__arrows_text__1zZQk","process__element_headline":"Process-module_process__element_headline__0Rb51","process__horizontal":"Process-module_process__horizontal__OesJl","process__horizontal_grid":"Process-module_process__horizontal_grid__Bi9qm","process__intro_text":"Process-module_process__intro_text__VVn0C","process__horizontal_text_wrapper":"Process-module_process__horizontal_text_wrapper__dVvnF","process__vertical_icon":"Process-module_process__vertical_icon__ZJk-7","process__vertical_icon_marker":"Process-module_process__vertical_icon_marker__wiPq7","process__element_button_wrapper":"Process-module_process__element_button_wrapper__PJtnC","process__horizontal_pagination":"Process-module_process__horizontal_pagination__YFqae","process__horizontal_slide":"Process-module_process__horizontal_slide__YwAuY","process__pagination":"Process-module_process__pagination__UVVYf","process__horizontal_headline_wrapper":"Process-module_process__horizontal_headline_wrapper__SFGxC","process__asset_wrapper":"Process-module_process__asset_wrapper__fM6a5","process__asset_wrapper_large":"Process-module_process__asset_wrapper_large__HMvG1","process__asset_wrapper_small":"Process-module_process__asset_wrapper_small__SR9xd","process__asset_wrapper_horizontal":"Process-module_process__asset_wrapper_horizontal__1UUi8","process__element_headline_wrapper":"Process-module_process__element_headline_wrapper__nKvLQ","process__element_no_icon":"Process-module_process__element_no_icon__2Ub9n","process__horizontal_icon_wrapper":"Process-module_process__horizontal_icon_wrapper__zybV1","icon__font":"Process-module_icon__font__o4qgW","icon__font__vertical":"Process-module_icon__font__vertical__Dce7B","process__element_wrapper":"Process-module_process__element_wrapper__4OZO5","process__element_button":"Process-module_process__element_button__UDMr0","process__element_headline_short":"Process-module_process__element_headline_short__eiynC","process__arrows_text__vertical":"Process-module_process__arrows_text__vertical__imlzH","process__horizontal_textimage_wrapper":"Process-module_process__horizontal_textimage_wrapper__EEH-g","process__horizontal_textimage_wrapper_noasset":"Process-module_process__horizontal_textimage_wrapper_noasset__61hWL","process__horizontal_icon":"Process-module_process__horizontal_icon__yTpfO","process__asset_wrapper_vertical":"Process-module_process__asset_wrapper_vertical__lhk3t","process__asset":"Process-module_process__asset__dCECs","process__asset_wrapper_vertical_large":"Process-module_process__asset_wrapper_vertical_large__YC2qi","process__asset_wrapper_horizontal_large":"Process-module_process__asset_wrapper_horizontal_large__3vbTh","process__asset_wrapper_vertical_small":"Process-module_process__asset_wrapper_vertical_small__Zq6Si","process__asset_wrapper_horizontal_small":"Process-module_process__asset_wrapper_horizontal_small__vVGJn"};

var ProcessImageHeight;
(function (ProcessImageHeight) {
  ProcessImageHeight["LARGE"] = "large";
  ProcessImageHeight["SMALL"] = "small";
})(ProcessImageHeight || (ProcessImageHeight = {}));
function getVideoRatio(assetRatio) {
  return assetRatio === ProcessImageHeight.LARGE ? '3/2' : '5/2';
}
var ProcessAssets = function ProcessAssets(_ref) {
  var asset = _ref.asset,
    caption = _ref.caption,
    isVertical = _ref.isVertical,
    assetRatio = _ref.assetRatio;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
  if (!hasAssetData(asset, MediaType.IMAGE) && !hasAssetData(asset, MediaType.VIDEO) && !hasAssetData(asset, MediaType.YOUTUBE)) return /*#__PURE__*/React.createElement(React.Fragment, null);
  var renderAssetSrc = getLocalAssetSrc(asset);
  return /*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames(css$8.process__asset_wrapper, conditionalClassname(!isVertical, css$8.process__asset_wrapper_horizontal), conditionalClassname(!isVertical, css$8.process__asset_wrapper_horizontal), conditionalClassname(!!isVertical, css$8.process__asset_wrapper_vertical), conditionalClassname(assetRatio === ProcessImageHeight.LARGE, css$8.process__asset_wrapper_vertical_large), conditionalClassname(assetRatio === ProcessImageHeight.SMALL, css$8.process__asset_wrapper_vertical_small), conditionalClassname(assetRatio === ProcessImageHeight.LARGE, css$8.process__asset_wrapper_large), conditionalClassname(assetRatio === ProcessImageHeight.SMALL, css$8.process__asset_wrapper_small), conditionalClassname(!isVertical && assetRatio === ProcessImageHeight.LARGE, css$8.process__asset_wrapper_horizontal_large), conditionalClassname(!isVertical && assetRatio === ProcessImageHeight.SMALL, css$8.process__asset_wrapper_horizontal_small))
  }, hasAssetData(asset, MediaType.IMAGE) && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
    src: "".concat(renderAssetSrc),
    alt: "".concat(asset.length ? (_a = asset[0]) === null || _a === void 0 ? void 0 : _a.alt_text : ''),
    imageSizes: isVertical ? verticalImageSrcSetSizes[assetRatio || 'large'] : horizontalImageSrcSetSizes[assetRatio || 'large'],
    sizes: isVertical ? imageSizes$1.vertical.sizes : imageSizes$1.horizontal.sizes,
    className: css$8.process__asset,
    copyrightText: (_b = asset[0]) === null || _b === void 0 ? void 0 : _b.copyright
  }), caption && /*#__PURE__*/React.createElement(Caption, {
    text: caption
  }))), hasAssetData(asset, MediaType.VIDEO) && ((_c = asset[0]) === null || _c === void 0 ? void 0 : _c.video) && (/*#__PURE__*/React.createElement(Videos, {
    controls: true,
    preload: 'none',
    width: "100%",
    aspectRatio: getVideoRatio(assetRatio || ''),
    src: renderAssetSrc,
    title: (_f = (_e = (_d = asset[0]) === null || _d === void 0 ? void 0 : _d.video) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.alt_text,
    thumbnailUrl: ((_h = (_g = asset[0]) === null || _g === void 0 ? void 0 : _g.preview_image) === null || _h === void 0 ? void 0 : _h.length) && ((_l = (_k = (_j = asset[0]) === null || _j === void 0 ? void 0 : _j.preview_image[0]) === null || _k === void 0 ? void 0 : _k.image) === null || _l === void 0 ? void 0 : _l.item) ? (_r = (_q = (_p = (_o = (_m = asset[0]) === null || _m === void 0 ? void 0 : _m.preview_image[0]) === null || _o === void 0 ? void 0 : _o.image) === null || _p === void 0 ? void 0 : _p.item) === null || _q === void 0 ? void 0 : _q.focal_embed_link) !== null && _r !== void 0 ? _r : (_v = (_u = (_t = (_s = asset[0]) === null || _s === void 0 ? void 0 : _s.preview_image[0]) === null || _t === void 0 ? void 0 : _t.image) === null || _u === void 0 ? void 0 : _u.item) === null || _v === void 0 ? void 0 : _v.embed_link : ((_0 = (_z = (_y = (_x = (_w = asset === null || asset === void 0 ? void 0 : asset[0]) === null || _w === void 0 ? void 0 : _w.local_video) === null || _x === void 0 ? void 0 : _x[0]) === null || _y === void 0 ? void 0 : _y.video) === null || _z === void 0 ? void 0 : _z.item) === null || _0 === void 0 ? void 0 : _0.thumbnail_link) || ((_3 = (_2 = (_1 = asset[0]) === null || _1 === void 0 ? void 0 : _1.video) === null || _2 === void 0 ? void 0 : _2.item) === null || _3 === void 0 ? void 0 : _3.thumbnail_link),
    caption: caption,
    background: (_5 = (_4 = asset[0]) === null || _4 === void 0 ? void 0 : _4.video) === null || _5 === void 0 ? void 0 : _5.color
  })), hasAssetData(asset, MediaType.YOUTUBE) && ((_6 = asset[0]) === null || _6 === void 0 ? void 0 : _6.youtube_id) && (/*#__PURE__*/React.createElement(Videos, {
    width: "100%",
    aspectRatio: getVideoRatio(assetRatio || ''),
    title: '',
    youtubeId: renderAssetSrc,
    caption: caption
  })));
};

function getSlideTitle(_ref) {
  var realIndex = _ref.realIndex,
    processElements = _ref.processElements;
  var _a, _b;
  if (processElements && processElements.length > 0) {
    var end = realIndex - 1 === -1 ? processElements.length - 1 : realIndex - 1;
    var start = realIndex === processElements.length - 1 ? 0 : realIndex + 1;
    return {
      next: "".concat(((_a = processElements[start]) === null || _a === void 0 ? void 0 : _a.title) || '0'),
      previous: "".concat(((_b = processElements[end]) === null || _b === void 0 ? void 0 : _b.title) || '0')
    };
  }
  return {
    next: "0",
    previous: "0"
  };
}

var ProcessHorizontal = function ProcessHorizontal(_ref) {
  var text = _ref.text,
    process_element = _ref.process_element,
    hide_timeline = _ref.hide_timeline,
    _uid = _ref._uid,
    asset_ratio = _ref.asset_ratio;
  var swiperRef = useRef();
  var _useState = useState({
      next: '0',
      previous: '0'
    }),
    slideIndex = _useState[0],
    setSlideIndex = _useState[1];
  var a11yData = a11yMessages('Process');
  var iconSizes = [{
    width: 64,
    height: 64
  }];
  return /*#__PURE__*/React.createElement(Container, {
    className: css$8.process__horizontal
  }, /*#__PURE__*/React.createElement(Row, {
    className: css$8.process__intro_text
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  })))), process_element.length >= 3 && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: css$8.process__horizontal_grid
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    },
    className: css$8.process__arrows
  }, /*#__PURE__*/React.createElement(SliderArrow, {
    className: css$8.process__arrow_left,
    direction: "left",
    clickHandler: function clickHandler() {}
  }), /*#__PURE__*/React.createElement("span", {
    className: chainConditionalClassnames(css$8.process__arrows_text, conditionalClassname(slideIndex.previous.trim().length > 2, css$8.process__arrows_text__vertical))
  }, slideIndex.previous)), /*#__PURE__*/React.createElement(Swiper, {
    key: hide_timeline === null || hide_timeline === void 0 ? void 0 : hide_timeline.toString(),
    className: css$8.process__horizontal_swiper,
    setWrapperSize: true,
    loop: true,
    effect: 'creative',
    creativeEffect: {
      next: {
        translate: ['100%', 0, 0]
      }
    },
    slidesPerView: 1,
    onBeforeInit: function onBeforeInit(swiper) {
      swiperRef.current = swiper;
    },
    onInit: function onInit(swiperRef) {
      var slideElement = getSlideTitle({
        realIndex: swiperRef.realIndex,
        processElements: process_element
      });
      setSlideIndex({
        next: slideElement.next,
        previous: slideElement.previous
      });
    },
    onSlideChangeTransitionEnd: function onSlideChangeTransitionEnd(swiperRef) {
      var slideElement = getSlideTitle({
        realIndex: swiperRef.realIndex,
        processElements: process_element
      });
      setSlideIndex({
        next: slideElement.next,
        previous: slideElement.previous
      });
    },
    modules: [Pagination, EffectCreative, A11y],
    pagination: {
      clickable: !hide_timeline,
      el: ".swiper-pagination-".concat(_uid),
      renderBullet: function renderBullet(index, className) {
        var _a;
        return "<span class='".concat(css$8.process__pagination, " ").concat(className, "'>").concat((_a = process_element[index]) === null || _a === void 0 ? void 0 : _a.title, "</span>");
      }
    },
    observer: true,
    a11y: a11yData
  }, process_element.map(function (element, index) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: "".concat(element === null || element === void 0 ? void 0 : element.title, "-").concat(index),
      className: css$8.process__horizontal_slide
    }, /*#__PURE__*/React.createElement(Col, {
      className: css$8.process__slider,
      xs: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: css$8.process__horizontal_headline_wrapper
    }, ((_a = element.title_icon[0]) === null || _a === void 0 ? void 0 : _a.icon) && ((_b = element.title_icon[0]) === null || _b === void 0 ? void 0 : _b.component) === 'icon_atom' && (/*#__PURE__*/React.createElement(IconFont, {
      icon: (_c = element.title_icon[0]) === null || _c === void 0 ? void 0 : _c.icon,
      className: css$8.icon__font
    })), hasAssetData(element.title_icon, MediaType.IMAGE) && (/*#__PURE__*/React.createElement("span", {
      className: css$8.process__horizontal_icon_wrapper
    }, /*#__PURE__*/React.createElement(Image, {
      src: "".concat(((_f = (_e = (_d = element === null || element === void 0 ? void 0 : element.title_icon[0]) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.embed_link) || ((_j = (_h = (_g = element === null || element === void 0 ? void 0 : element.title_icon[0]) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.focal_embed_link)),
      alt: "".concat(((_k = element === null || element === void 0 ? void 0 : element.title_icon[0]) === null || _k === void 0 ? void 0 : _k.alt_text) || 'Process Icon'),
      className: css$8.process__horizontal_icon,
      imageSizes: iconSizes
    }))), (element === null || element === void 0 ? void 0 : element.title) && !(element === null || element === void 0 ? void 0 : element.hide_title) && (/*#__PURE__*/React.createElement(Headline, {
      className: css$8.process__element_headline,
      tag: 'h3',
      hasAnchor: false,
      variant: element.variant
    }, element.title))), /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$8.process__horizontal_textimage_wrapper, " ").concat(element.asset.length > 0 ? '' : css$8.process__horizontal_textimage_wrapper_noasset)
    }, /*#__PURE__*/React.createElement("div", {
      className: css$8.process__horizontal_text_wrapper
    }, hasTextContent(element === null || element === void 0 ? void 0 : element.text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
      hasAnchor: false,
      content: mappedProps(element === null || element === void 0 ? void 0 : element.text.content)
    })), element && element.button && ((_l = element.button) === null || _l === void 0 ? void 0 : _l.length) > 0 && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      className: css$8.process__element_button_wrapper
    }, (_m = element.button) === null || _m === void 0 ? void 0 : _m.map(function (linkElement) {
      return /*#__PURE__*/React.createElement(RenderButtonType, {
        key: linkElement._uid,
        linkType: linkElement
      });
    }))))), /*#__PURE__*/React.createElement(ProcessAssets, {
      asset: element.asset,
      caption: element.caption,
      assetRatio: asset_ratio
    }))));
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var _a;
      return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    },
    className: css$8.process__arrows
  }, /*#__PURE__*/React.createElement("span", {
    className: chainConditionalClassnames(css$8.process__arrows_text, conditionalClassname(slideIndex.next.trim().length > 2, css$8.process__arrows_text__vertical))
  }, slideIndex.next), /*#__PURE__*/React.createElement(SliderArrow, {
    className: css$8.process__arrow_right,
    direction: "right",
    clickHandler: function clickHandler() {}
  }))), /*#__PURE__*/React.createElement(Row, {
    className: css$8.process__horizontal_pagination
  }, !hide_timeline && (/*#__PURE__*/React.createElement("div", {
    className: "process__pagination swiper-pagination-".concat(_uid, " swiper-pagination"),
    slot: 'pagination'
  }))))));
};

var ProcessVertical = function ProcessVertical(_ref) {
  var text = _ref.text,
    process_element = _ref.process_element,
    _uid = _ref._uid,
    asset_ratio = _ref.asset_ratio;
  var iconSizes = [{
    width: 48,
    height: 48
  }];
  return /*#__PURE__*/React.createElement(Container, {
    className: css$8.process__vertical,
    spacingWithSeparator: true
  }, /*#__PURE__*/React.createElement(Row, {
    className: css$8.process__intro_text
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text === null || text === void 0 ? void 0 : text.content)
  })))), /*#__PURE__*/React.createElement("div", {
    className: css$8.process__element_wrapper
  }, process_element.map(function (element, index) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "".concat(element.title, "-").concat(index)
    }, /*#__PURE__*/React.createElement(Col, {
      key: _uid,
      className: css$8.process__element,
      xs: 12,
      md: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: css$8.process__element_headline_wrapper
    }, ((_a = element.title_icon[0]) === null || _a === void 0 ? void 0 : _a.icon) && ((_b = element.title_icon[0]) === null || _b === void 0 ? void 0 : _b.component) === 'icon_atom' && (/*#__PURE__*/React.createElement("div", {
      className: css$8.process__vertical_icon
    }, /*#__PURE__*/React.createElement(IconFont, {
      icon: (_c = element.title_icon[0]) === null || _c === void 0 ? void 0 : _c.icon,
      className: css$8.icon__font__vertical
    }))), element.title_icon[0] && hasAssetData(element.title_icon, MediaType.IMAGE) && (/*#__PURE__*/React.createElement("span", {
      className: css$8.process__vertical_icon_wrapper
    }, /*#__PURE__*/React.createElement(Image, {
      src: "".concat(((_f = (_e = (_d = element === null || element === void 0 ? void 0 : element.title_icon[0]) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.embed_link) || ((_j = (_h = (_g = element === null || element === void 0 ? void 0 : element.title_icon[0]) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.focal_embed_link)),
      alt: "".concat(((_k = element === null || element === void 0 ? void 0 : element.title_icon[0]) === null || _k === void 0 ? void 0 : _k.alt_text) || 'Process Icon'),
      className: css$8.process__vertical_icon,
      imageSizes: iconSizes
    }))), (element === null || element === void 0 ? void 0 : element.title) && !(element === null || element === void 0 ? void 0 : element.hide_title) && (/*#__PURE__*/React.createElement(Headline, {
      className: "".concat(css$8.process__element_headline, " ").concat(element.title.length <= 2 ? css$8.process__element_headline_short : '', " ").concat(!element.title_icon[0] ? css$8.process__element_no_icon : ''),
      tag: 'h3',
      hasAnchor: false,
      variant: element.variant
    }, element.title)), /*#__PURE__*/React.createElement("span", {
      className: css$8.process__vertical_icon_marker
    })), hasTextContent(element === null || element === void 0 ? void 0 : element.text) && (/*#__PURE__*/React.createElement(RichTextRenderer, {
      hasAnchor: false,
      content: mappedProps(element === null || element === void 0 ? void 0 : element.text.content)
    })), element && element.button && ((_l = element.button) === null || _l === void 0 ? void 0 : _l.length) > 0 && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      className: css$8.process__element_button_wrapper
    }, (_m = element.button) === null || _m === void 0 ? void 0 : _m.map(function (linkElement) {
      return /*#__PURE__*/React.createElement(RenderButtonType, {
        className: css$8.process__element_button,
        key: linkElement._uid,
        linkType: linkElement
      });
    })))), /*#__PURE__*/React.createElement(ProcessAssets, {
      asset: element.asset,
      caption: element.caption,
      isVertical: true,
      assetRatio: asset_ratio
    })));
  })));
};

var Process = function Process(_ref) {
  var text = _ref.text,
    process_element = _ref.process_element,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? true : _ref$layout,
    hide_timeline = _ref.hide_timeline,
    _uid = _ref._uid,
    asset_ratio = _ref.asset_ratio;
  if (!layout) return /*#__PURE__*/React.createElement(ProcessHorizontal, {
    _uid: _uid,
    hide_timeline: hide_timeline,
    text: text,
    process_element: process_element,
    asset_ratio: asset_ratio
  });
  return /*#__PURE__*/React.createElement(ProcessVertical, {
    _uid: _uid,
    text: text,
    process_element: process_element,
    asset_ratio: asset_ratio
  });
};

var css$7 = {"customGridWrapper":"RssFeed-module_customGridWrapper__qT6yt","twoColumnTeaser":"RssFeed-module_twoColumnTeaser__aFXtt"};

var renderRssTeaserTypeData = function renderRssTeaserTypeData(teaser) {
  var _a;
  var teaserData = (_a = teaser === null || teaser === void 0 ? void 0 : teaser.map(function (item) {
    var _a, _b, _c;
    return {
      links: (_a = item === null || item === void 0 ? void 0 : item.links) === null || _a === void 0 ? void 0 : _a.map(function (linkData) {
        return linkPropsMapper(linkData);
      }),
      asset: (_b = item === null || item === void 0 ? void 0 : item.asset) !== null && _b !== void 0 ? _b : [],
      headline: (_c = item === null || item === void 0 ? void 0 : item.headline) !== null && _c !== void 0 ? _c : '',
      text: item === null || item === void 0 ? void 0 : item.text,
      video_duration: item.video_duration,
      created_at: item.created_at
    };
  })) !== null && _a !== void 0 ? _a : [];
  return teaserData;
};
var trimVideoDuration = function trimVideoDuration(duration) {
  if ((duration === null || duration === void 0 ? void 0 : duration.split(':')[0]) === '00') {
    return duration.replace('00:', '');
  }
  return duration;
};
var extractDate = function extractDate(dateTime) {
  var date = new Date("".concat(dateTime));
  var formattedDate = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date);
  return formattedDate || '';
};
var mappedRssFeedItems = function mappedRssFeedItems(items) {
  var hideDescription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var teasers = items.map(function (_ref) {
    var title = _ref.title,
      description = _ref.description,
      featured_image = _ref.featured_image,
      guid = _ref.guid,
      video_duration = _ref.video_duration,
      created_at = _ref.created_at,
      link_text = _ref.link_text;
    return {
      headline: title,
      text: !hideDescription ? {
        content: [{
          type: 'paragraph',
          content: [{
            text: description,
            type: 'text'
          }]
        }]
      } : {},
      asset: [{
        image: {
          item: {
            embed_link: featured_image.trim()
          }
        },
        alt_text: title
      }],
      links: [{
        link: {
          url: "".concat(guid.trim()),
          linktype: 'url',
          cached_url: "".concat(guid),
          target: TargetValues.Blank
        },
        variant: LinkVariant.Primary,
        name: link_text
      }],
      video_duration: trimVideoDuration(video_duration),
      created_at: created_at || ''
    };
  });
  return teasers;
};
var getRSSFeed = function getRSSFeed(url) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var urlWithProtocol, response, xmlText, parser, xml, items, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          urlWithProtocol = url.includes('https://') ? url : "https://".concat(url);
          _context.prev = 1;
          _context.next = 4;
          return fetch("".concat(urlWithProtocol));
        case 4:
          response = _context.sent;
          if (response.ok) {
            _context.next = 7;
            break;
          }
          throw new Error("Failed to fetch RSS");
        case 7:
          _context.next = 9;
          return response.text();
        case 9:
          xmlText = _context.sent;
          parser = new DOMParser();
          xml = parser.parseFromString(xmlText, 'application/xml');
          items = xml.querySelectorAll('item');
          data = Array.from(items).map(function (item) {
            var _a, _b, _c, _d, _e, _f, _g;
            return {
              title: ((_a = item.querySelector('title')) === null || _a === void 0 ? void 0 : _a.textContent) || '',
              description: ((_b = item.querySelector('description')) === null || _b === void 0 ? void 0 : _b.textContent) || '',
              guid: ((_c = item.querySelector('guid')) === null || _c === void 0 ? void 0 : _c.textContent) || '',
              featured_image: ((_d = item.querySelector('featured_image')) === null || _d === void 0 ? void 0 : _d.textContent) || '',
              video_duration: ((_e = item.querySelector('video_duration')) === null || _e === void 0 ? void 0 : _e.textContent) || '',
              created_at: ((_f = item.querySelector('pubDate')) === null || _f === void 0 ? void 0 : _f.textContent) || '',
              link_text: ((_g = item.querySelector('ctaTextLink')) === null || _g === void 0 ? void 0 : _g.textContent) || ''
            };
          });
          return _context.abrupt("return", data);
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](1);
          console.error('Error fetching RSS:', _context.t0);
          throw _context.t0;
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 17]]);
  }));
};
var getAndSetRssData = function getAndSetRssData(url_1, setRssData_1, setError_1) {
  for (var _len = arguments.length, args_1 = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args_1[_key - 3] = arguments[_key];
  }
  return __awaiter(void 0, [url_1, setRssData_1, setError_1].concat(args_1), void 0, function (url, setRssData, setError) {
    var maxTeaser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
    var hideDescription = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var data, teasers;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return getRSSFeed(url);
          case 3:
            data = _context2.sent;
            teasers = mappedRssFeedItems(data.slice(0, maxTeaser), hideDescription);
            setRssData(teasers);
            setError('');
            _context2.next = 13;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            setError('Error fetching RSS');
            console.error('Error fetching RSS', _context2.t0);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 9]]);
    })();
  });
};

var css$6 = {"asset__wrapper":"RssTeaserAsset-module_asset__wrapper__WLaJi","asset__wrapper_large":"RssTeaserAsset-module_asset__wrapper_large__QM-Zl","asset__wrapper_small":"RssTeaserAsset-module_asset__wrapper_small__4f-Xo","richtext__wrapper":"RssTeaserAsset-module_richtext__wrapper__EpJYm","link":"RssTeaserAsset-module_link__AfvCB","link__wrapper":"RssTeaserAsset-module_link__wrapper__TYMYD","link__icon__primary":"RssTeaserAsset-module_link__icon__primary__4DTX6","teaser__bottom":"RssTeaserAsset-module_teaser__bottom__PmKdo","headline":"RssTeaserAsset-module_headline__orwRj","teaser__content":"RssTeaserAsset-module_teaser__content__bZ2C7","subgrid":"RssTeaserAsset-module_subgrid__fARS5","teaser__body":"RssTeaserAsset-module_teaser__body__TxIg5","asset__image":"RssTeaserAsset-module_asset__image__-R8eK","asset__link":"RssTeaserAsset-module_asset__link__hhHYM","video_duration":"RssTeaserAsset-module_video_duration__KY2V2","video__play_icon":"RssTeaserAsset-module_video__play_icon__AJuB3","created_at__wrapper":"RssTeaserAsset-module_created_at__wrapper__37sai","img_shadow__micro":"RssTeaserAsset-module_img_shadow__micro__KiTK8","asset__fullwidth":"RssTeaserAsset-module_asset__fullwidth__pPtJQ","asset__halfwidth":"RssTeaserAsset-module_asset__halfwidth__0v2-x","asset__fallback":"RssTeaserAsset-module_asset__fallback__O3zMu","richtext__wrapper__half__image":"RssTeaserAsset-module_richtext__wrapper__half__image__qnanm"};

var RssTeaserAsset = function RssTeaserAsset(_ref) {
  var asset = _ref.asset,
    view = _ref.view,
    image_position = _ref.image_position,
    assetRatio = _ref.assetRatio,
    video_duration = _ref.video_duration,
    link = _ref.link;
  var _a, _b, _c, _d, _e, _f, _g;
  if (asset && ((_a = asset[0]) === null || _a === void 0 ? void 0 : _a.image)) {
    var imageElement = /*#__PURE__*/React.createElement(Image, {
      src: "".concat(((_b = asset[0]) === null || _b === void 0 ? void 0 : _b.image.item.focal_embed_link) || ((_e = (_d = (_c = asset[0]) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.item) === null || _e === void 0 ? void 0 : _e.embed_link)),
      alt: "".concat(asset.length ? (_f = asset[0]) === null || _f === void 0 ? void 0 : _f.alt_text : 'Igus Product'),
      className: "".concat(css$6.asset__image, " ").concat(css$6.img_shadow__micro),
      imageSizes: isFullWidth(image_position) ? fullWidthTwoColumnImageSizes[assetRatio !== null && assetRatio !== void 0 ? assetRatio : 'large'] : (_g = columnViewSizes[getColumnView(view)]) === null || _g === void 0 ? void 0 : _g[assetRatio !== null && assetRatio !== void 0 ? assetRatio : 'large'],
      sizes: isFullWidth(image_position) ? fullWidthSizes[ColumnView.Two] : sizes[view]
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(css$6.asset__wrapper, " ").concat(checkImagePosition(view, image_position) ? css$6.asset__halfwidth : css$6.asset__fullwidth, " ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === TeaserAssetImageHeight.LARGE, css$6.asset__wrapper_large), conditionalClassname(assetRatio === TeaserAssetImageHeight.SMALL, css$6.asset__wrapper_small)))
    }, link ? (/*#__PURE__*/React.createElement(Link, {
      external: link.external,
      href: link.href,
      title: link.title,
      variant: link.variant,
      icon: link.icon,
      target: link.target,
      className: css$6.asset__link,
      showExternalIcon: false
    }, imageElement)) : imageElement, video_duration && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      "aria-label": "Video play button icon",
      className: css$6.video__play_icon
    }), /*#__PURE__*/React.createElement("span", {
      "aria-label": "Video duration: ".concat(video_duration),
      className: css$6.video_duration
    }, video_duration))));
  }
  return /*#__PURE__*/React.createElement(FallbackImage, {
    className: "".concat(css$6.asset__wrapper, " ").concat(checkImagePosition(view, image_position) ? css$6.asset__halfwidth : css$6.asset__fullwidth, " ").concat(css$6.asset__fallback, "\n       ").concat(chainConditionalClassnames(conditionalClassname(assetRatio === TeaserAssetImageHeight.LARGE, css$6.asset__wrapper_large), conditionalClassname(assetRatio === TeaserAssetImageHeight.SMALL, css$6.asset__wrapper_small)), "  \n      ")
  });
};
var RssTwoColumnTeaser = function RssTwoColumnTeaser(_ref2) {
  var view = _ref2.view,
    image_position = _ref2.image_position,
    headline = _ref2.headline,
    asset = _ref2.asset,
    text = _ref2.text,
    checkColumnView = _ref2.checkColumnView,
    mappedLinks = _ref2.mappedLinks,
    assetRatio = _ref2.assetRatio,
    video_duration = _ref2.video_duration,
    created_at = _ref2.created_at;
  var dateTime = new Date("".concat(created_at)).toISOString();
  var formattedDate = extractDate(created_at);
  return /*#__PURE__*/React.createElement("section", {
    className: css$6.subgrid
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$6.teaser__content, " ").concat(checkColumnView ? setImagePosition(image_position) : '', " ").concat(css$6.teaser__body)
  }, /*#__PURE__*/React.createElement(RssTeaserAsset, {
    asset: asset,
    view: view,
    image_position: image_position,
    assetRatio: assetRatio,
    video_duration: video_duration,
    link: mappedLinks === null || mappedLinks === void 0 ? void 0 : mappedLinks[0]
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$6.richtext__wrapper, " ").concat(checkImagePosition(view, image_position) && css$6.richtext__wrapper__half__image)
  }, created_at && (/*#__PURE__*/React.createElement("div", {
    className: css$6.created_at__wrapper
  }, /*#__PURE__*/React.createElement("time", {
    dateTime: dateTime
  }, formattedDate))), headline && (/*#__PURE__*/React.createElement(Headline, {
    className: css$6.headline,
    tag: HeadlineTags.H4
  }, headline)), hasTextContent(text) && text && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })), mappedLinks && (mappedLinks === null || mappedLinks === void 0 ? void 0 : mappedLinks.map(function (linkItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: css$6.link__wrapper,
      key: "".concat(linkItem.title).concat(index)
    }, !buttonVariants.includes(linkItem.variant) && (/*#__PURE__*/React.createElement(LinkIcon, {
      className: css$6.link__icon__primary
    })), (linkItem === null || linkItem === void 0 ? void 0 : linkItem.href) && (/*#__PURE__*/React.createElement(Link, {
      external: linkItem.external,
      href: linkItem.href,
      title: linkItem.title,
      variant: linkItem.variant,
      icon: linkItem.icon,
      target: linkItem.target,
      className: css$6.link,
      piwik_click_id: linkItem === null || linkItem === void 0 ? void 0 : linkItem.piwik_click_id,
      anchor: linkItem === null || linkItem === void 0 ? void 0 : linkItem.anchor
    }, linkItem.title)));
  })))));
};
var RssTeaser = function RssTeaser(_ref3) {
  var view = _ref3.view,
    image_position = _ref3.image_position,
    headline = _ref3.headline,
    asset = _ref3.asset,
    text = _ref3.text,
    mappedLinks = _ref3.mappedLinks,
    assetRatio = _ref3.assetRatio,
    video_duration = _ref3.video_duration,
    created_at = _ref3.created_at;
  var dateTime = created_at !== '' ? new Date("".concat(created_at)).toISOString() : '';
  var formattedDate = created_at !== '' ? extractDate(created_at) : '';
  return /*#__PURE__*/React.createElement("section", {
    className: css$6.subgrid
  }, /*#__PURE__*/React.createElement(RssTeaserAsset, {
    asset: asset,
    view: view,
    image_position: image_position,
    assetRatio: assetRatio,
    video_duration: video_duration,
    link: mappedLinks === null || mappedLinks === void 0 ? void 0 : mappedLinks[0]
  }), /*#__PURE__*/React.createElement("div", {
    className: css$6.teaser__body
  }, created_at && (/*#__PURE__*/React.createElement("div", {
    className: css$6.created_at__wrapper
  }, /*#__PURE__*/React.createElement("time", {
    dateTime: dateTime
  }, formattedDate))), headline && (/*#__PURE__*/React.createElement(Headline, {
    className: css$6.headline,
    tag: HeadlineTags.H4
  }, headline)), hasTextContent(text) && text && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })), /*#__PURE__*/React.createElement("div", {
    className: css$6.teaser__bottom
  }, mappedLinks && (mappedLinks === null || mappedLinks === void 0 ? void 0 : mappedLinks.map(function (linkItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: css$6.link__wrapper,
      key: "".concat(linkItem.title).concat(index)
    }, /*#__PURE__*/React.createElement(LinkIcon, {
      className: css$6.link__icon__primary
    }), (linkItem === null || linkItem === void 0 ? void 0 : linkItem.href) && (/*#__PURE__*/React.createElement(Link, {
      external: linkItem.external,
      href: linkItem.href,
      title: linkItem.title,
      variant: linkItem.variant,
      icon: linkItem.icon,
      target: linkItem.target,
      className: chainConditionalClassnames(css$6.link, conditionalClassname(buttonVariants.includes(linkItem.variant), css$6.themed__button__width)),
      piwik_click_id: linkItem === null || linkItem === void 0 ? void 0 : linkItem.piwik_click_id,
      anchor: linkItem === null || linkItem === void 0 ? void 0 : linkItem.anchor
    }, linkItem.title)));
  })))));
};

var RssTeaserCard = function RssTeaserCard(_ref) {
  var view = _ref.view,
    image_position = _ref.image_position,
    headline = _ref.headline,
    asset = _ref.asset,
    text = _ref.text,
    links = _ref.links,
    assetRatio = _ref.assetRatio,
    video_duration = _ref.video_duration,
    created_at = _ref.created_at;
  var checkColumnView = Number(view) === 2;
  var twoColumnsTeaser = checkColumnView && image_position !== 'fullwidth';
  var mappedLinks = links;
  if (twoColumnsTeaser) {
    return /*#__PURE__*/React.createElement(RssTwoColumnTeaser, {
      image_position: image_position,
      view: view,
      headline: headline,
      asset: asset,
      checkColumnView: checkColumnView,
      text: text,
      mappedLinks: mappedLinks,
      assetRatio: assetRatio,
      video_duration: video_duration,
      created_at: created_at
    });
  }
  return /*#__PURE__*/React.createElement(RssTeaser, {
    image_position: image_position,
    view: view,
    headline: headline,
    asset: asset,
    text: text,
    mappedLinks: mappedLinks,
    assetRatio: assetRatio,
    video_duration: video_duration,
    created_at: created_at
  });
};

var RssFeed = function RssFeed(_ref) {
  var text = _ref.text,
    separator = _ref.separator,
    url = _ref.url,
    teaser_amount = _ref.teaser_amount,
    image_position = _ref.image_position,
    asset_ratio = _ref.asset_ratio,
    view = _ref.view,
    hide_description = _ref.hide_description;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState([]),
    rssData = _useState[0],
    setRssData = _useState[1];
  var _useState2 = useState(''),
    error = _useState2[0],
    setError = _useState2[1];
  var columnSize = Number(view);
  var DEFAULT_COLUMN_SIZE = 2;
  var twoColumnsTeaser = columnSize === DEFAULT_COLUMN_SIZE && image_position !== 'fullwidth';
  var errorMessage = formatMessage({
    id: 'RSS_FEED_FETCH_ERROR_MESSAGE'
  });
  useEffect(function () {
    getAndSetRssData(url, setRssData, setError, Number(teaser_amount), hide_description);
  }, [url, teaser_amount, hide_description]);
  var teaserRenderData = renderRssTeaserTypeData(rssData);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    spacingWithoutSeparator: !separator
  }, hasTextContent(text) && (/*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(text.content)
  })))), (rssData === null || rssData === void 0 ? void 0 : rssData.length) && !error ? (/*#__PURE__*/React.createElement(Row, {
    className: chainConditionalClassnames(css$7.customGridWrapper, conditionalClassname(twoColumnsTeaser, css$7.twoColumnTeaser), conditionalClassname(!!image_position, css$7.twoColumnTeaser)),
    style: {
      gridTemplateColumns: "repeat(".concat(columnSize, ", 1fr)")
    }
  }, teaserRenderData && teaserRenderData.map(function (teaserItem, index) {
    return /*#__PURE__*/React.createElement(RssTeaserCard, {
      key: "".concat(teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.headline, "-").concat(index),
      image_position: image_position,
      view: view,
      headline: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.headline,
      asset: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.asset,
      links: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.links,
      text: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.text,
      assetRatio: asset_ratio,
      created_at: teaserItem === null || teaserItem === void 0 ? void 0 : teaserItem.created_at,
      video_duration: teaserItem.video_duration
    });
  }))) : (/*#__PURE__*/React.createElement(TeaserPlaceholder, {
    errorMessage: error ? errorMessage : '',
    view: view,
    numberOfTeasers: teaser_amount
  }))), separator && (/*#__PURE__*/React.createElement(Container, {
    spacingWithSeparator: separator
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(Separator, null))))));
};

function ErrorPageIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 1170 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1170",
    height: "292",
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_20230_51537",
    transform: "matrix(0.000676349 0 0 0.00271003 0.245693 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_20230_51537",
    width: "752",
    height: "369",
    xlinkHref: "data:image/png;base64,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"
  })));
}

var css$5 = {"error__header__wrapper":"Error-module_error__header__wrapper__6v0bi","error__content__wrapper":"Error-module_error__content__wrapper__ZCP7q","error__text__wrapper":"Error-module_error__text__wrapper__FiJ2Y","error__input__wrapper":"Error-module_error__input__wrapper__bFiKM","error__footer":"Error-module_error__footer__Zapw-","footer__links__wrapper":"Error-module_footer__links__wrapper__jVM1D","error__footer__high":"Error-module_error__footer__high__fCm9R"};

var CustomError = function CustomError(_ref) {
  var pageIntroProps = _ref.pageIntroProps,
    linkProps = _ref.linkProps,
    footerLinkList = _ref.footerLinkList,
    _ref$showIn404Page = _ref.showIn404Page,
    showIn404Page = _ref$showIn404Page === void 0 ? true : _ref$showIn404Page,
    searchBarPlaceholder = _ref.searchBarPlaceholder;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var router = useRouter();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: css$5.error__header__wrapper
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Link, {
    showExternalIcon: false,
    icon: false,
    title: "Home",
    target: TargetValues.Self,
    href: "/",
    variant: LinkVariant.Secondary,
    external: false
  }, /*#__PURE__*/React.createElement(IgusLogoOrangeVariant, null)))))), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: css$5.error__content__wrapper
  }, /*#__PURE__*/React.createElement(ErrorPageIcon, null), /*#__PURE__*/React.createElement("div", {
    className: css$5.error__text__wrapper
  }, /*#__PURE__*/React.createElement(PageIntro, Object.assign({}, pageIntroProps, {
    style: {
      marginBottom: '0'
    }
  }))), linkProps && showIn404Page && (/*#__PURE__*/React.createElement(RenderButtonType, {
    linkType: linkProps
  })), showIn404Page && (/*#__PURE__*/React.createElement(SearchBar, {
    placeholder: searchBarPlaceholder || '',
    height: 100,
    className: css$5.error__input__wrapper,
    router: router,
    locale: router.locale || 'de-de'
  }))))))), /*#__PURE__*/React.createElement("footer", {
    className: "".concat(css$5.error__footer, " ").concat(conditionalClassname(!showIn404Page, css$5.error__footer__high))
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Separator, null), showIn404Page && footerLinkList && (/*#__PURE__*/React.createElement("div", {
    className: css$5.footer__links__wrapper
  }, /*#__PURE__*/React.createElement(LinkListHorizontal, {
    links: footerLinkList,
    cookieSettingLabel: formatMessage({
      id: 'COOKIE_SETTING_LINK_LABEL'
    })
  }))))))));
};

var css$4 = {"cta":"NewsLetter-module_cta__LD6H4","cta__row":"NewsLetter-module_cta__row__iE-ac","modeLight":"NewsLetter-module_modeLight__CK6g2","modeDark":"NewsLetter-module_modeDark__mPTfX","mb_hidden":"NewsLetter-module_mb_hidden__Ej6Ri","lg__hidden":"NewsLetter-module_lg__hidden__BQvCn","cta__action":"NewsLetter-module_cta__action__wCuHu"};

var css$3 = {"container__apply_padding":"IntroText-module_container__apply_padding__oCQ4O","container":"IntroText-module_container__Atutg","headline--main":"IntroText-module_headline--main__P9pHL","container__dark":"IntroText-module_container__dark__0V8Td"};

var IntroTextVariant;
(function (IntroTextVariant) {
  IntroTextVariant["PRIMARY"] = "primary";
  IntroTextVariant["SECONDARY"] = "secondary";
  IntroTextVariant["TERTIARY"] = "tertiary";
})(IntroTextVariant || (IntroTextVariant = {}));
function IntroText(_ref) {
  var headlineText = _ref.headlineText,
    copyText = _ref.copyText,
    applyPadding = _ref.applyPadding,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? IntroTextVariant.PRIMARY : _ref$variant,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: chainConditionalClassnames(css$3.container, className !== null && className !== void 0 ? className : '', conditionalClassname(variant === IntroTextVariant.SECONDARY, css$3.container__dark), conditionalClassname(applyPadding !== null && applyPadding !== void 0 ? applyPadding : false, css$3.container__apply_padding))
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H2,
    className: chainConditionalClassnames(conditionalClassname(['primary', 'secondary'].includes(variant), css$3['headline--main']))
  }, headlineText), hasTextContent(copyText) && copyText && (/*#__PURE__*/React.createElement(RichTextRenderer, {
    content: mappedProps(copyText.content)
  })));
}

var NewsLetter = function NewsLetter(_ref) {
  var text = _ref.text,
    dark_mode = _ref.dark_mode,
    button_text = _ref.button_text,
    headline = _ref.headline,
    link = _ref.link,
    image = _ref.image;
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var providedImage = Array.isArray(image) && image.length > 0 ? image[0] : null;
  return /*#__PURE__*/React.createElement(Container, {
    version: ComponentVersion.v2,
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$4.cta, " ").concat(dark_mode ? css$4.modeDark : css$4.modeLight)
  }, /*#__PURE__*/React.createElement(Row, {
    className: css$4.cta__row
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 5
  }, /*#__PURE__*/React.createElement(IntroText, {
    headlineText: headline,
    copyText: text,
    variant: dark_mode ? IntroTextVariant.SECONDARY : IntroTextVariant.TERTIARY
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css$4.cta__action, " ").concat(css$4.mb_hidden)
  }, /*#__PURE__*/React.createElement(Link_v2, {
    href: link.url || link.cached_url || '',
    target: TargetValues.Self,
    mode: dark_mode ? 'dark' : 'light',
    variant: LinkVariant.Button,
    icon: true,
    iconPosition: IconPosition.After,
    external: link.linktype === LinkType.Url
  }, button_text))), /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 5
  }, providedImage && providedImage.component === 'image_atom' && (/*#__PURE__*/React.createElement(Image, {
    alt: (_a = providedImage === null || providedImage === void 0 ? void 0 : providedImage.alt_text) !== null && _a !== void 0 ? _a : '',
    src: (_d = (_c = (_b = providedImage === null || providedImage === void 0 ? void 0 : providedImage.image) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.embed_link) !== null && _d !== void 0 ? _d : '',
    sizes: "(max-width: 344px) 33vw, (max-width: 768px) 50vw, (max-width: 939px) 70vw, 1200px",
    imageSizes: sizes$1['169'],
    RoundedCorners: providedImage === null || providedImage === void 0 ? void 0 : providedImage.RoundedCorners,
    copyrightText: providedImage === null || providedImage === void 0 ? void 0 : providedImage.copyright,
    Shadow: providedImage === null || providedImage === void 0 ? void 0 : providedImage.Shadow,
    legend: providedImage === null || providedImage === void 0 ? void 0 : providedImage.legend
  })), providedImage && providedImage.component === 'image_atom_enlarge' && (/*#__PURE__*/React.createElement(ImageEnlarge, {
    imageAltText: (_e = providedImage === null || providedImage === void 0 ? void 0 : providedImage.alt_text) !== null && _e !== void 0 ? _e : '',
    imageUrl: (_h = (_g = (_f = providedImage === null || providedImage === void 0 ? void 0 : providedImage.image) === null || _f === void 0 ? void 0 : _f.item) === null || _g === void 0 ? void 0 : _g.embed_link) !== null && _h !== void 0 ? _h : '',
    enlargeImage: true
  }))), /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    className: css$4.lg__hidden
  }, /*#__PURE__*/React.createElement("div", {
    className: css$4.cta__action
  }, /*#__PURE__*/React.createElement(Link_v2, {
    href: link.url || link.cached_url || '',
    target: TargetValues.Self,
    mode: dark_mode ? 'dark' : 'light',
    variant: LinkVariant.Button,
    icon: true,
    iconPosition: IconPosition.After,
    external: link.linktype === LinkType.Url
  }, button_text))))));
};

var css$2 = {"link":"ApplicationTeaser-module_link__8rYEU","atomMargin":"ApplicationTeaser-module_atomMargin__9vEGr"};

var getStories = function getStories(storiesData, goToLinkText) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var storyblokApi, uuids, stories;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          storyblokApi = getStoryblokApi();
          uuids = storiesData.map(function (data) {
            return data.application;
          });
          _context.next = 4;
          return storyblokApi.getAll('cdn/stories', {
            token: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
            by_uuids: uuids.join(',')
          });
        case 4:
          stories = _context.sent;
          return _context.abrupt("return", transformToTeaserUtil(stories, storiesData, goToLinkText));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var transformToTeaserUtil = function transformToTeaserUtil(stories, storiesData, goToLinkText) {
  return storiesData.map(function (storyData) {
    var _a, _b, _c, _d;
    var existingStory = stories.find(function (story) {
      return story.uuid === storyData.application;
    });
    var image = generateTeaserAsset(existingStory);
    return {
      _uid: storyData._uid,
      subline: (_a = existingStory.content) === null || _a === void 0 ? void 0 : _a.industry_tag.join(', '),
      asset: image,
      links: [{
        _uid: storyData._uid,
        name: goToLinkText,
        variant: LinkVariant.Secondary,
        link: {
          linktype: LinkType.Story,
          url: existingStory.full_slug,
          cached_url: existingStory.full_slug,
          target: TargetValues.Self,
          id: storyData._uid,
          fieldtype: ''
        }
      }],
      text: {
        content: [{
          type: 'heading',
          attrs: {
            level: 4
          },
          content: [{
            type: 'text',
            text: ((_c = (_b = existingStory.content) === null || _b === void 0 ? void 0 : _b.intro[0]) === null || _c === void 0 ? void 0 : _c.headline) || ''
          }]
        }, {
          type: 'paragraph',
          content: [{
            type: 'text',
            text: ((_d = existingStory.content) === null || _d === void 0 ? void 0 : _d.description) || ''
          }]
        }]
      }
    };
  });
};
var generateTeaserAsset = function generateTeaserAsset(story) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  if (_typeof$1((_a = story.content) === null || _a === void 0 ? void 0 : _a.thumbnail) !== 'object' || !((_c = (_b = story.content) === null || _b === void 0 ? void 0 : _b.thumbnail) === null || _c === void 0 ? void 0 : _c.item)) {
    return undefined;
  }
  return [{
    alt_text: ((_d = story.content) === null || _d === void 0 ? void 0 : _d.headline) || '',
    image: {
      item: {
        embed_link: (_g = (_f = (_e = story.content) === null || _e === void 0 ? void 0 : _e.thumbnail) === null || _f === void 0 ? void 0 : _f.item) === null || _g === void 0 ? void 0 : _g.embed_link,
        focal_embed_link: (_k = (_j = (_h = story.content) === null || _h === void 0 ? void 0 : _h.thumbnail) === null || _j === void 0 ? void 0 : _j.item) === null || _k === void 0 ? void 0 : _k.embed_link,
        filename: (_o = (_m = (_l = story.content) === null || _l === void 0 ? void 0 : _l.thumbnail) === null || _m === void 0 ? void 0 : _m.item) === null || _o === void 0 ? void 0 : _o.filename,
        external_id: (_r = (_q = (_p = story.content) === null || _p === void 0 ? void 0 : _p.thumbnail) === null || _q === void 0 ? void 0 : _q.item) === null || _r === void 0 ? void 0 : _r.external_id
      }
    },
    youtube_id: ''
  }];
};

var ApplicationTeaser = function ApplicationTeaser(_ref) {
  var headline = _ref.headline,
    intro_text = _ref.intro_text,
    application = _ref.application,
    view = _ref.view,
    collection_link = _ref.collection_link;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var goToLinkText = formatMessage({
    id: 'GO_TO_APPLICATION_LINK'
  });
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    teasers = _React$useState2[0],
    setTeasers = _React$useState2[1];
  var _useState = useState(false),
    isFetched = _useState[0],
    setIsFetched = _useState[1];
  React.useEffect(function () {
    var fetchStories = function fetchStories() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getStories(application, goToLinkText);
            case 3:
              result = _context.sent;
              setTeasers(result);
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 10:
              setIsFetched(true);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
    };
    if (!isFetched) {
      fetchStories();
    }
  }, [application, goToLinkText, isFetched]);
  return /*#__PURE__*/React.createElement(Container, {
    version: ComponentVersion.v2,
    spacingWithSeparator: true
  }, /*#__PURE__*/React.createElement(IntroText, {
    headlineText: headline !== null && headline !== void 0 ? headline : '',
    copyText: intro_text,
    className: css$2.atomMargin
  }), /*#__PURE__*/React.createElement(TeaserCardList, {
    teaser: teasers,
    image_position: AssetView.Fullwidth,
    version: ComponentVersion.v2,
    view: view
  }), collection_link && (collection_link.url || collection_link.cached_url) && (/*#__PURE__*/React.createElement("div", {
    className: css$2.link
  }, /*#__PURE__*/React.createElement(Link_v2, {
    children: formatMessage({
      id: 'MORE_APPLICATIONS_LINK'
    }),
    href: collection_link.url || collection_link.cached_url || '',
    mode: "light",
    target: TargetValues.Self,
    variant: LinkVariant.Secondary,
    icon: true,
    external: collection_link.linktype === LinkType.Url
  }))));
};

var css$1 = {"btn_holder":"ProductTileSlide_v2-module_btn_holder__wNoWu","btn":"ProductTileSlide_v2-module_btn__vN3ua","tile__slide":"ProductTileSlide_v2-module_tile__slide__pz9wG","tile__slide_span":"ProductTileSlide_v2-module_tile__slide_span__D4KHG","tile__slide_item":"ProductTileSlide_v2-module_tile__slide_item__Exrlg","tile__slide_item--active":"ProductTileSlide_v2-module_tile__slide_item--active__a0aQ8","tile__contents":"ProductTileSlide_v2-module_tile__contents__7KHUm","category_row":"ProductTileSlide_v2-module_category_row__Z-rYX","category_item":"ProductTileSlide_v2-module_category_item__yVr-G","tile__slider_container":"ProductTileSlide_v2-module_tile__slider_container__BEUEK","tile__slider":"ProductTileSlide_v2-module_tile__slider__vB-T-","tile__slider_btn":"ProductTileSlide_v2-module_tile__slider_btn__qQ9FW","lg_slider":"ProductTileSlide_v2-module_lg_slider__ZalnG","slider__link":"ProductTileSlide_v2-module_slider__link__YomXJ","tile__slider_btn--hide":"ProductTileSlide_v2-module_tile__slider_btn--hide__3T4wB","tile__slide_span50":"ProductTileSlide_v2-module_tile__slide_span50__UzBzO","tile__slide_span29":"ProductTileSlide_v2-module_tile__slide_span29__g8bNQ","tile__slide_span14":"ProductTileSlide_v2-module_tile__slide_span14__C-WES","tile__slide_span3":"ProductTileSlide_v2-module_tile__slide_span3__0-RAC","lg_slider__item":"ProductTileSlide_v2-module_lg_slider__item__y03dy","lg_slider__btn":"ProductTileSlide_v2-module_lg_slider__btn__HMzun","lg_slider__item_img":"ProductTileSlide_v2-module_lg_slider__item_img__he8Ac","lg_slider__item_title":"ProductTileSlide_v2-module_lg_slider__item_title__635ZI","lg_slider__item_title_text":"ProductTileSlide_v2-module_lg_slider__item_title_text__2FPHU"};

var CaretCircleLeftIcon = function CaretCircleLeftIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: conditionalClassname(Boolean(className), className)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2133 18.1066L13.1066 14L17.2133 9.89329L15.3333 7.99996L9.33325 14L15.3333 20L17.2133 18.1066ZM27.3333 14C27.3333 6.63996 21.3599 0.666626 13.9999 0.666625C6.63992 0.666625 0.666587 6.63996 0.666586 14C0.666586 21.36 6.63992 27.3333 13.9999 27.3333C21.3599 27.3333 27.3333 21.36 27.3333 14ZM3.33325 14C3.33325 8.10662 8.10659 3.33329 13.9999 3.33329C19.8933 3.33329 24.6666 8.10662 24.6666 14C24.6666 19.8933 19.8933 24.6666 13.9999 24.6666C8.10659 24.6666 3.33325 19.8933 3.33325 14Z",
    fill: "#E77600"
  }));
};
var CaretCircleRightIcon = function CaretCircleRightIcon(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: conditionalClassname(Boolean(className), className)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7867 9.89338L14.8934 14L10.7867 18.1067L12.6667 20L18.6667 14L12.6667 8.00004L10.7867 9.89338ZM0.666748 14C0.666748 21.36 6.64008 27.3334 14.0001 27.3334C21.3601 27.3334 27.3334 21.36 27.3334 14C27.3334 6.64004 21.3601 0.666709 14.0001 0.666709C6.64008 0.666709 0.666748 6.64004 0.666748 14ZM24.6667 14C24.6667 19.8934 19.8934 24.6667 14.0001 24.6667C8.10675 24.6667 3.33341 19.8934 3.33341 14C3.33341 8.10671 8.10675 3.33338 14.0001 3.33338C19.8934 3.33338 24.6667 8.10671 24.6667 14Z",
    fill: "#E77600"
  }));
};
var CaretLeftIcon = function CaretLeftIcon(_ref3) {
  var className = _ref3.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "11",
    height: "16",
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: conditionalClassname(Boolean(className), className)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4399 14.1201L4.33327 8.00006L10.4399 1.88006L8.55994 6.10352e-05L0.559937 8.00006L8.55994 16.0001L10.4399 14.1201Z",
    fill: "#E77600"
  }));
};
var CaretRightIcon = function CaretRightIcon(_ref4) {
  var className = _ref4.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "11",
    height: "16",
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: conditionalClassname(Boolean(className), className)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.560059 14.1201L6.66672 8.00006L0.560059 1.88006L2.44006 6.10352e-05L10.4401 8.00006L2.44006 16.0001L0.560059 14.1201Z",
    fill: "#E77600"
  }));
};

var TileHeader = function TileHeader(_ref) {
  var a11yData = _ref.a11yData,
    product_categories = _ref.product_categories,
    activeIndex = _ref.activeIndex,
    onSetActiveIndex = _ref.onSetActiveIndex;
  var tabSwiperRef = useRef();
  var spaceBetween = 10;
  var space = '';
  if (product_categories.length === 6) {
    spaceBetween = 101.6;
    space = css$1.tile__slide_span50;
  } else if (product_categories.length === 7) {
    spaceBetween = 58.667;
    space = css$1.tile__slide_span29;
  } else if (product_categories.length === 8) {
    spaceBetween = 28.857;
    space = css$1.tile__slide_span14;
  } else if (product_categories.length === 9) {
    spaceBetween = 6.5;
    space = css$1.tile__slide_span3;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css$1.tile__slider_container
  }, /*#__PURE__*/React.createElement("button", {
    className: chainConditionalClassnames(css$1.tile__slider_btn, conditionalClassname(product_categories.length === 6, css$1['tile__slider_btn--hide'])),
    onClick: function onClick() {
      var _a;
      return (_a = tabSwiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    }
  }, /*#__PURE__*/React.createElement(CaretCircleLeftIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: css$1.tile__slider
  }, /*#__PURE__*/React.createElement(Swiper, {
    a11y: a11yData,
    slidesPerView: 2,
    spaceBetween: 14.67,
    onBeforeInit: function onBeforeInit(swiper) {
      tabSwiperRef.current = swiper;
    },
    breakpoints: {
      520: {
        slidesPerView: 3,
        spaceBetween: 14.67
      },
      600: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      1200: {
        slidesPerView: 6,
        spaceBetween: product_categories.length === 6 ? 47.2 : 28.83
      },
      1440: {
        slidesPerView: 9,
        spaceBetween: spaceBetween
      }
    }
  }, product_categories.map(function (productCategory, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: productCategory._uid,
      className: css$1.tile__slide
    }, /*#__PURE__*/React.createElement("button", {
      className: chainConditionalClassnames(css$1.tile__slide_item, conditionalClassname(index === activeIndex, css$1['tile__slide_item--active'])),
      onClick: function onClick() {
        return onSetActiveIndex(index);
      }
    }, productCategory.title), /*#__PURE__*/React.createElement("span", {
      className: "".concat(css$1.tile__slide_span, " ").concat(space)
    }));
  }))), /*#__PURE__*/React.createElement("button", {
    className: chainConditionalClassnames(css$1.tile__slider_btn, conditionalClassname(product_categories.length === 6, css$1['tile__slider_btn--hide'])),
    onClick: function onClick() {
      var _a;
      return (_a = tabSwiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    }
  }, /*#__PURE__*/React.createElement(CaretCircleRightIcon, null)));
};
var TileContentSlider = function TileContentSlider(_ref2) {
  var a11yData = _ref2.a11yData,
    subCategories = _ref2.subCategories;
  var _a;
  var productSwiperRef = useRef();
  var _useState = useState(0),
    activeProductIndex = _useState[0],
    setActiveProductIndex = _useState[1];
  var upperBound = (_a = subCategories === null || subCategories === void 0 ? void 0 : subCategories.length) !== null && _a !== void 0 ? _a : 0;
  var totalProductsForDesktopView = 6;
  return /*#__PURE__*/React.createElement("div", {
    className: css$1.lg_slider
  }, activeProductIndex > 0 ? (/*#__PURE__*/React.createElement("button", {
    className: css$1.lg_slider__btn,
    onClick: function onClick() {
      var _a;
      return (_a = productSwiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    }
  }, /*#__PURE__*/React.createElement(CaretLeftIcon, null))) : null, /*#__PURE__*/React.createElement(Swiper, {
    a11y: a11yData,
    slidesPerView: 6,
    spaceBetween: 32,
    onBeforeInit: function onBeforeInit(swiper) {
      productSwiperRef.current = swiper;
    },
    onSlideChange: function onSlideChange(swiper) {
      setActiveProductIndex(swiper.realIndex);
    }
  }, subCategories === null || subCategories === void 0 ? void 0 : subCategories.map(function (subCategory) {
    var _a, _b, _c;
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: subCategory._uid
    }, /*#__PURE__*/React.createElement("div", {
      className: css$1.lg_slider__item
    }, /*#__PURE__*/React.createElement(Link_v2, {
      href: subCategory.link.url || subCategory.link.cached_url,
      target: TargetValues.Self,
      mode: "light",
      className: css$1.slider__link,
      variant: LinkVariant.Secondary
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: css$1.lg_slider__item_img
    }, /*#__PURE__*/React.createElement(Image, {
      alt: (_b = (_a = subCategory.image[0]) === null || _a === void 0 ? void 0 : _a.alt_text) !== null && _b !== void 0 ? _b : 'Igus Product',
      src: generateImageSrc((_c = subCategory.image[0]) === null || _c === void 0 ? void 0 : _c.image),
      imageSizes: [{
        width: 152,
        height: 64
      }]
    })), /*#__PURE__*/React.createElement("div", {
      className: css$1.lg_slider__item_title
    }, /*#__PURE__*/React.createElement("span", {
      className: css$1.lg_slider__item_title_text
    }, subCategory.title))))));
  })), activeProductIndex + totalProductsForDesktopView < upperBound ? (/*#__PURE__*/React.createElement("button", {
    className: css$1.lg_slider__btn,
    onClick: function onClick() {
      var _a;
      return (_a = productSwiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    }
  }, /*#__PURE__*/React.createElement(CaretRightIcon, null))) : null);
};

function ProductTileSlide_v2(_ref) {
  var text = _ref.text,
    product_categories = _ref.product_categories,
    slider_button = _ref.slider_button;
  var _a;
  var _useState = useState(0),
    activeIndex = _useState[0],
    setActiveIndex = _useState[1];
  var a11yData = a11yMessages('ProductTileSlide_v2');
  var subCategories = (_a = product_categories[activeIndex]) === null || _a === void 0 ? void 0 : _a.sub_categories;
  var mappedLinks = slider_button.map(function (button) {
    var _a;
    return Object.assign(Object.assign({
      _uid: button._uid
    }, linkPropsMapper(button)), {
      linktype: (_a = button.link) === null || _a === void 0 ? void 0 : _a.linktype
    });
  });
  return /*#__PURE__*/React.createElement(Container, {
    version: ComponentVersion.v2,
    spacingWithoutSeparator: true
  }, /*#__PURE__*/React.createElement(IntroText, {
    headlineText: text
  }), /*#__PURE__*/React.createElement("div", {
    className: css$1.tile__contents
  }, /*#__PURE__*/React.createElement(TileHeader, {
    a11yData: a11yData,
    activeIndex: activeIndex,
    onSetActiveIndex: setActiveIndex,
    product_categories: product_categories
  }), /*#__PURE__*/React.createElement(Row, {
    className: css$1.category_row
  }, subCategories === null || subCategories === void 0 ? void 0 : subCategories.map(function (subCategory) {
    var _a, _b, _c;
    return /*#__PURE__*/React.createElement(Col, {
      sm: 5,
      md: 3,
      xl: 2,
      key: subCategory._uid,
      className: css$1.category_item
    }, /*#__PURE__*/React.createElement(Link_v2, {
      href: subCategory.link.url || subCategory.link.cached_url,
      target: TargetValues.Self,
      mode: "light",
      className: css$1.slider__link,
      variant: LinkVariant.Secondary
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
      alt: (_b = (_a = subCategory.image[0]) === null || _a === void 0 ? void 0 : _a.alt_text) !== null && _b !== void 0 ? _b : 'Igus Product',
      src: generateImageSrc((_c = subCategory.image[0]) === null || _c === void 0 ? void 0 : _c.image),
      imageSizes: [{
        width: 152,
        height: 85
      }]
    }), /*#__PURE__*/React.createElement("span", null, subCategory.title))));
  })), /*#__PURE__*/React.createElement(TileContentSlider, {
    a11yData: a11yData,
    subCategories: subCategories !== null && subCategories !== void 0 ? subCategories : []
  })), /*#__PURE__*/React.createElement(Row, {
    className: css$1.btn_holder
  }, mappedLinks.map(function (button) {
    return /*#__PURE__*/React.createElement(Link_v2, {
      key: button._uid,
      icon: true,
      mode: "light",
      href: button.href,
      target: button.target,
      variant: button.variant,
      external: button.external || LinkType.Email === (button === null || button === void 0 ? void 0 : button.linktype),
      className: css$1.btn
    }, button.children);
  })));
}

var css = {"hero":"HeroHomePage-module_hero__QXQoQ","navigation":"HeroHomePage-module_navigation__enr8L","navigation__right":"HeroHomePage-module_navigation__right__H-TMM","navigation__btn":"HeroHomePage-module_navigation__btn__ZzjC4","navigation__slot":"HeroHomePage-module_navigation__slot__FYzYn","navigation__paginator":"HeroHomePage-module_navigation__paginator__gWkS9","navigation__slot_span":"HeroHomePage-module_navigation__slot_span__w4WUQ","navigation__active_index":"HeroHomePage-module_navigation__active_index__Pmj2f","navigation__slot_active":"HeroHomePage-module_navigation__slot_active__QglDw","slide__content":"HeroHomePage-module_slide__content__v7O4O","slide__headline":"HeroHomePage-module_slide__headline__SKoae","slide__sub_headline":"HeroHomePage-module_slide__sub_headline__4Lbqf","slide":"HeroHomePage-module_slide__3uK1N","slide__image":"HeroHomePage-module_slide__image__1Jmb7","slide__intro_text":"HeroHomePage-module_slide__intro_text__MKeWu","svg":"HeroHomePage-module_svg__QlnZg"};

var PauseIcon = function PauseIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 19.3333H12.6666V8.66663H9.99996V19.3333ZM14 0.666626C6.63996 0.666626 0.666626 6.63996 0.666626 14C0.666626 21.36 6.63996 27.3333 14 27.3333C21.36 27.3333 27.3333 21.36 27.3333 14C27.3333 6.63996 21.36 0.666626 14 0.666626ZM14 24.6666C8.11996 24.6666 3.33329 19.88 3.33329 14C3.33329 8.11996 8.11996 3.33329 14 3.33329C19.88 3.33329 24.6666 8.11996 24.6666 14C24.6666 19.88 19.88 24.6666 14 24.6666ZM15.3333 19.3333H18V8.66663H15.3333V19.3333Z"
  }));
};
var PlayIcon = function PlayIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 20L19.3333 14L11.3333 7.99996V20ZM14 0.666626C6.63996 0.666626 0.666626 6.63996 0.666626 14C0.666626 21.36 6.63996 27.3333 14 27.3333C21.36 27.3333 27.3333 21.36 27.3333 14C27.3333 6.63996 21.36 0.666626 14 0.666626ZM14 24.6666C8.11996 24.6666 3.33329 19.88 3.33329 14C3.33329 8.11996 8.11996 3.33329 14 3.33329C19.88 3.33329 24.6666 8.11996 24.6666 14C24.6666 19.88 19.88 24.6666 14 24.6666Z"
  }));
};

var getImageSource = function getImageSource(image) {
  var _a, _b, _c, _d, _e, _f;
  if ((_b = (_a = image[0]) === null || _a === void 0 ? void 0 : _a.image[0]) === null || _b === void 0 ? void 0 : _b.image.item.focal_embed_link) {
    return (_d = (_c = image[0]) === null || _c === void 0 ? void 0 : _c.image[0]) === null || _d === void 0 ? void 0 : _d.image.item.focal_embed_link;
  }
  return ((_f = (_e = image[0]) === null || _e === void 0 ? void 0 : _e.image[0]) === null || _f === void 0 ? void 0 : _f.image.item.embed_link) || '';
};
var heroImgSizes = [{
  width: 360,
  height: 360
}, {
  width: 768,
  height: 432
}, {
  width: 1024,
  height: 706
}, {
  width: 1200,
  height: 675
}, {
  width: 1440,
  height: 362
}, {
  width: 1920,
  height: 480
}];

var HeroSliderNavigation = function HeroSliderNavigation(_ref) {
  var slideItems = _ref.slideItems,
    isPaused = _ref.isPaused,
    activeIndex = _ref.activeIndex,
    onPauseSlider = _ref.onPauseSlider,
    onResumeSlider = _ref.onResumeSlider;
  var swiper = useSwiper();
  return /*#__PURE__*/React.createElement("div", {
    className: css.navigation
  }, /*#__PURE__*/React.createElement("button", {
    className: css.navigation__btn,
    onClick: function onClick() {
      return swiper.slidePrev();
    }
  }, /*#__PURE__*/React.createElement(CaretLeftIcon, null)), /*#__PURE__*/React.createElement("p", {
    className: css.navigation__active_index
  }, (activeIndex + 1).toString().padStart(2, '0'), " /", ' ', slideItems.toString().padStart(2, '0')), /*#__PURE__*/React.createElement("div", {
    className: css.navigation__paginator
  }, Array.from({
    length: slideItems
  }).fill('slide').map(function (slide, index) {
    return /*#__PURE__*/React.createElement("button", {
      key: "".concat(slide, "-").concat(index),
      onClick: function onClick() {
        return swiper.slideToLoop(index);
      },
      className: css.navigation__slot
    }, /*#__PURE__*/React.createElement("span", {
      className: chainConditionalClassnames(css.navigation__slot_span, conditionalClassname(activeIndex === index, css.navigation__slot_active))
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: css.navigation__right
  }, /*#__PURE__*/React.createElement("button", {
    className: css.navigation__btn,
    onClick: isPaused ? onResumeSlider : onPauseSlider
  }, isPaused ? /*#__PURE__*/React.createElement(PlayIcon, null) : /*#__PURE__*/React.createElement(PauseIcon, null)), /*#__PURE__*/React.createElement("button", {
    className: css.navigation__btn,
    onClick: function onClick() {
      return swiper.slideNext();
    }
  }, /*#__PURE__*/React.createElement(CaretRightIcon, null))));
};
var HeroSlide = function HeroSlide(_ref2) {
  var headline = _ref2.headline,
    image = _ref2.image,
    intro_text = _ref2.intro_text,
    link = _ref2.link,
    subline_h2 = _ref2.subline_h2;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
  return /*#__PURE__*/React.createElement("div", {
    className: css.slide
  }, /*#__PURE__*/React.createElement(ShapeClipPath, null), /*#__PURE__*/React.createElement("div", {
    className: css.slide__content
  }, /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H1,
    className: css.slide__headline
  }, headline), /*#__PURE__*/React.createElement(Headline, {
    tag: HeadlineTags.H4,
    className: css.slide__sub_headline
  }, subline_h2), /*#__PURE__*/React.createElement("p", {
    className: css.slide__intro_text
  }, intro_text), /*#__PURE__*/React.createElement(Link_v2, {
    children: (_b = (_a = link[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
    mode: "dark",
    href: ((_d = (_c = link[0]) === null || _c === void 0 ? void 0 : _c.link) === null || _d === void 0 ? void 0 : _d.url) || ((_f = (_e = link[0]) === null || _e === void 0 ? void 0 : _e.link) === null || _f === void 0 ? void 0 : _f.cached_url) || '',
    target: ((_h = (_g = link[0]) === null || _g === void 0 ? void 0 : _g.link) === null || _h === void 0 ? void 0 : _h.target) || TargetValues.Self,
    variant: (_j = link[0]) === null || _j === void 0 ? void 0 : _j.variant,
    external: ((_l = (_k = link[0]) === null || _k === void 0 ? void 0 : _k.link) === null || _l === void 0 ? void 0 : _l.linktype) !== LinkType.Story,
    icon: true
  })), /*#__PURE__*/React.createElement(Image, {
    priority: true,
    src: getImageSource(image),
    className: css.slide__image,
    alt: ((_o = (_m = image[0]) === null || _m === void 0 ? void 0 : _m.image[0]) === null || _o === void 0 ? void 0 : _o.alt_text) || 'Igus Product',
    sizes: "(max-width: 767px) 100vw, (min-width: 768px) calc(100vw - 330px), (min-width: 1200px) calc(100vw - 520px), (min-width: 1440px) calc(100vw - 585px)",
    imageSizes: heroImgSizes
  }), /*#__PURE__*/React.createElement(ImageEnlarge, {
    imageAltText: ((_q = (_p = image[0]) === null || _p === void 0 ? void 0 : _p.image[0]) === null || _q === void 0 ? void 0 : _q.alt_text) || 'Igus Product',
    imageUrl: getImageSource(image),
    enlargeImage: true
  }));
};
var ShapeClipPath = function ShapeClipPath() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 856 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: css.svg
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "desktop-large"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855.223 0C829.789 75.3523 816 156.066 816 240C816 323.934 829.789 404.648 855.223 480H0V0H855.223Z"
  }))), /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 645 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: css.svg
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "desktop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.98 0C625.799 56.8282 615.4 117.7 615.4 181C615.4 244.3 625.799 305.172 644.98 362H0V0H644.98Z",
    fill: "#E77600"
  }))), /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 575 675",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: css.svg
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.551 0C526.738 104.044 503.125 218.014 503.125 337.5C503.125 456.986 526.738 570.956 569.551 675H0V0H569.551Z",
    fill: "#E77600"
  }))), /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 374 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: css.svg
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "tablet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.591 0C334.944 62.4855 322 130.231 322 201C322 285.884 340.622 366.417 374 431.741V432H0V0H358.591Z"
  }))));
};

function HeroHomePage(_ref) {
  var hero_slider = _ref.hero_slider;
  var _a;
  var _useState = useState(false),
    isPaused = _useState[0],
    setIsPaused = _useState[1];
  var _useState2 = useState(0),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var _useState3 = useState(null),
    swiperInstance = _useState3[0],
    setSwiperInstance = _useState3[1];
  var handlePause = function handlePause() {
    if (swiperInstance) {
      swiperInstance.autoplay.stop();
      setIsPaused(!isPaused);
    }
  };
  var handleResume = function handleResume() {
    if (swiperInstance) {
      swiperInstance.autoplay.start();
      setIsPaused(!isPaused);
    }
  };
  var a11yData = a11yMessages('HeroHomePage');
  return /*#__PURE__*/React.createElement("article", {
    className: css.hero
  }, /*#__PURE__*/React.createElement(Swiper, {
    onSwiper: function onSwiper(swiper) {
      return setSwiperInstance(swiper);
    },
    onSlideChange: function onSlideChange(swiper) {
      setActiveIndex(swiper.realIndex);
    },
    speed: 800,
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false
    },
    modules: [Autoplay, Navigation$1],
    a11y: a11yData
  }, hero_slider.map(function (slider) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: slider._uid
    }, /*#__PURE__*/React.createElement(HeroSlide, Object.assign({}, slider)));
  }), /*#__PURE__*/React.createElement(HeroSliderNavigation, {
    slideItems: (_a = hero_slider === null || hero_slider === void 0 ? void 0 : hero_slider.length) !== null && _a !== void 0 ? _a : 0,
    isPaused: isPaused,
    onPauseSlider: handlePause,
    onResumeSlider: handleResume,
    activeIndex: activeIndex
  })));
}

var ContinentProps;
(function (ContinentProps) {
  ContinentProps["Europe"] = "europe";
  ContinentProps["Asia"] = "asia";
  ContinentProps["Australia"] = "australia";
  ContinentProps["Africa"] = "africa";
  ContinentProps["NorthAmerica"] = "north-america";
  ContinentProps["SouthAmerica"] = "south-america";
})(ContinentProps || (ContinentProps = {}));

export { APIResultStatus, Accordion, AccordionImageHeight, Anchor, AnchorTag, ApplicationTeaser, Asset, AssetView, AwardsIconType, BackToTop, Benefits, BenefitsListIcons, Bold, Breadcrumb, Break, CTA, Col, ColorValue, ColumnView, ComponentContact, ComponentNames, ComponentVersion, ContactImageDisplay, ContactMediumIconProps, ContactOverview, ContactPerson, ContactSpecial, ContactStandard, ContactType, Container, ContentNavigation, ContentOnImageWidthProps, ContentOneColumn, ContinentProps, CountrySwitch, CountrySwitchContext, CountrySwitchContextProvider, CustomError, DeliveryLocationNotification, DownloadIconTheme, DownloadLink, Downloads, DynamicTeaserOverview, ElementSchema, ElementTypeComponent, ExternalLink$1 as ExternalLink, ExternalLinkIcon$1 as ExternalLinkIcon, Factbox, FairsOverview, Feedback, FontColor, Footer, FooterLegal, FormElementColumn, FormSelection, FormationType, HeaderBar, Headline, HeadlineAtom, HeadlineTags, HeroHomePage, HomepageBanner, HomepageCarousel, HomepageProductOverview, HomepageTeaserCompilation, HomepageTeaserVariants, INITIAL_PAGE_NUMBER, IconLinks$1 as IconLinks, IconLinksBar, IconPosition, IgusGoContainer, IgusLogo, IgusLogoOrangeVariant, Image, ImageMolecule, ImageMoleculeBlokImageHeight, InPageNavigation, IncludeExternalPage, InternalLink$1 as InternalLink, Italic, LegendComponent, Link, LinkAtom, LinkList, LinkListColumn, LinkListHorizontal, LinkType, LinkVariant, List, MarkComponent, MarketingCloudContainer, NavigationBar, NavigationCard, NavigationProvider, NewsLetter, PER_PAGE, PageIndex, PageIntro, PageIntroHomepage, PageIntroImageHeight, PageTagsSearch, Paragraph, PaymentIconProps, Process, ProductTileSlide, ProductTileSlide_v2, QuickInfo, Quote, QuoteComponent, RelType, RenderAssetOnComponent, RenderButtonType, RichTextRenderer, Row, RssFeed, SearchBar, SelectContactView, Separator, Slider, SliderAssetRatio, SocialMediaIconProps, Span, Strike, Subscript, Superscript, Table, TagSelection, Tags, TargetValues, TeamOverview, TeaserAssetImageHeight, TeaserAssetRatio, TeaserBig, TeaserBigThemeSection, TeaserCard, TeaserCompilationCenterComponent, TeaserComponent, TeaserPlaceholder, Text, TextFormElement, TextImageFourColumn, TextImageImageHeight, TextImageThreeColumn, TextImageTwoColumn, TextMarks, ThemeVariables, TwoColumnElement, Underline, Variant, Video, alphabeticSort, changeLinkStyle, convertFileSizeToKB, convertHtmlEntities, determineContactType, externalLinkVariant, extractDate, filterForBusinessUnit, filterForDepartment, formatContactText, formatLink, formatLocaleHref, formatLocaleToMatchExistingLocales, formatSelectOptions, formatThankYouLink, generateImageSrc, getAndSetRssData, getCaseInsensitiveValue, getContactUrlPath, getContactsByUUID, getDepartmentAndBusinessUnits, getFallbackLocale, getFilteringOption, getLatestContacts, getLocale, getLocaleUsingSelectedCountry, getMarketingAction, getOnlySupportedCountries, getQueryParams, getRSSFeed, getRegions, getSelectedCountryName, getStoryblokApi, getStoryblokContactFilter, getTranslatedDepartmentsAndBusinessUnits, getTranslatedSalesTexts, getZipCode, hasRequiredField, inputTypeComponent, isButtonLink, isExternalCrossDomain, isFileTypeAllowed, isIgusDomain, isImage, isInternalCrossDomain, isPreferredVersion, isValidEmail, linkPropsMapper, mappedProps, mappedRssFeedItems, mappedUTMProps, renderAsset, renderListProps, renderRssTeaserTypeData, renderText, renderTextWithMarks, replaceSpaceInName, santizeQuery, setElementColumn, setFormation, setIconPosition, setLocales, setLocalizedForm, setRelValueFromTarget, sortContacts, _textProps as textProps, transformContacts, trimVideoDuration, useNavigation, useOutsideClick };
//# sourceMappingURL=index.mjs.map
